
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("KcDWk", function(module, exports) {

$parcel$export(module.exports, "collectSSRedLegacyMacros", () => $0cb26f4daa528aad$export$a738be6ce0ac5941);
$parcel$export(module.exports, "releaseSSRedLegacyMacros", () => $0cb26f4daa528aad$export$6e21e394d708bb62);
$parcel$export(module.exports, "releaseUnusedSSRedLegacyMacrosWithDelay", () => $0cb26f4daa528aad$export$f700dfca474a9730);
$parcel$export(module.exports, "useSSRedLegacyMacroElement", () => $0cb26f4daa528aad$export$be7b16c53ead6686);

var $dPJCf = parcelRequire("dPJCf");
const $0cb26f4daa528aad$var$RELEASE_UNUSED_DELAY_TIME = 10000; // 10 sec
const $0cb26f4daa528aad$var$ssredMacros = new Map();
const $0cb26f4daa528aad$var$usedMacros = new Set();
function $0cb26f4daa528aad$export$a738be6ce0ac5941() {
    document.querySelectorAll('[data-fabric-macro][data-skate-created]').forEach((e)=>{
        const macroId = e.getAttribute('data-fabric-macro');
        if (macroId) $0cb26f4daa528aad$var$ssredMacros.set(macroId, e);
    });
}
function $0cb26f4daa528aad$export$6e21e394d708bb62() {
    $0cb26f4daa528aad$var$ssredMacros.clear();
}
function $0cb26f4daa528aad$export$f700dfca474a9730() {
    setTimeout($0cb26f4daa528aad$var$releaseUnused, $0cb26f4daa528aad$var$RELEASE_UNUSED_DELAY_TIME);
}
function $0cb26f4daa528aad$var$releaseUnused() {
    for (const macroId of $0cb26f4daa528aad$var$ssredMacros.keys())if (!$0cb26f4daa528aad$var$usedMacros.has(macroId)) $0cb26f4daa528aad$var$ssredMacros.delete(macroId);
}
function $0cb26f4daa528aad$export$be7b16c53ead6686(macroId) {
    const transitionId = (0, $dPJCf.useTransitionId)();
    $0cb26f4daa528aad$var$usedMacros.add(macroId);
    const ssredElement = !transitionId ? $0cb26f4daa528aad$var$ssredMacros.get(macroId) : undefined;
    return {
        ssredElement: ssredElement
    };
}

});

parcelRegister("9p5st", function(module, exports) {

$parcel$export(module.exports, "MacroContentRendererQueryWithTags", () => $a2ace3c5eb1b62cc$export$537abee6021125ea);
$parcel$export(module.exports, "MacroBodyRendererQueryWithTags", () => $a2ace3c5eb1b62cc$export$216be55a5f5e84dd);

var $d2LG0 = parcelRequire("d2LG0");
const $a2ace3c5eb1b62cc$export$537abee6021125ea = (0, $d2LG0.default)`query MacroContentRendererQueryWithTags($adf:String!$containedRender:Boolean=false$contentId:ID!$mode:ContentRendererMode=RENDERER){contentRenderer(adf:$adf containedRender:$containedRender contentId:$contentId mode:$mode){html webResourceDependencies{contexts keys tags{js css}}}}`;
const $a2ace3c5eb1b62cc$export$216be55a5f5e84dd = (0, $d2LG0.default)`query MacroBodyRendererQueryWithTags($adf:String!$containedRender:Boolean=false$contentId:ID$mode:ContentRendererMode=RENDERER)@allowHigherTimeout{macroBodyRenderer(adf:$adf containedRender:$containedRender contentId:$contentId mode:$mode){value representation mediaToken{token}webResourceDependencies{contexts keys tags{js css}}}}`;

});

parcelRegister("lpxTx", function(module, exports) {

$parcel$export(module.exports, "ContentBlogUnifiedQuery", () => $4ac0bfd36ecfdf97$export$7e83667ababb3077);

var $d2LG0 = parcelRequire("d2LG0");

var $bp0kf = parcelRequire("bp0kf");

var $fyq3L = parcelRequire("fyq3L");
const $4ac0bfd36ecfdf97$export$7e83667ababb3077 = (0, $d2LG0.default)`query ContentBlogUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false)@SLA{content(id:$contentId version:$versionOverride){nodes{...contentUnifiedContentFragment}}space(key:$spaceKey){...contentUnifiedSpaceFragment}}${(0, $bp0kf.contentUnifiedContentFragment)}${(0, $fyq3L.contentUnifiedSpaceFragment)}`;

});
parcelRegister("bp0kf", function(module, exports) {

$parcel$export(module.exports, "contentUnifiedContentFragment", () => $c2e3f9471972d5d7$export$e00da28a49bae970);

var $d2LG0 = parcelRequire("d2LG0");

var $5byFK = parcelRequire("5byFK");

var $dTYjO = parcelRequire("dTYjO");
const $c2e3f9471972d5d7$export$e00da28a49bae970 = (0, $d2LG0.default)`fragment contentUnifiedContentFragment on Content{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value webresource{superbatch{tags{js css}}tags{js css}}}}...contentAppearancePublishedFragment ...labelsFragment}${(0, $5byFK.contentAppearancePublishedFragment)}${(0, $dTYjO.labelsFragment)}`;

});
parcelRegister("5byFK", function(module, exports) {

$parcel$export(module.exports, "contentAppearancePublishedFragment", () => $bfcff585a387a17c$export$fc63b02da1db3bfd);
$parcel$export(module.exports, "contentAppearanceDraftFragment", () => $bfcff585a387a17c$export$cddc8d7b74237b7c);

var $d2LG0 = parcelRequire("d2LG0");
const $bfcff585a387a17c$var$contentAppearanceInnerFragment = (0, $d2LG0.default)`fragment contentAppearanceInnerFragment on PaginatedJsonContentPropertyList{nodes{id key value version{number}}}`;
const $bfcff585a387a17c$export$fc63b02da1db3bfd = (0, $d2LG0.default)`fragment contentAppearancePublishedFragment on Content{appearancePublished:properties(key:"content-appearance-published"){...contentAppearanceInnerFragment}}${$bfcff585a387a17c$var$contentAppearanceInnerFragment}`;
const $bfcff585a387a17c$export$cddc8d7b74237b7c = (0, $d2LG0.default)`fragment contentAppearanceDraftFragment on Content{appearanceDraft:properties(key:"content-appearance-draft"){...contentAppearanceInnerFragment}}${$bfcff585a387a17c$var$contentAppearanceInnerFragment}`;

});

parcelRegister("dTYjO", function(module, exports) {

$parcel$export(module.exports, "labelsFragment", () => $821d365ad1b8d407$export$e939ebcde3b41902);

var $d2LG0 = parcelRequire("d2LG0");
const $821d365ad1b8d407$export$e939ebcde3b41902 = (0, $d2LG0.default)`fragment labelsFragment on Content{labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}`;

});


parcelRegister("fyq3L", function(module, exports) {

$parcel$export(module.exports, "contentUnifiedSpaceFragment", () => $38491625a6c957ee$export$68695711a2796ad5);

var $d2LG0 = parcelRequire("d2LG0");
const $38491625a6c957ee$export$68695711a2796ad5 = (0, $d2LG0.default)`fragment contentUnifiedSpaceFragment on Space{id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}`;

});


parcelRegister("61vTv", function(module, exports) {

$parcel$export(module.exports, "ContentUnifiedQuery", () => $7b6381fcd1b9e458$export$16dddce791a11901);

var $d2LG0 = parcelRequire("d2LG0");

var $bp0kf = parcelRequire("bp0kf");

var $fyq3L = parcelRequire("fyq3L");
const $7b6381fcd1b9e458$export$16dddce791a11901 = (0, $d2LG0.default)`query ContentUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false)@SLA@allowHigherTimeout{content(id:$contentId version:$versionOverride){nodes{...contentUnifiedContentFragment}}space(key:$spaceKey){...contentUnifiedSpaceFragment}}${(0, $bp0kf.contentUnifiedContentFragment)}${(0, $fyq3L.contentUnifiedSpaceFragment)}`;

});

parcelRegister("ld6xp", function(module, exports) {

$parcel$export(module.exports, "getMultiMacroQueryBlocklistFF", () => $1a525e6db77527ad$export$93a875f36a027067);
$parcel$export(module.exports, "canUseMultiMacroQuery", () => $1a525e6db77527ad$export$32e19dd05a214cc0);

var $4VJDS = parcelRequire("4VJDS");
function $1a525e6db77527ad$export$93a875f36a027067() {
    const blocklist = (0, $4VJDS.default).getStringList('confluence_frontend_macros_query_blocklist', [
        'include',
        'jirachart',
        'jiraroadmap',
        'ui-button',
        'contentbylabel',
        'excerpt-include',
        'tasks-report-macro',
        'blog-posts',
        'section',
        'table-filter',
        'children',
        'pagetree',
        'detailssummary',
        'decisionreport'
    ]);
    return String(blocklist).split(',');
}
function $1a525e6db77527ad$export$32e19dd05a214cc0(extensionKey, isNested2pBodiedExtension = false) {
    return !isNested2pBodiedExtension && !$1a525e6db77527ad$export$93a875f36a027067().includes(extensionKey || '');
}

});

parcelRegister("6Cce7", function(module, exports) {

$parcel$export(module.exports, "ContentConverterQuery", () => $266b70085156c92e$export$ef5feff44649e0e4);

var $d2LG0 = parcelRequire("d2LG0");
const $266b70085156c92e$export$ef5feff44649e0e4 = (0, $d2LG0.default)`query ContentConverterQuery($content:String!$contentId:ID!$from:String!$to:String!$spaceKeyContext:String=""){contentConverter(from:$from to:$to content:$content contentIdContext:$contentId spaceKeyContext:$spaceKeyContext){value}}`;

});

parcelRegister("92uc5", function(module, exports) {

$parcel$export(module.exports, "getContentConverterVariables", () => $0aecfdd3c11bee35$export$e4b2a3005b630bc8);

var $gHCIk = parcelRequire("gHCIk");
const $0aecfdd3c11bee35$export$e4b2a3005b630bc8 = ({ content: content, contentId: contentId })=>{
    const contentValue = content || [];
    const contentDocument = {
        type: 'doc',
        content: Array.isArray(contentValue) ? contentValue : [
            contentValue
        ],
        version: 1
    };
    const contentDocumentAdf = (0, $gHCIk.serializeExtensionADF)(contentDocument);
    return {
        content: contentDocumentAdf,
        from: 'atlas_doc_format',
        to: 'storage',
        contentId: contentId
    };
};

});
parcelRegister("gHCIk", function(module, exports) {

$parcel$export(module.exports, "serializeExtensionADF", () => $9fa754652de9cba0$export$af78762ebd645d38);
const $9fa754652de9cba0$var$replacer = (_, value)=>value !== null && typeof value === 'object' && !(value instanceof Array) ? Object.keys(value).sort().reduce((sorted, key)=>{
        sorted[key] = value[key];
        return sorted;
    }, {}) : value;
const $9fa754652de9cba0$export$af78762ebd645d38 = (adf)=>JSON.stringify(adf, $9fa754652de9cba0$var$replacer);

});


parcelRegister("8mIlz", function(module, exports) {

$parcel$export(module.exports, "getMacroQueryVariables", () => $c41a024b478ea6bf$export$99dbcdf31bb91f29);

var $4VJDS = parcelRequire("4VJDS");

var $6mEZ3 = parcelRequire("6mEZ3");

var $gHCIk = parcelRequire("gHCIk");
const $c41a024b478ea6bf$var$getContentId = (adf, contentId)=>{
    const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
    return parentId || contentId;
};
const $c41a024b478ea6bf$export$99dbcdf31bb91f29 = ({ adf: adf, node: node, mode: mode = 'RENDERER', contentId: contentId })=>{
    const extensionADF = adf || (0, $6mEZ3.extensionToADF)(node);
    const isMacroContentAndBody = (0, $4VJDS.default).getBoolean('confluence_frontend_macro_adf_frontend_render', true);
    return {
        adf: (0, $gHCIk.serializeExtensionADF)(extensionADF),
        mode: mode.toUpperCase(),
        contentId: isMacroContentAndBody ? $c41a024b478ea6bf$var$getContentId(extensionADF, contentId) : contentId,
        isMacroContentAndBody: isMacroContentAndBody
    };
};

});

parcelRegister("g1f2M", function(module, exports) {

$parcel$export(module.exports, "MacrosQuery", () => $61b558d6967afc9c$export$7e0981a52ec92fa4);

var $d2LG0 = parcelRequire("d2LG0");
const $61b558d6967afc9c$export$7e0981a52ec92fa4 = (0, $d2LG0.default)`query MacrosQuery($contentId:ID!$mode:MacroRendererMode=RENDERER$blocklist:[String!]$first:Int$after:String$refetchToken:String)@allowHigherTimeout{macros(contentId:$contentId blocklist:$blocklist first:$first after:$after refetchToken:$refetchToken){pageInfo{hasNextPage endCursor}nodes{macroId contentId renderedMacro(mode:$mode){value macroRenderedRepresentation macroBodyStorage webResource{contexts keys superbatch{metatags}tags{css data js}uris{css data js}}mediaToken{token}}}}}`;

});

parcelRegister("8pvtc", function(module, exports) {

$parcel$export(module.exports, "WebPanelLocationQuery", () => $ac1e927e530cb686$export$d97dfe528d83a912);

var $d2LG0 = parcelRequire("d2LG0");
const $ac1e927e530cb686$export$d97dfe528d83a912 = (0, $d2LG0.default)`query WebPanelLocationQuery($location:String$contentId:ID$spaceKey:String){webPanels(location:$location contentId:$contentId key:$spaceKey){moduleKey completeKey html location label weight name}}`;

});

parcelRegister("g5hv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb5ab000f498aae1$export$2e2bcd8739ae039);

var $4eQbn = parcelRequire("4eQbn");

var $jK4s4 = parcelRequire("jK4s4");

var $13IX4 = parcelRequire("13IX4");

var $hDQMP = parcelRequire("hDQMP");

var $4YLNd = parcelRequire("4YLNd");

var $hmjRW = parcelRequire("hmjRW");

var $cwFrB = parcelRequire("cwFrB");

var $6msfI = parcelRequire("6msfI");

var $fJKHo = parcelRequire("fJKHo");

var $7IxPz = parcelRequire("7IxPz");

var $6Z3KL = parcelRequire("6Z3KL");

var $59BA7 = parcelRequire("59BA7");

var $dBAF7 = parcelRequire("dBAF7");

var $gfYwW = parcelRequire("gfYwW");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $bb5ab000f498aae1$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $bb5ab000f498aae1$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $bb5ab000f498aae1$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $bb5ab000f498aae1$var$doubleQuoteRegExp = /''/g;
var $bb5ab000f498aae1$var$notWhitespaceRegExp = /\S/;
var $bb5ab000f498aae1$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $bb5ab000f498aae1$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6Z3KL.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $gfYwW.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $13IX4.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $7IxPz.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $7IxPz.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $4YLNd.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $59BA7.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($bb5ab000f498aae1$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $cwFrB.default)) {
            var longFormatter = (0, $cwFrB.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($bb5ab000f498aae1$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $jK4s4.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $fJKHo.isProtectedWeekYearToken)(token)) (0, $fJKHo.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $fJKHo.isProtectedDayOfYearToken)(token)) (0, $fJKHo.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $dBAF7.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($bb5ab000f498aae1$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $bb5ab000f498aae1$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $4eQbn.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $bb5ab000f498aae1$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $4YLNd.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $hDQMP.default)(date, (0, $6msfI.default)(date));
    var flags = {};
    var _iterator2 = (0, $jK4s4.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $hmjRW.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $bb5ab000f498aae1$var$cleanEscapedString(input) {
    return input.match($bb5ab000f498aae1$var$escapedStringRegExp)[1].replace($bb5ab000f498aae1$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("jK4s4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f5c432a914f35c$export$2e2bcd8739ae039);

var $asf9s = parcelRequire("asf9s");
function $e5f5c432a914f35c$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $asf9s.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});

parcelRegister("59BA7", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $3c0af1f09088f11a$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $3c0af1f09088f11a$export$5aaf7ff7f09ea4ee);

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $1tVDE = parcelRequire("1tVDE");
var $3c0af1f09088f11a$var$TIMEZONE_UNIT_PRIORITY = 10;
var $3c0af1f09088f11a$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $4ow2D.default)(this, Setter);
        (0, $1tVDE.default)(this, "priority", void 0);
        (0, $1tVDE.default)(this, "subPriority", 0);
    }
    (0, $1iGel.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $3c0af1f09088f11a$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $hvsbO.default)(ValueSetter, _Setter);
    var _super = (0, $jrmEa.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $4ow2D.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $1iGel.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($3c0af1f09088f11a$export$81d53e3678089a6);
var $3c0af1f09088f11a$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $hvsbO.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $jrmEa.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $4ow2D.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this2), "priority", $3c0af1f09088f11a$var$TIMEZONE_UNIT_PRIORITY);
        (0, $1tVDE.default)((0, $3uu23.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $1iGel.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($3c0af1f09088f11a$export$81d53e3678089a6);

});
parcelRegister("jrmEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2721b26ed0eb1d9$export$2e2bcd8739ae039);

var $gRL3C = parcelRequire("gRL3C");

var $3heWZ = parcelRequire("3heWZ");

var $fOU5P = parcelRequire("fOU5P");
function $e2721b26ed0eb1d9$export$2e2bcd8739ae039(t) {
    var r = (0, $3heWZ.default)();
    return function() {
        var e, o = (0, $gRL3C.default)(t);
        if (r) {
            var s = (0, $gRL3C.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $fOU5P.default)(this, e);
    };
}

});
parcelRegister("3heWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $262e8e7527aebea7$export$2e2bcd8739ae039);
function $262e8e7527aebea7$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($262e8e7527aebea7$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});



parcelRegister("dBAF7", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $9e7b2b657f2c7a77$export$19131010e7fd8373);

var $a5DZa = parcelRequire("a5DZa");

var $aK5oe = parcelRequire("aK5oe");

var $3ovXz = parcelRequire("3ovXz");

var $2OXI7 = parcelRequire("2OXI7");

var $hTKPR = parcelRequire("hTKPR");

var $kDsq8 = parcelRequire("kDsq8");

var $9sCrE = parcelRequire("9sCrE");

var $OK2pB = parcelRequire("OK2pB");

var $h1ZiK = parcelRequire("h1ZiK");

var $l34ow = parcelRequire("l34ow");

var $1dwN6 = parcelRequire("1dwN6");

var $6ZEqW = parcelRequire("6ZEqW");

var $2eKwn = parcelRequire("2eKwn");

var $iNSVm = parcelRequire("iNSVm");

var $6gwZX = parcelRequire("6gwZX");

var $a4pn9 = parcelRequire("a4pn9");

var $crnMN = parcelRequire("crnMN");

var $2wiU8 = parcelRequire("2wiU8");

var $aLijy = parcelRequire("aLijy");

var $dqaaB = parcelRequire("dqaaB");

var $8TjyR = parcelRequire("8TjyR");

var $gdWKQ = parcelRequire("gdWKQ");

var $5sqFR = parcelRequire("5sqFR");

var $e1WgN = parcelRequire("e1WgN");

var $iXjcT = parcelRequire("iXjcT");

var $cnfDz = parcelRequire("cnfDz");

var $jOHY4 = parcelRequire("jOHY4");

var $752tB = parcelRequire("752tB");

var $30xlx = parcelRequire("30xlx");

var $lhbPq = parcelRequire("lhbPq");

var $aakXT = parcelRequire("aakXT");
var $9e7b2b657f2c7a77$export$19131010e7fd8373 = {
    G: new (0, $a5DZa.EraParser)(),
    y: new (0, $aK5oe.YearParser)(),
    Y: new (0, $3ovXz.LocalWeekYearParser)(),
    R: new (0, $2OXI7.ISOWeekYearParser)(),
    u: new (0, $hTKPR.ExtendedYearParser)(),
    Q: new (0, $kDsq8.QuarterParser)(),
    q: new (0, $9sCrE.StandAloneQuarterParser)(),
    M: new (0, $OK2pB.MonthParser)(),
    L: new (0, $h1ZiK.StandAloneMonthParser)(),
    w: new (0, $l34ow.LocalWeekParser)(),
    I: new (0, $1dwN6.ISOWeekParser)(),
    d: new (0, $6ZEqW.DateParser)(),
    D: new (0, $2eKwn.DayOfYearParser)(),
    E: new (0, $iNSVm.DayParser)(),
    e: new (0, $6gwZX.LocalDayParser)(),
    c: new (0, $a4pn9.StandAloneLocalDayParser)(),
    i: new (0, $crnMN.ISODayParser)(),
    a: new (0, $2wiU8.AMPMParser)(),
    b: new (0, $aLijy.AMPMMidnightParser)(),
    B: new (0, $dqaaB.DayPeriodParser)(),
    h: new (0, $8TjyR.Hour1to12Parser)(),
    H: new (0, $gdWKQ.Hour0to23Parser)(),
    K: new (0, $5sqFR.Hour0To11Parser)(),
    k: new (0, $e1WgN.Hour1To24Parser)(),
    m: new (0, $iXjcT.MinuteParser)(),
    s: new (0, $cnfDz.SecondParser)(),
    S: new (0, $jOHY4.FractionOfSecondParser)(),
    X: new (0, $752tB.ISOTimezoneWithZParser)(),
    x: new (0, $30xlx.ISOTimezoneParser)(),
    t: new (0, $lhbPq.TimestampSecondsParser)(),
    T: new (0, $aakXT.TimestampMillisecondsParser)()
};

});
parcelRegister("a5DZa", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $7589634fd7ebd6ec$export$8e5a1d3f85a9688);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");
var $7589634fd7ebd6ec$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(EraParser, _Parser);
    var _super = (0, $jrmEa.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $4ow2D.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 140);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $6dukW.Parser));

});
parcelRegister("6dukW", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $486b7d3ac1e0f88d$export$7acfa6ed01010e37);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $1tVDE = parcelRequire("1tVDE");

var $59BA7 = parcelRequire("59BA7");
var $486b7d3ac1e0f88d$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $4ow2D.default)(this, Parser);
        (0, $1tVDE.default)(this, "incompatibleTokens", void 0);
        (0, $1tVDE.default)(this, "priority", void 0);
        (0, $1tVDE.default)(this, "subPriority", void 0);
    }
    (0, $1iGel.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $59BA7.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("aK5oe", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $7d22618c6efaf258$export$48d352de7cd4a988);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $7d22618c6efaf258$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(YearParser, _Parser);
    var _super = (0, $jrmEa.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $4ow2D.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 130);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $1riXU.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $1riXU.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $6dukW.Parser));

});
parcelRegister("1riXU", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $10c70630666045c7$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $10c70630666045c7$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $10c70630666045c7$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $10c70630666045c7$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $10c70630666045c7$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $10c70630666045c7$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $10c70630666045c7$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $10c70630666045c7$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $10c70630666045c7$export$3d50627710b84d75);

var $32hfQ = parcelRequire("32hfQ");

var $jG9OU = parcelRequire("jG9OU");
function $10c70630666045c7$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $10c70630666045c7$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $10c70630666045c7$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $32hfQ.millisecondsInHour) + minutes * (0, $32hfQ.millisecondsInMinute) + seconds * (0, $32hfQ.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $10c70630666045c7$export$d931c43c4608a164(dateString) {
    return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).anyDigitsSigned, dateString);
}
function $10c70630666045c7$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).singleDigit, dateString);
        case 2:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).twoDigits, dateString);
        case 3:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).threeDigits, dateString);
        case 4:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).fourDigits, dateString);
        default:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $10c70630666045c7$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388((0, $jG9OU.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $10c70630666045c7$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $10c70630666045c7$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $10c70630666045c7$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $10c70630666045c7$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("jG9OU", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", () => $e5398e9fa5129247$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $e5398e9fa5129247$export$a7ee192b982af9c1);
var $e5398e9fa5129247$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $e5398e9fa5129247$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("3ovXz", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $278c6787239771ce$export$b8ef38dfcf05d5db);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");

var $8O7vq = parcelRequire("8O7vq");

var $iE2Wv = parcelRequire("iE2Wv");
var $278c6787239771ce$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $jrmEa.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $4ow2D.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 130);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $1riXU.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $8O7vq.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $1riXU.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $iE2Wv.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $iE2Wv.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $6dukW.Parser));

});

parcelRegister("2OXI7", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $20de9189e2efe069$export$951d1df011fde06f);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");

var $8mopN = parcelRequire("8mopN");
var $20de9189e2efe069$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $jrmEa.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $4ow2D.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 130);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $1riXU.parseNDigitsSigned)(4, dateString);
                return (0, $1riXU.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $8mopN.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $6dukW.Parser));

});

parcelRegister("hTKPR", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $d07be73ffd17e9d4$export$bad9d2ea38e8f1a);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $d07be73ffd17e9d4$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(ExtendedYearParser, _Parser);
    var _super = (0, $jrmEa.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $4ow2D.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 130);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $1riXU.parseNDigitsSigned)(4, dateString);
                return (0, $1riXU.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $6dukW.Parser));

});

parcelRegister("kDsq8", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $f05d7ede3913a071$export$5cb0f701186dde1d);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $f05d7ede3913a071$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(QuarterParser, _Parser);
    var _super = (0, $jrmEa.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $4ow2D.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 120);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $6dukW.Parser));

});

parcelRegister("9sCrE", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $6e348cf0d2c64ae3$export$300c0c2990e20e6d);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $6e348cf0d2c64ae3$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $jrmEa.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $4ow2D.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 120);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $6dukW.Parser));

});

parcelRegister("OK2pB", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $098861cb6e50f804$export$400dd8b40ef138a3);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $1riXU = parcelRequire("1riXU");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");
var $098861cb6e50f804$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(MonthParser, _Parser);
    var _super = (0, $jrmEa.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $4ow2D.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 110);
        return _this;
    }
    (0, $1iGel.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $1riXU.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $6dukW.Parser));

});

parcelRegister("h1ZiK", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $c66214d8e6c0a605$export$1d7eaa53eaa5deba);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $c66214d8e6c0a605$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $jrmEa.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $4ow2D.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 110);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $1riXU.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $6dukW.Parser));

});

parcelRegister("l34ow", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $f52d49755b82eb07$export$c4005ffc174e07c0);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");

var $kjwJG = parcelRequire("kjwJG");

var $iE2Wv = parcelRequire("iE2Wv");
var $f52d49755b82eb07$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(LocalWeekParser, _Parser);
    var _super = (0, $jrmEa.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $4ow2D.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 100);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $iE2Wv.default)((0, $kjwJG.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $6dukW.Parser));

});
parcelRegister("kjwJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec9ef9a5952b035c$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $4YLNd = parcelRequire("4YLNd");

var $fHILx = parcelRequire("fHILx");

var $6Z3KL = parcelRequire("6Z3KL");
function $ec9ef9a5952b035c$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $6Z3KL.default)(2, arguments);
    var date = (0, $4YLNd.default)(dirtyDate);
    var week = (0, $7IxPz.default)(dirtyWeek);
    var diff = (0, $fHILx.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("1dwN6", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $0e3070f2a29c7fed$export$6fc8dbedd560a6af);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");

var $eyvFB = parcelRequire("eyvFB");

var $8mopN = parcelRequire("8mopN");
var $0e3070f2a29c7fed$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(ISOWeekParser, _Parser);
    var _super = (0, $jrmEa.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $4ow2D.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 100);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $8mopN.default)((0, $eyvFB.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $6dukW.Parser));

});
parcelRegister("eyvFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98cceb1366a8472$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $4YLNd = parcelRequire("4YLNd");

var $iUHnc = parcelRequire("iUHnc");

var $6Z3KL = parcelRequire("6Z3KL");
function $a98cceb1366a8472$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $6Z3KL.default)(2, arguments);
    var date = (0, $4YLNd.default)(dirtyDate);
    var isoWeek = (0, $7IxPz.default)(dirtyISOWeek);
    var diff = (0, $iUHnc.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("6ZEqW", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $5177cdd5e1330b9f$export$e8d4b28a20981dd2);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $1riXU = parcelRequire("1riXU");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");
var $5177cdd5e1330b9f$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $5177cdd5e1330b9f$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $5177cdd5e1330b9f$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(DateParser, _Parser);
    var _super = (0, $jrmEa.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $4ow2D.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 90);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "subPriority", 1);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $1riXU.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $5177cdd5e1330b9f$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $5177cdd5e1330b9f$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $6dukW.Parser));

});

parcelRegister("2eKwn", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $1a10f9b39ac584bf$export$6cfe0d613455f615);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $1a10f9b39ac584bf$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(DayOfYearParser, _Parser);
    var _super = (0, $jrmEa.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $4ow2D.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 90);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "subpriority", 1);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $1riXU.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $6dukW.Parser));

});

parcelRegister("iNSVm", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $db07685f4f12772d$export$1b03c8b76262f7bd);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $ckasU = parcelRequire("ckasU");
var $db07685f4f12772d$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(DayParser, _Parser);
    var _super = (0, $jrmEa.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $4ow2D.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 90);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $ckasU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $6dukW.Parser));

});
parcelRegister("ckasU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8f787b9d96cc03$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");

var $7IxPz = parcelRequire("7IxPz");

var $gfYwW = parcelRequire("gfYwW");
function $8f8f787b9d96cc03$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6Z3KL.default)(2, arguments);
    var defaultOptions = (0, $gfYwW.getDefaultOptions)();
    var weekStartsOn = (0, $7IxPz.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $4YLNd.default)(dirtyDate);
    var day = (0, $7IxPz.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("6gwZX", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $48fdd57440d130f4$export$44d1c127ab42c480);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");

var $ckasU = parcelRequire("ckasU");
var $48fdd57440d130f4$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(LocalDayParser, _Parser);
    var _super = (0, $jrmEa.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $4ow2D.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 90);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $1riXU.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $ckasU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $6dukW.Parser));

});

parcelRegister("a4pn9", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $754df58dd7cd49d2$export$e447a647caaaec1d);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");

var $ckasU = parcelRequire("ckasU");
var $754df58dd7cd49d2$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $jrmEa.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $4ow2D.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 90);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $1riXU.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $ckasU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $6dukW.Parser));

});

parcelRegister("crnMN", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $90ea750ce2e934a6$export$693fb1e525095b2a);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");

var $eJCfq = parcelRequire("eJCfq");
var $90ea750ce2e934a6$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(ISODayParser, _Parser);
    var _super = (0, $jrmEa.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $4ow2D.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 90);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $1riXU.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $1riXU.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $1riXU.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $1riXU.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $eJCfq.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $6dukW.Parser));

});
parcelRegister("eJCfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba2efdf637220a0$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");

var $7IxPz = parcelRequire("7IxPz");
function $aba2efdf637220a0$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $6Z3KL.default)(2, arguments);
    var day = (0, $7IxPz.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $4YLNd.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("2wiU8", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $1d5d3bf3e2468f62$export$8d1e08492351df91);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $1d5d3bf3e2468f62$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(AMPMParser, _Parser);
    var _super = (0, $jrmEa.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $4ow2D.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 80);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $1riXU.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $6dukW.Parser));

});

parcelRegister("aLijy", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $7d5c800a802f2e45$export$73ca2bd0a17d273);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $7d5c800a802f2e45$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $jrmEa.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $4ow2D.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 80);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $1riXU.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $6dukW.Parser));

});

parcelRegister("dqaaB", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $9c5597a116dffec5$export$bb9212adf05373db);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $9c5597a116dffec5$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(DayPeriodParser, _Parser);
    var _super = (0, $jrmEa.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $4ow2D.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 80);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $1riXU.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $6dukW.Parser));

});

parcelRegister("8TjyR", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $6792a2424352cba5$export$8a04050a727a1756);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $6792a2424352cba5$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(Hour1to12Parser, _Parser);
    var _super = (0, $jrmEa.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $4ow2D.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 70);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $6dukW.Parser));

});

parcelRegister("gdWKQ", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $bcfb6faa2d84e922$export$e56f4dea2c3e56dd);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $bcfb6faa2d84e922$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(Hour0to23Parser, _Parser);
    var _super = (0, $jrmEa.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $4ow2D.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 70);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $6dukW.Parser));

});

parcelRegister("5sqFR", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $3f944231c7c37ab1$export$cbbe855312f87d77);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $3f944231c7c37ab1$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(Hour0To11Parser, _Parser);
    var _super = (0, $jrmEa.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $4ow2D.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 70);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $6dukW.Parser));

});

parcelRegister("e1WgN", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $a36e5be4b3bbbfc6$export$6008046d2b34b6a5);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $a36e5be4b3bbbfc6$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(Hour1To24Parser, _Parser);
    var _super = (0, $jrmEa.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $4ow2D.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 70);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $6dukW.Parser));

});

parcelRegister("iXjcT", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $dccca2c82bad3a59$export$2b52670d9e2be53);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $dccca2c82bad3a59$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(MinuteParser, _Parser);
    var _super = (0, $jrmEa.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $4ow2D.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 60);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $6dukW.Parser));

});

parcelRegister("cnfDz", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $9023c339fb420cd8$export$94d46d540cf1366a);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $9023c339fb420cd8$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(SecondParser, _Parser);
    var _super = (0, $jrmEa.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $4ow2D.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 50);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $1riXU.parseNumericPattern)((0, $jG9OU.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $1riXU.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $6dukW.Parser));

});

parcelRegister("jOHY4", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $03b91c0c389a4c0b$export$b8e6f8b2d70893b1);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $03b91c0c389a4c0b$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $jrmEa.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $4ow2D.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 30);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1iGel.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $1riXU.mapValue)((0, $1riXU.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $6dukW.Parser));

});

parcelRegister("752tB", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $527aebcfff2b7474$export$104d901d49fea29b);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $527aebcfff2b7474$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $jrmEa.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $4ow2D.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 10);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $1iGel.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $6dukW.Parser));

});

parcelRegister("30xlx", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $230b3d12f78f27f3$export$12910e5204b52b9);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $jG9OU = parcelRequire("jG9OU");

var $1riXU = parcelRequire("1riXU");
var $230b3d12f78f27f3$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $jrmEa.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $4ow2D.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 10);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $1iGel.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $1riXU.parseTimezonePattern)((0, $jG9OU.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $6dukW.Parser));

});

parcelRegister("lhbPq", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $f7d45c69b371079c$export$2cd8bf877a05e96);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $f7d45c69b371079c$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $jrmEa.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $4ow2D.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 40);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $1iGel.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $1riXU.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $6dukW.Parser));

});

parcelRegister("aakXT", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $766b19c29e3e9a95$export$6d8f69c6906d6368);

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $3uu23 = parcelRequire("3uu23");

var $hvsbO = parcelRequire("hvsbO");

var $jrmEa = parcelRequire("jrmEa");

var $1tVDE = parcelRequire("1tVDE");

var $6dukW = parcelRequire("6dukW");

var $1riXU = parcelRequire("1riXU");
var $766b19c29e3e9a95$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $hvsbO.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $jrmEa.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $4ow2D.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "priority", 20);
        (0, $1tVDE.default)((0, $3uu23.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $1iGel.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $1riXU.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $6dukW.Parser));

});



parcelRegister("jUZqZ", function(module, exports) {

$parcel$export(module.exports, "ADFRendererWithExtensions", () => $3417e4f9eaf6aefe$export$d0545564fef5423e);
$parcel$export(module.exports, "ADFRenderer", () => (parcelRequire("hEeUR")).ADFRenderer);
$parcel$export(module.exports, "registerGlobalMediaViewedListener", () => (parcelRequire("edEsl")).registerGlobalMediaViewedListener);
$parcel$export(module.exports, "removeGlobalMediaViewedListener", () => (parcelRequire("edEsl")).removeGlobalMediaViewedListener);
$parcel$export(module.exports, "createSmartCardEventHandler", () => (parcelRequire("kdOv6")).createSmartCardEventHandler);
$parcel$export(module.exports, "createLinkEventHandler", () => (parcelRequire("h0UOA")).createLinkEventHandler);
$parcel$export(module.exports, "useEventHandlers", () => (parcelRequire("bzqa9")).useEventHandlers);
$parcel$export(module.exports, "ANALYTICS_EVENT_SEVERITY_TRACKING", () => (parcelRequire("fyKZ5")).ANALYTICS_EVENT_SEVERITY_TRACKING);
$parcel$export(module.exports, "UNSUPPORTED_CONTENT_THRESHOLDS", () => (parcelRequire("fyKZ5")).UNSUPPORTED_CONTENT_THRESHOLDS);

var $jmjWc = parcelRequire("jmjWc");

var $hEeUR = parcelRequire("hEeUR");

var $edEsl = parcelRequire("edEsl");

var $kdOv6 = parcelRequire("kdOv6");

var $h0UOA = parcelRequire("h0UOA");

var $bzqa9 = parcelRequire("bzqa9");

var $fyKZ5 = parcelRequire("fyKZ5");

const $3417e4f9eaf6aefe$export$d0545564fef5423e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lpCx0",
    name: "ADFRendererWithExtensions",
    loader: async ()=>(await (parcelRequire("3zar2"))).ADFRendererWithExtensions
});

});
parcelRegister("hEeUR", function(module, exports) {

$parcel$export(module.exports, "ADFRenderer", () => $2a9f51add9ac11ab$export$7cfa481653c48265);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $gqqjz = parcelRequire("gqqjz");

var $3PXtn = parcelRequire("3PXtn");

var $8WfxO = parcelRequire("8WfxO");

var $gz8ZY = parcelRequire("gz8ZY");

var $fyKZ5 = parcelRequire("fyKZ5");
const $2a9f51add9ac11ab$export$7cfa481653c48265 = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { includeTopNav: includeTopNav } = (0, $gwFzn.useContext)((0, $3PXtn.BannerContext));
    const { atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer),
            (0, $3PXtn.BannerStateContainer),
            (0, $3PXtn.FloatingBannerStateContainer)
        ]
    }, (flags, bannerState, floatingBanners)=>{
        const topNavAndBannerHeight = bannerState.getTotalHeight(includeTopNav);
        // if page header is fixed at the top, it adds extra 55px offset
        // However, when there is a theme applied to a space, page headers are not fixed at the top and will not require additional offset.
        const pageHeaderAndBannerHeight = floatingBanners.getFloatingHeight() + (props.isContentHeaderFixedAtTop ? 55 + atlGeneralWebPanelHeight : 0);
        const stickyTableHeaderOffsetTopForNav3 = topNavAndBannerHeight + pageHeaderAndBannerHeight;
        // topNavAndBannerHeight is outside the scroll root in Nav4
        const stickyTableHeaderOffsetTopForNav4 = pageHeaderAndBannerHeight;
        let stickyTableHeaderConfig = {
            offsetTop: stickyTableHeaderOffsetTopForNav3
        };
        if (isNav4Enabled) stickyTableHeaderConfig = {
            offsetTop: stickyTableHeaderOffsetTopForNav4,
            defaultScrollRootId_DO_NOT_USE: 'AkMainContent',
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: true
        };
        // WARNING: PERFORMANCE: <ADFRendererComponent> has been split out from <ADFRenderer>
        // because the child function of <Subscribe> component is called 4-5 times per every
        // transition or initial load. This caused AkRenderer component to be re-rendered the
        // same amount of times, which is quite bad for performance. Split allows to memoize
        // the <ADFRendererComponent> and render it only once.
        //
        // The fact that <ADFRenderer> is used for comments as well makes it even more
        // important to *not* re-render AkRenderer more than once for a page or comment.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fyKZ5.ADFRendererComponent), {
            flags: flags,
            ...stickyTableHeaderConfig,
            ...props
        });
    });
});
$2a9f51add9ac11ab$export$7cfa481653c48265.displayName = 'ADFRenderer';

});
parcelRegister("8WfxO", function(module, exports) {

$parcel$export(module.exports, "useATLGeneralWebPanelListener", () => $720c81ac24834d84$export$dc9cc84753faedac);

var $gwFzn = parcelRequire("gwFzn");

var $eSLr0 = parcelRequire("eSLr0");

var $3jwuS = parcelRequire("3jwuS");

var $ep3mz = parcelRequire("ep3mz");

var $dS3n9 = parcelRequire("dS3n9");
const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const [webPanelHeight, setWebPanelHeight] = (0, $gwFzn.useState)($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
    const [{ contentId: contentId, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isATLGeneralWebPanelFixed = panels.length > 0 && !isLivePage;
    (0, $gwFzn.useEffect)(()=>{
        const listener = ()=>{
            setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
        };
        if (isATLGeneralWebPanelFixed) document.addEventListener('atlGeneralWebPanelHeightUpdated', listener);
        return ()=>{
            if (isATLGeneralWebPanelFixed) document.removeEventListener('atlGeneralWebPanelHeightUpdated', listener);
        };
    }, [
        isATLGeneralWebPanelFixed
    ]);
    return {
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        atlGeneralWebPanelHeight: webPanelHeight
    };
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};

});
parcelRegister("dS3n9", function(module, exports) {

$parcel$export(module.exports, "useWebPanelLocation", () => $9fffd50bbcc7c343$export$c8daa7260f75e213);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $c3Qwv = parcelRequire("c3Qwv");
var $7zgzO = parcelRequire("7zgzO");

var $8pvtc = parcelRequire("8pvtc");
const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const { loading: loading, data: data, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $8pvtc.WebPanelLocationQuery), {
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    const panels = (data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: loading,
        error: error
    };
};

});


parcelRegister("fyKZ5", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_EVENT_SEVERITY_TRACKING", () => $1af8a83cb114ff50$export$3422b9c70e187e34);
$parcel$export(module.exports, "UNSUPPORTED_CONTENT_THRESHOLDS", () => $1af8a83cb114ff50$export$c02e908ea3c1fe52);
$parcel$export(module.exports, "ADFRendererComponent", () => $1af8a83cb114ff50$export$cec675c14d32c246);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dLvRS = parcelRequire("dLvRS");

var $4FxUL = parcelRequire("4FxUL");

var $ibzAc = parcelRequire("ibzAc");

var $67O0h = parcelRequire("67O0h");

var $dh538 = parcelRequire("dh538");

var $1iSzD = parcelRequire("1iSzD");

var $gNTSy = parcelRequire("gNTSy");

var $8cjD5 = parcelRequire("8cjD5");

var $fgQGl = parcelRequire("fgQGl");

var $3TtS2 = parcelRequire("3TtS2");

var $hSHWm = parcelRequire("hSHWm");

var $b2eAY = parcelRequire("b2eAY");

var $j5Mgj = parcelRequire("j5Mgj");

var $brsfB = parcelRequire("brsfB");


var $gXrHX = parcelRequire("gXrHX");

var $1SPMi = parcelRequire("1SPMi");

var $yuV6Z = parcelRequire("yuV6Z");

var $kLzei = parcelRequire("kLzei");

var $3WO8q = parcelRequire("3WO8q");
var $4IoVL = parcelRequire("4IoVL");
var $dtVue = parcelRequire("dtVue");
var $kBU5m = parcelRequire("kBU5m");
var $gxhb8 = parcelRequire("gxhb8");
var $iP9x4 = parcelRequire("iP9x4");

var $32x2E = parcelRequire("32x2E");

var $jyPfN = parcelRequire("jyPfN");

var $lykqo = parcelRequire("lykqo");

var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");

var $gj42z = parcelRequire("gj42z");
var $4GlQ9 = parcelRequire("4GlQ9");

var $dPJCf = parcelRequire("dPJCf");

var $4o1RV = parcelRequire("4o1RV");

var $bQm3c = parcelRequire("bQm3c");

var $6mKj3 = parcelRequire("6mKj3");

var $e4o8D = parcelRequire("e4o8D");

var $6M71K = parcelRequire("6M71K");

var $edEsl = parcelRequire("edEsl");

var $5hfGu = parcelRequire("5hfGu");

var $3mTvL = parcelRequire("3mTvL");
const $1af8a83cb114ff50$export$3422b9c70e187e34 = {
    enabled: true,
    severityDegradedThreshold: 4747,
    severityNormalThreshold: 3775
};
const $1af8a83cb114ff50$var$logger = (0, $7W8i8.getLogger)('ADFRenderer');
const $1af8a83cb114ff50$export$c02e908ea3c1fe52 = {
    enabled: true,
    thresholds: {
        blocking: 1.5,
        degraded: 1
    }
};
const $1af8a83cb114ff50$var$mergeDataProviders = ({ hasViewUserProfilePermission: hasViewUserProfilePermission, handleActionToggle: handleActionToggle, handleInviteItemClick: handleInviteItemClick, getDataProviders: getDataProviders, providerFactory: providerFactory, isExternalShare: isExternalShare, contentId: contentId, spaceKey: spaceKey, pageContextContentId: pageContextContentId, cloudId: cloudId, userId: userId, userRole: userRole, flags: flags, profilecardProvider: profilecardProvider, intl: intl, mediaToken: mediaToken, emojiResourceParams: emojiResourceParams })=>{
    const providers = {};
    if (getDataProviders) Object.assign(providers, getDataProviders());
    if (contentId || mediaToken) {
        providers.mediaProvider = (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            spaceKey: spaceKey,
            mediaDspContentId: pageContextContentId,
            isExternalShare: isExternalShare,
            mediaToken: mediaToken
        });
        providers.taskDecisionProvider = Promise.resolve(new (0, $3WO8q.ConfluenceTaskDecisionProvider)(intl, flags, contentId, handleActionToggle));
    }
    if (cloudId && userId) providers.mentionProvider = (0, $dtVue.createMentionsConfig)(cloudId, userId, undefined, undefined, handleInviteItemClick, userRole).then((config)=>config.mentionResource).catch((err)=>{
        if ($3mTvL.env.NODE_ENV !== 'production') $1af8a83cb114ff50$var$logger.error`Failed to initialise mention resource ${err}`;
        return Promise.reject();
    });
    if (emojiResourceParams && cloudId) providers.emojiProvider = (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (cloudId) // If global view user profile is enabled then user can view profile card
    {
        if (hasViewUserProfilePermission) // If Public Link, we want to disable profileCard handlers
        providers.profilecardProvider = isExternalShare && (0, $dh538.fg)('public_links_content_id_removal') ? Promise.resolve() : profilecardProvider;
    }
    if (contentId && spaceKey) providers.contextIdentifierProvider = Promise.resolve({
        containerId: spaceKey,
        objectId: contentId,
        product: 'confluence'
    });
    providers.cardProvider = Promise.resolve(new (0, $dLvRS.EditorCardProvider)(undefined, undefined, 'CONFLUENCE'));
    const keys = Object.keys(providers);
    if (keys.length) {
        providerFactory = providerFactory || (0, $4FxUL.default).create({});
        for (const provider of Object.keys(providers))providerFactory.setProvider(provider, providers[provider]);
    }
    return providerFactory;
};
const $1af8a83cb114ff50$var$projectLinkerHandlers = {
    'com.atlassian.confluence.project-linker': ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null)
};
const $1af8a83cb114ff50$export$58eac04eb6213951 = ()=>(0, $dh538.fg)('platform_renderer_unsupported_content_tracking') ? $1af8a83cb114ff50$export$c02e908ea3c1fe52 : undefined;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS = {};
const $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS = ()=>$1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $1af8a83cb114ff50$export$cec675c14d32c246 = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>{
    const { document: document, dataProviders: dataProviders, extensionHandlers: extensionHandlers = (0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS : {}, getExtensionHandlers: getExtensionHandlers = (0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS : ()=>({}), eventHandlers: eventHandlers, appearance: appearance, adfStage: adfStage = 'stage0', portal: portal, onComplete: onComplete, onRendered: onRendered, renderWhenReady: renderWhenReady, allowStickyHeaders: allowStickyHeaders = true, allowPlaceholderText: allowPlaceholderText = false, isTruncatedContent: isTruncatedContent, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, flags: flags, offsetTop: offsetTop, defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE, shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE, mediaToken: mediaToken, onError: onError, UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment = true, UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing = true, UNSTABLE_isPresentational: UNSTABLE_isPresentational = false, extensionViewportSizes: extensionViewportSizes = (0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES : [], onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail, ...rest } = props;
    const intl = (0, $dBxQj.default)();
    const [isTaskToggled, setIsTaskToggled] = (0, $gwFzn.useState)(false);
    const initialState = window['__SSR_SMARTLINKS__'];
    const isPageSSR = (0, $3TtS2.isPageSSRd)();
    const storeOptions = (0, $3TtS2.useStoreOptions)(initialState, isPageSSR);
    // Fix for HOT-99954 - Issue where embedded pages SSR SmartLinks open in same tab
    const shouldSSRsmartLinks = isPageSSR && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isLicensed: isLicensed, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [pageContextContentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $gwFzn.useContext)((0, $hSHWm.CoreInvitesContext));
    const [shouldRefetchContent, setShouldRefetchContent] = (0, $gwFzn.useState)(false);
    const contentId = props.contentId || pageContextContentId;
    const contentType = props.contentType || pageContextContentType;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const taskBatcherRef = (0, $gwFzn.useRef)(new (0, $gxhb8.TaskBatcher)((0, $6mKj3.expVal)('confluence_frontend_task_batching_interval', 'value', 3000)));
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    // Handlers for batched task update
    const handleBatchTaskUpdate = (0, $gwFzn.useCallback)((batch)=>{
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        (0, $5hfGu.batchTaskUpdate)(contentId, batch).then(()=>{
            setIsTaskToggled(false);
            setShouldRefetchContent(true);
        });
    }, [
        contentId,
        setShouldRefetchContent
    ]);
    const handleActionToggle = (0, $gwFzn.useCallback)((objectKey, state)=>{
        setIsTaskToggled(true);
        taskBatcherRef.current.add({
            objectKey: objectKey,
            state: state
        });
    }, [
        taskBatcherRef
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // there is a document check - we do not want to call registerGlobalMediaViewedListener
        // with no content
        if (document) (0, $edEsl.registerGlobalMediaViewedListener)();
        onRendered && onRendered();
        taskBatcherRef.current.onFlush(handleBatchTaskUpdate);
        return ()=>{
            if (document) (0, $edEsl.removeGlobalMediaViewedListener)();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        taskBatcherRef,
        handleBatchTaskUpdate
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setShouldRefetchContent(false);
    // WS-4098 - When the contentId changes or when we mount we don't need to refetch
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        contentId
    ]);
    const handleBeforeUnload = (event)=>{
        if (isTaskToggled) {
            event.preventDefault();
            event.returnValue = ''; // This triggers the alert in all browsers
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTaskToggled,
        contentId
    ]);
    // Setting up emoji resources for ssr and data providers
    const emojiResourceParams = (0, $gwFzn.useMemo)(()=>{
        if (cloudId) return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn,
            onEmojiLoadSuccess: onEmojiLoadSuccess,
            onEmojiLoadFail: onEmojiLoadFail
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn,
        onEmojiLoadSuccess,
        onEmojiLoadFail
    ]);
    const emojiResourceConfig = (0, $gwFzn.useMemo)(()=>{
        if (emojiResourceParams) return (0, $32x2E.getEmojiConfig)(emojiResourceParams.cloudId, emojiResourceParams.userId, emojiResourceParams.disableUpload, emojiResourceParams.emojiSSRConfig, undefined, emojiResourceParams.emojiLoadCallbacks);
    }, [
        emojiResourceParams
    ]);
    const { isExternalShareRequest: isExternalShareRequest } = (0, $gwFzn.useContext)((0, $gXrHX.ExternalShareContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const getMergedExtensionHandlers = (0, $gwFzn.useCallback)(()=>{
        let mergedExtensionHandlers = extensionHandlers;
        if (getExtensionHandlers) mergedExtensionHandlers = Object.assign({}, getExtensionHandlers(), extensionHandlers);
        return {
            ...mergedExtensionHandlers,
            ...(0, $b2eAY.getRendererCustomSitesExtensionHandlers)({
                contentId: contentId
            }),
            ...(0, $gNTSy.getRendererSmartButtonExtensionHandlers)({
                contentId: contentId,
                contentType: contentType,
                cloudId: cloudId
            }),
            ...$1af8a83cb114ff50$var$projectLinkerHandlers
        };
    }, [
        extensionHandlers,
        getExtensionHandlers,
        contentId,
        contentType,
        cloudId
    ]);
    const mergedExtensionHandlersAfterOptimization = (0, $gwFzn.useMemo)(()=>(0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? getMergedExtensionHandlers() : undefined, [
        getMergedExtensionHandlers
    ]);
    const mergedExtensionHandlers = (0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? mergedExtensionHandlersAfterOptimization : getMergedExtensionHandlers();
    const mediaSSR = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShareRequest,
        mediaToken: mediaToken
    });
    // -- Matches fabric-feature-flags.ts
    const isStickyHeadersEnabled = allowStickyHeaders;
    const errorHandlerBeforeOptimization = (error)=>{
        if (onError) onError(error);
    };
    const errorHandlerAfterOptimization = (0, $gwFzn.useCallback)(errorHandlerBeforeOptimization, [
        onError
    ]);
    const errorHandler = (0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? errorHandlerAfterOptimization : errorHandlerBeforeOptimization;
    const { shimAdfUrls: shimAdfUrls } = (0, $4o1RV.useNavigationPolicy)();
    const editorFeatureFlags = (0, $j5Mgj.useEditorFeatureFlags)();
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        userId: userId,
        cloudId: cloudId,
        featureFlags: featureFlags
    });
    const linkingPlatformFeatureFlags = (0, $lykqo.useSmartCardProviderFeatureFlags)();
    const shouldControlDataExport = (0, $4IoVL.controlDataExportOnCertainFeatures)(window.location.pathname);
    const onRenderComplete = (0, $gwFzn.useCallback)((stats)=>{
        if (onComplete) onComplete(stats);
    }, [
        onComplete
    ]);
    // ----------------------------------
    const allowHeadingAnchorLinks = (0, $gwFzn.useMemo)(()=>({
            allowNestedHeaderLinks: true,
            activeHeadingId: props.queryHash
        }), [
        props.queryHash
    ]);
    /*
   * With recent Feature Flags clean up, useSessionData now returns {} for featureFlags
   * So here we can safely drop getMediaFeatureFlags as it only evaluates existence of any featureFlags.
   * {} will always return TRUE in current implementation.
   */ const media = (0, $gwFzn.useMemo)(()=>({
            allowLinking: true,
            allowCaptions: true,
            featureFlags: {
                mediaInline: true
            },
            ssr: mediaSSR
        }), [
        mediaSSR
    ]);
    const smartLinks = (0, $gwFzn.useMemo)(()=>({
            ssr: shouldSSRsmartLinks,
            hideHoverPreview: false
        }), [
        shouldSSRsmartLinks
    ]);
    const stickyHeaders = (0, $gwFzn.useMemo)(()=>isStickyHeadersEnabled ? {
            offsetTop: offsetTop,
            defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE,
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
        } : undefined, [
        isStickyHeadersEnabled,
        offsetTop,
        defaultScrollRootId_DO_NOT_USE,
        shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
    ]);
    if (!document) return null;
    const mergedDataProviders = $1af8a83cb114ff50$var$mergeDataProviders({
        contentId: // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        contentId,
        spaceKey: // @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
        spaceKey,
        pageContextContentId: pageContextContentId,
        cloudId: cloudId,
        userId: userId,
        flags: flags,
        featureFlags: featureFlags,
        push: push,
        intl: intl,
        providerFactory: dataProviders,
        profilecardProvider: profilecardProvider,
        isExternalShare: isExternalShareRequest,
        handleActionToggle: handleActionToggle,
        hasViewUserProfilePermission: hasViewUserProfilePermission,
        handleInviteItemClick: openCoreInvites,
        userRole: userRole,
        mediaToken: mediaToken,
        emojiResourceParams: emojiResourceParams
    });
    const finalDocument = shimAdfUrls(document);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        ...(0, $kLzei.getSmartCardRenderers)(),
        ...storeOptions,
        featureFlags: linkingPlatformFeatureFlags,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        product: "CONFLUENCE"
    }, (appearance === 'full-page' || appearance === 'full-width') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8cjD5.PageLoadMark), {
        "data-testid": "pageLoadMarkTestId",
        name: "onBeforeAkRenderer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1SPMi.RendererAnalyticsListener), {
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        objectId: contentId,
        objectType: contentType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67O0h.RendererWithAnalytics), {
        // This flag is used for fixing table width in SSR mode and for hydration
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        enableSsrInlineScripts: Boolean(undefined),
        // include renderer inline script from above on first render to prevent hydration mismatch
        noOpSSRInlineScript: renderServerPlaceholder,
        adfStage: adfStage,
        document: finalDocument,
        appearance: appearance,
        stickyHeaders: (0, $dh538.fg)('cc_perf_reduce_rerenders') ? stickyHeaders : isStickyHeadersEnabled && {
            offsetTop: offsetTop,
            defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE,
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
        },
        extensionHandlers: mergedExtensionHandlers,
        eventHandlers: eventHandlers,
        featureFlags: editorFeatureFlags,
        dataProviders: mergedDataProviders,
        portal: portal,
        onComplete: onRenderComplete,
        allowColumnSorting: true,
        allowHeadingAnchorLinks: (0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? allowHeadingAnchorLinks : {
            allowNestedHeaderLinks: true,
            activeHeadingId: props.queryHash
        },
        allowAltTextOnImages: true,
        media: (0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? media : {
            allowLinking: true,
            allowCaptions: true,
            featureFlags: (0, $kBU5m.getMediaFeatureFlags)(featureFlags),
            ssr: mediaSSR
        },
        emojiResourceConfig: emojiResourceConfig,
        allowCopyToClipboard: true,
        allowWrapCodeBlock: true,
        ...rest,
        useSpecBasedValidator: true,
        truncated: isTruncatedContent,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        analyticsEventSeverityTracking: $1af8a83cb114ff50$export$3422b9c70e187e34,
        unsupportedContentLevelsTracking: $1af8a83cb114ff50$export$58eac04eb6213951(),
        allowPlaceholderText: allowPlaceholderText,
        allowCustomPanels: true,
        smartLinks: (0, $dh538.fg)('cc_complexit_fe_reduce_rerender') ? smartLinks : {
            ssr: shouldSSRsmartLinks,
            hideHoverPreview: false
        },
        extensionViewportSizes: extensionViewportSizes,
        onError: errorHandler,
        UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment,
        UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing,
        UNSTABLE_isPresentational: UNSTABLE_isPresentational
    }), renderWhenReady && renderWhenReady()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fgQGl.ContentRefetchHandler), {
        contentId: contentId,
        shouldRefetch: shouldRefetchContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedFollowData.feedConfigError,
        mutationError: feedFollowData.mutationError,
        showErrorFlag: true
    }));
});

});
parcelRegister("8cjD5", function(module, exports) {

$parcel$export(module.exports, "PageLoadMark", () => $ee56b91c2bcc40e3$export$60e4773fef02e3c);

var $gwFzn = parcelRequire("gwFzn");

var $3kTfj = parcelRequire("3kTfj");

var $dIouf = parcelRequire("dIouf");
const $ee56b91c2bcc40e3$var$PageLoadMarkComponent = ({ name: name })=>{
    const pageLoadMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    (0, $gwFzn.useEffect)(()=>{
        pageLoadMetric.mark(name);
    }, [
        pageLoadMetric,
        name
    ]);
    return null;
};
const $ee56b91c2bcc40e3$export$60e4773fef02e3c = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).BACKBONE
})($ee56b91c2bcc40e3$var$PageLoadMarkComponent);

});

parcelRegister("fgQGl", function(module, exports) {

$parcel$export(module.exports, "ContentRefetchHandler", () => $96596a053dd4ef1e$export$d1bbac313eb9a2c1);

var $gwFzn = parcelRequire("gwFzn");

var $lpxTx = parcelRequire("lpxTx");
var $61vTv = parcelRequire("61vTv");

var $cLo2u = parcelRequire("cLo2u");

var $hp2SH = parcelRequire("hp2SH");

var $dPJCf = parcelRequire("dPJCf");

var $ep3mz = parcelRequire("ep3mz");
const $96596a053dd4ef1e$export$d1bbac313eb9a2c1 = ({ contentId: contentId, shouldRefetch: shouldRefetch, refetchImmediately: refetchImmediately, onRefetchComplete: onRefetchComplete })=>{
    const history = (0, $dPJCf.useHistory)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    (0, $gwFzn.useEffect)(()=>{
        let unlisten;
        if (shouldRefetch && contentId) {
            let chooseContentUnifiedQuery = (0, $61vTv.ContentUnifiedQuery);
            const queryVariable = {
                contentId: contentId,
                spaceKey: spaceKey,
                useNewContentTopper: true
            };
            if (contentType === 'blogpost') chooseContentUnifiedQuery = (0, $lpxTx.ContentBlogUnifiedQuery);
            const refetchFn = async ()=>{
                let versionNumber;
                try {
                    const queryResult = await (0, $hp2SH.getApolloClient)().query({
                        query: chooseContentUnifiedQuery,
                        context: {
                            single: true
                        },
                        fetchPolicy: 'network-only',
                        variables: queryVariable
                    });
                    // at this time, queryResult.data is always ContentUnifiedQueryType or ContentBlogUnifiedQueryType format
                    // @ts-ignore
                    versionNumber = queryResult.data.content?.nodes?.[0]?.version?.number;
                } catch (error) {
                // NOTE: We intentionally swallow any possible error here as this query is only aimed to
                // populate the cache with just published content. Should any error occur here after
                // successful publishing the page, the Apollo cache for the query will be invalidated
                // anyway and View Page will fetch the page and handle possible errors.
                }
                // If a callback is supplied, call it regardless
                onRefetchComplete && onRefetchComplete(versionNumber);
            };
            if (refetchImmediately) refetchFn();
            else unlisten = history?.listen(refetchFn);
        }
        return ()=>{
            // Call the unlistener when this component unmounts
            unlisten && unlisten();
        };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        shouldRefetch
    ]);
    return null;
};

});

parcelRegister("b2eAY", function(module, exports) {

$parcel$export(module.exports, "getRendererCustomSitesExtensionHandlers", () => $044598a12ce14eec$export$2a3fa2b29e6e4046);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $9wGTI = parcelRequire("9wGTI");

var $4Xxgr = parcelRequire("4Xxgr");

var $chBfV = parcelRequire("chBfV");

var $ddbT9 = parcelRequire("ddbT9");

var $atBlB = parcelRequire("atBlB");

var $e5v7w = parcelRequire("e5v7w");

var $9rzlS = parcelRequire("9rzlS");

var $aRCfj = parcelRequire("aRCfj");

var $8P8yc = parcelRequire("8P8yc");

var $6vBy9 = parcelRequire("6vBy9");

var $qHXgy = parcelRequire("qHXgy");

var $2Z0Ux = parcelRequire("2Z0Ux");

var $abinC = parcelRequire("abinC");

var $ejFHT = parcelRequire("ejFHT");

const $044598a12ce14eec$var$PlatformSearchExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "24LHW",
    name: "PlatformSearchExtensionLoader",
    loader: async ()=>(await (parcelRequire("3qwoP"))).CustomSearchExtension
});
const $044598a12ce14eec$export$2a3fa2b29e6e4046 = ({ contentId: contentId })=>{
    const extensionHandlers = {
        [(0, $4Xxgr.linkCardsExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null),
        [(0, $atBlB.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null),
        [(0, $aRCfj.linksMenuExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null),
        [(0, $9rzlS.hubElementPlaceholderExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null),
        [(0, $chBfV.spotlightExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null),
        [(0, $qHXgy.hubSectionExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null),
        [(0, $2Z0Ux.searchExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null)
    };
    if (contentId) {
        extensionHandlers[0, $4Xxgr.linkCardsExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ddbT9.LinkCardsLoader), {
                extensionNode: extension,
                contentId: contentId
            });
        extensionHandlers[0, $atBlB.carouselExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e5v7w.CarouselLoader), {
                extensionNode: extension,
                contentId: contentId
            });
        extensionHandlers[0, $aRCfj.linksMenuExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8P8yc.LinksMenuLoader), {
                extensionNode: extension,
                contentId: contentId
            });
        extensionHandlers[0, $chBfV.spotlightExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6vBy9.SpotlightLoader), {
                extensionNode: extension,
                contentId: contentId
            });
        if ((0, $9wGTI.fg)('company_hub_section_extension')) extensionHandlers[0, $9rzlS.hubElementPlaceholderExtensionType] = ()=>null;
        if ((0, $9wGTI.fg)('company_hub_search_extension')) extensionHandlers[0, $2Z0Ux.searchExtensionType] = (extension)=>(0, $9wGTI.fg)('company_hub_search_extension_platformization') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($044598a12ce14eec$var$PlatformSearchExtensionLoader, {
                mode: "renderer",
                contentId: contentId,
                extensionNode: extension,
                propsProvider: (0, $ejFHT.CustomSearchExtensionPropsProvider)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $abinC.SearchExtensionLoader), {
                extensionNode: extension,
                contentId: contentId,
                mode: "renderer"
            });
    }
    return extensionHandlers;
};

});
parcelRegister("4Xxgr", function(module, exports) {

$parcel$export(module.exports, "linkCardsExtensionType", () => $dd50b3b82599d5f8$export$3c8c9455100c4d01);
$parcel$export(module.exports, "linkCardsExtensionKey", () => $dd50b3b82599d5f8$export$87a8e3803a4f0bb6);
const $dd50b3b82599d5f8$export$3c8c9455100c4d01 = 'com.atlassian.confluence.link-cards';
const $dd50b3b82599d5f8$export$87a8e3803a4f0bb6 = 'cards';

});

parcelRegister("chBfV", function(module, exports) {

$parcel$export(module.exports, "spotlightExtensionType", () => $59c10eb3ac644491$export$28c1670baba89c6d);
$parcel$export(module.exports, "spotlightExtensionKey", () => $59c10eb3ac644491$export$678addaa7f09fc18);
$parcel$export(module.exports, "getLayoutOptions", () => $59c10eb3ac644491$export$3238f1bda20b469c);

var $2nPZH = parcelRequire("2nPZH");

var $6dXII = parcelRequire("6dXII");
const $59c10eb3ac644491$export$28c1670baba89c6d = 'com.atlassian.confluence.spotlight';
const $59c10eb3ac644491$export$678addaa7f09fc18 = 'spotlight';
const $59c10eb3ac644491$var$i18n = (0, $2nPZH.defineMessages)({
    splitDesignContentFirstLabel: {
        id: "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.split-design-content-first.label",
        defaultMessage: "Split design (content first)"
    },
    splitDesignContentFirstDescription: {
        id: "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.split-design-content-first.description",
        defaultMessage: "Large image on the right with lots of room for content"
    },
    splitDesignImageFirstLabel: {
        id: "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.split-design-image-first.label",
        defaultMessage: "Split design (image first)"
    },
    splitDesignImageFirstDescription: {
        id: "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.split-design-image-first.description",
        defaultMessage: "Large image on the left with lots of room for content"
    },
    solidColorBackgroundLabel: {
        id: "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.solid-color-background.label",
        defaultMessage: "Solid color background"
    },
    solidColorBackgroundDescription: {
        id: "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.solid-color-background.description",
        defaultMessage: "Content in front of a full-width color"
    },
    // We will eventually use these translations when full background layout is properly introduced
    imageBackgroundLabel: {
        id: "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.image-background.label",
        defaultMessage: "Image background"
    },
    imageBackgroundDescription: {
        id: "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.image-background.description",
        defaultMessage: "Full-size image behind your content"
    }
});
const $59c10eb3ac644491$export$3238f1bda20b469c = ()=>[
        {
            label: $59c10eb3ac644491$var$i18n.splitDesignContentFirstLabel,
            description: $59c10eb3ac644491$var$i18n.splitDesignContentFirstDescription,
            value: (0, $6dXII.Layout).SPLIT_IMAGE_RIGHT
        },
        {
            label: $59c10eb3ac644491$var$i18n.splitDesignImageFirstLabel,
            description: $59c10eb3ac644491$var$i18n.splitDesignImageFirstDescription,
            value: (0, $6dXII.Layout).SPLIT_IMAGE_LEFT
        },
        {
            label: $59c10eb3ac644491$var$i18n.solidColorBackgroundLabel,
            description: $59c10eb3ac644491$var$i18n.solidColorBackgroundDescription,
            value: (0, $6dXII.Layout).NO_IMAGE_BACKGROUND
        }
    ];

});
parcelRegister("6dXII", function(module, exports) {

$parcel$export(module.exports, "ButtonStyle", () => $8d81feace13fe0e4$export$bdc3c19374266b98);
$parcel$export(module.exports, "CornerStyle", () => $8d81feace13fe0e4$export$a6e645fda5339bf8);
$parcel$export(module.exports, "Height", () => $8d81feace13fe0e4$export$8954cfac7c08d16a);
$parcel$export(module.exports, "Layout", () => $8d81feace13fe0e4$export$c84671f46d6a1ca);
var $8d81feace13fe0e4$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $8d81feace13fe0e4$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $8d81feace13fe0e4$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $8d81feace13fe0e4$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    Layout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    Layout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    Layout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return Layout;
}({});

});


parcelRegister("ddbT9", function(module, exports) {

$parcel$export(module.exports, "LinkCardsLoader", () => $61515f2b7128240f$export$2beedf31158dda51);

var $jmjWc = parcelRequire("jmjWc");

const $61515f2b7128240f$export$2beedf31158dda51 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oZCPB",
    name: "LinkCardsLoader",
    loader: async ()=>(await (parcelRequire("gNeXX"))).LinkCards
});

const $61515f2b7128240f$export$12aa3936be45655f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Xkgs-",
    name: "LazyLinkCardsLoader",
    loader: async ()=>(await (parcelRequire("gNeXX"))).LinkCards
});

});
parcelRegister("gNeXX", function(module, exports) {

let $c39cd4e659f96ba7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c39cd4e659f96ba7$var$load("iOWBI"),
    $c39cd4e659f96ba7$var$load("i7Jz8"),
    $c39cd4e659f96ba7$var$load("l7tIA"),
    $c39cd4e659f96ba7$var$load("9jsMO"),
    $c39cd4e659f96ba7$var$load("15APZ"),
    $c39cd4e659f96ba7$var$load("cea9f"),
    $c39cd4e659f96ba7$var$load("18vkH"),
    $c39cd4e659f96ba7$var$load("dTsOE"),
    $c39cd4e659f96ba7$var$load("hlqS1"),
    $c39cd4e659f96ba7$var$load("l42ar"),
    $c39cd4e659f96ba7$var$load("abVVB"),
    $c39cd4e659f96ba7$var$load("3c6qD"),
    $c39cd4e659f96ba7$var$load("fKONs"),
    $c39cd4e659f96ba7$var$load("j2OLf"),
    $c39cd4e659f96ba7$var$load("f28kH"),
    $c39cd4e659f96ba7$var$load("47wm8"),
    $c39cd4e659f96ba7$var$load("dzfxi"),
    $c39cd4e659f96ba7$var$load("7OtNC"),
    $c39cd4e659f96ba7$var$load("k6H7B"),
    $c39cd4e659f96ba7$var$load("7jSfd"),
    $c39cd4e659f96ba7$var$load("4HZlX"),
    $c39cd4e659f96ba7$var$load("kDqHr"),
    $c39cd4e659f96ba7$var$load("cMkgU"),
    $c39cd4e659f96ba7$var$load("lGAyv"),
    $c39cd4e659f96ba7$var$load("k1P8U")
]).then(()=>parcelRequire('d12gf'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("atBlB", function(module, exports) {

$parcel$export(module.exports, "carouselExtensionType", () => $1ecfe268fdfb1587$export$a06ac4f1777262dc);
$parcel$export(module.exports, "carouselExtensionKey", () => $1ecfe268fdfb1587$export$6c8179fa243b4399);
const $1ecfe268fdfb1587$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $1ecfe268fdfb1587$export$6c8179fa243b4399 = 'carousel';

});

parcelRegister("e5v7w", function(module, exports) {

$parcel$export(module.exports, "CarouselLoader", () => $2507cc0c94e65872$export$24486403434f6b4d);

var $jmjWc = parcelRequire("jmjWc");

const $2507cc0c94e65872$export$24486403434f6b4d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Eue7r",
    name: "CarouselLoader",
    loader: async ()=>(await (parcelRequire("1x8zN"))).Carousel
});

});
parcelRegister("1x8zN", function(module, exports) {

let $11df869390f4890f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $11df869390f4890f$var$load("k9cIR"),
    $11df869390f4890f$var$load("i7Jz8"),
    $11df869390f4890f$var$load("9jsMO"),
    $11df869390f4890f$var$load("15APZ"),
    $11df869390f4890f$var$load("cea9f"),
    $11df869390f4890f$var$load("18vkH"),
    $11df869390f4890f$var$load("dTsOE"),
    $11df869390f4890f$var$load("hlqS1"),
    $11df869390f4890f$var$load("l42ar"),
    $11df869390f4890f$var$load("abVVB"),
    $11df869390f4890f$var$load("b1gz4"),
    $11df869390f4890f$var$load("3c6qD"),
    $11df869390f4890f$var$load("fKONs"),
    $11df869390f4890f$var$load("j2OLf"),
    $11df869390f4890f$var$load("f28kH"),
    $11df869390f4890f$var$load("47wm8"),
    $11df869390f4890f$var$load("dzfxi"),
    $11df869390f4890f$var$load("7OtNC"),
    $11df869390f4890f$var$load("k6H7B"),
    $11df869390f4890f$var$load("7jSfd"),
    $11df869390f4890f$var$load("4HZlX"),
    $11df869390f4890f$var$load("kDqHr"),
    $11df869390f4890f$var$load("cMkgU"),
    $11df869390f4890f$var$load("lGAyv"),
    $11df869390f4890f$var$load("bed51")
]).then(()=>parcelRequire('lUnNV'));

});


parcelRegister("9rzlS", function(module, exports) {

$parcel$export(module.exports, "hubElementPlaceholderExtensionType", () => $98d24493cc64d988$export$a4bfe061f1fc2c67);
$parcel$export(module.exports, "hubElementPlaceholderExtensionKey", () => $98d24493cc64d988$export$aab3db793969d2df);
const $98d24493cc64d988$export$a4bfe061f1fc2c67 = 'com.atlassian.confluence.hub-element-placeholder';
const $98d24493cc64d988$export$aab3db793969d2df = 'hub-element-placeholder';

});

parcelRegister("aRCfj", function(module, exports) {

$parcel$export(module.exports, "linksMenuExtensionType", () => $8b5cf443f5f4a1db$export$a049a122ffcd7c92);
const $8b5cf443f5f4a1db$export$a049a122ffcd7c92 = 'com.atlassian.confluence.links-menu';

});

parcelRegister("8P8yc", function(module, exports) {

$parcel$export(module.exports, "LinksMenuLoader", () => $6302cd72168ba6a3$export$7a975701387c77ee);

var $jmjWc = parcelRequire("jmjWc");

const $6302cd72168ba6a3$export$7a975701387c77ee = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Hnyho",
    name: "LinksMenuLoader",
    loader: async ()=>(await (parcelRequire("7bDzn"))).LinksMenu
});

});
parcelRegister("7bDzn", function(module, exports) {

let $0159ae786faf6357$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0159ae786faf6357$var$load("aIlQC"),
    $0159ae786faf6357$var$load("6rkIt")
]).then(()=>parcelRequire('j2LbL'));

});


parcelRegister("6vBy9", function(module, exports) {

$parcel$export(module.exports, "SpotlightLoader", () => $26123ee5918d59dd$export$6832664000e5de60);

var $jmjWc = parcelRequire("jmjWc");

const $26123ee5918d59dd$export$6832664000e5de60 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "bnubB",
    name: "SpotlightLoader",
    loader: async ()=>(await (parcelRequire("9PCSD"))).Spotlight
});

});
parcelRegister("9PCSD", function(module, exports) {

let $7287094a4e405ceb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7287094a4e405ceb$var$load("9jsMO"),
    $7287094a4e405ceb$var$load("hzK1f"),
    $7287094a4e405ceb$var$load("fqrMn"),
    $7287094a4e405ceb$var$load("fYi1a"),
    $7287094a4e405ceb$var$load("bjzRn"),
    $7287094a4e405ceb$var$load("8mzoy"),
    $7287094a4e405ceb$var$load("7a9CL"),
    $7287094a4e405ceb$var$load("ivQYH"),
    $7287094a4e405ceb$var$load("8pE8S"),
    $7287094a4e405ceb$var$load("9Bu2S"),
    $7287094a4e405ceb$var$load("42vdC"),
    $7287094a4e405ceb$var$load("P5iE2"),
    $7287094a4e405ceb$var$load("2A5uW")
]).then(()=>parcelRequire('2ztSd'));

});


parcelRegister("qHXgy", function(module, exports) {

$parcel$export(module.exports, "hubSectionExtensionType", () => $f0d500570c5a98a0$export$bc9fa5e8a0c47b8b);
$parcel$export(module.exports, "hubSectionExtensionKey", () => $f0d500570c5a98a0$export$162cfec6280046d8);
$parcel$export(module.exports, "hubSectionAnalyticsSource", () => $f0d500570c5a98a0$export$adafe054ed92710c);
$parcel$export(module.exports, "CONTENT_WIDTH", () => $f0d500570c5a98a0$export$3130b484681bf8bc);
$parcel$export(module.exports, "DEFAULT_CONTENT_WIDTH", () => $f0d500570c5a98a0$export$6cccba5fae1d609d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $f0d500570c5a98a0$export$617cdcc6afaae4f7);
$parcel$export(module.exports, "getSectionExtensionContents", () => $f0d500570c5a98a0$export$993dca3597b448e8);

var $9rzlS = parcelRequire("9rzlS");
const $f0d500570c5a98a0$export$bc9fa5e8a0c47b8b = 'com.atlassian.confluence.hub-section';
const $f0d500570c5a98a0$export$162cfec6280046d8 = 'hub-section';
const $f0d500570c5a98a0$export$adafe054ed92710c = 'hub-sectionExtensionConfig';
var $f0d500570c5a98a0$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $f0d500570c5a98a0$export$6cccba5fae1d609d = "wide";
const $f0d500570c5a98a0$export$617cdcc6afaae4f7 = "var(--ds-surface, #FFFFFF)";
const $f0d500570c5a98a0$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>[
        {
            type: 'extensionFrame',
            content: [
                {
                    type: 'heading',
                    attrs: {
                        level: 1,
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${header}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${subHeader}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    }
                },
                {
                    type: 'extension',
                    attrs: {
                        extensionKey: (0, $9rzlS.hubElementPlaceholderExtensionKey),
                        extensionType: (0, $9rzlS.hubElementPlaceholderExtensionType),
                        parameters: {
                            extensionTitle: placeholderTitle
                        },
                        text: null,
                        layout: 'default',
                        localId: null
                    }
                }
            ]
        }
    ];

});

parcelRegister("2Z0Ux", function(module, exports) {

$parcel$export(module.exports, "searchVersion1", () => $683ce5eb1a6d8512$export$574395bc86cafa5d);
$parcel$export(module.exports, "searchExtensionKey", () => $683ce5eb1a6d8512$export$b4c28aeba24199c9);
$parcel$export(module.exports, "searchExtensionType", () => $683ce5eb1a6d8512$export$11ec81e6f061b327);
const $683ce5eb1a6d8512$export$574395bc86cafa5d = '1';
const $683ce5eb1a6d8512$export$b4c28aeba24199c9 = 'company-hub-search';
const $683ce5eb1a6d8512$export$11ec81e6f061b327 = 'com.atlassian.confluence.company-hub-search';

});

parcelRegister("abinC", function(module, exports) {

$parcel$export(module.exports, "SearchExtensionLoader", () => $080646e3fbf1754f$export$945b08120371c8ae);

var $jmjWc = parcelRequire("jmjWc");

const $080646e3fbf1754f$export$945b08120371c8ae = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Yo3Uh",
    name: "SearchExtensionLoader",
    loader: async ()=>(await (parcelRequire("boS5I"))).SearchExtension
});

});
parcelRegister("boS5I", function(module, exports) {

let $84cbe4fb613f08f1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $84cbe4fb613f08f1$var$load("kxuof"),
    $84cbe4fb613f08f1$var$load("iOWBI"),
    $84cbe4fb613f08f1$var$load("kB1sA"),
    $84cbe4fb613f08f1$var$load("7X74w"),
    $84cbe4fb613f08f1$var$load("4ru9N"),
    $84cbe4fb613f08f1$var$load("18vkH"),
    $84cbe4fb613f08f1$var$load("cMlHc"),
    $84cbe4fb613f08f1$var$load("aQp8v"),
    $84cbe4fb613f08f1$var$load("2jsRt"),
    $84cbe4fb613f08f1$var$load("2zJ0a"),
    $84cbe4fb613f08f1$var$load("6Yu8N"),
    $84cbe4fb613f08f1$var$load("4R9Qs")
]).then(()=>parcelRequire('8mqw8'));

});


parcelRegister("ejFHT", function(module, exports) {

$parcel$export(module.exports, "CustomSearchExtensionPropsProvider", () => $bebcf9e9945eb7d4$export$9b56a53d12268eed);

var $gwFzn = parcelRequire("gwFzn");

var $h4UMB = parcelRequire("h4UMB");

var $dIouf = parcelRequire("dIouf");

var $5kjCz = parcelRequire("5kjCz");
var $bX5uj = parcelRequire("bX5uj");

var $1NBp8 = parcelRequire("1NBp8");

var $bQm3c = parcelRequire("bQm3c");

var $4mffJ = parcelRequire("4mffJ");

var $8a8f1 = parcelRequire("8a8f1");

var $25Zbl = parcelRequire("25Zbl");
const $bebcf9e9945eb7d4$export$9b56a53d12268eed = ({ children: children, mode: mode, contentId: contentId = '', extensionNode: extensionNode })=>{
    const sessionData = (0, $bQm3c.useSessionData)();
    const getSpaceIdsFromSpaceKeys = (0, $4mffJ.useGetSpaceIdsFromSpaceKeys)();
    const { cloudId: cloudId = '', displayName: displayName = '', isAdminHubAIEnabled: isAdminHubAIEnabled = false, orgId: orgId = '', userId: userId = '' } = sessionData || {};
    const errorBoundaryComponent = (0, $gwFzn.useMemo)(()=>{
        return ({ children: childrenErrorBoundary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
                attribution: (0, $dIouf.Attribution).COMPANY_HUB
            }, childrenErrorBoundary);
    }, []);
    const experienceStartComponent = (0, $gwFzn.useMemo)(()=>{
        const Component = mode === 'editor' ? (0, $8a8f1.CustomSitesExtension) : (0, $25Zbl.CustomSitesRenderedExtension);
        return ({ children: childrenExperienceStart })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
                extensionNode: extensionNode,
                contentId: contentId,
                showNoDataState: mode === 'editor' && !extensionNode
            }, childrenExperienceStart);
        };
    }, [
        mode,
        extensionNode,
        contentId
    ]);
    const experienceSuccessComponent = (0, $gwFzn.useCallback)(()=>{
        const experience = mode === 'editor' ? (0, $5kjCz.EDITOR) : (0, $5kjCz.RENDERER);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: (0, $5kjCz.getExperienceName)(experience, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode?.extensionKey,
            mode: experience,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const props = (0, $gwFzn.useMemo)(()=>({
            mode: mode,
            orgId: orgId,
            cloudId: cloudId,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            userId: userId || '',
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys,
            displayName: displayName || '',
            advancedSearchUrl: (0, $1NBp8.ADVANCED_SEARCH).toUrl(),
            peopleDirectoryUrl: (0, $1NBp8.PEOPLE_DIRECTORY).toUrl(),
            errorBoundaryComponent: errorBoundaryComponent,
            experienceStartComponent: experienceStartComponent,
            experienceSuccessComponent: experienceSuccessComponent
        }), [
        mode,
        orgId,
        userId,
        cloudId,
        displayName,
        isAdminHubAIEnabled,
        getSpaceIdsFromSpaceKeys,
        errorBoundaryComponent,
        experienceStartComponent,
        experienceSuccessComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h4UMB.CustomSearchExtensionPropsContext).Provider, {
        value: props
    }, children);
};

});
parcelRegister("h4UMB", function(module, exports) {

$parcel$export(module.exports, "CustomSearchExtensionPropsContext", () => $732f51f9ec20d2bd$export$27c3b1f11c064c31);

var $gwFzn = parcelRequire("gwFzn");
const $732f51f9ec20d2bd$var$defaultContext = {
    advancedSearchUrl: '',
    cloudId: '',
    displayName: '',
    getSpaceIdsFromSpaceKeys: async ()=>[],
    isAdminHubAIEnabled: false,
    orgId: '',
    peopleDirectoryUrl: '',
    userId: '',
    errorBoundaryComponent: (0, $gwFzn.Fragment),
    experienceStartComponent: (0, $gwFzn.Fragment),
    experienceSuccessComponent: (0, $gwFzn.Fragment)
};
const $732f51f9ec20d2bd$export$27c3b1f11c064c31 = /*#__PURE__*/ (0, $gwFzn.createContext)($732f51f9ec20d2bd$var$defaultContext);

});

parcelRegister("4mffJ", function(module, exports) {

$parcel$export(module.exports, "useGetSpaceIdsFromSpaceKeys", () => $47b615d0f1500806$export$50f68914d42bd134);

var $gwFzn = parcelRequire("gwFzn");

var $d2LG0 = parcelRequire("d2LG0");

var $hp2SH = parcelRequire("hp2SH");

var $5ZqQS = parcelRequire("5ZqQS");

var $dIouf = parcelRequire("dIouf");
// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
const $47b615d0f1500806$var$UseGetSpaceIdsFromSpaceKeysQuery = (0, $d2LG0.default)`query UseGetSpaceIdsFromSpaceKeysQuery($spaceKeys:[String]){spaces(spaceKeys:$spaceKeys){nodes{id}}}`;
const $47b615d0f1500806$export$50f68914d42bd134 = ()=>{
    const getSpaceIdsFromSpaceKeys = (0, $gwFzn.useCallback)(async (spaceKeys)=>{
        const apolloClient = (0, $hp2SH.getApolloClient)();
        if (spaceKeys.length === 0) return [];
        try {
            const { data: data } = await apolloClient.query({
                query: $47b615d0f1500806$var$UseGetSpaceIdsFromSpaceKeysQuery,
                variables: {
                    spaceKeys: spaceKeys
                }
            });
            const spaceIds = (data.spaces?.nodes ?? []).map((node)=>node?.id).filter((id)=>!!id);
            return spaceIds;
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $dIouf.Attribution).COMPANY_HUB
            });
        }
        return [];
    }, []);
    return getSpaceIdsFromSpaceKeys;
};

});

parcelRegister("8a8f1", function(module, exports) {

$parcel$export(module.exports, "CustomSitesExtension", () => $34e19507d1762bb2$export$a567e8ed5717bee7);

var $gwFzn = parcelRequire("gwFzn");

var $aJPUt = parcelRequire("aJPUt");

var $5kjCz = parcelRequire("5kjCz");
var $4KFTW = parcelRequire("4KFTW");

var $ge2sX = parcelRequire("ge2sX");
var $f7i8j = parcelRequire("f7i8j");

var $lssSm = parcelRequire("lssSm");
const $34e19507d1762bb2$export$a567e8ed5717bee7 = ({ extensionNode: extensionNode, contentId: contentId, showNoDataState: showNoDataState, children: children })=>{
    const { extensionKey: extensionKey } = extensionNode;
    const macroAttributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.EDITOR), extensionNode),
            contentId: contentId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: macroAttributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), !showNoDataState ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lssSm.CustomSitesExtensionNoDataComponent), {
            source: extensionKey
        })));
};

});
parcelRegister("lssSm", function(module, exports) {

$parcel$export(module.exports, "CustomSitesExtensionNoDataComponent", () => $f5e251166e9aa0e0$export$71510344581d633);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $abC4X = parcelRequire("abC4X");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $5ZqQS = parcelRequire("5ZqQS");

var $dIouf = parcelRequire("dIouf");

var $eEFRK = parcelRequire("eEFRK");
const $f5e251166e9aa0e0$var$baseStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $f5e251166e9aa0e0$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    noDataStateHeaderText: {
        id: "custom-sites-extensions.link-cards.error-states.no-data.header-text",
        defaultMessage: "No data to display"
    },
    noDataStateDescription: {
        id: "custom-sites-extensions.link-cards.error-states.no-data.description-text",
        defaultMessage: "Try deleting this macro and creating a new one."
    }
});
const $f5e251166e9aa0e0$export$71510344581d633 = ({ source: source, isConfigPanel: isConfigPanel })=>{
    const intl = (0, $dBxQj.default)();
    const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);
    (0, $gwFzn.useEffect)(()=>{
        const errorMessage = `${extensionSourceName} ${isConfigPanel ? 'config panel' : 'extension'} failed to render. No parameters.`;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(errorMessage), {
            attribution: (0, $dIouf.Attribution).COMPANY_HUB
        });
    }, [
        extensionSourceName,
        isConfigPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $f5e251166e9aa0e0$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isConfigPanel ? (0, $ecnYn.xcss)({
                height: '90%'
            }) : (0, $ecnYn.xcss)({
                height: '100%'
            })
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $abC4X.default), {
        header: intl.formatMessage($f5e251166e9aa0e0$export$a7357cdd1f0b0168.noDataStateHeaderText),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f5e251166e9aa0e0$export$a7357cdd1f0b0168.noDataStateDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eEFRK)))
    }));
};

});
parcelRegister("eEFRK", function(module, exports) {
module.exports = new URL("Warning.e56d4e3e.svg", import.meta.url).toString();

});



parcelRegister("25Zbl", function(module, exports) {

$parcel$export(module.exports, "CustomSitesRenderedExtension", () => $d3c557b0f9d2c547$export$8939de262f4b5024);

var $gwFzn = parcelRequire("gwFzn");

var $atveb = parcelRequire("atveb");

var $inPa6 = parcelRequire("inPa6");

var $dIouf = parcelRequire("dIouf");

var $aJPUt = parcelRequire("aJPUt");

var $5kjCz = parcelRequire("5kjCz");
var $4KFTW = parcelRequire("4KFTW");

var $78QFu = parcelRequire("78QFu");
const $d3c557b0f9d2c547$var$CustomSitesRenderedExtensionContainer = ({ extensionNode: extensionNode, contentId: contentId, analyticsAttributes: analyticsAttributes, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { extensionKey: extensionKey, parameters: parameters } = extensionNode;
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: extensionKey,
                source: 'viewPageScreen',
                attributes: {
                    ...analyticsAttributes,
                    hasParameters: !!parameters,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const macroAttributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode);
    const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extensionNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KFTW.MacroExperienceStart), {
        name: experienceName,
        contentId: contentId,
        mode: (0, $5kjCz.RENDERER),
        extensionKey: extensionKey,
        attributes: macroAttributes,
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
    }), children);
};
const $d3c557b0f9d2c547$export$8939de262f4b5024 = /*#__PURE__*/ (0, $gwFzn.memo)((0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).COMPANY_HUB
})($d3c557b0f9d2c547$var$CustomSitesRenderedExtensionContainer), (0, (/*@__PURE__*/$parcel$interopDefault($atveb))));

});


parcelRegister("3qwoP", function(module, exports) {

let $27eceeab18fffe75$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $27eceeab18fffe75$var$load("e4zJF"),
    $27eceeab18fffe75$var$load("kxuof"),
    $27eceeab18fffe75$var$load("iOWBI"),
    $27eceeab18fffe75$var$load("kB1sA"),
    $27eceeab18fffe75$var$load("7X74w"),
    $27eceeab18fffe75$var$load("4ru9N"),
    $27eceeab18fffe75$var$load("18vkH"),
    $27eceeab18fffe75$var$load("cMlHc"),
    $27eceeab18fffe75$var$load("aQp8v"),
    $27eceeab18fffe75$var$load("2jsRt"),
    $27eceeab18fffe75$var$load("2zJ0a"),
    $27eceeab18fffe75$var$load("6Yu8N"),
    $27eceeab18fffe75$var$load("kUykF")
]).then(()=>parcelRequire('27HWy'));

});


parcelRegister("brsfB", function(module, exports) {

$parcel$export(module.exports, "useProfilecardProvider", () => $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $9UKrO = parcelRequire("9UKrO");

var $bedVD = parcelRequire("bedVD");
var $4qzKl = parcelRequire("4qzKl");
var $4GlQ9 = parcelRequire("4GlQ9");

var $jlIaF = parcelRequire("jlIaF");
function $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c({ push: push, userId: userId, cloudId: cloudId, featureFlags: featureFlags }) {
    const intl = (0, $dBxQj.default)();
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    const handleProfileCardActions = (0, $gwFzn.useCallback)((pushProfileCardActions, loggedInUserId)=>(profileCardUserId)=>{
            const atlassianPeopleProfileUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH));
            const followed = !!(profileCardUserId && feedFollowData?.followedUsers?.includes(profileCardUserId));
            return [
                {
                    label: intl.formatMessage({
                        id: "view.profile"
                    }),
                    callback: ()=>{
                        pushProfileCardActions((0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH)));
                    },
                    link: atlassianPeopleProfileUrl
                },
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bedVD.FeedFollow), {
                        followed: followed
                    }),
                    id: 'feed-follow-user',
                    callback: feedFollowData.getToggleFollowUser(profileCardUserId, followed, 'editor'),
                    shouldRender: (userData)=>feedFollowData.renderFeedFollow && Boolean(profileCardUserId) && profileCardUserId !== loggedInUserId && userData?.status === 'active'
                }
            ];
        }, [
        feedFollowData,
        intl
    ]);
    return (0, $gwFzn.useMemo)(()=>{
        return (0, $9UKrO.getProfileCardProvider)(cloudId, handleProfileCardActions(push, userId), featureFlags);
    }, [
        cloudId,
        handleProfileCardActions,
        push,
        userId,
        featureFlags
    ]);
}

});
parcelRegister("9UKrO", function(module, exports) {

$parcel$export(module.exports, "getProfileCardProvider", () => $88671cc112964e63$export$ecc18d1a90c31bf8);

var $bumSD = parcelRequire("bumSD");
function $88671cc112964e63$export$ecc18d1a90c31bf8(cloudId, getActions, featureFlags) {
    return Promise.resolve({
        cloudId: cloudId,
        resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
        getActions: getActions
    });
}

});


parcelRegister("3WO8q", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTaskDecisionProvider", () => $cc5c5911f5458682$export$bfe822b045233127);

var $hp2SH = parcelRequire("hp2SH");

var $eRkqO = parcelRequire("eRkqO");

var $9bZqv = parcelRequire("9bZqv");
class $cc5c5911f5458682$export$bfe822b045233127 {
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) {
            this._toggleTaskCallback(objectKey, state);
            return Promise.resolve(state);
        } else /**
       * Using objectKey.objectAri may be a better alternative to passing in
       * contentId to the constructor. If it's reliable.
       */ return (0, $hp2SH.getApolloClient)().mutate({
            mutation: (0, $eRkqO.SetTaskStatusMutation),
            variables: {
                contentId: this.contentId,
                taskId: objectKey.localId,
                status: state === 'DONE' ? 'CHECKED' : 'UNCHECKED'
            }
        }).then((response)=>{
            const success = response?.data?.setTaskStatus?.success || false;
            if (!success) this.showErrorFlag();
            return state;
        }).catch(// this method is set to return `any` as a workaround for types.
        // Given that `TaskDecisionProvider.toggleTask` does not actually permit
        // `void` to be returned, what the `catch` block should probably be doing
        // is re-throwing the error that it got (at least that might match the
        // expectations). Since doing that will result in actual behavior changes
        // which I'm hesitant to perform, TS is simply silenced by `ny`-ing the
        // return type.
        (_)=>{
            /**
         * Note: there seems to be an issue whereby clicking a checkbox twice
         * quickly causes an error. I'm guessing something's not happy with a
         * mutation being issued while the previous one was still in-flight.
         * KTLO: we should probably create a queue as a workaround.
         * I'm (mdean2) not fixing this right now because I'm up against the
         * clock and the previous classic implementation suffered the same
         * problem.
         */ this.showErrorFlag();
        });
    }
    showErrorFlag() {
        this.flags.showErrorFlag({
            title: this.intl.formatMessage((0, $9bZqv.i18n).flagTitle),
            description: this.intl.formatMessage((0, $9bZqv.i18n).flagDescription)
        });
    }
    // Below are stubs, implemented to pacify TypeScript, and inherited from old
    // classic implementation.
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    /* eslint-disable no-useless-constructor */ constructor(intl, flags, contentId, toggleTaskCallback){
        this.intl = intl;
        this.flags = flags;
        this.contentId = contentId;
        this.toggleTaskCallback = toggleTaskCallback;
        this._toggleTaskCallback = void 0;
        /**
     * eslint mistakenly thinks this is a useless constructor. It's not,
     * because TypeScript translates the 'public' arguments to actual code that
     * assigns them to instance variables.
     */ this._toggleTaskCallback = toggleTaskCallback;
    }
}

});
parcelRegister("eRkqO", function(module, exports) {

$parcel$export(module.exports, "SetTaskStatusMutation", () => $b50b509b402b0702$export$89c600402d79f2bd);

var $d2LG0 = parcelRequire("d2LG0");
const $b50b509b402b0702$export$89c600402d79f2bd = (0, $d2LG0.default)`mutation SetTaskStatusMutation($contentId:ID!$taskId:ID!$status:TaskStatus!){setTaskStatus(inlineTasksInput:{cid:$contentId taskId:$taskId status:$status trigger:VIEW_PAGE}){success}}`;

});

parcelRegister("9bZqv", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $c88a9f0357b47b1b$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $c88a9f0357b47b1b$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    flagTitle: {
        id: "fabric-media-support.tasklist.error.flag.title",
        defaultMessage: "Something went wrong"
    },
    flagDescription: {
        id: "fabric-media-support.tasklist.error.flag.description",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "An error occurred while trying to change a task's status. Please try again later."
    }
});

});


parcelRegister("gxhb8", function(module, exports) {

$parcel$export(module.exports, "TaskBatcher", () => $6c53b0825160fdb5$export$9a91b236871b318c);
/* eslint-disable no-useless-constructor */ class $6c53b0825160fdb5$export$9a91b236871b318c {
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallback = callback;
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs){
        this.flushIntervalMs = flushIntervalMs;
        this.flushIntervalId = void 0;
        this.onFlushCallback = void 0;
        this.currentBatch = [];
        this.add = (item)=>{
            this.scheduleFlush();
            // If there's a previous task action for the same task, remove it
            this.currentBatch = this.currentBatch.filter((task)=>task.objectKey.localId !== item.objectKey.localId);
            this.currentBatch.push(item);
        };
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            try {
                if (this.onFlushCallback) this.onFlushCallback(batch);
            } catch (e) {
                // rethrow error asynchronously to allow other callbacks to execute
                setTimeout(()=>{
                    /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                    throw e;
                }, 0);
            }
        };
    }
}

});

parcelRegister("edEsl", function(module, exports) {

$parcel$export(module.exports, "registerGlobalMediaViewedListener", () => $027ba4852fb11225$export$dbbc14ed63c88dd4);
$parcel$export(module.exports, "removeGlobalMediaViewedListener", () => $027ba4852fb11225$export$29046bd16724fad9);
/* tslint:disable */ /* eslint-disable */ 
var $eGqQQ = parcelRequire("eGqQQ");
const $027ba4852fb11225$var$requests = new Map();
const $027ba4852fb11225$var$setCacheWithTimeout = (fileId, req)=>$027ba4852fb11225$var$requests.set(fileId, req) && void setTimeout(()=>$027ba4852fb11225$var$requests.delete(fileId), 3000);
const $027ba4852fb11225$var$globalMediaViewedListener = (options)=>{
    // To avoid case when user opens media-picker (and we don't want to call BE API after that)
    if (!options.isUserCollection) {
        // Sometimes globalEventMediaEmitter will invoke the globalMediaViewedListener callback
        // multiple times for a single `media-viewed` event. For this reason we return a cached
        // request promise if one exists
        const priorRequestForTheSameFileID = $027ba4852fb11225$var$requests.get(options?.fileId);
        return priorRequestForTheSameFileID || (()=>{
            const mediaViewedReq = fetch('/wiki/rest/internal/1.0/eventnotifier/notify', {
                method: 'POST',
                body: JSON.stringify({
                    attachmentViewed: {
                        fileStoreId: options.fileId
                    }
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            $027ba4852fb11225$var$setCacheWithTimeout(options.fileId, mediaViewedReq);
            return mediaViewedReq;
        })();
    }
};
let $027ba4852fb11225$var$mediaViewedListenerRegistered = false;
const $027ba4852fb11225$export$dbbc14ed63c88dd4 = ()=>{
    if (!$027ba4852fb11225$var$mediaViewedListenerRegistered) {
        (0, $eGqQQ.globalMediaEventEmitter).on('media-viewed', $027ba4852fb11225$var$globalMediaViewedListener);
        $027ba4852fb11225$var$mediaViewedListenerRegistered = true;
    }
};
const $027ba4852fb11225$export$29046bd16724fad9 = ()=>{
    (0, $eGqQQ.globalMediaEventEmitter).off('media-viewed', $027ba4852fb11225$var$globalMediaViewedListener);
    $027ba4852fb11225$var$mediaViewedListenerRegistered = false;
};

});

parcelRegister("5hfGu", function(module, exports) {

$parcel$export(module.exports, "batchTaskUpdate", () => $ad68e9e7df73622d$export$ee66267d3930a21);

var $04e9M = parcelRequire("04e9M");

var $hp2SH = parcelRequire("hp2SH");

var $eXfot = parcelRequire("eXfot");
async function $ad68e9e7df73622d$export$ee66267d3930a21(contentId, batch) {
    const updateBatch = batch.map((update)=>{
        const { objectKey: objectKey, state: state } = update;
        const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';
        return {
            taskId: objectKey.localId,
            status: status
        };
    });
    const taskBatch = {
        contentId: contentId,
        tasks: updateBatch,
        trigger: 'VIEW_PAGE'
    };
    try {
        return await (0, $hp2SH.getApolloClient)().mutate({
            mutation: (0, $eXfot.SetBatchedTaskStatusMutation),
            variables: taskBatch
        });
    } catch (error) {
        const client = await (0, $04e9M.getAnalyticsWebClient)();
        client.sendOperationalEvent({
            source: 'page',
            action: 'batchTaskUpdate',
            actionSubject: 'checkbox',
            attributes: {
                error: error.message || String(error),
                stack: error.stack
            }
        });
    }
}

});
parcelRegister("eXfot", function(module, exports) {

$parcel$export(module.exports, "SetBatchedTaskStatusMutation", () => $408d997ca1cff4e4$export$2fe8e9e635ca9d7a);

var $d2LG0 = parcelRequire("d2LG0");
const $408d997ca1cff4e4$export$2fe8e9e635ca9d7a = (0, $d2LG0.default)`mutation SetBatchedTaskStatus($contentId:ID!$tasks:[InlineTask]!$trigger:PageUpdateTrigger=VIEW_PAGE){setBatchedTaskStatus(batchedInlineTasksInput:{contentId:$contentId tasks:$tasks trigger:$trigger}){success}}`;

});




parcelRegister("kdOv6", function(module, exports) {

$parcel$export(module.exports, "createSmartCardEventHandler", () => $5095179f89355d70$export$f996105bf70a5c25);

var $csnse = parcelRequire("csnse");

var $vLw8x = parcelRequire("vLw8x");
const $5095179f89355d70$export$f996105bf70a5c25 = (0, $csnse.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        }
    } : undefined);

});

parcelRegister("h0UOA", function(module, exports) {

$parcel$export(module.exports, "createLinkEventHandler", () => $f3a2ccfb73948f5b$export$68bee16d64211457);

var $csnse = parcelRequire("csnse");

var $6S5EB = parcelRequire("6S5EB");

var $dHSeC = parcelRequire("dHSeC");

var $jibmA = parcelRequire("jibmA");
const $f3a2ccfb73948f5b$export$68bee16d64211457 = (0, $csnse.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        link: {
            onClick (e, url) {
                const isInlineComment = e.target instanceof Element && e.target.matches('[data-mark-annotation-type="inlineComment"]');
                if (isInlineComment) return;
                const spaTransitionHref = (0, $dHSeC.getSpaTransitionHref)(e, routesContext);
                if ((0, $jibmA.isExternalLink)(url)) {
                    e.preventDefault();
                    window.open(url, '_blank', 'noopener, noreferrer');
                } else if (spaTransitionHref && spaTransitionHref === url) {
                    e.preventDefault();
                    routesContext.push(spaTransitionHref, (0, $6S5EB.isExternalShareRequest)());
                }
            }
        }
    } : undefined);

});

parcelRegister("bzqa9", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", () => $abb6860b27595ef6$export$8ce912bc34d0dbea);

var $gwFzn = parcelRequire("gwFzn");

var $1iSzD = parcelRequire("1iSzD");

var $dPJCf = parcelRequire("dPJCf");

var $4qzKl = parcelRequire("4qzKl");

var $icKZN = parcelRequire("icKZN");
const $abb6860b27595ef6$export$8ce912bc34d0dbea = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const handleClick = (0, $gwFzn.useCallback)((event, url)=>{
        if (!event?.isDefaultPrevented()) event?.preventDefault();
        if ((0, $icKZN.isClickEventToOpenNewTab)(event)) window.open(url, '_blank');
        else push(url);
    }, [
        push
    ]);
    return (0, $gwFzn.useMemo)(()=>(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? {
            mention: {
                onClick: async (userId, _, event)=>{
                    event?.preventDefault();
                    event?.stopPropagation();
                    // For Confirmed with PM, we apply the same approach as "mobile-web" to open `/people` link directly.
                    const url = await (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId);
                    handleClick(event, url);
                }
            },
            link: {
                onClick (e, url) {
                    handleClick(e, url);
                }
            },
            smartCard: {
                onClick (e, url) {
                    handleClick(e, url);
                }
            }
        } : undefined, [
        handleClick
    ]);
};

});

parcelRegister("3zar2", function(module, exports) {

let $298cbc2f22c3afa5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $298cbc2f22c3afa5$var$load("1D35j").then(()=>parcelRequire('bDbwM'));

});


parcelRegister("hUS75", function(module, exports) {

$parcel$export(module.exports, "MacroExperienceStop", () => $50ff55d614a641f6$export$d22b49804594ed4d);

var $flE5X = parcelRequire("flE5X");

var $5kjCz = parcelRequire("5kjCz");

var $2bAZx = parcelRequire("2bAZx");
function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $flE5X.containsNoNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}

});

parcelRegister("kXs6I", function(module, exports) {

$parcel$export(module.exports, "ClassicEditorContext", () => $6cfcc4729b372ddf$export$bbe9955f93d6ed27);

var $gwFzn = parcelRequire("gwFzn");
const $6cfcc4729b372ddf$export$bbe9955f93d6ed27 = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});

});

parcelRegister("fuLIO", function(module, exports) {

$parcel$export(module.exports, "LegacyMacroRendererQuery", () => $b65e5cf2eec587a5$export$1609bcb5ce6c9dd9);
$parcel$export(module.exports, "DebouncedLegacyMacroRendererQuery", () => $b65e5cf2eec587a5$export$c0b18e27c7eefe80);

var $4VJDS = parcelRequire("4VJDS");

var $aTqya = parcelRequire("aTqya");

var $atveb = parcelRequire("atveb");

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $4jR19 = parcelRequire("4jR19");

var $eczvQ = parcelRequire("eczvQ");

var $1kHsc = parcelRequire("1kHsc");
var $fGzMp = parcelRequire("fGzMp");

var $6mEZ3 = parcelRequire("6mEZ3");

var $8pcS0 = parcelRequire("8pcS0");

var $kRAnY = parcelRequire("kRAnY");

var $ld6xp = parcelRequire("ld6xp");
var $6Cce7 = parcelRequire("6Cce7");
var $92uc5 = parcelRequire("92uc5");
var $9p5st = parcelRequire("9p5st");
var $iKSlH = parcelRequire("iKSlH");
var $gHCIk = parcelRequire("gHCIk");

var $9wGTI = parcelRequire("9wGTI");

var $hp2SH = parcelRequire("hp2SH");

var $7W8i8 = parcelRequire("7W8i8");

var $5kjCz = parcelRequire("5kjCz");

var $jONcl = parcelRequire("jONcl");

var $bQm3c = parcelRequire("bQm3c");

var $5dK2X = parcelRequire("5dK2X");

var $7Q4pL = parcelRequire("7Q4pL");

var $aEc9Q = parcelRequire("aEc9Q");

var $euF5O = parcelRequire("euF5O");

var $4BMhZ = parcelRequire("4BMhZ");

var $b7V26 = parcelRequire("b7V26");
/**
 * Checks whether an extension node is a plain text macro or not.
 *
 * The node at this point may not indicate what it's content type is, so a
 * reliable way is to check for the `__bodyContent` property, which exists
 * on plain text macros.
 *
 * @param node Extension node to check
 */ const $b65e5cf2eec587a5$var$isPlainTextMacro = (node)=>node.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) && Boolean(node?.parameters?.macroParams?.__bodyContent);
/**
 * All bodied extensions are rich text.
 *
 * @param node Extension node to check
 */ const $b65e5cf2eec587a5$var$isRichTextMacro = (node)=>node.type === (0, $8pcS0.BODIED_EXTENSION_TYPE);
const $b65e5cf2eec587a5$var$convertADFContentToStorageQuery = async (contentId, content)=>{
    const result = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $6Cce7.ContentConverterQuery),
        variables: (0, $92uc5.getContentConverterVariables)({
            content: content,
            contentId: contentId
        })
    });
    return result.data?.contentConverter?.value;
};
class $b65e5cf2eec587a5$export$a7d233751dc2a8c9 extends (0, $gwFzn.Component) {
    getChildContext() {
        const { context: context } = this.props;
        const noop = ()=>{};
        return {
            insertCss: context.insertCss || noop
        };
    }
    componentDidMount() {
        this.setMacroData();
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.contentId !== nextProps.contentId || !(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(this.props?.node?.parameters, nextProps?.node?.parameters) || (nextProps.references || this.props.references) && this.props.references !== nextProps.references || this.state.hasBodyBeenFetched !== nextState.hasBodyBeenFetched || this.state.body !== nextState.body;
    }
    componentDidUpdate() {
        this.setMacroData();
    }
    componentWillUnmount() {
        const { node: node, mode: mode, contentId: contentId } = this.props;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        (0, $5kjCz.stopJIRAMacro)(mode, contentId, name, attributes);
    }
    /**
   * Parses the rich text macro's body and sets the state with it.
   */ async setRichTextMacroBody() {
        const { contentId: contentId, node: node, extensionKey: extensionKey } = this.props;
        // Get the ADF content of the node
        const content = node?.content || [];
        try {
            // Unfortunately, vendor add ons expect storage format. We need to convert
            // the ADF to the appropriate format.
            let body;
            // only use conversion query in two scenarios
            //   1. if not using macros query where body storage format is already provided.
            //   2. If macro is using in editor renderer view, we need to update the body for this singular macro
            //      using the multi macro query would refetch for all macros on the page, re-rendering them all.
            if (!(0, $ld6xp.canUseMultiMacroQuery)(extensionKey, this.isIncludePageNested2pBodiedExtension()) || this.isMacroUsingInEditorRendererView()) body = await $b65e5cf2eec587a5$var$convertADFContentToStorageQuery(contentId, content);
            this.setState({
                body: body,
                hasBodyBeenFetched: true
            });
        } catch (error) {
            this.logger.error`${error}`; //tslint:disable-line
        }
    }
    /**
   * Parses the plain text macro's body and sets the state with it.
   *
   * Even though it's plain text, we don't actually need to set state. This
   * could be done in the renderer, but because we're converting rich text
   * macro's body to storage format, the mechanism for passing in the body is
   * `this.setState`. This will change in the future if we start passing
   * adf in our `getMacroBody` calls (and then this can be cleaned up).
   */ setPlainTextMacroBody() {
        const { node: node } = this.props;
        const body = node?.parameters?.macroParams?.__bodyContent?.value || '';
        this.setState({
            body: body,
            hasBodyBeenFetched: true
        });
    }
    setMacroData() {
        const { node: node } = this.props;
        // 1. Node is null, which means we won't render anything.
        // 2. If macro is using in editor renderer view, we need to refetch the body on update
        //    because the parameters might have changed due to user interaction in the macros edit mode.
        if (!node || $b65e5cf2eec587a5$var$isRichTextMacro(node) && this.state.hasBodyBeenFetched && !this.isMacroUsingInEditorRendererView()) return;
        if ($b65e5cf2eec587a5$var$isPlainTextMacro(node)) this.setPlainTextMacroBody();
        else if ($b65e5cf2eec587a5$var$isRichTextMacro(node)) this.setRichTextMacroBody();
        else // It's neither, so just render the component
        this.setState({
            hasBodyBeenFetched: true
        });
    }
    // Use parent id if the macro source is different than the current page.
    // Critical for having the include-page macro load properly
    getContentId(adf, contentId) {
        const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
        return parentId || contentId;
    }
    render() {
        const mode = window.location.pathname.startsWith('/wiki/pdf/') ? 'pdf' : this.props.mode;
        const { hasBodyBeenFetched: hasBodyBeenFetched } = this.state;
        const node = this.props.node;
        if (!node) return null;
        if (!hasBodyBeenFetched) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
            node: node
        });
        const adf = (0, $6mEZ3.extensionToADF)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $euF5O.LegacyMacroRendererContext).Consumer, null, ({ shouldRefetchMacroQuery: shouldRefetchMacroQuery })=>// In edit mode the editor renders this component outside of the main app, therefore
            // the Apollo client has to be provided here too
            // only use the multi macro query if this macro is not inside another, such as a page include
            // since that means it will not have been fetched by the multi macro query
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.ApolloProvider), {
                client: (0, $hp2SH.getApolloClient)()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
                value: (0, $fGzMp.getExperienceTracker)()
            }, this.determineQuery({
                ...this.props,
                mode: mode,
                adf: adf,
                shouldRefetchMacroQuery: shouldRefetchMacroQuery
            }))));
    }
    constructor(..._args){
        super(..._args);
        this.state = {
            body: '',
            hasBodyBeenFetched: false
        };
        this.logger = (0, $7W8i8.getLogger)('LegacyMacroRendererQuery');
        this.isMacroUsingInEditorRendererView = ()=>{
            const { isInEditorRendererView: isInEditorRendererView, node: node, extensionKey: extensionKey } = this.props;
            return isInEditorRendererView && (0, $kRAnY.is2PBodiedExtension)({
                extensionKey: extensionKey,
                extensionType: node.type
            });
        };
        this.isIncludePageNested2pBodiedExtension = ()=>{
            const { contentId: contentId, node: node, extensionKey: extensionKey } = this.props;
            const hasParent = !!node?.parameters?.macroParams?._parentId?.value;
            const hasSameParent = node?.parameters?.macroParams?._parentId?.value === contentId;
            return (0, $kRAnY.is2PBodiedExtension)({
                extensionKey: extensionKey,
                extensionType: node.type
            }) && hasParent && !!contentId && !hasSameParent && (0, $9wGTI.fg)('confluence_nested_bodied_macros');
        };
        /**
     * Return a query for both contentRenderer and macroBodyRenderer.
     */ this.getQueryForMacroContentAndBodyForPossibleFrontendRendering = ({ adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, context: context, shouldRefetchMacroQuery: shouldRefetchMacroQuery, noOverlay: noOverlay, isPreviewMode: isPreviewMode })=>{
            const renderPageIncludeError = (pageTitle)=>{
                return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                    className: "error"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $7Q4pL.i18n).highlightedPageIncludeRenderedError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                    ...(0, $7Q4pL.i18n).nonhighlightedPageIncludeRenderedError,
                    values: {
                        pageTitle: pageTitle
                    }
                })));
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
                query: (0, $9p5st.MacroBodyRendererQueryWithTags),
                variables: {
                    adf: (0, $gHCIk.serializeExtensionADF)(adf),
                    // The template editor passes a "0" as contentId by default,
                    // in this scenario we do NOT want to pass a contentId at all into the query.
                    // Not passing the correct contentId can make some macros fail to load
                    ...contentId !== '0' ? {
                        contentId: this.getContentId(adf, contentId)
                    } : {},
                    mode: mode && mode.toUpperCase()
                },
                // Used when multiple instances of PageContentRenderer cause conflicting IDs in macroRenderedOutput. This forces
                // a refetch when rendering subsequent PageContentRenderer instances so that a new ID is present in
                // macroRenderedOutput. 'cache-first' is Apollo's default fetchPolicy.
                fetchPolicy: shouldRefetchMacroQuery ? 'no-cache' : 'cache-first',
                // Some macros take a long time to render, they should not hold up the rendering of other things
                context: {
                    throttle: true,
                    allowOnExternalPage: true
                },
                skip: Boolean(macroRenderedOutputFromSSR) || Boolean(macroOutput)
            }, ({ data: data, loading: loading, error: error })=>{
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRenderedOutput: data?.macroBodyRenderer?.value,
                    macroRepresentation: data?.macroBodyRenderer?.representation || 'view',
                    mediaToken: data?.macroBodyRenderer?.mediaToken?.token,
                    node: node,
                    webresource: data?.macroBodyRenderer?.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    context: context,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    showSpinner: !!data,
                    node: node
                });
                if (error || !data || !data.macroBodyRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4BMhZ.LegacyMacroRendererError), {
                    error: error,
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b7V26.PageIncludeContext).Consumer, null, ({ listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes })=>{
                    const { isCircularRef: isCircularRef, prevPageTitle: prevPageTitle } = $b65e5cf2eec587a5$export$ddad0aee336d9e1(listOfRenderedPageIncludeNodes);
                    if (isCircularRef) return renderPageIncludeError(prevPageTitle);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b65e5cf2eec587a5$var$PageIncludeContextProvider, {
                        contentId: contentId,
                        node: this.props.node,
                        listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                        contentId: contentId,
                        experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                        adf: adf,
                        attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                        references: references,
                        multiBodiedExtensionActions: multiBodiedExtensionActions,
                        macroRenderedOutput: data.macroBodyRenderer?.value,
                        macroRepresentation: data.macroBodyRenderer?.representation || 'view',
                        mediaToken: data?.macroBodyRenderer?.mediaToken?.token,
                        node: node,
                        webresource: data.macroBodyRenderer?.webResourceDependencies,
                        mode: mode,
                        body: this.state.body,
                        parameters: (0, $6mEZ3.getParametersString)(node),
                        featureFlags: featureFlags,
                        spaceKey: spaceKey,
                        context: context,
                        noOverlay: noOverlay,
                        isPreviewMode: isPreviewMode
                    }));
                });
            });
        };
        this.getQueryForMacroContentFromBackend = ({ adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, context: context, shouldRefetchMacroQuery: shouldRefetchMacroQuery, noOverlay: noOverlay, isPreviewMode: isPreviewMode })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
                query: (0, $9p5st.MacroContentRendererQueryWithTags),
                variables: {
                    adf: (0, $gHCIk.serializeExtensionADF)(adf),
                    contentId: contentId,
                    mode: mode && mode.toUpperCase()
                },
                // Used when multiple instances of PageContentRenderer cause conflicting IDs in macroRenderedOutput. This forces
                // a refetch when rendering subsequent PageContentRenderer instances so that a new ID is present in
                // macroRenderedOutput. 'cache-first' is Apollo's default fetchPolicy.
                fetchPolicy: shouldRefetchMacroQuery ? 'no-cache' : 'cache-first',
                // Some macros take a long time to render, they should not hold up the rendering of other things
                context: {
                    throttle: true,
                    allowOnExternalPage: true
                },
                skip: Boolean(macroRenderedOutputFromSSR) || Boolean(macroOutput)
            }, ({ data: data, loading: loading, error: error })=>{
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: data?.contentRenderer?.html,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: "view",
                    webresource: data?.contentRenderer?.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    context: context,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    showSpinner: !!data,
                    node: node
                });
                if (error || !data || !data.contentRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4BMhZ.LegacyMacroRendererError), {
                    error: error,
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // assume we have data here
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: data.contentRenderer.html,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: "view",
                    webresource: data.contentRenderer.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    context: context,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode
                });
            });
        };
        this.getQueryForMacros = (args)=>{
            const { adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, context: context, noOverlay: noOverlay } = args;
            const macroId = node.parameters?.macroMetadata?.macroId?.value;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iKSlH.MultiMacroQuerySubscriber), {
                contentId: contentId,
                macroId: macroId
            }, ({ renderedMacro: renderedMacro, loading: loading, error: error, complete: complete })=>{
                // if the multi macro query is complete and there were no errors
                // that means we are inserting a new macro in the editor or have
                // just published the page in which case the new macro data
                // will not be available on the backend to render yet so use
                // the old queries to render instead
                if (complete && !renderedMacro && !error) return this.determineQuery(args, true);
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: renderedMacro?.value,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: renderedMacro?.macroRenderedRepresentation || 'view',
                    webresource: renderedMacro?.webResource,
                    mode: mode,
                    body: renderedMacro?.macroBodyStorage || this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    context: context,
                    noOverlay: noOverlay
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    node: node
                });
                if (error || !renderedMacro) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4BMhZ.LegacyMacroRendererError), {
                    error: new (0, $aTqya.ApolloError)({
                        errorMessage: `error rendering legacy macro: {$extensionKey}`
                    }),
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // assume we have data here
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: renderedMacro?.value,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: renderedMacro?.macroRenderedRepresentation || 'view',
                    webresource: renderedMacro?.webResource,
                    mode: mode,
                    body: renderedMacro?.macroBodyStorage || this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    context: context,
                    noOverlay: noOverlay
                });
            });
        };
        this.getReferencedContentId = (node)=>{
            return node?.parameters?.macroParams?._referencedContentId?.value || undefined;
        };
        this.determineQuery = (props, doNotUseMultiMacro = false)=>{
            const { extensionKey: extensionKey, node: node } = props;
            if (!doNotUseMultiMacro && (!node?.parameters?.macroParams?._parentId || node.parameters.macroParams._parentId.value === this.props.contentId) && (0, $ld6xp.canUseMultiMacroQuery)(extensionKey, this.isIncludePageNested2pBodiedExtension())) return this.getQueryForMacros(props);
            const editorMacroADFRendering = (0, $4VJDS.default).getBoolean('confluence_frontend_macro_adf_frontend_render', true);
            return editorMacroADFRendering ? this.getQueryForMacroContentAndBodyForPossibleFrontendRendering(props) : this.getQueryForMacroContentFromBackend(props);
        };
    }
}
$b65e5cf2eec587a5$export$a7d233751dc2a8c9.childContextTypes = {
    /**
   * Handler for css injection in components.
   */ insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};
const $b65e5cf2eec587a5$export$ddad0aee336d9e1 = (listOfRenderedPageIncludeNodes)=>{
    if (listOfRenderedPageIncludeNodes?.length) {
        // Keep reference so that we can render the previous page title in error message
        let prevRenderedNode;
        const pageIncludeNodeIds = new Set();
        let pageIncludeNodeAlreadyRendered = false;
        for (const pageIncludeNode of listOfRenderedPageIncludeNodes){
            if (pageIncludeNode?.extensionKey !== 'include') continue;
            prevRenderedNode = pageIncludeNode;
            const id = pageIncludeNode?.parameters?.macroMetadata?.macroId?.value;
            if (id) {
                if (pageIncludeNodeIds.has(id)) {
                    pageIncludeNodeAlreadyRendered = true;
                    break;
                } else pageIncludeNodeIds.add(id);
            }
        }
        // indicate that this page has already been included, to avoid infinite loop
        if (pageIncludeNodeAlreadyRendered) {
            const prevReferencedNodePageTitle = prevRenderedNode?.parameters?.macroParams?.['']?.value;
            return {
                isCircularRef: true,
                prevPageTitle: prevReferencedNodePageTitle
            };
        }
    }
    return {
        isCircularRef: false,
        prevPageTitle: null
    };
};
const $b65e5cf2eec587a5$var$PageIncludeContextProvider = ({ contentId: contentId, node: node, listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes, children: children })=>{
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        const renderedPageIncludeNodes = [
            ...listOfRenderedPageIncludeNodes,
            {
                ...node,
                parentContentId: contentId
            }
        ];
        return {
            listOfRenderedPageIncludeNodes: renderedPageIncludeNodes
        };
    }, [
        listOfRenderedPageIncludeNodes,
        node,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b7V26.PageIncludeContext).Provider, {
        value: contextValue
    }, children);
};
const $b65e5cf2eec587a5$export$1609bcb5ce6c9dd9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>{
    const { featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b65e5cf2eec587a5$export$a7d233751dc2a8c9, {
        featureFlags: featureFlags,
        ...props
    });
}, (prevProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(prevProps, nextProps));
const $b65e5cf2eec587a5$export$c0b18e27c7eefe80 = (0, $jONcl.debounceRender)($b65e5cf2eec587a5$export$1609bcb5ce6c9dd9, 10000);

});
parcelRegister("eczvQ", function(module, exports) {

$parcel$export(module.exports, "LegacyMacroRendererShadow", () => $f3207d6ccf725790$export$ba91725a812e7aea);
/* LegacyMacroRendererShadow.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $9hlns = parcelRequire("9hlns");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3207d6ccf725790$var$InlineSkeleton = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko14y2 _1yt41b66 _1e0c1o8l _bfhkn82g _1ul912am _4t3ildb6",
            __cmplp.className
        ])
    });
});
const $f3207d6ccf725790$var$ExtensionSkeleton = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko14y2 _1yt41b66 _1e0c1ule _bfhkn82g _1bsb1osq _1ul91wqb _4t3ildb6 _vchhusvi",
            __cmplp.className
        ])
    });
});
const $f3207d6ccf725790$export$ba91725a812e7aea = ({ showSpinner: showSpinner, node: node })=>{
    return node && node.type === 'inlineExtension' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f3207d6ccf725790$var$InlineSkeleton, {
        "data-testid": "ext-skeleton"
    }, showSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "small"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f3207d6ccf725790$var$ExtensionSkeleton, {
        "data-testid": "ext-skeleton"
    }, showSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "small"
    }));
};

});

parcelRegister("kRAnY", function(module, exports) {

$parcel$export(module.exports, "is2PBodiedExtension", () => $ecf08ec6a3fe0bb1$export$99128e639bf2cee5);
$parcel$export(module.exports, "useExtensionRendererViewOptions", () => $ecf08ec6a3fe0bb1$export$8166325a9a095a58);

var $gwFzn = parcelRequire("gwFzn");

var $j0gZR = parcelRequire("j0gZR");
const $ecf08ec6a3fe0bb1$export$3edb28f707c97620 = ({ extensionKey: extensionKey, extensionType: extensionType })=>(0, $j0gZR.is1PMacro)(extensionKey || '') && extensionType === 'bodiedExtension';
const $ecf08ec6a3fe0bb1$export$99128e639bf2cee5 = ({ extensionKey: extensionKey, extensionType: extensionType })=>!(0, $j0gZR.is1PMacro)(extensionKey || '') && extensionType === 'bodiedExtension';
const $ecf08ec6a3fe0bb1$export$8166325a9a095a58 = ({ getExtensionHandlers: getExtensionHandlers, isLivePage: isLivePage, contentId: contentId, spaceKey: spaceKey })=>{
    return (0, $gwFzn.useMemo)(()=>{
        if (isLivePage) return {
            rendererExtensionHandlers: getExtensionHandlers?.({
                contentId: contentId,
                spaceKey: spaceKey,
                isInEditorRendererView: true
            }),
            isAllowedToUseRendererView: (node)=>$ecf08ec6a3fe0bb1$export$99128e639bf2cee5({
                    extensionKey: node.attrs?.extensionKey,
                    extensionType: node.type
                }),
            showUpdated1PBodiedExtensionUI: (node)=>$ecf08ec6a3fe0bb1$export$3edb28f707c97620({
                    extensionKey: node.attrs?.extensionKey,
                    extensionType: node.type
                })
        };
        return undefined;
    }, [
        getExtensionHandlers,
        isLivePage,
        contentId,
        spaceKey
    ]);
};

});
parcelRegister("j0gZR", function(module, exports) {

$parcel$export(module.exports, "is1PMacro", () => $fa4d787503d7b919$export$1bf1a639d38d3f44);
const $fa4d787503d7b919$export$1bf1a639d38d3f44 = (macro)=>$fa4d787503d7b919$export$4b1d56e1a5f9d339.has(macro);
const $fa4d787503d7b919$export$4b1d56e1a5f9d339 = new Set([
    'toc',
    'children',
    'livesearch',
    'recently-updated',
    'details',
    'jlol',
    'jira',
    'pagetree',
    'anchor',
    'contentbylabel',
    'create-from-template',
    'roadmap',
    'blog-posts',
    'excerpt',
    'attachments',
    'profile',
    'include',
    'content-report-table',
    'detailssummary',
    'tasks-report-macro',
    'excerpt-include',
    'iframe',
    'listlabels',
    'profile-picture',
    'change-history',
    'pagetreesearch',
    'widget',
    'decisionreport',
    'viewpdf',
    'contributors',
    'gadget',
    'popular-labels',
    'jirachart',
    'toc-zone',
    'portfolioforjiraplan',
    'viewppt',
    'viewxls',
    'recently-updated-dashboard',
    'spaces',
    'index',
    'contributors-summary',
    'userlister',
    'gallery',
    'viewdoc',
    'chart',
    'related-labels',
    'jiraroadmap'
]);

});


parcelRegister("iKSlH", function(module, exports) {

$parcel$export(module.exports, "MultiMacroQueryContainer", () => $45c36e8dcd65ba05$export$ad5695738c93511d);
$parcel$export(module.exports, "useMultiMacroQuery", () => $45c36e8dcd65ba05$export$f830af87140a4bfc);
$parcel$export(module.exports, "MultiMacroQuerySubscriber", () => $45c36e8dcd65ba05$export$9c7903e1ca090053);

var $2S0Fz = parcelRequire("2S0Fz");
var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
var $bd25s = parcelRequire("bd25s");

var $hp2SH = parcelRequire("hp2SH");

var $5ZqQS = parcelRequire("5ZqQS");

var $9wGTI = parcelRequire("9wGTI");

var $g1f2M = parcelRequire("g1f2M");

var $ld6xp = parcelRequire("ld6xp");
const $45c36e8dcd65ba05$var$DEFAULT_PRELOAD_PAGE_SIZE = 8;
const $45c36e8dcd65ba05$var$DEFAULT_PAGE_SIZE = 10;
const $45c36e8dcd65ba05$var$actions = {
    queryMacros: ({ contentId: contentId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, revision: revision, useServerRenderedData: useServerRenderedData = false })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            // avoid querying if already in progress
            if (getState().contentId === contentId && getState().revision === revision && getState().cursor === cursor) return;
            setState({
                contentId: contentId,
                revision: revision,
                cursor: cursor,
                complete: false
            });
            let mode = contentRendererMode.toUpperCase();
            mode = window.location.pathname.startsWith('/wiki/pdf/') ? 'PDF' : mode;
            const queryOptions = {
                query: (0, $g1f2M.MacrosQuery),
                variables: {
                    contentId: contentId,
                    mode: mode,
                    blocklist: (0, $ld6xp.getMultiMacroQueryBlocklistFF)(),
                    first: !cursor ? $45c36e8dcd65ba05$var$DEFAULT_PRELOAD_PAGE_SIZE : $45c36e8dcd65ba05$var$DEFAULT_PAGE_SIZE,
                    after: cursor
                },
                context: {
                    allowOnExternalPage: true
                }
            };
            // don't include revision if in SSR otherwise it will cause a cache miss between
            // SSR preload where revision is unknown and SSR render when this action is called
            if (!(0, $9wGTI.fg)('confluence_frontend_multi_macro_hydration_fix') || !useServerRenderedData && (0, $9wGTI.fg)('confluence_frontend_multi_macro_hydration_fix')) queryOptions.variables.refetchToken = revision;
            let data;
            {
                const shouldUseServerRenderedData = useServerRenderedData && !getState().cursor && (0, $9wGTI.fg)('confluence_frontend_multi_macro_hydration_fix');
                if (shouldUseServerRenderedData) try {
                    data = (0, $hp2SH.getApolloClient)().readQuery(queryOptions);
                } catch (e) {
                    //do not report error when query returns empty result in SSR
                    if (e?.message && !e?.message.includes('Invariant Violation: 8')) (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                        attribution: 'backbone'
                    });
                }
                if (!data || !data?.macros || !shouldUseServerRenderedData) {
                    const result = await (0, $hp2SH.getApolloClient)().query(queryOptions);
                    if (result.errors) {
                        (0, $5ZqQS.getMonitoringClient)().submitError(result.errors, {
                            attribution: 'backbone'
                        });
                        setState({
                            error: true
                        });
                    }
                    data = result.data;
                }
            }
            const { nodes: nodes = [], pageInfo: pageInfo = {} } = data?.macros;
            const macros = nodes?.reduce((nodeMap, node)=>{
                if (node) {
                    const key = $45c36e8dcd65ba05$var$getMacrosCacheKey(node.contentId || '', node.macroId || '');
                    nodeMap[key] = node?.renderedMacro;
                }
                return nodeMap;
            }, {});
            setState({
                macroData: {
                    ...getState().macroData,
                    ...macros
                }
            });
            if (pageInfo.hasNextPage) dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: pageInfo.endCursor,
                revision: revision
            }));
            else setState({
                complete: true
            });
        },
    //only for testing
    resetState: ()=>({ setState: setState })=>{
            setState({
                complete: false,
                data: {},
                macroData: {},
                error: false,
                contentId: undefined,
                revision: undefined,
                cursor: undefined
            });
        }
};
const $45c36e8dcd65ba05$var$store = (0, $4ZoIm.createStore)({
    initialState: {
        complete: false,
        data: {},
        macroData: {}
    },
    actions: $45c36e8dcd65ba05$var$actions,
    name: 'MultiMacroQueryStore'
});
const $45c36e8dcd65ba05$export$ad5695738c93511d = (0, $2S0Fz.createContainer)($45c36e8dcd65ba05$var$store, {
    onInit: ()=>({ dispatch: dispatch }, { contentId: contentId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, revision: revision, useServerRenderedData: useServerRenderedData })=>{
            dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: cursor,
                revision: revision,
                useServerRenderedData: useServerRenderedData
            }));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { contentId: contentId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, revision: revision, useServerRenderedData: useServerRenderedData })=>{
            dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: cursor,
                revision: revision,
                useServerRenderedData: useServerRenderedData
            }));
        }
});
function $45c36e8dcd65ba05$var$getMacrosCacheKey(contentId, macroId) {
    return `${contentId}::${macroId ?? 0}`;
}
function $45c36e8dcd65ba05$var$multiMacroQuerySelector(state, params) {
    const key = $45c36e8dcd65ba05$var$getMacrosCacheKey(params.contentId, params.macroId);
    const macroData = state.macroData?.[key];
    return {
        loading: !Boolean(macroData) && !state.complete,
        error: !Boolean(macroData) && state.error,
        renderedMacro: macroData || null,
        complete: state.complete
    };
}
const $45c36e8dcd65ba05$export$f830af87140a4bfc = (0, $iFWZA.createStateHook)($45c36e8dcd65ba05$var$store, {
    selector: $45c36e8dcd65ba05$var$multiMacroQuerySelector
});
const $45c36e8dcd65ba05$export$9c7903e1ca090053 = (0, $bd25s.createSubscriber)($45c36e8dcd65ba05$var$store, {
    selector: $45c36e8dcd65ba05$var$multiMacroQuerySelector
});
const $45c36e8dcd65ba05$export$6e231e75b8fd307c = (0, $iFWZA.createHook)($45c36e8dcd65ba05$var$store);

});

parcelRegister("jONcl", function(module, exports) {

$parcel$export(module.exports, "debounceRender", () => $3dbf040db5bfac2c$export$437fb41b7a687949);
// Code taken from https://github.com/podefr/react-debounce-render/tree/master aka react-debounce-render package
// In order to prevent a new package from being added to the AFM project, the code was copied and pasted here since it is lightweight.

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $TPNsL = parcelRequire("TPNsL");
const $3dbf040db5bfac2c$export$437fb41b7a687949 = (ComponentToDebounce, wait, debounceArgs)=>{
    class DebouncedContainer extends (0, $gwFzn.Component) {
        shouldComponentUpdate() {
            this.updateDebounced();
            return false;
        }
        componentWillUnmount() {
            this.updateDebounced.cancel();
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ComponentToDebounce, this.props);
        }
        constructor(...args){
            super(...args);
            // eslint-disable-next-line react/sort-comp
            this.updateDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(this.forceUpdate, wait, debounceArgs);
        }
    }
    DebouncedContainer.displayName = `debounceRender(${ComponentToDebounce.displayName || ComponentToDebounce.name || 'Component'})`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($TPNsL)))(DebouncedContainer, ComponentToDebounce);
};

});

parcelRegister("7Q4pL", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $71fb7e5ab8464496$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $71fb7e5ab8464496$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    highlightedPageIncludeRenderedError: {
        id: "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.highlightedPageIncludeError",
        defaultMessage: "Unable to render { include }"
    },
    nonhighlightedPageIncludeRenderedError: {
        id: "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.nonhighlightedPageIncludeRenderedError",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Already included page ''{pageTitle}'', stopping."
    }
});

});

parcelRegister("aEc9Q", function(module, exports) {

$parcel$export(module.exports, "LegacyMacroRendererComponent", () => $34a09ee48ab537fd$export$b43db7dd8b06a124);
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");
parcelRequire("dx8CK");
var $lEgye = parcelRequire("lEgye");

var $fwDOR = parcelRequire("fwDOR");

var $cpjd2 = parcelRequire("cpjd2");

var $brpfO = parcelRequire("brpfO");
parcelRequire("jUZqZ");
var $hEeUR = parcelRequire("hEeUR");

var $989nU = parcelRequire("989nU");
var $iaRmR = parcelRequire("iaRmR");
var $KcDWk = parcelRequire("KcDWk");

var $6AplS = parcelRequire("6AplS");

var $hMRhJ = parcelRequire("hMRhJ");

var $5LTS4 = parcelRequire("5LTS4");

var $hHZWk = parcelRequire("hHZWk");

var $7W8i8 = parcelRequire("7W8i8");

var $5kjCz = parcelRequire("5kjCz");
var $bX5uj = parcelRequire("bX5uj");

var $8eAX8 = parcelRequire("8eAX8");

var $fgbpl = parcelRequire("fgbpl");

var $8pcS0 = parcelRequire("8pcS0");

var $3Btfb = parcelRequire("3Btfb");

var $kXs6I = parcelRequire("kXs6I");

var $8cOoD = parcelRequire("8cOoD");

var $iQhLj = parcelRequire("iQhLj");
var $jShOo = parcelRequire("jShOo");

var $9L50P = parcelRequire("9L50P");

var $4BMhZ = parcelRequire("4BMhZ");

var $aQw7y = parcelRequire("aQw7y");

var $brT00 = parcelRequire("brT00");
// The rendered HTML currently outputs a div that contains a macro id attribute
// `data-macro-id="XYZ"`. We can parse that and get the ID
const $34a09ee48ab537fd$var$idFromStorageFormat = /data-macro-id="([0-9a-fA-F\-]+?)"/;
// this will be fallback pattern in case div does not contain the macro id attribute.
// Parse in from data variable in the script tag.Pattern looks like `\\\"macro.id\\\":\\\"XYZ\\\"`
const $34a09ee48ab537fd$var$idFromADF = /macro\.id\\":\\"([0-9a-fA-F\-]+?)\\"/;
const $34a09ee48ab537fd$var$logger = (0, $7W8i8.getLogger)('LegacyMacroRenderer');
const $34a09ee48ab537fd$var$Overlay = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "legacy-macro-overlay",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            bottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            cursor: 'default',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            zIndex: 2
        }
    });
/**
 * CEMS-919 and HOT-84603
 * ---------
 * Current implementation of the Team Calendars Plugin does not account for
 * a SPA transition. It only loads the calendars once and forgets about
 * re-initializing them once the page is unmounted. For this, we need to
 * invoke the assets when necessary and initialize the calendars. Also reference:
 * confluence-frontend-server/src/components/ContentBody/ContentBodyDefaultComponent.js
 * @private
 */ const $34a09ee48ab537fd$var$initializeCalendarIfNeeded = async (extensionKey)=>{
    if (extensionKey === 'calendar') (0, $cpjd2.requireLegacyWRM)((0, $8eAX8.teamCalendarWRM)(), ()=>{
        try {
            window.require('tc/init-resources').requireResources();
        } catch (err) {
            $34a09ee48ab537fd$var$logger.error(err);
        }
    }, ()=>{
        $34a09ee48ab537fd$var$logger.error`Error loading team calendar WRM!`;
    });
};
const $34a09ee48ab537fd$var$getMacroId = (adf, macroRenderedOutput)=>{
    const idFromNode = adf?.attrs?.parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    let matches = $34a09ee48ab537fd$var$idFromStorageFormat.exec(macroRenderedOutput || '');
    if (matches?.[1]) return matches[1];
    matches = $34a09ee48ab537fd$var$idFromADF.exec(macroRenderedOutput || '');
    if (matches?.[1]) return matches[1];
    $34a09ee48ab537fd$var$logger.error`Cannot find macro id from ${macroRenderedOutput}`;
    return '';
};
const $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM = [
    'include',
    'contentbylabel',
    'children',
    'content-report-table',
    'index',
    'pagetree',
    'tasks-report-macro',
    'recently-updated-dashboard',
    'recently-updated',
    'toc'
];
const $34a09ee48ab537fd$export$a5c44bbb70ae7ae6 = (0, $3Btfb.withNavigationPolicy)(({ adf: adf, macroRepresentation: macroRepresentation, macroRenderedOutput: macroRenderedOutput, mode: mode, node: node, contentId: contentId, attributes: attributes, experienceName: experienceName, featureFlags: featureFlags, webresource: webresource, body: body, parameters: parameters, navigationPolicy: navigationPolicy, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, context: context, spaceKey: spaceKey, providers: providers, mediaToken: mediaToken, noOverlay: noOverlay, isWithinEditor: isWithinEditor, isPreviewMode: isPreviewMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isInline = adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE);
    const isMultiBodied = adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE);
    const extensionKey = adf?.attrs?.extensionKey || '';
    const scriptContainer = (0, $gwFzn.useRef)(null);
    if (!macroRenderedOutput) macroRenderedOutput = '';
    if (extensionKey && macroRenderedOutput) {
        // If a Tiny page with Style Macro gets converted to Fabric, need to Scope the CSS
        // When in edit mode, the <style> tag don't have data-macro-name="style" attribute, so need to pass a different regex
        if (extensionKey === 'style') macroRenderedOutput = (0, $6AplS.scopeCSS)(macroRenderedOutput, (0, $6AplS.mainContentSelector), /(<style[^>]*>)((.|\n|\r)*?)(<\/style>)/gm).contentWithScopedCSS;
        else // Other extensionKeys could have nested Style Macro
        macroRenderedOutput = (0, $6AplS.scopeCSS)(macroRenderedOutput, (0, $6AplS.mainContentSelector)).contentWithScopedCSS;
    }
    const shouldHideOverlay = (0, $aQw7y.useShouldHideOverlay)(extensionKey, (0, $fgbpl.isBodiedExtension)(adf.type));
    /**
   * Callback to be triggered when web resources are resolved.
   * This is to make sure certain macros e.g. Gadget Macro only to render output after web resources loaded.
   * For more context of the issue: https://hello.atlassian.net/wiki/spaces/~462393321/pages/1007234825/Debugging+Legacy+Jira+gadgets+within+Connie
   * https://jira.atlassian.com/browse/CONFCLOUD-70573
   */ const [delayedOutput, setDelayedOutput] = (0, $gwFzn.useState)(extensionKey === 'gadget' ? '' : macroRenderedOutput);
    const [container, setContainer] = (0, $gwFzn.useState)(null);
    const [isMacroResourcesLoaded, setIsMacroResourcesLoaded] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (container) {
            const loadMacroResources = async ()=>{
                const isDPModuleDefined = (0, $8cOoD.checkIsDPModuleDefined)();
                if (!isDPModuleDefined) {
                    const isViewPage = mode === (0, $5kjCz.RENDERER);
                    await (0, $8cOoD.loadDataProviderModule)({
                        logger: $34a09ee48ab537fd$var$logger,
                        isViewPage: isViewPage,
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                }
                if (isMultiBodied) await (0, $iQhLj.defineMacroModule)({
                    logger: $34a09ee48ab537fd$var$logger
                });
                await (0, $8eAX8.loadMacroWebResources)(webresource, macroRenderedOutputFromSSR, macroOutput, ()=>{
                    if (delayedOutput !== macroRenderedOutput) setDelayedOutput(macroRenderedOutput);
                }, scriptContainer?.current);
                setIsMacroResourcesLoaded(true);
            };
            loadMacroResources();
            (0, $brpfO.evalLegacyConnectInlineScripts)(container);
            $34a09ee48ab537fd$var$initializeCalendarIfNeeded(extensionKey);
        }
    }, [
        webresource,
        extensionKey,
        macroRenderedOutput,
        delayedOutput,
        container,
        scriptContainer,
        macroRenderedOutputFromSSR,
        macroOutput,
        mode,
        createAnalyticsEvent,
        isMultiBodied
    ]);
    (0, $brT00.useLinkIntercept)(extensionKey ?? '', container, mode === (0, $5kjCz.EDITOR) || isWithinEditor);
    const macroId = $34a09ee48ab537fd$var$getMacroId(adf, macroRenderedOutput);
    const { ssredElement: ssredElement } = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    const nodeProps = {
        ref: setContainer
    };
    const macroDataProps = {
        'data-fabric-macro': macroId,
        'data-macro-body': body || '',
        'data-macro-parameters': parameters || '',
        'data-node-type': extensionKey === 'include' ? 'include' : undefined
    };
    // Use parent id if the macro source is different than the current page
    const getContentId = (adf, contentId)=>{
        const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
        return parentId || contentId;
    };
    const { getExtensionHandlers: getExtensionHandlers } = providers;
    const extensionHandlers = getExtensionHandlers ? getExtensionHandlers({
        adf: macroRepresentation == 'atlas_doc_format' ? macroRenderedOutputFromSSR || macroOutput || macroRenderedOutput : adf,
        contentId: getContentId(adf, contentId),
        spaceKey: spaceKey,
        macroRenderedOutput: macroRenderedOutputFromSSR || macroOutput || macroRenderedOutput,
        shouldIncludeMacroWithReferencesHandlers: true,
        referentialityDataSourceProvider: new (0, $lEgye.DataSourceProvider)(),
        mediaToken: mediaToken
    }) : {};
    const elementProps = {
        adf: adf,
        isInline: isInline,
        contentId: getContentId(adf, contentId),
        mode: mode,
        extensionKey: extensionKey,
        nodeProps: nodeProps,
        macroRepresentation: macroRepresentation,
        macroDataProps: macroDataProps,
        macroRenderedOutput: delayedOutput,
        extensionHandlers: extensionHandlers,
        mediaToken: mediaToken,
        ssredElement: ssredElement,
        delayIframe: false
    };
    if (mode === (0, $5kjCz.RENDERER) || mode === (0, $5kjCz.PDF)) {
        try {
            const macroId = attributes?.macroId ? attributes.macroId : '';
            const type = attributes?.type ? attributes.type : 'none';
            // on view page it will send macro load event
            // it will help to alert in case of multiple rendering of macro
            // event name: macro renderer (client)
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'renderer',
                    actionSubject: 'macro',
                    source: 'legacyMacroRenderer',
                    attributes: {
                        mode: mode,
                        extensionKey: extensionKey,
                        macroId: macroId,
                        contentId: contentId,
                        type: type
                    }
                }
            }).fire();
        } catch (err) {
            $34a09ee48ab537fd$var$logger.error`An error occurred while firing the analytics event for legacyMacroRendererComponent: ${err}`;
        }
        /**
     * https://product-fabric.atlassian.net/browse/CCP-1798
     * If macroRenderedOutputFromSSR or macroOuput are passed as a prop, they will be used for SPA rehydration (rather
     * than the MacroContentQuery). macroRenderedOutputFromSSR / macroOutput already have JS/CSS coming from ContentUnifiedQuery,
     * so here we use the base components of LegacyMacroRendererComponent, but instead
     * render FabricLegacyMacrosServerRenderer, which sets JS/CSS internally.
     * https://product-fabric.atlassian.net/browse/DLRN-3182
     * If macroOutput exists, it contains the full html (as a string) required to render the macro.
     */ if (macroRenderedOutputFromSSR || macroOutput) {
            const macroDefaultProps = {
                node: node,
                context: context,
                references: references,
                contentId: contentId,
                spaceKey: spaceKey || '',
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
                name: "LegacyMacroRendererComponentResourcesSSR",
                hold: !isMacroResourcesLoaded
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9L50P.LegacyMacroReferenceListener), {
                references: references,
                macroContainer: container
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
                extensionKey: attributes?.extensionKey || extensionKey,
                contentId: contentId,
                node: node
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $989nU.FabricLegacyMacrosServerRenderer), {
                macroRenderedOutput: macroRenderedOutputFromSSR,
                macroDefaultProps: macroDefaultProps,
                containerRef: setContainer,
                macroOutput: macroOutput
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hHZWk.LegacyUserElementsHover), {
                node: container
            }), // WS-3295 - DO NOT REMOVE THIS LOADER
            // We need to load the legacy editor here to allow users to create/edit/view comments with the attachments macro
            extensionKey === 'attachments' && !isPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hMRhJ.RendererExtensionContext).Consumer, null, ({ EditorLoaderLoader: EditorLoaderLoader })=>{
                // isWithinEditor will be true if the attachments macro is within a macro
                // that itself is being rendered in the editor, e.g., excerpt-include.
                return !isWithinEditor && !isPreviewMode && EditorLoaderLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(EditorLoaderLoader, null);
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bX5uj.MacroExperienceSuccess), {
                name: experienceName,
                contentId: contentId,
                extensionKey: extensionKey,
                mode: mode,
                attributes: attributes
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
            name: "LegacyMacroRendererComponentResourcesNonSSR",
            hold: !isMacroResourcesLoaded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9L50P.LegacyMacroReferenceListener), {
            references: references,
            macroContainer: container
        }), isMultiBodied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jShOo.MultiBodiedExtensionHandler), {
            macroId: macroId,
            macroParams: parameters,
            editorActions: multiBodiedExtensionActions,
            readonly: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: `${webresource?.tags?.css || ''}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                display: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
            extensionKey: attributes?.extensionKey || extensionKey,
            contentId: contentId,
            node: node
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
            ...elementProps,
            macroRenderedOutput: $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM.includes(extensionKey) ? navigationPolicy.shimHtmlUrls(delayedOutput) : delayedOutput
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hHZWk.LegacyUserElementsHover), {
            node: container
        }), // WS-3295 - DO NOT REMOVE THIS LOADER
        // We need to load the legacy editor here to allow users to create/edit/view comments with the attachments macro
        extensionKey === 'attachments' && !isPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hMRhJ.RendererExtensionContext).Consumer, null, ({ EditorLoaderLoader: EditorLoaderLoader })=>{
            // isWithinEditor will be true if the attachments macro is within a macro
            // that itself is being rendered in the editor, e.g., excerpt-include.
            return !isWithinEditor && EditorLoaderLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(EditorLoaderLoader, null);
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            key: "js-container",
            ref: scriptContainer,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                display: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes
        }));
    }
    let parsedDelayedOutput;
    let parseError;
    let component;
    try {
        if (macroRepresentation === 'atlas_doc_format') {
            parsedDelayedOutput = JSON.parse(delayedOutput);
            component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hEeUR.ADFRenderer), {
                document: parsedDelayedOutput,
                contentId: getContentId(adf, contentId),
                featureFlags: featureFlags ?? {},
                extensionHandlers: extensionHandlers,
                mediaToken: mediaToken,
                appearance: "full-width"
            });
        }
    } catch (e) {
        parseError = e;
        $34a09ee48ab537fd$var$logger.error`An error occurred while parsing adf output: ${delayedOutput}`;
        component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4BMhZ.LegacyMacroRendererError), {
            error: parseError,
            node: node,
            mode: mode,
            extensionKey: extensionKey,
            contentId: contentId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "LegacyMacroRendererComponentResourcesFabric",
        hold: !isMacroResourcesLoaded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: `${webresource?.tags?.css || ''}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }), isMultiBodied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jShOo.MultiBodiedExtensionHandler), {
        macroId: macroId,
        macroParams: parameters,
        editorActions: multiBodiedExtensionActions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iaRmR.LegacyMacroStyledElement), elementProps, noOverlay || shouldHideOverlay || isMultiBodied ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($34a09ee48ab537fd$var$Overlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9L50P.LegacyMacroReferenceListener), {
        references: references,
        macroContainer: container
    }), macroRepresentation === 'atlas_doc_format' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "macro-adf-renderer",
        ref: setContainer
    }, component) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: setContainer,
        dangerouslySetInnerHTML: {
            __html: `${delayedOutput}`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        key: "js-container",
        ref: scriptContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }));
});
const $34a09ee48ab537fd$export$b43db7dd8b06a124 = (props)=>{
    const rendererExtensionProviders = (0, $gwFzn.useContext)((0, $hMRhJ.RendererExtensionContext));
    const classicEditorExtensionProviders = (0, $gwFzn.useContext)((0, $kXs6I.ClassicEditorContext));
    const isWithinEditor = classicEditorExtensionProviders?.isWithinEditor ?? false;
    const providers = {
        ...classicEditorExtensionProviders,
        ...rendererExtensionProviders
    };
    const propsWithProviders = {
        ...props,
        providers: providers,
        isWithinEditor: isWithinEditor
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($34a09ee48ab537fd$export$a5c44bbb70ae7ae6, propsWithProviders);
};

});
parcelRegister("dx8CK", function(module, exports) {

$parcel$export(module.exports, "referentialityPlugin", () => (parcelRequire("1bl0g")).referentialityPlugin);
$parcel$export(module.exports, "createReferentiality", () => (parcelRequire("1bl0g")).createReferentiality);
$parcel$export(module.exports, "dataSourceResolver", () => (parcelRequire("4xvYZ")).dataSourceResolver);
$parcel$export(module.exports, "DataSourceProvider", () => (parcelRequire("lEgye")).DataSourceProvider);
$parcel$export(module.exports, "useReference", () => (parcelRequire("eVKuj")).useReference);
$parcel$export(module.exports, "ADFReferenceTypes", () => (parcelRequire("gcCrc")).ADFReferenceTypes);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $1bl0g = parcelRequire("1bl0g");

var $4xvYZ = parcelRequire("4xvYZ");

var $lEgye = parcelRequire("lEgye");

var $eVKuj = parcelRequire("eVKuj");

var $gcCrc = parcelRequire("gcCrc");

var $9oPnF = parcelRequire("9oPnF");

});
parcelRegister("1bl0g", function(module, exports) {

$parcel$export(module.exports, "referentialityPlugin", () => $6e4cd1d435523f2b$export$9d03c288c4007750);
$parcel$export(module.exports, "createReferentiality", () => $6e4cd1d435523f2b$export$7e7e0965a9844ba0);

var $1S4f7 = parcelRequire("1S4f7");

var $4tb0i = parcelRequire("4tb0i");

var $lEgye = parcelRequire("lEgye");

var $cVzsl = parcelRequire("cVzsl");

var $dh538 = parcelRequire("dh538");

var $2pjJ5 = parcelRequire("2pjJ5");

var $160re = parcelRequire("160re");

var $gcCrc = parcelRequire("gcCrc");

var $jOOx4 = parcelRequire("jOOx4");

var $gWR1e = parcelRequire("gWR1e");

var $h9yJL = parcelRequire("h9yJL");

var $csnse = parcelRequire("csnse");

var $9ge67 = parcelRequire("9ge67");

var $87lhs = parcelRequire("87lhs");
const $6e4cd1d435523f2b$var$EmitterEvents = {
    TABLE_DELETED: 'TABLE_DELETED'
};
const $6e4cd1d435523f2b$export$35dc45686fc2dbd7 = (node)=>{
    try {
        node.check();
        return true;
    } catch (err) {
        return false;
    }
};
const $6e4cd1d435523f2b$var$allowedSource = (node, schema)=>{
    const nodeName = typeof node.type === 'string' ? node.type : node.type.name;
    return [
        schema.nodes.table?.name
    ].includes(nodeName) && node.attrs?.localId;
};
const $6e4cd1d435523f2b$var$transformer = new (0, $h9yJL.JSONTransformer)();
const $6e4cd1d435523f2b$var$memoizedEncodeNode = (0, $csnse.default)((node)=>$6e4cd1d435523f2b$var$transformer.encodeNode(node));
function $6e4cd1d435523f2b$var$createPlugin(providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, externalObservers, options = {}, pluginInjectionApi, api, featureFlags, __livePage, __rendererExtensionOptions) {
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: !!featureFlags?.[0, $87lhs.MACRO_INTERACTION_DESIGN_UPDATES]
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $4tb0i.pluginKey),
        state: {
            init () {
                const dataSourceProvider = new (0, $lEgye.DataSourceProvider)();
                const nodeMutationObserver = new (0, $cVzsl.NodeMutationObserver)(dataSourceProvider);
                externalObservers.forEach((externalObserver)=>externalObserver.init({
                        emit: (localId, data)=>dataSourceProvider.createOrUpdate(localId, data)
                    }));
                return {
                    dataSourceProvider: dataSourceProvider,
                    nodeMutationObserver: nodeMutationObserver,
                    changedSources: new Map(),
                    selectedNodeLocalId: undefined
                };
            },
            apply (tr, pluginState, state, ns) {
                let selectedNodeLocalId = pluginState.selectedNodeLocalId;
                if (!!api && !state.selection.eq(ns.selection)) {
                    const supportedNodeTypes = (0, $9ge67.getNodeTypesSupported)(state.schema);
                    const { fragment: fragment } = state.schema.marks;
                    const selectedNode = (0, $gWR1e.findSelectedNodeOfType)(supportedNodeTypes)(tr.selection) || (0, $gWR1e.findParentNodeOfType)(supportedNodeTypes)(tr.selection);
                    selectedNodeLocalId = selectedNode?.node && (fragment?.isInSet(selectedNode?.node.marks)?.attrs.localId || selectedNode?.node.attrs.localId);
                }
                const selectedLocalIdChanged = selectedNodeLocalId !== pluginState.selectedNodeLocalId;
                if (!tr.docChanged) return selectedLocalIdChanged ? {
                    ...pluginState,
                    selectedNodeLocalId: selectedNodeLocalId
                } : pluginState;
                const changedSources = new Map();
                for (const [pos, node] of pluginState.changedSources.entries()){
                    const newPos = tr.mapping.map(pos);
                    changedSources.set(newPos, node);
                }
                // Handle added/updated table node
                const changedNodes = (0, $2pjJ5.getChangedNodes)(tr).filter(({ node: node })=>{
                    // Since we are calling node validation with every interaction in useDispatchTransaction, we can safely drop the check node here to improve performance.
                    // More details: https://hello.atlassian.net/wiki/spaces/~70121ba36f99acdb4453d8f80fd8186963f3e/pages/5081212079/Optimising+typing+latency#Bonus
                    if ((0, $dh538.fg)('cc_complexit_fe_skip_node_check_in_referentiality')) return tr.getMeta('uiEvent') !== 'cut' && $6e4cd1d435523f2b$var$allowedSource(node, state.schema);
                    return tr.getMeta('uiEvent') !== 'cut' && $6e4cd1d435523f2b$var$allowedSource(node, state.schema) && $6e4cd1d435523f2b$export$35dc45686fc2dbd7(node);
                });
                changedNodes.forEach(({ node: sourceNode, pos: pos })=>{
                    changedSources.set(pos, sourceNode);
                });
                if (changedNodes.length) return {
                    ...pluginState,
                    changedSources: changedSources,
                    selectedNodeLocalId: selectedNodeLocalId
                };
                if (selectedLocalIdChanged) return {
                    ...pluginState,
                    selectedNodeLocalId: selectedNodeLocalId
                };
                return pluginState;
            }
        },
        view: (editorView)=>{
            api?.attach(editorView);
            const tableNodeSchema = editorView.state.schema.nodes.table;
            const pluginState = (0, $4tb0i.getPluginState)(editorView.state);
            if (!pluginState) return {};
            let handleDeleteDataSource;
            const dataSourceProvider = pluginState.dataSourceProvider;
            const nodeMutationObserver = pluginState.nodeMutationObserver;
            if (dataSourceProvider) {
                handleDeleteDataSource = (node)=>{
                    if (node && node.attrs) {
                        let tableExistsInDoc = false;
                        // ensure the destroyed node is actually not recreated
                        (0, $gWR1e.findChildrenByType)(editorView.state.doc, tableNodeSchema).forEach(({ node: existingNode })=>{
                            if (existingNode.attrs.localId === node.attrs.localId) tableExistsInDoc = true;
                        });
                        if (!tableExistsInDoc) dataSourceProvider.delete(node.attrs.localId);
                    }
                };
                eventDispatcher.on($6e4cd1d435523f2b$var$EmitterEvents.TABLE_DELETED, handleDeleteDataSource);
            }
            if (nodeMutationObserver) (0, $gWR1e.findChildrenByType)(editorView.state.doc, tableNodeSchema).forEach(({ node: node })=>{
                const fragmentLocalId = node?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
                if (fragmentLocalId) nodeMutationObserver.emit(fragmentLocalId, {
                    get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                        return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                    }
                });
                nodeMutationObserver.emit(node.attrs.localId, {
                    get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                        return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                    }
                });
            });
            return {
                update (view, prevState) {
                    const pluginState = (0, $4tb0i.getPluginState)(view.state);
                    if (!pluginState) return;
                    const prevPluginState = (0, $4tb0i.getPluginState)(prevState);
                    const { changedSources: changedSources, nodeMutationObserver: nodeMutationObserver, selectedNodeLocalId: selectedNodeLocalId } = pluginState;
                    if (selectedNodeLocalId !== prevPluginState?.selectedNodeLocalId) api?.setSelectedLocalId(selectedNodeLocalId);
                    changedSources.forEach((node, pos)=>{
                        const fragmentLocalId = node?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
                        if (fragmentLocalId) nodeMutationObserver.emit(fragmentLocalId, {
                            get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                                return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                            }
                        });
                        if (node.attrs?.localId) nodeMutationObserver.emit(node.attrs.localId, {
                            get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                                return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                            }
                        });
                    });
                    changedSources.clear();
                },
                destroy () {
                    api?.detach();
                    if (dataSourceProvider) {
                        eventDispatcher.off($6e4cd1d435523f2b$var$EmitterEvents.TABLE_DELETED, handleDeleteDataSource);
                        if (dataSourceProvider.clear) dataSourceProvider.clear();
                    }
                }
            };
        },
        props: {
            nodeViews: {
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                extension: (0, $160re.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, options.appearance, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                bodiedExtension: (0, $160re.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, options.appearance, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers),
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                inlineExtension: (0, $160re.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, options.appearance, pluginInjectionApi, macroInteractionDesignFeatureFlags)
            }
        }
    });
}
const $6e4cd1d435523f2b$export$9d03c288c4007750 = ({ config: options, api: pluginInjectionApi })=>({
        name: 'referentiality',
        pmPlugins () {
            return [
                {
                    name: 'referentiality',
                    plugin: ({ providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher })=>{
                        const extensionHandlers = options?.extensionHandlers ?? {};
                        const externalObservers = options?.externalObservers ?? [];
                        return $6e4cd1d435523f2b$var$createPlugin(providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, externalObservers, {
                            appearance: options?.appearance
                        }, pluginInjectionApi, options?.api, options?.featureFlags, options?.__livePage, options?.__rendererExtensionOptions);
                    }
                }
            ];
        }
    });
const $6e4cd1d435523f2b$export$7e7e0965a9844ba0 = (options)=>{
    const api = options?.api ?? new (0, $jOOx4.ReferentialityAPIImpl)(options);
    return {
        api: api,
        plugin: $6e4cd1d435523f2b$export$9d03c288c4007750({
            config: {
                ...options,
                api: api
            }
        })
    };
};

});
parcelRegister("4tb0i", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $37c64d6535cfb5cb$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "getPluginState", () => $37c64d6535cfb5cb$export$f05434c51e3762e);

var $7T7aA = parcelRequire("7T7aA");
const $37c64d6535cfb5cb$export$18d4026d1ea86bb1 = new (0, $7T7aA.PluginKey)('referentialityPlugin');
const $37c64d6535cfb5cb$export$f05434c51e3762e = (state)=>state && $37c64d6535cfb5cb$export$18d4026d1ea86bb1.getState(state);

});

parcelRegister("lEgye", function(module, exports) {

$parcel$export(module.exports, "DataSourceProvider", () => $9eb3f7291ea30683$export$83ebb6424014532f);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
class $9eb3f7291ea30683$export$83ebb6424014532f {
    createOrUpdate(id, reference) {
        this.dataSources.set(id, reference);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const requestCallback = window.requestIdleCallback || window.requestAnimationFrame;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cancelCallback = window.cancelIdleCallback || window.cancelAnimationFrame;
        // TODO: ED-26962 - refactor if needed - https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/8012/ed-11927-data-source-provider#comment-206010499
        const callbackId = requestCallback(()=>{
            cancelCallback(callbackId);
            this.notifySubscribers(id, reference);
        });
    }
    notifySubscribers(id, reference) {
        if (this.subscriptions.has(id)) this.subscriptions.get(id)?.forEach((callback)=>{
            callback(reference);
        });
    }
    subscribe(id, callback) {
        if (!this.subscriptions.has(id)) this.subscriptions.set(id, new Set());
        this.subscriptions.get(id)?.add(callback);
    }
    unsubscribe(id, callback) {
        if (!this.subscriptions.has(id)) return;
        this.subscriptions.get(id)?.delete(callback);
    }
    delete(id) {
        this.dataSources.delete(id);
        this.notifySubscribers(id, null);
    }
    get(id) {
        return this.dataSources.get(id) || null;
    }
    clear() {
        this.dataSources.clear();
        this.subscriptions.clear();
    }
    constructor(){
        this.subscriptions = new Map();
        this.dataSources = new Map();
    }
}

});

parcelRegister("cVzsl", function(module, exports) {

$parcel$export(module.exports, "NodeMutationObserver", () => $26165acd862f475d$export$ab608a64509503ae);
class $26165acd862f475d$export$ab608a64509503ae {
    emit(id, adfReference) {
        this.dataSourceProvider.createOrUpdate(id, adfReference);
    }
    constructor(dataSourceProvider){
        this.dataSourceProvider = void 0;
        this.dataSourceProvider = dataSourceProvider;
    }
}

});

parcelRegister("160re", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0ebb093ddd3646$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gjBRE = parcelRequire("gjBRE");
var $3oRlx = parcelRequire("3oRlx");

var $jt8MB = parcelRequire("jt8MB");

var $4tb0i = parcelRequire("4tb0i");
class $9a0ebb093ddd3646$export$63dcdbe82ab2119 extends (0, $gjBRE.ExtensionNode) {
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3oRlx.ExtensionNodeWrapper), {
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jt8MB.default), {
                editorAppearance: props.appearance,
                editorView: this.view,
                node: this.node,
                // The getPos arg is always a function when used with nodes
                // the version of the types we use has a union with the type
                // for marks.
                // This has been fixed in later versions of the definitly typed
                // types (and also in prosmirror-views inbuilt types).
                // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
                getPos: this.getPos,
                providerFactory: props.providerFactory,
                handleContentDOMRef: forwardRef,
                extensionHandlers: props.extensionHandlers,
                dataSourceProvider: props.dataSourceProvider,
                pluginInjectionApi: props.pluginInjectionApi,
                macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: props.rendererExtensionHandlers
            })
        });
    }
}
function $9a0ebb093ddd3646$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, appearance, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers) {
    return (node, view, getPos)=>{
        const pluginState = (0, $4tb0i.getPluginState)(view.state);
        return new $9a0ebb093ddd3646$export$63dcdbe82ab2119(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            appearance: appearance,
            dataSourceProvider: pluginState?.dataSourceProvider,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers
        }).init();
    };
}

});
parcelRegister("jt8MB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a206d91b5b3f476$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fPlBD = parcelRequire("fPlBD");
const $5a206d91b5b3f476$export$eba5603251c4feaf = ({ editorView: editorView, node: node, dataSourceProvider: dataSourceProvider })=>{
    const dataSourceId = node.marks?.find((mark)=>mark.type === editorView.state.schema.marks?.dataConsumer)?.attrs?.sources?.[0];
    const [reference, setReference] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(()=>{
        const dataSourceReference = dataSourceProvider?.get(dataSourceId);
        if (dataSourceReference) return dataSourceReference;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        dataSourceProvider?.unsubscribe(dataSourceId, setReference);
        dataSourceProvider?.subscribe(dataSourceId, setReference);
        return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
    }, [
        dataSourceProvider,
        dataSourceId
    ]);
    return reference ? [
        reference
    ] : [];
};
const $5a206d91b5b3f476$var$ExtensionWithDataSource = (props)=>{
    const reference = $5a206d91b5b3f476$export$eba5603251c4feaf(props);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fPlBD.Extension), {
        ...props,
        references: reference
    });
};
var $5a206d91b5b3f476$export$2e2bcd8739ae039 = $5a206d91b5b3f476$var$ExtensionWithDataSource;

});


parcelRegister("gcCrc", function(module, exports) {

$parcel$export(module.exports, "ADFReferenceTypes", () => $b1f12d58a935bfc6$export$eeab3cae4ffcf74a);
$parcel$export(module.exports, "MEASURE_NAME", () => $b1f12d58a935bfc6$export$5cb1f459478c70e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
var $b1f12d58a935bfc6$export$eeab3cae4ffcf74a = /*#__PURE__*/ function(ADFReferenceTypes) {
    ADFReferenceTypes["TABLE"] = "table-adf";
    return ADFReferenceTypes;
}({});
var $b1f12d58a935bfc6$export$5cb1f459478c70e = /*#__PURE__*/ function(MEASURE_NAME) {
    MEASURE_NAME["INITIALISE_FRAGMENT_MARKS"] = "initialiseFragmentMarks";
    MEASURE_NAME["CONNECT_NODES"] = "connectNodes";
    MEASURE_NAME["UPDATE_SOURCE"] = "updateSource";
    MEASURE_NAME["DISCONNECT_SOURCE"] = "disconnectSource";
    MEASURE_NAME["UPDATE_TARGET"] = "updateTarget";
    MEASURE_NAME["DISCONNECT_TARGET"] = "disconnectTarget";
    MEASURE_NAME["UPDATE_FRAGMENT_MARK_NAME"] = "updateFragmentMarkName";
    MEASURE_NAME["GET_CONNECTIONS"] = "getConnections";
    return MEASURE_NAME;
}({});

});

parcelRegister("jOOx4", function(module, exports) {

$parcel$export(module.exports, "ReferentialityAPIImpl", () => $e9714976d4e11162$export$6a5e825be2d43d52);

var $7T7aA = parcelRequire("7T7aA");

var $30K2d = parcelRequire("30K2d");

var $h9yJL = parcelRequire("h9yJL");

var $2T4ch = parcelRequire("2T4ch");

var $gcCrc = parcelRequire("gcCrc");

var $aoIzw = parcelRequire("aoIzw");

var $9oPnF = parcelRequire("9oPnF");

var $9ge67 = parcelRequire("9ge67");

var $2PvyV = parcelRequire("2PvyV");
class $e9714976d4e11162$export$6a5e825be2d43d52 {
    get isAttached() {
        return !!this.editorView;
    }
    attach(editorView) {
        const { state: { schema: schema } } = editorView;
        if (!schema.marks.fragment) throw new (0, $9oPnF.CompatibilityError)('fragmentMark not supported');
        this.editorView = editorView;
    }
    detach() {
        this.editorView = undefined;
    }
    setNodeFocusCallback(callback) {
        this.nodeFocusCallback = callback;
    }
    setNodeNameCallback(callback) {
        this.nodeNameCallback = callback;
    }
    setSelectedLocalId(localId) {
        if (this.selectedLocalId === localId) return;
        this.selectedLocalId = localId;
        if (!!this.nodeFocusCallback) {
            if (!localId) {
                this.nodeFocusCallback(undefined);
                return;
            }
            if (this.editorView) {
                const { state: state } = this.editorView;
                const foundNode = (0, $9ge67.findNodeByLocalId)(localId, state);
                if (foundNode) this.nodeFocusCallback((0, $9ge67.createLinkNode)(this.normalizeLocalId(localId, foundNode.fragmentMark?.attrs.localId), foundNode.fragmentMark?.attrs.name || '', foundNode.node));
            }
        }
    }
    initialiseFragmentMarks() {
        if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('initialiseFragmentMarks');
        (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).INITIALISE_FRAGMENT_MARKS);
        const { state: state, dispatch: dispatch } = this.editorView;
        let { tr: tr } = state;
        const docSize = state.doc.nodeSize;
        const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId, false);
        let count = 0;
        const maxNumberUsedInFragmentMarkNames = context.getMaxNumberUsedInFragmentMarkNames();
        for (const target of context.namelessOnlyConnections()){
            const { markNameWithNumber: markNameWithNumber, markName: markName, markNameNumber: markNameNumber } = (0, $9ge67.generateMarkNameWithNumber)(target.node, state.schema, maxNumberUsedInFragmentMarkNames, this.nodeNameCallback);
            maxNumberUsedInFragmentMarkNames[markName] = markNameNumber;
            tr = (0, $9ge67.updateFragmentName)(state.schema, target, markNameWithNumber)(tr);
            count++;
        }
        tr.setMeta('addToHistory', false);
        (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).INITIALISE_FRAGMENT_MARKS, (0, $2PvyV.captureInitialiseFragmentMarksEvent)({
            docSize: docSize,
            count: count,
            tr: tr,
            editorAnalyticsAPI: this.editorAnalyticsAPI
        }));
        dispatch(tr);
    }
    getConnections() {
        (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS);
        const result = {};
        if (!this.editorView) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS);
            return result;
        }
        const { state: { tr: tr, doc: { nodeSize: nodeSize } } } = this.editorView;
        const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
        // First initialize all possible connection linkages
        for (const { node: node, normalizedId: normalizedId, name: name } of context.uniqueConnections())result[normalizedId] = (0, $9ge67.createConnectionLink)(node, normalizedId, name);
        // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
        for (const { normalizedId: normalizedId, dataConsumer: dataConsumer } of context.consumerOnlyConnections()){
            // This is a ref to the node (connection link) which contains the consumer.
            const currentNodeLink = result[normalizedId];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dataConsumer.attrs.sources.forEach((src)=>{
                const normalizedSrcId = context.getById(src)?.normalizedId ?? src;
                const srcLink = result[normalizedSrcId];
                if (srcLink && normalizedSrcId !== normalizedId) {
                    srcLink.targets.push(normalizedId);
                    currentNodeLink?.sources.push(normalizedSrcId);
                }
            });
        }
        (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS, (0, $2PvyV.captureGetConnectionsEvent)({
            tr: tr,
            editorAnalyticsAPI: this.editorAnalyticsAPI,
            docSize: nodeSize,
            count: Object.keys(result).length
        }));
        return result;
    }
    select(localId, scroll = false) {
        if (!this.editorView || !localId) throw new (0, $9oPnF.ConfigurationError)('select');
        const { state: state, dispatch: dispatch } = this.editorView;
        const foundNode = (0, $9ge67.findNodeByLocalId)(localId, state);
        if (foundNode) {
            const { tr: tr } = state;
            tr.setSelection((0, $7T7aA.NodeSelection).create(state.doc, foundNode.pos));
            if (scroll) tr.scrollIntoView();
            tr.setMeta('addToHistory', false);
            dispatch(tr);
        }
    }
    updateName(localId, name) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME);
            if (!this.isAttached || !this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateName');
            const { state: state, state: { schema: schema }, dispatch: dispatch } = this.editorView;
            const foundNode = (0, $9ge67.findNodeByLocalId)(localId, state);
            if (!foundNode) throw new (0, $9oPnF.NodeNotFoundError)(localId);
            const { fragment: fragment } = schema.marks;
            const { fragmentMark: fragmentMark, node: node, pos: pos } = foundNode;
            const fragLocalId = fragmentMark?.attrs.localId ?? (0, $30K2d.uuid).generate();
            const nextFragmentMark = fragment.create({
                localId: fragLocalId,
                name: name
            });
            const nextMarks = fragmentMark ? node.marks.filter((mark)=>mark.type !== nextFragmentMark.type) : node.marks.concat();
            nextMarks.push(nextFragmentMark);
            // ensure the fragment mark on the node has the correct id & name.
            const tr = state.tr.setNodeMarkup(pos, undefined, node.attrs, nextMarks);
            dispatch(tr);
            const linkNode = (0, $9ge67.createLinkNode)(this.normalizeLocalId(node.attrs.localId, fragLocalId), name, node);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME, (0, $2PvyV.captureUpdateFragmentMarkNameEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                nodeType: node.type.name
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME);
            throw e;
        }
    }
    getADFFromLocalId(localId) {
        if (!this.isAttached || !this.editorView) throw new (0, $9oPnF.ConfigurationError)('getADFFromLocalId');
        const { state: state } = this.editorView;
        const foundNode = (0, $9ge67.findNodeByLocalId)(localId, state);
        if (!foundNode) throw new (0, $9oPnF.NodeNotFoundError)(localId);
        return new (0, $h9yJL.JSONTransformer)().encodeNode(foundNode.node);
    }
    connectSource(targetLocalId, sourceLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('connectSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { source: source, target: target, tr: tr } = (0, $9ge67.connectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $2PvyV.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectSource',
                type: 'connect',
                sourceNodeType: source.node.type,
                targetNodeType: target.node.type
            }));
            return source;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    connectTarget(sourceLocalId, targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('connectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { source: source, target: target, tr: tr } = (0, $9ge67.connectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $2PvyV.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectTarget',
                type: 'connect',
                sourceNodeType: source.node.type,
                targetNodeType: target.node.type
            }));
            return target;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    updateTarget(sourceLocalId, oldTargetLocalId, newTargetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { target: target, source: source, tr: tr } = (0, $9ge67.connectNodes)(context, newTargetLocalId, sourceLocalId, (0, $9ge67.disconnectNodes)(context, oldTargetLocalId, sourceLocalId, state.tr));
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET, (0, $2PvyV.captureUpdateTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                newTargetNodeType: target.node.type,
                oldTargetNodeType: context.getById(oldTargetLocalId)?.node.type.name || '',
                sourceNodeType: source.node.type,
                type: 'update'
            }));
            return target;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            throw e;
        }
    }
    updateSource(targetLocalId, newSourceLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { target: target, source: source, tr: tr } = (0, $9ge67.resetNodes)(context, targetLocalId, newSourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE, (0, $2PvyV.captureUpdateSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                oldSourceNodeType: target.node.type,
                newSourceNodeType: source.node.type,
                type: 'update'
            }));
            return source;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            throw e;
        }
    }
    disconnectTarget(sourceLocalId, targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('disconnectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const tr = (0, $9ge67.disconnectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET, (0, $2PvyV.captureDisconnectTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || '',
                targetNodeType: context.getById(targetLocalId)?.node.type.name || ''
            }));
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET);
            throw e;
        }
    }
    disconnectSource(targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('disconnectSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const target = (0, $9ge67.findNodeByLocalId)(targetLocalId, state);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const tr = (0, $9ge67.updateNodeSources)(state.schema, target.node, target.pos)(state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE, (0, $2PvyV.captureDisconnectSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                targetNodeType: target.node.type.name
            }));
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE);
            throw e;
        }
    }
    insertAndConnectTarget(sourceLocalId, target) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('insertAndConnectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { linkNode: linkNode, tr: tr } = (0, $9ge67.insertTarget)(context, sourceLocalId, target, state.tr, this.nodeNameCallback);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $2PvyV.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectTarget',
                type: 'insertAndConnect',
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || '',
                targetNodeType: target.type
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    insertAndConnectSource(targetLocalId, source) {
        try {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('insertAndConnectSource');
            const { state: state, state: { schema: schema }, dispatch: dispatch } = this.editorView;
            const nodeType = schema.nodes[source.type];
            if (!(0, $9ge67.getNodesSupportingFragmentMark)(schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(source.type);
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const target = context.getById(targetLocalId);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const { linkNode: linkNode, node: node } = (0, $9ge67.createLinkElementNode)(context, source, this.nodeNameCallback);
            let tr = state.tr;
            const targetSources = (0, $9ge67.normalizeIds)(context, target.dataConsumer?.attrs.sources).add(linkNode.localId);
            tr = (0, $9ge67.updateSources)(schema, target, targetSources)(tr);
            tr = (0, $9ge67.insertNodeAfter)(targetLocalId, node, state, tr);
            tr = tr.setMeta('referentialityTableInserted', node.type.name === schema.nodes.table.name);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $2PvyV.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectSource',
                type: 'insertAndConnect',
                sourceNodeType: node.type.name,
                targetNodeType: context.getById(targetLocalId)?.node.type.name || ''
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    replaceAndUpdateTarget(sourceLocalId, oldTargetLocalId, newTarget) {
        try {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('replaceAndUpdateTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { linkNode: linkNode, tr: tr } = (0, $9ge67.insertTarget)(context, sourceLocalId, newTarget, state.tr, this.nodeNameCallback, oldTargetLocalId);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET, (0, $2PvyV.captureUpdateTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                type: 'replaceAndUpdate',
                newTargetNodeType: newTarget.type,
                oldTargetNodeType: context.getById(oldTargetLocalId)?.node.type.name || '',
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || ''
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            throw e;
        }
    }
    replaceAndUpdateSource(targetLocalId, newSource) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('replaceAndUpdateSource');
            const { state: { schema: schema }, state: state, dispatch: dispatch } = this.editorView;
            const nodeType = schema.nodes[newSource.type];
            if (!(0, $9ge67.getNodesSupportingFragmentMark)(schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(newSource.type);
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const target = context.getById(targetLocalId);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const { linkNode: linkNode, node: node } = (0, $9ge67.createLinkElementNode)(context, newSource, this.nodeNameCallback);
            let tr = (0, $9ge67.updateSources)(context.schema, target, new Set([
                linkNode.localId
            ]))(state.tr);
            tr = (0, $9ge67.insertNodeAfter)(targetLocalId, node, state, tr);
            tr = tr.setMeta('referentialityTableInserted', node.type.name === schema.nodes.table.name);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE, (0, $2PvyV.captureUpdateSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                oldSourceNodeType: target.node.type.name,
                newSourceNodeType: newSource.type,
                type: 'replaceAndUpdate'
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            throw e;
        }
    }
    /**
   * @constructor
   */ constructor({ nodeNameCallback: nodeNameCallback, nodeFocusCallback: // you can also set this callback using setNodeNameCallback method
    nodeFocusCallback, editorAnalyticsAPI: // you can also set this callback using setNodeFocusCallback method
    editorAnalyticsAPI, editorView: editorView, featureFlags: featureFlags } = {}){
        this.nodeNameCallback = void 0;
        this.nodeFocusCallback = void 0;
        this.normalizeLocalId = void 0;
        this.editorAnalyticsAPI = void 0;
        this.editorView = void 0;
        this.selectedLocalId = void 0;
        this.nodeNameCallback = nodeNameCallback;
        this.nodeFocusCallback = nodeFocusCallback;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
        this.editorView = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.normalizeLocalId = (attrsLocalId, fragmentLocalId)=>fragmentLocalId ?? attrsLocalId;
    }
}

});
parcelRegister("aoIzw", function(module, exports) {

$parcel$export(module.exports, "ReferentialityContext", () => $d8399198c52b1afb$export$3e2fc71d3c4adf01);

var $9ge67 = parcelRequire("9ge67");
class $d8399198c52b1afb$export$3e2fc71d3c4adf01 {
    /**
   * Convenience helper to get the EditorState
   */ get state() {
        return this.view.state;
    }
    /**
   * Convenience helper to get the Schema
   */ get schema() {
        return this.view.state.schema;
    }
    getById(localId) {
        return this.connections.get(localId);
    }
    hasId(localId) {
        return this.connections.has(localId);
    }
    getMaxNumberUsedInFragmentMarkNames() {
        return {
            ...this.maxNumberUsedInFragmentMarkName
        };
    }
    getMaxNumberUsedInFragmentMarkName(name) {
        return this.maxNumberUsedInFragmentMarkName[name] ?? 0;
    }
    updateMaxNumberUsedInFragmentMarkNames(name, value) {
        this.maxNumberUsedInFragmentMarkName[name] = value;
    }
    *uniqueConnections() {
        for (const id of this.uniqueNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * This generator will only return connections which contain DataConsumer sources.
   */ *consumerOnlyConnections() {
        for (const id of this.uniqueNormalizedIds){
            const connection = this.connections.get(id);
            if (connection && !!connection.dataConsumer?.attrs.sources.length) yield connection;
        }
    }
    /**
   * This generator will only return connections which are sources
   */ *sourceOnlyConnections() {
        for (const id of this.uniqueSourceNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * This generator will return connections which do not contain a name or fragment
   */ *namelessOnlyConnections() {
        for (const id of this.namelessNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * @constructor
   * @param view
   * @param shallow A flag to help identify the depth of scan required. This default to true. A Shallow context assumes
   * that nodes with data consumers cannot contain descendants with fragmentMarks or dataConsumers
   */ constructor(view, normalizeLocalId, shallow = true){
        this.view = view;
        this.normalizeLocalId = normalizeLocalId;
        this.shallow = shallow;
        /**
     * This record is used to keep track of the max number in each fragment name.
     */ this.maxNumberUsedInFragmentMarkName = {};
        /**
     * This map enables quick lookup of all unnormalized connections
     */ this.connections = new Map();
        /**
     * This is a unique set containing only normalized localIds
     */ this.uniqueNormalizedIds = new Set();
        /**
     * This is a unique set containing only normalized localIds
     */ this.uniqueSourceNormalizedIds = new Set();
        /**
     * This is a unique set of normalized localIds which are nameless
     */ this.namelessNormalizedIds = new Set();
        const { doc: doc, schema: schema } = this.view.state;
        const { fragment: fragment, dataConsumer: dataConsumer } = schema.marks;
        const nodesSupportingFragmentMark = (0, $9ge67.getNodesSupportingFragmentMark)(schema);
        const sourceToTargetMappings = new Map();
        doc.descendants((node, pos, parent)=>{
            if (!nodesSupportingFragmentMark.has(node.type)) return true;
            const fragmentMark = fragment.isInSet(node.marks);
            // If node cannot be referenced by any means then abort.
            if (!fragmentMark && !node.attrs?.localId) return true;
            const normalizedId = this.normalizeLocalId(node.attrs?.localId, fragmentMark?.attrs?.localId);
            if (!normalizedId || this.connections.has(normalizedId)) return true;
            let decodedName;
            if (!!fragmentMark?.attrs.name) {
                decodedName = (0, $9ge67.decodeName)(fragmentMark.attrs.name);
                if (decodedName) {
                    const currentMax = this.maxNumberUsedInFragmentMarkName[decodedName.defaultName];
                    if (currentMax === undefined || currentMax < decodedName.defaultNameNumber) this.maxNumberUsedInFragmentMarkName[decodedName.defaultName] = decodedName.defaultNameNumber;
                }
            } else this.namelessNormalizedIds.add(normalizedId);
            const consumer = dataConsumer.isInSet(node.marks);
            const ref = {
                node: node,
                pos: pos,
                parent: parent,
                normalizedId: normalizedId,
                name: fragmentMark?.attrs?.name ?? normalizedId,
                ids: new Set(),
                targets: new Set(),
                fragmentMark: fragmentMark,
                dataConsumer: consumer,
                decodedName: decodedName
            };
            if (!!fragmentMark?.attrs?.localId) {
                ref.ids.add(fragmentMark.attrs.localId);
                this.connections.set(fragmentMark.attrs.localId, ref);
            }
            if (!!node.attrs?.localId) {
                ref.ids.add(node.attrs.localId);
                this.connections.set(node.attrs.localId, ref);
            }
            this.uniqueNormalizedIds.add(normalizedId);
            if (consumer) // A lookup map of srcId -> targetId[]. This enables quickly finding all nodes
            // which consume a specific source.
            consumer.attrs.sources.forEach((src)=>sourceToTargetMappings.set(src, sourceToTargetMappings.get(src)?.add(normalizedId) ?? new Set([
                    normalizedId
                ])));
            // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
            // be referenced by another node. Unless of course this is not a shallow context.
            // if consumer: true & shallow: true -> return false // don't descend
            // if consumer: false & shallow: true -> return true // descend
            // if consumer: true & shallow: false -> return true // descend
            // if consumer: false & shallow: false -> return true // descend
            return !(shallow && consumer);
        });
        // This 2nd-pass is used to normalize all the source ids. We need to have full context before we're able to do this.
        for (const [source, targets] of sourceToTargetMappings){
            const connection = this.connections.get(source);
            if (connection) {
                this.uniqueSourceNormalizedIds.add(connection.normalizedId);
                connection.targets = new Set([
                    ...connection.targets,
                    ...targets
                ]);
            }
        }
    }
}

});
parcelRegister("9ge67", function(module, exports) {

$parcel$export(module.exports, "getNodeTypesSupported", () => $2e1ac7157de99f01$export$8174b2693cae81eb);
$parcel$export(module.exports, "getNodesSupportingFragmentMark", () => $2e1ac7157de99f01$export$3fdc75161fb8ee49);
$parcel$export(module.exports, "createConnectionLink", () => $2e1ac7157de99f01$export$54a3e405bb0d0a4a);
$parcel$export(module.exports, "decodeName", () => $2e1ac7157de99f01$export$368b1080eb192086);
$parcel$export(module.exports, "generateMarkNameWithNumber", () => $2e1ac7157de99f01$export$8a9a3ce4139f59c3);
$parcel$export(module.exports, "createLinkNode", () => $2e1ac7157de99f01$export$dbdf2d08277c626e);
$parcel$export(module.exports, "findNodeByLocalId", () => $2e1ac7157de99f01$export$aadcc3ba2430b);
$parcel$export(module.exports, "insertNodeAfter", () => $2e1ac7157de99f01$export$9c63b8d16fa708c5);
$parcel$export(module.exports, "normalizeIds", () => $2e1ac7157de99f01$export$4c47e28146a39728);
$parcel$export(module.exports, "updateSources", () => $2e1ac7157de99f01$export$6c4da287bd77d75c);
$parcel$export(module.exports, "updateNodeSources", () => $2e1ac7157de99f01$export$884cb393b34cee0d);
$parcel$export(module.exports, "updateFragmentName", () => $2e1ac7157de99f01$export$c4bf0d625842a200);
$parcel$export(module.exports, "createLinkElementNode", () => $2e1ac7157de99f01$export$599e2146ce482fc4);
$parcel$export(module.exports, "connectNodes", () => $2e1ac7157de99f01$export$2e109011d5320d15);
$parcel$export(module.exports, "disconnectNodes", () => $2e1ac7157de99f01$export$dba1c2bae2f381b9);
$parcel$export(module.exports, "resetNodes", () => $2e1ac7157de99f01$export$b0852c37ee3e7ea9);
$parcel$export(module.exports, "insertTarget", () => $2e1ac7157de99f01$export$fb891e3743d8c30f);

var $kviC1 = parcelRequire("kviC1");

var $30K2d = parcelRequire("30K2d");

var $h9yJL = parcelRequire("h9yJL");

var $gWR1e = parcelRequire("gWR1e");

var $9oPnF = parcelRequire("9oPnF");
const $2e1ac7157de99f01$export$8174b2693cae81eb = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $2e1ac7157de99f01$export$3fdc75161fb8ee49 = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return new Map([
        [
            table,
            'Table'
        ],
        [
            extension,
            'Extension'
        ],
        [
            bodiedExtension,
            'Extension'
        ],
        [
            inlineExtension,
            'Extension'
        ]
    ]);
};
const $2e1ac7157de99f01$export$549d0eefc6fd05c0 = (schema)=>{
    const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return new Set([
        extension,
        bodiedExtension,
        inlineExtension
    ].filter(Boolean));
};
const $2e1ac7157de99f01$export$54a3e405bb0d0a4a = (node, id, name)=>({
        linkNode: {
            localId: id,
            name: name ?? id,
            node: {
                type: node.type.name,
                attrs: {
                    ...node.attrs
                }
            }
        },
        sources: [],
        targets: []
    });
const $2e1ac7157de99f01$export$368b1080eb192086 = (name)=>{
    const splitName = name.split(' '); // ['Awesome', 'list', '2.0', '5']
    if (splitName.length < 2) return null;
    const lastNumberInName = Number(splitName[splitName.length - 1]);
    if (typeof lastNumberInName !== 'number') return null;
    const nameWithoutLastNumber = splitName.slice(0, splitName.length - 1) // ['Awesome', 'list', '2.0']
    .join(' '); // 'Awesome list 2.0'
    return {
        defaultName: nameWithoutLastNumber,
        defaultNameNumber: lastNumberInName
    };
};
const $2e1ac7157de99f01$export$8a9a3ce4139f59c3 = ({ type: type, attrs: attrs }, schema, fragmentMarkNameLastNumbers, nodeNameCallback)=>{
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    const nodesSupportingNameCallback = $2e1ac7157de99f01$export$549d0eefc6fd05c0(schema);
    let markName = '';
    if (nodesSupportingNameCallback.has(type)) {
        if (nodeNameCallback) markName = nodeNameCallback({
            node: {
                type: type.name,
                attrs: attrs
            }
        });
    }
    if (!markName) markName = nodesSupportingFragmentMark.get(type) ?? 'Element';
    const markNameNumber = (fragmentMarkNameLastNumbers?.[markName] ?? 0) + 1;
    return {
        markNameWithNumber: `${markName} ${markNameNumber}`,
        markName: markName,
        markNameNumber: markNameNumber
    };
};
const $2e1ac7157de99f01$export$7503e197531554a8 = ({ normalizedId: normalizedId, name: name, node: node })=>$2e1ac7157de99f01$export$dbdf2d08277c626e(normalizedId, name, node);
const $2e1ac7157de99f01$export$dbdf2d08277c626e = (localId, name, node)=>{
    const jsonNode = new (0, $h9yJL.JSONTransformer)().encodeNode(node);
    return {
        localId: localId,
        name: name,
        node: {
            type: jsonNode.type,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            attrs: jsonNode.attrs
        }
    };
};
const $2e1ac7157de99f01$export$c85fa7574bd3ee0b = (context, target, source)=>{
    if (target.normalizedId === source.normalizedId) return true;
    // Try and get a consumer from the source, this is because we don't care about the initial link between target -> source
    // we only care if somewhere down the chain after the source; is there a link back to this target.
    return !!source.dataConsumer?.attrs.sources.some((src)=>{
        const nextSrc = context.getById(src);
        return !!nextSrc && $2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, nextSrc);
    });
};
const $2e1ac7157de99f01$export$b25165d24a0db921 = (state, localId)=>{
    let found = false;
    const { doc: doc, schema: schema } = state;
    const { fragment: fragment } = schema.marks;
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    // TODO: ED-26962 - Update scanning method to abort the scan immediately once a node has been found.
    doc.descendants((node)=>{
        if (found) return false;
        if (!nodesSupportingFragmentMark.has(node.type)) return true;
        if (node.attrs?.localId === localId) {
            found = true;
            return false;
        }
        const fragmentMark = fragment.isInSet(node.marks);
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark) return true;
        if (fragmentMark?.attrs?.localId === localId) found = true;
        return !found;
    });
    return found;
};
const $2e1ac7157de99f01$export$aadcc3ba2430b = (localId, state)=>{
    const { doc: doc, schema: schema } = state;
    const fragment = schema.marks.fragment;
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    let foundNode = null;
    doc.descendants((node, pos)=>{
        if (foundNode) return false;
        if (!nodesSupportingFragmentMark.has(node.type)) return true;
        const existingFragmentMark = fragment.isInSet(node.marks) ?? null;
        if (existingFragmentMark && existingFragmentMark.attrs.localId === localId) {
            foundNode = {
                node: node,
                pos: pos,
                fragmentMark: existingFragmentMark
            };
            return false;
        }
        if (node.attrs.localId === localId) {
            foundNode = {
                node: node,
                pos: pos,
                fragmentMark: existingFragmentMark
            };
            return false;
        }
        return true;
    });
    return foundNode;
};
const $2e1ac7157de99f01$export$ebf688cb60f59a94 = (schema, localId, name, sources)=>{
    const { fragment: fragment, dataConsumer: dataConsumer } = schema.marks;
    return [
        fragment.create({
            localId: localId,
            name: name
        }),
        sources && dataConsumer.create({
            sources: Array.from(sources) ?? []
        })
    ].filter(Boolean);
};
const $2e1ac7157de99f01$export$270e7ba5936d3c48 = (schema, type, attrs, marks)=>{
    const { table: table } = schema.nodes;
    const createNodeContent = type === table ? $2e1ac7157de99f01$export$d142f815ac656d : $2e1ac7157de99f01$export$85ceaeb5400c34da;
    return type.createChecked({
        ...attrs,
        localId: (0, $30K2d.uuid).generate()
    }, createNodeContent(schema, type), marks);
};
const $2e1ac7157de99f01$export$d142f815ac656d = (schema, type)=>{
    const { tableCell: tableCell, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < 3; i++){
        const cell = tableCell.createAndFill();
        if (cell) cells.push(cell);
        const headerCell = tableHeader.createAndFill();
        if (headerCell) headerCells.push(headerCell);
    }
    const rows = [];
    for(let i = 0; i < 3; i++)rows.push(tableRow.createChecked(null, i === 0 ? headerCells : cells));
    return rows;
};
const $2e1ac7157de99f01$export$85ceaeb5400c34da = (schema, type)=>{
    const { bodiedExtension: bodiedExtension, paragraph: paragraph } = schema.nodes;
    if (type === bodiedExtension) return [
        paragraph.createChecked()
    ];
    return (0, $kviC1.Fragment).empty;
};
const $2e1ac7157de99f01$export$9c63b8d16fa708c5 = (localId, node, state, tr, options)=>{
    tr = tr ?? state.tr;
    const nodePos = $2e1ac7157de99f01$export$aadcc3ba2430b(localId, state);
    const insertPosition = nodePos ? nodePos.pos + nodePos.node.nodeSize : undefined;
    tr = (0, $gWR1e.safeInsert)(node, insertPosition)(tr);
    return tr;
};
const $2e1ac7157de99f01$export$4c47e28146a39728 = (context, ids)=>{
    return ids?.reduce((idSet, id)=>{
        const ns = context.getById(id)?.normalizedId;
        // filters out undefined, null or empty items
        return !!ns ? idSet.add(ns) : idSet;
    }, new Set()) ?? new Set();
};
const $2e1ac7157de99f01$export$6c4da287bd77d75c = (schema, target, sources)=>(tr)=>$2e1ac7157de99f01$export$884cb393b34cee0d(schema, target.node, target.pos, sources, target.dataConsumer)(tr);
const $2e1ac7157de99f01$export$884cb393b34cee0d = (schema, node, pos, sources, consumer)=>(tr)=>{
        const { dataConsumer: dataConsumer } = schema.marks;
        const currentSources = (consumer ?? dataConsumer.isInSet(node.marks))?.attrs.sources;
        // Quick Check: No point in updating node markup if nothing is changing.
        if (!sources?.size && !currentSources?.length) return tr;
        // This attempts to check deep equality. If the sizes are not the same or a source is different to what's being set; then
        // we want to perform the markup change, otherwise we should avoid unnecessary transactions.
        if (sources?.size === currentSources?.length && currentSources.every((src)=>sources.has(src))) return tr;
        const marks = (dataConsumer?.removeFromSet(node.marks) ?? node.marks).concat();
        if (!!sources?.size) marks.push(dataConsumer.create({
            sources: Array.from(sources)
        }));
        // If the old target sources is now 0 then the data consumer will be removed from the marks. Otherwise a new
        // consumer with updated sources will be injected.
        tr.setNodeMarkup(pos, undefined, node.attrs, marks);
        return tr;
    };
const $2e1ac7157de99f01$export$c4bf0d625842a200 = (schema, target, name)=>(tr)=>{
        const { fragment: fragment } = schema.marks;
        // Quick Check: No point in updating node markup if nothing is changing.
        if (name === target.fragmentMark?.attrs.name) return tr;
        const marks = (target.fragmentMark?.removeFromSet(target.node.marks) ?? target.node.marks).concat();
        marks.push(fragment.create({
            localId: target.fragmentMark?.attrs.localId ?? (0, $30K2d.uuid).generate(),
            name: name
        }));
        return tr.setNodeMarkup(target.pos, undefined, target.node.attrs, marks);
    };
const $2e1ac7157de99f01$export$599e2146ce482fc4 = (context, element, nodeNameCallback, sources)=>{
    const nodeType = context.schema.nodes[element.type];
    if (!$2e1ac7157de99f01$export$3fdc75161fb8ee49(context.schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(element.type);
    const newNodeUUID = (0, $30K2d.uuid).generate();
    if (context.hasId(newNodeUUID)) // XXX: Assuming UUID is true this condition should never occur.
    // This is just a safety catch; to protect against lightning strikes.
    throw new (0, $9oPnF.LocalIdCollisionError)(newNodeUUID);
    let attrs;
    if (element.type !== 'table') attrs = element.attrs;
    const { markNameWithNumber: markNameWithNumber } = $2e1ac7157de99f01$export$8a9a3ce4139f59c3({
        type: nodeType,
        attrs: attrs
    }, context.schema, context.getMaxNumberUsedInFragmentMarkNames(), nodeNameCallback);
    if (element.type === 'table') attrs = {
        width: 760
    };
    const node = $2e1ac7157de99f01$export$270e7ba5936d3c48(context.schema, nodeType, attrs, $2e1ac7157de99f01$export$ebf688cb60f59a94(context.schema, newNodeUUID, markNameWithNumber, sources));
    const { inlineExtension: inlineExtension, paragraph: paragraph } = context.schema.nodes;
    // The finalNode is a post-processed node which is eventually added to the document. This may not be the actual
    // element node this was told to create as some nodes may need to be wrapped by others to be safely added  to the document.
    const finalNode = nodeType === inlineExtension ? paragraph.create(undefined, [
        node
    ]) : node;
    return {
        linkNode: $2e1ac7157de99f01$export$dbdf2d08277c626e(newNodeUUID, markNameWithNumber, node),
        node: finalNode
    };
};
const $2e1ac7157de99f01$export$2e109011d5320d15 = (context, targetLocalId, sourceLocalId, tr)=>{
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    if (target.normalizedId === source.normalizedId) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
    // If the current target dataConsumer already has the source linked.
    const hasDataConsumerSource = !!target.dataConsumer?.attrs.sources.some((src)=>source.ids.has(src));
    if (hasDataConsumerSource) // If the connection has already been made, avoid an unnecessary transaction
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
    else {
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, source)) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
        const newSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
        // Add the source to the target.
        newSources.add(source.normalizedId);
        tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, newSources)(tr);
    }
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$dba1c2bae2f381b9 = (context, targetLocalId, sourceLocalId, tr)=>{
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const targetSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
    // Remove the source from the target (if any) and update the sources if the source was deleted.
    if (targetSources.delete(source.normalizedId)) return $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, targetSources)(tr);
    return tr;
};
const $2e1ac7157de99f01$export$b0852c37ee3e7ea9 = (context, targetLocalId, sourceLocalId, tr)=>{
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    if (target.normalizedId === source.normalizedId) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
    // If the current target dataConsumer already has the source linked.
    const hasDataConsumerSource = !!target.dataConsumer?.attrs.sources.every((src)=>source.ids.has(src));
    if (hasDataConsumerSource) // If the connection has already been made, avoid an unnecessary transaction
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
    else {
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, source)) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
        tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, new Set([
            source.normalizedId
        ]))(tr);
    }
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$73aa87199f4a96f5 = (context, localId, tr)=>{
    const source = context.getById(localId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(localId);
    source.targets.forEach((target)=>{
        tr = $2e1ac7157de99f01$export$dba1c2bae2f381b9(context, target, localId, tr);
    });
    return tr;
};
const $2e1ac7157de99f01$export$328b0edc9fda3a36 = (context, oldSourceLocalId, newSourceLocalId, tr)=>{
    // This needs to disconnect the old source from all targets. Then update each target with the new source
    const oldSource = context.getById(oldSourceLocalId);
    if (!oldSource) throw new (0, $9oPnF.SourceReferenceError)(oldSourceLocalId);
    const newSource = context.getById(newSourceLocalId);
    if (!newSource) throw new (0, $9oPnF.SourceReferenceError)(newSourceLocalId);
    // If the old/new source are referring to the same connection then we should avoid unnecessary transactions.
    if (oldSource === newSource) return {
        source: $2e1ac7157de99f01$export$7503e197531554a8(newSource),
        tr: tr
    };
    // Before we do any disconnecting or updating we must ensure a couple things first;
    // 1. The old source targets exist
    // 2. Moving the old source target to the new source doesn't cause a cyclic ref.
    for (const targetId of oldSource.targets){
        const target = context.getById(targetId);
        if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetId);
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, newSource)) throw new (0, $9oPnF.CyclicReferenceError)(targetId, newSourceLocalId);
        const targetSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
        const deleted = targetSources.delete(oldSource.normalizedId);
        // If the target source doesn't have the new source then it will be added.
        const added = !targetSources.has(newSource.normalizedId);
        targetSources.add(newSource.normalizedId);
        if (deleted || added) tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, targetSources)(tr);
    }
    return {
        source: $2e1ac7157de99f01$export$7503e197531554a8(newSource),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$fb891e3743d8c30f = (context, sourceLocalId, target, tr, nodeNameCallback, oldTargetLocalId)=>{
    const nodeType = context.schema.nodes[target.type];
    if (!$2e1ac7157de99f01$export$3fdc75161fb8ee49(context.schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(target.type);
    if (!context.hasId(sourceLocalId)) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    const { linkNode: linkNode, node: node } = $2e1ac7157de99f01$export$599e2146ce482fc4(context, target, nodeNameCallback, [
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        context.getById(sourceLocalId).normalizedId
    ]);
    if (!!oldTargetLocalId) // If an old target id has been supplied then this insert action is
    // replacing and old connection, so we need to disconnect the
    // old connection, then insert the new node.
    tr = $2e1ac7157de99f01$export$dba1c2bae2f381b9(context, oldTargetLocalId, sourceLocalId, tr);
    tr = $2e1ac7157de99f01$export$9c63b8d16fa708c5(sourceLocalId, node, context.state, tr);
    tr = tr.setMeta('referentialityTableInserted', node.type.name === context.schema.nodes.table.name);
    return {
        linkNode: linkNode,
        tr: tr
    };
};

});
parcelRegister("9oPnF", function(module, exports) {

$parcel$export(module.exports, "CompatibilityError", () => $4157e5902416a90b$export$fa0bafaea078bc3e);
$parcel$export(module.exports, "ConfigurationError", () => $4157e5902416a90b$export$c9ab3ad70477eb);
$parcel$export(module.exports, "UnsupportedTypeError", () => $4157e5902416a90b$export$fef5df6faf884a63);
$parcel$export(module.exports, "NodeNotFoundError", () => $4157e5902416a90b$export$8ef43b75008b17aa);
$parcel$export(module.exports, "TargetReferenceError", () => $4157e5902416a90b$export$88aaf39bc2cab9a8);
$parcel$export(module.exports, "SourceReferenceError", () => $4157e5902416a90b$export$311a85310d085910);
$parcel$export(module.exports, "CyclicReferenceError", () => $4157e5902416a90b$export$1a3d80e823d9a375);
$parcel$export(module.exports, "LocalIdCollisionError", () => $4157e5902416a90b$export$d754643475748116);
class $4157e5902416a90b$export$fa0bafaea078bc3e extends Error {
    constructor(reason){
        super(`Unable to attach, Incorrect configuration: ${reason}`), this.reason = reason;
    }
}
class $4157e5902416a90b$export$c9ab3ad70477eb extends Error {
    constructor(handlerName){
        super(`Unable to execute ${handlerName}, API hasn't been initialized`), this.handlerName = handlerName;
    }
}
class $4157e5902416a90b$export$6b13996afffc6894 extends Error {
    constructor(){
        super('An Error occured during Initialization');
    }
}
class $4157e5902416a90b$export$e162153238934121 extends Error {
    constructor(){
        super('API not implemented');
    }
}
class $4157e5902416a90b$export$fef5df6faf884a63 extends Error {
    constructor(type){
        super(`Unsupported type (${type})`);
    }
}
class $4157e5902416a90b$export$8ef43b75008b17aa extends ReferenceError {
    constructor(localId){
        super(`Node (${localId}) could not be found`), this.localId = localId;
    }
}
class $4157e5902416a90b$export$88aaf39bc2cab9a8 extends $4157e5902416a90b$export$8ef43b75008b17aa {
    constructor(localId){
        super(localId), this.localId = localId;
    }
}
class $4157e5902416a90b$export$311a85310d085910 extends $4157e5902416a90b$export$8ef43b75008b17aa {
    constructor(localId){
        super(localId), this.localId = localId;
    }
}
class $4157e5902416a90b$export$1a3d80e823d9a375 extends ReferenceError {
    constructor(targetLocalId, sourceLocalId){
        super(`Connecting Target (${targetLocalId}) to Source (${sourceLocalId}) will result in a Circular Reference`), this.targetLocalId = targetLocalId, this.sourceLocalId = sourceLocalId;
    }
}
class $4157e5902416a90b$export$d754643475748116 extends ReferenceError {
    constructor(localId){
        super(`LocalId (${localId}) Collision has occured`), this.localId = localId;
    }
}

});



parcelRegister("2PvyV", function(module, exports) {

$parcel$export(module.exports, "captureInitialiseFragmentMarksEvent", () => $32b6226d0cdd6a9e$export$12008b1cff7b5512);
$parcel$export(module.exports, "captureConnectNodesEvent", () => $32b6226d0cdd6a9e$export$bff45a9f8c570c00);
$parcel$export(module.exports, "captureUpdateSourceEvent", () => $32b6226d0cdd6a9e$export$d0d121977041a37d);
$parcel$export(module.exports, "captureDisconnectSourceEvent", () => $32b6226d0cdd6a9e$export$9f5791db63c112cc);
$parcel$export(module.exports, "captureDisconnectTargetEvent", () => $32b6226d0cdd6a9e$export$1bb576f3f4bb0389);
$parcel$export(module.exports, "captureUpdateTargetEvent", () => $32b6226d0cdd6a9e$export$41746208cd3b8ef5);
$parcel$export(module.exports, "captureUpdateFragmentMarkNameEvent", () => $32b6226d0cdd6a9e$export$6f3cdc6bed2f6e2e);
$parcel$export(module.exports, "captureGetConnectionsEvent", () => $32b6226d0cdd6a9e$export$c56def702d19a484);

var $d925B = parcelRequire("d925B");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32b6226d0cdd6a9e$var$getPayload = (payload)=>({
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        tags: [
            'editor'
        ],
        ...payload
    });
const $32b6226d0cdd6a9e$export$12008b1cff7b5512 = ({ docSize: docSize, count: count, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).INITIALISED_FRAGMENT_MARK,
            attributes: {
                duration: duration,
                docSize: docSize,
                count: count
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$bff45a9f8c570c00 = ({ docSize: docSize, sourceNodeType: sourceNodeType, targetNodeType: targetNodeType, type: type, actionType: actionType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).CONNECTED_NODES,
            attributes: {
                duration: duration,
                docSize: docSize,
                sourceNodeType: sourceNodeType,
                targetNodeType: targetNodeType,
                type: type,
                actionType: actionType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$d0d121977041a37d = ({ docSize: docSize, oldSourceNodeType: oldSourceNodeType, newSourceNodeType: newSourceNodeType, type: type, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_SOURCE,
            attributes: {
                duration: duration,
                docSize: docSize,
                oldSourceNodeType: oldSourceNodeType,
                newSourceNodeType: newSourceNodeType,
                type: type
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$9f5791db63c112cc = ({ docSize: docSize, targetNodeType: targetNodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).DISCONNECTED_SOURCE,
            attributes: {
                duration: duration,
                docSize: docSize,
                targetNodeType: targetNodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$1bb576f3f4bb0389 = ({ docSize: docSize, sourceNodeType: sourceNodeType, targetNodeType: targetNodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).DISCONNECTED_TARGET,
            attributes: {
                duration: duration,
                docSize: docSize,
                sourceNodeType: sourceNodeType,
                targetNodeType: targetNodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$41746208cd3b8ef5 = ({ docSize: docSize, newTargetNodeType: newTargetNodeType, oldTargetNodeType: oldTargetNodeType, sourceNodeType: sourceNodeType, type: type, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_TARGET,
            attributes: {
                duration: duration,
                docSize: docSize,
                newTargetNodeType: newTargetNodeType,
                oldTargetNodeType: oldTargetNodeType,
                sourceNodeType: sourceNodeType,
                type: type
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$6f3cdc6bed2f6e2e = ({ nodeType: nodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_FRAGMENT_MARK_NAME,
            attributes: {
                duration: duration,
                nodeType: nodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$c56def702d19a484 = ({ count: count, docSize: docSize, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).GOT_CONNECTIONS,
            attributes: {
                docSize: docSize,
                duration: duration,
                count: count
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};

});


parcelRegister("87lhs", function(module, exports) {

$parcel$export(module.exports, "MACRO_INTERACTION_DESIGN_UPDATES", () => $5e97256736fa056e$export$977ce18f16415288);
// This is a Statsig experiment
const $5e97256736fa056e$export$977ce18f16415288 = 'confluence_frontend_macro_interaction_design';

});


parcelRegister("4xvYZ", function(module, exports) {

$parcel$export(module.exports, "dataSourceResolver", () => $20c78fd742182292$export$5e2881449d7cf240);

var $7T7aA = parcelRequire("7T7aA");

var $4tb0i = parcelRequire("4tb0i");
const $20c78fd742182292$export$5e2881449d7cf240 = (editorActions)=>{
    const state = editorActions?._privateGetEditorView()?.state;
    if (!state) return null;
    const selection = state.selection;
    if (selection instanceof (0, $7T7aA.NodeSelection)) {
        const dataSourceId = selection.node.marks?.find((mark)=>mark.type === state.schema?.marks?.dataConsumer)?.attrs?.sources[0];
        if (!dataSourceId) return null;
        const dataSourceProvider = (0, $4tb0i.getPluginState)(state)?.dataSourceProvider;
        return dataSourceProvider?.get(dataSourceId);
    }
};

});

parcelRegister("eVKuj", function(module, exports) {

$parcel$export(module.exports, "useReference", () => $807577750dac8d47$export$cd3f7ccaa044b456);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gwFzn = parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");

var $gcCrc = parcelRequire("gcCrc");
// Getting all nodes mapping (LocalId => ADNode)
const $807577750dac8d47$var$getAllNodes = (nodes = [])=>{
    let allNodes = new Map();
    nodes.forEach((node)=>{
        const existingFragmentMark = node.marks?.find((m)=>m.type === 'fragment');
        const fragmentLocalId = existingFragmentMark?.attrs?.localId;
        if (fragmentLocalId) allNodes.set(fragmentLocalId, node);
        if (node.attrs?.localId) allNodes.set(node.attrs.localId, node);
        if (node.content) allNodes = new Map([
            ...allNodes,
            ...$807577750dac8d47$var$getAllNodes(node.content)
        ]);
    });
    return allNodes;
};
const $807577750dac8d47$var$memoGetAllNodes = (0, $csnse.default)((adf)=>$807577750dac8d47$var$getAllNodes(adf.content));
const $807577750dac8d47$export$cd3f7ccaa044b456 = ({ adf: adf, extensionParams: extensionParams, dataSourceProvider: dataSourceProvider })=>{
    const allADFNodes = $807577750dac8d47$var$memoGetAllNodes(adf);
    const activeNodeFromADF = allADFNodes.get(extensionParams.localId);
    // At the moment we support only one data consumer
    const dataSourceId = activeNodeFromADF?.marks?.find((mark)=>mark.type === 'dataConsumer')?.attrs?.sources?.[0];
    const [reference, setReference] = (0, $gwFzn.useState)(()=>{
        const dataSourceNode = allADFNodes.get(dataSourceId);
        // At the momment only table nodes as a source are supported
        if (dataSourceNode?.type === 'table') return {
            [(0, $gcCrc.ADFReferenceTypes).TABLE]: dataSourceNode
        };
    });
    (0, $gwFzn.useEffect)(()=>{
        if (!dataSourceId) return;
        dataSourceProvider?.subscribe(dataSourceId, setReference);
        return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
    }, [
        dataSourceProvider,
        dataSourceId
    ]);
    return {
        references: reference ? [
            reference
        ] : []
    };
};

});


parcelRegister("brpfO", function(module, exports) {

$parcel$export(module.exports, "evalLegacyConnectInlineScripts", () => evalLegacyConnectInlineScripts);

var $cpjd2 = parcelRequire("cpjd2");

var $9wGTI = parcelRequire("9wGTI");
function evalLegacyConnectInlineScripts(container) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    return new Promise((resolve)=>{
        const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
        const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
        const allScripts = connectScripts.concat(macroScripts);
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            allScripts.forEach((elementScript)=>{
                if ((0, $9wGTI.fg)('confluence_connect_indirect_eval')) {
                    /**
							 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
							 *
							 * This means that the eval function will have access to the variables and functions
							 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
							 *
							 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
							 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
							 *
							 * We can do this using "indirect" eval, see the MDN docs for more info:
							 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
							 *
							 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
							 * and the scripts will be able to access the global require.
							 */ const evalInGlobalScope = eval;
                    evalInGlobalScope(elementScript.innerHTML);
                } else eval(elementScript.innerHTML);
            });
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}

});

parcelRegister("989nU", function(module, exports) {

$parcel$export(module.exports, "FabricLegacyMacrosServerRenderer", () => $fc5bf07eec92d197$export$4f1d7d3b9a74b4f8);
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $dh538 = parcelRequire("dh538");

var $kksmx = parcelRequire("kksmx");

var $8pcS0 = parcelRequire("8pcS0");

var $6mEZ3 = parcelRequire("6mEZ3");

var $4JC0x = parcelRequire("4JC0x");

var $l6Xaz = parcelRequire("l6Xaz");

var $bQm3c = parcelRequire("bQm3c");

var $9tVje = parcelRequire("9tVje");

var $6AplS = parcelRequire("6AplS");

var $iaRmR = parcelRequire("iaRmR");

var $KcDWk = parcelRequire("KcDWk");

var $3o0Dr = parcelRequire("3o0Dr");

var $lqWPF = parcelRequire("lqWPF");

var $ji0Re = parcelRequire("ji0Re");

var $ebUME = parcelRequire("ebUME");
const $fc5bf07eec92d197$export$4f1d7d3b9a74b4f8 = ({ macroRenderedOutput: macroRenderedOutput, macroDefaultProps: macroDefaultProps, containerRef: containerRef, macroOutput: rawMacroOutput, reuseSSRedElement: reuseSSRedElement })=>{
    // NOTE: `featureFlags` object here is prop-drilled down through layers
    // of legacy code so the usage of deprecated attribute is retained here.
    const { featureFlags: featureFlags, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const macroOutput = rawMacroOutput;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { node: node, contentId: contentId, mode: mode, extensionKey: extensionKey } = macroDefaultProps;
    const keys = Object.keys(node);
    keys.forEach((key)=>{
        if (node[key] === undefined || node[key] === null) delete node[key];
    });
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const isMissingMacroParameters = node.parameters?.macroParams?.isMissingRequiredParameters?.value;
    (0, $gwFzn.useEffect)(()=>{
        if (macroOutput) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro.with.macroOutput',
                source: 'FabricLegacyMacrosServerRenderer',
                attributes: {
                    extensionKey: extensionKey,
                    contentId: contentId
                }
            }
        }).fire();
    }, [
        macroOutput,
        createAnalyticsEvent,
        extensionKey,
        contentId
    ]);
    const macroData = (0, $ji0Re.useMacroContentData)(contentId, node);
    const { ssredElement: ssredElement } = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    const containsMacro = macroRenderedOutput ? macroRenderedOutput.filter((macro)=>macro?.key === macroId) : [];
    let macroHtml = macroData?.macroBodyRenderer?.value || containsMacro[0]?.value?.value || macroOutput;
    if (extensionKey && macroRenderedOutput) // If a Tiny page with Style Macro gets converted to Fabric, need to Scope the CSS
    // Not limiting extensionKey to "style" only because the Style Macro can be nested in other macros
    macroHtml = (0, $6AplS.scopeCSS)(macroHtml, (0, $6AplS.mainContentSelector)).contentWithScopedCSS;
    const dataMacroBody = (0, $lqWPF.useDataMacroBody)(node, contentId);
    /**
	 * "tasks-report-macro" has no actually required macro parameters.
	 * Required parameter was introduced for UI only so the macro doesn't try to render all tasks in the instance when it's inserted in editor,
	 *
	 * Due to a bug https://product-fabric.atlassian.net/browse/COMMENTS-177
	 * it has polluted database with wrong isMissingMacroParameters and it prevents SSRing of this particular (and popular) macro.
	 * This check should be removed when we fix the property editor and clean up the DB.
	 */ const isActuallyMissingMacroParameters = isMissingMacroParameters && extensionKey !== 'tasks-report-macro';
    //To match the placeholder from SPA
    if (isMissingMacroParameters && extensionKey === 'tasks-report-macro' && !node.parameters?.macroParams?.pages && !node.parameters?.macroParams?.spaces) {
        const macro = {
            title: 'Task report',
            macroName: extensionKey,
            icon: {
                height: 80,
                location: '/download/resources/com.atlassian.confluence.plugins.confluence-inline-tasks/tasks-report-image-resources/task-report.png',
                relative: true,
                width: 80
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9tVje.ExtensionPlaceholder), {
            isEditor: false,
            macro: macro,
            description: (0, $9tVje.editToSetupMessage)
        });
    }
    /**
	 *
	 * skip check if macroOutput exists, as it contains all the html
	 * required to render the macro
	 */ if (!macroOutput && isActuallyMissingMacroParameters) return null;
    const preloadingDataPresent = macroData && !dataMacroBody.missing || macroData?.macroBodyStorageFormat;
    // If there's no data and no macro data from preloading to render - resort to standard macro preloading
    if (!macroOutput && containsMacro.length === 0 && !preloadingDataPresent) {
        (0, $4JC0x.markMissingMacroData)(macroId, extensionKey);
        // This logic is applicable to the cases when there's no server output for given macro
        // and therefore macro data loading is deferred till client code takes over. The idea is
        // when macro data is unavailable we attempt preloading it through the query preloader.
        //
        // NOTE: there's a lot of logic around what query to use (see LegacyMacroRendererQuery)
        // and the fact that we may want to THROTTLE macro loading to not overwhelm the backend.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3o0Dr.FabricLegacyMacrosServerLoader), macroDefaultProps);
    }
    if (!macroHtml) return null;
    const css = macroData?.macroBodyRenderer?.webResourceDependencies?.tags?.css || (0, $dh538.fg)('cc_fix_macro_resource_ssr') && macroData?.macroBodyRenderer?.webResource?.tags?.css || containsMacro[0]?.value?.webresource?.tags?.css;
    const js = macroData?.macroBodyRenderer?.webResourceDependencies?.tags?.js || (0, $dh538.fg)('cc_fix_macro_resource_ssr') && macroData?.macroBodyRenderer?.webResource?.tags?.js || containsMacro[0]?.value?.webresource?.tags?.js;
    const adf = (0, $6mEZ3.extensionToADF)(macroDefaultProps.node);
    const isInline = adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE);
    const macroDataProps = {
        'data-fabric-macro': macroId,
        'data-macro-body': macroData?.macroBodyStorageFormat?.value || dataMacroBody.value,
        'data-macro-parameters': (0, $6mEZ3.getParametersString)(node),
        'data-skate-created': undefined
    };
    const nodeProps = {
        // ref will be passed in only for SPA in order to load default WRM modules
        ref: containerRef || null
    };
    const macroRepresentation = macroData?.macroBodyRenderer?.representation || containsMacro[0]?.value?.representation || 'view';
    // In case of ADF format there might be nested macro(s)
    // so we have to pass extensionHandlers to dispatch them
    const extensionHandlers = macroRepresentation === 'atlas_doc_format' ? (0, $ebUME.getSsrExtensionHandlers)({
        adf: macroHtml,
        contentId: contentId,
        userId: userId,
        cloudId: cloudId
    }) : undefined;
    const mediaToken = macroData?.macroBodyRenderer?.mediaToken?.token;
    const elementProps = {
        adf: adf,
        isInline: isInline,
        contentId: contentId,
        mode: mode,
        extensionKey: extensionKey,
        macroRepresentation: macroRepresentation,
        macroDataProps: macroDataProps,
        macroRenderedOutput: macroHtml,
        featureFlags: featureFlags,
        nodeProps: nodeProps,
        mediaToken: mediaToken,
        extensionHandlers: extensionHandlers,
        ssredElement: ssredElement,
        delayIframe: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, css && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        key: "css-container",
        "data-testid": "macro_css",
        dangerouslySetInnerHTML: {
            __html: (0, $l6Xaz.addSSRInlineStyleAttr)(css)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iaRmR.LegacyMacroStyledElement), elementProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kksmx.ExtensionSSRMark), {
        macroId: macroId,
        renderType: (0, $kksmx.getRenderType)(macroOutput, macroData)
    }), js && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "macro_js",
        dangerouslySetInnerHTML: {
            __html: `${(0, $l6Xaz.deferScript)(js)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }));
};

});
parcelRegister("kksmx", function(module, exports) {

$parcel$export(module.exports, "getRenderType", () => $e82f7a932bbd9bed$export$583da28e18e772e3);
$parcel$export(module.exports, "getExtensionSSRMark", () => $e82f7a932bbd9bed$export$90da570939dfebac);
$parcel$export(module.exports, "ExtensionSSRMark", () => $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c);
const $e82f7a932bbd9bed$export$66373c7c22b9de3c = '__LEGACY_MACRO_SSRED__';
const $e82f7a932bbd9bed$export$583da28e18e772e3 = (macroOutput, macroData)=>{
    if (macroOutput) return 'ssr-new';
    else if (macroData) return 'ssr-exp';
    return 'ssr-legacy';
};
const $e82f7a932bbd9bed$export$90da570939dfebac = (macroId)=>window[$e82f7a932bbd9bed$export$66373c7c22b9de3c]?.[macroId];
const $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c = ({ macroId: macroId, renderType: renderType })=>{
    return null;
};

});

parcelRegister("4JC0x", function(module, exports) {

$parcel$export(module.exports, "macrosPreloadPerformed", () => $98c2a7811aa5a89d$export$1441f92d09a5c3ee);
$parcel$export(module.exports, "getPreloadFailedMacros", () => $98c2a7811aa5a89d$export$622ff65a4d6eaaaf);
$parcel$export(module.exports, "getPreloadFailures", () => $98c2a7811aa5a89d$export$3288a79f0c713f52);
$parcel$export(module.exports, "getGeneralFailures", () => $98c2a7811aa5a89d$export$34734b475a3fd7b9);
$parcel$export(module.exports, "markMissingMacroData", () => $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd);

var $csnse = parcelRequire("csnse");
const $98c2a7811aa5a89d$export$fe853ff85807a350 = new Map();
let $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
const $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState = (0, $csnse.default)(()=>{
    const rootQueryList = window?.__APOLLO_STATE__?.ROOT_QUERY || {};
    return Object.keys(rootQueryList).filter((query)=>query.startsWith('macroBodyRenderer'));
});
function $98c2a7811aa5a89d$var$isMacroPreloaded(macroId) {
    const preloadedMacros = $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState();
    return preloadedMacros.some((preloaded)=>preloaded.includes(macroId));
}
const $98c2a7811aa5a89d$export$1441f92d09a5c3ee = ()=>window.__SSR_RENDERED__ && !!window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
function $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl() {
    const cacheMismatches = $98c2a7811aa5a89d$var$getPreloadCacheMismatches();
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (cacheMismatches.length == 0 && (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0)) return;
    const failedMacros = {};
    function addFailed(reason, macroId, extensionKey) {
        failedMacros[macroId] = {
            reason: reason,
            extensionKey: extensionKey
        };
    }
    Object.entries(reportedFails).forEach(([keyAndId, reason])=>{
        if (keyAndId === 'general') return;
        const [extensionKey, macroId] = keyAndId.split(':');
        if (reason === 'timeout') {
            if ($98c2a7811aa5a89d$var$isMacroPreloaded(macroId)) addFailed('falseTimeouts', macroId, extensionKey);
            else addFailed('trueTimeouts', macroId, extensionKey);
        } else addFailed(reason, macroId, extensionKey);
    });
    cacheMismatches.forEach(([macroId, extensionKey])=>addFailed('cacheMismatch', macroId, extensionKey));
    return failedMacros;
}
function $98c2a7811aa5a89d$export$622ff65a4d6eaaaf() {
    if (!$98c2a7811aa5a89d$export$576fafc5561e06f5) $98c2a7811aa5a89d$export$576fafc5561e06f5 = {
        value: $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl()
    };
    return $98c2a7811aa5a89d$export$576fafc5561e06f5.value;
}
function $98c2a7811aa5a89d$export$de5406af81980582() {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
}
function $98c2a7811aa5a89d$export$3288a79f0c713f52(macroId) {
    const failedMacros = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf();
    return failedMacros?.[macroId]?.reason;
}
function $98c2a7811aa5a89d$export$34734b475a3fd7b9() {
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0) return;
    return reportedFails?.['general'];
}
function $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd(macroId, extensionKey) {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
    $98c2a7811aa5a89d$export$fe853ff85807a350.set(macroId, extensionKey || '');
}
function $98c2a7811aa5a89d$var$getPreloadCacheMismatches() {
    return [
        ...$98c2a7811aa5a89d$export$fe853ff85807a350
    ].filter(([macroId])=>$98c2a7811aa5a89d$var$isMacroPreloaded(macroId));
}

});

parcelRegister("9tVje", function(module, exports) {

$parcel$export(module.exports, "getIconComponent", () => $21c776825c39ac3f$export$860ffd8664f09722);
$parcel$export(module.exports, "AnchorMacroPlaceholder", () => $21c776825c39ac3f$export$19993a849e770b01);
$parcel$export(module.exports, "ExtensionPlaceholder", () => $21c776825c39ac3f$export$9aa94f8845c5044a);
$parcel$export(module.exports, "editToSetupMessage", () => $21c776825c39ac3f$export$58aff0a49290c040);
$parcel$export(module.exports, "getMissingConfigPlaceholderComponent", () => $21c776825c39ac3f$export$267f67275f4dde5c);
$parcel$export(module.exports, "getNonRenderablePlaceholderComponent", () => $21c776825c39ac3f$export$cefccc00343a8c80);
/* MacroComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $5dK2X = parcelRequire("5dK2X");

var $7hXDW = parcelRequire("7hXDW");

var $inPa6 = parcelRequire("inPa6");

var $dZMVn = parcelRequire("dZMVn");

var $b1Jpy = parcelRequire("b1Jpy");

var $fwDOR = parcelRequire("fwDOR");

var $9VJDA = parcelRequire("9VJDA");

var $9wGTI = parcelRequire("9wGTI");

var $7khND = parcelRequire("7khND");

var $X5KYY = parcelRequire("X5KYY");
const $21c776825c39ac3f$var$i18n = (0, $2nPZH.defineMessages)({
    invalidAnchorMacroLabel: {
        id: "fabric-extension-lib.anchor.placeholder.icon-label",
        defaultMessage: "Invalid anchor link"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$ItemBody = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$descriptionStyledSelector = 'description-styled-selector';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$Description = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8dcr7 _syaz1gjq _19pk1b66",
            __cmplp.className
        ])
    });
});
$21c776825c39ac3f$var$Description.defaultProps = {
    'data-styled-selector': $21c776825c39ac3f$var$descriptionStyledSelector
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$Item = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditor: isEditor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7vuon _2rko1l7b _1e0c1txw _4cvr1h6o",
            __cmplp.isEditor ? "_1yt41ejb" : "_1yt4ze3t",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$InlineItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q711bn _1yt41m6u _2rko1l7b _11c81ixg _1e0c116y _4cvr1h6o _1xw2u2gc",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$ItemIcon = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $iAWao.default)(__cmplp.width, "px"),
            "--_8jvb0j": (0, $iAWao.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _19itmuej _2rko1l7b _11q7vuon _1bsb1rkg _4t3i1474 _vchhusvi _1e0c1txw _1bah1h6o _4cvr1h6o _1qwg1rkg _1iia1474",
            __cmplp.width > 32 ? "_2hwxpxbi" : "_2hwx1b66",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$anchorMacroPlaceholderStyles = null;
const $21c776825c39ac3f$export$860ffd8664f09722 = (macro, testId)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        testId: testId
    });
};
const $21c776825c39ac3f$export$19993a849e770b01 = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _2rkoiti9 _1e0c1txw _1bah1h6o _4cvr1h6o _bfhkm7j4 _1bsb1tcg _4t3igktf _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZMVn))), {
        label: intl.formatMessage($21c776825c39ac3f$var$i18n.invalidAnchorMacroLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    }));
};
const $21c776825c39ac3f$var$InlineExtensionPlaceholder = ({ macro: macro, description: description })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "inline-extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$InlineItem, {
        "data-testid": "inline-extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$ItemIcon, {
        width: 16,
        height: 16
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$ItemBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        as: "p"
    }, macro.title, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$Description, null, description)))));
};
const $21c776825c39ac3f$export$9aa94f8845c5044a = ({ macro: macro, description: description, isEditor: isEditor })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$Item, {
        isEditor: isEditor,
        "data-testid": "extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$ItemIcon, {
        width: 40,
        height: 40
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$ItemBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "small"
    }, macro.title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$Description, null, description))));
};
const $21c776825c39ac3f$export$58aff0a49290c040 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
    id: "confluence-fabric-editor.extension.placeholder.missing-config",
    defaultMessage: "Edit to setup"
});
const $21c776825c39ac3f$var$PlaceholderWithAnalytics = ({ macro: macro, extension: extension, isEditor: isEditor })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useMemo)(()=>{
        if (createAnalyticsEvent) {
            const { extensionKey: extensionKey, extensionType: extensionType, parameters: parameters } = extension;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'macro',
                    actionSubjectId: 'placeholder',
                    source: isEditor ? 'editor' : 'renderer',
                    attributes: {
                        extensionKey: extensionKey,
                        extensionType: extensionType,
                        isMissingRequiredParameters: !!parameters?.macroParams?.isMissingRequiredParameters
                    }
                }
            }).fire();
        } // NOTE: `extension` node changes on resize so can't use it as dependency
    // A deep check can be done using `extension.macroMetadata.macroId` though not needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        macro,
        isEditor
    ]);
    if (macro.macroName === 'anchor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$export$19993a849e770b01, null);
    if ((0, $X5KYY.getExtensionBodyType)(macro) === 'inlineExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$InlineExtensionPlaceholder, {
        macro: macro,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, "(", $21c776825c39ac3f$export$58aff0a49290c040, ")")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$export$9aa94f8845c5044a, {
        isEditor: isEditor,
        macro: macro,
        description: $21c776825c39ac3f$export$58aff0a49290c040
    });
};
const $21c776825c39ac3f$export$267f67275f4dde5c = (macro, extension, isEditor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$PlaceholderWithAnalytics, {
        macro: macro,
        extension: extension,
        isEditor: isEditor
    }));
const $21c776825c39ac3f$export$cefccc00343a8c80 = (macro, type, isLivePage)=>{
    if (type === 'inlineExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$var$InlineExtensionPlaceholder, {
        macro: macro
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21c776825c39ac3f$export$9aa94f8845c5044a, {
        isEditor: true,
        macro: macro,
        description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "confluence-fabric-editor.extension.placeholder.can-not-render-in-live-page-editor",
            defaultMessage: "The results of this element aren\u2019t visible when editing a live doc. Convert this doc to a page and publish it via the <menuIcon></menuIcon> menu to display it fully.",
            values: {
                menuIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "Icon for publish menu"
                    })
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "confluence-fabric-editor.extension.placeholder.can-not-render-in-editor",
            defaultMessage: "The results of this element aren\u2019t visible when editing. Preview the page or publish it to see how it will look."
        })
    }));
};

});
parcelRegister("7khND", function(module, exports) {

$parcel$export(module.exports, "MacroIcon", () => $efa2272178ef68ba$export$ead5ed1f51ad51dc);
$parcel$export(module.exports, "BulletSVG", () => $efa2272178ef68ba$export$6185d2f1146c633c);
$parcel$export(module.exports, "CircleSVG", () => $efa2272178ef68ba$export$3053c37f1e2867f2);
$parcel$export(module.exports, "DiscSVG", () => $efa2272178ef68ba$export$ae8f25be6d60cbf3);
$parcel$export(module.exports, "NumberedSVG", () => $efa2272178ef68ba$export$c4da8a84cd30471c);
$parcel$export(module.exports, "SquareSVG", () => $efa2272178ef68ba$export$d67733307fd2aff1);
$parcel$export(module.exports, "BraceSVG", () => $efa2272178ef68ba$export$2be9fd0fc1da44cd);
$parcel$export(module.exports, "BracketSVG", () => $efa2272178ef68ba$export$4298d94e565d5e99);
$parcel$export(module.exports, "PipeSVG", () => $efa2272178ef68ba$export$2a8d2000f2d39e17);
$parcel$export(module.exports, "DropdownIcon", () => $efa2272178ef68ba$export$fae4d9254a21fe54);

var $gwFzn = parcelRequire("gwFzn");

var $eO4W8 = parcelRequire("eO4W8");

var $6bJyJ = parcelRequire("6bJyJ");

var $jdPfT = parcelRequire("jdPfT");

var $kevJM = parcelRequire("kevJM");

var $av0Vd = parcelRequire("av0Vd");

var $4wwVl = parcelRequire("4wwVl");

var $6767u = parcelRequire("6767u");

var $1bY7o = parcelRequire("1bY7o");

var $bA5bk = parcelRequire("bA5bk");

var $3cXSJ = parcelRequire("3cXSJ");

var $c8Vax = parcelRequire("c8Vax");

var $cb6fO = parcelRequire("cb6fO");

var $2E7zk = parcelRequire("2E7zk");
const $efa2272178ef68ba$var$sizeMap = {
    small: 24,
    medium: 32,
    large: 48
};
const $efa2272178ef68ba$var$getSizeInPx = (size)=>$efa2272178ef68ba$var$sizeMap[size];
function $efa2272178ef68ba$export$ead5ed1f51ad51dc({ macro: macro, size: size = 'small', testId: testId }) {
    const { icon: icon, macroName: macroName } = macro;
    switch(macroName){
        case 'children':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bA5bk.ChildMacroIcon), {
                label: ""
            });
        case 'excerpt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c8Vax.ExcerptMacroIcon), {
                label: ""
            });
        case 'excerpt-include':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3cXSJ.ExcerptIncludeMacroIcon), {
                label: ""
            });
        case 'recently-updated':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                color: "var(--ds-icon, #44546F)",
                label: "",
                spacing: "spacious",
                testId: "recently-updated-macro-icon"
            });
        case 'contentbylabel':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
                color: "var(--ds-icon, #44546F)",
                label: "",
                spacing: "spacious",
                testId: "contentbylabel-macro-icon"
            });
        case 'profile-picture':
            if ((0, $2E7zk.isProfileMacrosExperimentEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
                label: "",
                spacing: "spacious",
                testId: "profile-picture-icon"
            });
            break;
        case 'profile':
            if ((0, $2E7zk.isProfileMacrosExperimentEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                label: "",
                spacing: "spacious",
                testId: "profile-icon"
            });
            break;
        case 'toc':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: "",
                testId: "toc-icon",
                spacing: "spacious"
            });
        case 'jira':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eO4W8.JiraIcon), {
                label: "",
                size: "medium",
                "data-testid": testId
            });
        case 'anchor':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: "",
                spacing: "spacious",
                testId: "anchor-link-icon"
            });
    }
    if (!icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        spacing: "spacious",
        testId: "default-icon"
    });
    // connect macros will have absolute urls while others
    // will have relative
    const src = (0, $cb6fO.getContextAwareFullPath)(icon.location, true);
    const sizeInPx = $efa2272178ef68ba$var$getSizeInPx(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
        src: src,
        width: sizeInPx,
        height: sizeInPx,
        alt: "",
        "data-testid": testId
    });
}
const $efa2272178ef68ba$export$6185d2f1146c633c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "4",
        fill: "var(--ds-icon, #44546F)"
    }));
const $efa2272178ef68ba$export$3053c37f1e2867f2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "3.5",
        stroke: "var(--ds-icon, #44546F)"
    }));
const $efa2272178ef68ba$export$ae8f25be6d60cbf3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M9 13.9V16C9 16.5523 9.44772 17 10 17H15C15.5523 17 16 16.5523 16 16V11C16 10.4477 15.5523 10 15 10H12.9C12.5023 11.9591 10.9591 13.5023 9 13.9Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M4 8.99997C4 11.2091 5.79086 13 8 13C10.2091 13 12 11.2091 12 8.99997C12 7.09292 10.6654 5.49757 8.87929 5.09692C8.80495 5.42907 8.69755 5.74873 8.56074 6.05229C9.9496 6.31488 11 7.53476 11 8.99997C11 10.6568 9.65685 12 8 12C6.34315 12 5 10.6568 5 8.99997C5 8.96639 5.00055 8.93293 5.00165 8.89962C4.67803 8.96542 4.34305 8.99997 4 8.99997Z",
        fill: "var(--ds-icon, #44546F)"
    }));
const $efa2272178ef68ba$export$c4da8a84cd30471c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "10",
        height: "11",
        viewBox: "0 0 10 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M3.41016 10H4.64062V0.135742H3.41699L0.791992 2.02246V3.32129L3.30078 1.50293H3.41016V10ZM8.22266 10.0684C8.71484 10.0684 9.11133 9.66504 9.11133 9.17969C9.11133 8.6875 8.71484 8.29102 8.22266 8.29102C7.7373 8.29102 7.33398 8.6875 7.33398 9.17969C7.33398 9.66504 7.7373 10.0684 8.22266 10.0684Z",
        fill: "var(--ds-icon, #44546F)"
    }));
const $efa2272178ef68ba$export$d67733307fd2aff1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        width: "8",
        height: "8",
        rx: "1",
        fill: "var(--ds-icon, #44546F)"
    }));
const $efa2272178ef68ba$export$2be9fd0fc1da44cd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M1.80648 7.77764V9.55542C1.80648 10.2037 2.06826 10.8254 2.53401 11.2837C2.99977 11.7423 3.63154 11.9997 4.2904 11.9997H4.96785V10.6665H4.2904C3.99098 10.6665 3.70384 10.5493 3.49198 10.341C3.28029 10.1327 3.16137 9.85009 3.16137 9.55541V7.77764C3.16011 7.10412 2.87676 6.46084 2.37775 5.99986C2.87674 5.53888 3.16008 4.8956 3.16137 4.22209V2.44431C3.16137 2.14964 3.28029 1.86706 3.49198 1.65873C3.70383 1.45041 3.99097 1.33322 4.2904 1.33322H4.96785V0H4.2904C3.63154 0 2.99977 0.257466 2.53401 0.715975C2.06825 1.17434 1.80648 1.79607 1.80648 2.44431V4.22208C1.80648 4.51675 1.68756 4.79933 1.47587 5.00782C1.26402 5.21615 0.976884 5.33318 0.677452 5.33318H0V6.66656H0.677452C0.976876 6.66656 1.26402 6.78359 1.47587 6.99191C1.68756 7.2004 1.80648 7.48297 1.80648 7.77764Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M12.1936 4.2222V2.44443C12.1936 1.79619 11.9318 1.17446 11.4661 0.716097C11.0003 0.257576 10.3685 0.00012207 9.70968 0.00012207H9.03223V1.3335H9.70968V1.33335C10.0091 1.33335 10.2962 1.45053 10.5081 1.65886C10.7198 1.86719 10.8387 2.14976 10.8387 2.44444V4.22221C10.84 4.89573 11.1233 5.53901 11.6223 5.99999C11.1233 6.46097 10.84 7.10425 10.8387 7.77776V9.55554C10.8387 9.85021 10.7198 10.1328 10.5081 10.3411C10.2962 10.5494 10.0091 10.6666 9.70968 10.6666H9.03223V12H9.70968V11.9999C10.3685 11.9999 11.0003 11.7424 11.4661 11.2839C11.9318 10.8255 12.1936 10.2038 12.1936 9.55555V7.77777C12.1936 7.4831 12.3125 7.20052 12.5242 6.99204C12.7361 6.78371 13.0232 6.66668 13.3226 6.66668H14.0001V5.3333H13.3226C13.0232 5.3333 12.7361 5.21627 12.5242 5.00794C12.3125 4.79946 12.1936 4.51688 12.1936 4.2222Z",
        fill: "var(--ds-icon, #44546F)"
    }));
const $efa2272178ef68ba$export$4298d94e565d5e99 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "12",
        height: "14",
        viewBox: "0 0 12 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M4 1.5H1V12.5H4",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "1.25"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M8 12.5H11L11 1.5H8",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "1.25"
    }));
const $efa2272178ef68ba$export$2a8d2000f2d39e17 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "2",
        height: "12",
        viewBox: "0 0 2 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("line", {
        x1: "0.625",
        y1: "2.73196e-08",
        x2: "0.624999",
        y2: "12",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "1.25"
    }));
function $efa2272178ef68ba$export$fae4d9254a21fe54({ icon: icon, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 16,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: 16,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        "data-testId": testId
    }, icon());
}

});
parcelRegister("bA5bk", function(module, exports) {

$parcel$export(module.exports, "ChildMacroIcon", () => $af996b54de444f03$export$e64a53b8ea246fd3);

var $gwFzn = parcelRequire("gwFzn");

var $d6Fdl = parcelRequire("d6Fdl");
const $af996b54de444f03$export$e64a53b8ea246fd3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d6Fdl.default), {
        size: "large",
        secondaryColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "child-macro-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "6",
        y: "7",
        width: "23",
        height: "18",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "9",
        y: "10",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "13",
        y: "10",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "9",
        y: "15",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "13",
        y: "15",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "9",
        y: "20",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "13",
        y: "20",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "6",
        y: "2",
        width: "23",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "6",
        y: "28",
        width: "23",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M3 3.5L2 2.5",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M3 3.5L4 2.5",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M3.5 29L2.5 30",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M3.5 29L2.5 28",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)",
        strokeLinecap: "round"
    })));

});

parcelRegister("3cXSJ", function(module, exports) {

$parcel$export(module.exports, "ExcerptIncludeMacroIcon", () => $2d33a6ba968a8025$export$23d9ef6647bbd44d);

var $gwFzn = parcelRequire("gwFzn");

var $d6Fdl = parcelRequire("d6Fdl");
const $2d33a6ba968a8025$export$23d9ef6647bbd44d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d6Fdl.default), {
        size: "large",
        secondaryColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 34 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "excerpt-include-macro-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "12",
        y: "8",
        width: "22",
        height: "16",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "15",
        y: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "15",
        y: "11",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "15",
        y: "4",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "15",
        y: "30",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "15",
        y: "26",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "15",
        y: "19",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.8965 12.8966C5.85003 12.943 5.81316 12.9981 5.788 13.0588C5.76285 13.1195 5.7499 13.1845 5.7499 13.2501C5.7499 13.3158 5.76285 13.3808 5.788 13.4415C5.81316 13.5021 5.85003 13.5572 5.8965 13.6036L7.793 15.5001H3C2.86739 15.5001 2.74021 15.5528 2.64645 15.6466C2.55268 15.7404 2.5 15.8675 2.5 16.0001C2.5 16.1328 2.55268 16.2599 2.64645 16.3537C2.74021 16.4475 2.86739 16.5001 3 16.5001H7.793L5.8965 18.3966C5.85003 18.443 5.81316 18.4981 5.788 18.5588C5.76285 18.6195 5.7499 18.6845 5.7499 18.7501C5.7499 18.8158 5.76285 18.8808 5.788 18.9415C5.81316 19.0021 5.85003 19.0572 5.8965 19.1036C6.0915 19.2986 6.4085 19.2986 6.604 19.1036L9.3535 16.3536C9.44405 16.2634 9.49649 16.1419 9.5 16.0141V15.9856C9.49642 15.858 9.44398 15.7367 9.3535 15.6466L6.604 12.8966C6.55756 12.8502 6.50242 12.8133 6.44172 12.7881C6.38102 12.763 6.31596 12.75 6.25025 12.75C6.18454 12.75 6.11948 12.763 6.05878 12.7881C5.99808 12.8133 5.94294 12.8502 5.8965 12.8966V12.8966Z",
        fill: "var(--ds-icon, #44546F)"
    })));

});

parcelRegister("c8Vax", function(module, exports) {

$parcel$export(module.exports, "ExcerptMacroIcon", () => $058eb04dbe2ca1ce$export$49f2115fcc129894);

var $gwFzn = parcelRequire("gwFzn");

var $d6Fdl = parcelRequire("d6Fdl");
const $058eb04dbe2ca1ce$export$49f2115fcc129894 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d6Fdl.default), {
        size: "large",
        secondaryColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "excerpt-macro-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "5",
        y: "8",
        width: "22",
        height: "16",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "8",
        y: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "8",
        y: "11",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "8",
        y: "4",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "8",
        y: "30",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "8",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "8",
        y: "26",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "8",
        y: "19",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #0C66E4)"
    })));

});

parcelRegister("2E7zk", function(module, exports) {

$parcel$export(module.exports, "isPageId", () => $7dade95d99fee536$export$a1337ae19b5dbc53);
$parcel$export(module.exports, "getSelectedBodiedExtensionNode", () => $7dade95d99fee536$export$ab1c71053e82e441);
$parcel$export(module.exports, "isValueSet", () => $7dade95d99fee536$export$aa7156f87802b87e);
$parcel$export(module.exports, "createQuickInsertModule", () => $7dade95d99fee536$export$80b5cdf6b2ae3720);
$parcel$export(module.exports, "getConnectAppKey", () => $7dade95d99fee536$export$b57d0f2bae8a9afe);
$parcel$export(module.exports, "insertMacroPlaceholder", () => $7dade95d99fee536$export$7ea0c9b6e4a8ed9f);
$parcel$export(module.exports, "getJiraHostingOption", () => $7dade95d99fee536$export$e907759e00918f39);
$parcel$export(module.exports, "isProfileMacrosExperimentEnabled", () => $7dade95d99fee536$export$7968ac5aa248cce9);
$parcel$export(module.exports, "filterOutHiddenMacros", () => $7dade95d99fee536$export$30d8e5826b733890);
/* eslint-disable check-file/filename-blocklist */ 
var $6mKj3 = parcelRequire("6mKj3");

var $f7B1p = parcelRequire("f7B1p");

var $4VJDS = parcelRequire("4VJDS");

var $fgbpl = parcelRequire("fgbpl");

var $8pcS0 = parcelRequire("8pcS0");

var $X5KYY = parcelRequire("X5KYY");

var $j1x6W = parcelRequire("j1x6W");

var $9tVje = parcelRequire("9tVje");
const $7dade95d99fee536$var$pageIdRegex = /^[0-9]+$/;
const $7dade95d99fee536$export$a1337ae19b5dbc53 = (id)=>$7dade95d99fee536$var$pageIdRegex.test(id);
const $7dade95d99fee536$export$ab1c71053e82e441 = (editorActions)=>{
    const editorView = editorActions?._privateGetEditorView();
    if (editorView) {
        let maybeNode = editorView.state.selection.node;
        if (!maybeNode || !(0, $fgbpl.isBodiedExtension)(maybeNode.type.name)) {
            const { $head: $head } = editorView.state.selection;
            // If current selection isn't bodied extension traverse upward
            for(let i = $head.depth; i > 0; i--){
                const node = $head.node(i);
                if ((0, $fgbpl.isBodiedExtension)(node.type.name)) maybeNode = node;
            }
        }
        return maybeNode?.toJSON();
    }
};
const $7dade95d99fee536$export$aa7156f87802b87e = (value)=>(value === 0 || value === false || !!value) && (!Array.isArray(value) || value.length > 0);
const $7dade95d99fee536$export$80b5cdf6b2ae3720 = (macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled)=>{
    // Hidden macros don't appear in the slash menu
    // but still need to be defined in a manifest so old pages can show them
    if (macro.hidden) return [];
    const macroName = (0, $X5KYY.safeGetMacroName)(macro);
    try {
        const action = (0, $j1x6W.getQuickInsertAction)(macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled);
        return [
            {
                key: macroName,
                title: macro.title,
                description: macro.description,
                keywords: [
                    macro.macroName,
                    ...macro.aliases
                ],
                categories: macro.categories,
                icon: async ()=>()=>(0, $9tVje.getIconComponent)(macro),
                featured: pageContext.features.elementBrowser && (0, $8pcS0.allowedMacrosForInsertMenu).includes(macroName),
                action: action
            }
        ];
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return [];
    }
};
const $7dade95d99fee536$export$b57d0f2bae8a9afe = (macroKey)=>{
    if (!macroKey || !macroKey.startsWith('com.atlassian.plugins.atlassian-connect-plugin')) return '';
    const chunks = macroKey.split('__');
    if (chunks.length !== 3) return '';
    return chunks[1];
};
const $7dade95d99fee536$export$7ea0c9b6e4a8ed9f = (node, placeholderText)=>{
    node.content = [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'placeholder',
                    attrs: {
                        text: placeholderText
                    }
                }
            ]
        }
    ];
};
const $7dade95d99fee536$var$getMatchingAppLinkForViewPage = async (selectedServerId)=>{
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/jiraanywhere/1.0/servers');
        const appLinks = await res.json();
        return appLinks.find((appLink)=>appLink.id === selectedServerId);
    } catch  {}
};
const $7dade95d99fee536$var$isCloudAppLinkFromUrl = (url)=>{
    if (!url) return;
    return url.includes('atlassian.net') || url.includes('jira-dev.com');
};
const $7dade95d99fee536$export$e907759e00918f39 = async (macroName, selectedServerId = '', isViewPage = false)=>{
    if (macroName !== 'jira') return;
    let isCloudAppLink;
    if (isViewPage) {
        const selectedServerObject = await $7dade95d99fee536$var$getMatchingAppLinkForViewPage(selectedServerId);
        isCloudAppLink = $7dade95d99fee536$var$isCloudAppLinkFromUrl(selectedServerObject?.url) || $7dade95d99fee536$var$isCloudAppLinkFromUrl(selectedServerObject?.rpcUrl);
    } else try {
        // module is only available on edit page
        const ApplinksBridge = window.require('confluence/jim/jira/applinks-bridge-for-spa');
        isCloudAppLink = await ApplinksBridge.isCloudAppLinkFromServerId(selectedServerId);
    } catch  {}
    if (isCloudAppLink === undefined) return 'unknown';
    return isCloudAppLink ? 'cloud' : 'server';
};
const $7dade95d99fee536$export$7968ac5aa248cce9 = ()=>(0, $6mKj3.expVal)('confluence_profile_macros_updates', 'isEnabled', false);
const $7dade95d99fee536$export$30d8e5826b733890 = (macros)=>{
    const newMacros = [];
    const macrosToHide = new Set((0, $4VJDS.default).getStringList('confluence_frontend_hide_selected_macros', []));
    for (const macro of macros)if (macrosToHide.has(macro?.macroName)) {
        // Create a copy so we don't mutate the original macro
        const hiddenMacro = {
            ...macro,
            hidden: true
        };
        newMacros.push(hiddenMacro);
    } else newMacros.push(macro);
    return newMacros;
};

});
parcelRegister("X5KYY", function(module, exports) {

$parcel$export(module.exports, "safeGetMacroName", () => $0a65c3689dbc8777$export$36f7c0c22d0fa7f7);
$parcel$export(module.exports, "getExtensionBodyType", () => $0a65c3689dbc8777$export$a508225d9b2c6590);
$parcel$export(module.exports, "buildIconObject", () => $0a65c3689dbc8777$export$4588099541e0954d);
$parcel$export(module.exports, "getVisibleParameters", () => $0a65c3689dbc8777$export$e5e6ffc5fb5056d0);
$parcel$export(module.exports, "isMissingAnyRequiredParameters", () => $0a65c3689dbc8777$export$28f78411e8f58606);
$parcel$export(module.exports, "prepareMacro", () => $0a65c3689dbc8777$export$c311b87e097682ae);
$parcel$export(module.exports, "canRenderInTheEditor", () => $0a65c3689dbc8777$export$40ec622ba9bb94df);
$parcel$export(module.exports, "shouldUseMacroBrowser", () => $0a65c3689dbc8777$export$34e22dfe340bc2f0);
$parcel$export(module.exports, "needsToForceConfig", () => $0a65c3689dbc8777$export$96720d404c402c6d);
$parcel$export(module.exports, "shouldShowPlaceholder", () => $0a65c3689dbc8777$export$b6c9e4779dda4acf);

var $foRF9 = parcelRequire("foRF9");

var $8pcS0 = parcelRequire("8pcS0");

var $9tVje = parcelRequire("9tVje");

var $e7owm = parcelRequire("e7owm");

var $2E7zk = parcelRequire("2E7zk");
const $0a65c3689dbc8777$export$36f7c0c22d0fa7f7 = (macro)=>macro.alternateId || macro.macroName;
const $0a65c3689dbc8777$export$a508225d9b2c6590 = (macro)=>{
    const { bodyType: bodyType, outputType: outputType } = macro.formDetails.body;
    if (bodyType === 'MULTI_BODY_RICH_TEXT') return 0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE;
    //        none  plain   rich
    // block   ext   ext    body
    // inline  in    in     body
    if (bodyType === 'RICH_TEXT') return 0, $8pcS0.BODIED_EXTENSION_TYPE;
    if (outputType === 'INLINE') return 0, $8pcS0.INLINE_EXTENSION_TYPE;
    return 0, $8pcS0.REGULAR_EXTENSION_TYPE;
};
const $0a65c3689dbc8777$export$4588099541e0954d = (macro)=>{
    return {
        '48': ()=>Promise.resolve(()=>(0, $9tVje.getIconComponent)(macro))
    };
};
const $0a65c3689dbc8777$export$e5e6ffc5fb5056d0 = (macro)=>macro.formDetails && (macro.formDetails.parameters || []).filter((parameter)=>!parameter.hidden) || [];
const $0a65c3689dbc8777$var$hasParameter = (paramName, extension, macro)=>{
    if (extension && extension.parameters && extension.parameters.macroParams) {
        const params = (0, $e7owm.transformParams)('transformBefore', macro, {
            ...extension.parameters.macroParams
        });
        if (paramName in params) {
            let value = params[paramName];
            if (typeof value === 'object' && value !== null && value.hasOwnProperty('value')) value = value.value;
            return (0, $2E7zk.isValueSet)(value);
        }
    }
    return false;
};
const $0a65c3689dbc8777$export$28f78411e8f58606 = (macro, extension)=>macro.formDetails.parameters.some((param)=>param.required && param.defaultValue === null && !param.hidden && !$0a65c3689dbc8777$var$hasParameter(param.name, extension, macro));
const $0a65c3689dbc8777$export$c311b87e097682ae = (macroDefinition, contentId, selectedMacro, intl, isLivePagesFeatureEnabled)=>{
    return (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: {
            name: name,
            body: '',
            params: {},
            ...macroDefinition
        },
        contentId: contentId,
        selectedMacro: selectedMacro,
        intl: intl,
        isLivePagesFeatureEnabled: isLivePagesFeatureEnabled
    });
};
const $0a65c3689dbc8777$export$40ec622ba9bb94df = (macro)=>{
    switch(macro.macroName){
        case 'pagetree':
            // pagetree is not spa friendly and will only work sometimes
            return false;
        default:
            return true;
    }
};
const $0a65c3689dbc8777$export$34e22dfe340bc2f0 = (macro, excluded = [])=>{
    // This is to opt-out a macro quickly from the new experience
    // using the list in `next/packages/editor-features/src/featureFlagsUtils.ts`
    if (excluded.includes(macro.macroName)) return true;
    // Plain text macros are not supported yet
    if (macro.formDetails.body.bodyType === 'PLAIN_TEXT') return true;
    return macro.customConfigEditor;
};
const $0a65c3689dbc8777$export$96720d404c402c6d = (macro)=>{
    // Need to force config for Plain text macros
    if (macro.formDetails.body.bodyType === 'PLAIN_TEXT') return true;
    switch(macro.macroName){
        // CFE-2344: despite not having a required parameter, the children macro should open the macro browser
        // so that the user can select a parent page. Without this, on a brand new page, the children display
        // macro renders a loading state, then completely disappears and looks broken.
        case 'children':
        // CONFDEV-62041: tasks report macro also doesn't have a required parameter, but without any parameters
        // it tries to search the entirety of Confluence for tasks and usually times out, so let's ask for parameters anyway.
        case 'tasks-report-macro':
            // Has issues.
            return true;
        default:
            return macro.customConfigEditor;
    }
};
const $0a65c3689dbc8777$export$b6c9e4779dda4acf = (macro, excludedMacros = [], extension, isEditor)=>// NOTE: Since it's not possible to insert macros without required fields using
    // Macro Browser so there's no point of showing placeholder for them. @see ED-12141
    !$0a65c3689dbc8777$export$34e22dfe340bc2f0(macro, excludedMacros) && // Maintaining the anchor's unique(?) status as a non-rendering-in-publish-view macro
    (isEditor || macro.macroName !== 'anchor') && // Missing required parameters
    $0a65c3689dbc8777$export$28f78411e8f58606(macro, extension);

});
parcelRegister("e7owm", function(module, exports) {

$parcel$export(module.exports, "remapCustomFields", () => $763d528574677310$export$5a5c6ccdb287233d);
$parcel$export(module.exports, "transformParams", () => $763d528574677310$export$db6c1732c1c4814c);

var $8pcS0 = parcelRequire("8pcS0");

var $81Qvv = parcelRequire("81Qvv");

var $i1Wqg = parcelRequire("i1Wqg");

var $grShm = parcelRequire("grShm");

var $98p9q = parcelRequire("98p9q");

var $f8ZIi = parcelRequire("f8ZIi");

var $9D7MJ = parcelRequire("9D7MJ");

var $c786U = parcelRequire("c786U");

var $booiN = parcelRequire("booiN");

var $bJ8MA = parcelRequire("bJ8MA");

var $gaGUd = parcelRequire("gaGUd");

var $84b39 = parcelRequire("84b39");

var $9IuHM = parcelRequire("9IuHM");

var $6wLSo = parcelRequire("6wLSo");

var $4PzO1 = parcelRequire("4PzO1");

var $7kVCu = parcelRequire("7kVCu");

var $5NdPE = parcelRequire("5NdPE");
const $763d528574677310$var$makeObject = (xs)=>xs.reduce((obj, x)=>{
        obj[x.name] = x;
        return obj;
    }, {});
const $763d528574677310$export$78a98cfbfc91bcb5 = ()=>({
        attachments: $grShm.attachments,
        'blog-posts': (0, $98p9q.blogPosts),
        calendar: $gaGUd.calendar,
        children: $4PzO1.children,
        contributors: $f8ZIi.contributors,
        'contributors-summary': (0, $f8ZIi.contributors),
        'create-from-template': (0, $6wLSo.createFromTemplate),
        details: $5NdPE.details,
        excerpt: // content properties (page properties) macro
        $7kVCu.excerpt,
        include: $9D7MJ.include,
        pagetree: $bJ8MA.pagetree,
        viewpdf: (0, $c786U.officeConnector),
        viewdoc: (0, $c786U.officeConnector),
        viewxls: (0, $c786U.officeConnector),
        viewppt: (0, $c786U.officeConnector),
        'tasks-report-macro': (0, $booiN.tasksReport),
        anchor: $i1Wqg.anchor,
        'recently-updated': (0, $84b39.recentlyUpdated),
        'recently-updated-dashboard': (0, $9IuHM.recentlyUpdatedDashboard)
    });
const $763d528574677310$export$5a5c6ccdb287233d = async ({ macroName: macroName }, fields, pageContext, intl, params, createAnalyticsEvent, isLivePage, isLivePagesFeatureEnabled)=>{
    const transformFields = $763d528574677310$export$78a98cfbfc91bcb5()[macroName]?.transformFields;
    const alwaysFn = (0, $81Qvv.always)?.transformFields;
    if (macroName === 'create-from-template') return transformFields ? transformFields({
        fields: fields,
        pageContext: pageContext,
        intl: intl,
        params: params,
        createAnalyticsEvent: createAnalyticsEvent,
        isLivePage: isLivePage
    }) : fields;
    else {
        let newFields;
        if (transformFields) try {
            newFields = await transformFields({
                fields: fields,
                pageContext: pageContext,
                intl: intl,
                params: params,
                createAnalyticsEvent: createAnalyticsEvent,
                isLivePage: isLivePage,
                isLivePagesFeatureEnabled: isLivePagesFeatureEnabled
            });
        } catch (error) {
            if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(macroName)) $763d528574677310$var$fireErrorAnalytics(macroName, 'transformFields', error, createAnalyticsEvent);
        }
        else newFields = fields;
        return alwaysFn ? alwaysFn(newFields, pageContext, intl) : newFields;
    }
};
const $763d528574677310$export$db6c1732c1c4814c = (transformType, macro, params, pageContext, createAnalyticsEvent)=>{
    const { macroName: macroName, formDetails: formDetails } = macro;
    const metadata = $763d528574677310$var$makeObject(formDetails.parameters);
    const transformFn = $763d528574677310$export$78a98cfbfc91bcb5()[macroName]?.[transformType];
    const alwaysFn = (0, $81Qvv.always)?.[transformType];
    let newParams;
    if (transformFn) try {
        newParams = transformFn(params, metadata, pageContext);
    } catch (error) {
        if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(macroName)) $763d528574677310$var$fireErrorAnalytics(macroName, transformType, error, createAnalyticsEvent);
    }
    else newParams = params;
    return alwaysFn ? alwaysFn(newParams, metadata, pageContext) : newParams;
};
const $763d528574677310$var$fireErrorAnalytics = (macroName, fn, error, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: fn,
            actionSubjectId: macroName,
            source: 'field-mappings',
            attributes: {
                error: error.message,
                stack: error.stack
            }
        }
    }).fire();
};

});
parcelRegister("81Qvv", function(module, exports) {

$parcel$export(module.exports, "always", () => $35b63f91264cd025$export$ba9e5d519bc326ca);
// These transformers will run for all macros

var $7GAUm = parcelRequire("7GAUm");

var $3BPuo = parcelRequire("3BPuo");

var $b0tJK = parcelRequire("b0tJK");

var $hbWMr = parcelRequire("hbWMr");

var $hpCtS = parcelRequire("hpCtS");

var $dPp6L = parcelRequire("dPp6L");
const $35b63f91264cd025$export$d68957b367f91137 = (...transformers)=>({
        transformFields: (fields, pageContext, intl)=>transformers.reduce(async (transformedFields, transformer)=>{
                // We await transformedFields accumulator because transformFields returns a Promise<FieldDefinition[] | DynamicFieldDefinitions>
                const fieldsResult = await transformedFields;
                return transformer.transformFields ? transformer.transformFields({
                    fields: fieldsResult,
                    pageContext: pageContext,
                    intl: intl
                }) // Call transformFields on fields if it exists
                 : transformedFields; // Otherwise, return the original fields with any applied transformations thus far
            }, Promise.resolve(fields)),
        transformBefore: (params, metadata, pageContext)=>transformers.reduce((params, transformer)=>transformer.transformBefore ? transformer.transformBefore(params, metadata, pageContext) : params, params),
        transformAfter: (params, metadata, pageContext)=>transformers.reduce((params, transformer)=>transformer.transformAfter ? transformer.transformAfter(params, metadata, pageContext) : params, params)
    });
const $35b63f91264cd025$export$ba9e5d519bc326ca = $35b63f91264cd025$export$d68957b367f91137((0, $7GAUm.cql), (0, $hbWMr.transformEmptyKey), (0, $3BPuo.parseBoolean), (0, $hpCtS.transformMultiValuedFields), (0, $b0tJK.stripDefaultValues), (0, $dPp6L.missingRequiredParameters));

});
parcelRegister("7GAUm", function(module, exports) {

$parcel$export(module.exports, "cql", () => $cea6135e7e84bafe$export$6a5670d7122d77e8);
const $cea6135e7e84bafe$export$6a5670d7122d77e8 = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field.type.name === 'cql' && typeof value === 'string' && value.length) // Required to migrate old macros inserted via Macro Browser since
            // new config doesn't support . [dot] in field name. For more context @see ED-12857
            params[key] = value.replace(/(contributor|creator|mention)\.accountid = /g, '$1 = ');
        });
        return params;
    }
};

});

parcelRegister("3BPuo", function(module, exports) {

$parcel$export(module.exports, "parseBoolean", () => $8af95a90f3d439a2$export$3fb54149990fb5b5);
const $8af95a90f3d439a2$export$3fb54149990fb5b5 = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            if (field?.type?.name === 'boolean' && params[key] !== undefined) params[key] = params[key] === 'false' ? false : !!params[key];
        });
        return params;
    }
};

});

parcelRegister("b0tJK", function(module, exports) {

$parcel$export(module.exports, "stripDefaultValues", () => $c7a8c4deae65a41e$export$6a4d6155f720c963);
const $c7a8c4deae65a41e$export$6a4d6155f720c963 = {
    transformAfter (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            let remove = false;
            if (field && // Ideally required field shouldn't have defaultValue but it's "macro" ¯\_(ツ)_/¯
            !field.required) {
                // Default behavior
                if (field.defaultValue === params[key]) remove = true;
                else if (field.type.name === 'boolean' && (field.defaultValue === 'false' && params[key] === false || field.defaultValue === 'true' && params[key] === true)) remove = true;
                else if (field.type.name === 'string' && field.defaultValue === null && params[key] === '') remove = true;
            }
            if (remove) delete params[key];
        });
        return params;
    }
};

});

parcelRegister("hbWMr", function(module, exports) {

$parcel$export(module.exports, "transformEmptyKey", () => $12bc2881105e54ac$export$981278bf1b2aa327);
const $12bc2881105e54ac$export$981278bf1b2aa327 = {
    // Transform all empty keys ([""]) to `defaultParameterValue`
    transformBefore (params, metadata) {
        if (params[''] != null) {
            params.defaultParameterValue = params[''];
            metadata.defaultParameterValue = metadata[''];
        }
        return params;
    },
    // Transforming them back to [""] here.
    transformAfter (params, metadata) {
        if (params.defaultParameterValue != null) {
            params[''] = params.defaultParameterValue;
            metadata[''] = metadata.defaultParameterValue;
            delete params.defaultParameterValue;
        }
        return params;
    }
};

});

parcelRegister("hpCtS", function(module, exports) {

$parcel$export(module.exports, "transformMultiValuedFields", () => $9fdcf181e9622d09$export$e022d5efa3e02dee);
const $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX = [
    'username',
    'spacekey',
    'enum',
    'label'
];
const $9fdcf181e9622d09$export$e022d5efa3e02dee = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field?.multiple && value !== undefined && typeof value === 'string' && $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX.includes(field.type.name)) params[key] = value.split(',');
        });
        return params;
    },
    transformAfter (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field?.multiple && Array.isArray(value) && $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX.includes(field.type.name)) params[key] = value.join(',');
        });
        return params;
    }
};

});

parcelRegister("dPp6L", function(module, exports) {

$parcel$export(module.exports, "missingRequiredParameters", () => $485f60cc477809b5$export$af7e7c08e5e55c8f);

var $2E7zk = parcelRequire("2E7zk");
/**
 * There is a transformation on data that is happening for tasks report macro that deletes the combined field of spaceAndPage
 * https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/browse/confluence/next/packages/fabric-extension-lib/src/providers/macros/field-mappings/tasks-report.ts#90
 * This code runs prior to the missingRequiredParameters check at causes the check to fail.
 * To properly check if the field is set we need to check the renamed fields.
 * This check may be used for any other renamed parameters.
 */ const $485f60cc477809b5$var$COMPOUND_FIELD_MAP = {
    spaceAndPage: [
        'space',
        'page'
    ]
};
function $485f60cc477809b5$var$checkValueSet(key, params) {
    if (!$485f60cc477809b5$var$COMPOUND_FIELD_MAP[key]) return (0, $2E7zk.isValueSet)(params[key]);
    return (0, $2E7zk.isValueSet)(params[key]) || $485f60cc477809b5$var$COMPOUND_FIELD_MAP[key].some((subfield)=>(0, $2E7zk.isValueSet)(params[subfield]));
}
const $485f60cc477809b5$export$af7e7c08e5e55c8f = {
    transformAfter (params, metadata) {
        if (Object.entries(metadata).some(([key, field])=>// NOTE: CQL has default value inside `field.options.defaultFields`
            // But it doesn't work now
            field && field.required && field.defaultValue == null && !field.hidden && !$485f60cc477809b5$var$checkValueSet(key, params))) params.isMissingRequiredParameters = true;
        return params;
    }
};

});


parcelRegister("i1Wqg", function(module, exports) {

$parcel$export(module.exports, "anchor", () => $b0454047538f87a4$export$2e2992790a6f69a8);

var $2nPZH = parcelRequire("2nPZH");

var $8pcS0 = parcelRequire("8pcS0");
const $b0454047538f87a4$var$i18n = (0, $2nPZH.defineMessages)({
    defaultParameterValueFieldLabel: {
        id: "fabric-extension-lib.anchor.config-panel.name-field.label",
        defaultMessage: "Name"
    },
    defaultParameterValueFieldDescription: {
        id: "fabric-extension-lib.anchor.config-panel.name-field.description",
        defaultMessage: "Give this anchor link a unique name for easy reference."
    }
});
const $b0454047538f87a4$export$2e2992790a6f69a8 = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            if (field.name !== 'defaultParameterValue') return field;
            return {
                ...field,
                type: 'string',
                isRequired: true,
                label: intl.formatMessage($b0454047538f87a4$var$i18n.defaultParameterValueFieldLabel),
                description: intl.formatMessage($b0454047538f87a4$var$i18n.defaultParameterValueFieldDescription)
            };
        });
    },
    // Transforming name that user entered into a valid URI. Not a great experience, need to find a way to inform the user and allow them to pick again.
    transformAfter (params) {
        if (params.defaultParameterValue) {
            // Strip spaces off the beginning and end of the name
            params.defaultParameterValue = params.defaultParameterValue.replace(/^\s+/g, '');
            params.defaultParameterValue = params.defaultParameterValue.replace(/\s+$/g, '');
            // Changing spaces to '-' to match header logic
            params.defaultParameterValue = params.defaultParameterValue.replace(/\s+/g, '-');
            // Stripping out quotes for security (VULN-539679)
            params.defaultParameterValue = params.defaultParameterValue.replace(/["']+/g, '');
            params.defaultParameterValue = params.defaultParameterValue.substr(0, (0, $8pcS0.MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH));
        }
        return params;
    }
};

});

parcelRegister("grShm", function(module, exports) {

$parcel$export(module.exports, "attachments", () => $fdf5e213da5d1c5e$export$5ada257c34afac99);
const $fdf5e213da5d1c5e$export$5ada257c34afac99 = {
    // Converts the "labels" field to be a multi-select
    // which is not supported by the old macro browser
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name !== 'labels') return field;
            return {
                ...field,
                type: 'custom',
                isMultiple: true,
                options: {
                    resolver: {
                        type: 'label'
                    }
                }
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        if (params.labels && typeof params.labels === 'string') params.labels = params.labels.split(',');
        return params;
    },
    // Custom field returns an array, so converting it back to string to store
    transformAfter (params) {
        if (Array.isArray(params.labels)) params.labels = params.labels.join(',');
        return params;
    }
};

});

parcelRegister("98p9q", function(module, exports) {

$parcel$export(module.exports, "blogPosts", () => $a51a656fff9da83c$export$d09847bb5c97319b);
const $a51a656fff9da83c$var$FIELDS_TO_FIX = [
    'labels',
    'spaces'
];
const $a51a656fff9da83c$export$d09847bb5c97319b = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (!$a51a656fff9da83c$var$FIELDS_TO_FIX.includes(field.name)) return field;
            let options;
            switch(field.name){
                // Converts the "labels" field to be a multi-select
                // which is not supported by the old macro browser
                case 'labels':
                    options = {
                        resolver: {
                            type: 'label'
                        }
                    };
                    break;
                case 'spaces':
                    // restrict to particular spaces
                    // supports special values like @self
                    options = {
                        resolver: {
                            type: 'blogRecentlyUpdatedSpace'
                        }
                    };
                    break;
                default:
                    options = {};
                    break;
            }
            return {
                ...field,
                options: options,
                // description talks about entering comma separated syntax
                // which no longer applies as users are now just picking from a dropdown
                description: undefined,
                type: 'custom',
                isMultiple: true
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        $a51a656fff9da83c$var$FIELDS_TO_FIX.forEach((field)=>{
            if (params[field] && typeof params[field] === 'string') params[field] = params[field].split(',');
        });
        return params;
    },
    transformAfter (params) {
        $a51a656fff9da83c$var$FIELDS_TO_FIX.forEach((field)=>{
            if (Array.isArray(params[field])) params[field] = params[field].join(',');
        });
        return params;
    }
};

});

parcelRegister("f8ZIi", function(module, exports) {

$parcel$export(module.exports, "contributors", () => $f961a585851fa823$export$94a431ed9cc1a33c);

var $gKnE9 = parcelRequire("gKnE9");
// NOTE: Contributors uses ISO date format so this is only useful when
// the calendar picker will use a different locale.
// Dates must be entered as YYYY/MM/DD
// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
const $f961a585851fa823$var$PUBLISH_DATE_FORMAT = 'yyyy-MM-dd';
const $f961a585851fa823$export$94a431ed9cc1a33c = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            switch(field.name){
                case 'publishDate':
                    return {
                        ...field,
                        description: undefined
                    };
                case 'spaces':
                    return {
                        ...field,
                        options: {
                            resolver: {
                                type: 'contributorsSpaceParamResolver'
                            }
                        }
                    };
                default:
                    return field;
            }
        });
    },
    transformBefore (params) {
        if (params.publishDate?.length) params.publishDate = (0, $gKnE9.customToIsoDate)(params.publishDate, $f961a585851fa823$var$PUBLISH_DATE_FORMAT);
        return params;
    },
    transformAfter (params) {
        if (params.publishDate?.length) params.publishDate = (0, $gKnE9.isoToCustomDate)(params.publishDate, $f961a585851fa823$var$PUBLISH_DATE_FORMAT);
        return params;
    }
};

});
parcelRegister("gKnE9", function(module, exports) {

$parcel$export(module.exports, "isoToCustomDate", () => $af44a8b67702937d$export$c6813fa23b09b132);
$parcel$export(module.exports, "customToIsoDate", () => $af44a8b67702937d$export$f357581637260a);
$parcel$export(module.exports, "parseBoolean", () => $af44a8b67702937d$export$3fb54149990fb5b5);

var $g5hv1 = parcelRequire("g5hv1");

var $cpyCM = parcelRequire("cpyCM");

var $62ptY = parcelRequire("62ptY");

var $3Rv1w = parcelRequire("3Rv1w");
function $af44a8b67702937d$export$c6813fa23b09b132(date, dateFormat) {
    return (0, $62ptY.default)((0, $cpyCM.default)(date), dateFormat);
}
function $af44a8b67702937d$export$f357581637260a(date, dateFormat) {
    return (0, $3Rv1w.default)((0, $g5hv1.default)(date, dateFormat, new Date()), {
        representation: 'date'
    });
}
const $af44a8b67702937d$export$3fb54149990fb5b5 = (value)=>{
    if (typeof value === 'boolean') return value;
    return value === 'true';
};

});
parcelRegister("3Rv1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cfe62f5aa673667$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $1T6wY = parcelRequire("1T6wY");

var $6Z3KL = parcelRequire("6Z3KL");
function $2cfe62f5aa673667$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $6Z3KL.default)(1, arguments);
    var originalDate = (0, $4YLNd.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $1T6wY.default)(originalDate.getDate(), 2);
        var month = (0, $1T6wY.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $1T6wY.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $1T6wY.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $1T6wY.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $1T6wY.default)(originalDate.getHours(), 2);
        var minute = (0, $1T6wY.default)(originalDate.getMinutes(), 2);
        var second = (0, $1T6wY.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});



parcelRegister("9D7MJ", function(module, exports) {

$parcel$export(module.exports, "include", () => $e537b86479e256a3$export$99920f638bbeb850);

var $2nPZH = parcelRequire("2nPZH");

var $9wGTI = parcelRequire("9wGTI");
const $e537b86479e256a3$var$i18n = (0, $2nPZH.defineMessages)({
    contentIncludeFieldLabel: {
        id: "fabric-extension-lib.field-mappings.include.field.contentInclude.label",
        defaultMessage: "Content to include"
    }
});
const $e537b86479e256a3$export$99920f638bbeb850 = {
    transformFields: async ({ fields: fields, intl: intl, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled })=>{
        return fields.map((field)=>{
            if (field.name !== 'defaultParameterValue') return field;
            return {
                ...field,
                type: 'custom',
                label: isLivePagesFeatureEnabled && (0, $9wGTI.fg)('confluence_live_pages_macro_copy_updates') ? intl.formatMessage($e537b86479e256a3$var$i18n.contentIncludeFieldLabel) : field.label,
                // description talks about entering page using SPACEKEY:Page_title syntax
                // which no longer applies as users are now just picking from a dropdown
                description: undefined,
                options: {
                    resolver: {
                        type: 'spaceKeyAndPageTitleContent'
                    }
                }
            };
        });
    }
};

});

parcelRegister("c786U", function(module, exports) {

$parcel$export(module.exports, "officeConnector", () => $cc7cae6ecd5fddd6$export$7de1d9fa02de756b);
const $cc7cae6ecd5fddd6$export$7de1d9fa02de756b = {
    transformFields: async ({ fields: fields })=>{
        return fields// Removes the field altogether
        // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/browse/packages/confluence-macro-browser-overrides/src/office-connector/overrides.js#139-153
        .filter((field)=>![
                'date',
                'space'
            ].includes(field.name))// Adds a hidden field so it will keep existing values
        .map((field)=>{
            if (field.name !== 'page') return field;
            return {
                ...field,
                type: 'string',
                isHidden: true
            };
        });
    },
    transformAfter (params) {
        if (!params.page) delete params.page;
        return params;
    }
};

});

parcelRegister("booiN", function(module, exports) {

$parcel$export(module.exports, "tasksReport", () => $ea80d69ac5e0e244$export$5e6ec7c8e2ab7cd0);

var $2E7zk = parcelRequire("2E7zk");

var $gKnE9 = parcelRequire("gKnE9");
// Dates must be entered as dd-mm-yyyy
// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
const $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT = 'dd-MM-yyyy';
const $ea80d69ac5e0e244$export$5e6ec7c8e2ab7cd0 = {
    // Converts the "spaceAndPage" field to be a custom multi-select
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name === 'spaceAndPage') return {
                ...field,
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'spaceAndPage'
                    }
                }
            };
            else if (field.name === 'createddateFrom') // Remove the description since we are using a date picker now
            return {
                ...field,
                description: undefined
            };
            return field;
        });
    },
    transformBefore (params) {
        // Handle Space and Pages
        // We store { pages: '123', spaces: '~456' } in macroParams
        // but new config field definition has one `spaceAndPage` field
        // containing both `pages` and `spaces` field values joined together
        let spaceAndPage = '';
        if (params.spaces) spaceAndPage += params.spaces;
        if (params.pages) {
            if (spaceAndPage) spaceAndPage += ',';
            spaceAndPage += params.pages;
        }
        if (spaceAndPage) params.spaceAndPage = spaceAndPage;
        delete params.spaces;
        delete params.pages;
        // Handle Date
        if (params.createddateFrom?.length) params.createddateFrom = (0, $gKnE9.customToIsoDate)(params.createddateFrom, $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT);
        return params;
    },
    transformAfter (params) {
        // Before passing it back to macro splitting `spaceAndPage` into `spaces` & `pages`
        if (Array.isArray(params.spaceAndPage)) {
            const spaces = params.spaceAndPage.filter((value)=>!(0, $2E7zk.isPageId)(value));
            if (spaces.length > 0) params.spaces = spaces.join(',');
            const pages = params.spaceAndPage.filter((0, $2E7zk.isPageId));
            if (pages.length > 0) params.pages = pages.join(',');
            delete params.spaceAndPage;
        }
        // Handle Date
        if (params.createddateFrom?.length) params.createddateFrom = (0, $gKnE9.isoToCustomDate)(params.createddateFrom, $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT);
        return params;
    }
};

});

parcelRegister("bJ8MA", function(module, exports) {

$parcel$export(module.exports, "pagetree", () => $d936723dbc3f198e$export$399a6ae8796e7804);

var $2nPZH = parcelRequire("2nPZH");

var $9wGTI = parcelRequire("9wGTI");
const $d936723dbc3f198e$var$i18n = (0, $2nPZH.defineMessages)({
    fieldRootLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.root.label",
        defaultMessage: "Root content"
    },
    fieldSpacesLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.spaces.label",
        defaultMessage: "Restrict to this space key"
    },
    fieldSortLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.sort.label",
        defaultMessage: "Sort content by"
    },
    fieldExcerptLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.excerpt.label",
        defaultMessage: "Include excerpts in content tree"
    },
    fieldReverseLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.reverse.label",
        defaultMessage: "Reverse order"
    },
    fieldReverseDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.reverse.description",
        defaultMessage: "Used only in conjunction with the \u201CSort content by\u201D field."
    },
    fieldSearchBoxLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.searchBox.label",
        defaultMessage: "Include search box above content tree"
    },
    fieldExpandCollapseAllLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.expandCollapseAll.label",
        defaultMessage: "Show expand/collapse links"
    },
    fieldExpandCollapseAllDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.expandCollapseAll.description",
        defaultMessage: "Displays the \u201Cexpand all\u201D and \u201Ccollapse all\u201D links at the top of the content tree."
    },
    fieldStartDepthLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.startDepth.label",
        defaultMessage: "Tree depth"
    },
    fieldStartDepthDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.startDepth.description",
        defaultMessage: "The number of levels of child items displayed."
    }
});
const $d936723dbc3f198e$export$399a6ae8796e7804 = {
    transformFields: async ({ fields: fields, intl: intl, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled })=>{
        return fields.map((field)=>{
            let fieldResult = {
                ...field
            };
            if (field.name === 'root') fieldResult = {
                ...fieldResult,
                isMultiple: false,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'rootPage'
                    }
                }
            };
            if (isLivePagesFeatureEnabled && (0, $9wGTI.fg)('confluence_live_pages_macro_copy_updates')) {
                let newMacroCopies = {};
                switch(field.name){
                    case 'root':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldRootLabel)
                        };
                        break;
                    case 'spaces':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSpacesLabel)
                        };
                        break;
                    case 'sort':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSortLabel)
                        };
                        break;
                    case 'excerpt':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExcerptLabel)
                        };
                        break;
                    case 'reverse':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldReverseLabel),
                            description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldReverseDescription)
                        };
                        break;
                    case 'searchBox':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSearchBoxLabel)
                        };
                        break;
                    case 'expandCollapseAll':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExpandCollapseAllLabel),
                            description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExpandCollapseAllDescription)
                        };
                        break;
                    case 'startDepth':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldStartDepthLabel),
                            description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldStartDepthDescription)
                        };
                        break;
                }
                fieldResult = {
                    ...fieldResult,
                    ...newMacroCopies
                };
            }
            return fieldResult;
        });
    }
};

});

parcelRegister("gaGUd", function(module, exports) {

$parcel$export(module.exports, "calendar", () => $836a8b250eda6583$export$56bbcdb8aca31149);
const $836a8b250eda6583$export$56bbcdb8aca31149 = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name !== 'id') return field;
            return {
                ...field,
                type: 'custom',
                isMultiple: true,
                options: {
                    resolver: {
                        type: 'calendar'
                    }
                }
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        if (params.id && typeof params.id === 'string') params.id = params.id.split(',');
        return params;
    },
    // Custom field returns an array, so converting it back to string to store
    transformAfter (params) {
        if (Array.isArray(params.id)) params.id = params.id.join(',');
        return params;
    }
};

});

parcelRegister("84b39", function(module, exports) {

$parcel$export(module.exports, "recentlyUpdated", () => $11540f3edad606fa$export$8b4c22b4049c66c3);

var $gKnE9 = parcelRequire("gKnE9");

var $7Cd3h = parcelRequire("7Cd3h");

var $kTVK2 = parcelRequire("kTVK2");
const $11540f3edad606fa$var$basicTabFields = [
    'spaces',
    'types',
    'max'
];
const $11540f3edad606fa$var$displayTabFields = [
    'theme',
    'author',
    'labels',
    'width',
    'hideHeading'
];
const $11540f3edad606fa$export$8b4c22b4049c66c3 = {
    transformFields: async ({ fields: fields, intl: intl, createAnalyticsEvent: createAnalyticsEvent, isLivePage: isLivePage })=>{
        const fireErrorAnalytics = (tab, error)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'error',
                    actionSubject: 'transformFields',
                    actionSubjectId: tab,
                    source: 'field-mappings/recently-updated',
                    attributes: {
                        error: error.message,
                        stack: error.stack
                    }
                }
            }).fire();
        };
        const getDynamicFields = (currentParams)=>{
            const fieldsObj = fields.reduce((obj, field)=>{
                obj[field.name] = field;
                return obj;
            }, {});
            return [
                {
                    type: 'tab-group',
                    name: 'tabGroup',
                    label: 'Recent Updates Tab Group',
                    defaultTab: 'basic',
                    fields: [
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $kTVK2.i18n).basicTabLabel),
                            name: 'basic',
                            fields: [
                                ...$11540f3edad606fa$var$basicTabFields.flatMap((fieldName)=>{
                                    try {
                                        return (0, $7Cd3h.getBasicTabFields)(fieldName, fieldsObj, intl, currentParams, isLivePage);
                                    } catch (error) {
                                        fireErrorAnalytics('basicTab', error);
                                        return [];
                                    }
                                })
                            ]
                        },
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $kTVK2.i18n).displayTabLabel),
                            name: 'display',
                            fields: [
                                ...$11540f3edad606fa$var$displayTabFields.map((fieldName)=>{
                                    try {
                                        return (0, $7Cd3h.macroFields)(fieldName, fieldsObj, intl);
                                    } catch (error) {
                                        fireErrorAnalytics('displayTab', error);
                                        return [];
                                    }
                                })
                            ]
                        }
                    ]
                }
            ];
        };
        return getDynamicFields;
    },
    transformBefore (params, _metadata, _pageContext) {
        // Convert "Include in list" string to array for FE enum field
        if (params.types) params.types = params.types.split(/[ ,]+/);
        else params.types = [
            ''
        ];
        // Convert labels param from string to array for FE custom field
        if (params.labels) params.labels = params.labels.split(/[ ,]+/);
        // We are hiding "Show User Profile Pictures" checkbox
        // In the BE if this was checked, it sets theme to "social" and overrides the "theme" param
        // So if an existing macro had this checked, set theme to "social" (results in no change to macro view)
        if ((0, $gKnE9.parseBoolean)(params.showProfilePic)) {
            params.theme = 'social';
            params.showProfilePic = 'false';
        }
        return params;
    },
    transformAfter (params, _metadata, _pageContext) {
        // "Include in list" param behavior: Default is "All" which is mutually exclusive with other options.
        // i.e. selection in this field can be either "All" by itself, or any content types (but no "All").
        // Also converts array to string for BE field data type
        if (params.types) {
            const types = params.types;
            if (types[types.length - 1] === '') // "All" was just chosen, remove all other selections
            params.types = '';
            else if (types.some((type)=>type === '')) {
                // A content type was selected but "All" exists in the list, so remove "All"
                types.splice(types.indexOf(''), 1);
                params.types = types.join();
            } else params.types = types.join();
        }
        // If "Show all updates" toggle is on, set max param to highest allowed from BE
        const showAll = (0, $gKnE9.parseBoolean)(params.maxToggle);
        if (showAll) params.max = 250;
        // Convert labels param from array to string for BE field definition
        if (params.labels) params.labels = params.labels.join();
        return params;
    }
};

});
parcelRegister("7Cd3h", function(module, exports) {

$parcel$export(module.exports, "macroFields", () => $6cbac4da7b29df9c$export$aa84be64c5f7ddf4);
$parcel$export(module.exports, "getBasicTabFields", () => $6cbac4da7b29df9c$export$e9aa8a2eb319b54d);

var $9wGTI = parcelRequire("9wGTI");

var $gKnE9 = parcelRequire("gKnE9");

var $kTVK2 = parcelRequire("kTVK2");
const $6cbac4da7b29df9c$export$aa84be64c5f7ddf4 = (name, fields, intl, _defaultValue, isLivePage)=>{
    let field;
    switch(name){
        case 'spaces':
            field = {
                ...$6cbac4da7b29df9c$var$getSpacesField(fields['spaces']),
                label: intl.formatMessage((0, $kTVK2.i18n).spaceLabel),
                description: '',
                placeholder: intl.formatMessage((0, $kTVK2.i18n).spacePlaceholder)
            };
            break;
        case 'types':
            field = {
                ...fields['types'],
                label: intl.formatMessage((0, $kTVK2.i18n).typesLabel),
                description: '',
                placeholder: intl.formatMessage((0, $kTVK2.i18n).typePlaceholder),
                type: 'enum',
                style: 'select',
                isMultiple: true,
                items: [
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).allLabel),
                        value: ''
                    },
                    {
                        label: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? intl.formatMessage((0, $kTVK2.i18nTypes).livePageLabel) : intl.formatMessage((0, $kTVK2.i18nTypes).pageLabel),
                        value: 'page'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).blogPostLabel),
                        value: 'blogpost'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).commentLabel),
                        value: 'comment'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).attachmentLabel),
                        value: 'attachment'
                    }
                ]
            };
            break;
        case 'maxToggle':
            field = {
                name: 'maxToggle',
                type: 'boolean',
                style: 'toggle',
                label: intl.formatMessage((0, $kTVK2.i18n).maxToggleLabel),
                description: '',
                defaultValue: false,
                isHidden: false,
                isMultiple: false,
                isRequired: false
            };
            break;
        case 'max':
            field = {
                ...fields['max'],
                label: intl.formatMessage((0, $kTVK2.i18n).maxLabel)
            };
            break;
        case 'theme':
            field = {
                ...fields['theme'],
                label: intl.formatMessage((0, $kTVK2.i18n).themeLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18nTheme).conciseLabel),
                items: [
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).conciseLabel),
                        value: 'concise'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).sidebarLabel),
                        value: 'sidebar'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).socialLabel),
                        value: 'social'
                    }
                ]
            };
            break;
        case 'author':
            field = {
                ...fields['author'],
                label: intl.formatMessage((0, $kTVK2.i18n).authorLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).authorPlaceholder),
                description: ''
            };
            break;
        case 'labels':
            field = {
                ...fields['labels'],
                label: intl.formatMessage((0, $kTVK2.i18n).labelsLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).labelsPlaceholder),
                description: '',
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'label'
                    }
                }
            };
            break;
        case 'width':
            field = {
                ...fields['width'],
                label: intl.formatMessage((0, $kTVK2.i18n).widthLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).widthPlaceholder),
                description: '',
                type: 'custom',
                options: {
                    isCreatable: true,
                    formatCreateLabel: (value)=>{
                        return value;
                    },
                    resolver: {
                        type: 'widthPercentage'
                    }
                }
            };
            break;
        case 'hideHeading':
            field = {
                ...fields['hideHeading'],
                label: intl.formatMessage((0, $kTVK2.i18n).hideHeadingLabel)
            };
            break;
    }
    return field;
};
const $6cbac4da7b29df9c$var$getSpacesField = (field)=>{
    return {
        ...field,
        isMultiple: true,
        type: 'custom',
        options: {
            resolver: {
                type: 'blogRecentlyUpdatedSpace'
            }
        }
    };
};
const $6cbac4da7b29df9c$export$e9aa8a2eb319b54d = (name, fields, intl, currentParams, isLivePage)=>{
    if (name === 'max') {
        const result = [];
        result.push($6cbac4da7b29df9c$export$aa84be64c5f7ddf4('maxToggle', fields, intl, isLivePage));
        if (!(0, $gKnE9.parseBoolean)(currentParams?.macroParams?.maxToggle?.value)) result.push($6cbac4da7b29df9c$export$aa84be64c5f7ddf4(name, fields, intl));
        return result;
    }
    return $6cbac4da7b29df9c$export$aa84be64c5f7ddf4(name, fields, intl, isLivePage);
};

});
parcelRegister("kTVK2", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $735a35f26a402a9b$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "i18nTypes", () => $735a35f26a402a9b$export$e89c4678ffd2a62b);
$parcel$export(module.exports, "i18nTheme", () => $735a35f26a402a9b$export$cfae297845436803);
$parcel$export(module.exports, "i18nWidth", () => $735a35f26a402a9b$export$9227588ce3953cff);

var $2nPZH = parcelRequire("2nPZH");
const $735a35f26a402a9b$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    basicTabLabel: {
        id: "fabric-extension-lib.recently-updated.tab.basic.label",
        defaultMessage: "Basic"
    },
    displayTabLabel: {
        id: "fabric-extension-lib.recently-updated.tab.display.label",
        defaultMessage: "Display"
    },
    spaceLabel: {
        id: "fabric-extension-lib.recently-updated.field.spaces.label",
        defaultMessage: "Space"
    },
    spacePlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.spaces.placeholder",
        defaultMessage: "Search and select by name"
    },
    typesLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.label",
        defaultMessage: "Include in list"
    },
    typePlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.types.placeholder",
        defaultMessage: "Select one or several"
    },
    maxToggleLabel: {
        id: "fabric-extension-lib.recently-updated.field.maxToggle.label",
        defaultMessage: "Show all updates"
    },
    maxLabel: {
        id: "fabric-extension-lib.recently-updated.field.max.label",
        defaultMessage: "Max number of updates"
    },
    themeLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.label",
        defaultMessage: "List style"
    },
    authorLabel: {
        id: "fabric-extension-lib.recently-updated.field.author.label",
        defaultMessage: "Filter by user"
    },
    authorPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.author.placeholder",
        defaultMessage: "Search and select user(s)"
    },
    labelsLabel: {
        id: "fabric-extension-lib.recently-updated.field.labels.label",
        defaultMessage: "Filter by label"
    },
    labelsPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.labels.placeholder",
        defaultMessage: "Search and select label(s)"
    },
    widthLabel: {
        id: "fabric-extension-lib.recently-updated.field.width.label",
        defaultMessage: "List width"
    },
    widthPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.width.placeholder",
        defaultMessage: "Select or enter width"
    },
    hideHeadingLabel: {
        id: "fabric-extension-lib.recently-updated.field.hideHeading.label",
        defaultMessage: "Hide list header"
    }
});
const $735a35f26a402a9b$export$e89c4678ffd2a62b = (0, $2nPZH.defineMessages)({
    allLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.all",
        defaultMessage: "All"
    },
    pageLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.page",
        defaultMessage: "Pages"
    },
    livePageLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.live-page",
        defaultMessage: "Live docs"
    },
    blogPostLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.blogpost",
        defaultMessage: "Blog posts"
    },
    commentLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.comment",
        defaultMessage: "Comments"
    },
    attachmentLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.attachment",
        defaultMessage: "Attachments"
    }
});
const $735a35f26a402a9b$export$cfae297845436803 = (0, $2nPZH.defineMessages)({
    conciseLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.concise",
        defaultMessage: "Title + user name"
    },
    sidebarLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.sidebar",
        defaultMessage: "Title"
    },
    socialLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.social",
        defaultMessage: "User name + profile picture"
    }
});
const $735a35f26a402a9b$export$9227588ce3953cff = (0, $2nPZH.defineMessages)({
    fullLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.full",
        defaultMessage: "100% of frame"
    },
    threeQuartersLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.threeQuarters",
        defaultMessage: "75% of frame"
    },
    halfLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.half",
        defaultMessage: "50% of frame"
    },
    quarterLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.quarter",
        defaultMessage: "25% of frame"
    }
});

});



parcelRegister("9IuHM", function(module, exports) {

$parcel$export(module.exports, "recentlyUpdatedDashboard", () => $88990a4623f29192$export$fdb887e9b25aa392);
const $88990a4623f29192$export$fdb887e9b25aa392 = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name === 'spaces') return {
                ...field,
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'recentlyUpdatedDashboardSpaceKeyResolver'
                    }
                }
            };
            return field;
        });
    }
};

});

parcelRegister("6wLSo", function(module, exports) {

$parcel$export(module.exports, "createFromTemplate", () => $a9bebca19b89c955$export$f0ecb46e90798741);

var $gw2T1 = parcelRequire("gw2T1");
const $a9bebca19b89c955$var$isNumber = (contentId)=>/^[0-9]+$/.test(contentId);
const $a9bebca19b89c955$export$f0ecb46e90798741 = {
    transformFields: async ({ fields: fields, pageContext: pageContext, params: params })=>{
        let templates = [];
        const resolver = (0, $gw2T1.getTemplateResolver)(params?.spaceKey ? params : pageContext);
        if (resolver) templates = await resolver('', '');
        const newFields = fields.map((field)=>{
            if (field.name === 'templateName') return {
                ...field,
                type: 'enum',
                items: templates,
                isRequired: true
            };
            else if (field.name === 'spaceKey') return {
                ...field,
                defaultValue: pageContext.spaceKey,
                isRequired: false
            };
            return field;
        });
        const spaceKeyIndex = newFields.findIndex(({ name: name })=>name === 'spaceKey');
        const templateIndex = newFields.findIndex(({ name: name })=>name === 'templateName');
        newFields.unshift(newFields.splice(templateIndex, 1)[0]);
        newFields.unshift(newFields.splice(spaceKeyIndex, 1)[0]);
        return newFields;
    },
    transformAfter (params) {
        const { templateName: templateName } = params;
        if (templateName) {
            if ($a9bebca19b89c955$var$isNumber(templateName)) {
                params.templateId = templateName;
                delete params.contentBlueprintId;
            } else {
                params.contentBlueprintId = templateName;
                delete params.templateId;
            }
        }
        return params;
    }
};

});
parcelRegister("gw2T1", function(module, exports) {

$parcel$export(module.exports, "getTemplateResolver", () => $dcac0b0097aba21f$export$e9ae85abdbcb00ec);

var $gwFzn = parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");

var $d2LG0 = parcelRequire("d2LG0");

var $hp2SH = parcelRequire("hp2SH");

var $10Oe6 = parcelRequire("10Oe6");
var $2DGtt = parcelRequire("2DGtt");

var $7Wf9U = parcelRequire("7Wf9U");

var $5ZqQS = parcelRequire("5ZqQS");

var $dIouf = parcelRequire("dIouf");
var $dcac0b0097aba21f$var$SortOrder = /*#__PURE__*/ function(SortOrder) {
    SortOrder["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    return SortOrder;
}($dcac0b0097aba21f$var$SortOrder || {});
const $dcac0b0097aba21f$var$AllTemplatesQuery = // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
(0, $d2LG0.default)`query AllTemplatesQuery($spaceKey:String!$sortingScheme:String!){allTemplates(spaceKey:$spaceKey sortingScheme:$sortingScheme){nodes{name description templateId contentBlueprintId iconURL darkModeIconURL}}}`;
const $dcac0b0097aba21f$var$loadLegacyTemplateStyles = (0, $csnse.default)((0, $2DGtt.requireStyleClassResourcesForTemplates));
const $dcac0b0097aba21f$var$getAllTemplates = async (spaceKey)=>{
    const allTemplatesData = await (0, $hp2SH.getApolloClient)().query({
        query: $dcac0b0097aba21f$var$AllTemplatesQuery,
        variables: {
            spaceKey: spaceKey,
            sortingScheme: "web.item.sorting.scheme.relevancy"
        }
    });
    return allTemplatesData?.data.allTemplates?.nodes;
};
const $dcac0b0097aba21f$var$search = async (spaceKey)=>{
    try {
        const templates = await $dcac0b0097aba21f$var$getAllTemplates(spaceKey);
        return templates.map((template)=>({
                label: template.name,
                description: template.description,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7Wf9U.TemplateIcon), {
                    size: "small",
                    template: template
                }),
                value: (0, $10Oe6.getTemplateId)(template)
            }));
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Failed to fetch templates from template resolver in macro config panel with error: ${error}`), {
            attribution: (0, $dIouf.Attribution).TAILORED_EXPERIENCES
        });
        return [];
    }
};
const $dcac0b0097aba21f$export$a95dc440d0d8d0bc = (spaceKey)=>async (_searchTerm, _selectedValue)=>{
        return spaceKey ? $dcac0b0097aba21f$var$search(spaceKey) : [];
    };
const $dcac0b0097aba21f$export$e9ae85abdbcb00ec = ({ spaceKey: spaceKey })=>{
    $dcac0b0097aba21f$var$loadLegacyTemplateStyles();
    return $dcac0b0097aba21f$export$a95dc440d0d8d0bc(spaceKey);
};

});
parcelRegister("2DGtt", function(module, exports) {

$parcel$export(module.exports, "requireStyleClassResourcesForTemplates", () => $86243521f2d43c3e$export$8a6adc80de847409);

var $dIouf = parcelRequire("dIouf");

var $5ZqQS = parcelRequire("5ZqQS");

var $19aF3 = parcelRequire("19aF3");
var $cpjd2 = parcelRequire("cpjd2");
var $6Ywr0 = parcelRequire("6Ywr0");
const $86243521f2d43c3e$export$8a6adc80de847409 = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!com.atlassian.plugins.atlassian-connect-plugin:blueprint-css-resources',
        'wrc!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources'
    ], ()=>{
        // Although we've included 'wr!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources' here
        // The 'link-style-css' may have been executed somewhere else previously.
        // Requiring it again will not have effect. Here we are going to manually initialize it.
        (0, $6Ywr0.waitForRequiredModule)({
            listener: 'TemplateList',
            module: 'ac/confluence/style/link-style-css'
        }, ()=>{
            const linkStyleCSS = (0, $19aF3.globalRequire)('ac/confluence/style/link-style-css');
            if (linkStyleCSS && typeof linkStyleCSS.addLinkTags === 'function') linkStyleCSS.addLinkTags();
        });
    }, ()=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error('Style classes cannot be initialized when WRM is disabled.'), {
            attribution: (0, $dIouf.Attribution).TAILORED_EXPERIENCES
        });
    });
};

});
parcelRegister("19aF3", function(module, exports) {

$parcel$export(module.exports, "globalRequire", () => $87dd746ae26ba9c8$export$139d5ccee31f82f4);
function $87dd746ae26ba9c8$export$139d5ccee31f82f4(...args) {
    if (!window) return;
    if (!window.require) return;
    return window.require.apply(window, args);
}

});




parcelRegister("4PzO1", function(module, exports) {

$parcel$export(module.exports, "children", () => $2ed2a9038132d075$export$bacb5cc5a11aef16);

var $gKnE9 = parcelRequire("gKnE9");

var $foorG = parcelRequire("foorG");

var $a3IVB = parcelRequire("a3IVB");
const $2ed2a9038132d075$var$basicTabFields = [
    'page',
    'first',
    'all'
];
const $2ed2a9038132d075$var$displayTabFields = [
    'sort',
    'style',
    'excerptType'
];
const $2ed2a9038132d075$export$bacb5cc5a11aef16 = {
    transformFields: async ({ fields: fields, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>{
        const fireErrorAnalytics = (tab, error)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'error',
                    actionSubject: 'transformFields',
                    actionSubjectId: tab,
                    source: 'field-mappings/children',
                    attributes: {
                        error: error.message,
                        stack: error.stack
                    }
                }
            }).fire();
        };
        const getDynamicFields = (currentParams)=>{
            const fieldsObj = fields.reduce((obj, field)=>{
                obj[field.name] = field;
                return obj;
            }, {});
            return [
                {
                    type: 'tab-group',
                    name: 'tabGroup',
                    label: 'Child Pages Tab Group',
                    defaultTab: 'basic',
                    fields: [
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $foorG.i18n).basicTabLabel),
                            name: 'basic',
                            fields: [
                                ...$2ed2a9038132d075$var$basicTabFields.flatMap((fieldName)=>{
                                    try {
                                        return (0, $a3IVB.getBasicTabFields)(fieldName, fieldsObj, intl, currentParams);
                                    } catch (error) {
                                        fireErrorAnalytics('basicTab', error);
                                        return [];
                                    }
                                })
                            ]
                        },
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $foorG.i18n).displayTabLabel),
                            name: 'display',
                            fields: [
                                ...$2ed2a9038132d075$var$displayTabFields.map((fieldName)=>{
                                    try {
                                        return (0, $a3IVB.childMacroFields)(fieldName, fieldsObj, intl);
                                    } catch (error) {
                                        fireErrorAnalytics('displayTab', error);
                                        return [];
                                    }
                                })
                            ]
                        }
                    ]
                }
            ];
        };
        return getDynamicFields;
    },
    transformBefore (params) {
        // We need to update 'Show all levels' toggle here as well to align param state with UI
        params.all = (0, $a3IVB.validateDepthFields)((0, $gKnE9.parseBoolean)(params.all), typeof params.depth === 'number' ? params.depth : parseInt(params.depth ?? ''));
        // `sort` and `reverse` params have been combined into a single `sortAndReverse` field
        // so we need to combine their values into one to pass into the new enum field
        params.sortAndReverse = params.sort ?? '';
        if ((0, $gKnE9.parseBoolean)(params.reverse)) params.sortAndReverse += '.true';
        return params;
    },
    transformAfter (params) {
        // 'Show all child pages' toggle field
        const allChildren = (0, $gKnE9.parseBoolean)(params.allChildren);
        if (allChildren) params.first = 0; // 'Max number in list' field
        if (!allChildren && !params.first) params.first = 10; // set some non-0 value
        // 'Show all levels' depth toggle field
        const allLevels = (0, $gKnE9.parseBoolean)(params.all);
        if (allLevels) params.depth = 0;
        if (!allLevels && params.depth === 0) params.depth = 1;
        // Convert sort/reverse field back to manifest definition for BE handling
        [params.sort = '', params.reverse] = (params.sortAndReverse ?? '').split('.');
        if (!params.sort) delete params.sort;
        return params;
    }
};

});
parcelRegister("foorG", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $862710ac50c04301$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "i18nDepth", () => $862710ac50c04301$export$e7de9fb1789252ba);
$parcel$export(module.exports, "i18nSort", () => $862710ac50c04301$export$22a6a8b908f4792e);
$parcel$export(module.exports, "i18nStyle", () => $862710ac50c04301$export$937ee27e4f72fd9f);
$parcel$export(module.exports, "i18nExcerptType", () => $862710ac50c04301$export$981659feafe35cff);

var $2nPZH = parcelRequire("2nPZH");
const $862710ac50c04301$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    pageLabel: {
        id: "fabric-extension-lib.children.field.page.label",
        defaultMessage: "Parent item"
    },
    pagePlaceholder: {
        id: "fabric-extension-lib.children.field.page.placeholder",
        defaultMessage: "Current"
    },
    allChildren: {
        id: "fabric-extension-lib.children.field.allChildren.label",
        defaultMessage: "Show all child items"
    },
    allLabel: {
        id: "fabric-extension-lib.children.field.all.label",
        defaultMessage: "Show all levels"
    },
    depthLabel: {
        id: "fabric-extension-lib.children.field.depth.label",
        defaultMessage: "Max number of levels"
    },
    excerptTypeLabel: {
        id: "fabric-extension-lib.children.field.excerptType.label",
        defaultMessage: "Display preview"
    },
    excerptTypeDescription: {
        id: "fabric-extension-lib.children.field.excerptType.description",
        defaultMessage: "Lists can display a preview of the top of a child item, or the content of its excerpt."
    },
    firstLabel: {
        id: "fabric-extension-lib.children.field.first.label",
        defaultMessage: "Max number in list"
    },
    sortLabel: {
        id: "fabric-extension-lib.children.field.sort.label",
        defaultMessage: "Sort order"
    },
    styleLabel: {
        id: "fabric-extension-lib.children.field.style.label",
        defaultMessage: "List style"
    },
    basicTabLabel: {
        id: "fabric-extension-lib.config.tab.basic.label",
        defaultMessage: "Basic"
    },
    displayTabLabel: {
        id: "fabric-extension-lib.config.tab.display.label",
        defaultMessage: "Display"
    }
});
const $862710ac50c04301$export$e7de9fb1789252ba = (0, $2nPZH.defineMessages)({
    one: {
        id: "fabric-extension-lib.children.field.depth.item.one",
        defaultMessage: "1 level"
    },
    two: {
        id: "fabric-extension-lib.children.field.depth.item.two",
        defaultMessage: "2 levels"
    },
    three: {
        id: "fabric-extension-lib.children.field.depth.item.three",
        defaultMessage: "3 levels"
    },
    four: {
        id: "fabric-extension-lib.children.field.depth.item.four",
        defaultMessage: "4 levels"
    },
    five: {
        id: "fabric-extension-lib.children.field.depth.item.five",
        defaultMessage: "5 levels"
    },
    six: {
        id: "fabric-extension-lib.children.field.depth.item.six",
        defaultMessage: "6 levels"
    },
    seven: {
        id: "fabric-extension-lib.children.field.depth.item.seven",
        defaultMessage: "7 levels"
    },
    eight: {
        id: "fabric-extension-lib.children.field.depth.item.eight",
        defaultMessage: "8 levels"
    },
    nine: {
        id: "fabric-extension-lib.children.field.depth.item.nine",
        defaultMessage: "9 levels"
    }
});
const $862710ac50c04301$export$22a6a8b908f4792e = (0, $2nPZH.defineMessages)({
    titleGroup: {
        id: "fabric-extension-lib.children.field.sort.group.title",
        defaultMessage: "Title"
    },
    titleItem: {
        id: "fabric-extension-lib.children.field.sort.item.title",
        defaultMessage: "A \u2192 Z"
    },
    titleReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.titlereverse",
        defaultMessage: "Z \u2192 A"
    },
    creationGroup: {
        id: "fabric-extension-lib.children.field.sort.group.creation",
        defaultMessage: "Created"
    },
    creationItem: {
        id: "fabric-extension-lib.children.field.sort.item.creation",
        defaultMessage: "Newest \u2192 Oldest"
    },
    creationReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.creationreverse",
        defaultMessage: "Oldest \u2192 Newest"
    },
    modifiedGroup: {
        id: "fabric-extension-lib.children.field.sort.group.modified",
        defaultMessage: "Modified"
    },
    modifiedItem: {
        id: "fabric-extension-lib.children.field.sort.item.modified",
        defaultMessage: "Old \u2192 Recent"
    },
    modifiedReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.modifiednreverse",
        defaultMessage: "Recent \u2192 Old"
    },
    defaultGroup: {
        id: "fabric-extension-lib.children.field.sort.group.default",
        defaultMessage: "Content Tree"
    },
    defaultItem: {
        id: "fabric-extension-lib.children.field.sort.item.default",
        defaultMessage: "Current"
    },
    defaultReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.defaultreverse",
        defaultMessage: "Reverse"
    }
});
const $862710ac50c04301$export$937ee27e4f72fd9f = (0, $2nPZH.defineMessages)({
    default: {
        id: "fabric-extension-lib.children.field.style.item.default",
        defaultMessage: "Bulleted"
    },
    h1: {
        id: "fabric-extension-lib.children.field.style.item.h1",
        defaultMessage: "H1"
    },
    h2: {
        id: "fabric-extension-lib.children.field.style.item.h2",
        defaultMessage: "H2"
    },
    h3: {
        id: "fabric-extension-lib.children.field.style.item.h3",
        defaultMessage: "H3"
    },
    h4: {
        id: "fabric-extension-lib.children.field.style.item.h4",
        defaultMessage: "H4"
    },
    h5: {
        id: "fabric-extension-lib.children.field.style.item.h5",
        defaultMessage: "H5"
    },
    h6: {
        id: "fabric-extension-lib.children.field.style.item.h6",
        defaultMessage: "H6"
    }
});
const $862710ac50c04301$export$981659feafe35cff = (0, $2nPZH.defineMessages)({
    none: {
        id: "fabric-extension-lib.children.field.excerptType.item.none",
        defaultMessage: "None"
    },
    richContent: {
        id: "fabric-extension-lib.children.field.excerptType.item.richContent",
        defaultMessage: "Preview content"
    },
    simple: {
        id: "fabric-extension-lib.children.field.excerptType.item.simple",
        defaultMessage: "Excerpt preview"
    }
});

});

parcelRegister("a3IVB", function(module, exports) {

$parcel$export(module.exports, "childMacroFields", () => $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7);
$parcel$export(module.exports, "validateDepthFields", () => $8b7d499a5aa031b6$export$d0c9dc351b89eb65);
$parcel$export(module.exports, "getBasicTabFields", () => $8b7d499a5aa031b6$export$e9aa8a2eb319b54d);

var $gKnE9 = parcelRequire("gKnE9");

var $foorG = parcelRequire("foorG");
const $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7 = (name, fields, intl, defaultValue)=>{
    let field;
    switch(name){
        case 'page':
            field = {
                ...fields['page'],
                label: intl.formatMessage((0, $foorG.i18n).pageLabel),
                placeholder: intl.formatMessage((0, $foorG.i18n).pagePlaceholder),
                description: ''
            };
            break;
        case 'allChildren':
            field = {
                name: 'allChildren',
                type: 'boolean',
                style: 'toggle',
                label: intl.formatMessage((0, $foorG.i18n).allChildren),
                description: '',
                defaultValue: defaultValue,
                isHidden: false,
                isMultiple: false,
                isRequired: false
            };
            break;
        case 'first':
            field = {
                ...fields['first'],
                label: intl.formatMessage((0, $foorG.i18n).firstLabel),
                description: ''
            };
            break;
        case 'all':
            field = {
                ...fields['all'],
                style: 'toggle',
                defaultValue: 'false',
                label: intl.formatMessage((0, $foorG.i18n).allLabel)
            };
            break;
        case 'depth':
            field = {
                ...fields['depth'],
                type: 'enum',
                style: 'select',
                defaultValue: '1',
                isMultiple: false,
                label: intl.formatMessage((0, $foorG.i18n).depthLabel),
                items: [
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).one),
                        value: '1'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).two),
                        value: '2'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).three),
                        value: '3'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).four),
                        value: '4'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).five),
                        value: '5'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).six),
                        value: '6'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).seven),
                        value: '7'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).eight),
                        value: '8'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nDepth).nine),
                        value: '9'
                    }
                ]
            };
            break;
        case 'sort':
            field = {
                ...fields['sort'],
                name: 'sortAndReverse',
                type: 'enum',
                style: 'select',
                label: intl.formatMessage((0, $foorG.i18n).sortLabel),
                defaultValue: '',
                items: [
                    {
                        label: intl.formatMessage((0, $foorG.i18nSort).defaultGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $foorG.i18nSort).defaultItem),
                                value: ''
                            },
                            {
                                label: intl.formatMessage((0, $foorG.i18nSort).defaultReverseItem),
                                value: '.true'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nSort).titleGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $foorG.i18nSort).titleItem),
                                value: 'title'
                            },
                            {
                                label: intl.formatMessage((0, $foorG.i18nSort).titleReverseItem),
                                value: 'title.true'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nSort).creationGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $foorG.i18nSort).creationItem),
                                value: 'creation.true'
                            },
                            {
                                label: intl.formatMessage((0, $foorG.i18nSort).creationReverseItem),
                                value: 'creation'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nSort).modifiedGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $foorG.i18nSort).modifiedReverseItem),
                                value: 'modified.true'
                            },
                            {
                                label: intl.formatMessage((0, $foorG.i18nSort).modifiedItem),
                                value: 'modified'
                            }
                        ]
                    }
                ]
            };
            break;
        case 'style':
            field = {
                ...fields['style'],
                label: intl.formatMessage((0, $foorG.i18n).styleLabel),
                defaultValue: '',
                items: [
                    {
                        label: intl.formatMessage((0, $foorG.i18nStyle).default),
                        value: ''
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nStyle).h1),
                        value: 'h1'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nStyle).h2),
                        value: 'h2'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nStyle).h3),
                        value: 'h3'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nStyle).h4),
                        value: 'h4'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nStyle).h5),
                        value: 'h5'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nStyle).h6),
                        value: 'h6'
                    }
                ]
            };
            break;
        case 'excerptType':
            field = {
                ...fields['excerptType'],
                label: intl.formatMessage((0, $foorG.i18n).excerptTypeLabel),
                description: intl.formatMessage((0, $foorG.i18n).excerptTypeDescription),
                items: [
                    {
                        label: intl.formatMessage((0, $foorG.i18nExcerptType).none),
                        value: 'none'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nExcerptType).richContent),
                        value: 'rich content'
                    },
                    {
                        label: intl.formatMessage((0, $foorG.i18nExcerptType).simple),
                        value: 'simple'
                    }
                ]
            };
            break;
    }
    return field;
};
const $8b7d499a5aa031b6$export$d0c9dc351b89eb65 = (all, depth)=>{
    if (all && depth > 0) return false;
    return all;
};
const $8b7d499a5aa031b6$export$e9aa8a2eb319b54d = (name, fields, intl, currentParams)=>{
    if (name === 'page') return $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('page', fields, intl);
    const result = [];
    if (name === 'first') {
        // "Max number in list" field
        // Add an FE-only toggle field `allChildren` to conditionally display the "Max # in list" (`first`) field
        // Since it's an FE-only param, dynamically set its defaultValue depending on `first` param's current value
        // Toggle is TRUE if `first` is undefined or 0, i.e. no child page limit
        const defaultValue = !currentParams?.macroParams?.first?.value || parseInt(currentParams.macroParams.first.value) === 0 ? 'true' : 'false';
        result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('allChildren', fields, intl, defaultValue));
        // If param is null (i.e. on initial load), manually update its state
        if (currentParams?.macroParams && !currentParams.macroParams.allChildren) currentParams.macroParams.allChildren = {
            value: defaultValue
        };
        // Only render "Max number in list" field when toggle is FALSE
        if (!(0, $gKnE9.parseBoolean)(currentParams?.macroParams?.allChildren?.value)) result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('first', fields, intl));
    }
    if (name === 'all') {
        // "Show all levels" toggle
        result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('all', fields, intl));
        // Only render "Max number of levels" field when `all` toggle is FALSE
        // (or edge case described in validateDepthFields)
        if (!$8b7d499a5aa031b6$export$d0c9dc351b89eb65((0, $gKnE9.parseBoolean)(currentParams?.macroParams?.all?.value), parseInt(currentParams?.macroParams?.depth?.value ?? ''))) result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('depth', fields, intl));
    }
    return result;
};

});


parcelRegister("7kVCu", function(module, exports) {

$parcel$export(module.exports, "excerpt", () => $0f335227b4c76418$export$f8e8f85027c88e59);
const $0f335227b4c76418$export$f8e8f85027c88e59 = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            // Mark this field as required in the FE to display the UI red asterisk, but we will not
            // enforce it in the backend as this breaks existing untitled excerpts
            if (field.name === 'name') return {
                ...field,
                isRequired: true
            };
            return field;
        });
    }
};

});

parcelRegister("5NdPE", function(module, exports) {

$parcel$export(module.exports, "details", () => $2d464ae24baf1d6f$export$41ee12f6f6f05843);

var $2nPZH = parcelRequire("2nPZH");

var $9wGTI = parcelRequire("9wGTI");
const $2d464ae24baf1d6f$var$i18n = (0, $2nPZH.defineMessages)({
    fieldIdLabel: {
        id: "fabric-extension-lib.field-mappings.details.field.id.label",
        defaultMessage: "Content properties ID (optional)"
    },
    fieldIdDescription: {
        id: "fabric-extension-lib.field-mappings.details.field.id.description",
        defaultMessage: "Specify an ID if you have multiple content properties macros on this page or doc and want to report on them separately."
    },
    fieldHiddenLabel: {
        id: "fabric-extension-lib.field-mappings.details.field.hidden.label",
        defaultMessage: "Hide from view"
    },
    fieldHiddenDescription: {
        id: "fabric-extension-lib.field-mappings.details.field.hidden.description",
        defaultMessage: "Hide macro contents from view, but continue to display them in the Content Properties Report macro."
    }
});
const $2d464ae24baf1d6f$export$41ee12f6f6f05843 = {
    transformFields: async ({ fields: fields, intl: intl, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled })=>{
        if (isLivePagesFeatureEnabled && (0, $9wGTI.fg)('confluence_live_pages_macro_copy_updates')) return fields.map((field)=>{
            if (field.name === 'id') return {
                ...field,
                label: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldIdLabel),
                description: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldIdDescription)
            };
            if (field.name === 'hidden') return {
                ...field,
                label: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldHiddenLabel),
                description: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldHiddenDescription)
            };
            return field;
        });
        return fields;
    }
};

});



parcelRegister("j1x6W", function(module, exports) {

$parcel$export(module.exports, "getQuickInsertAction", () => $7b3d41287d889ce8$export$5f32dd5e0bdce03);

var $2nPZH = parcelRequire("2nPZH");

var $kyKWe = parcelRequire("kyKWe");

var $jhwJP = parcelRequire("jhwJP");

var $4VJDS = parcelRequire("4VJDS");

var $9wGTI = parcelRequire("9wGTI");

var $fgbpl = parcelRequire("fgbpl");

var $2E7zk = parcelRequire("2E7zk");

var $X5KYY = parcelRequire("X5KYY");
const $7b3d41287d889ce8$var$i18nBase = (0, $2nPZH.defineMessages)({
    excerptPlaceholder: {
        id: "fabric-extension-lib.excerpt.placeholder",
        defaultMessage: "Type or paste something here to turn it into an excerpt."
    },
    pagePropertiesPlaceholder: {
        id: "fabric-extension-lib.page.properties.placeholder",
        defaultMessage: "Add a table with key/value pairs in order to display its data on another page using the Page Properties Report macro."
    },
    tocZonePlaceholder: {
        id: "fabric-extension-lib.toc.zone.placeholder",
        defaultMessage: "A table of contents based on the headings within this frame will appear here."
    }
});
const $7b3d41287d889ce8$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    pagePropertiesPlaceholder: {
        id: "fabric-extension-lib.page.properties.placeholder.livedocs",
        defaultMessage: "Add a table with key/value pairs in order to display its data on another page or doc using the Page Properties Report macro."
    },
    contentPropertiesPlaceholder: {
        id: "fabric-extension-lib.content.properties.placeholder.livedocs",
        defaultMessage: "Add a table with key/value pairs in order to display its data on another page or doc using a content properties report macro."
    }
});
const $7b3d41287d889ce8$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($7b3d41287d889ce8$var$i18nBase, $7b3d41287d889ce8$var$i18nLiveDocs);
const $7b3d41287d889ce8$var$maybeGetGadgetUrl = (macro)=>macro.macroName === 'gadget' && macro?.formDetails?.parameters?.[0]?.defaultValue && {
        gadgetUrl: new URL(// This is gross, but this is the only way to get the URL of the
        // the gadget. We use the same url in the view event to know
        // which gadget was actually inserted, thus track gadget usage
        macro.formDetails.parameters[0].defaultValue, location.origin).pathname
    };
const $7b3d41287d889ce8$var$createBaseMacroAction = (macro, pageContext, intl, createAnalyticsEvent, isLivePage = false, isLivePagesFeatureEnabled)=>async ()=>{
        const node = await (0, $X5KYY.prepareMacro)({
            name: macro.macroName
        }, pageContext.contentId, null, intl, isLivePagesFeatureEnabled);
        if (macro.macroName === 'excerpt') (0, $2E7zk.insertMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.excerptPlaceholder));
        if (macro.macroName === 'details') {
            // Once confluence_live_pages_macro_copy_updates is launched, the contents of contentPropertiesPlaceholder can replace i18n.pagePropertiesPlaceholder
            // for users with live docs, so then we can just directly use i18n.pagePropertiesPlaceholder and remove this if statement.
            if (isLivePagesFeatureEnabled && (0, $9wGTI.fg)('confluence_live_pages_macro_copy_updates')) (0, $2E7zk.insertMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$var$i18nLiveDocs.contentPropertiesPlaceholder));
            else (0, $2E7zk.insertMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.pagePropertiesPlaceholder));
        }
        if (macro.macroName === 'toc-zone') (0, $2E7zk.insertMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.tocZonePlaceholder));
        const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
        if (createAnalyticsEvent) {
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
        return node;
    };
const $7b3d41287d889ce8$var$createActionForMacrosThatRequireMacroBrowser = (macro, openMacroBrowserForInitialConfiguration, editorAPI, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage = false)=>async ()=>{
        if (!macroBrowserConfig) throw new Error(`Macro Browser Config is missing`);
        if (!editorActions) throw new Error(`editorActions is missing`);
        const macroFilter = undefined;
        const extensionAnalyticsInfo = {
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: macroBrowserConfig.contentId
        };
        const updateMacro = (node)=>{
            const selectedNode = (0, $2E7zk.getSelectedBodiedExtensionNode)(editorActions);
            if (selectedNode) editorAPI?.extension?.actions?.editSelectedExtension();
            else {
                // initial insert of the roadmap macro
                editorActions.replaceSelection(node);
                editorAPI?.extension?.actions?.editSelectedExtension();
            }
        };
        const node = await openMacroBrowserForInitialConfiguration(macro, macroBrowserConfig, macroFilter, extensionAnalyticsInfo, onCompleteCallback, updateMacro);
        const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
        if (editorActions.replaceSelection(node) && createAnalyticsEvent) {
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        inputMethod: 'macroBrowser',
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
    };
const $7b3d41287d889ce8$var$createActionForMacrosThatCanUseNewConfig = (macro, pageContext, intl, editorAPI, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage = false, isLivePagesFeatureEnabled)=>async ()=>{
        if (!editorActions) throw new Error(`editorActions is missing`);
        const getNode = $7b3d41287d889ce8$var$createBaseMacroAction(macro, pageContext, intl, undefined, isLivePage, isLivePagesFeatureEnabled);
        const node = await getNode();
        // Default the TOC style to none
        if (node?.attrs?.extensionKey === 'toc') {
            if (node?.attrs?.parameters?.macroParams) node.attrs.parameters.macroParams['style'] = {
                value: 'none'
            };
        }
        // Default the anchor macro name to a random UUID
        if (node?.attrs?.extensionKey === 'anchor') {
            if (node?.attrs?.parameters?.macroParams) node.attrs.parameters.macroParams[''] = {
                value: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
            };
        }
        // Add a param to show that the macro is missing required parameters
        const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = node.attrs;
        if ((0, $X5KYY.isMissingAnyRequiredParameters)(macro, {
            extensionType: extensionType,
            extensionKey: extensionKey,
            parameters: parameters
        })) {
            if (node.attrs.parameters?.macroParams) node.attrs.parameters.macroParams['isMissingRequiredParameters'] = {
                // Need to be `string` to be able to persist
                value: 'true'
            };
        }
        if (editorActions.replaceSelection(node) && createAnalyticsEvent) {
            const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        inputMethod: 'configPanel',
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
        editorAPI?.extension?.actions?.editSelectedExtension();
        onCompleteCallback?.({
            macro: macro.macroName,
            isBodiedExtension: (0, $fgbpl.isBodiedExtension)(node?.type)
        });
    };
const $7b3d41287d889ce8$export$5f32dd5e0bdce03 = (macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled)=>{
    const { enabled: isConfigPanelEnabled, optedOut: excludedMacros } = pageContext.features.configPanel || {};
    // using the detailed legacy macro manifest list, the attributes `anyParameterRequired` and `alwaysShowConfig` are not available so we need to calculate ourselves
    const hasRequiredParameter = macro.anyParameterRequired || macro.formDetails.parameters.some((param)=>param.required && param.defaultValue === null);
    const useNewConfigExperience = isConfigPanelEnabled && !(0, $X5KYY.shouldUseMacroBrowser)(macro, excludedMacros);
    const showInitialConfig = // always show the config panel if we are using the new config experience
    useNewConfigExperience || hasRequiredParameter || macro.alwaysShowConfig || (0, $X5KYY.needsToForceConfig)(macro);
    if (showInitialConfig) {
        if (!useNewConfigExperience) return $7b3d41287d889ce8$var$createActionForMacrosThatRequireMacroBrowser(macro, openMacroBrowserForInitialConfiguration, editorAPI, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage);
        else return $7b3d41287d889ce8$var$createActionForMacrosThatCanUseNewConfig(macro, pageContext, intl, editorAPI, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled);
    } else return $7b3d41287d889ce8$var$createBaseMacroAction(macro, pageContext, intl, createAnalyticsEvent, isLivePage, isLivePagesFeatureEnabled);
};
const $7b3d41287d889ce8$export$f3046997f1755ab7 = async (macroKey)=>{
    if (!macroKey) return undefined;
    const macroFallbackUiAllowlist = (0, $4VJDS.default).getStringList('confluence_frontend_macro_fallback_ui_allowlist', []);
    if (macroFallbackUiAllowlist.length === 0) return undefined;
    else if (macroFallbackUiAllowlist[0] === 'ALLOW_ALL') return true;
    const macros = macroFallbackUiAllowlist.map((m)=>m.trim().toLowerCase());
    return macros.includes(macroKey.toLowerCase());
};

});




parcelRegister("6AplS", function(module, exports) {

$parcel$export(module.exports, "mainContentSelector", () => $9fad9b244fc806cb$export$ff57b14bf41d4f9d);
$parcel$export(module.exports, "extractCSS", () => $9fad9b244fc806cb$export$506216bb8c62ec77);
$parcel$export(module.exports, "scopeCSS", () => $9fad9b244fc806cb$export$5cc9f764c97a719a);

var $6v6w3 = parcelRequire("6v6w3");
var $9fad9b244fc806cb$require$minify = $6v6w3.minify;
var $9fad9b244fc806cb$require$syntax = $6v6w3.syntax;
const $9fad9b244fc806cb$var$styleMacroBoundryCSSSelectors = [
    {
        name: 'main-content',
        type: 'IdSelector'
    },
    {
        name: 'content',
        type: 'IdSelector'
    },
    {
        name: 'wiki-content',
        type: 'ClassSelector'
    }
];
const $9fad9b244fc806cb$export$ff57b14bf41d4f9d = '#main-content';
const $9fad9b244fc806cb$var$styleMacroRegex = /(<style[^>]*data-macro-name="style"[^>]*>)((.|\n|\r)*?)(<\/style>)/gm;
function $9fad9b244fc806cb$var$addScopeBoundry(css, scope) {
    const ast = $9fad9b244fc806cb$require$syntax.parse(css);
    const combinatorObj = {
        type: 'Combinator',
        loc: null,
        name: ' '
    };
    $9fad9b244fc806cb$require$syntax.walk(ast, (node)=>{
        // Remove CSS imported from URL as thet can't be scoped and styles can leak to entire application
        if (node.type === 'Atrule' && node.name === 'import') node.prelude?.children.forEach((child)=>{
            if (child.type === 'Url') child.value = '';
        });
        if (node.type === 'Selector') {
            const isFirstChildPseudoClass = node.children?.first.type === 'PseudoClassSelector';
            const isFirstChildCombinator = node.children?.first.type === 'Combinator';
            const existingBoundry = $9fad9b244fc806cb$require$syntax.find(node, (n)=>$9fad9b244fc806cb$var$styleMacroBoundryCSSSelectors.find((selector)=>selector.name === n.name && selector.type === n.type));
            if (!Boolean(existingBoundry) && !Boolean(isFirstChildPseudoClass) && !Boolean(isFirstChildCombinator)) {
                const styleMacroBoundryAST = $9fad9b244fc806cb$require$syntax.parse(scope, {
                    context: 'selector'
                });
                const styleMacroBoundryNode = node.children.createItem(styleMacroBoundryAST.children.first);
                const combinatorNode = node.children.createItem($9fad9b244fc806cb$require$syntax.fromPlainObject(combinatorObj));
                node.children.prepend(combinatorNode);
                node.children.prepend(styleMacroBoundryNode);
            }
        }
    });
    const scopedCSS = $9fad9b244fc806cb$require$syntax.generate(ast);
    let minified = '';
    try {
        minified = $9fad9b244fc806cb$require$minify(scopedCSS).css;
    } finally{
        return minified || scopedCSS;
    }
}
function $9fad9b244fc806cb$export$506216bb8c62ec77(html) {
    const matches = html.matchAll($9fad9b244fc806cb$var$styleMacroRegex);
    const matchedCSS = [];
    for (const match of matches)if (match[2]) matchedCSS.push(match[2]);
    return matchedCSS;
}
function $9fad9b244fc806cb$export$5cc9f764c97a719a(html = '', scopeSelector = $9fad9b244fc806cb$export$ff57b14bf41d4f9d, regex = $9fad9b244fc806cb$var$styleMacroRegex) {
    const matches = html.matchAll(regex);
    const CSSForAnalytics = [];
    for (const match of matches)if (match[2]) {
        const originalCSS = match[2];
        const scopedCSS = $9fad9b244fc806cb$var$addScopeBoundry(originalCSS, scopeSelector);
        CSSForAnalytics.push({
            originalCSS: originalCSS,
            scopedCSS: scopedCSS
        });
        html = html.replace(match[2], scopedCSS);
    }
    return {
        contentWithScopedCSS: html,
        CSSForAnalytics: CSSForAnalytics
    };
}

});
parcelRegister("6v6w3", function(module, exports) {

$parcel$export(module.exports, "syntax", () => $4bbab1411e171c4e$export$e07e737eb4e4eeba, (v) => $4bbab1411e171c4e$export$e07e737eb4e4eeba = v);
$parcel$export(module.exports, "minify", () => $4bbab1411e171c4e$export$8e388a857ed0c062, (v) => $4bbab1411e171c4e$export$8e388a857ed0c062 = v);
var $4bbab1411e171c4e$export$83d89fbfd8236492;
var $4bbab1411e171c4e$export$e07e737eb4e4eeba;
var $4bbab1411e171c4e$export$eab97d15b1788b8d;
var $4bbab1411e171c4e$export$8e388a857ed0c062;
var $4bbab1411e171c4e$export$50c32ca09add9a32;
'use strict';

var $eYUQE = parcelRequire("eYUQE");

var $j2SRr = parcelRequire("j2SRr");

var $girxf = parcelRequire("girxf");
const { parse: $4bbab1411e171c4e$var$parse, generate: $4bbab1411e171c4e$var$generate, compress: $4bbab1411e171c4e$var$compress } = $j2SRr;
function $4bbab1411e171c4e$var$debugOutput(name, options, startTime, data) {
    if (options.debug) console.error(`## ${name} done in %d ms\n`, Date.now() - startTime);
    return data;
}
function $4bbab1411e171c4e$var$createDefaultLogger(level) {
    let lastDebug;
    return function logger(title, ast) {
        let line = title;
        if (ast) line = `[${((Date.now() - lastDebug) / 1000).toFixed(3)}s] ${line}`;
        if (level > 1 && ast) {
            let css = $4bbab1411e171c4e$var$generate(ast);
            // when level 2, limit css to 256 symbols
            if (level === 2 && css.length > 256) css = css.substr(0, 256) + '...';
            line += `\n  ${css}\n`;
        }
        console.error(line);
        lastDebug = Date.now();
    };
}
function $4bbab1411e171c4e$var$buildCompressOptions(options) {
    options = {
        ...options
    };
    if (typeof options.logger !== 'function' && options.debug) options.logger = $4bbab1411e171c4e$var$createDefaultLogger(options.debug);
    return options;
}
function $4bbab1411e171c4e$var$runHandler(ast, options, handlers) {
    if (!Array.isArray(handlers)) handlers = [
        handlers
    ];
    handlers.forEach((fn)=>fn(ast, options));
}
function $4bbab1411e171c4e$var$minify(context, source, options) {
    options = options || {};
    const filename = options.filename || '<unknown>';
    let result;
    // parse
    const ast = $4bbab1411e171c4e$var$debugOutput('parsing', options, Date.now(), $4bbab1411e171c4e$var$parse(source, {
        context: context,
        filename: filename,
        positions: Boolean(options.sourceMap)
    }));
    // before compress handlers
    if (options.beforeCompress) $4bbab1411e171c4e$var$debugOutput('beforeCompress', options, Date.now(), $4bbab1411e171c4e$var$runHandler(ast, options, options.beforeCompress));
    // compress
    const compressResult = $4bbab1411e171c4e$var$debugOutput('compress', options, Date.now(), $4bbab1411e171c4e$var$compress(ast, $4bbab1411e171c4e$var$buildCompressOptions(options)));
    // after compress handlers
    if (options.afterCompress) $4bbab1411e171c4e$var$debugOutput('afterCompress', options, Date.now(), $4bbab1411e171c4e$var$runHandler(compressResult, options, options.afterCompress));
    // generate
    if (options.sourceMap) result = $4bbab1411e171c4e$var$debugOutput('generate(sourceMap: true)', options, Date.now(), (()=>{
        const tmp = $4bbab1411e171c4e$var$generate(compressResult.ast, {
            sourceMap: true
        });
        tmp.map._file = filename; // since other tools can relay on file in source map transform chain
        tmp.map.setSourceContent(filename, source);
        return tmp;
    })());
    else result = $4bbab1411e171c4e$var$debugOutput('generate', options, Date.now(), {
        css: $4bbab1411e171c4e$var$generate(compressResult.ast),
        map: null
    });
    return result;
}
function $4bbab1411e171c4e$var$minifyStylesheet(source, options) {
    return $4bbab1411e171c4e$var$minify('stylesheet', source, options);
}
function $4bbab1411e171c4e$var$minifyBlock(source, options) {
    return $4bbab1411e171c4e$var$minify('declarationList', source, options);
}
$4bbab1411e171c4e$export$83d89fbfd8236492 = $eYUQE.version;
$4bbab1411e171c4e$export$e07e737eb4e4eeba = $j2SRr;
$4bbab1411e171c4e$export$eab97d15b1788b8d = $girxf;
$4bbab1411e171c4e$export$8e388a857ed0c062 = $4bbab1411e171c4e$var$minifyStylesheet;
$4bbab1411e171c4e$export$50c32ca09add9a32 = $4bbab1411e171c4e$var$minifyBlock;

});
parcelRegister("eYUQE", function(module, exports) {
module.exports = "5.0.5";

});

parcelRegister("j2SRr", function(module, exports) {

$parcel$export(module.exports, "compress", () => $ddd8c2730f632619$export$80908c17a05abbe5, (v) => $ddd8c2730f632619$export$80908c17a05abbe5 = v);
$parcel$export(module.exports, "specificity", () => $ddd8c2730f632619$export$37de5b62848a0d8, (v) => $ddd8c2730f632619$export$37de5b62848a0d8 = v);
$parcel$export(module.exports, "find", () => $ddd8c2730f632619$export$71aa6c912b956294, (v) => $ddd8c2730f632619$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "findAll", () => $ddd8c2730f632619$export$18200ea6c8035394, (v) => $ddd8c2730f632619$export$18200ea6c8035394 = v);
$parcel$export(module.exports, "findLast", () => $ddd8c2730f632619$export$296de88ccac4bedb, (v) => $ddd8c2730f632619$export$296de88ccac4bedb = v);
$parcel$export(module.exports, "fromPlainObject", () => $ddd8c2730f632619$export$208fdd74c481bdd3, (v) => $ddd8c2730f632619$export$208fdd74c481bdd3 = v);
$parcel$export(module.exports, "generate", () => $ddd8c2730f632619$export$80d376111cc09ad7, (v) => $ddd8c2730f632619$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "lexer", () => $ddd8c2730f632619$export$43feed32102720d2, (v) => $ddd8c2730f632619$export$43feed32102720d2 = v);
$parcel$export(module.exports, "parse", () => $ddd8c2730f632619$export$98e6a39c04603d36, (v) => $ddd8c2730f632619$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "toPlainObject", () => $ddd8c2730f632619$export$8530f7b85295aab2, (v) => $ddd8c2730f632619$export$8530f7b85295aab2 = v);
$parcel$export(module.exports, "tokenize", () => $ddd8c2730f632619$export$660b2ee2d4fb4eff, (v) => $ddd8c2730f632619$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "walk", () => $ddd8c2730f632619$export$588732934346abbf, (v) => $ddd8c2730f632619$export$588732934346abbf = v);
var $ddd8c2730f632619$export$80908c17a05abbe5;
var $ddd8c2730f632619$export$37de5b62848a0d8;
var $ddd8c2730f632619$export$71aa6c912b956294;
var $ddd8c2730f632619$export$18200ea6c8035394;
var $ddd8c2730f632619$export$296de88ccac4bedb;
var $ddd8c2730f632619$export$208fdd74c481bdd3;
var $ddd8c2730f632619$export$80d376111cc09ad7;
var $ddd8c2730f632619$export$43feed32102720d2;
var $ddd8c2730f632619$export$98e6a39c04603d36;
var $ddd8c2730f632619$export$8530f7b85295aab2;
var $ddd8c2730f632619$export$660b2ee2d4fb4eff;
var $ddd8c2730f632619$export$588732934346abbf;
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $l2JNJ = parcelRequire("l2JNJ");

var $iePWG = parcelRequire("iePWG");
function $ddd8c2730f632619$var$encodeString(value) {
    const stringApostrophe = $bi5JI.string.encode(value, true);
    const stringQuote = $bi5JI.string.encode(value);
    return stringApostrophe.length < stringQuote.length ? stringApostrophe : stringQuote;
}
const { lexer: $ddd8c2730f632619$var$lexer, tokenize: $ddd8c2730f632619$var$tokenize, parse: $ddd8c2730f632619$var$parse, generate: $ddd8c2730f632619$var$generate, walk: $ddd8c2730f632619$var$walk, find: $ddd8c2730f632619$var$find, findLast: $ddd8c2730f632619$var$findLast, findAll: $ddd8c2730f632619$var$findAll, fromPlainObject: $ddd8c2730f632619$var$fromPlainObject, toPlainObject: $ddd8c2730f632619$var$toPlainObject } = $bi5JI.fork({
    node: {
        String: {
            generate (node) {
                this.token($bi5JI.tokenTypes.String, $ddd8c2730f632619$var$encodeString(node.value));
            }
        },
        Url: {
            generate (node) {
                const encodedUrl = $bi5JI.url.encode(node.value);
                const string = $ddd8c2730f632619$var$encodeString(node.value);
                this.token($bi5JI.tokenTypes.Url, encodedUrl.length <= string.length + 5 /* "url()".length */  ? encodedUrl : 'url(' + string + ')');
            }
        }
    }
});
$ddd8c2730f632619$export$80908c17a05abbe5 = $l2JNJ;
$ddd8c2730f632619$export$37de5b62848a0d8 = $iePWG;
$ddd8c2730f632619$export$71aa6c912b956294 = $ddd8c2730f632619$var$find;
$ddd8c2730f632619$export$18200ea6c8035394 = $ddd8c2730f632619$var$findAll;
$ddd8c2730f632619$export$296de88ccac4bedb = $ddd8c2730f632619$var$findLast;
$ddd8c2730f632619$export$208fdd74c481bdd3 = $ddd8c2730f632619$var$fromPlainObject;
$ddd8c2730f632619$export$80d376111cc09ad7 = $ddd8c2730f632619$var$generate;
$ddd8c2730f632619$export$43feed32102720d2 = $ddd8c2730f632619$var$lexer;
$ddd8c2730f632619$export$98e6a39c04603d36 = $ddd8c2730f632619$var$parse;
$ddd8c2730f632619$export$8530f7b85295aab2 = $ddd8c2730f632619$var$toPlainObject;
$ddd8c2730f632619$export$660b2ee2d4fb4eff = $ddd8c2730f632619$var$tokenize;
$ddd8c2730f632619$export$588732934346abbf = $ddd8c2730f632619$var$walk;

});
parcelRegister("bi5JI", function(module, exports) {

$parcel$export(module.exports, "List", () => $8385d3422905a1b5$export$54c2e3dc7acea9f5, (v) => $8385d3422905a1b5$export$54c2e3dc7acea9f5 = v);
$parcel$export(module.exports, "clone", () => $8385d3422905a1b5$export$9cd59f9826255e47, (v) => $8385d3422905a1b5$export$9cd59f9826255e47 = v);
$parcel$export(module.exports, "keyword", () => $8385d3422905a1b5$export$2e81050496d0e63e, (v) => $8385d3422905a1b5$export$2e81050496d0e63e = v);
$parcel$export(module.exports, "property", () => $8385d3422905a1b5$export$d541bacb2bda4494, (v) => $8385d3422905a1b5$export$d541bacb2bda4494 = v);
$parcel$export(module.exports, "string", () => $8385d3422905a1b5$export$22b082955e083ec3, (v) => $8385d3422905a1b5$export$22b082955e083ec3 = v);
$parcel$export(module.exports, "url", () => $8385d3422905a1b5$export$128fa18b7194ef, (v) => $8385d3422905a1b5$export$128fa18b7194ef = v);
$parcel$export(module.exports, "tokenTypes", () => $8385d3422905a1b5$export$a60b91545d7e19fc, (v) => $8385d3422905a1b5$export$a60b91545d7e19fc = v);
$parcel$export(module.exports, "fork", () => $8385d3422905a1b5$export$7a5058c6b79333e0, (v) => $8385d3422905a1b5$export$7a5058c6b79333e0 = v);
$parcel$export(module.exports, "generate", () => $8385d3422905a1b5$export$80d376111cc09ad7, (v) => $8385d3422905a1b5$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "lexer", () => $8385d3422905a1b5$export$43feed32102720d2, (v) => $8385d3422905a1b5$export$43feed32102720d2 = v);
$parcel$export(module.exports, "parse", () => $8385d3422905a1b5$export$98e6a39c04603d36, (v) => $8385d3422905a1b5$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "walk", () => $8385d3422905a1b5$export$588732934346abbf, (v) => $8385d3422905a1b5$export$588732934346abbf = v);
var $8385d3422905a1b5$export$83d89fbfd8236492;
var $8385d3422905a1b5$export$ef7698fd92a0afb9;
var $8385d3422905a1b5$export$54c2e3dc7acea9f5;
var $8385d3422905a1b5$export$6168dc8908a6c652;
var $8385d3422905a1b5$export$1d94185c187dec3;
var $8385d3422905a1b5$export$9cd59f9826255e47;
var $8385d3422905a1b5$export$15cf667f7f91c461;
var $8385d3422905a1b5$export$2e81050496d0e63e;
var $8385d3422905a1b5$export$d541bacb2bda4494;
var $8385d3422905a1b5$export$5150dd39c4b2a5da;
var $8385d3422905a1b5$export$7b66c250b210a314;
var $8385d3422905a1b5$export$22b082955e083ec3;
var $8385d3422905a1b5$export$128fa18b7194ef;
var $8385d3422905a1b5$export$a60b91545d7e19fc;
var $8385d3422905a1b5$export$a5f6079b5a0c262e;
var $8385d3422905a1b5$export$b55edb69cfa7ac57;
var $8385d3422905a1b5$export$542413421c3f8a82;
var $8385d3422905a1b5$export$71aa6c912b956294;
var $8385d3422905a1b5$export$18200ea6c8035394;
var $8385d3422905a1b5$export$296de88ccac4bedb;
var $8385d3422905a1b5$export$7a5058c6b79333e0;
var $8385d3422905a1b5$export$208fdd74c481bdd3;
var $8385d3422905a1b5$export$80d376111cc09ad7;
var $8385d3422905a1b5$export$43feed32102720d2;
var $8385d3422905a1b5$export$98e6a39c04603d36;
var $8385d3422905a1b5$export$8530f7b85295aab2;
var $8385d3422905a1b5$export$660b2ee2d4fb4eff;
var $8385d3422905a1b5$export$588732934346abbf;
'use strict';

var $2INtZ = parcelRequire("2INtZ");

var $ktuCZ = parcelRequire("ktuCZ");

var $j0WzV = parcelRequire("j0WzV");

var $72kB1 = parcelRequire("72kB1");

var $ae5TN = parcelRequire("ae5TN");

var $7DVyC = parcelRequire("7DVyC");

var $6vDqu = parcelRequire("6vDqu");

var $jJe0G = parcelRequire("jJe0G");

var $jFe7E = parcelRequire("jFe7E");

var $lF7ah = parcelRequire("lF7ah");

var $1r7OF = parcelRequire("1r7OF");

var $iYo0F = parcelRequire("iYo0F");

var $jhzPX = parcelRequire("jhzPX");

var $3Bp4a = parcelRequire("3Bp4a");
const { tokenize: $8385d3422905a1b5$var$tokenize, parse: $8385d3422905a1b5$var$parse, generate: $8385d3422905a1b5$var$generate, lexer: $8385d3422905a1b5$var$lexer, createLexer: $8385d3422905a1b5$var$createLexer, walk: $8385d3422905a1b5$var$walk, find: $8385d3422905a1b5$var$find, findLast: $8385d3422905a1b5$var$findLast, findAll: $8385d3422905a1b5$var$findAll, toPlainObject: $8385d3422905a1b5$var$toPlainObject, fromPlainObject: $8385d3422905a1b5$var$fromPlainObject, fork: $8385d3422905a1b5$var$fork } = $2INtZ;
$8385d3422905a1b5$export$83d89fbfd8236492 = $ktuCZ.version;
$8385d3422905a1b5$export$ef7698fd92a0afb9 = $j0WzV;
$8385d3422905a1b5$export$54c2e3dc7acea9f5 = $72kB1.List;
$8385d3422905a1b5$export$6168dc8908a6c652 = $ae5TN.Lexer;
$8385d3422905a1b5$export$1d94185c187dec3 = $7DVyC;
$8385d3422905a1b5$export$9cd59f9826255e47 = $6vDqu.clone;
$8385d3422905a1b5$export$15cf667f7f91c461 = $jJe0G.isCustomProperty;
$8385d3422905a1b5$export$2e81050496d0e63e = $jJe0G.keyword;
$8385d3422905a1b5$export$d541bacb2bda4494 = $jJe0G.property;
$8385d3422905a1b5$export$5150dd39c4b2a5da = $jJe0G.vendorPrefix;
$8385d3422905a1b5$export$7b66c250b210a314 = $jFe7E;
$8385d3422905a1b5$export$22b082955e083ec3 = $lF7ah;
$8385d3422905a1b5$export$128fa18b7194ef = $1r7OF;
$8385d3422905a1b5$export$a60b91545d7e19fc = $iYo0F;
$8385d3422905a1b5$export$a5f6079b5a0c262e = $jhzPX;
$8385d3422905a1b5$export$b55edb69cfa7ac57 = $3Bp4a.TokenStream;
$8385d3422905a1b5$export$542413421c3f8a82 = $8385d3422905a1b5$var$createLexer;
$8385d3422905a1b5$export$71aa6c912b956294 = $8385d3422905a1b5$var$find;
$8385d3422905a1b5$export$18200ea6c8035394 = $8385d3422905a1b5$var$findAll;
$8385d3422905a1b5$export$296de88ccac4bedb = $8385d3422905a1b5$var$findLast;
$8385d3422905a1b5$export$7a5058c6b79333e0 = $8385d3422905a1b5$var$fork;
$8385d3422905a1b5$export$208fdd74c481bdd3 = $8385d3422905a1b5$var$fromPlainObject;
$8385d3422905a1b5$export$80d376111cc09ad7 = $8385d3422905a1b5$var$generate;
$8385d3422905a1b5$export$43feed32102720d2 = $8385d3422905a1b5$var$lexer;
$8385d3422905a1b5$export$98e6a39c04603d36 = $8385d3422905a1b5$var$parse;
$8385d3422905a1b5$export$8530f7b85295aab2 = $8385d3422905a1b5$var$toPlainObject;
$8385d3422905a1b5$export$660b2ee2d4fb4eff = $8385d3422905a1b5$var$tokenize;
$8385d3422905a1b5$export$588732934346abbf = $8385d3422905a1b5$var$walk;

});
parcelRegister("2INtZ", function(module, exports) {
'use strict';

var $j0WzV = parcelRequire("j0WzV");

var $cxuR7 = parcelRequire("cxuR7");

var $tQYnB = parcelRequire("tQYnB");

var $1WjjG = parcelRequire("1WjjG");
const $1fb6131292035ae4$var$syntax = $j0WzV({
    ...$cxuR7,
    ...$tQYnB,
    ...$1WjjG
});
module.exports = $1fb6131292035ae4$var$syntax;

});
parcelRegister("j0WzV", function(module, exports) {
'use strict';

var $2vMqe = parcelRequire("2vMqe");

var $gWOMR = parcelRequire("gWOMR");

var $cIN7t = parcelRequire("cIN7t");

var $eRSNQ = parcelRequire("eRSNQ");

var $d6Nz5 = parcelRequire("d6Nz5");

var $ae5TN = parcelRequire("ae5TN");

var $RnRNw = parcelRequire("RnRNw");
function $dd7b74e0dc1c8176$var$createSyntax(config) {
    const parse = $gWOMR.createParser(config);
    const walk = $d6Nz5.createWalker(config);
    const generate = $cIN7t.createGenerator(config);
    const { fromPlainObject: fromPlainObject, toPlainObject: toPlainObject } = $eRSNQ.createConvertor(walk);
    const syntax = {
        lexer: null,
        createLexer: (config)=>new $ae5TN.Lexer(config, syntax, syntax.lexer.structure),
        tokenize: $2vMqe.tokenize,
        parse: parse,
        generate: generate,
        walk: walk,
        find: walk.find,
        findLast: walk.findLast,
        findAll: walk.findAll,
        fromPlainObject: fromPlainObject,
        toPlainObject: toPlainObject,
        fork (extension) {
            const base = $RnRNw({}, config); // copy of config
            return $dd7b74e0dc1c8176$var$createSyntax(typeof extension === 'function' ? extension(base, Object.assign) : $RnRNw(base, extension));
        }
    };
    syntax.lexer = new $ae5TN.Lexer({
        generic: true,
        types: config.types,
        atrules: config.atrules,
        properties: config.properties,
        node: config.node
    }, syntax);
    return syntax;
}
const $dd7b74e0dc1c8176$var$createSyntax$1 = (config)=>$dd7b74e0dc1c8176$var$createSyntax($RnRNw({}, config));
module.exports = $dd7b74e0dc1c8176$var$createSyntax$1;

});
parcelRegister("2vMqe", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $1d4409a3608d16c4$export$660b2ee2d4fb4eff, (v) => $1d4409a3608d16c4$export$660b2ee2d4fb4eff = v);
var $1d4409a3608d16c4$export$21bfcb60d1b5ccac;
var $1d4409a3608d16c4$export$d273d1be20da6de2;
var $1d4409a3608d16c4$export$f8b4878501aa4a62;
var $1d4409a3608d16c4$export$b0b2bd2d1777c179;
var $1d4409a3608d16c4$export$521ef26a3002003b;
var $1d4409a3608d16c4$export$e20ebb298016f6;
var $1d4409a3608d16c4$export$c06e3ee3b4d233fa;
var $1d4409a3608d16c4$export$4d299b491347818a;
var $1d4409a3608d16c4$export$a918ca49ff4337a3;
var $1d4409a3608d16c4$export$c940ece961bc43c6;
var $1d4409a3608d16c4$export$c1a09112320b1603;
var $1d4409a3608d16c4$export$f3890eeaf6851387;
var $1d4409a3608d16c4$export$ab85ecd77ce6a5cd;
var $1d4409a3608d16c4$export$331e9b6bdecaac5f;
var $1d4409a3608d16c4$export$ccdce7304ac66390;
var $1d4409a3608d16c4$export$b5a25f132cb53de6;
var $1d4409a3608d16c4$export$cd363bb53c2bb;
var $1d4409a3608d16c4$export$fffa67e515d04022;
var $1d4409a3608d16c4$export$d11913f8a6922aea;
var $1d4409a3608d16c4$export$186d8b1f99e2bfec;
var $1d4409a3608d16c4$export$773d33972c6279ed;
var $1d4409a3608d16c4$export$72f933344f701f30;
var $1d4409a3608d16c4$export$bedd8b9b04d9dbd;
var $1d4409a3608d16c4$export$89b8e0fa65f6a914;
var $1d4409a3608d16c4$export$59d795186a5d3f58;
var $1d4409a3608d16c4$export$fb98946286ab4c97;
var $1d4409a3608d16c4$export$a60b91545d7e19fc;
var $1d4409a3608d16c4$export$bbf58a4a05c6b6e2;
var $1d4409a3608d16c4$export$2f591833f7f1b967;
var $1d4409a3608d16c4$export$48d90b0d2444a844;
var $1d4409a3608d16c4$export$deba3a5f607eb19;
var $1d4409a3608d16c4$export$90f8a5e44c6cc5e3;
var $1d4409a3608d16c4$export$4b3b0ba223857b61;
var $1d4409a3608d16c4$export$da737789103788ca;
var $1d4409a3608d16c4$export$727d9dbc4fbb948f;
var $1d4409a3608d16c4$export$2a81dc4d1a2f9334;
var $1d4409a3608d16c4$export$56b48cc5d7560ffb;
var $1d4409a3608d16c4$export$79c5d5217943d6a7;
var $1d4409a3608d16c4$export$25a7e820fbcd58b9;
var $1d4409a3608d16c4$export$998d7ff9801e90bb;
var $1d4409a3608d16c4$export$45a677ea7cb6d5c8;
var $1d4409a3608d16c4$export$c6b40e80adfef3ae;
var $1d4409a3608d16c4$export$386c40f28a3efd99;
var $1d4409a3608d16c4$export$b7ed17c2edb4d953;
var $1d4409a3608d16c4$export$598e9af52cb9b904;
var $1d4409a3608d16c4$export$35784e2518402c99;
var $1d4409a3608d16c4$export$352e2c1d24776bfb;
var $1d4409a3608d16c4$export$3c52dd84024ae72c;
var $1d4409a3608d16c4$export$6902610076fb2dc1;
var $1d4409a3608d16c4$export$5bf4b3d0861be8d9;
var $1d4409a3608d16c4$export$349fae4425f20458;
var $1d4409a3608d16c4$export$1cf8ac3f090cf48a;
var $1d4409a3608d16c4$export$e314ae15c0f41984;
var $1d4409a3608d16c4$export$b817115b8219186a;
var $1d4409a3608d16c4$export$5ed93187f4ce070a;
var $1d4409a3608d16c4$export$e9aed36b506f417c;
var $1d4409a3608d16c4$export$5bd0595948d7ed9;
var $1d4409a3608d16c4$export$c4eb8307a0331d71;
var $1d4409a3608d16c4$export$2e282c3c0c638f20;
var $1d4409a3608d16c4$export$a5f6079b5a0c262e;
var $1d4409a3608d16c4$export$a1e9ec249d80652c;
var $1d4409a3608d16c4$export$b55edb69cfa7ac57;
var $1d4409a3608d16c4$export$660b2ee2d4fb4eff;
'use strict';

var $iYo0F = parcelRequire("iYo0F");

var $kIeAG = parcelRequire("kIeAG");

var $7UrOl = parcelRequire("7UrOl");

var $jhzPX = parcelRequire("jhzPX");

var $eioKZ = parcelRequire("eioKZ");

var $3Bp4a = parcelRequire("3Bp4a");
function $1d4409a3608d16c4$var$tokenize(source, onToken) {
    function getCharCode(offset) {
        return offset < sourceLength ? source.charCodeAt(offset) : 0;
    }
    // § 4.3.3. Consume a numeric token
    function consumeNumericToken() {
        // Consume a number and let number be the result.
        offset = $7UrOl.consumeNumber(source, offset);
        // If the next 3 input code points would start an identifier, then:
        if ($kIeAG.isIdentifierStart(getCharCode(offset), getCharCode(offset + 1), getCharCode(offset + 2))) {
            // Create a <dimension-token> with the same value and type flag as number, and a unit set initially to the empty string.
            // Consume a name. Set the <dimension-token>’s unit to the returned value.
            // Return the <dimension-token>.
            type = $iYo0F.Dimension;
            offset = $7UrOl.consumeName(source, offset);
            return;
        }
        // Otherwise, if the next input code point is U+0025 PERCENTAGE SIGN (%), consume it.
        if (getCharCode(offset) === 0x0025) {
            // Create a <percentage-token> with the same value as number, and return it.
            type = $iYo0F.Percentage;
            offset++;
            return;
        }
        // Otherwise, create a <number-token> with the same value and type flag as number, and return it.
        type = $iYo0F.Number;
    }
    // § 4.3.4. Consume an ident-like token
    function consumeIdentLikeToken() {
        const nameStartOffset = offset;
        // Consume a name, and let string be the result.
        offset = $7UrOl.consumeName(source, offset);
        // If string’s value is an ASCII case-insensitive match for "url",
        // and the next input code point is U+0028 LEFT PARENTHESIS ((), consume it.
        if ($7UrOl.cmpStr(source, nameStartOffset, offset, 'url') && getCharCode(offset) === 0x0028) {
            // While the next two input code points are whitespace, consume the next input code point.
            offset = $7UrOl.findWhiteSpaceEnd(source, offset + 1);
            // If the next one or two input code points are U+0022 QUOTATION MARK ("), U+0027 APOSTROPHE ('),
            // or whitespace followed by U+0022 QUOTATION MARK (") or U+0027 APOSTROPHE ('),
            // then create a <function-token> with its value set to string and return it.
            if (getCharCode(offset) === 0x0022 || getCharCode(offset) === 0x0027) {
                type = $iYo0F.Function;
                offset = nameStartOffset + 4;
                return;
            }
            // Otherwise, consume a url token, and return it.
            consumeUrlToken();
            return;
        }
        // Otherwise, if the next input code point is U+0028 LEFT PARENTHESIS ((), consume it.
        // Create a <function-token> with its value set to string and return it.
        if (getCharCode(offset) === 0x0028) {
            type = $iYo0F.Function;
            offset++;
            return;
        }
        // Otherwise, create an <ident-token> with its value set to string and return it.
        type = $iYo0F.Ident;
    }
    // § 4.3.5. Consume a string token
    function consumeStringToken(endingCodePoint) {
        // This algorithm may be called with an ending code point, which denotes the code point
        // that ends the string. If an ending code point is not specified,
        // the current input code point is used.
        if (!endingCodePoint) endingCodePoint = getCharCode(offset++);
        // Initially create a <string-token> with its value set to the empty string.
        type = $iYo0F.String;
        // Repeatedly consume the next input code point from the stream:
        for(; offset < source.length; offset++){
            const code = source.charCodeAt(offset);
            switch($kIeAG.charCodeCategory(code)){
                // ending code point
                case endingCodePoint:
                    // Return the <string-token>.
                    offset++;
                    return;
                // EOF
                // case EofCategory:
                // This is a parse error. Return the <string-token>.
                // return;
                // newline
                case $kIeAG.WhiteSpaceCategory:
                    if ($kIeAG.isNewline(code)) {
                        // This is a parse error. Reconsume the current input code point,
                        // create a <bad-string-token>, and return it.
                        offset += $7UrOl.getNewlineLength(source, offset, code);
                        type = $iYo0F.BadString;
                        return;
                    }
                    break;
                // U+005C REVERSE SOLIDUS (\)
                case 0x005C:
                    // If the next input code point is EOF, do nothing.
                    if (offset === source.length - 1) break;
                    const nextCode = getCharCode(offset + 1);
                    // Otherwise, if the next input code point is a newline, consume it.
                    if ($kIeAG.isNewline(nextCode)) offset += $7UrOl.getNewlineLength(source, offset + 1, nextCode);
                    else if ($kIeAG.isValidEscape(code, nextCode)) // Otherwise, (the stream starts with a valid escape) consume
                    // an escaped code point and append the returned code point to
                    // the <string-token>’s value.
                    offset = $7UrOl.consumeEscaped(source, offset) - 1;
                    break;
            }
        }
    }
    // § 4.3.6. Consume a url token
    // Note: This algorithm assumes that the initial "url(" has already been consumed.
    // This algorithm also assumes that it’s being called to consume an "unquoted" value, like url(foo).
    // A quoted value, like url("foo"), is parsed as a <function-token>. Consume an ident-like token
    // automatically handles this distinction; this algorithm shouldn’t be called directly otherwise.
    function consumeUrlToken() {
        // Initially create a <url-token> with its value set to the empty string.
        type = $iYo0F.Url;
        // Consume as much whitespace as possible.
        offset = $7UrOl.findWhiteSpaceEnd(source, offset);
        // Repeatedly consume the next input code point from the stream:
        for(; offset < source.length; offset++){
            const code = source.charCodeAt(offset);
            switch($kIeAG.charCodeCategory(code)){
                // U+0029 RIGHT PARENTHESIS ())
                case 0x0029:
                    // Return the <url-token>.
                    offset++;
                    return;
                // EOF
                // case EofCategory:
                // This is a parse error. Return the <url-token>.
                // return;
                // whitespace
                case $kIeAG.WhiteSpaceCategory:
                    // Consume as much whitespace as possible.
                    offset = $7UrOl.findWhiteSpaceEnd(source, offset);
                    // If the next input code point is U+0029 RIGHT PARENTHESIS ()) or EOF,
                    // consume it and return the <url-token>
                    // (if EOF was encountered, this is a parse error);
                    if (getCharCode(offset) === 0x0029 || offset >= source.length) {
                        if (offset < source.length) offset++;
                        return;
                    }
                    // otherwise, consume the remnants of a bad url, create a <bad-url-token>,
                    // and return it.
                    offset = $7UrOl.consumeBadUrlRemnants(source, offset);
                    type = $iYo0F.BadUrl;
                    return;
                // U+0022 QUOTATION MARK (")
                // U+0027 APOSTROPHE (')
                // U+0028 LEFT PARENTHESIS (()
                // non-printable code point
                case 0x0022:
                case 0x0027:
                case 0x0028:
                case $kIeAG.NonPrintableCategory:
                    // This is a parse error. Consume the remnants of a bad url,
                    // create a <bad-url-token>, and return it.
                    offset = $7UrOl.consumeBadUrlRemnants(source, offset);
                    type = $iYo0F.BadUrl;
                    return;
                // U+005C REVERSE SOLIDUS (\)
                case 0x005C:
                    // If the stream starts with a valid escape, consume an escaped code point and
                    // append the returned code point to the <url-token>’s value.
                    if ($kIeAG.isValidEscape(code, getCharCode(offset + 1))) {
                        offset = $7UrOl.consumeEscaped(source, offset) - 1;
                        break;
                    }
                    // Otherwise, this is a parse error. Consume the remnants of a bad url,
                    // create a <bad-url-token>, and return it.
                    offset = $7UrOl.consumeBadUrlRemnants(source, offset);
                    type = $iYo0F.BadUrl;
                    return;
            }
        }
    }
    // ensure source is a string
    source = String(source || '');
    const sourceLength = source.length;
    let start = $kIeAG.isBOM(getCharCode(0));
    let offset = start;
    let type;
    // https://drafts.csswg.org/css-syntax-3/#consume-token
    // § 4.3.1. Consume a token
    while(offset < sourceLength){
        const code = source.charCodeAt(offset);
        switch($kIeAG.charCodeCategory(code)){
            // whitespace
            case $kIeAG.WhiteSpaceCategory:
                // Consume as much whitespace as possible. Return a <whitespace-token>.
                type = $iYo0F.WhiteSpace;
                offset = $7UrOl.findWhiteSpaceEnd(source, offset + 1);
                break;
            // U+0022 QUOTATION MARK (")
            case 0x0022:
                // Consume a string token and return it.
                consumeStringToken();
                break;
            // U+0023 NUMBER SIGN (#)
            case 0x0023:
                // If the next input code point is a name code point or the next two input code points are a valid escape, then:
                if ($kIeAG.isName(getCharCode(offset + 1)) || $kIeAG.isValidEscape(getCharCode(offset + 1), getCharCode(offset + 2))) {
                    // Create a <hash-token>.
                    type = $iYo0F.Hash;
                    // If the next 3 input code points would start an identifier, set the <hash-token>’s type flag to "id".
                    // if (isIdentifierStart(getCharCode(offset + 1), getCharCode(offset + 2), getCharCode(offset + 3))) {
                    //     // TODO: set id flag
                    // }
                    // Consume a name, and set the <hash-token>’s value to the returned string.
                    offset = $7UrOl.consumeName(source, offset + 1);
                // Return the <hash-token>.
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $iYo0F.Delim;
                    offset++;
                }
                break;
            // U+0027 APOSTROPHE (')
            case 0x0027:
                // Consume a string token and return it.
                consumeStringToken();
                break;
            // U+0028 LEFT PARENTHESIS (()
            case 0x0028:
                // Return a <(-token>.
                type = $iYo0F.LeftParenthesis;
                offset++;
                break;
            // U+0029 RIGHT PARENTHESIS ())
            case 0x0029:
                // Return a <)-token>.
                type = $iYo0F.RightParenthesis;
                offset++;
                break;
            // U+002B PLUS SIGN (+)
            case 0x002B:
                // If the input stream starts with a number, ...
                if ($kIeAG.isNumberStart(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $iYo0F.Delim;
                    offset++;
                }
                break;
            // U+002C COMMA (,)
            case 0x002C:
                // Return a <comma-token>.
                type = $iYo0F.Comma;
                offset++;
                break;
            // U+002D HYPHEN-MINUS (-)
            case 0x002D:
                // If the input stream starts with a number, reconsume the current input code point, consume a numeric token, and return it.
                if ($kIeAG.isNumberStart(code, getCharCode(offset + 1), getCharCode(offset + 2))) consumeNumericToken();
                else {
                    // Otherwise, if the next 2 input code points are U+002D HYPHEN-MINUS U+003E GREATER-THAN SIGN (->), consume them and return a <CDC-token>.
                    if (getCharCode(offset + 1) === 0x002D && getCharCode(offset + 2) === 0x003E) {
                        type = $iYo0F.CDC;
                        offset = offset + 3;
                    } else // Otherwise, if the input stream starts with an identifier, ...
                    if ($kIeAG.isIdentifierStart(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume an ident-like token, and return it.
                    consumeIdentLikeToken();
                    else {
                        // Otherwise, return a <delim-token> with its value set to the current input code point.
                        type = $iYo0F.Delim;
                        offset++;
                    }
                }
                break;
            // U+002E FULL STOP (.)
            case 0x002E:
                // If the input stream starts with a number, ...
                if ($kIeAG.isNumberStart(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $iYo0F.Delim;
                    offset++;
                }
                break;
            // U+002F SOLIDUS (/)
            case 0x002F:
                // If the next two input code point are U+002F SOLIDUS (/) followed by a U+002A ASTERISK (*),
                if (getCharCode(offset + 1) === 0x002A) {
                    // ... consume them and all following code points up to and including the first U+002A ASTERISK (*)
                    // followed by a U+002F SOLIDUS (/), or up to an EOF code point.
                    type = $iYo0F.Comment;
                    offset = source.indexOf('*/', offset + 2);
                    offset = offset === -1 ? source.length : offset + 2;
                } else {
                    type = $iYo0F.Delim;
                    offset++;
                }
                break;
            // U+003A COLON (:)
            case 0x003A:
                // Return a <colon-token>.
                type = $iYo0F.Colon;
                offset++;
                break;
            // U+003B SEMICOLON (;)
            case 0x003B:
                // Return a <semicolon-token>.
                type = $iYo0F.Semicolon;
                offset++;
                break;
            // U+003C LESS-THAN SIGN (<)
            case 0x003C:
                // If the next 3 input code points are U+0021 EXCLAMATION MARK U+002D HYPHEN-MINUS U+002D HYPHEN-MINUS (!--), ...
                if (getCharCode(offset + 1) === 0x0021 && getCharCode(offset + 2) === 0x002D && getCharCode(offset + 3) === 0x002D) {
                    // ... consume them and return a <CDO-token>.
                    type = $iYo0F.CDO;
                    offset = offset + 4;
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $iYo0F.Delim;
                    offset++;
                }
                break;
            // U+0040 COMMERCIAL AT (@)
            case 0x0040:
                // If the next 3 input code points would start an identifier, ...
                if ($kIeAG.isIdentifierStart(getCharCode(offset + 1), getCharCode(offset + 2), getCharCode(offset + 3))) {
                    // ... consume a name, create an <at-keyword-token> with its value set to the returned value, and return it.
                    type = $iYo0F.AtKeyword;
                    offset = $7UrOl.consumeName(source, offset + 1);
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $iYo0F.Delim;
                    offset++;
                }
                break;
            // U+005B LEFT SQUARE BRACKET ([)
            case 0x005B:
                // Return a <[-token>.
                type = $iYo0F.LeftSquareBracket;
                offset++;
                break;
            // U+005C REVERSE SOLIDUS (\)
            case 0x005C:
                // If the input stream starts with a valid escape, ...
                if ($kIeAG.isValidEscape(code, getCharCode(offset + 1))) // ... reconsume the current input code point, consume an ident-like token, and return it.
                consumeIdentLikeToken();
                else {
                    // Otherwise, this is a parse error. Return a <delim-token> with its value set to the current input code point.
                    type = $iYo0F.Delim;
                    offset++;
                }
                break;
            // U+005D RIGHT SQUARE BRACKET (])
            case 0x005D:
                // Return a <]-token>.
                type = $iYo0F.RightSquareBracket;
                offset++;
                break;
            // U+007B LEFT CURLY BRACKET ({)
            case 0x007B:
                // Return a <{-token>.
                type = $iYo0F.LeftCurlyBracket;
                offset++;
                break;
            // U+007D RIGHT CURLY BRACKET (})
            case 0x007D:
                // Return a <}-token>.
                type = $iYo0F.RightCurlyBracket;
                offset++;
                break;
            // digit
            case $kIeAG.DigitCategory:
                // Reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                break;
            // name-start code point
            case $kIeAG.NameStartCategory:
                // Reconsume the current input code point, consume an ident-like token, and return it.
                consumeIdentLikeToken();
                break;
            // EOF
            // case EofCategory:
            // Return an <EOF-token>.
            // break;
            // anything else
            default:
                // Return a <delim-token> with its value set to the current input code point.
                type = $iYo0F.Delim;
                offset++;
        }
        // put token to stream
        onToken(type, start, start = offset);
    }
}
$1d4409a3608d16c4$export$21bfcb60d1b5ccac = $iYo0F.AtKeyword;
$1d4409a3608d16c4$export$d273d1be20da6de2 = $iYo0F.BadString;
$1d4409a3608d16c4$export$f8b4878501aa4a62 = $iYo0F.BadUrl;
$1d4409a3608d16c4$export$b0b2bd2d1777c179 = $iYo0F.CDC;
$1d4409a3608d16c4$export$521ef26a3002003b = $iYo0F.CDO;
$1d4409a3608d16c4$export$e20ebb298016f6 = $iYo0F.Colon;
$1d4409a3608d16c4$export$c06e3ee3b4d233fa = $iYo0F.Comma;
$1d4409a3608d16c4$export$4d299b491347818a = $iYo0F.Comment;
$1d4409a3608d16c4$export$a918ca49ff4337a3 = $iYo0F.Delim;
$1d4409a3608d16c4$export$c940ece961bc43c6 = $iYo0F.Dimension;
$1d4409a3608d16c4$export$c1a09112320b1603 = $iYo0F.EOF;
$1d4409a3608d16c4$export$f3890eeaf6851387 = $iYo0F.Function;
$1d4409a3608d16c4$export$ab85ecd77ce6a5cd = $iYo0F.Hash;
$1d4409a3608d16c4$export$331e9b6bdecaac5f = $iYo0F.Ident;
$1d4409a3608d16c4$export$ccdce7304ac66390 = $iYo0F.LeftCurlyBracket;
$1d4409a3608d16c4$export$b5a25f132cb53de6 = $iYo0F.LeftParenthesis;
$1d4409a3608d16c4$export$cd363bb53c2bb = $iYo0F.LeftSquareBracket;
$1d4409a3608d16c4$export$fffa67e515d04022 = $iYo0F.Number;
$1d4409a3608d16c4$export$d11913f8a6922aea = $iYo0F.Percentage;
$1d4409a3608d16c4$export$186d8b1f99e2bfec = $iYo0F.RightCurlyBracket;
$1d4409a3608d16c4$export$773d33972c6279ed = $iYo0F.RightParenthesis;
$1d4409a3608d16c4$export$72f933344f701f30 = $iYo0F.RightSquareBracket;
$1d4409a3608d16c4$export$bedd8b9b04d9dbd = $iYo0F.Semicolon;
$1d4409a3608d16c4$export$89b8e0fa65f6a914 = $iYo0F.String;
$1d4409a3608d16c4$export$59d795186a5d3f58 = $iYo0F.Url;
$1d4409a3608d16c4$export$fb98946286ab4c97 = $iYo0F.WhiteSpace;
$1d4409a3608d16c4$export$a60b91545d7e19fc = $iYo0F;
$1d4409a3608d16c4$export$bbf58a4a05c6b6e2 = $kIeAG.DigitCategory;
$1d4409a3608d16c4$export$2f591833f7f1b967 = $kIeAG.EofCategory;
$1d4409a3608d16c4$export$48d90b0d2444a844 = $kIeAG.NameStartCategory;
$1d4409a3608d16c4$export$deba3a5f607eb19 = $kIeAG.NonPrintableCategory;
$1d4409a3608d16c4$export$90f8a5e44c6cc5e3 = $kIeAG.WhiteSpaceCategory;
$1d4409a3608d16c4$export$4b3b0ba223857b61 = $kIeAG.charCodeCategory;
$1d4409a3608d16c4$export$da737789103788ca = $kIeAG.isBOM;
$1d4409a3608d16c4$export$727d9dbc4fbb948f = $kIeAG.isDigit;
$1d4409a3608d16c4$export$2a81dc4d1a2f9334 = $kIeAG.isHexDigit;
$1d4409a3608d16c4$export$56b48cc5d7560ffb = $kIeAG.isIdentifierStart;
$1d4409a3608d16c4$export$79c5d5217943d6a7 = $kIeAG.isLetter;
$1d4409a3608d16c4$export$25a7e820fbcd58b9 = $kIeAG.isLowercaseLetter;
$1d4409a3608d16c4$export$998d7ff9801e90bb = $kIeAG.isName;
$1d4409a3608d16c4$export$45a677ea7cb6d5c8 = $kIeAG.isNameStart;
$1d4409a3608d16c4$export$c6b40e80adfef3ae = $kIeAG.isNewline;
$1d4409a3608d16c4$export$386c40f28a3efd99 = $kIeAG.isNonAscii;
$1d4409a3608d16c4$export$b7ed17c2edb4d953 = $kIeAG.isNonPrintable;
$1d4409a3608d16c4$export$598e9af52cb9b904 = $kIeAG.isNumberStart;
$1d4409a3608d16c4$export$35784e2518402c99 = $kIeAG.isUppercaseLetter;
$1d4409a3608d16c4$export$352e2c1d24776bfb = $kIeAG.isValidEscape;
$1d4409a3608d16c4$export$3c52dd84024ae72c = $kIeAG.isWhiteSpace;
$1d4409a3608d16c4$export$6902610076fb2dc1 = $7UrOl.cmpChar;
$1d4409a3608d16c4$export$5bf4b3d0861be8d9 = $7UrOl.cmpStr;
$1d4409a3608d16c4$export$349fae4425f20458 = $7UrOl.consumeBadUrlRemnants;
$1d4409a3608d16c4$export$1cf8ac3f090cf48a = $7UrOl.consumeEscaped;
$1d4409a3608d16c4$export$e314ae15c0f41984 = $7UrOl.consumeName;
$1d4409a3608d16c4$export$b817115b8219186a = $7UrOl.consumeNumber;
$1d4409a3608d16c4$export$5ed93187f4ce070a = $7UrOl.decodeEscaped;
$1d4409a3608d16c4$export$e9aed36b506f417c = $7UrOl.findDecimalNumberEnd;
$1d4409a3608d16c4$export$5bd0595948d7ed9 = $7UrOl.findWhiteSpaceEnd;
$1d4409a3608d16c4$export$c4eb8307a0331d71 = $7UrOl.findWhiteSpaceStart;
$1d4409a3608d16c4$export$2e282c3c0c638f20 = $7UrOl.getNewlineLength;
$1d4409a3608d16c4$export$a5f6079b5a0c262e = $jhzPX;
$1d4409a3608d16c4$export$a1e9ec249d80652c = $eioKZ.OffsetToLocation;
$1d4409a3608d16c4$export$b55edb69cfa7ac57 = $3Bp4a.TokenStream;
$1d4409a3608d16c4$export$660b2ee2d4fb4eff = $1d4409a3608d16c4$var$tokenize;

});
parcelRegister("iYo0F", function(module, exports) {

$parcel$export(module.exports, "AtKeyword", () => $dd0074710b22aa49$export$21bfcb60d1b5ccac, (v) => $dd0074710b22aa49$export$21bfcb60d1b5ccac = v);
$parcel$export(module.exports, "BadString", () => $dd0074710b22aa49$export$d273d1be20da6de2, (v) => $dd0074710b22aa49$export$d273d1be20da6de2 = v);
$parcel$export(module.exports, "BadUrl", () => $dd0074710b22aa49$export$f8b4878501aa4a62, (v) => $dd0074710b22aa49$export$f8b4878501aa4a62 = v);
$parcel$export(module.exports, "CDC", () => $dd0074710b22aa49$export$b0b2bd2d1777c179, (v) => $dd0074710b22aa49$export$b0b2bd2d1777c179 = v);
$parcel$export(module.exports, "CDO", () => $dd0074710b22aa49$export$521ef26a3002003b, (v) => $dd0074710b22aa49$export$521ef26a3002003b = v);
$parcel$export(module.exports, "Colon", () => $dd0074710b22aa49$export$e20ebb298016f6, (v) => $dd0074710b22aa49$export$e20ebb298016f6 = v);
$parcel$export(module.exports, "Comma", () => $dd0074710b22aa49$export$c06e3ee3b4d233fa, (v) => $dd0074710b22aa49$export$c06e3ee3b4d233fa = v);
$parcel$export(module.exports, "Comment", () => $dd0074710b22aa49$export$4d299b491347818a, (v) => $dd0074710b22aa49$export$4d299b491347818a = v);
$parcel$export(module.exports, "Delim", () => $dd0074710b22aa49$export$a918ca49ff4337a3, (v) => $dd0074710b22aa49$export$a918ca49ff4337a3 = v);
$parcel$export(module.exports, "Dimension", () => $dd0074710b22aa49$export$c940ece961bc43c6, (v) => $dd0074710b22aa49$export$c940ece961bc43c6 = v);
$parcel$export(module.exports, "EOF", () => $dd0074710b22aa49$export$c1a09112320b1603, (v) => $dd0074710b22aa49$export$c1a09112320b1603 = v);
$parcel$export(module.exports, "Function", () => $dd0074710b22aa49$export$f3890eeaf6851387, (v) => $dd0074710b22aa49$export$f3890eeaf6851387 = v);
$parcel$export(module.exports, "Hash", () => $dd0074710b22aa49$export$ab85ecd77ce6a5cd, (v) => $dd0074710b22aa49$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "Ident", () => $dd0074710b22aa49$export$331e9b6bdecaac5f, (v) => $dd0074710b22aa49$export$331e9b6bdecaac5f = v);
$parcel$export(module.exports, "LeftCurlyBracket", () => $dd0074710b22aa49$export$ccdce7304ac66390, (v) => $dd0074710b22aa49$export$ccdce7304ac66390 = v);
$parcel$export(module.exports, "LeftParenthesis", () => $dd0074710b22aa49$export$b5a25f132cb53de6, (v) => $dd0074710b22aa49$export$b5a25f132cb53de6 = v);
$parcel$export(module.exports, "LeftSquareBracket", () => $dd0074710b22aa49$export$cd363bb53c2bb, (v) => $dd0074710b22aa49$export$cd363bb53c2bb = v);
$parcel$export(module.exports, "Number", () => $dd0074710b22aa49$export$fffa67e515d04022, (v) => $dd0074710b22aa49$export$fffa67e515d04022 = v);
$parcel$export(module.exports, "Percentage", () => $dd0074710b22aa49$export$d11913f8a6922aea, (v) => $dd0074710b22aa49$export$d11913f8a6922aea = v);
$parcel$export(module.exports, "RightCurlyBracket", () => $dd0074710b22aa49$export$186d8b1f99e2bfec, (v) => $dd0074710b22aa49$export$186d8b1f99e2bfec = v);
$parcel$export(module.exports, "RightParenthesis", () => $dd0074710b22aa49$export$773d33972c6279ed, (v) => $dd0074710b22aa49$export$773d33972c6279ed = v);
$parcel$export(module.exports, "RightSquareBracket", () => $dd0074710b22aa49$export$72f933344f701f30, (v) => $dd0074710b22aa49$export$72f933344f701f30 = v);
$parcel$export(module.exports, "Semicolon", () => $dd0074710b22aa49$export$bedd8b9b04d9dbd, (v) => $dd0074710b22aa49$export$bedd8b9b04d9dbd = v);
$parcel$export(module.exports, "String", () => $dd0074710b22aa49$export$89b8e0fa65f6a914, (v) => $dd0074710b22aa49$export$89b8e0fa65f6a914 = v);
$parcel$export(module.exports, "Url", () => $dd0074710b22aa49$export$59d795186a5d3f58, (v) => $dd0074710b22aa49$export$59d795186a5d3f58 = v);
$parcel$export(module.exports, "WhiteSpace", () => $dd0074710b22aa49$export$fb98946286ab4c97, (v) => $dd0074710b22aa49$export$fb98946286ab4c97 = v);
var $dd0074710b22aa49$export$21bfcb60d1b5ccac;
var $dd0074710b22aa49$export$d273d1be20da6de2;
var $dd0074710b22aa49$export$f8b4878501aa4a62;
var $dd0074710b22aa49$export$b0b2bd2d1777c179;
var $dd0074710b22aa49$export$521ef26a3002003b;
var $dd0074710b22aa49$export$e20ebb298016f6;
var $dd0074710b22aa49$export$c06e3ee3b4d233fa;
var $dd0074710b22aa49$export$4d299b491347818a;
var $dd0074710b22aa49$export$a918ca49ff4337a3;
var $dd0074710b22aa49$export$c940ece961bc43c6;
var $dd0074710b22aa49$export$c1a09112320b1603;
var $dd0074710b22aa49$export$f3890eeaf6851387;
var $dd0074710b22aa49$export$ab85ecd77ce6a5cd;
var $dd0074710b22aa49$export$331e9b6bdecaac5f;
var $dd0074710b22aa49$export$ccdce7304ac66390;
var $dd0074710b22aa49$export$b5a25f132cb53de6;
var $dd0074710b22aa49$export$cd363bb53c2bb;
var $dd0074710b22aa49$export$fffa67e515d04022;
var $dd0074710b22aa49$export$d11913f8a6922aea;
var $dd0074710b22aa49$export$186d8b1f99e2bfec;
var $dd0074710b22aa49$export$773d33972c6279ed;
var $dd0074710b22aa49$export$72f933344f701f30;
var $dd0074710b22aa49$export$bedd8b9b04d9dbd;
var $dd0074710b22aa49$export$89b8e0fa65f6a914;
var $dd0074710b22aa49$export$59d795186a5d3f58;
var $dd0074710b22aa49$export$fb98946286ab4c97;
'use strict';
// CSS Syntax Module Level 3
// https://www.w3.org/TR/css-syntax-3/
const $dd0074710b22aa49$var$EOF = 0; // <EOF-token>
const $dd0074710b22aa49$var$Ident = 1; // <ident-token>
const $dd0074710b22aa49$var$Function = 2; // <function-token>
const $dd0074710b22aa49$var$AtKeyword = 3; // <at-keyword-token>
const $dd0074710b22aa49$var$Hash = 4; // <hash-token>
const $dd0074710b22aa49$var$String = 5; // <string-token>
const $dd0074710b22aa49$var$BadString = 6; // <bad-string-token>
const $dd0074710b22aa49$var$Url = 7; // <url-token>
const $dd0074710b22aa49$var$BadUrl = 8; // <bad-url-token>
const $dd0074710b22aa49$var$Delim = 9; // <delim-token>
const $dd0074710b22aa49$var$Number = 10; // <number-token>
const $dd0074710b22aa49$var$Percentage = 11; // <percentage-token>
const $dd0074710b22aa49$var$Dimension = 12; // <dimension-token>
const $dd0074710b22aa49$var$WhiteSpace = 13; // <whitespace-token>
const $dd0074710b22aa49$var$CDO = 14; // <CDO-token>
const $dd0074710b22aa49$var$CDC = 15; // <CDC-token>
const $dd0074710b22aa49$var$Colon = 16; // <colon-token>     :
const $dd0074710b22aa49$var$Semicolon = 17; // <semicolon-token> ;
const $dd0074710b22aa49$var$Comma = 18; // <comma-token>     ,
const $dd0074710b22aa49$var$LeftSquareBracket = 19; // <[-token>
const $dd0074710b22aa49$var$RightSquareBracket = 20; // <]-token>
const $dd0074710b22aa49$var$LeftParenthesis = 21; // <(-token>
const $dd0074710b22aa49$var$RightParenthesis = 22; // <)-token>
const $dd0074710b22aa49$var$LeftCurlyBracket = 23; // <{-token>
const $dd0074710b22aa49$var$RightCurlyBracket = 24; // <}-token>
const $dd0074710b22aa49$var$Comment = 25;
$dd0074710b22aa49$export$21bfcb60d1b5ccac = $dd0074710b22aa49$var$AtKeyword;
$dd0074710b22aa49$export$d273d1be20da6de2 = $dd0074710b22aa49$var$BadString;
$dd0074710b22aa49$export$f8b4878501aa4a62 = $dd0074710b22aa49$var$BadUrl;
$dd0074710b22aa49$export$b0b2bd2d1777c179 = $dd0074710b22aa49$var$CDC;
$dd0074710b22aa49$export$521ef26a3002003b = $dd0074710b22aa49$var$CDO;
$dd0074710b22aa49$export$e20ebb298016f6 = $dd0074710b22aa49$var$Colon;
$dd0074710b22aa49$export$c06e3ee3b4d233fa = $dd0074710b22aa49$var$Comma;
$dd0074710b22aa49$export$4d299b491347818a = $dd0074710b22aa49$var$Comment;
$dd0074710b22aa49$export$a918ca49ff4337a3 = $dd0074710b22aa49$var$Delim;
$dd0074710b22aa49$export$c940ece961bc43c6 = $dd0074710b22aa49$var$Dimension;
$dd0074710b22aa49$export$c1a09112320b1603 = $dd0074710b22aa49$var$EOF;
$dd0074710b22aa49$export$f3890eeaf6851387 = $dd0074710b22aa49$var$Function;
$dd0074710b22aa49$export$ab85ecd77ce6a5cd = $dd0074710b22aa49$var$Hash;
$dd0074710b22aa49$export$331e9b6bdecaac5f = $dd0074710b22aa49$var$Ident;
$dd0074710b22aa49$export$ccdce7304ac66390 = $dd0074710b22aa49$var$LeftCurlyBracket;
$dd0074710b22aa49$export$b5a25f132cb53de6 = $dd0074710b22aa49$var$LeftParenthesis;
$dd0074710b22aa49$export$cd363bb53c2bb = $dd0074710b22aa49$var$LeftSquareBracket;
$dd0074710b22aa49$export$fffa67e515d04022 = $dd0074710b22aa49$var$Number;
$dd0074710b22aa49$export$d11913f8a6922aea = $dd0074710b22aa49$var$Percentage;
$dd0074710b22aa49$export$186d8b1f99e2bfec = $dd0074710b22aa49$var$RightCurlyBracket;
$dd0074710b22aa49$export$773d33972c6279ed = $dd0074710b22aa49$var$RightParenthesis;
$dd0074710b22aa49$export$72f933344f701f30 = $dd0074710b22aa49$var$RightSquareBracket;
$dd0074710b22aa49$export$bedd8b9b04d9dbd = $dd0074710b22aa49$var$Semicolon;
$dd0074710b22aa49$export$89b8e0fa65f6a914 = $dd0074710b22aa49$var$String;
$dd0074710b22aa49$export$59d795186a5d3f58 = $dd0074710b22aa49$var$Url;
$dd0074710b22aa49$export$fb98946286ab4c97 = $dd0074710b22aa49$var$WhiteSpace;

});

parcelRegister("kIeAG", function(module, exports) {

$parcel$export(module.exports, "DigitCategory", () => $f1433c17e7c2c7ae$export$bbf58a4a05c6b6e2, (v) => $f1433c17e7c2c7ae$export$bbf58a4a05c6b6e2 = v);
$parcel$export(module.exports, "EofCategory", () => $f1433c17e7c2c7ae$export$2f591833f7f1b967, (v) => $f1433c17e7c2c7ae$export$2f591833f7f1b967 = v);
$parcel$export(module.exports, "NameStartCategory", () => $f1433c17e7c2c7ae$export$48d90b0d2444a844, (v) => $f1433c17e7c2c7ae$export$48d90b0d2444a844 = v);
$parcel$export(module.exports, "NonPrintableCategory", () => $f1433c17e7c2c7ae$export$deba3a5f607eb19, (v) => $f1433c17e7c2c7ae$export$deba3a5f607eb19 = v);
$parcel$export(module.exports, "WhiteSpaceCategory", () => $f1433c17e7c2c7ae$export$90f8a5e44c6cc5e3, (v) => $f1433c17e7c2c7ae$export$90f8a5e44c6cc5e3 = v);
$parcel$export(module.exports, "charCodeCategory", () => $f1433c17e7c2c7ae$export$4b3b0ba223857b61, (v) => $f1433c17e7c2c7ae$export$4b3b0ba223857b61 = v);
$parcel$export(module.exports, "isBOM", () => $f1433c17e7c2c7ae$export$da737789103788ca, (v) => $f1433c17e7c2c7ae$export$da737789103788ca = v);
$parcel$export(module.exports, "isDigit", () => $f1433c17e7c2c7ae$export$727d9dbc4fbb948f, (v) => $f1433c17e7c2c7ae$export$727d9dbc4fbb948f = v);
$parcel$export(module.exports, "isHexDigit", () => $f1433c17e7c2c7ae$export$2a81dc4d1a2f9334, (v) => $f1433c17e7c2c7ae$export$2a81dc4d1a2f9334 = v);
$parcel$export(module.exports, "isIdentifierStart", () => $f1433c17e7c2c7ae$export$56b48cc5d7560ffb, (v) => $f1433c17e7c2c7ae$export$56b48cc5d7560ffb = v);
$parcel$export(module.exports, "isLetter", () => $f1433c17e7c2c7ae$export$79c5d5217943d6a7, (v) => $f1433c17e7c2c7ae$export$79c5d5217943d6a7 = v);
$parcel$export(module.exports, "isLowercaseLetter", () => $f1433c17e7c2c7ae$export$25a7e820fbcd58b9, (v) => $f1433c17e7c2c7ae$export$25a7e820fbcd58b9 = v);
$parcel$export(module.exports, "isName", () => $f1433c17e7c2c7ae$export$998d7ff9801e90bb, (v) => $f1433c17e7c2c7ae$export$998d7ff9801e90bb = v);
$parcel$export(module.exports, "isNameStart", () => $f1433c17e7c2c7ae$export$45a677ea7cb6d5c8, (v) => $f1433c17e7c2c7ae$export$45a677ea7cb6d5c8 = v);
$parcel$export(module.exports, "isNewline", () => $f1433c17e7c2c7ae$export$c6b40e80adfef3ae, (v) => $f1433c17e7c2c7ae$export$c6b40e80adfef3ae = v);
$parcel$export(module.exports, "isNonAscii", () => $f1433c17e7c2c7ae$export$386c40f28a3efd99, (v) => $f1433c17e7c2c7ae$export$386c40f28a3efd99 = v);
$parcel$export(module.exports, "isNonPrintable", () => $f1433c17e7c2c7ae$export$b7ed17c2edb4d953, (v) => $f1433c17e7c2c7ae$export$b7ed17c2edb4d953 = v);
$parcel$export(module.exports, "isNumberStart", () => $f1433c17e7c2c7ae$export$598e9af52cb9b904, (v) => $f1433c17e7c2c7ae$export$598e9af52cb9b904 = v);
$parcel$export(module.exports, "isUppercaseLetter", () => $f1433c17e7c2c7ae$export$35784e2518402c99, (v) => $f1433c17e7c2c7ae$export$35784e2518402c99 = v);
$parcel$export(module.exports, "isValidEscape", () => $f1433c17e7c2c7ae$export$352e2c1d24776bfb, (v) => $f1433c17e7c2c7ae$export$352e2c1d24776bfb = v);
$parcel$export(module.exports, "isWhiteSpace", () => $f1433c17e7c2c7ae$export$3c52dd84024ae72c, (v) => $f1433c17e7c2c7ae$export$3c52dd84024ae72c = v);
var $f1433c17e7c2c7ae$export$bbf58a4a05c6b6e2;
var $f1433c17e7c2c7ae$export$2f591833f7f1b967;
var $f1433c17e7c2c7ae$export$48d90b0d2444a844;
var $f1433c17e7c2c7ae$export$deba3a5f607eb19;
var $f1433c17e7c2c7ae$export$90f8a5e44c6cc5e3;
var $f1433c17e7c2c7ae$export$4b3b0ba223857b61;
var $f1433c17e7c2c7ae$export$da737789103788ca;
var $f1433c17e7c2c7ae$export$727d9dbc4fbb948f;
var $f1433c17e7c2c7ae$export$2a81dc4d1a2f9334;
var $f1433c17e7c2c7ae$export$56b48cc5d7560ffb;
var $f1433c17e7c2c7ae$export$79c5d5217943d6a7;
var $f1433c17e7c2c7ae$export$25a7e820fbcd58b9;
var $f1433c17e7c2c7ae$export$998d7ff9801e90bb;
var $f1433c17e7c2c7ae$export$45a677ea7cb6d5c8;
var $f1433c17e7c2c7ae$export$c6b40e80adfef3ae;
var $f1433c17e7c2c7ae$export$386c40f28a3efd99;
var $f1433c17e7c2c7ae$export$b7ed17c2edb4d953;
var $f1433c17e7c2c7ae$export$598e9af52cb9b904;
var $f1433c17e7c2c7ae$export$35784e2518402c99;
var $f1433c17e7c2c7ae$export$352e2c1d24776bfb;
var $f1433c17e7c2c7ae$export$3c52dd84024ae72c;
'use strict';
const $f1433c17e7c2c7ae$var$EOF = 0;
// https://drafts.csswg.org/css-syntax-3/
// § 4.2. Definitions
// digit
// A code point between U+0030 DIGIT ZERO (0) and U+0039 DIGIT NINE (9).
function $f1433c17e7c2c7ae$var$isDigit(code) {
    return code >= 0x0030 && code <= 0x0039;
}
// hex digit
// A digit, or a code point between U+0041 LATIN CAPITAL LETTER A (A) and U+0046 LATIN CAPITAL LETTER F (F),
// or a code point between U+0061 LATIN SMALL LETTER A (a) and U+0066 LATIN SMALL LETTER F (f).
function $f1433c17e7c2c7ae$var$isHexDigit(code) {
    return $f1433c17e7c2c7ae$var$isDigit(code) || // 0 .. 9
    code >= 0x0041 && code <= 0x0046 || // A .. F
    code >= 0x0061 && code <= 0x0066 // a .. f
    ;
}
// uppercase letter
// A code point between U+0041 LATIN CAPITAL LETTER A (A) and U+005A LATIN CAPITAL LETTER Z (Z).
function $f1433c17e7c2c7ae$var$isUppercaseLetter(code) {
    return code >= 0x0041 && code <= 0x005A;
}
// lowercase letter
// A code point between U+0061 LATIN SMALL LETTER A (a) and U+007A LATIN SMALL LETTER Z (z).
function $f1433c17e7c2c7ae$var$isLowercaseLetter(code) {
    return code >= 0x0061 && code <= 0x007A;
}
// letter
// An uppercase letter or a lowercase letter.
function $f1433c17e7c2c7ae$var$isLetter(code) {
    return $f1433c17e7c2c7ae$var$isUppercaseLetter(code) || $f1433c17e7c2c7ae$var$isLowercaseLetter(code);
}
// non-ASCII code point
// A code point with a value equal to or greater than U+0080 <control>.
function $f1433c17e7c2c7ae$var$isNonAscii(code) {
    return code >= 0x0080;
}
// name-start code point
// A letter, a non-ASCII code point, or U+005F LOW LINE (_).
function $f1433c17e7c2c7ae$var$isNameStart(code) {
    return $f1433c17e7c2c7ae$var$isLetter(code) || $f1433c17e7c2c7ae$var$isNonAscii(code) || code === 0x005F;
}
// name code point
// A name-start code point, a digit, or U+002D HYPHEN-MINUS (-).
function $f1433c17e7c2c7ae$var$isName(code) {
    return $f1433c17e7c2c7ae$var$isNameStart(code) || $f1433c17e7c2c7ae$var$isDigit(code) || code === 0x002D;
}
// non-printable code point
// A code point between U+0000 NULL and U+0008 BACKSPACE, or U+000B LINE TABULATION,
// or a code point between U+000E SHIFT OUT and U+001F INFORMATION SEPARATOR ONE, or U+007F DELETE.
function $f1433c17e7c2c7ae$var$isNonPrintable(code) {
    return code >= 0x0000 && code <= 0x0008 || code === 0x000B || code >= 0x000E && code <= 0x001F || code === 0x007F;
}
// newline
// U+000A LINE FEED. Note that U+000D CARRIAGE RETURN and U+000C FORM FEED are not included in this definition,
// as they are converted to U+000A LINE FEED during preprocessing.
// TODO: we doesn't do a preprocessing, so check a code point for U+000D CARRIAGE RETURN and U+000C FORM FEED
function $f1433c17e7c2c7ae$var$isNewline(code) {
    return code === 0x000A || code === 0x000D || code === 0x000C;
}
// whitespace
// A newline, U+0009 CHARACTER TABULATION, or U+0020 SPACE.
function $f1433c17e7c2c7ae$var$isWhiteSpace(code) {
    return $f1433c17e7c2c7ae$var$isNewline(code) || code === 0x0020 || code === 0x0009;
}
// § 4.3.8. Check if two code points are a valid escape
function $f1433c17e7c2c7ae$var$isValidEscape(first, second) {
    // If the first code point is not U+005C REVERSE SOLIDUS (\), return false.
    if (first !== 0x005C) return false;
    // Otherwise, if the second code point is a newline or EOF, return false.
    if ($f1433c17e7c2c7ae$var$isNewline(second) || second === $f1433c17e7c2c7ae$var$EOF) return false;
    // Otherwise, return true.
    return true;
}
// § 4.3.9. Check if three code points would start an identifier
function $f1433c17e7c2c7ae$var$isIdentifierStart(first, second, third) {
    // Look at the first code point:
    // U+002D HYPHEN-MINUS
    if (first === 0x002D) // If the second code point is a name-start code point or a U+002D HYPHEN-MINUS,
    // or the second and third code points are a valid escape, return true. Otherwise, return false.
    return $f1433c17e7c2c7ae$var$isNameStart(second) || second === 0x002D || $f1433c17e7c2c7ae$var$isValidEscape(second, third);
    // name-start code point
    if ($f1433c17e7c2c7ae$var$isNameStart(first)) // Return true.
    return true;
    // U+005C REVERSE SOLIDUS (\)
    if (first === 0x005C) // If the first and second code points are a valid escape, return true. Otherwise, return false.
    return $f1433c17e7c2c7ae$var$isValidEscape(first, second);
    // anything else
    // Return false.
    return false;
}
// § 4.3.10. Check if three code points would start a number
function $f1433c17e7c2c7ae$var$isNumberStart(first, second, third) {
    // Look at the first code point:
    // U+002B PLUS SIGN (+)
    // U+002D HYPHEN-MINUS (-)
    if (first === 0x002B || first === 0x002D) {
        // If the second code point is a digit, return true.
        if ($f1433c17e7c2c7ae$var$isDigit(second)) return 2;
        // Otherwise, if the second code point is a U+002E FULL STOP (.)
        // and the third code point is a digit, return true.
        // Otherwise, return false.
        return second === 0x002E && $f1433c17e7c2c7ae$var$isDigit(third) ? 3 : 0;
    }
    // U+002E FULL STOP (.)
    if (first === 0x002E) // If the second code point is a digit, return true. Otherwise, return false.
    return $f1433c17e7c2c7ae$var$isDigit(second) ? 2 : 0;
    // digit
    if ($f1433c17e7c2c7ae$var$isDigit(first)) // Return true.
    return 1;
    // anything else
    // Return false.
    return 0;
}
//
// Misc
//
// detect BOM (https://en.wikipedia.org/wiki/Byte_order_mark)
function $f1433c17e7c2c7ae$var$isBOM(code) {
    // UTF-16BE
    if (code === 0xFEFF) return 1;
    // UTF-16LE
    if (code === 0xFFFE) return 1;
    return 0;
}
// Fast code category
// Only ASCII code points has a special meaning, that's why we define a maps for 0..127 codes only
const $f1433c17e7c2c7ae$var$CATEGORY = new Array(0x80);
const $f1433c17e7c2c7ae$var$EofCategory = 0x80;
const $f1433c17e7c2c7ae$var$WhiteSpaceCategory = 0x82;
const $f1433c17e7c2c7ae$var$DigitCategory = 0x83;
const $f1433c17e7c2c7ae$var$NameStartCategory = 0x84;
const $f1433c17e7c2c7ae$var$NonPrintableCategory = 0x85;
for(let i = 0; i < $f1433c17e7c2c7ae$var$CATEGORY.length; i++)$f1433c17e7c2c7ae$var$CATEGORY[i] = $f1433c17e7c2c7ae$var$isWhiteSpace(i) && $f1433c17e7c2c7ae$var$WhiteSpaceCategory || $f1433c17e7c2c7ae$var$isDigit(i) && $f1433c17e7c2c7ae$var$DigitCategory || $f1433c17e7c2c7ae$var$isNameStart(i) && $f1433c17e7c2c7ae$var$NameStartCategory || $f1433c17e7c2c7ae$var$isNonPrintable(i) && $f1433c17e7c2c7ae$var$NonPrintableCategory || i || $f1433c17e7c2c7ae$var$EofCategory;
function $f1433c17e7c2c7ae$var$charCodeCategory(code) {
    return code < 0x80 ? $f1433c17e7c2c7ae$var$CATEGORY[code] : $f1433c17e7c2c7ae$var$NameStartCategory;
}
$f1433c17e7c2c7ae$export$bbf58a4a05c6b6e2 = $f1433c17e7c2c7ae$var$DigitCategory;
$f1433c17e7c2c7ae$export$2f591833f7f1b967 = $f1433c17e7c2c7ae$var$EofCategory;
$f1433c17e7c2c7ae$export$48d90b0d2444a844 = $f1433c17e7c2c7ae$var$NameStartCategory;
$f1433c17e7c2c7ae$export$deba3a5f607eb19 = $f1433c17e7c2c7ae$var$NonPrintableCategory;
$f1433c17e7c2c7ae$export$90f8a5e44c6cc5e3 = $f1433c17e7c2c7ae$var$WhiteSpaceCategory;
$f1433c17e7c2c7ae$export$4b3b0ba223857b61 = $f1433c17e7c2c7ae$var$charCodeCategory;
$f1433c17e7c2c7ae$export$da737789103788ca = $f1433c17e7c2c7ae$var$isBOM;
$f1433c17e7c2c7ae$export$727d9dbc4fbb948f = $f1433c17e7c2c7ae$var$isDigit;
$f1433c17e7c2c7ae$export$2a81dc4d1a2f9334 = $f1433c17e7c2c7ae$var$isHexDigit;
$f1433c17e7c2c7ae$export$56b48cc5d7560ffb = $f1433c17e7c2c7ae$var$isIdentifierStart;
$f1433c17e7c2c7ae$export$79c5d5217943d6a7 = $f1433c17e7c2c7ae$var$isLetter;
$f1433c17e7c2c7ae$export$25a7e820fbcd58b9 = $f1433c17e7c2c7ae$var$isLowercaseLetter;
$f1433c17e7c2c7ae$export$998d7ff9801e90bb = $f1433c17e7c2c7ae$var$isName;
$f1433c17e7c2c7ae$export$45a677ea7cb6d5c8 = $f1433c17e7c2c7ae$var$isNameStart;
$f1433c17e7c2c7ae$export$c6b40e80adfef3ae = $f1433c17e7c2c7ae$var$isNewline;
$f1433c17e7c2c7ae$export$386c40f28a3efd99 = $f1433c17e7c2c7ae$var$isNonAscii;
$f1433c17e7c2c7ae$export$b7ed17c2edb4d953 = $f1433c17e7c2c7ae$var$isNonPrintable;
$f1433c17e7c2c7ae$export$598e9af52cb9b904 = $f1433c17e7c2c7ae$var$isNumberStart;
$f1433c17e7c2c7ae$export$35784e2518402c99 = $f1433c17e7c2c7ae$var$isUppercaseLetter;
$f1433c17e7c2c7ae$export$352e2c1d24776bfb = $f1433c17e7c2c7ae$var$isValidEscape;
$f1433c17e7c2c7ae$export$3c52dd84024ae72c = $f1433c17e7c2c7ae$var$isWhiteSpace;

});

parcelRegister("7UrOl", function(module, exports) {

$parcel$export(module.exports, "cmpChar", () => $5c23560d43844b43$export$6902610076fb2dc1, (v) => $5c23560d43844b43$export$6902610076fb2dc1 = v);
$parcel$export(module.exports, "cmpStr", () => $5c23560d43844b43$export$5bf4b3d0861be8d9, (v) => $5c23560d43844b43$export$5bf4b3d0861be8d9 = v);
$parcel$export(module.exports, "consumeBadUrlRemnants", () => $5c23560d43844b43$export$349fae4425f20458, (v) => $5c23560d43844b43$export$349fae4425f20458 = v);
$parcel$export(module.exports, "consumeEscaped", () => $5c23560d43844b43$export$1cf8ac3f090cf48a, (v) => $5c23560d43844b43$export$1cf8ac3f090cf48a = v);
$parcel$export(module.exports, "consumeName", () => $5c23560d43844b43$export$e314ae15c0f41984, (v) => $5c23560d43844b43$export$e314ae15c0f41984 = v);
$parcel$export(module.exports, "consumeNumber", () => $5c23560d43844b43$export$b817115b8219186a, (v) => $5c23560d43844b43$export$b817115b8219186a = v);
$parcel$export(module.exports, "decodeEscaped", () => $5c23560d43844b43$export$5ed93187f4ce070a, (v) => $5c23560d43844b43$export$5ed93187f4ce070a = v);
$parcel$export(module.exports, "findDecimalNumberEnd", () => $5c23560d43844b43$export$e9aed36b506f417c, (v) => $5c23560d43844b43$export$e9aed36b506f417c = v);
$parcel$export(module.exports, "findWhiteSpaceEnd", () => $5c23560d43844b43$export$5bd0595948d7ed9, (v) => $5c23560d43844b43$export$5bd0595948d7ed9 = v);
$parcel$export(module.exports, "findWhiteSpaceStart", () => $5c23560d43844b43$export$c4eb8307a0331d71, (v) => $5c23560d43844b43$export$c4eb8307a0331d71 = v);
$parcel$export(module.exports, "getNewlineLength", () => $5c23560d43844b43$export$2e282c3c0c638f20, (v) => $5c23560d43844b43$export$2e282c3c0c638f20 = v);
var $5c23560d43844b43$export$6902610076fb2dc1;
var $5c23560d43844b43$export$5bf4b3d0861be8d9;
var $5c23560d43844b43$export$349fae4425f20458;
var $5c23560d43844b43$export$1cf8ac3f090cf48a;
var $5c23560d43844b43$export$e314ae15c0f41984;
var $5c23560d43844b43$export$b817115b8219186a;
var $5c23560d43844b43$export$5ed93187f4ce070a;
var $5c23560d43844b43$export$e9aed36b506f417c;
var $5c23560d43844b43$export$5bd0595948d7ed9;
var $5c23560d43844b43$export$c4eb8307a0331d71;
var $5c23560d43844b43$export$2e282c3c0c638f20;
'use strict';

var $kIeAG = parcelRequire("kIeAG");
function $5c23560d43844b43$var$getCharCode(source, offset) {
    return offset < source.length ? source.charCodeAt(offset) : 0;
}
function $5c23560d43844b43$var$getNewlineLength(source, offset, code) {
    if (code === 13 /* \r */  && $5c23560d43844b43$var$getCharCode(source, offset + 1) === 10 /* \n */ ) return 2;
    return 1;
}
function $5c23560d43844b43$var$cmpChar(testStr, offset, referenceCode) {
    let code = testStr.charCodeAt(offset);
    // code.toLowerCase() for A..Z
    if ($kIeAG.isUppercaseLetter(code)) code = code | 32;
    return code === referenceCode;
}
function $5c23560d43844b43$var$cmpStr(testStr, start, end, referenceStr) {
    if (end - start !== referenceStr.length) return false;
    if (start < 0 || end > testStr.length) return false;
    for(let i = start; i < end; i++){
        const referenceCode = referenceStr.charCodeAt(i - start);
        let testCode = testStr.charCodeAt(i);
        // testCode.toLowerCase() for A..Z
        if ($kIeAG.isUppercaseLetter(testCode)) testCode = testCode | 32;
        if (testCode !== referenceCode) return false;
    }
    return true;
}
function $5c23560d43844b43$var$findWhiteSpaceStart(source, offset) {
    for(; offset >= 0; offset--){
        if (!$kIeAG.isWhiteSpace(source.charCodeAt(offset))) break;
    }
    return offset + 1;
}
function $5c23560d43844b43$var$findWhiteSpaceEnd(source, offset) {
    for(; offset < source.length; offset++){
        if (!$kIeAG.isWhiteSpace(source.charCodeAt(offset))) break;
    }
    return offset;
}
function $5c23560d43844b43$var$findDecimalNumberEnd(source, offset) {
    for(; offset < source.length; offset++){
        if (!$kIeAG.isDigit(source.charCodeAt(offset))) break;
    }
    return offset;
}
// § 4.3.7. Consume an escaped code point
function $5c23560d43844b43$var$consumeEscaped(source, offset) {
    // It assumes that the U+005C REVERSE SOLIDUS (\) has already been consumed and
    // that the next input code point has already been verified to be part of a valid escape.
    offset += 2;
    // hex digit
    if ($kIeAG.isHexDigit($5c23560d43844b43$var$getCharCode(source, offset - 1))) {
        // Consume as many hex digits as possible, but no more than 5.
        // Note that this means 1-6 hex digits have been consumed in total.
        for(const maxOffset = Math.min(source.length, offset + 5); offset < maxOffset; offset++){
            if (!$kIeAG.isHexDigit($5c23560d43844b43$var$getCharCode(source, offset))) break;
        }
        // If the next input code point is whitespace, consume it as well.
        const code = $5c23560d43844b43$var$getCharCode(source, offset);
        if ($kIeAG.isWhiteSpace(code)) offset += $5c23560d43844b43$var$getNewlineLength(source, offset, code);
    }
    return offset;
}
// §4.3.11. Consume a name
// Note: This algorithm does not do the verification of the first few code points that are necessary
// to ensure the returned code points would constitute an <ident-token>. If that is the intended use,
// ensure that the stream starts with an identifier before calling this algorithm.
function $5c23560d43844b43$var$consumeName(source, offset) {
    // Let result initially be an empty string.
    // Repeatedly consume the next input code point from the stream:
    for(; offset < source.length; offset++){
        const code = source.charCodeAt(offset);
        // name code point
        if ($kIeAG.isName(code)) continue;
        // the stream starts with a valid escape
        if ($kIeAG.isValidEscape(code, $5c23560d43844b43$var$getCharCode(source, offset + 1))) {
            // Consume an escaped code point. Append the returned code point to result.
            offset = $5c23560d43844b43$var$consumeEscaped(source, offset) - 1;
            continue;
        }
        break;
    }
    return offset;
}
// §4.3.12. Consume a number
function $5c23560d43844b43$var$consumeNumber(source, offset) {
    let code = source.charCodeAt(offset);
    // 2. If the next input code point is U+002B PLUS SIGN (+) or U+002D HYPHEN-MINUS (-),
    // consume it and append it to repr.
    if (code === 0x002B || code === 0x002D) code = source.charCodeAt(offset += 1);
    // 3. While the next input code point is a digit, consume it and append it to repr.
    if ($kIeAG.isDigit(code)) {
        offset = $5c23560d43844b43$var$findDecimalNumberEnd(source, offset + 1);
        code = source.charCodeAt(offset);
    }
    // 4. If the next 2 input code points are U+002E FULL STOP (.) followed by a digit, then:
    if (code === 0x002E && $kIeAG.isDigit(source.charCodeAt(offset + 1))) {
        // 4.1 Consume them.
        // 4.2 Append them to repr.
        offset += 2;
        // 4.3 Set type to "number".
        // TODO
        // 4.4 While the next input code point is a digit, consume it and append it to repr.
        offset = $5c23560d43844b43$var$findDecimalNumberEnd(source, offset);
    }
    // 5. If the next 2 or 3 input code points are U+0045 LATIN CAPITAL LETTER E (E)
    // or U+0065 LATIN SMALL LETTER E (e), ... , followed by a digit, then:
    if ($5c23560d43844b43$var$cmpChar(source, offset, 101 /* e */ )) {
        let sign = 0;
        code = source.charCodeAt(offset + 1);
        // ... optionally followed by U+002D HYPHEN-MINUS (-) or U+002B PLUS SIGN (+) ...
        if (code === 0x002D || code === 0x002B) {
            sign = 1;
            code = source.charCodeAt(offset + 2);
        }
        // ... followed by a digit
        if ($kIeAG.isDigit(code)) // 5.1 Consume them.
        // 5.2 Append them to repr.
        // 5.3 Set type to "number".
        // TODO
        // 5.4 While the next input code point is a digit, consume it and append it to repr.
        offset = $5c23560d43844b43$var$findDecimalNumberEnd(source, offset + 1 + sign + 1);
    }
    return offset;
}
// § 4.3.14. Consume the remnants of a bad url
// ... its sole use is to consume enough of the input stream to reach a recovery point
// where normal tokenizing can resume.
function $5c23560d43844b43$var$consumeBadUrlRemnants(source, offset) {
    // Repeatedly consume the next input code point from the stream:
    for(; offset < source.length; offset++){
        const code = source.charCodeAt(offset);
        // U+0029 RIGHT PARENTHESIS ())
        // EOF
        if (code === 0x0029) {
            // Return.
            offset++;
            break;
        }
        if ($kIeAG.isValidEscape(code, $5c23560d43844b43$var$getCharCode(source, offset + 1))) // Consume an escaped code point.
        // Note: This allows an escaped right parenthesis ("\)") to be encountered
        // without ending the <bad-url-token>. This is otherwise identical to
        // the "anything else" clause.
        offset = $5c23560d43844b43$var$consumeEscaped(source, offset);
    }
    return offset;
}
// § 4.3.7. Consume an escaped code point
// Note: This algorithm assumes that escaped is valid without leading U+005C REVERSE SOLIDUS (\)
function $5c23560d43844b43$var$decodeEscaped(escaped) {
    // Single char escaped that's not a hex digit
    if (escaped.length === 1 && !$kIeAG.isHexDigit(escaped.charCodeAt(0))) return escaped[0];
    // Interpret the hex digits as a hexadecimal number.
    let code = parseInt(escaped, 16);
    if (code === 0 || // If this number is zero,
    code >= 0xD800 && code <= 0xDFFF || // or is for a surrogate,
    code > 0x10FFFF // or is greater than the maximum allowed code point
    ) // ... return U+FFFD REPLACEMENT CHARACTER
    code = 0xFFFD;
    // Otherwise, return the code point with that value.
    return String.fromCodePoint(code);
}
$5c23560d43844b43$export$6902610076fb2dc1 = $5c23560d43844b43$var$cmpChar;
$5c23560d43844b43$export$5bf4b3d0861be8d9 = $5c23560d43844b43$var$cmpStr;
$5c23560d43844b43$export$349fae4425f20458 = $5c23560d43844b43$var$consumeBadUrlRemnants;
$5c23560d43844b43$export$1cf8ac3f090cf48a = $5c23560d43844b43$var$consumeEscaped;
$5c23560d43844b43$export$e314ae15c0f41984 = $5c23560d43844b43$var$consumeName;
$5c23560d43844b43$export$b817115b8219186a = $5c23560d43844b43$var$consumeNumber;
$5c23560d43844b43$export$5ed93187f4ce070a = $5c23560d43844b43$var$decodeEscaped;
$5c23560d43844b43$export$e9aed36b506f417c = $5c23560d43844b43$var$findDecimalNumberEnd;
$5c23560d43844b43$export$5bd0595948d7ed9 = $5c23560d43844b43$var$findWhiteSpaceEnd;
$5c23560d43844b43$export$c4eb8307a0331d71 = $5c23560d43844b43$var$findWhiteSpaceStart;
$5c23560d43844b43$export$2e282c3c0c638f20 = $5c23560d43844b43$var$getNewlineLength;

});

parcelRegister("jhzPX", function(module, exports) {
'use strict';
const $e09b675b792298d6$var$tokenNames = [
    'EOF-token',
    'ident-token',
    'function-token',
    'at-keyword-token',
    'hash-token',
    'string-token',
    'bad-string-token',
    'url-token',
    'bad-url-token',
    'delim-token',
    'number-token',
    'percentage-token',
    'dimension-token',
    'whitespace-token',
    'CDO-token',
    'CDC-token',
    'colon-token',
    'semicolon-token',
    'comma-token',
    '[-token',
    ']-token',
    '(-token',
    ')-token',
    '{-token',
    '}-token'
];
module.exports = $e09b675b792298d6$var$tokenNames;

});

parcelRegister("eioKZ", function(module, exports) {

$parcel$export(module.exports, "OffsetToLocation", () => $a685f359ad128d25$export$a1e9ec249d80652c, (v) => $a685f359ad128d25$export$a1e9ec249d80652c = v);
var $a685f359ad128d25$export$a1e9ec249d80652c;
'use strict';

var $egRLK = parcelRequire("egRLK");

var $kIeAG = parcelRequire("kIeAG");
const $a685f359ad128d25$var$N = 10;
const $a685f359ad128d25$var$F = 12;
const $a685f359ad128d25$var$R = 13;
function $a685f359ad128d25$var$computeLinesAndColumns(host) {
    const source = host.source;
    const sourceLength = source.length;
    const startOffset = source.length > 0 ? $kIeAG.isBOM(source.charCodeAt(0)) : 0;
    const lines = $egRLK.adoptBuffer(host.lines, sourceLength);
    const columns = $egRLK.adoptBuffer(host.columns, sourceLength);
    let line = host.startLine;
    let column = host.startColumn;
    for(let i = startOffset; i < sourceLength; i++){
        const code = source.charCodeAt(i);
        lines[i] = line;
        columns[i] = column++;
        if (code === $a685f359ad128d25$var$N || code === $a685f359ad128d25$var$R || code === $a685f359ad128d25$var$F) {
            if (code === $a685f359ad128d25$var$R && i + 1 < sourceLength && source.charCodeAt(i + 1) === $a685f359ad128d25$var$N) {
                i++;
                lines[i] = line;
                columns[i] = column;
            }
            line++;
            column = 1;
        }
    }
    lines[sourceLength] = line;
    columns[sourceLength] = column;
    host.lines = lines;
    host.columns = columns;
    host.computed = true;
}
class $a685f359ad128d25$var$OffsetToLocation {
    setSource(source, startOffset = 0, startLine = 1, startColumn = 1) {
        this.source = source;
        this.startOffset = startOffset;
        this.startLine = startLine;
        this.startColumn = startColumn;
        this.computed = false;
    }
    getLocation(offset, filename) {
        if (!this.computed) $a685f359ad128d25$var$computeLinesAndColumns(this);
        return {
            source: filename,
            offset: this.startOffset + offset,
            line: this.lines[offset],
            column: this.columns[offset]
        };
    }
    getLocationRange(start, end, filename) {
        if (!this.computed) $a685f359ad128d25$var$computeLinesAndColumns(this);
        return {
            source: filename,
            start: {
                offset: this.startOffset + start,
                line: this.lines[start],
                column: this.columns[start]
            },
            end: {
                offset: this.startOffset + end,
                line: this.lines[end],
                column: this.columns[end]
            }
        };
    }
    constructor(){
        this.lines = null;
        this.columns = null;
        this.computed = false;
    }
}
$a685f359ad128d25$export$a1e9ec249d80652c = $a685f359ad128d25$var$OffsetToLocation;

});
parcelRegister("egRLK", function(module, exports) {

$parcel$export(module.exports, "adoptBuffer", () => $a63c44bd351dc817$export$cb41ea972ba24ee8, (v) => $a63c44bd351dc817$export$cb41ea972ba24ee8 = v);
var $a63c44bd351dc817$export$cb41ea972ba24ee8;
'use strict';
const $a63c44bd351dc817$var$MIN_SIZE = 16384;
function $a63c44bd351dc817$var$adoptBuffer(buffer = null, size) {
    if (buffer === null || buffer.length < size) return new Uint32Array(Math.max(size + 1024, $a63c44bd351dc817$var$MIN_SIZE));
    return buffer;
}
$a63c44bd351dc817$export$cb41ea972ba24ee8 = $a63c44bd351dc817$var$adoptBuffer;

});


parcelRegister("3Bp4a", function(module, exports) {

$parcel$export(module.exports, "TokenStream", () => $29f8456bd0acbc80$export$b55edb69cfa7ac57, (v) => $29f8456bd0acbc80$export$b55edb69cfa7ac57 = v);
var $29f8456bd0acbc80$export$b55edb69cfa7ac57;
'use strict';

var $egRLK = parcelRequire("egRLK");

var $7UrOl = parcelRequire("7UrOl");

var $jhzPX = parcelRequire("jhzPX");

var $iYo0F = parcelRequire("iYo0F");
const $29f8456bd0acbc80$var$OFFSET_MASK = 0x00FFFFFF;
const $29f8456bd0acbc80$var$TYPE_SHIFT = 24;
const $29f8456bd0acbc80$var$balancePair = new Map([
    [
        $iYo0F.Function,
        $iYo0F.RightParenthesis
    ],
    [
        $iYo0F.LeftParenthesis,
        $iYo0F.RightParenthesis
    ],
    [
        $iYo0F.LeftSquareBracket,
        $iYo0F.RightSquareBracket
    ],
    [
        $iYo0F.LeftCurlyBracket,
        $iYo0F.RightCurlyBracket
    ]
]);
class $29f8456bd0acbc80$var$TokenStream {
    reset() {
        this.eof = false;
        this.tokenIndex = -1;
        this.tokenType = 0;
        this.tokenStart = this.firstCharOffset;
        this.tokenEnd = this.firstCharOffset;
    }
    setSource(source = '', tokenize = ()=>{}) {
        source = String(source || '');
        const sourceLength = source.length;
        const offsetAndType = $egRLK.adoptBuffer(this.offsetAndType, source.length + 1); // +1 because of eof-token
        const balance = $egRLK.adoptBuffer(this.balance, source.length + 1);
        let tokenCount = 0;
        let balanceCloseType = 0;
        let balanceStart = 0;
        let firstCharOffset = -1;
        // capture buffers
        this.offsetAndType = null;
        this.balance = null;
        tokenize(source, (type, start, end)=>{
            switch(type){
                default:
                    balance[tokenCount] = sourceLength;
                    break;
                case balanceCloseType:
                    {
                        let balancePrev = balanceStart & $29f8456bd0acbc80$var$OFFSET_MASK;
                        balanceStart = balance[balancePrev];
                        balanceCloseType = balanceStart >> $29f8456bd0acbc80$var$TYPE_SHIFT;
                        balance[tokenCount] = balancePrev;
                        balance[balancePrev++] = tokenCount;
                        for(; balancePrev < tokenCount; balancePrev++)if (balance[balancePrev] === sourceLength) balance[balancePrev] = tokenCount;
                        break;
                    }
                case $iYo0F.LeftParenthesis:
                case $iYo0F.Function:
                case $iYo0F.LeftSquareBracket:
                case $iYo0F.LeftCurlyBracket:
                    balance[tokenCount] = balanceStart;
                    balanceCloseType = $29f8456bd0acbc80$var$balancePair.get(type);
                    balanceStart = balanceCloseType << $29f8456bd0acbc80$var$TYPE_SHIFT | tokenCount;
                    break;
            }
            offsetAndType[tokenCount++] = type << $29f8456bd0acbc80$var$TYPE_SHIFT | end;
            if (firstCharOffset === -1) firstCharOffset = start;
        });
        // finalize buffers
        offsetAndType[tokenCount] = $iYo0F.EOF << $29f8456bd0acbc80$var$TYPE_SHIFT | sourceLength; // <EOF-token>
        balance[tokenCount] = sourceLength;
        balance[sourceLength] = sourceLength; // prevents false positive balance match with any token
        while(balanceStart !== 0){
            const balancePrev = balanceStart & $29f8456bd0acbc80$var$OFFSET_MASK;
            balanceStart = balance[balancePrev];
            balance[balancePrev] = sourceLength;
        }
        this.source = source;
        this.firstCharOffset = firstCharOffset === -1 ? 0 : firstCharOffset;
        this.tokenCount = tokenCount;
        this.offsetAndType = offsetAndType;
        this.balance = balance;
        this.reset();
        this.next();
    }
    lookupType(offset) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return this.offsetAndType[offset] >> $29f8456bd0acbc80$var$TYPE_SHIFT;
        return $iYo0F.EOF;
    }
    lookupOffset(offset) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return this.offsetAndType[offset - 1] & $29f8456bd0acbc80$var$OFFSET_MASK;
        return this.source.length;
    }
    lookupValue(offset, referenceStr) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return $7UrOl.cmpStr(this.source, this.offsetAndType[offset - 1] & $29f8456bd0acbc80$var$OFFSET_MASK, this.offsetAndType[offset] & $29f8456bd0acbc80$var$OFFSET_MASK, referenceStr);
        return false;
    }
    getTokenStart(tokenIndex) {
        if (tokenIndex === this.tokenIndex) return this.tokenStart;
        if (tokenIndex > 0) return tokenIndex < this.tokenCount ? this.offsetAndType[tokenIndex - 1] & $29f8456bd0acbc80$var$OFFSET_MASK : this.offsetAndType[this.tokenCount] & $29f8456bd0acbc80$var$OFFSET_MASK;
        return this.firstCharOffset;
    }
    substrToCursor(start) {
        return this.source.substring(start, this.tokenStart);
    }
    isBalanceEdge(pos) {
        return this.balance[this.tokenIndex] < pos;
    }
    isDelim(code, offset) {
        if (offset) return this.lookupType(offset) === $iYo0F.Delim && this.source.charCodeAt(this.lookupOffset(offset)) === code;
        return this.tokenType === $iYo0F.Delim && this.source.charCodeAt(this.tokenStart) === code;
    }
    skip(tokenCount) {
        let next = this.tokenIndex + tokenCount;
        if (next < this.tokenCount) {
            this.tokenIndex = next;
            this.tokenStart = this.offsetAndType[next - 1] & $29f8456bd0acbc80$var$OFFSET_MASK;
            next = this.offsetAndType[next];
            this.tokenType = next >> $29f8456bd0acbc80$var$TYPE_SHIFT;
            this.tokenEnd = next & $29f8456bd0acbc80$var$OFFSET_MASK;
        } else {
            this.tokenIndex = this.tokenCount;
            this.next();
        }
    }
    next() {
        let next = this.tokenIndex + 1;
        if (next < this.tokenCount) {
            this.tokenIndex = next;
            this.tokenStart = this.tokenEnd;
            next = this.offsetAndType[next];
            this.tokenType = next >> $29f8456bd0acbc80$var$TYPE_SHIFT;
            this.tokenEnd = next & $29f8456bd0acbc80$var$OFFSET_MASK;
        } else {
            this.eof = true;
            this.tokenIndex = this.tokenCount;
            this.tokenType = $iYo0F.EOF;
            this.tokenStart = this.tokenEnd = this.source.length;
        }
    }
    skipSC() {
        while(this.tokenType === $iYo0F.WhiteSpace || this.tokenType === $iYo0F.Comment)this.next();
    }
    skipUntilBalanced(startToken, stopConsume) {
        let cursor = startToken;
        let balanceEnd;
        let offset;
        loop: for(; cursor < this.tokenCount; cursor++){
            balanceEnd = this.balance[cursor];
            // stop scanning on balance edge that points to offset before start token
            if (balanceEnd < startToken) break loop;
            offset = cursor > 0 ? this.offsetAndType[cursor - 1] & $29f8456bd0acbc80$var$OFFSET_MASK : this.firstCharOffset;
            // check stop condition
            switch(stopConsume(this.source.charCodeAt(offset))){
                case 1:
                    break loop;
                case 2:
                    cursor++;
                    break loop;
                default:
                    // fast forward to the end of balanced block
                    if (this.balance[balanceEnd] === cursor) cursor = balanceEnd;
            }
        }
        this.skip(cursor - this.tokenIndex);
    }
    forEachToken(fn) {
        for(let i = 0, offset = this.firstCharOffset; i < this.tokenCount; i++){
            const start = offset;
            const item = this.offsetAndType[i];
            const end = item & $29f8456bd0acbc80$var$OFFSET_MASK;
            const type = item >> $29f8456bd0acbc80$var$TYPE_SHIFT;
            offset = end;
            fn(type, start, end, i);
        }
    }
    dump() {
        const tokens = new Array(this.tokenCount);
        this.forEachToken((type, start, end, index)=>{
            tokens[index] = {
                idx: index,
                type: $jhzPX[type],
                chunk: this.source.substring(start, end),
                balance: this.balance[index]
            };
        });
        return tokens;
    }
    constructor(source, tokenize){
        this.setSource(source, tokenize);
    }
}
$29f8456bd0acbc80$export$b55edb69cfa7ac57 = $29f8456bd0acbc80$var$TokenStream;

});


parcelRegister("gWOMR", function(module, exports) {

$parcel$export(module.exports, "createParser", () => $c569755d65587810$export$88a1156fad04455f, (v) => $c569755d65587810$export$88a1156fad04455f = v);
var $c569755d65587810$export$88a1156fad04455f;
'use strict';

var $72kB1 = parcelRequire("72kB1");

var $dyeM8 = parcelRequire("dyeM8");

var $2vMqe = parcelRequire("2vMqe");

var $k6ffb = parcelRequire("k6ffb");

var $eioKZ = parcelRequire("eioKZ");

var $3Bp4a = parcelRequire("3Bp4a");

var $7UrOl = parcelRequire("7UrOl");

var $iYo0F = parcelRequire("iYo0F");

var $jhzPX = parcelRequire("jhzPX");
const $c569755d65587810$var$NOOP = ()=>{};
const $c569755d65587810$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
const $c569755d65587810$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $c569755d65587810$var$SEMICOLON = 0x003B; // U+003B SEMICOLON (;)
const $c569755d65587810$var$LEFTCURLYBRACKET = 0x007B; // U+007B LEFT CURLY BRACKET ({)
const $c569755d65587810$var$NULL = 0;
function $c569755d65587810$var$createParseContext(name) {
    return function() {
        return this[name]();
    };
}
function $c569755d65587810$var$fetchParseValues(dict) {
    const result = Object.create(null);
    for(const name in dict){
        const item = dict[name];
        const fn = item.parse || item;
        if (fn) result[name] = fn;
    }
    return result;
}
function $c569755d65587810$var$processConfig(config) {
    const parseConfig = {
        context: Object.create(null),
        scope: Object.assign(Object.create(null), config.scope),
        atrule: $c569755d65587810$var$fetchParseValues(config.atrule),
        pseudo: $c569755d65587810$var$fetchParseValues(config.pseudo),
        node: $c569755d65587810$var$fetchParseValues(config.node)
    };
    for(const name in config.parseContext)switch(typeof config.parseContext[name]){
        case 'function':
            parseConfig.context[name] = config.parseContext[name];
            break;
        case 'string':
            parseConfig.context[name] = $c569755d65587810$var$createParseContext(config.parseContext[name]);
            break;
    }
    return {
        config: parseConfig,
        ...parseConfig,
        ...parseConfig.node
    };
}
function $c569755d65587810$var$createParser(config) {
    let source = '';
    let filename = '<unknown>';
    let needPositions = false;
    let onParseError = $c569755d65587810$var$NOOP;
    let onParseErrorThrow = false;
    const locationMap = new $eioKZ.OffsetToLocation();
    const parser = Object.assign(new $3Bp4a.TokenStream(), $c569755d65587810$var$processConfig(config || {}), {
        parseAtrulePrelude: true,
        parseRulePrelude: true,
        parseValue: true,
        parseCustomProperty: false,
        readSequence: $k6ffb.readSequence,
        consumeUntilBalanceEnd: ()=>0,
        consumeUntilLeftCurlyBracket (code) {
            return code === $c569755d65587810$var$LEFTCURLYBRACKET ? 1 : 0;
        },
        consumeUntilLeftCurlyBracketOrSemicolon (code) {
            return code === $c569755d65587810$var$LEFTCURLYBRACKET || code === $c569755d65587810$var$SEMICOLON ? 1 : 0;
        },
        consumeUntilExclamationMarkOrSemicolon (code) {
            return code === $c569755d65587810$var$EXCLAMATIONMARK || code === $c569755d65587810$var$SEMICOLON ? 1 : 0;
        },
        consumeUntilSemicolonIncluded (code) {
            return code === $c569755d65587810$var$SEMICOLON ? 2 : 0;
        },
        createList () {
            return new $72kB1.List();
        },
        createSingleNodeList (node) {
            return new $72kB1.List().appendData(node);
        },
        getFirstListNode (list) {
            return list && list.first;
        },
        getLastListNode (list) {
            return list && list.last;
        },
        parseWithFallback (consumer, fallback) {
            const startToken = this.tokenIndex;
            try {
                return consumer.call(this);
            } catch (e) {
                if (onParseErrorThrow) throw e;
                const fallbackNode = fallback.call(this, startToken);
                onParseErrorThrow = true;
                onParseError(e, fallbackNode);
                onParseErrorThrow = false;
                return fallbackNode;
            }
        },
        lookupNonWSType (offset) {
            let type;
            do {
                type = this.lookupType(offset++);
                if (type !== $iYo0F.WhiteSpace) return type;
            }while (type !== $c569755d65587810$var$NULL);
            return $c569755d65587810$var$NULL;
        },
        charCodeAt (offset) {
            return offset >= 0 && offset < source.length ? source.charCodeAt(offset) : 0;
        },
        substring (offsetStart, offsetEnd) {
            return source.substring(offsetStart, offsetEnd);
        },
        substrToCursor (start) {
            return this.source.substring(start, this.tokenStart);
        },
        cmpChar (offset, charCode) {
            return $7UrOl.cmpChar(source, offset, charCode);
        },
        cmpStr (offsetStart, offsetEnd, str) {
            return $7UrOl.cmpStr(source, offsetStart, offsetEnd, str);
        },
        consume (tokenType) {
            const start = this.tokenStart;
            this.eat(tokenType);
            return this.substrToCursor(start);
        },
        consumeFunctionName () {
            const name = source.substring(this.tokenStart, this.tokenEnd - 1);
            this.eat($iYo0F.Function);
            return name;
        },
        consumeNumber (type) {
            const number = source.substring(this.tokenStart, $7UrOl.consumeNumber(source, this.tokenStart));
            this.eat(type);
            return number;
        },
        eat (tokenType) {
            if (this.tokenType !== tokenType) {
                const tokenName = $jhzPX[tokenType].slice(0, -6).replace(/-/g, ' ').replace(/^./, (m)=>m.toUpperCase());
                let message = `${/[[\](){}]/.test(tokenName) ? `"${tokenName}"` : tokenName} is expected`;
                let offset = this.tokenStart;
                // tweak message and offset
                switch(tokenType){
                    case $iYo0F.Ident:
                        // when identifier is expected but there is a function or url
                        if (this.tokenType === $iYo0F.Function || this.tokenType === $iYo0F.Url) {
                            offset = this.tokenEnd - 1;
                            message = 'Identifier is expected but function found';
                        } else message = 'Identifier is expected';
                        break;
                    case $iYo0F.Hash:
                        if (this.isDelim($c569755d65587810$var$NUMBERSIGN)) {
                            this.next();
                            offset++;
                            message = 'Name is expected';
                        }
                        break;
                    case $iYo0F.Percentage:
                        if (this.tokenType === $iYo0F.Number) {
                            offset = this.tokenEnd;
                            message = 'Percent sign is expected';
                        }
                        break;
                }
                this.error(message, offset);
            }
            this.next();
        },
        eatIdent (name) {
            if (this.tokenType !== $iYo0F.Ident || this.lookupValue(0, name) === false) this.error(`Identifier "${name}" is expected`);
            this.next();
        },
        eatDelim (code) {
            if (!this.isDelim(code)) this.error(`Delim "${String.fromCharCode(code)}" is expected`);
            this.next();
        },
        getLocation (start, end) {
            if (needPositions) return locationMap.getLocationRange(start, end, filename);
            return null;
        },
        getLocationFromList (list) {
            if (needPositions) {
                const head = this.getFirstListNode(list);
                const tail = this.getLastListNode(list);
                return locationMap.getLocationRange(head !== null ? head.loc.start.offset - locationMap.startOffset : this.tokenStart, tail !== null ? tail.loc.end.offset - locationMap.startOffset : this.tokenStart, filename);
            }
            return null;
        },
        error (message, offset) {
            const location = typeof offset !== 'undefined' && offset < source.length ? locationMap.getLocation(offset) : this.eof ? locationMap.getLocation($7UrOl.findWhiteSpaceStart(source, source.length - 1)) : locationMap.getLocation(this.tokenStart);
            throw new $dyeM8.SyntaxError(message || 'Unexpected input', source, location.offset, location.line, location.column);
        }
    });
    const parse = function(source_, options) {
        source = source_;
        options = options || {};
        parser.setSource(source, $2vMqe.tokenize);
        locationMap.setSource(source, options.offset, options.line, options.column);
        filename = options.filename || '<unknown>';
        needPositions = Boolean(options.positions);
        onParseError = typeof options.onParseError === 'function' ? options.onParseError : $c569755d65587810$var$NOOP;
        onParseErrorThrow = false;
        parser.parseAtrulePrelude = 'parseAtrulePrelude' in options ? Boolean(options.parseAtrulePrelude) : true;
        parser.parseRulePrelude = 'parseRulePrelude' in options ? Boolean(options.parseRulePrelude) : true;
        parser.parseValue = 'parseValue' in options ? Boolean(options.parseValue) : true;
        parser.parseCustomProperty = 'parseCustomProperty' in options ? Boolean(options.parseCustomProperty) : false;
        const { context: context = 'default', onComment: onComment } = options;
        if (context in parser.context === false) throw new Error('Unknown context `' + context + '`');
        if (typeof onComment === 'function') parser.forEachToken((type, start, end)=>{
            if (type === $iYo0F.Comment) {
                const loc = parser.getLocation(start, end);
                const value = $7UrOl.cmpStr(source, end - 2, end, '*/') ? source.slice(start + 2, end - 2) : source.slice(start + 2, end);
                onComment(value, loc);
            }
        });
        const ast = parser.context[context].call(parser, options);
        if (!parser.eof) parser.error();
        return ast;
    };
    return Object.assign(parse, {
        SyntaxError: $dyeM8.SyntaxError,
        config: parser.config
    });
}
$c569755d65587810$export$88a1156fad04455f = $c569755d65587810$var$createParser;

});
parcelRegister("72kB1", function(module, exports) {

$parcel$export(module.exports, "List", () => $51f8b242c201426e$export$54c2e3dc7acea9f5, (v) => $51f8b242c201426e$export$54c2e3dc7acea9f5 = v);
var $51f8b242c201426e$export$54c2e3dc7acea9f5;
'use strict';
//
//                              list
//                            ┌──────┐
//             ┌──────────────┼─head │
//             │              │ tail─┼──────────────┐
//             │              └──────┘              │
//             ▼                                    ▼
//            item        item        item        item
//          ┌──────┐    ┌──────┐    ┌──────┐    ┌──────┐
//  null ◀──┼─prev │◀───┼─prev │◀───┼─prev │◀───┼─prev │
//          │ next─┼───▶│ next─┼───▶│ next─┼───▶│ next─┼──▶ null
//          ├──────┤    ├──────┤    ├──────┤    ├──────┤
//          │ data │    │ data │    │ data │    │ data │
//          └──────┘    └──────┘    └──────┘    └──────┘
//
let $51f8b242c201426e$var$releasedCursors = null;
class $51f8b242c201426e$var$List {
    static createItem(data) {
        return {
            prev: null,
            next: null,
            data: data
        };
    }
    createItem(data) {
        return $51f8b242c201426e$var$List.createItem(data);
    }
    // cursor helpers
    allocateCursor(prev, next) {
        let cursor;
        if ($51f8b242c201426e$var$releasedCursors !== null) {
            cursor = $51f8b242c201426e$var$releasedCursors;
            $51f8b242c201426e$var$releasedCursors = $51f8b242c201426e$var$releasedCursors.cursor;
            cursor.prev = prev;
            cursor.next = next;
            cursor.cursor = this.cursor;
        } else cursor = {
            prev: prev,
            next: next,
            cursor: this.cursor
        };
        this.cursor = cursor;
        return cursor;
    }
    releaseCursor() {
        const { cursor: cursor } = this;
        this.cursor = cursor.cursor;
        cursor.prev = null;
        cursor.next = null;
        cursor.cursor = $51f8b242c201426e$var$releasedCursors;
        $51f8b242c201426e$var$releasedCursors = cursor;
    }
    updateCursors(prevOld, prevNew, nextOld, nextNew) {
        let { cursor: cursor } = this;
        while(cursor !== null){
            if (cursor.prev === prevOld) cursor.prev = prevNew;
            if (cursor.next === nextOld) cursor.next = nextNew;
            cursor = cursor.cursor;
        }
    }
    *[Symbol.iterator]() {
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)yield cursor.data;
    }
    // getters
    get size() {
        let size = 0;
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)size++;
        return size;
    }
    get isEmpty() {
        return this.head === null;
    }
    get first() {
        return this.head && this.head.data;
    }
    get last() {
        return this.tail && this.tail.data;
    }
    // convertors
    fromArray(array) {
        let cursor = null;
        this.head = null;
        for (let data of array){
            const item = $51f8b242c201426e$var$List.createItem(data);
            if (cursor !== null) cursor.next = item;
            else this.head = item;
            item.prev = cursor;
            cursor = item;
        }
        this.tail = cursor;
        return this;
    }
    toArray() {
        return [
            ...this
        ];
    }
    toJSON() {
        return [
            ...this
        ];
    }
    // array-like methods
    forEach(fn, thisArg = this) {
        // push cursor
        const cursor = this.allocateCursor(null, this.head);
        while(cursor.next !== null){
            const item = cursor.next;
            cursor.next = item.next;
            fn.call(thisArg, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
    }
    forEachRight(fn, thisArg = this) {
        // push cursor
        const cursor = this.allocateCursor(this.tail, null);
        while(cursor.prev !== null){
            const item = cursor.prev;
            cursor.prev = item.prev;
            fn.call(thisArg, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
    }
    reduce(fn, initialValue, thisArg = this) {
        // push cursor
        let cursor = this.allocateCursor(null, this.head);
        let acc = initialValue;
        let item;
        while(cursor.next !== null){
            item = cursor.next;
            cursor.next = item.next;
            acc = fn.call(thisArg, acc, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
        return acc;
    }
    reduceRight(fn, initialValue, thisArg = this) {
        // push cursor
        let cursor = this.allocateCursor(this.tail, null);
        let acc = initialValue;
        let item;
        while(cursor.prev !== null){
            item = cursor.prev;
            cursor.prev = item.prev;
            acc = fn.call(thisArg, acc, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
        return acc;
    }
    some(fn, thisArg = this) {
        for(let cursor = this.head; cursor !== null; cursor = cursor.next){
            if (fn.call(thisArg, cursor.data, cursor, this)) return true;
        }
        return false;
    }
    map(fn, thisArg = this) {
        const result = new $51f8b242c201426e$var$List();
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)result.appendData(fn.call(thisArg, cursor.data, cursor, this));
        return result;
    }
    filter(fn, thisArg = this) {
        const result = new $51f8b242c201426e$var$List();
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)if (fn.call(thisArg, cursor.data, cursor, this)) result.appendData(cursor.data);
        return result;
    }
    nextUntil(start, fn, thisArg = this) {
        if (start === null) return;
        // push cursor
        const cursor = this.allocateCursor(null, start);
        while(cursor.next !== null){
            const item = cursor.next;
            cursor.next = item.next;
            if (fn.call(thisArg, item.data, item, this)) break;
        }
        // pop cursor
        this.releaseCursor();
    }
    prevUntil(start, fn, thisArg = this) {
        if (start === null) return;
        // push cursor
        const cursor = this.allocateCursor(start, null);
        while(cursor.prev !== null){
            const item = cursor.prev;
            cursor.prev = item.prev;
            if (fn.call(thisArg, item.data, item, this)) break;
        }
        // pop cursor
        this.releaseCursor();
    }
    // mutation
    clear() {
        this.head = null;
        this.tail = null;
    }
    copy() {
        const result = new $51f8b242c201426e$var$List();
        for (let data of this)result.appendData(data);
        return result;
    }
    prepend(item) {
        //      head
        //    ^
        // item
        this.updateCursors(null, item, this.head, item);
        // insert to the beginning of the list
        if (this.head !== null) {
            // new item <- first item
            this.head.prev = item;
            // new item -> first item
            item.next = this.head;
        } else // if list has no head, then it also has no tail
        // in this case tail points to the new item
        this.tail = item;
        // head always points to new item
        this.head = item;
        return this;
    }
    prependData(data) {
        return this.prepend($51f8b242c201426e$var$List.createItem(data));
    }
    append(item) {
        return this.insert(item);
    }
    appendData(data) {
        return this.insert($51f8b242c201426e$var$List.createItem(data));
    }
    insert(item, before = null) {
        if (before !== null) {
            // prev   before
            //      ^
            //     item
            this.updateCursors(before.prev, item, before, item);
            if (before.prev === null) {
                // insert to the beginning of list
                if (this.head !== before) throw new Error('before doesn\'t belong to list');
                // since head points to before therefore list doesn't empty
                // no need to check tail
                this.head = item;
                before.prev = item;
                item.next = before;
                this.updateCursors(null, item);
            } else {
                // insert between two items
                before.prev.next = item;
                item.prev = before.prev;
                before.prev = item;
                item.next = before;
            }
        } else {
            // tail
            //      ^
            //      item
            this.updateCursors(this.tail, item, null, item);
            // insert to the ending of the list
            if (this.tail !== null) {
                // last item -> new item
                this.tail.next = item;
                // last item <- new item
                item.prev = this.tail;
            } else // if list has no tail, then it also has no head
            // in this case head points to new item
            this.head = item;
            // tail always points to new item
            this.tail = item;
        }
        return this;
    }
    insertData(data, before) {
        return this.insert($51f8b242c201426e$var$List.createItem(data), before);
    }
    remove(item) {
        //      item
        //       ^
        // prev     next
        this.updateCursors(item, item.prev, item, item.next);
        if (item.prev !== null) item.prev.next = item.next;
        else {
            if (this.head !== item) throw new Error('item doesn\'t belong to list');
            this.head = item.next;
        }
        if (item.next !== null) item.next.prev = item.prev;
        else {
            if (this.tail !== item) throw new Error('item doesn\'t belong to list');
            this.tail = item.prev;
        }
        item.prev = null;
        item.next = null;
        return item;
    }
    push(data) {
        this.insert($51f8b242c201426e$var$List.createItem(data));
    }
    pop() {
        return this.tail !== null ? this.remove(this.tail) : null;
    }
    unshift(data) {
        this.prepend($51f8b242c201426e$var$List.createItem(data));
    }
    shift() {
        return this.head !== null ? this.remove(this.head) : null;
    }
    prependList(list) {
        return this.insertList(list, this.head);
    }
    appendList(list) {
        return this.insertList(list);
    }
    insertList(list, before) {
        // ignore empty lists
        if (list.head === null) return this;
        if (before !== undefined && before !== null) {
            this.updateCursors(before.prev, list.tail, before, list.head);
            // insert in the middle of dist list
            if (before.prev !== null) {
                // before.prev <-> list.head
                before.prev.next = list.head;
                list.head.prev = before.prev;
            } else this.head = list.head;
            before.prev = list.tail;
            list.tail.next = before;
        } else {
            this.updateCursors(this.tail, list.tail, null, list.head);
            // insert to end of the list
            if (this.tail !== null) {
                // if destination list has a tail, then it also has a head,
                // but head doesn't change
                // dest tail -> source head
                this.tail.next = list.head;
                // dest tail <- source head
                list.head.prev = this.tail;
            } else // if list has no a tail, then it also has no a head
            // in this case points head to new item
            this.head = list.head;
            // tail always start point to new item
            this.tail = list.tail;
        }
        list.head = null;
        list.tail = null;
        return this;
    }
    replace(oldItem, newItemOrList) {
        if ('head' in newItemOrList) this.insertList(newItemOrList, oldItem);
        else this.insert(newItemOrList, oldItem);
        this.remove(oldItem);
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.cursor = null;
    }
}
$51f8b242c201426e$export$54c2e3dc7acea9f5 = $51f8b242c201426e$var$List;

});

parcelRegister("dyeM8", function(module, exports) {

$parcel$export(module.exports, "SyntaxError", () => $9dd9e96897579f95$export$f21cea08b0dd60e8, (v) => $9dd9e96897579f95$export$f21cea08b0dd60e8 = v);
var $9dd9e96897579f95$export$f21cea08b0dd60e8;
'use strict';

var $1YFif = parcelRequire("1YFif");
const $9dd9e96897579f95$var$MAX_LINE_LENGTH = 100;
const $9dd9e96897579f95$var$OFFSET_CORRECTION = 60;
const $9dd9e96897579f95$var$TAB_REPLACEMENT = '    ';
function $9dd9e96897579f95$var$sourceFragment({ source: source, line: line, column: column }, extraLines) {
    function processLines(start, end) {
        return lines.slice(start, end).map((line, idx)=>String(start + idx + 1).padStart(maxNumLength) + ' |' + line).join('\n');
    }
    const lines = source.split(/\r\n?|\n|\f/);
    const startLine = Math.max(1, line - extraLines) - 1;
    const endLine = Math.min(line + extraLines, lines.length + 1);
    const maxNumLength = Math.max(4, String(endLine).length) + 1;
    let cutLeft = 0;
    // column correction according to replaced tab before column
    column += ($9dd9e96897579f95$var$TAB_REPLACEMENT.length - 1) * (lines[line - 1].substr(0, column - 1).match(/\t/g) || []).length;
    if (column > $9dd9e96897579f95$var$MAX_LINE_LENGTH) {
        cutLeft = column - $9dd9e96897579f95$var$OFFSET_CORRECTION + 3;
        column = $9dd9e96897579f95$var$OFFSET_CORRECTION - 2;
    }
    for(let i = startLine; i <= endLine; i++)if (i >= 0 && i < lines.length) {
        lines[i] = lines[i].replace(/\t/g, $9dd9e96897579f95$var$TAB_REPLACEMENT);
        lines[i] = (cutLeft > 0 && lines[i].length > cutLeft ? '\u2026' : '') + lines[i].substr(cutLeft, $9dd9e96897579f95$var$MAX_LINE_LENGTH - 2) + (lines[i].length > cutLeft + $9dd9e96897579f95$var$MAX_LINE_LENGTH - 1 ? '\u2026' : '');
    }
    return [
        processLines(startLine, line),
        new Array(column + maxNumLength + 2).join('-') + '^',
        processLines(line, endLine)
    ].filter(Boolean).join('\n');
}
function $9dd9e96897579f95$var$SyntaxError(message, source, offset, line, column) {
    const error = Object.assign($1YFif.createCustomError('SyntaxError', message), {
        source: source,
        offset: offset,
        line: line,
        column: column,
        sourceFragment (extraLines) {
            return $9dd9e96897579f95$var$sourceFragment({
                source: source,
                line: line,
                column: column
            }, isNaN(extraLines) ? 0 : extraLines);
        },
        get formattedMessage () {
            return `Parse error: ${message}\n` + $9dd9e96897579f95$var$sourceFragment({
                source: source,
                line: line,
                column: column
            }, 2);
        }
    });
    return error;
}
$9dd9e96897579f95$export$f21cea08b0dd60e8 = $9dd9e96897579f95$var$SyntaxError;

});
parcelRegister("1YFif", function(module, exports) {

$parcel$export(module.exports, "createCustomError", () => $170b6d036a7b9eda$export$435492119a21bab3, (v) => $170b6d036a7b9eda$export$435492119a21bab3 = v);
var $170b6d036a7b9eda$export$435492119a21bab3;
'use strict';
function $170b6d036a7b9eda$var$createCustomError(name, message) {
    // use Object.create(), because some VMs prevent setting line/column otherwise
    // (iOS Safari 10 even throws an exception)
    const error = Object.create(SyntaxError.prototype);
    const errorStack = new Error();
    return Object.assign(error, {
        name: name,
        message: message,
        get stack () {
            return (errorStack.stack || '').replace(/^(.+\n){1,3}/, `${name}: ${message}\n`);
        }
    });
}
$170b6d036a7b9eda$export$435492119a21bab3 = $170b6d036a7b9eda$var$createCustomError;

});


parcelRegister("k6ffb", function(module, exports) {

$parcel$export(module.exports, "readSequence", () => $ea203151b91050a1$export$edc1450f8a1049b2, (v) => $ea203151b91050a1$export$edc1450f8a1049b2 = v);
var $ea203151b91050a1$export$edc1450f8a1049b2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
function $ea203151b91050a1$var$readSequence(recognizer) {
    const children = this.createList();
    let space = false;
    const context = {
        recognizer: recognizer
    };
    while(!this.eof){
        switch(this.tokenType){
            case $iYo0F.Comment:
                this.next();
                continue;
            case $iYo0F.WhiteSpace:
                space = true;
                this.next();
                continue;
        }
        let child = recognizer.getNode.call(this, context);
        if (child === undefined) break;
        if (space) {
            if (recognizer.onWhiteSpace) recognizer.onWhiteSpace.call(this, child, children, context);
            space = false;
        }
        children.push(child);
    }
    if (space && recognizer.onWhiteSpace) recognizer.onWhiteSpace.call(this, null, children, context);
    return children;
}
$ea203151b91050a1$export$edc1450f8a1049b2 = $ea203151b91050a1$var$readSequence;

});


parcelRegister("cIN7t", function(module, exports) {

$parcel$export(module.exports, "createGenerator", () => $942fb239999fa578$export$881f0ad61271ba2, (v) => $942fb239999fa578$export$881f0ad61271ba2 = v);
var $942fb239999fa578$export$881f0ad61271ba2;
'use strict';

var $2vMqe = parcelRequire("2vMqe");

var $iGigP = parcelRequire("iGigP");

var $jVffH = parcelRequire("jVffH");

var $iYo0F = parcelRequire("iYo0F");
const $942fb239999fa578$var$REVERSESOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
function $942fb239999fa578$var$processChildren(node, delimeter) {
    if (typeof delimeter === 'function') {
        let prev = null;
        node.children.forEach((node)=>{
            if (prev !== null) delimeter.call(this, prev);
            this.node(node);
            prev = node;
        });
        return;
    }
    node.children.forEach(this.node, this);
}
function $942fb239999fa578$var$processChunk(chunk) {
    $2vMqe.tokenize(chunk, (type, start, end)=>{
        this.token(type, chunk.slice(start, end));
    });
}
function $942fb239999fa578$var$createGenerator(config) {
    const types$1 = new Map();
    for(let name in config.node){
        const item = config.node[name];
        const fn = item.generate || item;
        if (typeof fn === 'function') types$1.set(name, item.generate || item);
    }
    return function(node, options) {
        let buffer = '';
        let prevCode = 0;
        let handlers = {
            node (node) {
                if (types$1.has(node.type)) types$1.get(node.type).call(publicApi, node);
                else throw new Error('Unknown node type: ' + node.type);
            },
            tokenBefore: $jVffH.safe,
            token (type, value) {
                prevCode = this.tokenBefore(prevCode, type, value);
                this.emit(value, type, false);
                if (type === $iYo0F.Delim && value.charCodeAt(0) === $942fb239999fa578$var$REVERSESOLIDUS) this.emit('\n', $iYo0F.WhiteSpace, true);
            },
            emit (value) {
                buffer += value;
            },
            result () {
                return buffer;
            }
        };
        if (options) {
            if (typeof options.decorator === 'function') handlers = options.decorator(handlers);
            if (options.sourceMap) handlers = $iGigP.generateSourceMap(handlers);
            if (options.mode in $jVffH) handlers.tokenBefore = $jVffH[options.mode];
        }
        const publicApi = {
            node: (node)=>handlers.node(node),
            children: $942fb239999fa578$var$processChildren,
            token: (type, value)=>handlers.token(type, value),
            tokenize: $942fb239999fa578$var$processChunk
        };
        handlers.node(node);
        return handlers.result();
    };
}
$942fb239999fa578$export$881f0ad61271ba2 = $942fb239999fa578$var$createGenerator;

});
parcelRegister("iGigP", function(module, exports) {

$parcel$export(module.exports, "generateSourceMap", () => $d99a526291138485$export$36066a35e0efbb1e, (v) => $d99a526291138485$export$36066a35e0efbb1e = v);
var $d99a526291138485$export$36066a35e0efbb1e;
'use strict';

var $2x0Mc = parcelRequire("2x0Mc");
const $d99a526291138485$var$trackNodes = new Set([
    'Atrule',
    'Selector',
    'Declaration'
]);
function $d99a526291138485$var$generateSourceMap(handlers) {
    const map = new $2x0Mc.SourceMapGenerator();
    const generated = {
        line: 1,
        column: 0
    };
    const original = {
        line: 0,
        column: 0
    };
    const activatedGenerated = {
        line: 1,
        column: 0
    };
    const activatedMapping = {
        generated: activatedGenerated
    };
    let line = 1;
    let column = 0;
    let sourceMappingActive = false;
    const origHandlersNode = handlers.node;
    handlers.node = function(node) {
        if (node.loc && node.loc.start && $d99a526291138485$var$trackNodes.has(node.type)) {
            const nodeLine = node.loc.start.line;
            const nodeColumn = node.loc.start.column - 1;
            if (original.line !== nodeLine || original.column !== nodeColumn) {
                original.line = nodeLine;
                original.column = nodeColumn;
                generated.line = line;
                generated.column = column;
                if (sourceMappingActive) {
                    sourceMappingActive = false;
                    if (generated.line !== activatedGenerated.line || generated.column !== activatedGenerated.column) map.addMapping(activatedMapping);
                }
                sourceMappingActive = true;
                map.addMapping({
                    source: node.loc.source,
                    original: original,
                    generated: generated
                });
            }
        }
        origHandlersNode.call(this, node);
        if (sourceMappingActive && $d99a526291138485$var$trackNodes.has(node.type)) {
            activatedGenerated.line = line;
            activatedGenerated.column = column;
        }
    };
    const origHandlersEmit = handlers.emit;
    handlers.emit = function(value, type, auto) {
        for(let i = 0; i < value.length; i++)if (value.charCodeAt(i) === 10) {
            line++;
            column = 0;
        } else column++;
        origHandlersEmit(value, type, auto);
    };
    const origHandlersResult = handlers.result;
    handlers.result = function() {
        if (sourceMappingActive) map.addMapping(activatedMapping);
        return {
            css: origHandlersResult(),
            map: map
        };
    };
    return handlers;
}
$d99a526291138485$export$36066a35e0efbb1e = $d99a526291138485$var$generateSourceMap;

});
parcelRegister("2x0Mc", function(module, exports) {

$parcel$export(module.exports, "SourceMapGenerator", () => $1d7f4403e76a8f0d$export$4d99f7c30e854ff, (v) => $1d7f4403e76a8f0d$export$4d99f7c30e854ff = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $1d7f4403e76a8f0d$export$4d99f7c30e854ff;

var $4KyUy = parcelRequire("4KyUy");

var $gFVD1 = parcelRequire("gFVD1");

var $b9hmr = parcelRequire("b9hmr");
var $1d7f4403e76a8f0d$require$ArraySet = $b9hmr.ArraySet;

var $iRQGz = parcelRequire("iRQGz");
var $1d7f4403e76a8f0d$require$MappingList = $iRQGz.MappingList;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */ function $1d7f4403e76a8f0d$var$SourceMapGenerator(aArgs) {
    if (!aArgs) aArgs = {};
    this._file = $gFVD1.getArg(aArgs, 'file', null);
    this._sourceRoot = $gFVD1.getArg(aArgs, 'sourceRoot', null);
    this._skipValidation = $gFVD1.getArg(aArgs, 'skipValidation', false);
    this._ignoreInvalidMapping = $gFVD1.getArg(aArgs, 'ignoreInvalidMapping', false);
    this._sources = new $1d7f4403e76a8f0d$require$ArraySet();
    this._names = new $1d7f4403e76a8f0d$require$ArraySet();
    this._mappings = new $1d7f4403e76a8f0d$require$MappingList();
    this._sourcesContents = null;
}
$1d7f4403e76a8f0d$var$SourceMapGenerator.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */ $1d7f4403e76a8f0d$var$SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer, generatorOps) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new $1d7f4403e76a8f0d$var$SourceMapGenerator(Object.assign(generatorOps || {}, {
        file: aSourceMapConsumer.file,
        sourceRoot: sourceRoot
    }));
    aSourceMapConsumer.eachMapping(function(mapping) {
        var newMapping = {
            generated: {
                line: mapping.generatedLine,
                column: mapping.generatedColumn
            }
        };
        if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) newMapping.source = $gFVD1.relative(sourceRoot, newMapping.source);
            newMapping.original = {
                line: mapping.originalLine,
                column: mapping.originalColumn
            };
            if (mapping.name != null) newMapping.name = mapping.name;
        }
        generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var sourceRelative = sourceFile;
        if (sourceRoot !== null) sourceRelative = $gFVD1.relative(sourceRoot, sourceFile);
        if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) generator.setSourceContent(sourceFile, content);
    });
    return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */ $1d7f4403e76a8f0d$var$SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
    var generated = $gFVD1.getArg(aArgs, 'generated');
    var original = $gFVD1.getArg(aArgs, 'original', null);
    var source = $gFVD1.getArg(aArgs, 'source', null);
    var name = $gFVD1.getArg(aArgs, 'name', null);
    if (!this._skipValidation) {
        if (this._validateMapping(generated, original, source, name) === false) return;
    }
    if (source != null) {
        source = String(source);
        if (!this._sources.has(source)) this._sources.add(source);
    }
    if (name != null) {
        name = String(name);
        if (!this._names.has(name)) this._names.add(name);
    }
    this._mappings.add({
        generatedLine: generated.line,
        generatedColumn: generated.column,
        originalLine: original != null && original.line,
        originalColumn: original != null && original.column,
        source: source,
        name: name
    });
};
/**
 * Set the source content for a source file.
 */ $1d7f4403e76a8f0d$var$SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) source = $gFVD1.relative(this._sourceRoot, source);
    if (aSourceContent != null) {
        // Add the source content to the _sourcesContents map.
        // Create a new _sourcesContents map if the property is null.
        if (!this._sourcesContents) this._sourcesContents = Object.create(null);
        this._sourcesContents[$gFVD1.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
        // Remove the source file from the _sourcesContents map.
        // If the _sourcesContents map is empty, set the property to null.
        delete this._sourcesContents[$gFVD1.toSetString(source)];
        if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
    }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */ $1d7f4403e76a8f0d$var$SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
        if (aSourceMapConsumer.file == null) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
        sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) sourceFile = $gFVD1.relative(sourceRoot, sourceFile);
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new $1d7f4403e76a8f0d$require$ArraySet();
    var newNames = new $1d7f4403e76a8f0d$require$ArraySet();
    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function(mapping) {
        if (mapping.source === sourceFile && mapping.originalLine != null) {
            // Check if it can be mapped by the source map, then update the mapping.
            var original = aSourceMapConsumer.originalPositionFor({
                line: mapping.originalLine,
                column: mapping.originalColumn
            });
            if (original.source != null) {
                // Copy mapping
                mapping.source = original.source;
                if (aSourceMapPath != null) mapping.source = $gFVD1.join(aSourceMapPath, mapping.source);
                if (sourceRoot != null) mapping.source = $gFVD1.relative(sourceRoot, mapping.source);
                mapping.originalLine = original.line;
                mapping.originalColumn = original.column;
                if (original.name != null) mapping.name = original.name;
            }
        }
        var source = mapping.source;
        if (source != null && !newSources.has(source)) newSources.add(source);
        var name = mapping.name;
        if (name != null && !newNames.has(name)) newNames.add(name);
    }, this);
    this._sources = newSources;
    this._names = newNames;
    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aSourceMapPath != null) sourceFile = $gFVD1.join(aSourceMapPath, sourceFile);
            if (sourceRoot != null) sourceFile = $gFVD1.relative(sourceRoot, sourceFile);
            this.setSourceContent(sourceFile, content);
        }
    }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */ $1d7f4403e76a8f0d$var$SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
        var message = "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.";
        if (this._ignoreInvalidMapping) {
            if (typeof console !== 'undefined' && console.warn) console.warn(message);
            return false;
        } else throw new Error(message);
    }
    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) // Case 1.
    return;
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aOriginal && 'line' in aOriginal && 'column' in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) // Cases 2 and 3.
    return;
    else {
        var message = 'Invalid mapping: ' + JSON.stringify({
            generated: aGenerated,
            source: aSource,
            original: aOriginal,
            name: aName
        });
        if (this._ignoreInvalidMapping) {
            if (typeof console !== 'undefined' && console.warn) console.warn(message);
            return false;
        } else throw new Error(message);
    }
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */ $1d7f4403e76a8f0d$var$SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;
    var mappings = this._mappings.toArray();
    for(var i = 0, len = mappings.length; i < len; i++){
        mapping = mappings[i];
        next = '';
        if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while(mapping.generatedLine !== previousGeneratedLine){
                next += ';';
                previousGeneratedLine++;
            }
        } else if (i > 0) {
            if (!$gFVD1.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) continue;
            next += ',';
        }
        next += $4KyUy.encode(mapping.generatedColumn - previousGeneratedColumn);
        previousGeneratedColumn = mapping.generatedColumn;
        if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += $4KyUy.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            // lines are stored 0-based in SourceMap spec version 3
            next += $4KyUy.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += $4KyUy.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
                nameIdx = this._names.indexOf(mapping.name);
                next += $4KyUy.encode(nameIdx - previousName);
                previousName = nameIdx;
            }
        }
        result += next;
    }
    return result;
};
$1d7f4403e76a8f0d$var$SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function(source) {
        if (!this._sourcesContents) return null;
        if (aSourceRoot != null) source = $gFVD1.relative(aSourceRoot, source);
        var key = $gFVD1.toSetString(source);
        return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
    }, this);
};
/**
 * Externalize the source map.
 */ $1d7f4403e76a8f0d$var$SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
    var map = {
        version: this._version,
        sources: this._sources.toArray(),
        names: this._names.toArray(),
        mappings: this._serializeMappings()
    };
    if (this._file != null) map.file = this._file;
    if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
    if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    return map;
};
/**
 * Render the source map being generated to a string.
 */ $1d7f4403e76a8f0d$var$SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
};
$1d7f4403e76a8f0d$export$4d99f7c30e854ff = $1d7f4403e76a8f0d$var$SourceMapGenerator;

});
parcelRegister("4KyUy", function(module, exports) {

$parcel$export(module.exports, "encode", () => $375689eb140f0849$export$c564cdbbe6da493, (v) => $375689eb140f0849$export$c564cdbbe6da493 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $375689eb140f0849$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $375689eb140f0849$export$2f872c0f2117be69;

var $gTq7g = parcelRequire("gTq7g");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $375689eb140f0849$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $375689eb140f0849$var$VLQ_BASE = 1 << $375689eb140f0849$var$VLQ_BASE_SHIFT;
// binary: 011111
var $375689eb140f0849$var$VLQ_BASE_MASK = $375689eb140f0849$var$VLQ_BASE - 1;
// binary: 100000
var $375689eb140f0849$var$VLQ_CONTINUATION_BIT = $375689eb140f0849$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $375689eb140f0849$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $375689eb140f0849$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$375689eb140f0849$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $375689eb140f0849$var$toVLQSigned(aValue);
    do {
        digit = vlq & $375689eb140f0849$var$VLQ_BASE_MASK;
        vlq >>>= $375689eb140f0849$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $375689eb140f0849$var$VLQ_CONTINUATION_BIT;
        encoded += $gTq7g.encode(digit);
    }while (vlq > 0);
    return encoded;
};
$375689eb140f0849$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $gTq7g.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $375689eb140f0849$var$VLQ_CONTINUATION_BIT);
        digit &= $375689eb140f0849$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $375689eb140f0849$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $375689eb140f0849$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

});
parcelRegister("gTq7g", function(module, exports) {

$parcel$export(module.exports, "encode", () => $c4c60a86d1850701$export$c564cdbbe6da493, (v) => $c4c60a86d1850701$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $c4c60a86d1850701$export$2f872c0f2117be69, (v) => $c4c60a86d1850701$export$2f872c0f2117be69 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $c4c60a86d1850701$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $c4c60a86d1850701$export$2f872c0f2117be69;
var $c4c60a86d1850701$var$intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
$c4c60a86d1850701$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $c4c60a86d1850701$var$intToCharMap.length) return $c4c60a86d1850701$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$c4c60a86d1850701$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

});


parcelRegister("gFVD1", function(module, exports) {

$parcel$export(module.exports, "getArg", () => $c23d2d7bc552caa1$export$6e45e70adce70bb2, (v) => $c23d2d7bc552caa1$export$6e45e70adce70bb2 = v);
$parcel$export(module.exports, "isAbsolute", () => $c23d2d7bc552caa1$export$e434c7255acda994, (v) => $c23d2d7bc552caa1$export$e434c7255acda994 = v);
$parcel$export(module.exports, "join", () => $c23d2d7bc552caa1$export$f7e2c8231c57a8bd, (v) => $c23d2d7bc552caa1$export$f7e2c8231c57a8bd = v);
$parcel$export(module.exports, "relative", () => $c23d2d7bc552caa1$export$f0e7d1106eeabbe6, (v) => $c23d2d7bc552caa1$export$f0e7d1106eeabbe6 = v);
$parcel$export(module.exports, "toSetString", () => $c23d2d7bc552caa1$export$be0fa1163fa7a4c, (v) => $c23d2d7bc552caa1$export$be0fa1163fa7a4c = v);
$parcel$export(module.exports, "compareByGeneratedPositionsInflated", () => $c23d2d7bc552caa1$export$f9c43907549d61f1, (v) => $c23d2d7bc552caa1$export$f9c43907549d61f1 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $c23d2d7bc552caa1$export$6e45e70adce70bb2;
var $c23d2d7bc552caa1$export$d6e833647f7f5f17;
var $c23d2d7bc552caa1$export$2ec9abc2d2cac192;
var $c23d2d7bc552caa1$export$a3295358bff77e;
var $c23d2d7bc552caa1$export$f7e2c8231c57a8bd;
var $c23d2d7bc552caa1$export$e434c7255acda994;
var $c23d2d7bc552caa1$export$f0e7d1106eeabbe6;
var $c23d2d7bc552caa1$export$be0fa1163fa7a4c;
var $c23d2d7bc552caa1$export$1fc47c3d4c3302a1;
var $c23d2d7bc552caa1$export$273077902de92ff2;
var $c23d2d7bc552caa1$export$6af840b44a9241f3;
var $c23d2d7bc552caa1$export$b7acf533941302f6;
var $c23d2d7bc552caa1$export$4d81ca1117b6e802;
var $c23d2d7bc552caa1$export$f9c43907549d61f1;
var $c23d2d7bc552caa1$export$b49e2de2ad542732;
var $c23d2d7bc552caa1$export$659a1aa8f1cdc036;
function $c23d2d7bc552caa1$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$c23d2d7bc552caa1$export$6e45e70adce70bb2 = $c23d2d7bc552caa1$var$getArg;
var $c23d2d7bc552caa1$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var $c23d2d7bc552caa1$var$dataUrlRegexp = /^data:.+\,.+$/;
function $c23d2d7bc552caa1$var$urlParse(aUrl) {
    var match = aUrl.match($c23d2d7bc552caa1$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$c23d2d7bc552caa1$export$d6e833647f7f5f17 = $c23d2d7bc552caa1$var$urlParse;
function $c23d2d7bc552caa1$var$urlGenerate(aParsedUrl) {
    var url = '';
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ':';
    url += '//';
    if (aParsedUrl.auth) url += aParsedUrl.auth + '@';
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$c23d2d7bc552caa1$export$2ec9abc2d2cac192 = $c23d2d7bc552caa1$var$urlGenerate;
var $c23d2d7bc552caa1$var$MAX_CACHED_INPUTS = 32;
/**
 * Takes some function `f(input) -> result` and returns a memoized version of
 * `f`.
 *
 * We keep at most `MAX_CACHED_INPUTS` memoized results of `f` alive. The
 * memoization is a dumb-simple, linear least-recently-used cache.
 */ function $c23d2d7bc552caa1$var$lruMemoize(f) {
    var cache = [];
    return function(input) {
        for(var i = 0; i < cache.length; i++)if (cache[i].input === input) {
            var temp = cache[0];
            cache[0] = cache[i];
            cache[i] = temp;
            return cache[0].result;
        }
        var result = f(input);
        cache.unshift({
            input: input,
            result: result
        });
        if (cache.length > $c23d2d7bc552caa1$var$MAX_CACHED_INPUTS) cache.pop();
        return result;
    };
}
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ var $c23d2d7bc552caa1$var$normalize = $c23d2d7bc552caa1$var$lruMemoize(function normalize(aPath) {
    var path = aPath;
    var url = $c23d2d7bc552caa1$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $c23d2d7bc552caa1$export$e434c7255acda994(path);
    // Split the path into parts between `/` characters. This is much faster than
    // using `.split(/\/+/g)`.
    var parts = [];
    var start = 0;
    var i = 0;
    while(true){
        start = i;
        i = path.indexOf("/", start);
        if (i === -1) {
            parts.push(path.slice(start));
            break;
        } else {
            parts.push(path.slice(start, i));
            while(i < path.length && path[i] === "/")i++;
        }
    }
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === '.') parts.splice(i, 1);
        else if (part === '..') up++;
        else if (up > 0) {
            if (part === '') {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join('/');
    if (path === '') path = isAbsolute ? '/' : '.';
    if (url) {
        url.path = path;
        return $c23d2d7bc552caa1$var$urlGenerate(url);
    }
    return path;
});
$c23d2d7bc552caa1$export$a3295358bff77e = $c23d2d7bc552caa1$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $c23d2d7bc552caa1$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $c23d2d7bc552caa1$var$urlParse(aPath);
    var aRootUrl = $c23d2d7bc552caa1$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || '/';
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $c23d2d7bc552caa1$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($c23d2d7bc552caa1$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $c23d2d7bc552caa1$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === '/' ? aPath : $c23d2d7bc552caa1$var$normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $c23d2d7bc552caa1$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$c23d2d7bc552caa1$export$f7e2c8231c57a8bd = $c23d2d7bc552caa1$var$join;
$c23d2d7bc552caa1$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === '/' || $c23d2d7bc552caa1$var$urlRegexp.test(aPath);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $c23d2d7bc552caa1$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, '');
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + '/') !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$c23d2d7bc552caa1$export$f0e7d1106eeabbe6 = $c23d2d7bc552caa1$var$relative;
var $c23d2d7bc552caa1$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !('__proto__' in obj);
}();
function $c23d2d7bc552caa1$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $c23d2d7bc552caa1$var$toSetString(aStr) {
    if ($c23d2d7bc552caa1$var$isProtoString(aStr)) return '$' + aStr;
    return aStr;
}
$c23d2d7bc552caa1$export$be0fa1163fa7a4c = $c23d2d7bc552caa1$var$supportsNullProto ? $c23d2d7bc552caa1$var$identity : $c23d2d7bc552caa1$var$toSetString;
function $c23d2d7bc552caa1$var$fromSetString(aStr) {
    if ($c23d2d7bc552caa1$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$c23d2d7bc552caa1$export$1fc47c3d4c3302a1 = $c23d2d7bc552caa1$var$supportsNullProto ? $c23d2d7bc552caa1$var$identity : $c23d2d7bc552caa1$var$fromSetString;
function $c23d2d7bc552caa1$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $c23d2d7bc552caa1$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = $c23d2d7bc552caa1$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $c23d2d7bc552caa1$var$strcmp(mappingA.name, mappingB.name);
}
$c23d2d7bc552caa1$export$273077902de92ff2 = $c23d2d7bc552caa1$var$compareByOriginalPositions;
function $c23d2d7bc552caa1$var$compareByOriginalPositionsNoSource(mappingA, mappingB, onlyCompareOriginal) {
    var cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $c23d2d7bc552caa1$var$strcmp(mappingA.name, mappingB.name);
}
$c23d2d7bc552caa1$export$6af840b44a9241f3 = $c23d2d7bc552caa1$var$compareByOriginalPositionsNoSource;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $c23d2d7bc552caa1$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $c23d2d7bc552caa1$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $c23d2d7bc552caa1$var$strcmp(mappingA.name, mappingB.name);
}
$c23d2d7bc552caa1$export$b7acf533941302f6 = $c23d2d7bc552caa1$var$compareByGeneratedPositionsDeflated;
function $c23d2d7bc552caa1$var$compareByGeneratedPositionsDeflatedNoLine(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $c23d2d7bc552caa1$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $c23d2d7bc552caa1$var$strcmp(mappingA.name, mappingB.name);
}
$c23d2d7bc552caa1$export$4d81ca1117b6e802 = $c23d2d7bc552caa1$var$compareByGeneratedPositionsDeflatedNoLine;
function $c23d2d7bc552caa1$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 === null) return 1; // aStr2 !== null
    if (aStr2 === null) return -1; // aStr1 !== null
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $c23d2d7bc552caa1$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $c23d2d7bc552caa1$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $c23d2d7bc552caa1$var$strcmp(mappingA.name, mappingB.name);
}
$c23d2d7bc552caa1$export$f9c43907549d61f1 = $c23d2d7bc552caa1$var$compareByGeneratedPositionsInflated;
/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */ function $c23d2d7bc552caa1$var$parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
}
$c23d2d7bc552caa1$export$b49e2de2ad542732 = $c23d2d7bc552caa1$var$parseSourceMapInput;
/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */ function $c23d2d7bc552caa1$var$computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || '';
    if (sourceRoot) {
        // This follows what Chrome does.
        if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') sourceRoot += '/';
        // The spec says:
        //   Line 4: An optional source root, useful for relocating source
        //   files on a server or removing repeated values in the
        //   “sources” entry.  This value is prepended to the individual
        //   entries in the “source” field.
        sourceURL = sourceRoot + sourceURL;
    }
    // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).
    if (sourceMapURL) {
        var parsed = $c23d2d7bc552caa1$var$urlParse(sourceMapURL);
        if (!parsed) throw new Error("sourceMapURL could not be parsed");
        if (parsed.path) {
            // Strip the last path component, but keep the "/".
            var index = parsed.path.lastIndexOf('/');
            if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
        }
        sourceURL = $c23d2d7bc552caa1$var$join($c23d2d7bc552caa1$var$urlGenerate(parsed), sourceURL);
    }
    return $c23d2d7bc552caa1$var$normalize(sourceURL);
}
$c23d2d7bc552caa1$export$659a1aa8f1cdc036 = $c23d2d7bc552caa1$var$computeSourceURL;

});

parcelRegister("b9hmr", function(module, exports) {

$parcel$export(module.exports, "ArraySet", () => $81de0084fa4891f1$export$605bbf5ea7b60ba3, (v) => $81de0084fa4891f1$export$605bbf5ea7b60ba3 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $81de0084fa4891f1$export$605bbf5ea7b60ba3;

var $gFVD1 = parcelRequire("gFVD1");
var $81de0084fa4891f1$var$has = Object.prototype.hasOwnProperty;
var $81de0084fa4891f1$var$hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $81de0084fa4891f1$var$ArraySet() {
    this._array = [];
    this._set = $81de0084fa4891f1$var$hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $81de0084fa4891f1$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $81de0084fa4891f1$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $81de0084fa4891f1$var$ArraySet.prototype.size = function ArraySet_size() {
    return $81de0084fa4891f1$var$hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $81de0084fa4891f1$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $81de0084fa4891f1$var$hasNativeMap ? aStr : $gFVD1.toSetString(aStr);
    var isDuplicate = $81de0084fa4891f1$var$hasNativeMap ? this.has(aStr) : $81de0084fa4891f1$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) {
        if ($81de0084fa4891f1$var$hasNativeMap) this._set.set(aStr, idx);
        else this._set[sStr] = idx;
    }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $81de0084fa4891f1$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    if ($81de0084fa4891f1$var$hasNativeMap) return this._set.has(aStr);
    else {
        var sStr = $gFVD1.toSetString(aStr);
        return $81de0084fa4891f1$var$has.call(this._set, sStr);
    }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $81de0084fa4891f1$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    if ($81de0084fa4891f1$var$hasNativeMap) {
        var idx = this._set.get(aStr);
        if (idx >= 0) return idx;
    } else {
        var sStr = $gFVD1.toSetString(aStr);
        if ($81de0084fa4891f1$var$has.call(this._set, sStr)) return this._set[sStr];
    }
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $81de0084fa4891f1$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error('No element indexed by ' + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $81de0084fa4891f1$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$81de0084fa4891f1$export$605bbf5ea7b60ba3 = $81de0084fa4891f1$var$ArraySet;

});

parcelRegister("iRQGz", function(module, exports) {

$parcel$export(module.exports, "MappingList", () => $dbc60b7a23c0ad03$export$e82e0908843dd951, (v) => $dbc60b7a23c0ad03$export$e82e0908843dd951 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $dbc60b7a23c0ad03$export$e82e0908843dd951;

var $gFVD1 = parcelRequire("gFVD1");
/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */ function $dbc60b7a23c0ad03$var$generatedPositionAfter(mappingA, mappingB) {
    // Optimized for most common case
    var lineA = mappingA.generatedLine;
    var lineB = mappingB.generatedLine;
    var columnA = mappingA.generatedColumn;
    var columnB = mappingB.generatedColumn;
    return lineB > lineA || lineB == lineA && columnB >= columnA || $gFVD1.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */ function $dbc60b7a23c0ad03$var$MappingList() {
    this._array = [];
    this._sorted = true;
    // Serves as infimum
    this._last = {
        generatedLine: -1,
        generatedColumn: 0
    };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */ $dbc60b7a23c0ad03$var$MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */ $dbc60b7a23c0ad03$var$MappingList.prototype.add = function MappingList_add(aMapping) {
    if ($dbc60b7a23c0ad03$var$generatedPositionAfter(this._last, aMapping)) {
        this._last = aMapping;
        this._array.push(aMapping);
    } else {
        this._sorted = false;
        this._array.push(aMapping);
    }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */ $dbc60b7a23c0ad03$var$MappingList.prototype.toArray = function MappingList_toArray() {
    if (!this._sorted) {
        this._array.sort($gFVD1.compareByGeneratedPositionsInflated);
        this._sorted = true;
    }
    return this._array;
};
$dbc60b7a23c0ad03$export$e82e0908843dd951 = $dbc60b7a23c0ad03$var$MappingList;

});



parcelRegister("jVffH", function(module, exports) {

$parcel$export(module.exports, "safe", () => $e80f2bfc28eb90d8$export$170b8c323eee7bec, (v) => $e80f2bfc28eb90d8$export$170b8c323eee7bec = v);
$parcel$export(module.exports, "spec", () => $e80f2bfc28eb90d8$export$a40e83dd9f9a97c8, (v) => $e80f2bfc28eb90d8$export$a40e83dd9f9a97c8 = v);
var $e80f2bfc28eb90d8$export$170b8c323eee7bec;
var $e80f2bfc28eb90d8$export$a40e83dd9f9a97c8;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $e80f2bfc28eb90d8$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $e80f2bfc28eb90d8$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $e80f2bfc28eb90d8$var$code = (type, value)=>{
    if (type === $iYo0F.Delim) type = value;
    if (typeof type === 'string') {
        const charCode = type.charCodeAt(0);
        return charCode > 0x7F ? 0x8000 : charCode << 8;
    }
    return type;
};
// https://www.w3.org/TR/css-syntax-3/#serialization
// The only requirement for serialization is that it must "round-trip" with parsing,
// that is, parsing the stylesheet must produce the same data structures as parsing,
// serializing, and parsing again, except for consecutive <whitespace-token>s,
// which may be collapsed into a single token.
const $e80f2bfc28eb90d8$var$specPairs = [
    [
        $iYo0F.Ident,
        $iYo0F.Ident
    ],
    [
        $iYo0F.Ident,
        $iYo0F.Function
    ],
    [
        $iYo0F.Ident,
        $iYo0F.Url
    ],
    [
        $iYo0F.Ident,
        $iYo0F.BadUrl
    ],
    [
        $iYo0F.Ident,
        '-'
    ],
    [
        $iYo0F.Ident,
        $iYo0F.Number
    ],
    [
        $iYo0F.Ident,
        $iYo0F.Percentage
    ],
    [
        $iYo0F.Ident,
        $iYo0F.Dimension
    ],
    [
        $iYo0F.Ident,
        $iYo0F.CDC
    ],
    [
        $iYo0F.Ident,
        $iYo0F.LeftParenthesis
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.Ident
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.Function
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.Url
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.BadUrl
    ],
    [
        $iYo0F.AtKeyword,
        '-'
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.Number
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.Percentage
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.Dimension
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.CDC
    ],
    [
        $iYo0F.Hash,
        $iYo0F.Ident
    ],
    [
        $iYo0F.Hash,
        $iYo0F.Function
    ],
    [
        $iYo0F.Hash,
        $iYo0F.Url
    ],
    [
        $iYo0F.Hash,
        $iYo0F.BadUrl
    ],
    [
        $iYo0F.Hash,
        '-'
    ],
    [
        $iYo0F.Hash,
        $iYo0F.Number
    ],
    [
        $iYo0F.Hash,
        $iYo0F.Percentage
    ],
    [
        $iYo0F.Hash,
        $iYo0F.Dimension
    ],
    [
        $iYo0F.Hash,
        $iYo0F.CDC
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.Ident
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.Function
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.Url
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.BadUrl
    ],
    [
        $iYo0F.Dimension,
        '-'
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.Number
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.Percentage
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.Dimension
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.CDC
    ],
    [
        '#',
        $iYo0F.Ident
    ],
    [
        '#',
        $iYo0F.Function
    ],
    [
        '#',
        $iYo0F.Url
    ],
    [
        '#',
        $iYo0F.BadUrl
    ],
    [
        '#',
        '-'
    ],
    [
        '#',
        $iYo0F.Number
    ],
    [
        '#',
        $iYo0F.Percentage
    ],
    [
        '#',
        $iYo0F.Dimension
    ],
    [
        '#',
        $iYo0F.CDC
    ],
    [
        '-',
        $iYo0F.Ident
    ],
    [
        '-',
        $iYo0F.Function
    ],
    [
        '-',
        $iYo0F.Url
    ],
    [
        '-',
        $iYo0F.BadUrl
    ],
    [
        '-',
        '-'
    ],
    [
        '-',
        $iYo0F.Number
    ],
    [
        '-',
        $iYo0F.Percentage
    ],
    [
        '-',
        $iYo0F.Dimension
    ],
    [
        '-',
        $iYo0F.CDC
    ],
    [
        $iYo0F.Number,
        $iYo0F.Ident
    ],
    [
        $iYo0F.Number,
        $iYo0F.Function
    ],
    [
        $iYo0F.Number,
        $iYo0F.Url
    ],
    [
        $iYo0F.Number,
        $iYo0F.BadUrl
    ],
    [
        $iYo0F.Number,
        $iYo0F.Number
    ],
    [
        $iYo0F.Number,
        $iYo0F.Percentage
    ],
    [
        $iYo0F.Number,
        $iYo0F.Dimension
    ],
    [
        $iYo0F.Number,
        '%'
    ],
    [
        $iYo0F.Number,
        $iYo0F.CDC
    ],
    [
        '@',
        $iYo0F.Ident
    ],
    [
        '@',
        $iYo0F.Function
    ],
    [
        '@',
        $iYo0F.Url
    ],
    [
        '@',
        $iYo0F.BadUrl
    ],
    [
        '@',
        '-'
    ],
    [
        '@',
        $iYo0F.CDC
    ],
    [
        '.',
        $iYo0F.Number
    ],
    [
        '.',
        $iYo0F.Percentage
    ],
    [
        '.',
        $iYo0F.Dimension
    ],
    [
        '+',
        $iYo0F.Number
    ],
    [
        '+',
        $iYo0F.Percentage
    ],
    [
        '+',
        $iYo0F.Dimension
    ],
    [
        '/',
        '*'
    ]
];
// validate with scripts/generate-safe
const $e80f2bfc28eb90d8$var$safePairs = $e80f2bfc28eb90d8$var$specPairs.concat([
    [
        $iYo0F.Ident,
        $iYo0F.Hash
    ],
    [
        $iYo0F.Dimension,
        $iYo0F.Hash
    ],
    [
        $iYo0F.Hash,
        $iYo0F.Hash
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.LeftParenthesis
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.String
    ],
    [
        $iYo0F.AtKeyword,
        $iYo0F.Colon
    ],
    [
        $iYo0F.Percentage,
        $iYo0F.Percentage
    ],
    [
        $iYo0F.Percentage,
        $iYo0F.Dimension
    ],
    [
        $iYo0F.Percentage,
        $iYo0F.Function
    ],
    [
        $iYo0F.Percentage,
        '-'
    ],
    [
        $iYo0F.RightParenthesis,
        $iYo0F.Ident
    ],
    [
        $iYo0F.RightParenthesis,
        $iYo0F.Function
    ],
    [
        $iYo0F.RightParenthesis,
        $iYo0F.Percentage
    ],
    [
        $iYo0F.RightParenthesis,
        $iYo0F.Dimension
    ],
    [
        $iYo0F.RightParenthesis,
        $iYo0F.Hash
    ],
    [
        $iYo0F.RightParenthesis,
        '-'
    ]
]);
function $e80f2bfc28eb90d8$var$createMap(pairs) {
    const isWhiteSpaceRequired = new Set(pairs.map(([prev, next])=>$e80f2bfc28eb90d8$var$code(prev) << 16 | $e80f2bfc28eb90d8$var$code(next)));
    return function(prevCode, type, value) {
        const nextCode = $e80f2bfc28eb90d8$var$code(type, value);
        const nextCharCode = value.charCodeAt(0);
        const emitWs = nextCharCode === $e80f2bfc28eb90d8$var$HYPHENMINUS && type !== $iYo0F.Ident && type !== $iYo0F.Function && type !== $iYo0F.CDC || nextCharCode === $e80f2bfc28eb90d8$var$PLUSSIGN ? isWhiteSpaceRequired.has(prevCode << 16 | nextCharCode << 8) : isWhiteSpaceRequired.has(prevCode << 16 | nextCode);
        if (emitWs) this.emit(' ', $iYo0F.WhiteSpace, true);
        return nextCode;
    };
}
const $e80f2bfc28eb90d8$var$spec = $e80f2bfc28eb90d8$var$createMap($e80f2bfc28eb90d8$var$specPairs);
const $e80f2bfc28eb90d8$var$safe = $e80f2bfc28eb90d8$var$createMap($e80f2bfc28eb90d8$var$safePairs);
$e80f2bfc28eb90d8$export$170b8c323eee7bec = $e80f2bfc28eb90d8$var$safe;
$e80f2bfc28eb90d8$export$a40e83dd9f9a97c8 = $e80f2bfc28eb90d8$var$spec;

});


parcelRegister("eRSNQ", function(module, exports) {

$parcel$export(module.exports, "createConvertor", () => $ad3086aaeae38f4a$export$270c35c9c0b7b1f9, (v) => $ad3086aaeae38f4a$export$270c35c9c0b7b1f9 = v);
var $ad3086aaeae38f4a$export$270c35c9c0b7b1f9;
'use strict';

var $72kB1 = parcelRequire("72kB1");
function $ad3086aaeae38f4a$var$createConvertor(walk) {
    return {
        fromPlainObject (ast) {
            walk(ast, {
                enter (node) {
                    if (node.children && node.children instanceof $72kB1.List === false) node.children = new $72kB1.List().fromArray(node.children);
                }
            });
            return ast;
        },
        toPlainObject (ast) {
            walk(ast, {
                leave (node) {
                    if (node.children && node.children instanceof $72kB1.List) node.children = node.children.toArray();
                }
            });
            return ast;
        }
    };
}
$ad3086aaeae38f4a$export$270c35c9c0b7b1f9 = $ad3086aaeae38f4a$var$createConvertor;

});

parcelRegister("d6Nz5", function(module, exports) {

$parcel$export(module.exports, "createWalker", () => $98b24879a15a6ec8$export$774c92c6aec941e8, (v) => $98b24879a15a6ec8$export$774c92c6aec941e8 = v);
var $98b24879a15a6ec8$export$774c92c6aec941e8;
'use strict';
const { hasOwnProperty: $98b24879a15a6ec8$var$hasOwnProperty } = Object.prototype;
const $98b24879a15a6ec8$var$noop = function() {};
function $98b24879a15a6ec8$var$ensureFunction(value) {
    return typeof value === 'function' ? value : $98b24879a15a6ec8$var$noop;
}
function $98b24879a15a6ec8$var$invokeForType(fn, type) {
    return function(node, item, list) {
        if (node.type === type) fn.call(this, node, item, list);
    };
}
function $98b24879a15a6ec8$var$getWalkersFromStructure(name, nodeType) {
    const structure = nodeType.structure;
    const walkers = [];
    for(const key in structure){
        if ($98b24879a15a6ec8$var$hasOwnProperty.call(structure, key) === false) continue;
        let fieldTypes = structure[key];
        const walker = {
            name: key,
            type: false,
            nullable: false
        };
        if (!Array.isArray(fieldTypes)) fieldTypes = [
            fieldTypes
        ];
        for (const fieldType of fieldTypes){
            if (fieldType === null) walker.nullable = true;
            else if (typeof fieldType === 'string') walker.type = 'node';
            else if (Array.isArray(fieldType)) walker.type = 'list';
        }
        if (walker.type) walkers.push(walker);
    }
    if (walkers.length) return {
        context: nodeType.walkContext,
        fields: walkers
    };
    return null;
}
function $98b24879a15a6ec8$var$getTypesFromConfig(config) {
    const types = {};
    for(const name in config.node)if ($98b24879a15a6ec8$var$hasOwnProperty.call(config.node, name)) {
        const nodeType = config.node[name];
        if (!nodeType.structure) throw new Error('Missed `structure` field in `' + name + '` node type definition');
        types[name] = $98b24879a15a6ec8$var$getWalkersFromStructure(name, nodeType);
    }
    return types;
}
function $98b24879a15a6ec8$var$createTypeIterator(config, reverse) {
    const fields = config.fields.slice();
    const contextName = config.context;
    const useContext = typeof contextName === 'string';
    if (reverse) fields.reverse();
    return function(node, context, walk, walkReducer) {
        let prevContextValue;
        if (useContext) {
            prevContextValue = context[contextName];
            context[contextName] = node;
        }
        for (const field of fields){
            const ref = node[field.name];
            if (!field.nullable || ref) {
                if (field.type === 'list') {
                    const breakWalk = reverse ? ref.reduceRight(walkReducer, false) : ref.reduce(walkReducer, false);
                    if (breakWalk) return true;
                } else if (walk(ref)) return true;
            }
        }
        if (useContext) context[contextName] = prevContextValue;
    };
}
function $98b24879a15a6ec8$var$createFastTraveralMap({ StyleSheet: StyleSheet, Atrule: Atrule, Rule: Rule, Block: Block, DeclarationList: DeclarationList }) {
    return {
        Atrule: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block
        },
        Rule: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block
        },
        Declaration: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block,
            DeclarationList: DeclarationList
        }
    };
}
function $98b24879a15a6ec8$var$createWalker(config) {
    const types = $98b24879a15a6ec8$var$getTypesFromConfig(config);
    const iteratorsNatural = {};
    const iteratorsReverse = {};
    const breakWalk = Symbol('break-walk');
    const skipNode = Symbol('skip-node');
    for(const name in types)if ($98b24879a15a6ec8$var$hasOwnProperty.call(types, name) && types[name] !== null) {
        iteratorsNatural[name] = $98b24879a15a6ec8$var$createTypeIterator(types[name], false);
        iteratorsReverse[name] = $98b24879a15a6ec8$var$createTypeIterator(types[name], true);
    }
    const fastTraversalIteratorsNatural = $98b24879a15a6ec8$var$createFastTraveralMap(iteratorsNatural);
    const fastTraversalIteratorsReverse = $98b24879a15a6ec8$var$createFastTraveralMap(iteratorsReverse);
    const walk = function(root, options) {
        function walkNode(node, item, list) {
            const enterRet = enter.call(context, node, item, list);
            if (enterRet === breakWalk) return true;
            if (enterRet === skipNode) return false;
            if (iterators.hasOwnProperty(node.type)) {
                if (iterators[node.type](node, context, walkNode, walkReducer)) return true;
            }
            if (leave.call(context, node, item, list) === breakWalk) return true;
            return false;
        }
        let enter = $98b24879a15a6ec8$var$noop;
        let leave = $98b24879a15a6ec8$var$noop;
        let iterators = iteratorsNatural;
        let walkReducer = (ret, data, item, list)=>ret || walkNode(data, item, list);
        const context = {
            break: breakWalk,
            skip: skipNode,
            root: root,
            stylesheet: null,
            atrule: null,
            atrulePrelude: null,
            rule: null,
            selector: null,
            block: null,
            declaration: null,
            function: null
        };
        if (typeof options === 'function') enter = options;
        else if (options) {
            enter = $98b24879a15a6ec8$var$ensureFunction(options.enter);
            leave = $98b24879a15a6ec8$var$ensureFunction(options.leave);
            if (options.reverse) iterators = iteratorsReverse;
            if (options.visit) {
                if (fastTraversalIteratorsNatural.hasOwnProperty(options.visit)) iterators = options.reverse ? fastTraversalIteratorsReverse[options.visit] : fastTraversalIteratorsNatural[options.visit];
                else if (!types.hasOwnProperty(options.visit)) throw new Error('Bad value `' + options.visit + '` for `visit` option (should be: ' + Object.keys(types).sort().join(', ') + ')');
                enter = $98b24879a15a6ec8$var$invokeForType(enter, options.visit);
                leave = $98b24879a15a6ec8$var$invokeForType(leave, options.visit);
            }
        }
        if (enter === $98b24879a15a6ec8$var$noop && leave === $98b24879a15a6ec8$var$noop) throw new Error('Neither `enter` nor `leave` walker handler is set or both aren\'t a function');
        walkNode(root);
    };
    walk.break = breakWalk;
    walk.skip = skipNode;
    walk.find = function(ast, fn) {
        let found = null;
        walk(ast, function(node, item, list) {
            if (fn.call(this, node, item, list)) {
                found = node;
                return breakWalk;
            }
        });
        return found;
    };
    walk.findLast = function(ast, fn) {
        let found = null;
        walk(ast, {
            reverse: true,
            enter (node, item, list) {
                if (fn.call(this, node, item, list)) {
                    found = node;
                    return breakWalk;
                }
            }
        });
        return found;
    };
    walk.findAll = function(ast, fn) {
        const found = [];
        walk(ast, function(node, item, list) {
            if (fn.call(this, node, item, list)) found.push(node);
        });
        return found;
    };
    return walk;
}
$98b24879a15a6ec8$export$774c92c6aec941e8 = $98b24879a15a6ec8$var$createWalker;

});

parcelRegister("ae5TN", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $771fc9957da5893f$export$6168dc8908a6c652, (v) => $771fc9957da5893f$export$6168dc8908a6c652 = v);
var $771fc9957da5893f$export$6168dc8908a6c652;
'use strict';

var $evUTe = parcelRequire("evUTe");

var $jJe0G = parcelRequire("jJe0G");

var $71Tj9 = parcelRequire("71Tj9");

var $6FUvZ = parcelRequire("6FUvZ");

var $75eBD = parcelRequire("75eBD");

var $ejayB = parcelRequire("ejayB");

var $1PrC8 = parcelRequire("1PrC8");

var $7ttZl = parcelRequire("7ttZl");

var $ka2do = parcelRequire("ka2do");

var $7mF6V = parcelRequire("7mF6V");

var $8tOv6 = parcelRequire("8tOv6");

var $fiYed = parcelRequire("fiYed");

var $cSjEF = parcelRequire("cSjEF");
const $771fc9957da5893f$var$cssWideKeywordsSyntax = $ejayB.buildMatchGraph($71Tj9.cssWideKeywords.join(' | '));
function $771fc9957da5893f$var$dumpMapSyntax(map, compact, syntaxAsAst) {
    const result = {};
    for(const name in map)if (map[name].syntax) result[name] = syntaxAsAst ? map[name].syntax : $fiYed.generate(map[name].syntax, {
        compact: compact
    });
    return result;
}
function $771fc9957da5893f$var$dumpAtruleMapSyntax(map, compact, syntaxAsAst) {
    const result = {};
    for (const [name, atrule] of Object.entries(map))result[name] = {
        prelude: atrule.prelude && (syntaxAsAst ? atrule.prelude.syntax : $fiYed.generate(atrule.prelude.syntax, {
            compact: compact
        })),
        descriptors: atrule.descriptors && $771fc9957da5893f$var$dumpMapSyntax(atrule.descriptors, compact, syntaxAsAst)
    };
    return result;
}
function $771fc9957da5893f$var$valueHasVar(tokens) {
    for(let i = 0; i < tokens.length; i++){
        if (tokens[i].value.toLowerCase() === 'var(') return true;
    }
    return false;
}
function $771fc9957da5893f$var$buildMatchResult(matched, error, iterations) {
    return {
        matched: matched,
        iterations: iterations,
        error: error,
        ...$7ttZl
    };
}
function $771fc9957da5893f$var$matchSyntax(lexer, syntax, value, useCssWideKeywords) {
    const tokens = $75eBD(value, lexer.syntax);
    let result;
    if ($771fc9957da5893f$var$valueHasVar(tokens)) return $771fc9957da5893f$var$buildMatchResult(null, new Error('Matching for a tree with var() is not supported'));
    if (useCssWideKeywords) result = $1PrC8.matchAsTree(tokens, lexer.cssWideKeywordsSyntax, lexer);
    if (!useCssWideKeywords || !result.match) {
        result = $1PrC8.matchAsTree(tokens, syntax.match, lexer);
        if (!result.match) return $771fc9957da5893f$var$buildMatchResult(null, new $evUTe.SyntaxMatchError(result.reason, syntax.syntax, value, result), result.iterations);
    }
    return $771fc9957da5893f$var$buildMatchResult(result.match, null, result.iterations);
}
class $771fc9957da5893f$var$Lexer {
    checkStructure(ast) {
        function collectWarning(node, message) {
            warns.push({
                node: node,
                message: message
            });
        }
        const structure = this.structure;
        const warns = [];
        this.syntax.walk(ast, function(node) {
            if (structure.hasOwnProperty(node.type)) structure[node.type].check(node, collectWarning);
            else collectWarning(node, 'Unknown node type `' + node.type + '`');
        });
        return warns.length ? warns : false;
    }
    createDescriptor(syntax, type, name, parent = null) {
        const ref = {
            type: type,
            name: name
        };
        const descriptor = {
            type: type,
            name: name,
            parent: parent,
            serializable: typeof syntax === 'string' || syntax && typeof syntax.type === 'string',
            syntax: null,
            match: null
        };
        if (typeof syntax === 'function') descriptor.match = $ejayB.buildMatchGraph(syntax, ref);
        else {
            if (typeof syntax === 'string') // lazy parsing on first access
            Object.defineProperty(descriptor, 'syntax', {
                get () {
                    Object.defineProperty(descriptor, 'syntax', {
                        value: $8tOv6.parse(syntax)
                    });
                    return descriptor.syntax;
                }
            });
            else descriptor.syntax = syntax;
            // lazy graph build on first access
            Object.defineProperty(descriptor, 'match', {
                get () {
                    Object.defineProperty(descriptor, 'match', {
                        value: $ejayB.buildMatchGraph(descriptor.syntax, ref)
                    });
                    return descriptor.match;
                }
            });
        }
        return descriptor;
    }
    addAtrule_(name, syntax) {
        if (!syntax) return;
        this.atrules[name] = {
            type: 'Atrule',
            name: name,
            prelude: syntax.prelude ? this.createDescriptor(syntax.prelude, 'AtrulePrelude', name) : null,
            descriptors: syntax.descriptors ? Object.keys(syntax.descriptors).reduce((map, descName)=>{
                map[descName] = this.createDescriptor(syntax.descriptors[descName], 'AtruleDescriptor', descName, name);
                return map;
            }, Object.create(null)) : null
        };
    }
    addProperty_(name, syntax) {
        if (!syntax) return;
        this.properties[name] = this.createDescriptor(syntax, 'Property', name);
    }
    addType_(name, syntax) {
        if (!syntax) return;
        this.types[name] = this.createDescriptor(syntax, 'Type', name);
    }
    checkAtruleName(atruleName) {
        if (!this.getAtrule(atruleName)) return new $evUTe.SyntaxReferenceError('Unknown at-rule', '@' + atruleName);
    }
    checkAtrulePrelude(atruleName, prelude) {
        const error = this.checkAtruleName(atruleName);
        if (error) return error;
        const atrule = this.getAtrule(atruleName);
        if (!atrule.prelude && prelude) return new SyntaxError('At-rule `@' + atruleName + '` should not contain a prelude');
        if (atrule.prelude && !prelude) {
            if (!$771fc9957da5893f$var$matchSyntax(this, atrule.prelude, '', false).matched) return new SyntaxError('At-rule `@' + atruleName + '` should contain a prelude');
        }
    }
    checkAtruleDescriptorName(atruleName, descriptorName) {
        const error$1 = this.checkAtruleName(atruleName);
        if (error$1) return error$1;
        const atrule = this.getAtrule(atruleName);
        const descriptor = $jJe0G.keyword(descriptorName);
        if (!atrule.descriptors) return new SyntaxError('At-rule `@' + atruleName + '` has no known descriptors');
        if (!atrule.descriptors[descriptor.name] && !atrule.descriptors[descriptor.basename]) return new $evUTe.SyntaxReferenceError('Unknown at-rule descriptor', descriptorName);
    }
    checkPropertyName(propertyName) {
        if (!this.getProperty(propertyName)) return new $evUTe.SyntaxReferenceError('Unknown property', propertyName);
    }
    matchAtrulePrelude(atruleName, prelude) {
        const error = this.checkAtrulePrelude(atruleName, prelude);
        if (error) return $771fc9957da5893f$var$buildMatchResult(null, error);
        const atrule = this.getAtrule(atruleName);
        if (!atrule.prelude) return $771fc9957da5893f$var$buildMatchResult(null, null);
        return $771fc9957da5893f$var$matchSyntax(this, atrule.prelude, prelude || '', false);
    }
    matchAtruleDescriptor(atruleName, descriptorName, value) {
        const error = this.checkAtruleDescriptorName(atruleName, descriptorName);
        if (error) return $771fc9957da5893f$var$buildMatchResult(null, error);
        const atrule = this.getAtrule(atruleName);
        const descriptor = $jJe0G.keyword(descriptorName);
        return $771fc9957da5893f$var$matchSyntax(this, atrule.descriptors[descriptor.name] || atrule.descriptors[descriptor.basename], value, false);
    }
    matchDeclaration(node) {
        if (node.type !== 'Declaration') return $771fc9957da5893f$var$buildMatchResult(null, new Error('Not a Declaration node'));
        return this.matchProperty(node.property, node.value);
    }
    matchProperty(propertyName, value) {
        // don't match syntax for a custom property at the moment
        if ($jJe0G.property(propertyName).custom) return $771fc9957da5893f$var$buildMatchResult(null, new Error('Lexer matching doesn\'t applicable for custom properties'));
        const error = this.checkPropertyName(propertyName);
        if (error) return $771fc9957da5893f$var$buildMatchResult(null, error);
        return $771fc9957da5893f$var$matchSyntax(this, this.getProperty(propertyName), value, true);
    }
    matchType(typeName, value) {
        const typeSyntax = this.getType(typeName);
        if (!typeSyntax) return $771fc9957da5893f$var$buildMatchResult(null, new $evUTe.SyntaxReferenceError('Unknown type', typeName));
        return $771fc9957da5893f$var$matchSyntax(this, typeSyntax, value, false);
    }
    match(syntax, value) {
        if (typeof syntax !== 'string' && (!syntax || !syntax.type)) return $771fc9957da5893f$var$buildMatchResult(null, new $evUTe.SyntaxReferenceError('Bad syntax'));
        if (typeof syntax === 'string' || !syntax.match) syntax = this.createDescriptor(syntax, 'Type', 'anonymous');
        return $771fc9957da5893f$var$matchSyntax(this, syntax, value, false);
    }
    findValueFragments(propertyName, value, type, name) {
        return $ka2do.matchFragments(this, value, this.matchProperty(propertyName, value), type, name);
    }
    findDeclarationValueFragments(declaration, type, name) {
        return $ka2do.matchFragments(this, declaration.value, this.matchDeclaration(declaration), type, name);
    }
    findAllFragments(ast, type, name) {
        const result = [];
        this.syntax.walk(ast, {
            visit: 'Declaration',
            enter: (declaration)=>{
                result.push.apply(result, this.findDeclarationValueFragments(declaration, type, name));
            }
        });
        return result;
    }
    getAtrule(atruleName, fallbackBasename = true) {
        const atrule = $jJe0G.keyword(atruleName);
        const atruleEntry = atrule.vendor && fallbackBasename ? this.atrules[atrule.name] || this.atrules[atrule.basename] : this.atrules[atrule.name];
        return atruleEntry || null;
    }
    getAtrulePrelude(atruleName, fallbackBasename = true) {
        const atrule = this.getAtrule(atruleName, fallbackBasename);
        return atrule && atrule.prelude || null;
    }
    getAtruleDescriptor(atruleName, name) {
        return this.atrules.hasOwnProperty(atruleName) && this.atrules.declarators ? this.atrules[atruleName].declarators[name] || null : null;
    }
    getProperty(propertyName, fallbackBasename = true) {
        const property = $jJe0G.property(propertyName);
        const propertyEntry = property.vendor && fallbackBasename ? this.properties[property.name] || this.properties[property.basename] : this.properties[property.name];
        return propertyEntry || null;
    }
    getType(name) {
        return hasOwnProperty.call(this.types, name) ? this.types[name] : null;
    }
    validate() {
        function validate(syntax, name, broken, descriptor) {
            if (broken.has(name)) return broken.get(name);
            broken.set(name, false);
            if (descriptor.syntax !== null) $cSjEF.walk(descriptor.syntax, function(node) {
                if (node.type !== 'Type' && node.type !== 'Property') return;
                const map = node.type === 'Type' ? syntax.types : syntax.properties;
                const brokenMap = node.type === 'Type' ? brokenTypes : brokenProperties;
                if (!hasOwnProperty.call(map, node.name) || validate(syntax, node.name, brokenMap, map[node.name])) broken.set(name, true);
            }, this);
        }
        let brokenTypes = new Map();
        let brokenProperties = new Map();
        for(const key in this.types)validate(this, key, brokenTypes, this.types[key]);
        for(const key in this.properties)validate(this, key, brokenProperties, this.properties[key]);
        brokenTypes = [
            ...brokenTypes.keys()
        ].filter((name)=>brokenTypes.get(name));
        brokenProperties = [
            ...brokenProperties.keys()
        ].filter((name)=>brokenProperties.get(name));
        if (brokenTypes.length || brokenProperties.length) return {
            types: brokenTypes,
            properties: brokenProperties
        };
        return null;
    }
    dump(syntaxAsAst, pretty) {
        return {
            generic: this.generic,
            types: $771fc9957da5893f$var$dumpMapSyntax(this.types, !pretty, syntaxAsAst),
            properties: $771fc9957da5893f$var$dumpMapSyntax(this.properties, !pretty, syntaxAsAst),
            atrules: $771fc9957da5893f$var$dumpAtruleMapSyntax(this.atrules, !pretty, syntaxAsAst)
        };
    }
    toString() {
        return JSON.stringify(this.dump());
    }
    constructor(config, syntax, structure$1){
        this.cssWideKeywordsSyntax = $771fc9957da5893f$var$cssWideKeywordsSyntax;
        this.syntax = syntax;
        this.generic = false;
        this.atrules = Object.create(null);
        this.properties = Object.create(null);
        this.types = Object.create(null);
        this.structure = structure$1 || $7mF6V.getStructureFromConfig(config);
        if (config) {
            if (config.types) for(const name in config.types)this.addType_(name, config.types[name]);
            if (config.generic) {
                this.generic = true;
                for(const name in $6FUvZ)this.addType_(name, $6FUvZ[name]);
            }
            if (config.atrules) for(const name in config.atrules)this.addAtrule_(name, config.atrules[name]);
            if (config.properties) for(const name in config.properties)this.addProperty_(name, config.properties[name]);
        }
    }
}
$771fc9957da5893f$export$6168dc8908a6c652 = $771fc9957da5893f$var$Lexer;

});
parcelRegister("evUTe", function(module, exports) {

$parcel$export(module.exports, "SyntaxMatchError", () => $a9101713cce542fa$export$c937494ee8e9606d, (v) => $a9101713cce542fa$export$c937494ee8e9606d = v);
$parcel$export(module.exports, "SyntaxReferenceError", () => $a9101713cce542fa$export$65d073607b1def2, (v) => $a9101713cce542fa$export$65d073607b1def2 = v);
var $a9101713cce542fa$export$c937494ee8e9606d;
var $a9101713cce542fa$export$65d073607b1def2;
'use strict';

var $1YFif = parcelRequire("1YFif");

var $fiYed = parcelRequire("fiYed");
const $a9101713cce542fa$var$defaultLoc = {
    offset: 0,
    line: 1,
    column: 1
};
function $a9101713cce542fa$var$locateMismatch(matchResult, node) {
    const tokens = matchResult.tokens;
    const longestMatch = matchResult.longestMatch;
    const mismatchNode = longestMatch < tokens.length ? tokens[longestMatch].node || null : null;
    const badNode = mismatchNode !== node ? mismatchNode : null;
    let mismatchOffset = 0;
    let mismatchLength = 0;
    let entries = 0;
    let css = '';
    let start;
    let end;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i].value;
        if (i === longestMatch) {
            mismatchLength = token.length;
            mismatchOffset = css.length;
        }
        if (badNode !== null && tokens[i].node === badNode) {
            if (i <= longestMatch) entries++;
            else entries = 0;
        }
        css += token;
    }
    if (longestMatch === tokens.length || entries > 1) {
        start = $a9101713cce542fa$var$fromLoc(badNode || node, 'end') || $a9101713cce542fa$var$buildLoc($a9101713cce542fa$var$defaultLoc, css);
        end = $a9101713cce542fa$var$buildLoc(start);
    } else {
        start = $a9101713cce542fa$var$fromLoc(badNode, 'start') || $a9101713cce542fa$var$buildLoc($a9101713cce542fa$var$fromLoc(node, 'start') || $a9101713cce542fa$var$defaultLoc, css.slice(0, mismatchOffset));
        end = $a9101713cce542fa$var$fromLoc(badNode, 'end') || $a9101713cce542fa$var$buildLoc(start, css.substr(mismatchOffset, mismatchLength));
    }
    return {
        css: css,
        mismatchOffset: mismatchOffset,
        mismatchLength: mismatchLength,
        start: start,
        end: end
    };
}
function $a9101713cce542fa$var$fromLoc(node, point) {
    const value = node && node.loc && node.loc[point];
    if (value) return 'line' in value ? $a9101713cce542fa$var$buildLoc(value) : value;
    return null;
}
function $a9101713cce542fa$var$buildLoc({ offset: offset, line: line, column: column }, extra) {
    const loc = {
        offset: offset,
        line: line,
        column: column
    };
    if (extra) {
        const lines = extra.split(/\n|\r\n?|\f/);
        loc.offset += extra.length;
        loc.line += lines.length - 1;
        loc.column = lines.length === 1 ? loc.column + extra.length : lines.pop().length + 1;
    }
    return loc;
}
const $a9101713cce542fa$var$SyntaxReferenceError = function(type, referenceName) {
    const error = $1YFif.createCustomError('SyntaxReferenceError', type + (referenceName ? ' `' + referenceName + '`' : ''));
    error.reference = referenceName;
    return error;
};
const $a9101713cce542fa$var$SyntaxMatchError = function(message, syntax, node, matchResult) {
    const error = $1YFif.createCustomError('SyntaxMatchError', message);
    const { css: css, mismatchOffset: mismatchOffset, mismatchLength: mismatchLength, start: start, end: end } = $a9101713cce542fa$var$locateMismatch(matchResult, node);
    error.rawMessage = message;
    error.syntax = syntax ? $fiYed.generate(syntax) : '<generic>';
    error.css = css;
    error.mismatchOffset = mismatchOffset;
    error.mismatchLength = mismatchLength;
    error.message = message + '\n' + '  syntax: ' + error.syntax + '\n' + '   value: ' + (css || '<empty string>') + '\n' + '  --------' + new Array(error.mismatchOffset + 1).join('-') + '^';
    Object.assign(error, start);
    error.loc = {
        source: node && node.loc && node.loc.source || '<unknown>',
        start: start,
        end: end
    };
    return error;
};
$a9101713cce542fa$export$c937494ee8e9606d = $a9101713cce542fa$var$SyntaxMatchError;
$a9101713cce542fa$export$65d073607b1def2 = $a9101713cce542fa$var$SyntaxReferenceError;

});
parcelRegister("fiYed", function(module, exports) {

$parcel$export(module.exports, "generate", () => $b24741853096cf4e$export$80d376111cc09ad7, (v) => $b24741853096cf4e$export$80d376111cc09ad7 = v);
var $b24741853096cf4e$export$80d376111cc09ad7;
'use strict';
function $b24741853096cf4e$var$noop(value) {
    return value;
}
function $b24741853096cf4e$var$generateMultiplier(multiplier) {
    const { min: min, max: max, comma: comma } = multiplier;
    if (min === 0 && max === 0) return comma ? '#?' : '*';
    if (min === 0 && max === 1) return '?';
    if (min === 1 && max === 0) return comma ? '#' : '+';
    if (min === 1 && max === 1) return '';
    return (comma ? '#' : '') + (min === max ? '{' + min + '}' : '{' + min + ',' + (max !== 0 ? max : '') + '}');
}
function $b24741853096cf4e$var$generateTypeOpts(node) {
    switch(node.type){
        case 'Range':
            return ' [' + (node.min === null ? "-\u221E" : node.min) + ',' + (node.max === null ? "\u221E" : node.max) + ']';
        default:
            throw new Error('Unknown node type `' + node.type + '`');
    }
}
function $b24741853096cf4e$var$generateSequence(node, decorate, forceBraces, compact) {
    const combinator = node.combinator === ' ' || compact ? node.combinator : ' ' + node.combinator + ' ';
    const result = node.terms.map((term)=>$b24741853096cf4e$var$internalGenerate(term, decorate, forceBraces, compact)).join(combinator);
    if (node.explicit || forceBraces) return (compact || result[0] === ',' ? '[' : '[ ') + result + (compact ? ']' : ' ]');
    return result;
}
function $b24741853096cf4e$var$internalGenerate(node, decorate, forceBraces, compact) {
    let result;
    switch(node.type){
        case 'Group':
            result = $b24741853096cf4e$var$generateSequence(node, decorate, forceBraces, compact) + (node.disallowEmpty ? '!' : '');
            break;
        case 'Multiplier':
            // return since node is a composition
            return $b24741853096cf4e$var$internalGenerate(node.term, decorate, forceBraces, compact) + decorate($b24741853096cf4e$var$generateMultiplier(node), node);
        case 'Type':
            result = '<' + node.name + (node.opts ? decorate($b24741853096cf4e$var$generateTypeOpts(node.opts), node.opts) : '') + '>';
            break;
        case 'Property':
            result = '<\'' + node.name + '\'>';
            break;
        case 'Keyword':
            result = node.name;
            break;
        case 'AtKeyword':
            result = '@' + node.name;
            break;
        case 'Function':
            result = node.name + '(';
            break;
        case 'String':
        case 'Token':
            result = node.value;
            break;
        case 'Comma':
            result = ',';
            break;
        default:
            throw new Error('Unknown node type `' + node.type + '`');
    }
    return decorate(result, node);
}
function $b24741853096cf4e$var$generate(node, options) {
    let decorate = $b24741853096cf4e$var$noop;
    let forceBraces = false;
    let compact = false;
    if (typeof options === 'function') decorate = options;
    else if (options) {
        forceBraces = Boolean(options.forceBraces);
        compact = Boolean(options.compact);
        if (typeof options.decorate === 'function') decorate = options.decorate;
    }
    return $b24741853096cf4e$var$internalGenerate(node, decorate, forceBraces, compact);
}
$b24741853096cf4e$export$80d376111cc09ad7 = $b24741853096cf4e$var$generate;

});


parcelRegister("jJe0G", function(module, exports) {

$parcel$export(module.exports, "isCustomProperty", () => $e5cd165d09a59fe2$export$15cf667f7f91c461, (v) => $e5cd165d09a59fe2$export$15cf667f7f91c461 = v);
$parcel$export(module.exports, "keyword", () => $e5cd165d09a59fe2$export$2e81050496d0e63e, (v) => $e5cd165d09a59fe2$export$2e81050496d0e63e = v);
$parcel$export(module.exports, "property", () => $e5cd165d09a59fe2$export$d541bacb2bda4494, (v) => $e5cd165d09a59fe2$export$d541bacb2bda4494 = v);
$parcel$export(module.exports, "vendorPrefix", () => $e5cd165d09a59fe2$export$5150dd39c4b2a5da, (v) => $e5cd165d09a59fe2$export$5150dd39c4b2a5da = v);
var $e5cd165d09a59fe2$export$15cf667f7f91c461;
var $e5cd165d09a59fe2$export$2e81050496d0e63e;
var $e5cd165d09a59fe2$export$d541bacb2bda4494;
var $e5cd165d09a59fe2$export$5150dd39c4b2a5da;
'use strict';
const $e5cd165d09a59fe2$var$keywords = new Map();
const $e5cd165d09a59fe2$var$properties = new Map();
const $e5cd165d09a59fe2$var$HYPHENMINUS = 45; // '-'.charCodeAt()
const $e5cd165d09a59fe2$var$keyword = $e5cd165d09a59fe2$var$getKeywordDescriptor;
const $e5cd165d09a59fe2$var$property = $e5cd165d09a59fe2$var$getPropertyDescriptor;
const $e5cd165d09a59fe2$var$vendorPrefix = $e5cd165d09a59fe2$var$getVendorPrefix;
function $e5cd165d09a59fe2$var$isCustomProperty(str, offset) {
    offset = offset || 0;
    return str.length - offset >= 2 && str.charCodeAt(offset) === $e5cd165d09a59fe2$var$HYPHENMINUS && str.charCodeAt(offset + 1) === $e5cd165d09a59fe2$var$HYPHENMINUS;
}
function $e5cd165d09a59fe2$var$getVendorPrefix(str, offset) {
    offset = offset || 0;
    // verdor prefix should be at least 3 chars length
    if (str.length - offset >= 3) // vendor prefix starts with hyper minus following non-hyper minus
    {
        if (str.charCodeAt(offset) === $e5cd165d09a59fe2$var$HYPHENMINUS && str.charCodeAt(offset + 1) !== $e5cd165d09a59fe2$var$HYPHENMINUS) {
            // vendor prefix should contain a hyper minus at the ending
            const secondDashIndex = str.indexOf('-', offset + 2);
            if (secondDashIndex !== -1) return str.substring(offset, secondDashIndex + 1);
        }
    }
    return '';
}
function $e5cd165d09a59fe2$var$getKeywordDescriptor(keyword) {
    if ($e5cd165d09a59fe2$var$keywords.has(keyword)) return $e5cd165d09a59fe2$var$keywords.get(keyword);
    const name = keyword.toLowerCase();
    let descriptor = $e5cd165d09a59fe2$var$keywords.get(name);
    if (descriptor === undefined) {
        const custom = $e5cd165d09a59fe2$var$isCustomProperty(name, 0);
        const vendor = !custom ? $e5cd165d09a59fe2$var$getVendorPrefix(name, 0) : '';
        descriptor = Object.freeze({
            basename: name.substr(vendor.length),
            name: name,
            prefix: vendor,
            vendor: vendor,
            custom: custom
        });
    }
    $e5cd165d09a59fe2$var$keywords.set(keyword, descriptor);
    return descriptor;
}
function $e5cd165d09a59fe2$var$getPropertyDescriptor(property) {
    if ($e5cd165d09a59fe2$var$properties.has(property)) return $e5cd165d09a59fe2$var$properties.get(property);
    let name = property;
    let hack = property[0];
    if (hack === '/') hack = property[1] === '/' ? '//' : '/';
    else if (hack !== '_' && hack !== '*' && hack !== '$' && hack !== '#' && hack !== '+' && hack !== '&') hack = '';
    const custom = $e5cd165d09a59fe2$var$isCustomProperty(name, hack.length);
    // re-use result when possible (the same as for lower case)
    if (!custom) {
        name = name.toLowerCase();
        if ($e5cd165d09a59fe2$var$properties.has(name)) {
            const descriptor = $e5cd165d09a59fe2$var$properties.get(name);
            $e5cd165d09a59fe2$var$properties.set(property, descriptor);
            return descriptor;
        }
    }
    const vendor = !custom ? $e5cd165d09a59fe2$var$getVendorPrefix(name, hack.length) : '';
    const prefix = name.substr(0, hack.length + vendor.length);
    const descriptor = Object.freeze({
        basename: name.substr(prefix.length),
        name: name.substr(hack.length),
        hack: hack,
        vendor: vendor,
        prefix: prefix,
        custom: custom
    });
    $e5cd165d09a59fe2$var$properties.set(property, descriptor);
    return descriptor;
}
$e5cd165d09a59fe2$export$15cf667f7f91c461 = $e5cd165d09a59fe2$var$isCustomProperty;
$e5cd165d09a59fe2$export$2e81050496d0e63e = $e5cd165d09a59fe2$var$keyword;
$e5cd165d09a59fe2$export$d541bacb2bda4494 = $e5cd165d09a59fe2$var$property;
$e5cd165d09a59fe2$export$5150dd39c4b2a5da = $e5cd165d09a59fe2$var$vendorPrefix;

});

parcelRegister("71Tj9", function(module, exports) {

$parcel$export(module.exports, "cssWideKeywords", () => $51e387686cc4e242$export$b3191e0d9e666e2c, (v) => $51e387686cc4e242$export$b3191e0d9e666e2c = v);
var $51e387686cc4e242$export$b3191e0d9e666e2c;
'use strict';
// https://drafts.csswg.org/css-cascade-5/
const $51e387686cc4e242$var$cssWideKeywords = [
    'initial',
    'inherit',
    'unset',
    'revert',
    'revert-layer'
];
$51e387686cc4e242$export$b3191e0d9e666e2c = $51e387686cc4e242$var$cssWideKeywords;

});

parcelRegister("6FUvZ", function(module, exports) {
'use strict';

var $71Tj9 = parcelRequire("71Tj9");

var $55epl = parcelRequire("55epl");

var $fdDzq = parcelRequire("fdDzq");

var $iYo0F = parcelRequire("iYo0F");

var $kIeAG = parcelRequire("kIeAG");

var $7UrOl = parcelRequire("7UrOl");
const $4dc2691d1c111074$var$calcFunctionNames = [
    'calc(',
    '-moz-calc(',
    '-webkit-calc('
];
const $4dc2691d1c111074$var$balancePair = new Map([
    [
        $iYo0F.Function,
        $iYo0F.RightParenthesis
    ],
    [
        $iYo0F.LeftParenthesis,
        $iYo0F.RightParenthesis
    ],
    [
        $iYo0F.LeftSquareBracket,
        $iYo0F.RightSquareBracket
    ],
    [
        $iYo0F.LeftCurlyBracket,
        $iYo0F.RightCurlyBracket
    ]
]);
// units
const $4dc2691d1c111074$var$LENGTH = [
    // absolute length units https://www.w3.org/TR/css-values-3/#lengths
    'cm',
    'mm',
    'q',
    'in',
    'pt',
    'pc',
    'px',
    // font-relative length units https://drafts.csswg.org/css-values-4/#font-relative-lengths
    'em',
    'rem',
    'ex',
    'rex',
    'cap',
    'rcap',
    'ch',
    'rch',
    'ic',
    'ric',
    'lh',
    'rlh',
    // viewport-percentage lengths https://drafts.csswg.org/css-values-4/#viewport-relative-lengths
    'vw',
    'svw',
    'lvw',
    'dvw',
    'vh',
    'svh',
    'lvh',
    'dvh',
    'vi',
    'svi',
    'lvi',
    'dvi',
    'vb',
    'svb',
    'lvb',
    'dvb',
    'vmin',
    'svmin',
    'lvmin',
    'dvmin',
    'vmax',
    'svmax',
    'lvmax',
    'dvmax',
    // container relative lengths https://drafts.csswg.org/css-contain-3/#container-lengths
    'cqw',
    'cqh',
    'cqi',
    'cqb',
    'cqmin',
    'cqmax'
];
const $4dc2691d1c111074$var$ANGLE = [
    'deg',
    'grad',
    'rad',
    'turn'
]; // https://www.w3.org/TR/css-values-3/#angles
const $4dc2691d1c111074$var$TIME = [
    's',
    'ms'
]; // https://www.w3.org/TR/css-values-3/#time
const $4dc2691d1c111074$var$FREQUENCY = [
    'hz',
    'khz'
]; // https://www.w3.org/TR/css-values-3/#frequency
const $4dc2691d1c111074$var$RESOLUTION = [
    'dpi',
    'dpcm',
    'dppx',
    'x'
]; // https://www.w3.org/TR/css-values-3/#resolution
const $4dc2691d1c111074$var$FLEX = [
    'fr'
]; // https://drafts.csswg.org/css-grid/#fr-unit
const $4dc2691d1c111074$var$DECIBEL = [
    'db'
]; // https://www.w3.org/TR/css3-speech/#mixing-props-voice-volume
const $4dc2691d1c111074$var$SEMITONES = [
    'st'
]; // https://www.w3.org/TR/css3-speech/#voice-props-voice-pitch
// safe char code getter
function $4dc2691d1c111074$var$charCodeAt(str, index) {
    return index < str.length ? str.charCodeAt(index) : 0;
}
function $4dc2691d1c111074$var$eqStr(actual, expected) {
    return $7UrOl.cmpStr(actual, 0, actual.length, expected);
}
function $4dc2691d1c111074$var$eqStrAny(actual, expected) {
    for(let i = 0; i < expected.length; i++){
        if ($4dc2691d1c111074$var$eqStr(actual, expected[i])) return true;
    }
    return false;
}
// IE postfix hack, i.e. 123\0 or 123px\9
function $4dc2691d1c111074$var$isPostfixIeHack(str, offset) {
    if (offset !== str.length - 2) return false;
    return $4dc2691d1c111074$var$charCodeAt(str, offset) === 0x005C && // U+005C REVERSE SOLIDUS (\)
    $kIeAG.isDigit($4dc2691d1c111074$var$charCodeAt(str, offset + 1));
}
function $4dc2691d1c111074$var$outOfRange(opts, value, numEnd) {
    if (opts && opts.type === 'Range') {
        const num = Number(numEnd !== undefined && numEnd !== value.length ? value.substr(0, numEnd) : value);
        if (isNaN(num)) return true;
        // FIXME: when opts.min is a string it's a dimension, skip a range validation
        // for now since it requires a type covertation which is not implmented yet
        if (opts.min !== null && num < opts.min && typeof opts.min !== 'string') return true;
        // FIXME: when opts.max is a string it's a dimension, skip a range validation
        // for now since it requires a type covertation which is not implmented yet
        if (opts.max !== null && num > opts.max && typeof opts.max !== 'string') return true;
    }
    return false;
}
function $4dc2691d1c111074$var$consumeFunction(token, getNextToken) {
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // balanced token consuming
    scan: do {
        switch(token.type){
            case $iYo0F.RightCurlyBracket:
            case $iYo0F.RightParenthesis:
            case $iYo0F.RightSquareBracket:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                if (balanceStash.length === 0) {
                    length++;
                    break scan;
                }
                break;
            case $iYo0F.Function:
            case $iYo0F.LeftParenthesis:
            case $iYo0F.LeftSquareBracket:
            case $iYo0F.LeftCurlyBracket:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $4dc2691d1c111074$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// TODO: implement
// can be used wherever <length>, <frequency>, <angle>, <time>, <percentage>, <number>, or <integer> values are allowed
// https://drafts.csswg.org/css-values/#calc-notation
function $4dc2691d1c111074$var$calc(next) {
    return function(token, getNextToken, opts) {
        if (token === null) return 0;
        if (token.type === $iYo0F.Function && $4dc2691d1c111074$var$eqStrAny(token.value, $4dc2691d1c111074$var$calcFunctionNames)) return $4dc2691d1c111074$var$consumeFunction(token, getNextToken);
        return next(token, getNextToken, opts);
    };
}
function $4dc2691d1c111074$var$tokenType(expectedTokenType) {
    return function(token) {
        if (token === null || token.type !== expectedTokenType) return 0;
        return 1;
    };
}
// =========================
// Complex types
//
// https://drafts.csswg.org/css-values-4/#custom-idents
// 4.2. Author-defined Identifiers: the <custom-ident> type
// Some properties accept arbitrary author-defined identifiers as a component value.
// This generic data type is denoted by <custom-ident>, and represents any valid CSS identifier
// that would not be misinterpreted as a pre-defined keyword in that property’s value definition.
//
// See also: https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident
function $4dc2691d1c111074$var$customIdent(token) {
    if (token === null || token.type !== $iYo0F.Ident) return 0;
    const name = token.value.toLowerCase();
    // The CSS-wide keywords are not valid <custom-ident>s
    if ($4dc2691d1c111074$var$eqStrAny(name, $71Tj9.cssWideKeywords)) return 0;
    // The default keyword is reserved and is also not a valid <custom-ident>
    if ($4dc2691d1c111074$var$eqStr(name, 'default')) return 0;
    // TODO: ignore property specific keywords (as described https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident)
    // Specifications using <custom-ident> must specify clearly what other keywords
    // are excluded from <custom-ident>, if any—for example by saying that any pre-defined keywords
    // in that property’s value definition are excluded. Excluded keywords are excluded
    // in all ASCII case permutations.
    return 1;
}
// https://drafts.csswg.org/css-variables/#typedef-custom-property-name
// A custom property is any property whose name starts with two dashes (U+002D HYPHEN-MINUS), like --foo.
// The <custom-property-name> production corresponds to this: it’s defined as any valid identifier
// that starts with two dashes, except -- itself, which is reserved for future use by CSS.
// NOTE: Current implementation treat `--` as a valid name since most (all?) major browsers treat it as valid.
function $4dc2691d1c111074$var$customPropertyName(token) {
    // ... defined as any valid identifier
    if (token === null || token.type !== $iYo0F.Ident) return 0;
    // ... that starts with two dashes (U+002D HYPHEN-MINUS)
    if ($4dc2691d1c111074$var$charCodeAt(token.value, 0) !== 0x002D || $4dc2691d1c111074$var$charCodeAt(token.value, 1) !== 0x002D) return 0;
    return 1;
}
// https://drafts.csswg.org/css-color-4/#hex-notation
// The syntax of a <hex-color> is a <hash-token> token whose value consists of 3, 4, 6, or 8 hexadecimal digits.
// In other words, a hex color is written as a hash character, "#", followed by some number of digits 0-9 or
// letters a-f (the case of the letters doesn’t matter - #00ff00 is identical to #00FF00).
function $4dc2691d1c111074$var$hexColor(token) {
    if (token === null || token.type !== $iYo0F.Hash) return 0;
    const length = token.value.length;
    // valid values (length): #rgb (4), #rgba (5), #rrggbb (7), #rrggbbaa (9)
    if (length !== 4 && length !== 5 && length !== 7 && length !== 9) return 0;
    for(let i = 1; i < length; i++){
        if (!$kIeAG.isHexDigit($4dc2691d1c111074$var$charCodeAt(token.value, i))) return 0;
    }
    return 1;
}
function $4dc2691d1c111074$var$idSelector(token) {
    if (token === null || token.type !== $iYo0F.Hash) return 0;
    if (!$kIeAG.isIdentifierStart($4dc2691d1c111074$var$charCodeAt(token.value, 1), $4dc2691d1c111074$var$charCodeAt(token.value, 2), $4dc2691d1c111074$var$charCodeAt(token.value, 3))) return 0;
    return 1;
}
// https://drafts.csswg.org/css-syntax/#any-value
// It represents the entirety of what a valid declaration can have as its value.
function $4dc2691d1c111074$var$declarationValue(token, getNextToken) {
    if (!token) return 0;
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // The <declaration-value> production matches any sequence of one or more tokens,
    // so long as the sequence does not contain ...
    scan: do {
        switch(token.type){
            // ... <bad-string-token>, <bad-url-token>,
            case $iYo0F.BadString:
            case $iYo0F.BadUrl:
                break scan;
            // ... unmatched <)-token>, <]-token>, or <}-token>,
            case $iYo0F.RightCurlyBracket:
            case $iYo0F.RightParenthesis:
            case $iYo0F.RightSquareBracket:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                break;
            // ... or top-level <semicolon-token> tokens
            case $iYo0F.Semicolon:
                if (balanceCloseType === 0) break scan;
                break;
            // ... or <delim-token> tokens with a value of "!"
            case $iYo0F.Delim:
                if (balanceCloseType === 0 && token.value === '!') break scan;
                break;
            case $iYo0F.Function:
            case $iYo0F.LeftParenthesis:
            case $iYo0F.LeftSquareBracket:
            case $iYo0F.LeftCurlyBracket:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $4dc2691d1c111074$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// https://drafts.csswg.org/css-syntax/#any-value
// The <any-value> production is identical to <declaration-value>, but also
// allows top-level <semicolon-token> tokens and <delim-token> tokens
// with a value of "!". It represents the entirety of what valid CSS can be in any context.
function $4dc2691d1c111074$var$anyValue(token, getNextToken) {
    if (!token) return 0;
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // The <any-value> production matches any sequence of one or more tokens,
    // so long as the sequence ...
    scan: do {
        switch(token.type){
            // ... does not contain <bad-string-token>, <bad-url-token>,
            case $iYo0F.BadString:
            case $iYo0F.BadUrl:
                break scan;
            // ... unmatched <)-token>, <]-token>, or <}-token>,
            case $iYo0F.RightCurlyBracket:
            case $iYo0F.RightParenthesis:
            case $iYo0F.RightSquareBracket:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                break;
            case $iYo0F.Function:
            case $iYo0F.LeftParenthesis:
            case $iYo0F.LeftSquareBracket:
            case $iYo0F.LeftCurlyBracket:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $4dc2691d1c111074$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// =========================
// Dimensions
//
function $4dc2691d1c111074$var$dimension(type) {
    if (type) type = new Set(type);
    return function(token, getNextToken, opts) {
        if (token === null || token.type !== $iYo0F.Dimension) return 0;
        const numberEnd = $7UrOl.consumeNumber(token.value, 0);
        // check unit
        if (type !== null) {
            // check for IE postfix hack, i.e. 123px\0 or 123px\9
            const reverseSolidusOffset = token.value.indexOf('\\', numberEnd);
            const unit = reverseSolidusOffset === -1 || !$4dc2691d1c111074$var$isPostfixIeHack(token.value, reverseSolidusOffset) ? token.value.substr(numberEnd) : token.value.substring(numberEnd, reverseSolidusOffset);
            if (type.has(unit.toLowerCase()) === false) return 0;
        }
        // check range if specified
        if ($4dc2691d1c111074$var$outOfRange(opts, token.value, numberEnd)) return 0;
        return 1;
    };
}
// =========================
// Percentage
//
// §5.5. Percentages: the <percentage> type
// https://drafts.csswg.org/css-values-4/#percentages
function $4dc2691d1c111074$var$percentage(token, getNextToken, opts) {
    // ... corresponds to the <percentage-token> production
    if (token === null || token.type !== $iYo0F.Percentage) return 0;
    // check range if specified
    if ($4dc2691d1c111074$var$outOfRange(opts, token.value, token.value.length - 1)) return 0;
    return 1;
}
// =========================
// Numeric
//
// https://drafts.csswg.org/css-values-4/#numbers
// The value <zero> represents a literal number with the value 0. Expressions that merely
// evaluate to a <number> with the value 0 (for example, calc(0)) do not match <zero>;
// only literal <number-token>s do.
function $4dc2691d1c111074$var$zero(next) {
    if (typeof next !== 'function') next = function() {
        return 0;
    };
    return function(token, getNextToken, opts) {
        if (token !== null && token.type === $iYo0F.Number) {
            if (Number(token.value) === 0) return 1;
        }
        return next(token, getNextToken, opts);
    };
}
// § 5.3. Real Numbers: the <number> type
// https://drafts.csswg.org/css-values-4/#numbers
// Number values are denoted by <number>, and represent real numbers, possibly with a fractional component.
// ... It corresponds to the <number-token> production
function $4dc2691d1c111074$var$number(token, getNextToken, opts) {
    if (token === null) return 0;
    const numberEnd = $7UrOl.consumeNumber(token.value, 0);
    const isNumber = numberEnd === token.value.length;
    if (!isNumber && !$4dc2691d1c111074$var$isPostfixIeHack(token.value, numberEnd)) return 0;
    // check range if specified
    if ($4dc2691d1c111074$var$outOfRange(opts, token.value, numberEnd)) return 0;
    return 1;
}
// §5.2. Integers: the <integer> type
// https://drafts.csswg.org/css-values-4/#integers
function $4dc2691d1c111074$var$integer(token, getNextToken, opts) {
    // ... corresponds to a subset of the <number-token> production
    if (token === null || token.type !== $iYo0F.Number) return 0;
    // The first digit of an integer may be immediately preceded by `-` or `+` to indicate the integer’s sign.
    let i = $4dc2691d1c111074$var$charCodeAt(token.value, 0) === 0x002B || // U+002B PLUS SIGN (+)
    $4dc2691d1c111074$var$charCodeAt(token.value, 0) === 0x002D ? 1 : 0; // U+002D HYPHEN-MINUS (-)
    // When written literally, an integer is one or more decimal digits 0 through 9 ...
    for(; i < token.value.length; i++){
        if (!$kIeAG.isDigit($4dc2691d1c111074$var$charCodeAt(token.value, i))) return 0;
    }
    // check range if specified
    if ($4dc2691d1c111074$var$outOfRange(opts, token.value, i)) return 0;
    return 1;
}
const $4dc2691d1c111074$var$genericSyntaxes = {
    // token types
    'ident-token': $4dc2691d1c111074$var$tokenType($iYo0F.Ident),
    'function-token': $4dc2691d1c111074$var$tokenType($iYo0F.Function),
    'at-keyword-token': $4dc2691d1c111074$var$tokenType($iYo0F.AtKeyword),
    'hash-token': $4dc2691d1c111074$var$tokenType($iYo0F.Hash),
    'string-token': $4dc2691d1c111074$var$tokenType($iYo0F.String),
    'bad-string-token': $4dc2691d1c111074$var$tokenType($iYo0F.BadString),
    'url-token': $4dc2691d1c111074$var$tokenType($iYo0F.Url),
    'bad-url-token': $4dc2691d1c111074$var$tokenType($iYo0F.BadUrl),
    'delim-token': $4dc2691d1c111074$var$tokenType($iYo0F.Delim),
    'number-token': $4dc2691d1c111074$var$tokenType($iYo0F.Number),
    'percentage-token': $4dc2691d1c111074$var$tokenType($iYo0F.Percentage),
    'dimension-token': $4dc2691d1c111074$var$tokenType($iYo0F.Dimension),
    'whitespace-token': $4dc2691d1c111074$var$tokenType($iYo0F.WhiteSpace),
    'CDO-token': $4dc2691d1c111074$var$tokenType($iYo0F.CDO),
    'CDC-token': $4dc2691d1c111074$var$tokenType($iYo0F.CDC),
    'colon-token': $4dc2691d1c111074$var$tokenType($iYo0F.Colon),
    'semicolon-token': $4dc2691d1c111074$var$tokenType($iYo0F.Semicolon),
    'comma-token': $4dc2691d1c111074$var$tokenType($iYo0F.Comma),
    '[-token': $4dc2691d1c111074$var$tokenType($iYo0F.LeftSquareBracket),
    ']-token': $4dc2691d1c111074$var$tokenType($iYo0F.RightSquareBracket),
    '(-token': $4dc2691d1c111074$var$tokenType($iYo0F.LeftParenthesis),
    ')-token': $4dc2691d1c111074$var$tokenType($iYo0F.RightParenthesis),
    '{-token': $4dc2691d1c111074$var$tokenType($iYo0F.LeftCurlyBracket),
    '}-token': $4dc2691d1c111074$var$tokenType($iYo0F.RightCurlyBracket),
    // token type aliases
    'string': $4dc2691d1c111074$var$tokenType($iYo0F.String),
    'ident': $4dc2691d1c111074$var$tokenType($iYo0F.Ident),
    // complex types
    'custom-ident': $4dc2691d1c111074$var$customIdent,
    'custom-property-name': $4dc2691d1c111074$var$customPropertyName,
    'hex-color': $4dc2691d1c111074$var$hexColor,
    'id-selector': $4dc2691d1c111074$var$idSelector,
    'an-plus-b': $55epl,
    'urange': $fdDzq,
    'declaration-value': $4dc2691d1c111074$var$declarationValue,
    'any-value': $4dc2691d1c111074$var$anyValue,
    // dimensions
    'dimension': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$dimension(null)),
    'angle': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$dimension($4dc2691d1c111074$var$ANGLE)),
    'decibel': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$dimension($4dc2691d1c111074$var$DECIBEL)),
    'frequency': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$dimension($4dc2691d1c111074$var$FREQUENCY)),
    'flex': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$dimension($4dc2691d1c111074$var$FLEX)),
    'length': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$zero($4dc2691d1c111074$var$dimension($4dc2691d1c111074$var$LENGTH))),
    'resolution': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$dimension($4dc2691d1c111074$var$RESOLUTION)),
    'semitones': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$dimension($4dc2691d1c111074$var$SEMITONES)),
    'time': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$dimension($4dc2691d1c111074$var$TIME)),
    // percentage
    'percentage': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$percentage),
    // numeric
    'zero': $4dc2691d1c111074$var$zero(),
    'number': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$number),
    'integer': $4dc2691d1c111074$var$calc($4dc2691d1c111074$var$integer)
};
module.exports = $4dc2691d1c111074$var$genericSyntaxes;

});
parcelRegister("55epl", function(module, exports) {
'use strict';

var $kIeAG = parcelRequire("kIeAG");

var $iYo0F = parcelRequire("iYo0F");

var $7UrOl = parcelRequire("7UrOl");
const $3b38987d40543df8$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $3b38987d40543df8$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $3b38987d40543df8$var$N = 0x006E; // U+006E LATIN SMALL LETTER N (n)
const $3b38987d40543df8$var$DISALLOW_SIGN = true;
const $3b38987d40543df8$var$ALLOW_SIGN = false;
function $3b38987d40543df8$var$isDelim(token, code) {
    return token !== null && token.type === $iYo0F.Delim && token.value.charCodeAt(0) === code;
}
function $3b38987d40543df8$var$skipSC(token, offset, getNextToken) {
    while(token !== null && (token.type === $iYo0F.WhiteSpace || token.type === $iYo0F.Comment))token = getNextToken(++offset);
    return offset;
}
function $3b38987d40543df8$var$checkInteger(token, valueOffset, disallowSign, offset) {
    if (!token) return 0;
    const code = token.value.charCodeAt(valueOffset);
    if (code === $3b38987d40543df8$var$PLUSSIGN || code === $3b38987d40543df8$var$HYPHENMINUS) {
        if (disallowSign) // Number sign is not allowed
        return 0;
        valueOffset++;
    }
    for(; valueOffset < token.value.length; valueOffset++){
        if (!$kIeAG.isDigit(token.value.charCodeAt(valueOffset))) // Integer is expected
        return 0;
    }
    return offset + 1;
}
// ... <signed-integer>
// ... ['+' | '-'] <signless-integer>
function $3b38987d40543df8$var$consumeB(token, offset_, getNextToken) {
    let sign = false;
    let offset = $3b38987d40543df8$var$skipSC(token, offset_, getNextToken);
    token = getNextToken(offset);
    if (token === null) return offset_;
    if (token.type !== $iYo0F.Number) {
        if ($3b38987d40543df8$var$isDelim(token, $3b38987d40543df8$var$PLUSSIGN) || $3b38987d40543df8$var$isDelim(token, $3b38987d40543df8$var$HYPHENMINUS)) {
            sign = true;
            offset = $3b38987d40543df8$var$skipSC(getNextToken(++offset), offset, getNextToken);
            token = getNextToken(offset);
            if (token === null || token.type !== $iYo0F.Number) return 0;
        } else return offset_;
    }
    if (!sign) {
        const code = token.value.charCodeAt(0);
        if (code !== $3b38987d40543df8$var$PLUSSIGN && code !== $3b38987d40543df8$var$HYPHENMINUS) // Number sign is expected
        return 0;
    }
    return $3b38987d40543df8$var$checkInteger(token, sign ? 0 : 1, sign, offset);
}
// An+B microsyntax https://www.w3.org/TR/css-syntax-3/#anb
function $3b38987d40543df8$var$anPlusB(token, getNextToken) {
    /* eslint-disable brace-style*/ let offset = 0;
    if (!token) return 0;
    // <integer>
    if (token.type === $iYo0F.Number) return $3b38987d40543df8$var$checkInteger(token, 0, $3b38987d40543df8$var$ALLOW_SIGN, offset); // b
    else if (token.type === $iYo0F.Ident && token.value.charCodeAt(0) === $3b38987d40543df8$var$HYPHENMINUS) {
        // expect 1st char is N
        if (!$7UrOl.cmpChar(token.value, 1, $3b38987d40543df8$var$N)) return 0;
        switch(token.value.length){
            // -n
            // -n <signed-integer>
            // -n ['+' | '-'] <signless-integer>
            case 2:
                return $3b38987d40543df8$var$consumeB(getNextToken(++offset), offset, getNextToken);
            // -n- <signless-integer>
            case 3:
                if (token.value.charCodeAt(2) !== $3b38987d40543df8$var$HYPHENMINUS) return 0;
                offset = $3b38987d40543df8$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $3b38987d40543df8$var$checkInteger(token, 0, $3b38987d40543df8$var$DISALLOW_SIGN, offset);
            // <dashndashdigit-ident>
            default:
                if (token.value.charCodeAt(2) !== $3b38987d40543df8$var$HYPHENMINUS) return 0;
                return $3b38987d40543df8$var$checkInteger(token, 3, $3b38987d40543df8$var$DISALLOW_SIGN, offset);
        }
    } else if (token.type === $iYo0F.Ident || $3b38987d40543df8$var$isDelim(token, $3b38987d40543df8$var$PLUSSIGN) && getNextToken(offset + 1).type === $iYo0F.Ident) {
        // just ignore a plus
        if (token.type !== $iYo0F.Ident) token = getNextToken(++offset);
        if (token === null || !$7UrOl.cmpChar(token.value, 0, $3b38987d40543df8$var$N)) return 0;
        switch(token.value.length){
            // '+'? n
            // '+'? n <signed-integer>
            // '+'? n ['+' | '-'] <signless-integer>
            case 1:
                return $3b38987d40543df8$var$consumeB(getNextToken(++offset), offset, getNextToken);
            // '+'? n- <signless-integer>
            case 2:
                if (token.value.charCodeAt(1) !== $3b38987d40543df8$var$HYPHENMINUS) return 0;
                offset = $3b38987d40543df8$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $3b38987d40543df8$var$checkInteger(token, 0, $3b38987d40543df8$var$DISALLOW_SIGN, offset);
            // '+'? <ndashdigit-ident>
            default:
                if (token.value.charCodeAt(1) !== $3b38987d40543df8$var$HYPHENMINUS) return 0;
                return $3b38987d40543df8$var$checkInteger(token, 2, $3b38987d40543df8$var$DISALLOW_SIGN, offset);
        }
    } else if (token.type === $iYo0F.Dimension) {
        let code = token.value.charCodeAt(0);
        let sign = code === $3b38987d40543df8$var$PLUSSIGN || code === $3b38987d40543df8$var$HYPHENMINUS ? 1 : 0;
        let i = sign;
        for(; i < token.value.length; i++){
            if (!$kIeAG.isDigit(token.value.charCodeAt(i))) break;
        }
        if (i === sign) // Integer is expected
        return 0;
        if (!$7UrOl.cmpChar(token.value, i, $3b38987d40543df8$var$N)) return 0;
        // <n-dimension>
        // <n-dimension> <signed-integer>
        // <n-dimension> ['+' | '-'] <signless-integer>
        if (i + 1 === token.value.length) return $3b38987d40543df8$var$consumeB(getNextToken(++offset), offset, getNextToken);
        else {
            if (token.value.charCodeAt(i + 1) !== $3b38987d40543df8$var$HYPHENMINUS) return 0;
            // <ndash-dimension> <signless-integer>
            if (i + 2 === token.value.length) {
                offset = $3b38987d40543df8$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $3b38987d40543df8$var$checkInteger(token, 0, $3b38987d40543df8$var$DISALLOW_SIGN, offset);
            } else return $3b38987d40543df8$var$checkInteger(token, i + 2, $3b38987d40543df8$var$DISALLOW_SIGN, offset);
        }
    }
    return 0;
}
module.exports = $3b38987d40543df8$var$anPlusB;

});

parcelRegister("fdDzq", function(module, exports) {
'use strict';

var $kIeAG = parcelRequire("kIeAG");

var $iYo0F = parcelRequire("iYo0F");

var $7UrOl = parcelRequire("7UrOl");
const $b146c3c256da8694$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $b146c3c256da8694$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $b146c3c256da8694$var$QUESTIONMARK = 0x003F; // U+003F QUESTION MARK (?)
const $b146c3c256da8694$var$U = 0x0075; // U+0075 LATIN SMALL LETTER U (u)
function $b146c3c256da8694$var$isDelim(token, code) {
    return token !== null && token.type === $iYo0F.Delim && token.value.charCodeAt(0) === code;
}
function $b146c3c256da8694$var$startsWith(token, code) {
    return token.value.charCodeAt(0) === code;
}
function $b146c3c256da8694$var$hexSequence(token, offset, allowDash) {
    let hexlen = 0;
    for(let pos = offset; pos < token.value.length; pos++){
        const code = token.value.charCodeAt(pos);
        if (code === $b146c3c256da8694$var$HYPHENMINUS && allowDash && hexlen !== 0) {
            $b146c3c256da8694$var$hexSequence(token, offset + hexlen + 1, false);
            return 6; // dissallow following question marks
        }
        if (!$kIeAG.isHexDigit(code)) return 0; // not a hex digit
        if (++hexlen > 6) return 0; // too many hex digits
    }
    return hexlen;
}
function $b146c3c256da8694$var$withQuestionMarkSequence(consumed, length, getNextToken) {
    if (!consumed) return 0; // nothing consumed
    while($b146c3c256da8694$var$isDelim(getNextToken(length), $b146c3c256da8694$var$QUESTIONMARK)){
        if (++consumed > 6) return 0; // too many question marks
        length++;
    }
    return length;
}
// https://drafts.csswg.org/css-syntax/#urange
// Informally, the <urange> production has three forms:
// U+0001
//      Defines a range consisting of a single code point, in this case the code point "1".
// U+0001-00ff
//      Defines a range of codepoints between the first and the second value, in this case
//      the range between "1" and "ff" (255 in decimal) inclusive.
// U+00??
//      Defines a range of codepoints where the "?" characters range over all hex digits,
//      in this case defining the same as the value U+0000-00ff.
// In each form, a maximum of 6 digits is allowed for each hexadecimal number (if you treat "?" as a hexadecimal digit).
//
// <urange> =
//   u '+' <ident-token> '?'* |
//   u <dimension-token> '?'* |
//   u <number-token> '?'* |
//   u <number-token> <dimension-token> |
//   u <number-token> <number-token> |
//   u '+' '?'+
function $b146c3c256da8694$var$urange(token, getNextToken) {
    let length = 0;
    // should start with `u` or `U`
    if (token === null || token.type !== $iYo0F.Ident || !$7UrOl.cmpChar(token.value, 0, $b146c3c256da8694$var$U)) return 0;
    token = getNextToken(++length);
    if (token === null) return 0;
    // u '+' <ident-token> '?'*
    // u '+' '?'+
    if ($b146c3c256da8694$var$isDelim(token, $b146c3c256da8694$var$PLUSSIGN)) {
        token = getNextToken(++length);
        if (token === null) return 0;
        if (token.type === $iYo0F.Ident) // u '+' <ident-token> '?'*
        return $b146c3c256da8694$var$withQuestionMarkSequence($b146c3c256da8694$var$hexSequence(token, 0, true), ++length, getNextToken);
        if ($b146c3c256da8694$var$isDelim(token, $b146c3c256da8694$var$QUESTIONMARK)) // u '+' '?'+
        return $b146c3c256da8694$var$withQuestionMarkSequence(1, ++length, getNextToken);
        // Hex digit or question mark is expected
        return 0;
    }
    // u <number-token> '?'*
    // u <number-token> <dimension-token>
    // u <number-token> <number-token>
    if (token.type === $iYo0F.Number) {
        const consumedHexLength = $b146c3c256da8694$var$hexSequence(token, 1, true);
        if (consumedHexLength === 0) return 0;
        token = getNextToken(++length);
        if (token === null) // u <number-token> <eof>
        return length;
        if (token.type === $iYo0F.Dimension || token.type === $iYo0F.Number) {
            // u <number-token> <dimension-token>
            // u <number-token> <number-token>
            if (!$b146c3c256da8694$var$startsWith(token, $b146c3c256da8694$var$HYPHENMINUS) || !$b146c3c256da8694$var$hexSequence(token, 1, false)) return 0;
            return length + 1;
        }
        // u <number-token> '?'*
        return $b146c3c256da8694$var$withQuestionMarkSequence(consumedHexLength, length, getNextToken);
    }
    // u <dimension-token> '?'*
    if (token.type === $iYo0F.Dimension) return $b146c3c256da8694$var$withQuestionMarkSequence($b146c3c256da8694$var$hexSequence(token, 1, true), ++length, getNextToken);
    return 0;
}
module.exports = $b146c3c256da8694$var$urange;

});


parcelRegister("75eBD", function(module, exports) {
'use strict';

var $2vMqe = parcelRequire("2vMqe");
const $5284547875bcaa22$var$astToTokens = {
    decorator (handlers) {
        const tokens = [];
        let curNode = null;
        return {
            ...handlers,
            node (node) {
                const tmp = curNode;
                curNode = node;
                handlers.node.call(this, node);
                curNode = tmp;
            },
            emit (value, type, auto) {
                tokens.push({
                    type: type,
                    value: value,
                    node: auto ? null : curNode
                });
            },
            result () {
                return tokens;
            }
        };
    }
};
function $5284547875bcaa22$var$stringToTokens(str) {
    const tokens = [];
    $2vMqe.tokenize(str, (type, start, end)=>tokens.push({
            type: type,
            value: str.slice(start, end),
            node: null
        }));
    return tokens;
}
function $5284547875bcaa22$var$prepareTokens(value, syntax) {
    if (typeof value === 'string') return $5284547875bcaa22$var$stringToTokens(value);
    return syntax.generate(value, $5284547875bcaa22$var$astToTokens);
}
module.exports = $5284547875bcaa22$var$prepareTokens;

});

parcelRegister("ejayB", function(module, exports) {

$parcel$export(module.exports, "DISALLOW_EMPTY", () => $a6ab0772205d4a0f$export$d962e73e7bcd24c, (v) => $a6ab0772205d4a0f$export$d962e73e7bcd24c = v);
$parcel$export(module.exports, "MATCH", () => $a6ab0772205d4a0f$export$5a1a83be8f503735, (v) => $a6ab0772205d4a0f$export$5a1a83be8f503735 = v);
$parcel$export(module.exports, "MISMATCH", () => $a6ab0772205d4a0f$export$dfbc42837bfccec4, (v) => $a6ab0772205d4a0f$export$dfbc42837bfccec4 = v);
$parcel$export(module.exports, "buildMatchGraph", () => $a6ab0772205d4a0f$export$41c88d779c06859d, (v) => $a6ab0772205d4a0f$export$41c88d779c06859d = v);
var $a6ab0772205d4a0f$export$d962e73e7bcd24c;
var $a6ab0772205d4a0f$export$5a1a83be8f503735;
var $a6ab0772205d4a0f$export$dfbc42837bfccec4;
var $a6ab0772205d4a0f$export$41c88d779c06859d;
'use strict';

var $8tOv6 = parcelRequire("8tOv6");
const $a6ab0772205d4a0f$var$MATCH = {
    type: 'Match'
};
const $a6ab0772205d4a0f$var$MISMATCH = {
    type: 'Mismatch'
};
const $a6ab0772205d4a0f$var$DISALLOW_EMPTY = {
    type: 'DisallowEmpty'
};
const $a6ab0772205d4a0f$var$LEFTPARENTHESIS = 40; // (
const $a6ab0772205d4a0f$var$RIGHTPARENTHESIS = 41; // )
function $a6ab0772205d4a0f$var$createCondition(match, thenBranch, elseBranch) {
    // reduce node count
    if (thenBranch === $a6ab0772205d4a0f$var$MATCH && elseBranch === $a6ab0772205d4a0f$var$MISMATCH) return match;
    if (match === $a6ab0772205d4a0f$var$MATCH && thenBranch === $a6ab0772205d4a0f$var$MATCH && elseBranch === $a6ab0772205d4a0f$var$MATCH) return match;
    if (match.type === 'If' && match.else === $a6ab0772205d4a0f$var$MISMATCH && thenBranch === $a6ab0772205d4a0f$var$MATCH) {
        thenBranch = match.then;
        match = match.match;
    }
    return {
        type: 'If',
        match: match,
        then: thenBranch,
        else: elseBranch
    };
}
function $a6ab0772205d4a0f$var$isFunctionType(name) {
    return name.length > 2 && name.charCodeAt(name.length - 2) === $a6ab0772205d4a0f$var$LEFTPARENTHESIS && name.charCodeAt(name.length - 1) === $a6ab0772205d4a0f$var$RIGHTPARENTHESIS;
}
function $a6ab0772205d4a0f$var$isEnumCapatible(term) {
    return term.type === 'Keyword' || term.type === 'AtKeyword' || term.type === 'Function' || term.type === 'Type' && $a6ab0772205d4a0f$var$isFunctionType(term.name);
}
function $a6ab0772205d4a0f$var$buildGroupMatchGraph(combinator, terms, atLeastOneTermMatched) {
    switch(combinator){
        case ' ':
            {
                // Juxtaposing components means that all of them must occur, in the given order.
                //
                // a b c
                // =
                // match a
                //   then match b
                //     then match c
                //       then MATCH
                //       else MISMATCH
                //     else MISMATCH
                //   else MISMATCH
                let result = $a6ab0772205d4a0f$var$MATCH;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    result = $a6ab0772205d4a0f$var$createCondition(term, result, $a6ab0772205d4a0f$var$MISMATCH);
                }
                return result;
            }
        case '|':
            {
                // A bar (|) separates two or more alternatives: exactly one of them must occur.
                //
                // a | b | c
                // =
                // match a
                //   then MATCH
                //   else match b
                //     then MATCH
                //     else match c
                //       then MATCH
                //       else MISMATCH
                let result = $a6ab0772205d4a0f$var$MISMATCH;
                let map = null;
                for(let i = terms.length - 1; i >= 0; i--){
                    let term = terms[i];
                    // reduce sequence of keywords into a Enum
                    if ($a6ab0772205d4a0f$var$isEnumCapatible(term)) {
                        if (map === null && i > 0 && $a6ab0772205d4a0f$var$isEnumCapatible(terms[i - 1])) {
                            map = Object.create(null);
                            result = $a6ab0772205d4a0f$var$createCondition({
                                type: 'Enum',
                                map: map
                            }, $a6ab0772205d4a0f$var$MATCH, result);
                        }
                        if (map !== null) {
                            const key = ($a6ab0772205d4a0f$var$isFunctionType(term.name) ? term.name.slice(0, -1) : term.name).toLowerCase();
                            if (key in map === false) {
                                map[key] = term;
                                continue;
                            }
                        }
                    }
                    map = null;
                    // create a new conditonal node
                    result = $a6ab0772205d4a0f$var$createCondition(term, $a6ab0772205d4a0f$var$MATCH, result);
                }
                return result;
            }
        case '&&':
            {
                // A double ampersand (&&) separates two or more components,
                // all of which must occur, in any order.
                // Use MatchOnce for groups with a large number of terms,
                // since &&-groups produces at least N!-node trees
                if (terms.length > 5) return {
                    type: 'MatchOnce',
                    terms: terms,
                    all: true
                };
                // Use a combination tree for groups with small number of terms
                //
                // a && b && c
                // =
                // match a
                //   then [b && c]
                //   else match b
                //     then [a && c]
                //     else match c
                //       then [a && b]
                //       else MISMATCH
                //
                // a && b
                // =
                // match a
                //   then match b
                //     then MATCH
                //     else MISMATCH
                //   else match b
                //     then match a
                //       then MATCH
                //       else MISMATCH
                //     else MISMATCH
                let result = $a6ab0772205d4a0f$var$MISMATCH;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    let thenClause;
                    if (terms.length > 1) thenClause = $a6ab0772205d4a0f$var$buildGroupMatchGraph(combinator, terms.filter(function(newGroupTerm) {
                        return newGroupTerm !== term;
                    }), false);
                    else thenClause = $a6ab0772205d4a0f$var$MATCH;
                    result = $a6ab0772205d4a0f$var$createCondition(term, thenClause, result);
                }
                return result;
            }
        case '||':
            {
                // A double bar (||) separates two or more options:
                // one or more of them must occur, in any order.
                // Use MatchOnce for groups with a large number of terms,
                // since ||-groups produces at least N!-node trees
                if (terms.length > 5) return {
                    type: 'MatchOnce',
                    terms: terms,
                    all: false
                };
                // Use a combination tree for groups with small number of terms
                //
                // a || b || c
                // =
                // match a
                //   then [b || c]
                //   else match b
                //     then [a || c]
                //     else match c
                //       then [a || b]
                //       else MISMATCH
                //
                // a || b
                // =
                // match a
                //   then match b
                //     then MATCH
                //     else MATCH
                //   else match b
                //     then match a
                //       then MATCH
                //       else MATCH
                //     else MISMATCH
                let result = atLeastOneTermMatched ? $a6ab0772205d4a0f$var$MATCH : $a6ab0772205d4a0f$var$MISMATCH;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    let thenClause;
                    if (terms.length > 1) thenClause = $a6ab0772205d4a0f$var$buildGroupMatchGraph(combinator, terms.filter(function(newGroupTerm) {
                        return newGroupTerm !== term;
                    }), true);
                    else thenClause = $a6ab0772205d4a0f$var$MATCH;
                    result = $a6ab0772205d4a0f$var$createCondition(term, thenClause, result);
                }
                return result;
            }
    }
}
function $a6ab0772205d4a0f$var$buildMultiplierMatchGraph(node) {
    let result = $a6ab0772205d4a0f$var$MATCH;
    let matchTerm = $a6ab0772205d4a0f$var$buildMatchGraphInternal(node.term);
    if (node.max === 0) {
        // disable repeating of empty match to prevent infinite loop
        matchTerm = $a6ab0772205d4a0f$var$createCondition(matchTerm, $a6ab0772205d4a0f$var$DISALLOW_EMPTY, $a6ab0772205d4a0f$var$MISMATCH);
        // an occurrence count is not limited, make a cycle;
        // to collect more terms on each following matching mismatch
        result = $a6ab0772205d4a0f$var$createCondition(matchTerm, null, $a6ab0772205d4a0f$var$MISMATCH);
        result.then = $a6ab0772205d4a0f$var$createCondition($a6ab0772205d4a0f$var$MATCH, $a6ab0772205d4a0f$var$MATCH, result // make a loop
        );
        if (node.comma) result.then.else = $a6ab0772205d4a0f$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $a6ab0772205d4a0f$var$MISMATCH);
    } else // create a match node chain for [min .. max] interval with optional matches
    for(let i = node.min || 1; i <= node.max; i++){
        if (node.comma && result !== $a6ab0772205d4a0f$var$MATCH) result = $a6ab0772205d4a0f$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $a6ab0772205d4a0f$var$MISMATCH);
        result = $a6ab0772205d4a0f$var$createCondition(matchTerm, $a6ab0772205d4a0f$var$createCondition($a6ab0772205d4a0f$var$MATCH, $a6ab0772205d4a0f$var$MATCH, result), $a6ab0772205d4a0f$var$MISMATCH);
    }
    if (node.min === 0) // allow zero match
    result = $a6ab0772205d4a0f$var$createCondition($a6ab0772205d4a0f$var$MATCH, $a6ab0772205d4a0f$var$MATCH, result);
    else // create a match node chain to collect [0 ... min - 1] required matches
    for(let i = 0; i < node.min - 1; i++){
        if (node.comma && result !== $a6ab0772205d4a0f$var$MATCH) result = $a6ab0772205d4a0f$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $a6ab0772205d4a0f$var$MISMATCH);
        result = $a6ab0772205d4a0f$var$createCondition(matchTerm, result, $a6ab0772205d4a0f$var$MISMATCH);
    }
    return result;
}
function $a6ab0772205d4a0f$var$buildMatchGraphInternal(node) {
    if (typeof node === 'function') return {
        type: 'Generic',
        fn: node
    };
    switch(node.type){
        case 'Group':
            {
                let result = $a6ab0772205d4a0f$var$buildGroupMatchGraph(node.combinator, node.terms.map($a6ab0772205d4a0f$var$buildMatchGraphInternal), false);
                if (node.disallowEmpty) result = $a6ab0772205d4a0f$var$createCondition(result, $a6ab0772205d4a0f$var$DISALLOW_EMPTY, $a6ab0772205d4a0f$var$MISMATCH);
                return result;
            }
        case 'Multiplier':
            return $a6ab0772205d4a0f$var$buildMultiplierMatchGraph(node);
        case 'Type':
        case 'Property':
            return {
                type: node.type,
                name: node.name,
                syntax: node
            };
        case 'Keyword':
            return {
                type: node.type,
                name: node.name.toLowerCase(),
                syntax: node
            };
        case 'AtKeyword':
            return {
                type: node.type,
                name: '@' + node.name.toLowerCase(),
                syntax: node
            };
        case 'Function':
            return {
                type: node.type,
                name: node.name.toLowerCase() + '(',
                syntax: node
            };
        case 'String':
            // convert a one char length String to a Token
            if (node.value.length === 3) return {
                type: 'Token',
                value: node.value.charAt(1),
                syntax: node
            };
            // otherwise use it as is
            return {
                type: node.type,
                value: node.value.substr(1, node.value.length - 2).replace(/\\'/g, '\''),
                syntax: node
            };
        case 'Token':
            return {
                type: node.type,
                value: node.value,
                syntax: node
            };
        case 'Comma':
            return {
                type: node.type,
                syntax: node
            };
        default:
            throw new Error('Unknown node type:', node.type);
    }
}
function $a6ab0772205d4a0f$var$buildMatchGraph(syntaxTree, ref) {
    if (typeof syntaxTree === 'string') syntaxTree = $8tOv6.parse(syntaxTree);
    return {
        type: 'MatchGraph',
        match: $a6ab0772205d4a0f$var$buildMatchGraphInternal(syntaxTree),
        syntax: ref || null,
        source: syntaxTree
    };
}
$a6ab0772205d4a0f$export$d962e73e7bcd24c = $a6ab0772205d4a0f$var$DISALLOW_EMPTY;
$a6ab0772205d4a0f$export$5a1a83be8f503735 = $a6ab0772205d4a0f$var$MATCH;
$a6ab0772205d4a0f$export$dfbc42837bfccec4 = $a6ab0772205d4a0f$var$MISMATCH;
$a6ab0772205d4a0f$export$41c88d779c06859d = $a6ab0772205d4a0f$var$buildMatchGraph;

});
parcelRegister("8tOv6", function(module, exports) {

$parcel$export(module.exports, "parse", () => $62c8348e5099ab56$export$98e6a39c04603d36, (v) => $62c8348e5099ab56$export$98e6a39c04603d36 = v);
var $62c8348e5099ab56$export$98e6a39c04603d36;
'use strict';

var $3LJiZ = parcelRequire("3LJiZ");
const $62c8348e5099ab56$var$TAB = 9;
const $62c8348e5099ab56$var$N = 10;
const $62c8348e5099ab56$var$F = 12;
const $62c8348e5099ab56$var$R = 13;
const $62c8348e5099ab56$var$SPACE = 32;
const $62c8348e5099ab56$var$EXCLAMATIONMARK = 33; // !
const $62c8348e5099ab56$var$NUMBERSIGN = 35; // #
const $62c8348e5099ab56$var$AMPERSAND = 38; // &
const $62c8348e5099ab56$var$APOSTROPHE = 39; // '
const $62c8348e5099ab56$var$LEFTPARENTHESIS = 40; // (
const $62c8348e5099ab56$var$RIGHTPARENTHESIS = 41; // )
const $62c8348e5099ab56$var$ASTERISK = 42; // *
const $62c8348e5099ab56$var$PLUSSIGN = 43; // +
const $62c8348e5099ab56$var$COMMA = 44; // ,
const $62c8348e5099ab56$var$HYPERMINUS = 45; // -
const $62c8348e5099ab56$var$LESSTHANSIGN = 60; // <
const $62c8348e5099ab56$var$GREATERTHANSIGN = 62; // >
const $62c8348e5099ab56$var$QUESTIONMARK = 63; // ?
const $62c8348e5099ab56$var$COMMERCIALAT = 64; // @
const $62c8348e5099ab56$var$LEFTSQUAREBRACKET = 91; // [
const $62c8348e5099ab56$var$RIGHTSQUAREBRACKET = 93; // ]
const $62c8348e5099ab56$var$LEFTCURLYBRACKET = 123; // {
const $62c8348e5099ab56$var$VERTICALLINE = 124; // |
const $62c8348e5099ab56$var$RIGHTCURLYBRACKET = 125; // }
const $62c8348e5099ab56$var$INFINITY = 8734; // ∞
const $62c8348e5099ab56$var$NAME_CHAR = new Uint8Array(128).map((_, idx)=>/[a-zA-Z0-9\-]/.test(String.fromCharCode(idx)) ? 1 : 0);
const $62c8348e5099ab56$var$COMBINATOR_PRECEDENCE = {
    ' ': 1,
    '&&': 2,
    '||': 3,
    '|': 4
};
function $62c8348e5099ab56$var$scanSpaces(tokenizer) {
    return tokenizer.substringToPos(tokenizer.findWsEnd(tokenizer.pos));
}
function $62c8348e5099ab56$var$scanWord(tokenizer) {
    let end = tokenizer.pos;
    for(; end < tokenizer.str.length; end++){
        const code = tokenizer.str.charCodeAt(end);
        if (code >= 128 || $62c8348e5099ab56$var$NAME_CHAR[code] === 0) break;
    }
    if (tokenizer.pos === end) tokenizer.error('Expect a keyword');
    return tokenizer.substringToPos(end);
}
function $62c8348e5099ab56$var$scanNumber(tokenizer) {
    let end = tokenizer.pos;
    for(; end < tokenizer.str.length; end++){
        const code = tokenizer.str.charCodeAt(end);
        if (code < 48 || code > 57) break;
    }
    if (tokenizer.pos === end) tokenizer.error('Expect a number');
    return tokenizer.substringToPos(end);
}
function $62c8348e5099ab56$var$scanString(tokenizer) {
    const end = tokenizer.str.indexOf('\'', tokenizer.pos + 1);
    if (end === -1) {
        tokenizer.pos = tokenizer.str.length;
        tokenizer.error('Expect an apostrophe');
    }
    return tokenizer.substringToPos(end + 1);
}
function $62c8348e5099ab56$var$readMultiplierRange(tokenizer) {
    let min = null;
    let max = null;
    tokenizer.eat($62c8348e5099ab56$var$LEFTCURLYBRACKET);
    min = $62c8348e5099ab56$var$scanNumber(tokenizer);
    if (tokenizer.charCode() === $62c8348e5099ab56$var$COMMA) {
        tokenizer.pos++;
        if (tokenizer.charCode() !== $62c8348e5099ab56$var$RIGHTCURLYBRACKET) max = $62c8348e5099ab56$var$scanNumber(tokenizer);
    } else max = min;
    tokenizer.eat($62c8348e5099ab56$var$RIGHTCURLYBRACKET);
    return {
        min: Number(min),
        max: max ? Number(max) : 0
    };
}
function $62c8348e5099ab56$var$readMultiplier(tokenizer) {
    let range = null;
    let comma = false;
    switch(tokenizer.charCode()){
        case $62c8348e5099ab56$var$ASTERISK:
            tokenizer.pos++;
            range = {
                min: 0,
                max: 0
            };
            break;
        case $62c8348e5099ab56$var$PLUSSIGN:
            tokenizer.pos++;
            range = {
                min: 1,
                max: 0
            };
            break;
        case $62c8348e5099ab56$var$QUESTIONMARK:
            tokenizer.pos++;
            range = {
                min: 0,
                max: 1
            };
            break;
        case $62c8348e5099ab56$var$NUMBERSIGN:
            tokenizer.pos++;
            comma = true;
            if (tokenizer.charCode() === $62c8348e5099ab56$var$LEFTCURLYBRACKET) range = $62c8348e5099ab56$var$readMultiplierRange(tokenizer);
            else if (tokenizer.charCode() === $62c8348e5099ab56$var$QUESTIONMARK) {
                // https://www.w3.org/TR/css-values-4/#component-multipliers
                // > the # and ? multipliers may be stacked as #?
                // In this case just treat "#?" as a single multiplier
                // { min: 0, max: 0, comma: true }
                tokenizer.pos++;
                range = {
                    min: 0,
                    max: 0
                };
            } else range = {
                min: 1,
                max: 0
            };
            break;
        case $62c8348e5099ab56$var$LEFTCURLYBRACKET:
            range = $62c8348e5099ab56$var$readMultiplierRange(tokenizer);
            break;
        default:
            return null;
    }
    return {
        type: 'Multiplier',
        comma: comma,
        min: range.min,
        max: range.max,
        term: null
    };
}
function $62c8348e5099ab56$var$maybeMultiplied(tokenizer, node) {
    const multiplier = $62c8348e5099ab56$var$readMultiplier(tokenizer);
    if (multiplier !== null) {
        multiplier.term = node;
        // https://www.w3.org/TR/css-values-4/#component-multipliers
        // > The + and # multipliers may be stacked as +#;
        // Represent "+#" as nested multipliers:
        // { ...<multiplier #>,
        //   term: {
        //     ...<multipler +>,
        //     term: node
        //   }
        // }
        if (tokenizer.charCode() === $62c8348e5099ab56$var$NUMBERSIGN && tokenizer.charCodeAt(tokenizer.pos - 1) === $62c8348e5099ab56$var$PLUSSIGN) return $62c8348e5099ab56$var$maybeMultiplied(tokenizer, multiplier);
        return multiplier;
    }
    return node;
}
function $62c8348e5099ab56$var$maybeToken(tokenizer) {
    const ch = tokenizer.peek();
    if (ch === '') return null;
    return {
        type: 'Token',
        value: ch
    };
}
function $62c8348e5099ab56$var$readProperty(tokenizer) {
    let name;
    tokenizer.eat($62c8348e5099ab56$var$LESSTHANSIGN);
    tokenizer.eat($62c8348e5099ab56$var$APOSTROPHE);
    name = $62c8348e5099ab56$var$scanWord(tokenizer);
    tokenizer.eat($62c8348e5099ab56$var$APOSTROPHE);
    tokenizer.eat($62c8348e5099ab56$var$GREATERTHANSIGN);
    return $62c8348e5099ab56$var$maybeMultiplied(tokenizer, {
        type: 'Property',
        name: name
    });
}
// https://drafts.csswg.org/css-values-3/#numeric-ranges
// 4.1. Range Restrictions and Range Definition Notation
//
// Range restrictions can be annotated in the numeric type notation using CSS bracketed
// range notation—[min,max]—within the angle brackets, after the identifying keyword,
// indicating a closed range between (and including) min and max.
// For example, <integer [0, 10]> indicates an integer between 0 and 10, inclusive.
function $62c8348e5099ab56$var$readTypeRange(tokenizer) {
    // use null for Infinity to make AST format JSON serializable/deserializable
    let min = null; // -Infinity
    let max = null; // Infinity
    let sign = 1;
    tokenizer.eat($62c8348e5099ab56$var$LEFTSQUAREBRACKET);
    if (tokenizer.charCode() === $62c8348e5099ab56$var$HYPERMINUS) {
        tokenizer.peek();
        sign = -1;
    }
    if (sign == -1 && tokenizer.charCode() === $62c8348e5099ab56$var$INFINITY) tokenizer.peek();
    else {
        min = sign * Number($62c8348e5099ab56$var$scanNumber(tokenizer));
        if ($62c8348e5099ab56$var$NAME_CHAR[tokenizer.charCode()] !== 0) min += $62c8348e5099ab56$var$scanWord(tokenizer);
    }
    $62c8348e5099ab56$var$scanSpaces(tokenizer);
    tokenizer.eat($62c8348e5099ab56$var$COMMA);
    $62c8348e5099ab56$var$scanSpaces(tokenizer);
    if (tokenizer.charCode() === $62c8348e5099ab56$var$INFINITY) tokenizer.peek();
    else {
        sign = 1;
        if (tokenizer.charCode() === $62c8348e5099ab56$var$HYPERMINUS) {
            tokenizer.peek();
            sign = -1;
        }
        max = sign * Number($62c8348e5099ab56$var$scanNumber(tokenizer));
        if ($62c8348e5099ab56$var$NAME_CHAR[tokenizer.charCode()] !== 0) max += $62c8348e5099ab56$var$scanWord(tokenizer);
    }
    tokenizer.eat($62c8348e5099ab56$var$RIGHTSQUAREBRACKET);
    return {
        type: 'Range',
        min: min,
        max: max
    };
}
function $62c8348e5099ab56$var$readType(tokenizer) {
    let name;
    let opts = null;
    tokenizer.eat($62c8348e5099ab56$var$LESSTHANSIGN);
    name = $62c8348e5099ab56$var$scanWord(tokenizer);
    if (tokenizer.charCode() === $62c8348e5099ab56$var$LEFTPARENTHESIS && tokenizer.nextCharCode() === $62c8348e5099ab56$var$RIGHTPARENTHESIS) {
        tokenizer.pos += 2;
        name += '()';
    }
    if (tokenizer.charCodeAt(tokenizer.findWsEnd(tokenizer.pos)) === $62c8348e5099ab56$var$LEFTSQUAREBRACKET) {
        $62c8348e5099ab56$var$scanSpaces(tokenizer);
        opts = $62c8348e5099ab56$var$readTypeRange(tokenizer);
    }
    tokenizer.eat($62c8348e5099ab56$var$GREATERTHANSIGN);
    return $62c8348e5099ab56$var$maybeMultiplied(tokenizer, {
        type: 'Type',
        name: name,
        opts: opts
    });
}
function $62c8348e5099ab56$var$readKeywordOrFunction(tokenizer) {
    const name = $62c8348e5099ab56$var$scanWord(tokenizer);
    if (tokenizer.charCode() === $62c8348e5099ab56$var$LEFTPARENTHESIS) {
        tokenizer.pos++;
        return {
            type: 'Function',
            name: name
        };
    }
    return $62c8348e5099ab56$var$maybeMultiplied(tokenizer, {
        type: 'Keyword',
        name: name
    });
}
function $62c8348e5099ab56$var$regroupTerms(terms, combinators) {
    function createGroup(terms, combinator) {
        return {
            type: 'Group',
            terms: terms,
            combinator: combinator,
            disallowEmpty: false,
            explicit: false
        };
    }
    let combinator;
    combinators = Object.keys(combinators).sort((a, b)=>$62c8348e5099ab56$var$COMBINATOR_PRECEDENCE[a] - $62c8348e5099ab56$var$COMBINATOR_PRECEDENCE[b]);
    while(combinators.length > 0){
        combinator = combinators.shift();
        let i = 0;
        let subgroupStart = 0;
        for(; i < terms.length; i++){
            const term = terms[i];
            if (term.type === 'Combinator') {
                if (term.value === combinator) {
                    if (subgroupStart === -1) subgroupStart = i - 1;
                    terms.splice(i, 1);
                    i--;
                } else {
                    if (subgroupStart !== -1 && i - subgroupStart > 1) {
                        terms.splice(subgroupStart, i - subgroupStart, createGroup(terms.slice(subgroupStart, i), combinator));
                        i = subgroupStart + 1;
                    }
                    subgroupStart = -1;
                }
            }
        }
        if (subgroupStart !== -1 && combinators.length) terms.splice(subgroupStart, i - subgroupStart, createGroup(terms.slice(subgroupStart, i), combinator));
    }
    return combinator;
}
function $62c8348e5099ab56$var$readImplicitGroup(tokenizer) {
    const terms = [];
    const combinators = {};
    let token;
    let prevToken = null;
    let prevTokenPos = tokenizer.pos;
    while(token = $62c8348e5099ab56$var$peek(tokenizer))if (token.type !== 'Spaces') {
        if (token.type === 'Combinator') {
            // check for combinator in group beginning and double combinator sequence
            if (prevToken === null || prevToken.type === 'Combinator') {
                tokenizer.pos = prevTokenPos;
                tokenizer.error('Unexpected combinator');
            }
            combinators[token.value] = true;
        } else if (prevToken !== null && prevToken.type !== 'Combinator') {
            combinators[' '] = true; // a b
            terms.push({
                type: 'Combinator',
                value: ' '
            });
        }
        terms.push(token);
        prevToken = token;
        prevTokenPos = tokenizer.pos;
    }
    // check for combinator in group ending
    if (prevToken !== null && prevToken.type === 'Combinator') {
        tokenizer.pos -= prevTokenPos;
        tokenizer.error('Unexpected combinator');
    }
    return {
        type: 'Group',
        terms: terms,
        combinator: $62c8348e5099ab56$var$regroupTerms(terms, combinators) || ' ',
        disallowEmpty: false,
        explicit: false
    };
}
function $62c8348e5099ab56$var$readGroup(tokenizer) {
    let result;
    tokenizer.eat($62c8348e5099ab56$var$LEFTSQUAREBRACKET);
    result = $62c8348e5099ab56$var$readImplicitGroup(tokenizer);
    tokenizer.eat($62c8348e5099ab56$var$RIGHTSQUAREBRACKET);
    result.explicit = true;
    if (tokenizer.charCode() === $62c8348e5099ab56$var$EXCLAMATIONMARK) {
        tokenizer.pos++;
        result.disallowEmpty = true;
    }
    return result;
}
function $62c8348e5099ab56$var$peek(tokenizer) {
    let code = tokenizer.charCode();
    if (code < 128 && $62c8348e5099ab56$var$NAME_CHAR[code] === 1) return $62c8348e5099ab56$var$readKeywordOrFunction(tokenizer);
    switch(code){
        case $62c8348e5099ab56$var$RIGHTSQUAREBRACKET:
            break;
        case $62c8348e5099ab56$var$LEFTSQUAREBRACKET:
            return $62c8348e5099ab56$var$maybeMultiplied(tokenizer, $62c8348e5099ab56$var$readGroup(tokenizer));
        case $62c8348e5099ab56$var$LESSTHANSIGN:
            return tokenizer.nextCharCode() === $62c8348e5099ab56$var$APOSTROPHE ? $62c8348e5099ab56$var$readProperty(tokenizer) : $62c8348e5099ab56$var$readType(tokenizer);
        case $62c8348e5099ab56$var$VERTICALLINE:
            return {
                type: 'Combinator',
                value: tokenizer.substringToPos(tokenizer.pos + (tokenizer.nextCharCode() === $62c8348e5099ab56$var$VERTICALLINE ? 2 : 1))
            };
        case $62c8348e5099ab56$var$AMPERSAND:
            tokenizer.pos++;
            tokenizer.eat($62c8348e5099ab56$var$AMPERSAND);
            return {
                type: 'Combinator',
                value: '&&'
            };
        case $62c8348e5099ab56$var$COMMA:
            tokenizer.pos++;
            return {
                type: 'Comma'
            };
        case $62c8348e5099ab56$var$APOSTROPHE:
            return $62c8348e5099ab56$var$maybeMultiplied(tokenizer, {
                type: 'String',
                value: $62c8348e5099ab56$var$scanString(tokenizer)
            });
        case $62c8348e5099ab56$var$SPACE:
        case $62c8348e5099ab56$var$TAB:
        case $62c8348e5099ab56$var$N:
        case $62c8348e5099ab56$var$R:
        case $62c8348e5099ab56$var$F:
            return {
                type: 'Spaces',
                value: $62c8348e5099ab56$var$scanSpaces(tokenizer)
            };
        case $62c8348e5099ab56$var$COMMERCIALAT:
            code = tokenizer.nextCharCode();
            if (code < 128 && $62c8348e5099ab56$var$NAME_CHAR[code] === 1) {
                tokenizer.pos++;
                return {
                    type: 'AtKeyword',
                    name: $62c8348e5099ab56$var$scanWord(tokenizer)
                };
            }
            return $62c8348e5099ab56$var$maybeToken(tokenizer);
        case $62c8348e5099ab56$var$ASTERISK:
        case $62c8348e5099ab56$var$PLUSSIGN:
        case $62c8348e5099ab56$var$QUESTIONMARK:
        case $62c8348e5099ab56$var$NUMBERSIGN:
        case $62c8348e5099ab56$var$EXCLAMATIONMARK:
            break;
        case $62c8348e5099ab56$var$LEFTCURLYBRACKET:
            // LEFTCURLYBRACKET is allowed since mdn/data uses it w/o quoting
            // check next char isn't a number, because it's likely a disjoined multiplier
            code = tokenizer.nextCharCode();
            if (code < 48 || code > 57) return $62c8348e5099ab56$var$maybeToken(tokenizer);
            break;
        default:
            return $62c8348e5099ab56$var$maybeToken(tokenizer);
    }
}
function $62c8348e5099ab56$var$parse(source) {
    const tokenizer$1 = new $3LJiZ.Tokenizer(source);
    const result = $62c8348e5099ab56$var$readImplicitGroup(tokenizer$1);
    if (tokenizer$1.pos !== source.length) tokenizer$1.error('Unexpected input');
    // reduce redundant groups with single group term
    if (result.terms.length === 1 && result.terms[0].type === 'Group') return result.terms[0];
    return result;
}
$62c8348e5099ab56$export$98e6a39c04603d36 = $62c8348e5099ab56$var$parse;

});
parcelRegister("3LJiZ", function(module, exports) {

$parcel$export(module.exports, "Tokenizer", () => $2be8e792d94ef201$export$55e8b082af4aa63e, (v) => $2be8e792d94ef201$export$55e8b082af4aa63e = v);
var $2be8e792d94ef201$export$55e8b082af4aa63e;
'use strict';

var $MxUmp = parcelRequire("MxUmp");
const $2be8e792d94ef201$var$TAB = 9;
const $2be8e792d94ef201$var$N = 10;
const $2be8e792d94ef201$var$F = 12;
const $2be8e792d94ef201$var$R = 13;
const $2be8e792d94ef201$var$SPACE = 32;
class $2be8e792d94ef201$var$Tokenizer {
    charCodeAt(pos) {
        return pos < this.str.length ? this.str.charCodeAt(pos) : 0;
    }
    charCode() {
        return this.charCodeAt(this.pos);
    }
    nextCharCode() {
        return this.charCodeAt(this.pos + 1);
    }
    nextNonWsCode(pos) {
        return this.charCodeAt(this.findWsEnd(pos));
    }
    findWsEnd(pos) {
        for(; pos < this.str.length; pos++){
            const code = this.str.charCodeAt(pos);
            if (code !== $2be8e792d94ef201$var$R && code !== $2be8e792d94ef201$var$N && code !== $2be8e792d94ef201$var$F && code !== $2be8e792d94ef201$var$SPACE && code !== $2be8e792d94ef201$var$TAB) break;
        }
        return pos;
    }
    substringToPos(end) {
        return this.str.substring(this.pos, this.pos = end);
    }
    eat(code) {
        if (this.charCode() !== code) this.error('Expect `' + String.fromCharCode(code) + '`');
        this.pos++;
    }
    peek() {
        return this.pos < this.str.length ? this.str.charAt(this.pos++) : '';
    }
    error(message) {
        throw new $MxUmp.SyntaxError(message, this.str, this.pos);
    }
    constructor(str){
        this.str = str;
        this.pos = 0;
    }
}
$2be8e792d94ef201$export$55e8b082af4aa63e = $2be8e792d94ef201$var$Tokenizer;

});
parcelRegister("MxUmp", function(module, exports) {

$parcel$export(module.exports, "SyntaxError", () => $091ec93d59796cae$export$f21cea08b0dd60e8, (v) => $091ec93d59796cae$export$f21cea08b0dd60e8 = v);
var $091ec93d59796cae$export$f21cea08b0dd60e8;
'use strict';

var $1YFif = parcelRequire("1YFif");
function $091ec93d59796cae$var$SyntaxError(message, input, offset) {
    return Object.assign($1YFif.createCustomError('SyntaxError', message), {
        input: input,
        offset: offset,
        rawMessage: message,
        message: message + '\n' + '  ' + input + '\n' + '--' + new Array((offset || input.length) + 1).join('-') + '^'
    });
}
$091ec93d59796cae$export$f21cea08b0dd60e8 = $091ec93d59796cae$var$SyntaxError;

});




parcelRegister("1PrC8", function(module, exports) {

$parcel$export(module.exports, "matchAsTree", () => $154ff96df91439e8$export$575ec9525823c563, (v) => $154ff96df91439e8$export$575ec9525823c563 = v);
var $154ff96df91439e8$export$b15baef7e00e9fac;
var $154ff96df91439e8$export$575ec9525823c563;
'use strict';

var $ejayB = parcelRequire("ejayB");

var $iYo0F = parcelRequire("iYo0F");
const { hasOwnProperty: $154ff96df91439e8$var$hasOwnProperty } = Object.prototype;
const $154ff96df91439e8$var$STUB = 0;
const $154ff96df91439e8$var$TOKEN = 1;
const $154ff96df91439e8$var$OPEN_SYNTAX = 2;
const $154ff96df91439e8$var$CLOSE_SYNTAX = 3;
const $154ff96df91439e8$var$EXIT_REASON_MATCH = 'Match';
const $154ff96df91439e8$var$EXIT_REASON_MISMATCH = 'Mismatch';
const $154ff96df91439e8$var$EXIT_REASON_ITERATION_LIMIT = 'Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)';
const $154ff96df91439e8$var$ITERATION_LIMIT = 15000;
function $154ff96df91439e8$var$reverseList(list) {
    let prev = null;
    let next = null;
    let item = list;
    while(item !== null){
        next = item.prev;
        item.prev = prev;
        prev = item;
        item = next;
    }
    return prev;
}
function $154ff96df91439e8$var$areStringsEqualCaseInsensitive(testStr, referenceStr) {
    if (testStr.length !== referenceStr.length) return false;
    for(let i = 0; i < testStr.length; i++){
        const referenceCode = referenceStr.charCodeAt(i);
        let testCode = testStr.charCodeAt(i);
        // testCode.toLowerCase() for U+0041 LATIN CAPITAL LETTER A (A) .. U+005A LATIN CAPITAL LETTER Z (Z).
        if (testCode >= 0x0041 && testCode <= 0x005A) testCode = testCode | 32;
        if (testCode !== referenceCode) return false;
    }
    return true;
}
function $154ff96df91439e8$var$isContextEdgeDelim(token) {
    if (token.type !== $iYo0F.Delim) return false;
    // Fix matching for unicode-range: U+30??, U+FF00-FF9F
    // Probably we need to check out previous match instead
    return token.value !== '?';
}
function $154ff96df91439e8$var$isCommaContextStart(token) {
    if (token === null) return true;
    return token.type === $iYo0F.Comma || token.type === $iYo0F.Function || token.type === $iYo0F.LeftParenthesis || token.type === $iYo0F.LeftSquareBracket || token.type === $iYo0F.LeftCurlyBracket || $154ff96df91439e8$var$isContextEdgeDelim(token);
}
function $154ff96df91439e8$var$isCommaContextEnd(token) {
    if (token === null) return true;
    return token.type === $iYo0F.RightParenthesis || token.type === $iYo0F.RightSquareBracket || token.type === $iYo0F.RightCurlyBracket || token.type === $iYo0F.Delim && token.value === '/';
}
function $154ff96df91439e8$var$internalMatch(tokens, state, syntaxes) {
    function moveToNextToken() {
        do {
            tokenIndex++;
            token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
        }while (token !== null && (token.type === $iYo0F.WhiteSpace || token.type === $iYo0F.Comment));
    }
    function getNextToken(offset) {
        const nextIndex = tokenIndex + offset;
        return nextIndex < tokens.length ? tokens[nextIndex] : null;
    }
    function stateSnapshotFromSyntax(nextState, prev) {
        return {
            nextState: nextState,
            matchStack: matchStack,
            syntaxStack: syntaxStack,
            thenStack: thenStack,
            tokenIndex: tokenIndex,
            prev: prev
        };
    }
    function pushThenStack(nextState) {
        thenStack = {
            nextState: nextState,
            matchStack: matchStack,
            syntaxStack: syntaxStack,
            prev: thenStack
        };
    }
    function pushElseStack(nextState) {
        elseStack = stateSnapshotFromSyntax(nextState, elseStack);
    }
    function addTokenToMatch() {
        matchStack = {
            type: $154ff96df91439e8$var$TOKEN,
            syntax: state.syntax,
            token: token,
            prev: matchStack
        };
        moveToNextToken();
        syntaxStash = null;
        if (tokenIndex > longestMatch) longestMatch = tokenIndex;
    }
    function openSyntax() {
        syntaxStack = {
            syntax: state.syntax,
            opts: state.syntax.opts || syntaxStack !== null && syntaxStack.opts || null,
            prev: syntaxStack
        };
        matchStack = {
            type: $154ff96df91439e8$var$OPEN_SYNTAX,
            syntax: state.syntax,
            token: matchStack.token,
            prev: matchStack
        };
    }
    function closeSyntax() {
        if (matchStack.type === $154ff96df91439e8$var$OPEN_SYNTAX) matchStack = matchStack.prev;
        else matchStack = {
            type: $154ff96df91439e8$var$CLOSE_SYNTAX,
            syntax: syntaxStack.syntax,
            token: matchStack.token,
            prev: matchStack
        };
        syntaxStack = syntaxStack.prev;
    }
    let syntaxStack = null;
    let thenStack = null;
    let elseStack = null;
    // null – stashing allowed, nothing stashed
    // false – stashing disabled, nothing stashed
    // anithing else – fail stashable syntaxes, some syntax stashed
    let syntaxStash = null;
    let iterationCount = 0; // count iterations and prevent infinite loop
    let exitReason = null;
    let token = null;
    let tokenIndex = -1;
    let longestMatch = 0;
    let matchStack = {
        type: $154ff96df91439e8$var$STUB,
        syntax: null,
        token: null,
        prev: null
    };
    moveToNextToken();
    while(exitReason === null && ++iterationCount < $154ff96df91439e8$var$ITERATION_LIMIT)// function mapList(list, fn) {
    //     const result = [];
    //     while (list) {
    //         result.unshift(fn(list));
    //         list = list.prev;
    //     }
    //     return result;
    // }
    // console.log('--\n',
    //     '#' + iterationCount,
    //     require('util').inspect({
    //         match: mapList(matchStack, x => x.type === TOKEN ? x.token && x.token.value : x.syntax ? ({ [OPEN_SYNTAX]: '<', [CLOSE_SYNTAX]: '</' }[x.type] || x.type) + '!' + x.syntax.name : null),
    //         token: token && token.value,
    //         tokenIndex,
    //         syntax: syntax.type + (syntax.id ? ' #' + syntax.id : '')
    //     }, { depth: null })
    // );
    switch(state.type){
        case 'Match':
            if (thenStack === null) {
                // turn to MISMATCH when some tokens left unmatched
                if (token !== null) // doesn't mismatch if just one token left and it's an IE hack
                {
                    if (tokenIndex !== tokens.length - 1 || token.value !== '\\0' && token.value !== '\\9') {
                        state = $ejayB.MISMATCH;
                        break;
                    }
                }
                // break the main loop, return a result - MATCH
                exitReason = $154ff96df91439e8$var$EXIT_REASON_MATCH;
                break;
            }
            // go to next syntax (`then` branch)
            state = thenStack.nextState;
            // check match is not empty
            if (state === $ejayB.DISALLOW_EMPTY) {
                if (thenStack.matchStack === matchStack) {
                    state = $ejayB.MISMATCH;
                    break;
                } else state = $ejayB.MATCH;
            }
            // close syntax if needed
            while(thenStack.syntaxStack !== syntaxStack)closeSyntax();
            // pop stack
            thenStack = thenStack.prev;
            break;
        case 'Mismatch':
            // when some syntax is stashed
            if (syntaxStash !== null && syntaxStash !== false) // there is no else branches or a branch reduce match stack
            {
                if (elseStack === null || tokenIndex > elseStack.tokenIndex) {
                    // restore state from the stash
                    elseStack = syntaxStash;
                    syntaxStash = false; // disable stashing
                }
            } else if (elseStack === null) {
                // no else branches -> break the main loop
                // return a result - MISMATCH
                exitReason = $154ff96df91439e8$var$EXIT_REASON_MISMATCH;
                break;
            }
            // go to next syntax (`else` branch)
            state = elseStack.nextState;
            // restore all the rest stack states
            thenStack = elseStack.thenStack;
            syntaxStack = elseStack.syntaxStack;
            matchStack = elseStack.matchStack;
            tokenIndex = elseStack.tokenIndex;
            token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
            // pop stack
            elseStack = elseStack.prev;
            break;
        case 'MatchGraph':
            state = state.match;
            break;
        case 'If':
            // IMPORTANT: else stack push must go first,
            // since it stores the state of thenStack before changes
            if (state.else !== $ejayB.MISMATCH) pushElseStack(state.else);
            if (state.then !== $ejayB.MATCH) pushThenStack(state.then);
            state = state.match;
            break;
        case 'MatchOnce':
            state = {
                type: 'MatchOnceBuffer',
                syntax: state,
                index: 0,
                mask: 0
            };
            break;
        case 'MatchOnceBuffer':
            {
                const terms = state.syntax.terms;
                if (state.index === terms.length) {
                    // no matches at all or it's required all terms to be matched
                    if (state.mask === 0 || state.syntax.all) {
                        state = $ejayB.MISMATCH;
                        break;
                    }
                    // a partial match is ok
                    state = $ejayB.MATCH;
                    break;
                }
                // all terms are matched
                if (state.mask === (1 << terms.length) - 1) {
                    state = $ejayB.MATCH;
                    break;
                }
                for(; state.index < terms.length; state.index++){
                    const matchFlag = 1 << state.index;
                    if ((state.mask & matchFlag) === 0) {
                        // IMPORTANT: else stack push must go first,
                        // since it stores the state of thenStack before changes
                        pushElseStack(state);
                        pushThenStack({
                            type: 'AddMatchOnce',
                            syntax: state.syntax,
                            mask: state.mask | matchFlag
                        });
                        // match
                        state = terms[state.index++];
                        break;
                    }
                }
                break;
            }
        case 'AddMatchOnce':
            state = {
                type: 'MatchOnceBuffer',
                syntax: state.syntax,
                index: 0,
                mask: state.mask
            };
            break;
        case 'Enum':
            if (token !== null) {
                let name = token.value.toLowerCase();
                // drop \0 and \9 hack from keyword name
                if (name.indexOf('\\') !== -1) name = name.replace(/\\[09].*$/, '');
                if ($154ff96df91439e8$var$hasOwnProperty.call(state.map, name)) {
                    state = state.map[name];
                    break;
                }
            }
            state = $ejayB.MISMATCH;
            break;
        case 'Generic':
            {
                const opts = syntaxStack !== null ? syntaxStack.opts : null;
                const lastTokenIndex = tokenIndex + Math.floor(state.fn(token, getNextToken, opts));
                if (!isNaN(lastTokenIndex) && lastTokenIndex > tokenIndex) {
                    while(tokenIndex < lastTokenIndex)addTokenToMatch();
                    state = $ejayB.MATCH;
                } else state = $ejayB.MISMATCH;
                break;
            }
        case 'Type':
        case 'Property':
            {
                const syntaxDict = state.type === 'Type' ? 'types' : 'properties';
                const dictSyntax = $154ff96df91439e8$var$hasOwnProperty.call(syntaxes, syntaxDict) ? syntaxes[syntaxDict][state.name] : null;
                if (!dictSyntax || !dictSyntax.match) throw new Error('Bad syntax reference: ' + (state.type === 'Type' ? '<' + state.name + '>' : '<\'' + state.name + '\'>'));
                // stash a syntax for types with low priority
                if (syntaxStash !== false && token !== null && state.type === 'Type') {
                    const lowPriorityMatching = // https://drafts.csswg.org/css-values-4/#custom-idents
                    // When parsing positionally-ambiguous keywords in a property value, a <custom-ident> production
                    // can only claim the keyword if no other unfulfilled production can claim it.
                    state.name === 'custom-ident' && token.type === $iYo0F.Ident || // https://drafts.csswg.org/css-values-4/#lengths
                    // ... if a `0` could be parsed as either a <number> or a <length> in a property (such as line-height),
                    // it must parse as a <number>
                    state.name === 'length' && token.value === '0';
                    if (lowPriorityMatching) {
                        if (syntaxStash === null) syntaxStash = stateSnapshotFromSyntax(state, elseStack);
                        state = $ejayB.MISMATCH;
                        break;
                    }
                }
                openSyntax();
                state = dictSyntax.match;
                break;
            }
        case 'Keyword':
            {
                const name = state.name;
                if (token !== null) {
                    let keywordName = token.value;
                    // drop \0 and \9 hack from keyword name
                    if (keywordName.indexOf('\\') !== -1) keywordName = keywordName.replace(/\\[09].*$/, '');
                    if ($154ff96df91439e8$var$areStringsEqualCaseInsensitive(keywordName, name)) {
                        addTokenToMatch();
                        state = $ejayB.MATCH;
                        break;
                    }
                }
                state = $ejayB.MISMATCH;
                break;
            }
        case 'AtKeyword':
        case 'Function':
            if (token !== null && $154ff96df91439e8$var$areStringsEqualCaseInsensitive(token.value, state.name)) {
                addTokenToMatch();
                state = $ejayB.MATCH;
                break;
            }
            state = $ejayB.MISMATCH;
            break;
        case 'Token':
            if (token !== null && token.value === state.value) {
                addTokenToMatch();
                state = $ejayB.MATCH;
                break;
            }
            state = $ejayB.MISMATCH;
            break;
        case 'Comma':
            if (token !== null && token.type === $iYo0F.Comma) {
                if ($154ff96df91439e8$var$isCommaContextStart(matchStack.token)) state = $ejayB.MISMATCH;
                else {
                    addTokenToMatch();
                    state = $154ff96df91439e8$var$isCommaContextEnd(token) ? $ejayB.MISMATCH : $ejayB.MATCH;
                }
            } else state = $154ff96df91439e8$var$isCommaContextStart(matchStack.token) || $154ff96df91439e8$var$isCommaContextEnd(token) ? $ejayB.MATCH : $ejayB.MISMATCH;
            break;
        case 'String':
            let string = '';
            let lastTokenIndex = tokenIndex;
            for(; lastTokenIndex < tokens.length && string.length < state.value.length; lastTokenIndex++)string += tokens[lastTokenIndex].value;
            if ($154ff96df91439e8$var$areStringsEqualCaseInsensitive(string, state.value)) {
                while(tokenIndex < lastTokenIndex)addTokenToMatch();
                state = $ejayB.MATCH;
            } else state = $ejayB.MISMATCH;
            break;
        default:
            throw new Error('Unknown node type: ' + state.type);
    }
    switch(exitReason){
        case null:
            console.warn('[csstree-match] BREAK after ' + $154ff96df91439e8$var$ITERATION_LIMIT + ' iterations');
            exitReason = $154ff96df91439e8$var$EXIT_REASON_ITERATION_LIMIT;
            matchStack = null;
            break;
        case $154ff96df91439e8$var$EXIT_REASON_MATCH:
            while(syntaxStack !== null)closeSyntax();
            break;
        default:
            matchStack = null;
    }
    return {
        tokens: tokens,
        reason: exitReason,
        iterations: iterationCount,
        match: matchStack,
        longestMatch: longestMatch
    };
}
function $154ff96df91439e8$var$matchAsList(tokens, matchGraph, syntaxes) {
    const matchResult = $154ff96df91439e8$var$internalMatch(tokens, matchGraph, syntaxes || {});
    if (matchResult.match !== null) {
        let item = $154ff96df91439e8$var$reverseList(matchResult.match).prev;
        matchResult.match = [];
        while(item !== null){
            switch(item.type){
                case $154ff96df91439e8$var$OPEN_SYNTAX:
                case $154ff96df91439e8$var$CLOSE_SYNTAX:
                    matchResult.match.push({
                        type: item.type,
                        syntax: item.syntax
                    });
                    break;
                default:
                    matchResult.match.push({
                        token: item.token.value,
                        node: item.token.node
                    });
                    break;
            }
            item = item.prev;
        }
    }
    return matchResult;
}
function $154ff96df91439e8$var$matchAsTree(tokens, matchGraph, syntaxes) {
    const matchResult = $154ff96df91439e8$var$internalMatch(tokens, matchGraph, syntaxes || {});
    if (matchResult.match === null) return matchResult;
    let item = matchResult.match;
    let host = matchResult.match = {
        syntax: matchGraph.syntax || null,
        match: []
    };
    const hostStack = [
        host
    ];
    // revert a list and start with 2nd item since 1st is a stub item
    item = $154ff96df91439e8$var$reverseList(item).prev;
    // build a tree
    while(item !== null){
        switch(item.type){
            case $154ff96df91439e8$var$OPEN_SYNTAX:
                host.match.push(host = {
                    syntax: item.syntax,
                    match: []
                });
                hostStack.push(host);
                break;
            case $154ff96df91439e8$var$CLOSE_SYNTAX:
                hostStack.pop();
                host = hostStack[hostStack.length - 1];
                break;
            default:
                host.match.push({
                    syntax: item.syntax || null,
                    token: item.token.value,
                    node: item.token.node
                });
        }
        item = item.prev;
    }
    return matchResult;
}
$154ff96df91439e8$export$b15baef7e00e9fac = $154ff96df91439e8$var$matchAsList;
$154ff96df91439e8$export$575ec9525823c563 = $154ff96df91439e8$var$matchAsTree;

});

parcelRegister("7ttZl", function(module, exports) {

$parcel$export(module.exports, "getTrace", () => $571280e5c7d8a5d0$export$4f813bbe73196350, (v) => $571280e5c7d8a5d0$export$4f813bbe73196350 = v);
$parcel$export(module.exports, "isKeyword", () => $571280e5c7d8a5d0$export$384ccb3991bcb643, (v) => $571280e5c7d8a5d0$export$384ccb3991bcb643 = v);
$parcel$export(module.exports, "isProperty", () => $571280e5c7d8a5d0$export$dc0811f98246bcff, (v) => $571280e5c7d8a5d0$export$dc0811f98246bcff = v);
$parcel$export(module.exports, "isType", () => $571280e5c7d8a5d0$export$26b9f946b448f23e, (v) => $571280e5c7d8a5d0$export$26b9f946b448f23e = v);
var $571280e5c7d8a5d0$export$4f813bbe73196350;
var $571280e5c7d8a5d0$export$384ccb3991bcb643;
var $571280e5c7d8a5d0$export$dc0811f98246bcff;
var $571280e5c7d8a5d0$export$26b9f946b448f23e;
'use strict';
function $571280e5c7d8a5d0$var$getTrace(node) {
    function shouldPutToTrace(syntax) {
        if (syntax === null) return false;
        return syntax.type === 'Type' || syntax.type === 'Property' || syntax.type === 'Keyword';
    }
    function hasMatch(matchNode) {
        if (Array.isArray(matchNode.match)) {
            // use for-loop for better perfomance
            for(let i = 0; i < matchNode.match.length; i++)if (hasMatch(matchNode.match[i])) {
                if (shouldPutToTrace(matchNode.syntax)) result.unshift(matchNode.syntax);
                return true;
            }
        } else if (matchNode.node === node) {
            result = shouldPutToTrace(matchNode.syntax) ? [
                matchNode.syntax
            ] : [];
            return true;
        }
        return false;
    }
    let result = null;
    if (this.matched !== null) hasMatch(this.matched);
    return result;
}
function $571280e5c7d8a5d0$var$isType(node, type) {
    return $571280e5c7d8a5d0$var$testNode(this, node, (match)=>match.type === 'Type' && match.name === type);
}
function $571280e5c7d8a5d0$var$isProperty(node, property) {
    return $571280e5c7d8a5d0$var$testNode(this, node, (match)=>match.type === 'Property' && match.name === property);
}
function $571280e5c7d8a5d0$var$isKeyword(node) {
    return $571280e5c7d8a5d0$var$testNode(this, node, (match)=>match.type === 'Keyword');
}
function $571280e5c7d8a5d0$var$testNode(match, node, fn) {
    const trace = $571280e5c7d8a5d0$var$getTrace.call(match, node);
    if (trace === null) return false;
    return trace.some(fn);
}
$571280e5c7d8a5d0$export$4f813bbe73196350 = $571280e5c7d8a5d0$var$getTrace;
$571280e5c7d8a5d0$export$384ccb3991bcb643 = $571280e5c7d8a5d0$var$isKeyword;
$571280e5c7d8a5d0$export$dc0811f98246bcff = $571280e5c7d8a5d0$var$isProperty;
$571280e5c7d8a5d0$export$26b9f946b448f23e = $571280e5c7d8a5d0$var$isType;

});

parcelRegister("ka2do", function(module, exports) {

$parcel$export(module.exports, "matchFragments", () => $ead675a861c6d918$export$2c0817d7096f698, (v) => $ead675a861c6d918$export$2c0817d7096f698 = v);
var $ead675a861c6d918$export$2c0817d7096f698;
'use strict';

var $72kB1 = parcelRequire("72kB1");
function $ead675a861c6d918$var$getFirstMatchNode(matchNode) {
    if ('node' in matchNode) return matchNode.node;
    return $ead675a861c6d918$var$getFirstMatchNode(matchNode.match[0]);
}
function $ead675a861c6d918$var$getLastMatchNode(matchNode) {
    if ('node' in matchNode) return matchNode.node;
    return $ead675a861c6d918$var$getLastMatchNode(matchNode.match[matchNode.match.length - 1]);
}
function $ead675a861c6d918$var$matchFragments(lexer, ast, match, type, name) {
    function findFragments(matchNode) {
        if (matchNode.syntax !== null && matchNode.syntax.type === type && matchNode.syntax.name === name) {
            const start = $ead675a861c6d918$var$getFirstMatchNode(matchNode);
            const end = $ead675a861c6d918$var$getLastMatchNode(matchNode);
            lexer.syntax.walk(ast, function(node, item, list) {
                if (node === start) {
                    const nodes = new $72kB1.List();
                    do {
                        nodes.appendData(item.data);
                        if (item.data === end) break;
                        item = item.next;
                    }while (item !== null);
                    fragments.push({
                        parent: list,
                        nodes: nodes
                    });
                }
            });
        }
        if (Array.isArray(matchNode.match)) matchNode.match.forEach(findFragments);
    }
    const fragments = [];
    if (match.matched !== null) findFragments(match.matched);
    return fragments;
}
$ead675a861c6d918$export$2c0817d7096f698 = $ead675a861c6d918$var$matchFragments;

});

parcelRegister("7mF6V", function(module, exports) {

$parcel$export(module.exports, "getStructureFromConfig", () => $55ca7a33fdf498de$export$2e9edb38e02d3c76, (v) => $55ca7a33fdf498de$export$2e9edb38e02d3c76 = v);
var $55ca7a33fdf498de$export$2e9edb38e02d3c76;
'use strict';

var $72kB1 = parcelRequire("72kB1");
const { hasOwnProperty: $55ca7a33fdf498de$var$hasOwnProperty } = Object.prototype;
function $55ca7a33fdf498de$var$isValidNumber(value) {
    // Number.isInteger(value) && value >= 0
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value && value >= 0;
}
function $55ca7a33fdf498de$var$isValidLocation(loc) {
    return Boolean(loc) && $55ca7a33fdf498de$var$isValidNumber(loc.offset) && $55ca7a33fdf498de$var$isValidNumber(loc.line) && $55ca7a33fdf498de$var$isValidNumber(loc.column);
}
function $55ca7a33fdf498de$var$createNodeStructureChecker(type, fields) {
    return function checkNode(node, warn) {
        if (!node || node.constructor !== Object) return warn(node, 'Type of node should be an Object');
        for(let key in node){
            let valid = true;
            if ($55ca7a33fdf498de$var$hasOwnProperty.call(node, key) === false) continue;
            if (key === 'type') {
                if (node.type !== type) warn(node, 'Wrong node type `' + node.type + '`, expected `' + type + '`');
            } else if (key === 'loc') {
                if (node.loc === null) continue;
                else if (node.loc && node.loc.constructor === Object) {
                    if (typeof node.loc.source !== 'string') key += '.source';
                    else if (!$55ca7a33fdf498de$var$isValidLocation(node.loc.start)) key += '.start';
                    else if (!$55ca7a33fdf498de$var$isValidLocation(node.loc.end)) key += '.end';
                    else continue;
                }
                valid = false;
            } else if (fields.hasOwnProperty(key)) {
                valid = false;
                for(let i = 0; !valid && i < fields[key].length; i++){
                    const fieldType = fields[key][i];
                    switch(fieldType){
                        case String:
                            valid = typeof node[key] === 'string';
                            break;
                        case Boolean:
                            valid = typeof node[key] === 'boolean';
                            break;
                        case null:
                            valid = node[key] === null;
                            break;
                        default:
                            if (typeof fieldType === 'string') valid = node[key] && node[key].type === fieldType;
                            else if (Array.isArray(fieldType)) valid = node[key] instanceof $72kB1.List;
                    }
                }
            } else warn(node, 'Unknown field `' + key + '` for ' + type + ' node type');
            if (!valid) warn(node, 'Bad value for `' + type + '.' + key + '`');
        }
        for(const key in fields)if ($55ca7a33fdf498de$var$hasOwnProperty.call(fields, key) && $55ca7a33fdf498de$var$hasOwnProperty.call(node, key) === false) warn(node, 'Field `' + type + '.' + key + '` is missed');
    };
}
function $55ca7a33fdf498de$var$processStructure(name, nodeType) {
    const structure = nodeType.structure;
    const fields = {
        type: String,
        loc: true
    };
    const docs = {
        type: '"' + name + '"'
    };
    for(const key in structure){
        if ($55ca7a33fdf498de$var$hasOwnProperty.call(structure, key) === false) continue;
        const docsTypes = [];
        const fieldTypes = fields[key] = Array.isArray(structure[key]) ? structure[key].slice() : [
            structure[key]
        ];
        for(let i = 0; i < fieldTypes.length; i++){
            const fieldType = fieldTypes[i];
            if (fieldType === String || fieldType === Boolean) docsTypes.push(fieldType.name);
            else if (fieldType === null) docsTypes.push('null');
            else if (typeof fieldType === 'string') docsTypes.push('<' + fieldType + '>');
            else if (Array.isArray(fieldType)) docsTypes.push('List'); // TODO: use type enum
            else throw new Error('Wrong value `' + fieldType + '` in `' + name + '.' + key + '` structure definition');
        }
        docs[key] = docsTypes.join(' | ');
    }
    return {
        docs: docs,
        check: $55ca7a33fdf498de$var$createNodeStructureChecker(name, fields)
    };
}
function $55ca7a33fdf498de$var$getStructureFromConfig(config) {
    const structure = {};
    if (config.node) {
        for(const name in config.node)if ($55ca7a33fdf498de$var$hasOwnProperty.call(config.node, name)) {
            const nodeType = config.node[name];
            if (nodeType.structure) structure[name] = $55ca7a33fdf498de$var$processStructure(name, nodeType);
            else throw new Error('Missed `structure` field in `' + name + '` node type definition');
        }
    }
    return structure;
}
$55ca7a33fdf498de$export$2e9edb38e02d3c76 = $55ca7a33fdf498de$var$getStructureFromConfig;

});

parcelRegister("cSjEF", function(module, exports) {

$parcel$export(module.exports, "walk", () => $95f9c643f11b6fe8$export$588732934346abbf, (v) => $95f9c643f11b6fe8$export$588732934346abbf = v);
var $95f9c643f11b6fe8$export$588732934346abbf;
'use strict';
const $95f9c643f11b6fe8$var$noop = function() {};
function $95f9c643f11b6fe8$var$ensureFunction(value) {
    return typeof value === 'function' ? value : $95f9c643f11b6fe8$var$noop;
}
function $95f9c643f11b6fe8$var$walk(node, options, context) {
    function walk(node) {
        enter.call(context, node);
        switch(node.type){
            case 'Group':
                node.terms.forEach(walk);
                break;
            case 'Multiplier':
                walk(node.term);
                break;
            case 'Type':
            case 'Property':
            case 'Keyword':
            case 'AtKeyword':
            case 'Function':
            case 'String':
            case 'Token':
            case 'Comma':
                break;
            default:
                throw new Error('Unknown type: ' + node.type);
        }
        leave.call(context, node);
    }
    let enter = $95f9c643f11b6fe8$var$noop;
    let leave = $95f9c643f11b6fe8$var$noop;
    if (typeof options === 'function') enter = options;
    else if (options) {
        enter = $95f9c643f11b6fe8$var$ensureFunction(options.enter);
        leave = $95f9c643f11b6fe8$var$ensureFunction(options.leave);
    }
    if (enter === $95f9c643f11b6fe8$var$noop && leave === $95f9c643f11b6fe8$var$noop) throw new Error('Neither `enter` nor `leave` walker handler is set or both aren\'t a function');
    walk(node);
}
$95f9c643f11b6fe8$export$588732934346abbf = $95f9c643f11b6fe8$var$walk;

});


parcelRegister("RnRNw", function(module, exports) {
'use strict';
const { hasOwnProperty: $0a0776c859a41562$var$hasOwnProperty } = Object.prototype;
const $0a0776c859a41562$var$shape = {
    generic: true,
    types: $0a0776c859a41562$var$appendOrAssign,
    atrules: {
        prelude: $0a0776c859a41562$var$appendOrAssignOrNull,
        descriptors: $0a0776c859a41562$var$appendOrAssignOrNull
    },
    properties: $0a0776c859a41562$var$appendOrAssign,
    parseContext: $0a0776c859a41562$var$assign,
    scope: $0a0776c859a41562$var$deepAssign,
    atrule: [
        'parse'
    ],
    pseudo: [
        'parse'
    ],
    node: [
        'name',
        'structure',
        'parse',
        'generate',
        'walkContext'
    ]
};
function $0a0776c859a41562$var$isObject(value) {
    return value && value.constructor === Object;
}
function $0a0776c859a41562$var$copy(value) {
    return $0a0776c859a41562$var$isObject(value) ? {
        ...value
    } : value;
}
function $0a0776c859a41562$var$assign(dest, src) {
    return Object.assign(dest, src);
}
function $0a0776c859a41562$var$deepAssign(dest, src) {
    for(const key in src)if ($0a0776c859a41562$var$hasOwnProperty.call(src, key)) {
        if ($0a0776c859a41562$var$isObject(dest[key])) $0a0776c859a41562$var$deepAssign(dest[key], src[key]);
        else dest[key] = $0a0776c859a41562$var$copy(src[key]);
    }
    return dest;
}
function $0a0776c859a41562$var$append(a, b) {
    if (typeof b === 'string' && /^\s*\|/.test(b)) return typeof a === 'string' ? a + b : b.replace(/^\s*\|\s*/, '');
    return b || null;
}
function $0a0776c859a41562$var$appendOrAssign(a, b) {
    if (typeof b === 'string') return $0a0776c859a41562$var$append(a, b);
    const result = {
        ...a
    };
    for(let key in b)if ($0a0776c859a41562$var$hasOwnProperty.call(b, key)) result[key] = $0a0776c859a41562$var$append($0a0776c859a41562$var$hasOwnProperty.call(a, key) ? a[key] : undefined, b[key]);
    return result;
}
function $0a0776c859a41562$var$appendOrAssignOrNull(a, b) {
    const result = $0a0776c859a41562$var$appendOrAssign(a, b);
    return !$0a0776c859a41562$var$isObject(result) || Object.keys(result).length ? result : null;
}
function $0a0776c859a41562$var$mix(dest, src, shape) {
    for(const key in shape){
        if ($0a0776c859a41562$var$hasOwnProperty.call(shape, key) === false) continue;
        if (shape[key] === true) {
            if ($0a0776c859a41562$var$hasOwnProperty.call(src, key)) dest[key] = $0a0776c859a41562$var$copy(src[key]);
        } else if (shape[key]) {
            if (typeof shape[key] === 'function') {
                const fn = shape[key];
                dest[key] = fn({}, dest[key]);
                dest[key] = fn(dest[key] || {}, src[key]);
            } else if ($0a0776c859a41562$var$isObject(shape[key])) {
                const result = {};
                for(let name in dest[key])result[name] = $0a0776c859a41562$var$mix({}, dest[key][name], shape[key]);
                for(let name in src[key])result[name] = $0a0776c859a41562$var$mix(result[name] || {}, src[key][name], shape[key]);
                dest[key] = result;
            } else if (Array.isArray(shape[key])) {
                const res = {};
                const innerShape = shape[key].reduce(function(s, k) {
                    s[k] = true;
                    return s;
                }, {});
                for (const [name, value] of Object.entries(dest[key] || {})){
                    res[name] = {};
                    if (value) $0a0776c859a41562$var$mix(res[name], value, innerShape);
                }
                for(const name in src[key])if ($0a0776c859a41562$var$hasOwnProperty.call(src[key], name)) {
                    if (!res[name]) res[name] = {};
                    if (src[key] && src[key][name]) $0a0776c859a41562$var$mix(res[name], src[key][name], innerShape);
                }
                dest[key] = res;
            }
        }
    }
    return dest;
}
const $0a0776c859a41562$var$mix$1 = (dest, src)=>$0a0776c859a41562$var$mix(dest, src, $0a0776c859a41562$var$shape);
module.exports = $0a0776c859a41562$var$mix$1;

});


parcelRegister("cxuR7", function(module, exports) {
'use strict';

var $gzx9d = parcelRequire("gzx9d");

var $1jT8b = parcelRequire("1jT8b");
const $9210806cfcdce8d1$var$lexerConfig = {
    generic: true,
    ...$gzx9d,
    node: $1jT8b
};
module.exports = $9210806cfcdce8d1$var$lexerConfig;

});
parcelRegister("gzx9d", function(module, exports) {
module.exports = {
    "generic": true,
    "types": {
        "absolute-size": "xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large",
        "alpha-value": "<number>|<percentage>",
        "angle-percentage": "<angle>|<percentage>",
        "angular-color-hint": "<angle-percentage>",
        "angular-color-stop": "<color>&&<color-stop-angle>?",
        "angular-color-stop-list": "[<angular-color-stop> [, <angular-color-hint>]?]# , <angular-color-stop>",
        "animateable-feature": "scroll-position|contents|<custom-ident>",
        "attachment": "scroll|fixed|local",
        "attr()": "attr( <attr-name> <type-or-unit>? [, <attr-fallback>]? )",
        "attr-matcher": "['~'|'|'|'^'|'$'|'*']? '='",
        "attr-modifier": "i|s",
        "attribute-selector": "'[' <wq-name> ']'|'[' <wq-name> <attr-matcher> [<string-token>|<ident-token>] <attr-modifier>? ']'",
        "auto-repeat": "repeat( [auto-fill|auto-fit] , [<line-names>? <fixed-size>]+ <line-names>? )",
        "auto-track-list": "[<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>? <auto-repeat> [<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>?",
        "baseline-position": "[first|last]? baseline",
        "basic-shape": "<inset()>|<circle()>|<ellipse()>|<polygon()>|<path()>",
        "bg-image": "none|<image>",
        "bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
        "bg-position": "[[left|center|right|top|bottom|<length-percentage>]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]|[center|[left|right] <length-percentage>?]&&[center|[top|bottom] <length-percentage>?]]",
        "bg-size": "[<length-percentage>|auto]{1,2}|cover|contain",
        "blur()": "blur( <length> )",
        "blend-mode": "normal|multiply|screen|overlay|darken|lighten|color-dodge|color-burn|hard-light|soft-light|difference|exclusion|hue|saturation|color|luminosity",
        "box": "border-box|padding-box|content-box",
        "brightness()": "brightness( <number-percentage> )",
        "calc()": "calc( <calc-sum> )",
        "calc-sum": "<calc-product> [['+'|'-'] <calc-product>]*",
        "calc-product": "<calc-value> ['*' <calc-value>|'/' <number>]*",
        "calc-value": "<number>|<dimension>|<percentage>|( <calc-sum> )",
        "cf-final-image": "<image>|<color>",
        "cf-mixing-image": "<percentage>?&&<image>",
        "circle()": "circle( [<shape-radius>]? [at <position>]? )",
        "clamp()": "clamp( <calc-sum>#{3} )",
        "class-selector": "'.' <ident-token>",
        "clip-source": "<url>",
        "color": "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<hex-color>|<named-color>|currentcolor|<deprecated-system-color>",
        "color-stop": "<color-stop-length>|<color-stop-angle>",
        "color-stop-angle": "<angle-percentage>{1,2}",
        "color-stop-length": "<length-percentage>{1,2}",
        "color-stop-list": "[<linear-color-stop> [, <linear-color-hint>]?]# , <linear-color-stop>",
        "combinator": "'>'|'+'|'~'|['||']",
        "common-lig-values": "[common-ligatures|no-common-ligatures]",
        "compat-auto": "searchfield|textarea|push-button|slider-horizontal|checkbox|radio|square-button|menulist|listbox|meter|progress-bar|button",
        "composite-style": "clear|copy|source-over|source-in|source-out|source-atop|destination-over|destination-in|destination-out|destination-atop|xor",
        "compositing-operator": "add|subtract|intersect|exclude",
        "compound-selector": "[<type-selector>? <subclass-selector>* [<pseudo-element-selector> <pseudo-class-selector>*]*]!",
        "compound-selector-list": "<compound-selector>#",
        "complex-selector": "<compound-selector> [<combinator>? <compound-selector>]*",
        "complex-selector-list": "<complex-selector>#",
        "conic-gradient()": "conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
        "contextual-alt-values": "[contextual|no-contextual]",
        "content-distribution": "space-between|space-around|space-evenly|stretch",
        "content-list": "[<string>|contents|<image>|<counter>|<quote>|<target>|<leader()>|<attr()>]+",
        "content-position": "center|start|end|flex-start|flex-end",
        "content-replacement": "<image>",
        "contrast()": "contrast( [<number-percentage>] )",
        "counter": "<counter()>|<counters()>",
        "counter()": "counter( <counter-name> , <counter-style>? )",
        "counter-name": "<custom-ident>",
        "counter-style": "<counter-style-name>|symbols( )",
        "counter-style-name": "<custom-ident>",
        "counters()": "counters( <counter-name> , <string> , <counter-style>? )",
        "cross-fade()": "cross-fade( <cf-mixing-image> , <cf-final-image>? )",
        "cubic-bezier-timing-function": "ease|ease-in|ease-out|ease-in-out|cubic-bezier( <number [0,1]> , <number> , <number [0,1]> , <number> )",
        "deprecated-system-color": "ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonFace|ButtonHighlight|ButtonShadow|ButtonText|CaptionText|GrayText|Highlight|HighlightText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText",
        "discretionary-lig-values": "[discretionary-ligatures|no-discretionary-ligatures]",
        "display-box": "contents|none",
        "display-inside": "flow|flow-root|table|flex|grid|ruby",
        "display-internal": "table-row-group|table-header-group|table-footer-group|table-row|table-cell|table-column-group|table-column|table-caption|ruby-base|ruby-text|ruby-base-container|ruby-text-container",
        "display-legacy": "inline-block|inline-list-item|inline-table|inline-flex|inline-grid",
        "display-listitem": "<display-outside>?&&[flow|flow-root]?&&list-item",
        "display-outside": "block|inline|run-in",
        "drop-shadow()": "drop-shadow( <length>{2,3} <color>? )",
        "east-asian-variant-values": "[jis78|jis83|jis90|jis04|simplified|traditional]",
        "east-asian-width-values": "[full-width|proportional-width]",
        "element()": "element( <custom-ident> , [first|start|last|first-except]? )|element( <id-selector> )",
        "ellipse()": "ellipse( [<shape-radius>{2}]? [at <position>]? )",
        "ending-shape": "circle|ellipse",
        "env()": "env( <custom-ident> , <declaration-value>? )",
        "explicit-track-list": "[<line-names>? <track-size>]+ <line-names>?",
        "family-name": "<string>|<custom-ident>+",
        "feature-tag-value": "<string> [<integer>|on|off]?",
        "feature-type": "@stylistic|@historical-forms|@styleset|@character-variant|@swash|@ornaments|@annotation",
        "feature-value-block": "<feature-type> '{' <feature-value-declaration-list> '}'",
        "feature-value-block-list": "<feature-value-block>+",
        "feature-value-declaration": "<custom-ident> : <integer>+ ;",
        "feature-value-declaration-list": "<feature-value-declaration>",
        "feature-value-name": "<custom-ident>",
        "fill-rule": "nonzero|evenodd",
        "filter-function": "<blur()>|<brightness()>|<contrast()>|<drop-shadow()>|<grayscale()>|<hue-rotate()>|<invert()>|<opacity()>|<saturate()>|<sepia()>",
        "filter-function-list": "[<filter-function>|<url>]+",
        "final-bg-layer": "<'background-color'>||<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
        "fit-content()": "fit-content( [<length>|<percentage>] )",
        "fixed-breadth": "<length-percentage>",
        "fixed-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <fixed-size>]+ <line-names>? )",
        "fixed-size": "<fixed-breadth>|minmax( <fixed-breadth> , <track-breadth> )|minmax( <inflexible-breadth> , <fixed-breadth> )",
        "font-stretch-absolute": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded|<percentage>",
        "font-variant-css21": "[normal|small-caps]",
        "font-weight-absolute": "normal|bold|<number [1,1000]>",
        "frequency-percentage": "<frequency>|<percentage>",
        "general-enclosed": "[<function-token> <any-value> )]|( <ident> <any-value> )",
        "generic-family": "serif|sans-serif|cursive|fantasy|monospace|-apple-system",
        "generic-name": "serif|sans-serif|cursive|fantasy|monospace",
        "geometry-box": "<shape-box>|fill-box|stroke-box|view-box",
        "gradient": "<linear-gradient()>|<repeating-linear-gradient()>|<radial-gradient()>|<repeating-radial-gradient()>|<conic-gradient()>|<repeating-conic-gradient()>|<-legacy-gradient>",
        "grayscale()": "grayscale( <number-percentage> )",
        "grid-line": "auto|<custom-ident>|[<integer>&&<custom-ident>?]|[span&&[<integer>||<custom-ident>]]",
        "historical-lig-values": "[historical-ligatures|no-historical-ligatures]",
        "hsl()": "hsl( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsl( <hue> , <percentage> , <percentage> , <alpha-value>? )",
        "hsla()": "hsla( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsla( <hue> , <percentage> , <percentage> , <alpha-value>? )",
        "hue": "<number>|<angle>",
        "hue-rotate()": "hue-rotate( <angle> )",
        "hwb()": "hwb( [<hue>|none] [<percentage>|none] [<percentage>|none] [/ [<alpha-value>|none]]? )",
        "image": "<url>|<image()>|<image-set()>|<element()>|<paint()>|<cross-fade()>|<gradient>",
        "image()": "image( <image-tags>? [<image-src>? , <color>?]! )",
        "image-set()": "image-set( <image-set-option># )",
        "image-set-option": "[<image>|<string>] [<resolution>||type( <string> )]",
        "image-src": "<url>|<string>",
        "image-tags": "ltr|rtl",
        "inflexible-breadth": "<length>|<percentage>|min-content|max-content|auto",
        "inset()": "inset( <length-percentage>{1,4} [round <'border-radius'>]? )",
        "invert()": "invert( <number-percentage> )",
        "keyframes-name": "<custom-ident>|<string>",
        "keyframe-block": "<keyframe-selector># { <declaration-list> }",
        "keyframe-block-list": "<keyframe-block>+",
        "keyframe-selector": "from|to|<percentage>",
        "layer()": "layer( <layer-name> )",
        "layer-name": "<ident> ['.' <ident>]*",
        "leader()": "leader( <leader-type> )",
        "leader-type": "dotted|solid|space|<string>",
        "length-percentage": "<length>|<percentage>",
        "line-names": "'[' <custom-ident>* ']'",
        "line-name-list": "[<line-names>|<name-repeat>]+",
        "line-style": "none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset",
        "line-width": "<length>|thin|medium|thick",
        "linear-color-hint": "<length-percentage>",
        "linear-color-stop": "<color> <color-stop-length>?",
        "linear-gradient()": "linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
        "mask-layer": "<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||<geometry-box>||[<geometry-box>|no-clip]||<compositing-operator>||<masking-mode>",
        "mask-position": "[<length-percentage>|left|center|right] [<length-percentage>|top|center|bottom]?",
        "mask-reference": "none|<image>|<mask-source>",
        "mask-source": "<url>",
        "masking-mode": "alpha|luminance|match-source",
        "matrix()": "matrix( <number>#{6} )",
        "matrix3d()": "matrix3d( <number>#{16} )",
        "max()": "max( <calc-sum># )",
        "media-and": "<media-in-parens> [and <media-in-parens>]+",
        "media-condition": "<media-not>|<media-and>|<media-or>|<media-in-parens>",
        "media-condition-without-or": "<media-not>|<media-and>|<media-in-parens>",
        "media-feature": "( [<mf-plain>|<mf-boolean>|<mf-range>] )",
        "media-in-parens": "( <media-condition> )|<media-feature>|<general-enclosed>",
        "media-not": "not <media-in-parens>",
        "media-or": "<media-in-parens> [or <media-in-parens>]+",
        "media-query": "<media-condition>|[not|only]? <media-type> [and <media-condition-without-or>]?",
        "media-query-list": "<media-query>#",
        "media-type": "<ident>",
        "mf-boolean": "<mf-name>",
        "mf-name": "<ident>",
        "mf-plain": "<mf-name> : <mf-value>",
        "mf-range": "<mf-name> ['<'|'>']? '='? <mf-value>|<mf-value> ['<'|'>']? '='? <mf-name>|<mf-value> '<' '='? <mf-name> '<' '='? <mf-value>|<mf-value> '>' '='? <mf-name> '>' '='? <mf-value>",
        "mf-value": "<number>|<dimension>|<ident>|<ratio>",
        "min()": "min( <calc-sum># )",
        "minmax()": "minmax( [<length>|<percentage>|min-content|max-content|auto] , [<length>|<percentage>|<flex>|min-content|max-content|auto] )",
        "name-repeat": "repeat( [<integer [1,\u221E]>|auto-fill] , <line-names>+ )",
        "named-color": "transparent|aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen|<-non-standard-color>",
        "namespace-prefix": "<ident>",
        "ns-prefix": "[<ident-token>|'*']? '|'",
        "number-percentage": "<number>|<percentage>",
        "numeric-figure-values": "[lining-nums|oldstyle-nums]",
        "numeric-fraction-values": "[diagonal-fractions|stacked-fractions]",
        "numeric-spacing-values": "[proportional-nums|tabular-nums]",
        "nth": "<an-plus-b>|even|odd",
        "opacity()": "opacity( [<number-percentage>] )",
        "overflow-position": "unsafe|safe",
        "outline-radius": "<length>|<percentage>",
        "page-body": "<declaration>? [; <page-body>]?|<page-margin-box> <page-body>",
        "page-margin-box": "<page-margin-box-type> '{' <declaration-list> '}'",
        "page-margin-box-type": "@top-left-corner|@top-left|@top-center|@top-right|@top-right-corner|@bottom-left-corner|@bottom-left|@bottom-center|@bottom-right|@bottom-right-corner|@left-top|@left-middle|@left-bottom|@right-top|@right-middle|@right-bottom",
        "page-selector-list": "[<page-selector>#]?",
        "page-selector": "<pseudo-page>+|<ident> <pseudo-page>*",
        "page-size": "A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger",
        "path()": "path( [<fill-rule> ,]? <string> )",
        "paint()": "paint( <ident> , <declaration-value>? )",
        "perspective()": "perspective( <length> )",
        "polygon()": "polygon( <fill-rule>? , [<length-percentage> <length-percentage>]# )",
        "position": "[[left|center|right]||[top|center|bottom]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]?|[[left|right] <length-percentage>]&&[[top|bottom] <length-percentage>]]",
        "pseudo-class-selector": "':' <ident-token>|':' <function-token> <any-value> ')'",
        "pseudo-element-selector": "':' <pseudo-class-selector>",
        "pseudo-page": ": [left|right|first|blank]",
        "quote": "open-quote|close-quote|no-open-quote|no-close-quote",
        "radial-gradient()": "radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
        "relative-selector": "<combinator>? <complex-selector>",
        "relative-selector-list": "<relative-selector>#",
        "relative-size": "larger|smaller",
        "repeat-style": "repeat-x|repeat-y|[repeat|space|round|no-repeat]{1,2}",
        "repeating-conic-gradient()": "repeating-conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
        "repeating-linear-gradient()": "repeating-linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
        "repeating-radial-gradient()": "repeating-radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
        "rgb()": "rgb( <percentage>{3} [/ <alpha-value>]? )|rgb( <number>{3} [/ <alpha-value>]? )|rgb( <percentage>#{3} , <alpha-value>? )|rgb( <number>#{3} , <alpha-value>? )",
        "rgba()": "rgba( <percentage>{3} [/ <alpha-value>]? )|rgba( <number>{3} [/ <alpha-value>]? )|rgba( <percentage>#{3} , <alpha-value>? )|rgba( <number>#{3} , <alpha-value>? )",
        "rotate()": "rotate( [<angle>|<zero>] )",
        "rotate3d()": "rotate3d( <number> , <number> , <number> , [<angle>|<zero>] )",
        "rotateX()": "rotateX( [<angle>|<zero>] )",
        "rotateY()": "rotateY( [<angle>|<zero>] )",
        "rotateZ()": "rotateZ( [<angle>|<zero>] )",
        "saturate()": "saturate( <number-percentage> )",
        "scale()": "scale( <number> , <number>? )",
        "scale3d()": "scale3d( <number> , <number> , <number> )",
        "scaleX()": "scaleX( <number> )",
        "scaleY()": "scaleY( <number> )",
        "scaleZ()": "scaleZ( <number> )",
        "self-position": "center|start|end|self-start|self-end|flex-start|flex-end",
        "shape-radius": "<length-percentage>|closest-side|farthest-side",
        "skew()": "skew( [<angle>|<zero>] , [<angle>|<zero>]? )",
        "skewX()": "skewX( [<angle>|<zero>] )",
        "skewY()": "skewY( [<angle>|<zero>] )",
        "sepia()": "sepia( <number-percentage> )",
        "shadow": "inset?&&<length>{2,4}&&<color>?",
        "shadow-t": "[<length>{2,3}&&<color>?]",
        "shape": "rect( <top> , <right> , <bottom> , <left> )|rect( <top> <right> <bottom> <left> )",
        "shape-box": "<box>|margin-box",
        "side-or-corner": "[left|right]||[top|bottom]",
        "single-animation": "<time>||<easing-function>||<time>||<single-animation-iteration-count>||<single-animation-direction>||<single-animation-fill-mode>||<single-animation-play-state>||[none|<keyframes-name>]",
        "single-animation-direction": "normal|reverse|alternate|alternate-reverse",
        "single-animation-fill-mode": "none|forwards|backwards|both",
        "single-animation-iteration-count": "infinite|<number>",
        "single-animation-play-state": "running|paused",
        "single-animation-timeline": "auto|none|<timeline-name>",
        "single-transition": "[none|<single-transition-property>]||<time>||<easing-function>||<time>",
        "single-transition-property": "all|<custom-ident>",
        "size": "closest-side|farthest-side|closest-corner|farthest-corner|<length>|<length-percentage>{2}",
        "step-position": "jump-start|jump-end|jump-none|jump-both|start|end",
        "step-timing-function": "step-start|step-end|steps( <integer> [, <step-position>]? )",
        "subclass-selector": "<id-selector>|<class-selector>|<attribute-selector>|<pseudo-class-selector>",
        "supports-condition": "not <supports-in-parens>|<supports-in-parens> [and <supports-in-parens>]*|<supports-in-parens> [or <supports-in-parens>]*",
        "supports-in-parens": "( <supports-condition> )|<supports-feature>|<general-enclosed>",
        "supports-feature": "<supports-decl>|<supports-selector-fn>",
        "supports-decl": "( <declaration> )",
        "supports-selector-fn": "selector( <complex-selector> )",
        "symbol": "<string>|<image>|<custom-ident>",
        "target": "<target-counter()>|<target-counters()>|<target-text()>",
        "target-counter()": "target-counter( [<string>|<url>] , <custom-ident> , <counter-style>? )",
        "target-counters()": "target-counters( [<string>|<url>] , <custom-ident> , <string> , <counter-style>? )",
        "target-text()": "target-text( [<string>|<url>] , [content|before|after|first-letter]? )",
        "time-percentage": "<time>|<percentage>",
        "timeline-name": "<custom-ident>|<string>",
        "easing-function": "linear|<cubic-bezier-timing-function>|<step-timing-function>",
        "track-breadth": "<length-percentage>|<flex>|min-content|max-content|auto",
        "track-list": "[<line-names>? [<track-size>|<track-repeat>]]+ <line-names>?",
        "track-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <track-size>]+ <line-names>? )",
        "track-size": "<track-breadth>|minmax( <inflexible-breadth> , <track-breadth> )|fit-content( [<length>|<percentage>] )",
        "transform-function": "<matrix()>|<translate()>|<translateX()>|<translateY()>|<scale()>|<scaleX()>|<scaleY()>|<rotate()>|<skew()>|<skewX()>|<skewY()>|<matrix3d()>|<translate3d()>|<translateZ()>|<scale3d()>|<scaleZ()>|<rotate3d()>|<rotateX()>|<rotateY()>|<rotateZ()>|<perspective()>",
        "transform-list": "<transform-function>+",
        "translate()": "translate( <length-percentage> , <length-percentage>? )",
        "translate3d()": "translate3d( <length-percentage> , <length-percentage> , <length> )",
        "translateX()": "translateX( <length-percentage> )",
        "translateY()": "translateY( <length-percentage> )",
        "translateZ()": "translateZ( <length> )",
        "type-or-unit": "string|color|url|integer|number|length|angle|time|frequency|cap|ch|em|ex|ic|lh|rlh|rem|vb|vi|vw|vh|vmin|vmax|mm|Q|cm|in|pt|pc|px|deg|grad|rad|turn|ms|s|Hz|kHz|%",
        "type-selector": "<wq-name>|<ns-prefix>? '*'",
        "var()": "var( <custom-property-name> , <declaration-value>? )",
        "viewport-length": "auto|<length-percentage>",
        "visual-box": "content-box|padding-box|border-box",
        "wq-name": "<ns-prefix>? <ident-token>",
        "-legacy-gradient": "<-webkit-gradient()>|<-legacy-linear-gradient>|<-legacy-repeating-linear-gradient>|<-legacy-radial-gradient>|<-legacy-repeating-radial-gradient>",
        "-legacy-linear-gradient": "-moz-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-linear-gradient( <-legacy-linear-gradient-arguments> )",
        "-legacy-repeating-linear-gradient": "-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )",
        "-legacy-linear-gradient-arguments": "[<angle>|<side-or-corner>]? , <color-stop-list>",
        "-legacy-radial-gradient": "-moz-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-radial-gradient( <-legacy-radial-gradient-arguments> )",
        "-legacy-repeating-radial-gradient": "-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )",
        "-legacy-radial-gradient-arguments": "[<position> ,]? [[[<-legacy-radial-gradient-shape>||<-legacy-radial-gradient-size>]|[<length>|<percentage>]{2}] ,]? <color-stop-list>",
        "-legacy-radial-gradient-size": "closest-side|closest-corner|farthest-side|farthest-corner|contain|cover",
        "-legacy-radial-gradient-shape": "circle|ellipse",
        "-non-standard-font": "-apple-system-body|-apple-system-headline|-apple-system-subheadline|-apple-system-caption1|-apple-system-caption2|-apple-system-footnote|-apple-system-short-body|-apple-system-short-headline|-apple-system-short-subheadline|-apple-system-short-caption1|-apple-system-short-footnote|-apple-system-tall-body",
        "-non-standard-color": "-moz-ButtonDefault|-moz-ButtonHoverFace|-moz-ButtonHoverText|-moz-CellHighlight|-moz-CellHighlightText|-moz-Combobox|-moz-ComboboxText|-moz-Dialog|-moz-DialogText|-moz-dragtargetzone|-moz-EvenTreeRow|-moz-Field|-moz-FieldText|-moz-html-CellHighlight|-moz-html-CellHighlightText|-moz-mac-accentdarkestshadow|-moz-mac-accentdarkshadow|-moz-mac-accentface|-moz-mac-accentlightesthighlight|-moz-mac-accentlightshadow|-moz-mac-accentregularhighlight|-moz-mac-accentregularshadow|-moz-mac-chrome-active|-moz-mac-chrome-inactive|-moz-mac-focusring|-moz-mac-menuselect|-moz-mac-menushadow|-moz-mac-menutextselect|-moz-MenuHover|-moz-MenuHoverText|-moz-MenuBarText|-moz-MenuBarHoverText|-moz-nativehyperlinktext|-moz-OddTreeRow|-moz-win-communicationstext|-moz-win-mediatext|-moz-activehyperlinktext|-moz-default-background-color|-moz-default-color|-moz-hyperlinktext|-moz-visitedhyperlinktext|-webkit-activelink|-webkit-focus-ring-color|-webkit-link|-webkit-text",
        "-non-standard-image-rendering": "optimize-contrast|-moz-crisp-edges|-o-crisp-edges|-webkit-optimize-contrast",
        "-non-standard-overflow": "-moz-scrollbars-none|-moz-scrollbars-horizontal|-moz-scrollbars-vertical|-moz-hidden-unscrollable",
        "-non-standard-width": "fill-available|min-intrinsic|intrinsic|-moz-available|-moz-fit-content|-moz-min-content|-moz-max-content|-webkit-min-content|-webkit-max-content",
        "-webkit-gradient()": "-webkit-gradient( <-webkit-gradient-type> , <-webkit-gradient-point> [, <-webkit-gradient-point>|, <-webkit-gradient-radius> , <-webkit-gradient-point>] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )",
        "-webkit-gradient-color-stop": "from( <color> )|color-stop( [<number-zero-one>|<percentage>] , <color> )|to( <color> )",
        "-webkit-gradient-point": "[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]",
        "-webkit-gradient-radius": "<length>|<percentage>",
        "-webkit-gradient-type": "linear|radial",
        "-webkit-mask-box-repeat": "repeat|stretch|round",
        "-webkit-mask-clip-style": "border|border-box|padding|padding-box|content|content-box|text",
        "-ms-filter-function-list": "<-ms-filter-function>+",
        "-ms-filter-function": "<-ms-filter-function-progid>|<-ms-filter-function-legacy>",
        "-ms-filter-function-progid": "'progid:' [<ident-token> '.']* [<ident-token>|<function-token> <any-value>? )]",
        "-ms-filter-function-legacy": "<ident-token>|<function-token> <any-value>? )",
        "-ms-filter": "<string>",
        "age": "child|young|old",
        "attr-name": "<wq-name>",
        "attr-fallback": "<any-value>",
        "bg-clip": "<box>|border|text",
        "border-radius": "<length-percentage>{1,2}",
        "bottom": "<length>|auto",
        "generic-voice": "[<age>? <gender> <integer>?]",
        "gender": "male|female|neutral",
        "lab()": "lab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
        "lch()": "lch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
        "left": "<length>|auto",
        "mask-image": "<mask-reference>#",
        "paint": "none|<color>|<url> [none|<color>]?|context-fill|context-stroke",
        "ratio": "<number [0,\u221E]> [/ <number [0,\u221E]>]?",
        "reversed-counter-name": "reversed( <counter-name> )",
        "right": "<length>|auto",
        "svg-length": "<percentage>|<length>|<number>",
        "svg-writing-mode": "lr-tb|rl-tb|tb-rl|lr|rl|tb",
        "top": "<length>|auto",
        "track-group": "'(' [<string>* <track-minmax> <string>*]+ ')' ['[' <positive-integer> ']']?|<track-minmax>",
        "track-list-v0": "[<string>* <track-group> <string>*]+|none",
        "track-minmax": "minmax( <track-breadth> , <track-breadth> )|auto|<track-breadth>|fit-content",
        "x": "<number>",
        "y": "<number>",
        "declaration": "<ident-token> : <declaration-value>? ['!' important]?",
        "declaration-list": "[<declaration>? ';']* <declaration>?",
        "url": "url( <string> <url-modifier>* )|<url-token>",
        "url-modifier": "<ident>|<function-token> <any-value> )",
        "number-zero-one": "<number [0,1]>",
        "number-one-or-greater": "<number [1,\u221E]>",
        "positive-integer": "<integer [0,\u221E]>",
        "-non-standard-display": "-ms-inline-flexbox|-ms-grid|-ms-inline-grid|-webkit-flex|-webkit-inline-flex|-webkit-box|-webkit-inline-box|-moz-inline-stack|-moz-box|-moz-inline-box"
    },
    "properties": {
        "--*": "<declaration-value>",
        "-ms-accelerator": "false|true",
        "-ms-block-progression": "tb|rl|bt|lr",
        "-ms-content-zoom-chaining": "none|chained",
        "-ms-content-zooming": "none|zoom",
        "-ms-content-zoom-limit": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
        "-ms-content-zoom-limit-max": "<percentage>",
        "-ms-content-zoom-limit-min": "<percentage>",
        "-ms-content-zoom-snap": "<'-ms-content-zoom-snap-type'>||<'-ms-content-zoom-snap-points'>",
        "-ms-content-zoom-snap-points": "snapInterval( <percentage> , <percentage> )|snapList( <percentage># )",
        "-ms-content-zoom-snap-type": "none|proximity|mandatory",
        "-ms-filter": "<string>",
        "-ms-flow-from": "[none|<custom-ident>]#",
        "-ms-flow-into": "[none|<custom-ident>]#",
        "-ms-grid-columns": "none|<track-list>|<auto-track-list>",
        "-ms-grid-rows": "none|<track-list>|<auto-track-list>",
        "-ms-high-contrast-adjust": "auto|none",
        "-ms-hyphenate-limit-chars": "auto|<integer>{1,3}",
        "-ms-hyphenate-limit-lines": "no-limit|<integer>",
        "-ms-hyphenate-limit-zone": "<percentage>|<length>",
        "-ms-ime-align": "auto|after",
        "-ms-overflow-style": "auto|none|scrollbar|-ms-autohiding-scrollbar",
        "-ms-scrollbar-3dlight-color": "<color>",
        "-ms-scrollbar-arrow-color": "<color>",
        "-ms-scrollbar-base-color": "<color>",
        "-ms-scrollbar-darkshadow-color": "<color>",
        "-ms-scrollbar-face-color": "<color>",
        "-ms-scrollbar-highlight-color": "<color>",
        "-ms-scrollbar-shadow-color": "<color>",
        "-ms-scrollbar-track-color": "<color>",
        "-ms-scroll-chaining": "chained|none",
        "-ms-scroll-limit": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
        "-ms-scroll-limit-x-max": "auto|<length>",
        "-ms-scroll-limit-x-min": "<length>",
        "-ms-scroll-limit-y-max": "auto|<length>",
        "-ms-scroll-limit-y-min": "<length>",
        "-ms-scroll-rails": "none|railed",
        "-ms-scroll-snap-points-x": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
        "-ms-scroll-snap-points-y": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
        "-ms-scroll-snap-type": "none|proximity|mandatory",
        "-ms-scroll-snap-x": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
        "-ms-scroll-snap-y": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
        "-ms-scroll-translation": "none|vertical-to-horizontal",
        "-ms-text-autospace": "none|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space",
        "-ms-touch-select": "grippers|none",
        "-ms-user-select": "none|element|text",
        "-ms-wrap-flow": "auto|both|start|end|maximum|clear",
        "-ms-wrap-margin": "<length>",
        "-ms-wrap-through": "wrap|none",
        "-moz-appearance": "none|button|button-arrow-down|button-arrow-next|button-arrow-previous|button-arrow-up|button-bevel|button-focus|caret|checkbox|checkbox-container|checkbox-label|checkmenuitem|dualbutton|groupbox|listbox|listitem|menuarrow|menubar|menucheckbox|menuimage|menuitem|menuitemtext|menulist|menulist-button|menulist-text|menulist-textfield|menupopup|menuradio|menuseparator|meterbar|meterchunk|progressbar|progressbar-vertical|progresschunk|progresschunk-vertical|radio|radio-container|radio-label|radiomenuitem|range|range-thumb|resizer|resizerpanel|scale-horizontal|scalethumbend|scalethumb-horizontal|scalethumbstart|scalethumbtick|scalethumb-vertical|scale-vertical|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|separator|sheet|spinner|spinner-downbutton|spinner-textfield|spinner-upbutton|splitter|statusbar|statusbarpanel|tab|tabpanel|tabpanels|tab-scroll-arrow-back|tab-scroll-arrow-forward|textfield|textfield-multiline|toolbar|toolbarbutton|toolbarbutton-dropdown|toolbargripper|toolbox|tooltip|treeheader|treeheadercell|treeheadersortarrow|treeitem|treeline|treetwisty|treetwistyopen|treeview|-moz-mac-unified-toolbar|-moz-win-borderless-glass|-moz-win-browsertabbar-toolbox|-moz-win-communicationstext|-moz-win-communications-toolbox|-moz-win-exclude-glass|-moz-win-glass|-moz-win-mediatext|-moz-win-media-toolbox|-moz-window-button-box|-moz-window-button-box-maximized|-moz-window-button-close|-moz-window-button-maximize|-moz-window-button-minimize|-moz-window-button-restore|-moz-window-frame-bottom|-moz-window-frame-left|-moz-window-frame-right|-moz-window-titlebar|-moz-window-titlebar-maximized",
        "-moz-binding": "<url>|none",
        "-moz-border-bottom-colors": "<color>+|none",
        "-moz-border-left-colors": "<color>+|none",
        "-moz-border-right-colors": "<color>+|none",
        "-moz-border-top-colors": "<color>+|none",
        "-moz-context-properties": "none|[fill|fill-opacity|stroke|stroke-opacity]#",
        "-moz-float-edge": "border-box|content-box|margin-box|padding-box",
        "-moz-force-broken-image-icon": "0|1",
        "-moz-image-region": "<shape>|auto",
        "-moz-orient": "inline|block|horizontal|vertical",
        "-moz-outline-radius": "<outline-radius>{1,4} [/ <outline-radius>{1,4}]?",
        "-moz-outline-radius-bottomleft": "<outline-radius>",
        "-moz-outline-radius-bottomright": "<outline-radius>",
        "-moz-outline-radius-topleft": "<outline-radius>",
        "-moz-outline-radius-topright": "<outline-radius>",
        "-moz-stack-sizing": "ignore|stretch-to-fit",
        "-moz-text-blink": "none|blink",
        "-moz-user-focus": "ignore|normal|select-after|select-before|select-menu|select-same|select-all|none",
        "-moz-user-input": "auto|none|enabled|disabled",
        "-moz-user-modify": "read-only|read-write|write-only",
        "-moz-window-dragging": "drag|no-drag",
        "-moz-window-shadow": "default|menu|tooltip|sheet|none",
        "-webkit-appearance": "none|button|button-bevel|caps-lock-indicator|caret|checkbox|default-button|inner-spin-button|listbox|listitem|media-controls-background|media-controls-fullscreen-background|media-current-time-display|media-enter-fullscreen-button|media-exit-fullscreen-button|media-fullscreen-button|media-mute-button|media-overlay-play-button|media-play-button|media-seek-back-button|media-seek-forward-button|media-slider|media-sliderthumb|media-time-remaining-display|media-toggle-closed-captions-button|media-volume-slider|media-volume-slider-container|media-volume-sliderthumb|menulist|menulist-button|menulist-text|menulist-textfield|meter|progress-bar|progress-bar-value|push-button|radio|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbargripper-horizontal|scrollbargripper-vertical|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|searchfield-cancel-button|searchfield-decoration|searchfield-results-button|searchfield-results-decoration|slider-horizontal|slider-vertical|sliderthumb-horizontal|sliderthumb-vertical|square-button|textarea|textfield|-apple-pay-button",
        "-webkit-border-before": "<'border-width'>||<'border-style'>||<color>",
        "-webkit-border-before-color": "<color>",
        "-webkit-border-before-style": "<'border-style'>",
        "-webkit-border-before-width": "<'border-width'>",
        "-webkit-box-reflect": "[above|below|right|left]? <length>? <image>?",
        "-webkit-line-clamp": "none|<integer>",
        "-webkit-mask": "[<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||[<box>|border|padding|content|text]||[<box>|border|padding|content]]#",
        "-webkit-mask-attachment": "<attachment>#",
        "-webkit-mask-clip": "[<box>|border|padding|content|text]#",
        "-webkit-mask-composite": "<composite-style>#",
        "-webkit-mask-image": "<mask-reference>#",
        "-webkit-mask-origin": "[<box>|border|padding|content]#",
        "-webkit-mask-position": "<position>#",
        "-webkit-mask-position-x": "[<length-percentage>|left|center|right]#",
        "-webkit-mask-position-y": "[<length-percentage>|top|center|bottom]#",
        "-webkit-mask-repeat": "<repeat-style>#",
        "-webkit-mask-repeat-x": "repeat|no-repeat|space|round",
        "-webkit-mask-repeat-y": "repeat|no-repeat|space|round",
        "-webkit-mask-size": "<bg-size>#",
        "-webkit-overflow-scrolling": "auto|touch",
        "-webkit-tap-highlight-color": "<color>",
        "-webkit-text-fill-color": "<color>",
        "-webkit-text-stroke": "<length>||<color>",
        "-webkit-text-stroke-color": "<color>",
        "-webkit-text-stroke-width": "<length>",
        "-webkit-touch-callout": "default|none",
        "-webkit-user-modify": "read-only|read-write|read-write-plaintext-only",
        "accent-color": "auto|<color>",
        "align-content": "normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>",
        "align-items": "normal|stretch|<baseline-position>|[<overflow-position>? <self-position>]",
        "align-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? <self-position>",
        "align-tracks": "[normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>]#",
        "all": "initial|inherit|unset|revert|revert-layer",
        "animation": "<single-animation>#",
        "animation-delay": "<time>#",
        "animation-direction": "<single-animation-direction>#",
        "animation-duration": "<time>#",
        "animation-fill-mode": "<single-animation-fill-mode>#",
        "animation-iteration-count": "<single-animation-iteration-count>#",
        "animation-name": "[none|<keyframes-name>]#",
        "animation-play-state": "<single-animation-play-state>#",
        "animation-timing-function": "<easing-function>#",
        "animation-timeline": "<single-animation-timeline>#",
        "appearance": "none|auto|textfield|menulist-button|<compat-auto>",
        "aspect-ratio": "auto|<ratio>",
        "azimuth": "<angle>|[[left-side|far-left|left|center-left|center|center-right|right|far-right|right-side]||behind]|leftwards|rightwards",
        "backdrop-filter": "none|<filter-function-list>",
        "backface-visibility": "visible|hidden",
        "background": "[<bg-layer> ,]* <final-bg-layer>",
        "background-attachment": "<attachment>#",
        "background-blend-mode": "<blend-mode>#",
        "background-clip": "<bg-clip>#",
        "background-color": "<color>",
        "background-image": "<bg-image>#",
        "background-origin": "<box>#",
        "background-position": "<bg-position>#",
        "background-position-x": "[center|[[left|right|x-start|x-end]? <length-percentage>?]!]#",
        "background-position-y": "[center|[[top|bottom|y-start|y-end]? <length-percentage>?]!]#",
        "background-repeat": "<repeat-style>#",
        "background-size": "<bg-size>#",
        "block-overflow": "clip|ellipsis|<string>",
        "block-size": "<'width'>",
        "border": "<line-width>||<line-style>||<color>",
        "border-block": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-color": "<'border-top-color'>{1,2}",
        "border-block-style": "<'border-top-style'>",
        "border-block-width": "<'border-top-width'>",
        "border-block-end": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-end-color": "<'border-top-color'>",
        "border-block-end-style": "<'border-top-style'>",
        "border-block-end-width": "<'border-top-width'>",
        "border-block-start": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-start-color": "<'border-top-color'>",
        "border-block-start-style": "<'border-top-style'>",
        "border-block-start-width": "<'border-top-width'>",
        "border-bottom": "<line-width>||<line-style>||<color>",
        "border-bottom-color": "<'border-top-color'>",
        "border-bottom-left-radius": "<length-percentage>{1,2}",
        "border-bottom-right-radius": "<length-percentage>{1,2}",
        "border-bottom-style": "<line-style>",
        "border-bottom-width": "<line-width>",
        "border-collapse": "collapse|separate",
        "border-color": "<color>{1,4}",
        "border-end-end-radius": "<length-percentage>{1,2}",
        "border-end-start-radius": "<length-percentage>{1,2}",
        "border-image": "<'border-image-source'>||<'border-image-slice'> [/ <'border-image-width'>|/ <'border-image-width'>? / <'border-image-outset'>]?||<'border-image-repeat'>",
        "border-image-outset": "[<length>|<number>]{1,4}",
        "border-image-repeat": "[stretch|repeat|round|space]{1,2}",
        "border-image-slice": "<number-percentage>{1,4}&&fill?",
        "border-image-source": "none|<image>",
        "border-image-width": "[<length-percentage>|<number>|auto]{1,4}",
        "border-inline": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-end": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-color": "<'border-top-color'>{1,2}",
        "border-inline-style": "<'border-top-style'>",
        "border-inline-width": "<'border-top-width'>",
        "border-inline-end-color": "<'border-top-color'>",
        "border-inline-end-style": "<'border-top-style'>",
        "border-inline-end-width": "<'border-top-width'>",
        "border-inline-start": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-start-color": "<'border-top-color'>",
        "border-inline-start-style": "<'border-top-style'>",
        "border-inline-start-width": "<'border-top-width'>",
        "border-left": "<line-width>||<line-style>||<color>",
        "border-left-color": "<color>",
        "border-left-style": "<line-style>",
        "border-left-width": "<line-width>",
        "border-radius": "<length-percentage>{1,4} [/ <length-percentage>{1,4}]?",
        "border-right": "<line-width>||<line-style>||<color>",
        "border-right-color": "<color>",
        "border-right-style": "<line-style>",
        "border-right-width": "<line-width>",
        "border-spacing": "<length> <length>?",
        "border-start-end-radius": "<length-percentage>{1,2}",
        "border-start-start-radius": "<length-percentage>{1,2}",
        "border-style": "<line-style>{1,4}",
        "border-top": "<line-width>||<line-style>||<color>",
        "border-top-color": "<color>",
        "border-top-left-radius": "<length-percentage>{1,2}",
        "border-top-right-radius": "<length-percentage>{1,2}",
        "border-top-style": "<line-style>",
        "border-top-width": "<line-width>",
        "border-width": "<line-width>{1,4}",
        "bottom": "<length>|<percentage>|auto",
        "box-align": "start|center|end|baseline|stretch",
        "box-decoration-break": "slice|clone",
        "box-direction": "normal|reverse|inherit",
        "box-flex": "<number>",
        "box-flex-group": "<integer>",
        "box-lines": "single|multiple",
        "box-ordinal-group": "<integer>",
        "box-orient": "horizontal|vertical|inline-axis|block-axis|inherit",
        "box-pack": "start|center|end|justify",
        "box-shadow": "none|<shadow>#",
        "box-sizing": "content-box|border-box",
        "break-after": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
        "break-before": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
        "break-inside": "auto|avoid|avoid-page|avoid-column|avoid-region",
        "caption-side": "top|bottom|block-start|block-end|inline-start|inline-end",
        "caret-color": "auto|<color>",
        "clear": "none|left|right|both|inline-start|inline-end",
        "clip": "<shape>|auto",
        "clip-path": "<clip-source>|[<basic-shape>||<geometry-box>]|none",
        "color": "<color>",
        "print-color-adjust": "economy|exact",
        "color-scheme": "normal|[light|dark|<custom-ident>]+&&only?",
        "column-count": "<integer>|auto",
        "column-fill": "auto|balance|balance-all",
        "column-gap": "normal|<length-percentage>",
        "column-rule": "<'column-rule-width'>||<'column-rule-style'>||<'column-rule-color'>",
        "column-rule-color": "<color>",
        "column-rule-style": "<'border-style'>",
        "column-rule-width": "<'border-width'>",
        "column-span": "none|all",
        "column-width": "<length>|auto",
        "columns": "<'column-width'>||<'column-count'>",
        "contain": "none|strict|content|[size||layout||style||paint]",
        "content": "normal|none|[<content-replacement>|<content-list>] [/ [<string>|<counter>]+]?",
        "content-visibility": "visible|auto|hidden",
        "counter-increment": "[<counter-name> <integer>?]+|none",
        "counter-reset": "[<counter-name> <integer>?|<reversed-counter-name> <integer>?]+|none",
        "counter-set": "[<counter-name> <integer>?]+|none",
        "cursor": "[[<url> [<x> <y>]? ,]* [auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing|hand|-webkit-grab|-webkit-grabbing|-webkit-zoom-in|-webkit-zoom-out|-moz-grab|-moz-grabbing|-moz-zoom-in|-moz-zoom-out]]",
        "direction": "ltr|rtl",
        "display": "[<display-outside>||<display-inside>]|<display-listitem>|<display-internal>|<display-box>|<display-legacy>|<-non-standard-display>",
        "empty-cells": "show|hide",
        "filter": "none|<filter-function-list>|<-ms-filter-function-list>",
        "flex": "none|[<'flex-grow'> <'flex-shrink'>?||<'flex-basis'>]",
        "flex-basis": "content|<'width'>",
        "flex-direction": "row|row-reverse|column|column-reverse",
        "flex-flow": "<'flex-direction'>||<'flex-wrap'>",
        "flex-grow": "<number>",
        "flex-shrink": "<number>",
        "flex-wrap": "nowrap|wrap|wrap-reverse",
        "float": "left|right|none|inline-start|inline-end",
        "font": "[[<'font-style'>||<font-variant-css21>||<'font-weight'>||<'font-stretch'>]? <'font-size'> [/ <'line-height'>]? <'font-family'>]|caption|icon|menu|message-box|small-caption|status-bar",
        "font-family": "[<family-name>|<generic-family>]#",
        "font-feature-settings": "normal|<feature-tag-value>#",
        "font-kerning": "auto|normal|none",
        "font-language-override": "normal|<string>",
        "font-optical-sizing": "auto|none",
        "font-variation-settings": "normal|[<string> <number>]#",
        "font-size": "<absolute-size>|<relative-size>|<length-percentage>",
        "font-size-adjust": "none|[ex-height|cap-height|ch-width|ic-width|ic-height]? [from-font|<number>]",
        "font-smooth": "auto|never|always|<absolute-size>|<length>",
        "font-stretch": "<font-stretch-absolute>",
        "font-style": "normal|italic|oblique <angle>?",
        "font-synthesis": "none|[weight||style||small-caps]",
        "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "font-variant-alternates": "normal|[stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )]",
        "font-variant-caps": "normal|small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
        "font-variant-east-asian": "normal|[<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "font-variant-ligatures": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>]",
        "font-variant-numeric": "normal|[<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero]",
        "font-variant-position": "normal|sub|super",
        "font-weight": "<font-weight-absolute>|bolder|lighter",
        "forced-color-adjust": "auto|none",
        "gap": "<'row-gap'> <'column-gap'>?",
        "grid": "<'grid-template'>|<'grid-template-rows'> / [auto-flow&&dense?] <'grid-auto-columns'>?|[auto-flow&&dense?] <'grid-auto-rows'>? / <'grid-template-columns'>",
        "grid-area": "<grid-line> [/ <grid-line>]{0,3}",
        "grid-auto-columns": "<track-size>+",
        "grid-auto-flow": "[row|column]||dense",
        "grid-auto-rows": "<track-size>+",
        "grid-column": "<grid-line> [/ <grid-line>]?",
        "grid-column-end": "<grid-line>",
        "grid-column-gap": "<length-percentage>",
        "grid-column-start": "<grid-line>",
        "grid-gap": "<'grid-row-gap'> <'grid-column-gap'>?",
        "grid-row": "<grid-line> [/ <grid-line>]?",
        "grid-row-end": "<grid-line>",
        "grid-row-gap": "<length-percentage>",
        "grid-row-start": "<grid-line>",
        "grid-template": "none|[<'grid-template-rows'> / <'grid-template-columns'>]|[<line-names>? <string> <track-size>? <line-names>?]+ [/ <explicit-track-list>]?",
        "grid-template-areas": "none|<string>+",
        "grid-template-columns": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
        "grid-template-rows": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
        "hanging-punctuation": "none|[first||[force-end|allow-end]||last]",
        "height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
        "hyphenate-character": "auto|<string>",
        "hyphens": "none|manual|auto",
        "image-orientation": "from-image|<angle>|[<angle>? flip]",
        "image-rendering": "auto|crisp-edges|pixelated|optimizeSpeed|optimizeQuality|<-non-standard-image-rendering>",
        "image-resolution": "[from-image||<resolution>]&&snap?",
        "ime-mode": "auto|normal|active|inactive|disabled",
        "initial-letter": "normal|[<number> <integer>?]",
        "initial-letter-align": "[auto|alphabetic|hanging|ideographic]",
        "inline-size": "<'width'>",
        "input-security": "auto|none",
        "inset": "<'top'>{1,4}",
        "inset-block": "<'top'>{1,2}",
        "inset-block-end": "<'top'>",
        "inset-block-start": "<'top'>",
        "inset-inline": "<'top'>{1,2}",
        "inset-inline-end": "<'top'>",
        "inset-inline-start": "<'top'>",
        "isolation": "auto|isolate",
        "justify-content": "normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]",
        "justify-items": "normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|legacy|legacy&&[left|right|center]",
        "justify-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]",
        "justify-tracks": "[normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]]#",
        "left": "<length>|<percentage>|auto",
        "letter-spacing": "normal|<length-percentage>",
        "line-break": "auto|loose|normal|strict|anywhere",
        "line-clamp": "none|<integer>",
        "line-height": "normal|<number>|<length>|<percentage>",
        "line-height-step": "<length>",
        "list-style": "<'list-style-type'>||<'list-style-position'>||<'list-style-image'>",
        "list-style-image": "<image>|none",
        "list-style-position": "inside|outside",
        "list-style-type": "<counter-style>|<string>|none",
        "margin": "[<length>|<percentage>|auto]{1,4}",
        "margin-block": "<'margin-left'>{1,2}",
        "margin-block-end": "<'margin-left'>",
        "margin-block-start": "<'margin-left'>",
        "margin-bottom": "<length>|<percentage>|auto",
        "margin-inline": "<'margin-left'>{1,2}",
        "margin-inline-end": "<'margin-left'>",
        "margin-inline-start": "<'margin-left'>",
        "margin-left": "<length>|<percentage>|auto",
        "margin-right": "<length>|<percentage>|auto",
        "margin-top": "<length>|<percentage>|auto",
        "margin-trim": "none|in-flow|all",
        "mask": "<mask-layer>#",
        "mask-border": "<'mask-border-source'>||<'mask-border-slice'> [/ <'mask-border-width'>? [/ <'mask-border-outset'>]?]?||<'mask-border-repeat'>||<'mask-border-mode'>",
        "mask-border-mode": "luminance|alpha",
        "mask-border-outset": "[<length>|<number>]{1,4}",
        "mask-border-repeat": "[stretch|repeat|round|space]{1,2}",
        "mask-border-slice": "<number-percentage>{1,4} fill?",
        "mask-border-source": "none|<image>",
        "mask-border-width": "[<length-percentage>|<number>|auto]{1,4}",
        "mask-clip": "[<geometry-box>|no-clip]#",
        "mask-composite": "<compositing-operator>#",
        "mask-image": "<mask-reference>#",
        "mask-mode": "<masking-mode>#",
        "mask-origin": "<geometry-box>#",
        "mask-position": "<position>#",
        "mask-repeat": "<repeat-style>#",
        "mask-size": "<bg-size>#",
        "mask-type": "luminance|alpha",
        "masonry-auto-flow": "[pack|next]||[definite-first|ordered]",
        "math-style": "normal|compact",
        "max-block-size": "<'max-width'>",
        "max-height": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
        "max-inline-size": "<'max-width'>",
        "max-lines": "none|<integer>",
        "max-width": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
        "min-block-size": "<'min-width'>",
        "min-height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
        "min-inline-size": "<'min-width'>",
        "min-width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
        "mix-blend-mode": "<blend-mode>|plus-lighter",
        "object-fit": "fill|contain|cover|none|scale-down",
        "object-position": "<position>",
        "offset": "[<'offset-position'>? [<'offset-path'> [<'offset-distance'>||<'offset-rotate'>]?]?]! [/ <'offset-anchor'>]?",
        "offset-anchor": "auto|<position>",
        "offset-distance": "<length-percentage>",
        "offset-path": "none|ray( [<angle>&&<size>&&contain?] )|<path()>|<url>|[<basic-shape>||<geometry-box>]",
        "offset-position": "auto|<position>",
        "offset-rotate": "[auto|reverse]||<angle>",
        "opacity": "<alpha-value>",
        "order": "<integer>",
        "orphans": "<integer>",
        "outline": "[<'outline-color'>||<'outline-style'>||<'outline-width'>]",
        "outline-color": "<color>|invert",
        "outline-offset": "<length>",
        "outline-style": "auto|<'border-style'>",
        "outline-width": "<line-width>",
        "overflow": "[visible|hidden|clip|scroll|auto]{1,2}|<-non-standard-overflow>",
        "overflow-anchor": "auto|none",
        "overflow-block": "visible|hidden|clip|scroll|auto",
        "overflow-clip-box": "padding-box|content-box",
        "overflow-clip-margin": "<visual-box>||<length [0,\u221E]>",
        "overflow-inline": "visible|hidden|clip|scroll|auto",
        "overflow-wrap": "normal|break-word|anywhere",
        "overflow-x": "visible|hidden|clip|scroll|auto",
        "overflow-y": "visible|hidden|clip|scroll|auto",
        "overscroll-behavior": "[contain|none|auto]{1,2}",
        "overscroll-behavior-block": "contain|none|auto",
        "overscroll-behavior-inline": "contain|none|auto",
        "overscroll-behavior-x": "contain|none|auto",
        "overscroll-behavior-y": "contain|none|auto",
        "padding": "[<length>|<percentage>]{1,4}",
        "padding-block": "<'padding-left'>{1,2}",
        "padding-block-end": "<'padding-left'>",
        "padding-block-start": "<'padding-left'>",
        "padding-bottom": "<length>|<percentage>",
        "padding-inline": "<'padding-left'>{1,2}",
        "padding-inline-end": "<'padding-left'>",
        "padding-inline-start": "<'padding-left'>",
        "padding-left": "<length>|<percentage>",
        "padding-right": "<length>|<percentage>",
        "padding-top": "<length>|<percentage>",
        "page-break-after": "auto|always|avoid|left|right|recto|verso",
        "page-break-before": "auto|always|avoid|left|right|recto|verso",
        "page-break-inside": "auto|avoid",
        "paint-order": "normal|[fill||stroke||markers]",
        "perspective": "none|<length>",
        "perspective-origin": "<position>",
        "place-content": "<'align-content'> <'justify-content'>?",
        "place-items": "<'align-items'> <'justify-items'>?",
        "place-self": "<'align-self'> <'justify-self'>?",
        "pointer-events": "auto|none|visiblePainted|visibleFill|visibleStroke|visible|painted|fill|stroke|all|inherit",
        "position": "static|relative|absolute|sticky|fixed|-webkit-sticky",
        "quotes": "none|auto|[<string> <string>]+",
        "resize": "none|both|horizontal|vertical|block|inline",
        "right": "<length>|<percentage>|auto",
        "rotate": "none|<angle>|[x|y|z|<number>{3}]&&<angle>",
        "row-gap": "normal|<length-percentage>",
        "ruby-align": "start|center|space-between|space-around",
        "ruby-merge": "separate|collapse|auto",
        "ruby-position": "[alternate||[over|under]]|inter-character",
        "scale": "none|<number>{1,3}",
        "scrollbar-color": "auto|<color>{2}",
        "scrollbar-gutter": "auto|stable&&both-edges?",
        "scrollbar-width": "auto|thin|none",
        "scroll-behavior": "auto|smooth",
        "scroll-margin": "<length>{1,4}",
        "scroll-margin-block": "<length>{1,2}",
        "scroll-margin-block-start": "<length>",
        "scroll-margin-block-end": "<length>",
        "scroll-margin-bottom": "<length>",
        "scroll-margin-inline": "<length>{1,2}",
        "scroll-margin-inline-start": "<length>",
        "scroll-margin-inline-end": "<length>",
        "scroll-margin-left": "<length>",
        "scroll-margin-right": "<length>",
        "scroll-margin-top": "<length>",
        "scroll-padding": "[auto|<length-percentage>]{1,4}",
        "scroll-padding-block": "[auto|<length-percentage>]{1,2}",
        "scroll-padding-block-start": "auto|<length-percentage>",
        "scroll-padding-block-end": "auto|<length-percentage>",
        "scroll-padding-bottom": "auto|<length-percentage>",
        "scroll-padding-inline": "[auto|<length-percentage>]{1,2}",
        "scroll-padding-inline-start": "auto|<length-percentage>",
        "scroll-padding-inline-end": "auto|<length-percentage>",
        "scroll-padding-left": "auto|<length-percentage>",
        "scroll-padding-right": "auto|<length-percentage>",
        "scroll-padding-top": "auto|<length-percentage>",
        "scroll-snap-align": "[none|start|end|center]{1,2}",
        "scroll-snap-coordinate": "none|<position>#",
        "scroll-snap-destination": "<position>",
        "scroll-snap-points-x": "none|repeat( <length-percentage> )",
        "scroll-snap-points-y": "none|repeat( <length-percentage> )",
        "scroll-snap-stop": "normal|always",
        "scroll-snap-type": "none|[x|y|block|inline|both] [mandatory|proximity]?",
        "scroll-snap-type-x": "none|mandatory|proximity",
        "scroll-snap-type-y": "none|mandatory|proximity",
        "shape-image-threshold": "<alpha-value>",
        "shape-margin": "<length-percentage>",
        "shape-outside": "none|[<shape-box>||<basic-shape>]|<image>",
        "tab-size": "<integer>|<length>",
        "table-layout": "auto|fixed",
        "text-align": "start|end|left|right|center|justify|match-parent",
        "text-align-last": "auto|start|end|left|right|center|justify",
        "text-combine-upright": "none|all|[digits <integer>?]",
        "text-decoration": "<'text-decoration-line'>||<'text-decoration-style'>||<'text-decoration-color'>||<'text-decoration-thickness'>",
        "text-decoration-color": "<color>",
        "text-decoration-line": "none|[underline||overline||line-through||blink]|spelling-error|grammar-error",
        "text-decoration-skip": "none|[objects||[spaces|[leading-spaces||trailing-spaces]]||edges||box-decoration]",
        "text-decoration-skip-ink": "auto|all|none",
        "text-decoration-style": "solid|double|dotted|dashed|wavy",
        "text-decoration-thickness": "auto|from-font|<length>|<percentage>",
        "text-emphasis": "<'text-emphasis-style'>||<'text-emphasis-color'>",
        "text-emphasis-color": "<color>",
        "text-emphasis-position": "[over|under]&&[right|left]",
        "text-emphasis-style": "none|[[filled|open]||[dot|circle|double-circle|triangle|sesame]]|<string>",
        "text-indent": "<length-percentage>&&hanging?&&each-line?",
        "text-justify": "auto|inter-character|inter-word|none",
        "text-orientation": "mixed|upright|sideways",
        "text-overflow": "[clip|ellipsis|<string>]{1,2}",
        "text-rendering": "auto|optimizeSpeed|optimizeLegibility|geometricPrecision",
        "text-shadow": "none|<shadow-t>#",
        "text-size-adjust": "none|auto|<percentage>",
        "text-transform": "none|capitalize|uppercase|lowercase|full-width|full-size-kana",
        "text-underline-offset": "auto|<length>|<percentage>",
        "text-underline-position": "auto|from-font|[under||[left|right]]",
        "top": "<length>|<percentage>|auto",
        "touch-action": "auto|none|[[pan-x|pan-left|pan-right]||[pan-y|pan-up|pan-down]||pinch-zoom]|manipulation",
        "transform": "none|<transform-list>",
        "transform-box": "content-box|border-box|fill-box|stroke-box|view-box",
        "transform-origin": "[<length-percentage>|left|center|right|top|bottom]|[[<length-percentage>|left|center|right]&&[<length-percentage>|top|center|bottom]] <length>?",
        "transform-style": "flat|preserve-3d",
        "transition": "<single-transition>#",
        "transition-delay": "<time>#",
        "transition-duration": "<time>#",
        "transition-property": "none|<single-transition-property>#",
        "transition-timing-function": "<easing-function>#",
        "translate": "none|<length-percentage> [<length-percentage> <length>?]?",
        "unicode-bidi": "normal|embed|isolate|bidi-override|isolate-override|plaintext|-moz-isolate|-moz-isolate-override|-moz-plaintext|-webkit-isolate|-webkit-isolate-override|-webkit-plaintext",
        "user-select": "auto|text|none|contain|all",
        "vertical-align": "baseline|sub|super|text-top|text-bottom|middle|top|bottom|<percentage>|<length>",
        "visibility": "visible|hidden|collapse",
        "white-space": "normal|pre|nowrap|pre-wrap|pre-line|break-spaces",
        "widows": "<integer>",
        "width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|fill|stretch|intrinsic|-moz-max-content|-webkit-max-content|-moz-fit-content|-webkit-fit-content",
        "will-change": "auto|<animateable-feature>#",
        "word-break": "normal|break-all|keep-all|break-word",
        "word-spacing": "normal|<length>",
        "word-wrap": "normal|break-word",
        "writing-mode": "horizontal-tb|vertical-rl|vertical-lr|sideways-rl|sideways-lr|<svg-writing-mode>",
        "z-index": "auto|<integer>",
        "zoom": "normal|reset|<number>|<percentage>",
        "-moz-background-clip": "padding|border",
        "-moz-border-radius-bottomleft": "<'border-bottom-left-radius'>",
        "-moz-border-radius-bottomright": "<'border-bottom-right-radius'>",
        "-moz-border-radius-topleft": "<'border-top-left-radius'>",
        "-moz-border-radius-topright": "<'border-bottom-right-radius'>",
        "-moz-control-character-visibility": "visible|hidden",
        "-moz-osx-font-smoothing": "auto|grayscale",
        "-moz-user-select": "none|text|all|-moz-none",
        "-ms-flex-align": "start|end|center|baseline|stretch",
        "-ms-flex-item-align": "auto|start|end|center|baseline|stretch",
        "-ms-flex-line-pack": "start|end|center|justify|distribute|stretch",
        "-ms-flex-negative": "<'flex-shrink'>",
        "-ms-flex-pack": "start|end|center|justify|distribute",
        "-ms-flex-order": "<integer>",
        "-ms-flex-positive": "<'flex-grow'>",
        "-ms-flex-preferred-size": "<'flex-basis'>",
        "-ms-interpolation-mode": "nearest-neighbor|bicubic",
        "-ms-grid-column-align": "start|end|center|stretch",
        "-ms-grid-row-align": "start|end|center|stretch",
        "-ms-hyphenate-limit-last": "none|always|column|page|spread",
        "-webkit-background-clip": "[<box>|border|padding|content|text]#",
        "-webkit-column-break-after": "always|auto|avoid",
        "-webkit-column-break-before": "always|auto|avoid",
        "-webkit-column-break-inside": "always|auto|avoid",
        "-webkit-font-smoothing": "auto|none|antialiased|subpixel-antialiased",
        "-webkit-mask-box-image": "[<url>|<gradient>|none] [<length-percentage>{4} <-webkit-mask-box-repeat>{2}]?",
        "-webkit-print-color-adjust": "economy|exact",
        "-webkit-text-security": "none|circle|disc|square",
        "-webkit-user-drag": "none|element|auto",
        "-webkit-user-select": "auto|none|text|all",
        "alignment-baseline": "auto|baseline|before-edge|text-before-edge|middle|central|after-edge|text-after-edge|ideographic|alphabetic|hanging|mathematical",
        "baseline-shift": "baseline|sub|super|<svg-length>",
        "behavior": "<url>+",
        "clip-rule": "nonzero|evenodd",
        "cue": "<'cue-before'> <'cue-after'>?",
        "cue-after": "<url> <decibel>?|none",
        "cue-before": "<url> <decibel>?|none",
        "dominant-baseline": "auto|use-script|no-change|reset-size|ideographic|alphabetic|hanging|mathematical|central|middle|text-after-edge|text-before-edge",
        "fill": "<paint>",
        "fill-opacity": "<number-zero-one>",
        "fill-rule": "nonzero|evenodd",
        "glyph-orientation-horizontal": "<angle>",
        "glyph-orientation-vertical": "<angle>",
        "kerning": "auto|<svg-length>",
        "marker": "none|<url>",
        "marker-end": "none|<url>",
        "marker-mid": "none|<url>",
        "marker-start": "none|<url>",
        "pause": "<'pause-before'> <'pause-after'>?",
        "pause-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "pause-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "rest": "<'rest-before'> <'rest-after'>?",
        "rest-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "rest-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "shape-rendering": "auto|optimizeSpeed|crispEdges|geometricPrecision",
        "src": "[<url> [format( <string># )]?|local( <family-name> )]#",
        "speak": "auto|none|normal",
        "speak-as": "normal|spell-out||digits||[literal-punctuation|no-punctuation]",
        "stroke": "<paint>",
        "stroke-dasharray": "none|[<svg-length>+]#",
        "stroke-dashoffset": "<svg-length>",
        "stroke-linecap": "butt|round|square",
        "stroke-linejoin": "miter|round|bevel",
        "stroke-miterlimit": "<number-one-or-greater>",
        "stroke-opacity": "<number-zero-one>",
        "stroke-width": "<svg-length>",
        "text-anchor": "start|middle|end",
        "unicode-range": "<urange>#",
        "voice-balance": "<number>|left|center|right|leftwards|rightwards",
        "voice-duration": "auto|<time>",
        "voice-family": "[[<family-name>|<generic-voice>] ,]* [<family-name>|<generic-voice>]|preserve",
        "voice-pitch": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
        "voice-range": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
        "voice-rate": "[normal|x-slow|slow|medium|fast|x-fast]||<percentage>",
        "voice-stress": "normal|strong|moderate|none|reduced",
        "voice-volume": "silent|[[x-soft|soft|medium|loud|x-loud]||<decibel>]"
    },
    "atrules": {
        "charset": {
            "prelude": "<string>",
            "descriptors": null
        },
        "counter-style": {
            "prelude": "<counter-style-name>",
            "descriptors": {
                "additive-symbols": "[<integer>&&<symbol>]#",
                "fallback": "<counter-style-name>",
                "negative": "<symbol> <symbol>?",
                "pad": "<integer>&&<symbol>",
                "prefix": "<symbol>",
                "range": "[[<integer>|infinite]{2}]#|auto",
                "speak-as": "auto|bullets|numbers|words|spell-out|<counter-style-name>",
                "suffix": "<symbol>",
                "symbols": "<symbol>+",
                "system": "cyclic|numeric|alphabetic|symbolic|additive|[fixed <integer>?]|[extends <counter-style-name>]"
            }
        },
        "document": {
            "prelude": "[<url>|url-prefix( <string> )|domain( <string> )|media-document( <string> )|regexp( <string> )]#",
            "descriptors": null
        },
        "font-face": {
            "prelude": null,
            "descriptors": {
                "ascent-override": "normal|<percentage>",
                "descent-override": "normal|<percentage>",
                "font-display": "[auto|block|swap|fallback|optional]",
                "font-family": "<family-name>",
                "font-feature-settings": "normal|<feature-tag-value>#",
                "font-variation-settings": "normal|[<string> <number>]#",
                "font-stretch": "<font-stretch-absolute>{1,2}",
                "font-style": "normal|italic|oblique <angle>{0,2}",
                "font-weight": "<font-weight-absolute>{1,2}",
                "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
                "line-gap-override": "normal|<percentage>",
                "size-adjust": "<percentage>",
                "src": "[<url> [format( <string># )]?|local( <family-name> )]#",
                "unicode-range": "<urange>#"
            }
        },
        "font-feature-values": {
            "prelude": "<family-name>#",
            "descriptors": null
        },
        "import": {
            "prelude": "[<string>|<url>] [layer|layer( <layer-name> )]? [supports( [<supports-condition>|<declaration>] )]? <media-query-list>?",
            "descriptors": null
        },
        "keyframes": {
            "prelude": "<keyframes-name>",
            "descriptors": null
        },
        "layer": {
            "prelude": "[<layer-name>#|<layer-name>?]",
            "descriptors": null
        },
        "media": {
            "prelude": "<media-query-list>",
            "descriptors": null
        },
        "namespace": {
            "prelude": "<namespace-prefix>? [<string>|<url>]",
            "descriptors": null
        },
        "page": {
            "prelude": "<page-selector-list>",
            "descriptors": {
                "bleed": "auto|<length>",
                "marks": "none|[crop||cross]",
                "size": "<length>{1,2}|auto|[<page-size>||[portrait|landscape]]"
            }
        },
        "property": {
            "prelude": "<custom-property-name>",
            "descriptors": {
                "syntax": "<string>",
                "inherits": "true|false",
                "initial-value": "<string>"
            }
        },
        "scroll-timeline": {
            "prelude": "<timeline-name>",
            "descriptors": null
        },
        "supports": {
            "prelude": "<supports-condition>",
            "descriptors": null
        },
        "viewport": {
            "prelude": null,
            "descriptors": {
                "height": "<viewport-length>{1,2}",
                "max-height": "<viewport-length>",
                "max-width": "<viewport-length>",
                "max-zoom": "auto|<number>|<percentage>",
                "min-height": "<viewport-length>",
                "min-width": "<viewport-length>",
                "min-zoom": "auto|<number>|<percentage>",
                "orientation": "auto|portrait|landscape",
                "user-zoom": "zoom|fixed",
                "viewport-fit": "auto|contain|cover",
                "width": "<viewport-length>{1,2}",
                "zoom": "auto|<number>|<percentage>"
            }
        }
    }
};

});

parcelRegister("1jT8b", function(module, exports) {

$parcel$export(module.exports, "AnPlusB", () => $0f6254ac32db5507$export$29d22f23fc62deec, (v) => $0f6254ac32db5507$export$29d22f23fc62deec = v);
$parcel$export(module.exports, "Atrule", () => $0f6254ac32db5507$export$b0e869c28ebe2686, (v) => $0f6254ac32db5507$export$b0e869c28ebe2686 = v);
$parcel$export(module.exports, "AtrulePrelude", () => $0f6254ac32db5507$export$a551ca711e9f0de7, (v) => $0f6254ac32db5507$export$a551ca711e9f0de7 = v);
$parcel$export(module.exports, "AttributeSelector", () => $0f6254ac32db5507$export$8170b1e1b2558dd5, (v) => $0f6254ac32db5507$export$8170b1e1b2558dd5 = v);
$parcel$export(module.exports, "Block", () => $0f6254ac32db5507$export$d96a8827a60d6b69, (v) => $0f6254ac32db5507$export$d96a8827a60d6b69 = v);
$parcel$export(module.exports, "Brackets", () => $0f6254ac32db5507$export$27f9608f5b4a4cfa, (v) => $0f6254ac32db5507$export$27f9608f5b4a4cfa = v);
$parcel$export(module.exports, "CDC", () => $0f6254ac32db5507$export$b0b2bd2d1777c179, (v) => $0f6254ac32db5507$export$b0b2bd2d1777c179 = v);
$parcel$export(module.exports, "CDO", () => $0f6254ac32db5507$export$521ef26a3002003b, (v) => $0f6254ac32db5507$export$521ef26a3002003b = v);
$parcel$export(module.exports, "ClassSelector", () => $0f6254ac32db5507$export$208720b1a4408baf, (v) => $0f6254ac32db5507$export$208720b1a4408baf = v);
$parcel$export(module.exports, "Combinator", () => $0f6254ac32db5507$export$3cbfd7ee92c4e2ca, (v) => $0f6254ac32db5507$export$3cbfd7ee92c4e2ca = v);
$parcel$export(module.exports, "Comment", () => $0f6254ac32db5507$export$4d299b491347818a, (v) => $0f6254ac32db5507$export$4d299b491347818a = v);
$parcel$export(module.exports, "Declaration", () => $0f6254ac32db5507$export$48f3d9e786303b67, (v) => $0f6254ac32db5507$export$48f3d9e786303b67 = v);
$parcel$export(module.exports, "DeclarationList", () => $0f6254ac32db5507$export$b8d0a768b241031f, (v) => $0f6254ac32db5507$export$b8d0a768b241031f = v);
$parcel$export(module.exports, "Dimension", () => $0f6254ac32db5507$export$c940ece961bc43c6, (v) => $0f6254ac32db5507$export$c940ece961bc43c6 = v);
$parcel$export(module.exports, "Function", () => $0f6254ac32db5507$export$f3890eeaf6851387, (v) => $0f6254ac32db5507$export$f3890eeaf6851387 = v);
$parcel$export(module.exports, "Hash", () => $0f6254ac32db5507$export$ab85ecd77ce6a5cd, (v) => $0f6254ac32db5507$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "Identifier", () => $0f6254ac32db5507$export$989167234458594d, (v) => $0f6254ac32db5507$export$989167234458594d = v);
$parcel$export(module.exports, "IdSelector", () => $0f6254ac32db5507$export$31c96e959895721d, (v) => $0f6254ac32db5507$export$31c96e959895721d = v);
$parcel$export(module.exports, "MediaFeature", () => $0f6254ac32db5507$export$a38b0f36e6ad18cf, (v) => $0f6254ac32db5507$export$a38b0f36e6ad18cf = v);
$parcel$export(module.exports, "MediaQuery", () => $0f6254ac32db5507$export$b745838c41029eb3, (v) => $0f6254ac32db5507$export$b745838c41029eb3 = v);
$parcel$export(module.exports, "MediaQueryList", () => $0f6254ac32db5507$export$789660f679e96cab, (v) => $0f6254ac32db5507$export$789660f679e96cab = v);
$parcel$export(module.exports, "Nth", () => $0f6254ac32db5507$export$69f042d6c338d0d, (v) => $0f6254ac32db5507$export$69f042d6c338d0d = v);
$parcel$export(module.exports, "Number", () => $0f6254ac32db5507$export$fffa67e515d04022, (v) => $0f6254ac32db5507$export$fffa67e515d04022 = v);
$parcel$export(module.exports, "Operator", () => $0f6254ac32db5507$export$fa5f90bfb4dbdbcd, (v) => $0f6254ac32db5507$export$fa5f90bfb4dbdbcd = v);
$parcel$export(module.exports, "Parentheses", () => $0f6254ac32db5507$export$f9c1f512ab2b4a4c, (v) => $0f6254ac32db5507$export$f9c1f512ab2b4a4c = v);
$parcel$export(module.exports, "Percentage", () => $0f6254ac32db5507$export$d11913f8a6922aea, (v) => $0f6254ac32db5507$export$d11913f8a6922aea = v);
$parcel$export(module.exports, "PseudoClassSelector", () => $0f6254ac32db5507$export$4a1f3470168c60fe, (v) => $0f6254ac32db5507$export$4a1f3470168c60fe = v);
$parcel$export(module.exports, "PseudoElementSelector", () => $0f6254ac32db5507$export$fcc96471f1c8a2f3, (v) => $0f6254ac32db5507$export$fcc96471f1c8a2f3 = v);
$parcel$export(module.exports, "Ratio", () => $0f6254ac32db5507$export$438ad6fc467f929b, (v) => $0f6254ac32db5507$export$438ad6fc467f929b = v);
$parcel$export(module.exports, "Raw", () => $0f6254ac32db5507$export$6f88fe47d32c9c94, (v) => $0f6254ac32db5507$export$6f88fe47d32c9c94 = v);
$parcel$export(module.exports, "Rule", () => $0f6254ac32db5507$export$f1ff2a90c38ff669, (v) => $0f6254ac32db5507$export$f1ff2a90c38ff669 = v);
$parcel$export(module.exports, "Selector", () => $0f6254ac32db5507$export$d15f4cd5286f9b1e, (v) => $0f6254ac32db5507$export$d15f4cd5286f9b1e = v);
$parcel$export(module.exports, "SelectorList", () => $0f6254ac32db5507$export$d2c5a04859a7aa8c, (v) => $0f6254ac32db5507$export$d2c5a04859a7aa8c = v);
$parcel$export(module.exports, "String", () => $0f6254ac32db5507$export$89b8e0fa65f6a914, (v) => $0f6254ac32db5507$export$89b8e0fa65f6a914 = v);
$parcel$export(module.exports, "StyleSheet", () => $0f6254ac32db5507$export$9d753cd7ae895cce, (v) => $0f6254ac32db5507$export$9d753cd7ae895cce = v);
$parcel$export(module.exports, "TypeSelector", () => $0f6254ac32db5507$export$1cbeb7199b91dfe2, (v) => $0f6254ac32db5507$export$1cbeb7199b91dfe2 = v);
$parcel$export(module.exports, "UnicodeRange", () => $0f6254ac32db5507$export$3f8e011aa996e1b4, (v) => $0f6254ac32db5507$export$3f8e011aa996e1b4 = v);
$parcel$export(module.exports, "Url", () => $0f6254ac32db5507$export$59d795186a5d3f58, (v) => $0f6254ac32db5507$export$59d795186a5d3f58 = v);
$parcel$export(module.exports, "Value", () => $0f6254ac32db5507$export$4c8d1a57a761ef94, (v) => $0f6254ac32db5507$export$4c8d1a57a761ef94 = v);
$parcel$export(module.exports, "WhiteSpace", () => $0f6254ac32db5507$export$fb98946286ab4c97, (v) => $0f6254ac32db5507$export$fb98946286ab4c97 = v);
var $0f6254ac32db5507$export$29d22f23fc62deec;
var $0f6254ac32db5507$export$b0e869c28ebe2686;
var $0f6254ac32db5507$export$a551ca711e9f0de7;
var $0f6254ac32db5507$export$8170b1e1b2558dd5;
var $0f6254ac32db5507$export$d96a8827a60d6b69;
var $0f6254ac32db5507$export$27f9608f5b4a4cfa;
var $0f6254ac32db5507$export$b0b2bd2d1777c179;
var $0f6254ac32db5507$export$521ef26a3002003b;
var $0f6254ac32db5507$export$208720b1a4408baf;
var $0f6254ac32db5507$export$3cbfd7ee92c4e2ca;
var $0f6254ac32db5507$export$4d299b491347818a;
var $0f6254ac32db5507$export$48f3d9e786303b67;
var $0f6254ac32db5507$export$b8d0a768b241031f;
var $0f6254ac32db5507$export$c940ece961bc43c6;
var $0f6254ac32db5507$export$f3890eeaf6851387;
var $0f6254ac32db5507$export$ab85ecd77ce6a5cd;
var $0f6254ac32db5507$export$989167234458594d;
var $0f6254ac32db5507$export$31c96e959895721d;
var $0f6254ac32db5507$export$a38b0f36e6ad18cf;
var $0f6254ac32db5507$export$b745838c41029eb3;
var $0f6254ac32db5507$export$789660f679e96cab;
var $0f6254ac32db5507$export$69f042d6c338d0d;
var $0f6254ac32db5507$export$fffa67e515d04022;
var $0f6254ac32db5507$export$fa5f90bfb4dbdbcd;
var $0f6254ac32db5507$export$f9c1f512ab2b4a4c;
var $0f6254ac32db5507$export$d11913f8a6922aea;
var $0f6254ac32db5507$export$4a1f3470168c60fe;
var $0f6254ac32db5507$export$fcc96471f1c8a2f3;
var $0f6254ac32db5507$export$438ad6fc467f929b;
var $0f6254ac32db5507$export$6f88fe47d32c9c94;
var $0f6254ac32db5507$export$f1ff2a90c38ff669;
var $0f6254ac32db5507$export$d15f4cd5286f9b1e;
var $0f6254ac32db5507$export$d2c5a04859a7aa8c;
var $0f6254ac32db5507$export$89b8e0fa65f6a914;
var $0f6254ac32db5507$export$9d753cd7ae895cce;
var $0f6254ac32db5507$export$1cbeb7199b91dfe2;
var $0f6254ac32db5507$export$3f8e011aa996e1b4;
var $0f6254ac32db5507$export$59d795186a5d3f58;
var $0f6254ac32db5507$export$4c8d1a57a761ef94;
var $0f6254ac32db5507$export$fb98946286ab4c97;
'use strict';

var $kqMf5 = parcelRequire("kqMf5");

var $4zWEu = parcelRequire("4zWEu");

var $a6F6BB = parcelRequire("a6F6BB");

var $is1r8 = parcelRequire("is1r8");

var $f7sOf = parcelRequire("f7sOf");

var $8xr0b = parcelRequire("8xr0b");

var $jplhI = parcelRequire("jplhI");

var $hQNxd = parcelRequire("hQNxd");

var $7VwxD = parcelRequire("7VwxD");

var $aNcVJ = parcelRequire("aNcVJ");

var $hSilY = parcelRequire("hSilY");

var $bpQLC = parcelRequire("bpQLC");

var $ksrhQ = parcelRequire("ksrhQ");

var $ej7Bo = parcelRequire("ej7Bo");

var $gGYMY = parcelRequire("gGYMY");

var $4I8uN = parcelRequire("4I8uN");

var $01xxE = parcelRequire("01xxE");

var $an8qD = parcelRequire("an8qD");

var $9zX8c = parcelRequire("9zX8c");

var $eLYwZ = parcelRequire("eLYwZ");

var $e5Xih = parcelRequire("e5Xih");

var $c53ky = parcelRequire("c53ky");

var $gXnZP = parcelRequire("gXnZP");

var $aQk36 = parcelRequire("aQk36");

var $fju2N = parcelRequire("fju2N");

var $2kUaV = parcelRequire("2kUaV");

var $6BEdX = parcelRequire("6BEdX");

var $TNJb9 = parcelRequire("TNJb9");

var $2lkt2 = parcelRequire("2lkt2");

var $aTzIL = parcelRequire("aTzIL");

var $5ppzC = parcelRequire("5ppzC");

var $9gWZU = parcelRequire("9gWZU");

var $3CnUF = parcelRequire("3CnUF");

var $1v6vW = parcelRequire("1v6vW");

var $2ZnEQ = parcelRequire("2ZnEQ");

var $lz3BD = parcelRequire("lz3BD");

var $51prC = parcelRequire("51prC");

var $id4Cb = parcelRequire("id4Cb");

var $dpFhL = parcelRequire("dpFhL");

var $c6UNZ = parcelRequire("c6UNZ");
$0f6254ac32db5507$export$29d22f23fc62deec = $kqMf5;
$0f6254ac32db5507$export$b0e869c28ebe2686 = $4zWEu;
$0f6254ac32db5507$export$a551ca711e9f0de7 = $a6F6BB;
$0f6254ac32db5507$export$8170b1e1b2558dd5 = $is1r8;
$0f6254ac32db5507$export$d96a8827a60d6b69 = $f7sOf;
$0f6254ac32db5507$export$27f9608f5b4a4cfa = $8xr0b;
$0f6254ac32db5507$export$b0b2bd2d1777c179 = $jplhI;
$0f6254ac32db5507$export$521ef26a3002003b = $hQNxd;
$0f6254ac32db5507$export$208720b1a4408baf = $7VwxD;
$0f6254ac32db5507$export$3cbfd7ee92c4e2ca = $aNcVJ;
$0f6254ac32db5507$export$4d299b491347818a = $hSilY;
$0f6254ac32db5507$export$48f3d9e786303b67 = $bpQLC;
$0f6254ac32db5507$export$b8d0a768b241031f = $ksrhQ;
$0f6254ac32db5507$export$c940ece961bc43c6 = $ej7Bo;
$0f6254ac32db5507$export$f3890eeaf6851387 = $gGYMY;
$0f6254ac32db5507$export$ab85ecd77ce6a5cd = $4I8uN;
$0f6254ac32db5507$export$989167234458594d = $01xxE;
$0f6254ac32db5507$export$31c96e959895721d = $an8qD;
$0f6254ac32db5507$export$a38b0f36e6ad18cf = $9zX8c;
$0f6254ac32db5507$export$b745838c41029eb3 = $eLYwZ;
$0f6254ac32db5507$export$789660f679e96cab = $e5Xih;
$0f6254ac32db5507$export$69f042d6c338d0d = $c53ky;
$0f6254ac32db5507$export$fffa67e515d04022 = $gXnZP;
$0f6254ac32db5507$export$fa5f90bfb4dbdbcd = $aQk36;
$0f6254ac32db5507$export$f9c1f512ab2b4a4c = $fju2N;
$0f6254ac32db5507$export$d11913f8a6922aea = $2kUaV;
$0f6254ac32db5507$export$4a1f3470168c60fe = $6BEdX;
$0f6254ac32db5507$export$fcc96471f1c8a2f3 = $TNJb9;
$0f6254ac32db5507$export$438ad6fc467f929b = $2lkt2;
$0f6254ac32db5507$export$6f88fe47d32c9c94 = $aTzIL;
$0f6254ac32db5507$export$f1ff2a90c38ff669 = $5ppzC;
$0f6254ac32db5507$export$d15f4cd5286f9b1e = $9gWZU;
$0f6254ac32db5507$export$d2c5a04859a7aa8c = $3CnUF;
$0f6254ac32db5507$export$89b8e0fa65f6a914 = $1v6vW;
$0f6254ac32db5507$export$9d753cd7ae895cce = $2ZnEQ;
$0f6254ac32db5507$export$1cbeb7199b91dfe2 = $lz3BD;
$0f6254ac32db5507$export$3f8e011aa996e1b4 = $51prC;
$0f6254ac32db5507$export$59d795186a5d3f58 = $id4Cb;
$0f6254ac32db5507$export$4c8d1a57a761ef94 = $dpFhL;
$0f6254ac32db5507$export$fb98946286ab4c97 = $c6UNZ;

});
parcelRegister("kqMf5", function(module, exports) {

$parcel$export(module.exports, "generate", () => $edfba845328c427b$export$80d376111cc09ad7, (v) => $edfba845328c427b$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $edfba845328c427b$export$a8ff84c12d48cfa6, (v) => $edfba845328c427b$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $edfba845328c427b$export$98e6a39c04603d36, (v) => $edfba845328c427b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $edfba845328c427b$export$46a2a563c28afca0, (v) => $edfba845328c427b$export$46a2a563c28afca0 = v);
var $edfba845328c427b$export$80d376111cc09ad7;
var $edfba845328c427b$export$a8ff84c12d48cfa6;
var $edfba845328c427b$export$98e6a39c04603d36;
var $edfba845328c427b$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");

var $kIeAG = parcelRequire("kIeAG");
const $edfba845328c427b$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $edfba845328c427b$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $edfba845328c427b$var$N = 0x006E; // U+006E LATIN SMALL LETTER N (n)
const $edfba845328c427b$var$DISALLOW_SIGN = true;
const $edfba845328c427b$var$ALLOW_SIGN = false;
function $edfba845328c427b$var$checkInteger(offset, disallowSign) {
    let pos = this.tokenStart + offset;
    const code = this.charCodeAt(pos);
    if (code === $edfba845328c427b$var$PLUSSIGN || code === $edfba845328c427b$var$HYPHENMINUS) {
        if (disallowSign) this.error('Number sign is not allowed');
        pos++;
    }
    for(; pos < this.tokenEnd; pos++)if (!$kIeAG.isDigit(this.charCodeAt(pos))) this.error('Integer is expected', pos);
}
function $edfba845328c427b$var$checkTokenIsInteger(disallowSign) {
    return $edfba845328c427b$var$checkInteger.call(this, 0, disallowSign);
}
function $edfba845328c427b$var$expectCharCode(offset, code) {
    if (!this.cmpChar(this.tokenStart + offset, code)) {
        let msg = '';
        switch(code){
            case $edfba845328c427b$var$N:
                msg = 'N is expected';
                break;
            case $edfba845328c427b$var$HYPHENMINUS:
                msg = 'HyphenMinus is expected';
                break;
        }
        this.error(msg, this.tokenStart + offset);
    }
}
// ... <signed-integer>
// ... ['+' | '-'] <signless-integer>
function $edfba845328c427b$var$consumeB() {
    let offset = 0;
    let sign = 0;
    let type = this.tokenType;
    while(type === $iYo0F.WhiteSpace || type === $iYo0F.Comment)type = this.lookupType(++offset);
    if (type !== $iYo0F.Number) {
        if (this.isDelim($edfba845328c427b$var$PLUSSIGN, offset) || this.isDelim($edfba845328c427b$var$HYPHENMINUS, offset)) {
            sign = this.isDelim($edfba845328c427b$var$PLUSSIGN, offset) ? $edfba845328c427b$var$PLUSSIGN : $edfba845328c427b$var$HYPHENMINUS;
            do type = this.lookupType(++offset);
            while (type === $iYo0F.WhiteSpace || type === $iYo0F.Comment);
            if (type !== $iYo0F.Number) {
                this.skip(offset);
                $edfba845328c427b$var$checkTokenIsInteger.call(this, $edfba845328c427b$var$DISALLOW_SIGN);
            }
        } else return null;
    }
    if (offset > 0) this.skip(offset);
    if (sign === 0) {
        type = this.charCodeAt(this.tokenStart);
        if (type !== $edfba845328c427b$var$PLUSSIGN && type !== $edfba845328c427b$var$HYPHENMINUS) this.error('Number sign is expected');
    }
    $edfba845328c427b$var$checkTokenIsInteger.call(this, sign !== 0);
    return sign === $edfba845328c427b$var$HYPHENMINUS ? '-' + this.consume($iYo0F.Number) : this.consume($iYo0F.Number);
}
// An+B microsyntax https://www.w3.org/TR/css-syntax-3/#anb
const $edfba845328c427b$var$name = 'AnPlusB';
const $edfba845328c427b$var$structure = {
    a: [
        String,
        null
    ],
    b: [
        String,
        null
    ]
};
function $edfba845328c427b$var$parse() {
    /* eslint-disable brace-style*/ const start = this.tokenStart;
    let a = null;
    let b = null;
    // <integer>
    if (this.tokenType === $iYo0F.Number) {
        $edfba845328c427b$var$checkTokenIsInteger.call(this, $edfba845328c427b$var$ALLOW_SIGN);
        b = this.consume($iYo0F.Number);
    } else if (this.tokenType === $iYo0F.Ident && this.cmpChar(this.tokenStart, $edfba845328c427b$var$HYPHENMINUS)) {
        a = '-1';
        $edfba845328c427b$var$expectCharCode.call(this, 1, $edfba845328c427b$var$N);
        switch(this.tokenEnd - this.tokenStart){
            // -n
            // -n <signed-integer>
            // -n ['+' | '-'] <signless-integer>
            case 2:
                this.next();
                b = $edfba845328c427b$var$consumeB.call(this);
                break;
            // -n- <signless-integer>
            case 3:
                $edfba845328c427b$var$expectCharCode.call(this, 2, $edfba845328c427b$var$HYPHENMINUS);
                this.next();
                this.skipSC();
                $edfba845328c427b$var$checkTokenIsInteger.call(this, $edfba845328c427b$var$DISALLOW_SIGN);
                b = '-' + this.consume($iYo0F.Number);
                break;
            // <dashndashdigit-ident>
            default:
                $edfba845328c427b$var$expectCharCode.call(this, 2, $edfba845328c427b$var$HYPHENMINUS);
                $edfba845328c427b$var$checkInteger.call(this, 3, $edfba845328c427b$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(start + 2);
        }
    } else if (this.tokenType === $iYo0F.Ident || this.isDelim($edfba845328c427b$var$PLUSSIGN) && this.lookupType(1) === $iYo0F.Ident) {
        let sign = 0;
        a = '1';
        // just ignore a plus
        if (this.isDelim($edfba845328c427b$var$PLUSSIGN)) {
            sign = 1;
            this.next();
        }
        $edfba845328c427b$var$expectCharCode.call(this, 0, $edfba845328c427b$var$N);
        switch(this.tokenEnd - this.tokenStart){
            // '+'? n
            // '+'? n <signed-integer>
            // '+'? n ['+' | '-'] <signless-integer>
            case 1:
                this.next();
                b = $edfba845328c427b$var$consumeB.call(this);
                break;
            // '+'? n- <signless-integer>
            case 2:
                $edfba845328c427b$var$expectCharCode.call(this, 1, $edfba845328c427b$var$HYPHENMINUS);
                this.next();
                this.skipSC();
                $edfba845328c427b$var$checkTokenIsInteger.call(this, $edfba845328c427b$var$DISALLOW_SIGN);
                b = '-' + this.consume($iYo0F.Number);
                break;
            // '+'? <ndashdigit-ident>
            default:
                $edfba845328c427b$var$expectCharCode.call(this, 1, $edfba845328c427b$var$HYPHENMINUS);
                $edfba845328c427b$var$checkInteger.call(this, 2, $edfba845328c427b$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(start + sign + 1);
        }
    } else if (this.tokenType === $iYo0F.Dimension) {
        const code = this.charCodeAt(this.tokenStart);
        const sign = code === $edfba845328c427b$var$PLUSSIGN || code === $edfba845328c427b$var$HYPHENMINUS;
        let i = this.tokenStart + sign;
        for(; i < this.tokenEnd; i++){
            if (!$kIeAG.isDigit(this.charCodeAt(i))) break;
        }
        if (i === this.tokenStart + sign) this.error('Integer is expected', this.tokenStart + sign);
        $edfba845328c427b$var$expectCharCode.call(this, i - this.tokenStart, $edfba845328c427b$var$N);
        a = this.substring(start, i);
        // <n-dimension>
        // <n-dimension> <signed-integer>
        // <n-dimension> ['+' | '-'] <signless-integer>
        if (i + 1 === this.tokenEnd) {
            this.next();
            b = $edfba845328c427b$var$consumeB.call(this);
        } else {
            $edfba845328c427b$var$expectCharCode.call(this, i - this.tokenStart + 1, $edfba845328c427b$var$HYPHENMINUS);
            // <ndash-dimension> <signless-integer>
            if (i + 2 === this.tokenEnd) {
                this.next();
                this.skipSC();
                $edfba845328c427b$var$checkTokenIsInteger.call(this, $edfba845328c427b$var$DISALLOW_SIGN);
                b = '-' + this.consume($iYo0F.Number);
            } else {
                $edfba845328c427b$var$checkInteger.call(this, i - this.tokenStart + 2, $edfba845328c427b$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(i + 1);
            }
        }
    } else this.error();
    if (a !== null && a.charCodeAt(0) === $edfba845328c427b$var$PLUSSIGN) a = a.substr(1);
    if (b !== null && b.charCodeAt(0) === $edfba845328c427b$var$PLUSSIGN) b = b.substr(1);
    return {
        type: 'AnPlusB',
        loc: this.getLocation(start, this.tokenStart),
        a: a,
        b: b
    };
}
function $edfba845328c427b$var$generate(node) {
    if (node.a) {
        const a = node.a === '+1' && 'n' || node.a === '1' && 'n' || node.a === '-1' && '-n' || node.a + 'n';
        if (node.b) {
            const b = node.b[0] === '-' || node.b[0] === '+' ? node.b : '+' + node.b;
            this.tokenize(a + b);
        } else this.tokenize(a);
    } else this.tokenize(node.b);
}
$edfba845328c427b$export$80d376111cc09ad7 = $edfba845328c427b$var$generate;
$edfba845328c427b$export$a8ff84c12d48cfa6 = $edfba845328c427b$var$name;
$edfba845328c427b$export$98e6a39c04603d36 = $edfba845328c427b$var$parse;
$edfba845328c427b$export$46a2a563c28afca0 = $edfba845328c427b$var$structure;

});

parcelRegister("4zWEu", function(module, exports) {

$parcel$export(module.exports, "generate", () => $3557ed5fce58a1d2$export$80d376111cc09ad7, (v) => $3557ed5fce58a1d2$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $3557ed5fce58a1d2$export$a8ff84c12d48cfa6, (v) => $3557ed5fce58a1d2$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $3557ed5fce58a1d2$export$98e6a39c04603d36, (v) => $3557ed5fce58a1d2$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $3557ed5fce58a1d2$export$46a2a563c28afca0, (v) => $3557ed5fce58a1d2$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $3557ed5fce58a1d2$export$f7e0bb689fefb8c2, (v) => $3557ed5fce58a1d2$export$f7e0bb689fefb8c2 = v);
var $3557ed5fce58a1d2$export$80d376111cc09ad7;
var $3557ed5fce58a1d2$export$a8ff84c12d48cfa6;
var $3557ed5fce58a1d2$export$98e6a39c04603d36;
var $3557ed5fce58a1d2$export$46a2a563c28afca0;
var $3557ed5fce58a1d2$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
function $3557ed5fce58a1d2$var$consumeRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilLeftCurlyBracketOrSemicolon, true);
}
function $3557ed5fce58a1d2$var$isDeclarationBlockAtrule() {
    for(let offset = 1, type; type = this.lookupType(offset); offset++){
        if (type === $iYo0F.RightCurlyBracket) return true;
        if (type === $iYo0F.LeftCurlyBracket || type === $iYo0F.AtKeyword) return false;
    }
    return false;
}
const $3557ed5fce58a1d2$var$name = 'Atrule';
const $3557ed5fce58a1d2$var$walkContext = 'atrule';
const $3557ed5fce58a1d2$var$structure = {
    name: String,
    prelude: [
        'AtrulePrelude',
        'Raw',
        null
    ],
    block: [
        'Block',
        null
    ]
};
function $3557ed5fce58a1d2$var$parse() {
    const start = this.tokenStart;
    let name;
    let nameLowerCase;
    let prelude = null;
    let block = null;
    this.eat($iYo0F.AtKeyword);
    name = this.substrToCursor(start + 1);
    nameLowerCase = name.toLowerCase();
    this.skipSC();
    // parse prelude
    if (this.eof === false && this.tokenType !== $iYo0F.LeftCurlyBracket && this.tokenType !== $iYo0F.Semicolon) {
        if (this.parseAtrulePrelude) prelude = this.parseWithFallback(this.AtrulePrelude.bind(this, name), $3557ed5fce58a1d2$var$consumeRaw);
        else prelude = $3557ed5fce58a1d2$var$consumeRaw.call(this, this.tokenIndex);
        this.skipSC();
    }
    switch(this.tokenType){
        case $iYo0F.Semicolon:
            this.next();
            break;
        case $iYo0F.LeftCurlyBracket:
            if (hasOwnProperty.call(this.atrule, nameLowerCase) && typeof this.atrule[nameLowerCase].block === 'function') block = this.atrule[nameLowerCase].block.call(this);
            else // TODO: should consume block content as Raw?
            block = this.Block($3557ed5fce58a1d2$var$isDeclarationBlockAtrule.call(this));
            break;
    }
    return {
        type: 'Atrule',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        prelude: prelude,
        block: block
    };
}
function $3557ed5fce58a1d2$var$generate(node) {
    this.token($iYo0F.AtKeyword, '@' + node.name);
    if (node.prelude !== null) this.node(node.prelude);
    if (node.block) this.node(node.block);
    else this.token($iYo0F.Semicolon, ';');
}
$3557ed5fce58a1d2$export$80d376111cc09ad7 = $3557ed5fce58a1d2$var$generate;
$3557ed5fce58a1d2$export$a8ff84c12d48cfa6 = $3557ed5fce58a1d2$var$name;
$3557ed5fce58a1d2$export$98e6a39c04603d36 = $3557ed5fce58a1d2$var$parse;
$3557ed5fce58a1d2$export$46a2a563c28afca0 = $3557ed5fce58a1d2$var$structure;
$3557ed5fce58a1d2$export$f7e0bb689fefb8c2 = $3557ed5fce58a1d2$var$walkContext;

});

parcelRegister("a6F6BB", function(module, exports) {

$parcel$export(module.exports, "generate", () => $75ba599f24587a9f$export$80d376111cc09ad7, (v) => $75ba599f24587a9f$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $75ba599f24587a9f$export$a8ff84c12d48cfa6, (v) => $75ba599f24587a9f$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $75ba599f24587a9f$export$98e6a39c04603d36, (v) => $75ba599f24587a9f$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $75ba599f24587a9f$export$46a2a563c28afca0, (v) => $75ba599f24587a9f$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $75ba599f24587a9f$export$f7e0bb689fefb8c2, (v) => $75ba599f24587a9f$export$f7e0bb689fefb8c2 = v);
var $75ba599f24587a9f$export$80d376111cc09ad7;
var $75ba599f24587a9f$export$a8ff84c12d48cfa6;
var $75ba599f24587a9f$export$98e6a39c04603d36;
var $75ba599f24587a9f$export$46a2a563c28afca0;
var $75ba599f24587a9f$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $75ba599f24587a9f$var$name = 'AtrulePrelude';
const $75ba599f24587a9f$var$walkContext = 'atrulePrelude';
const $75ba599f24587a9f$var$structure = {
    children: [
        []
    ]
};
function $75ba599f24587a9f$var$parse(name) {
    let children = null;
    if (name !== null) name = name.toLowerCase();
    this.skipSC();
    if (hasOwnProperty.call(this.atrule, name) && typeof this.atrule[name].prelude === 'function') // custom consumer
    children = this.atrule[name].prelude.call(this);
    else // default consumer
    children = this.readSequence(this.scope.AtrulePrelude);
    this.skipSC();
    if (this.eof !== true && this.tokenType !== $iYo0F.LeftCurlyBracket && this.tokenType !== $iYo0F.Semicolon) this.error('Semicolon or block is expected');
    return {
        type: 'AtrulePrelude',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $75ba599f24587a9f$var$generate(node) {
    this.children(node);
}
$75ba599f24587a9f$export$80d376111cc09ad7 = $75ba599f24587a9f$var$generate;
$75ba599f24587a9f$export$a8ff84c12d48cfa6 = $75ba599f24587a9f$var$name;
$75ba599f24587a9f$export$98e6a39c04603d36 = $75ba599f24587a9f$var$parse;
$75ba599f24587a9f$export$46a2a563c28afca0 = $75ba599f24587a9f$var$structure;
$75ba599f24587a9f$export$f7e0bb689fefb8c2 = $75ba599f24587a9f$var$walkContext;

});

parcelRegister("is1r8", function(module, exports) {

$parcel$export(module.exports, "generate", () => $d6ebf4cc7a0493b1$export$80d376111cc09ad7, (v) => $d6ebf4cc7a0493b1$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $d6ebf4cc7a0493b1$export$a8ff84c12d48cfa6, (v) => $d6ebf4cc7a0493b1$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $d6ebf4cc7a0493b1$export$98e6a39c04603d36, (v) => $d6ebf4cc7a0493b1$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $d6ebf4cc7a0493b1$export$46a2a563c28afca0, (v) => $d6ebf4cc7a0493b1$export$46a2a563c28afca0 = v);
var $d6ebf4cc7a0493b1$export$80d376111cc09ad7;
var $d6ebf4cc7a0493b1$export$a8ff84c12d48cfa6;
var $d6ebf4cc7a0493b1$export$98e6a39c04603d36;
var $d6ebf4cc7a0493b1$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $d6ebf4cc7a0493b1$var$DOLLARSIGN = 0x0024; // U+0024 DOLLAR SIGN ($)
const $d6ebf4cc7a0493b1$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $d6ebf4cc7a0493b1$var$EQUALSSIGN = 0x003D; // U+003D EQUALS SIGN (=)
const $d6ebf4cc7a0493b1$var$CIRCUMFLEXACCENT = 0x005E; // U+005E (^)
const $d6ebf4cc7a0493b1$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
const $d6ebf4cc7a0493b1$var$TILDE = 0x007E; // U+007E TILDE (~)
function $d6ebf4cc7a0493b1$var$getAttributeName() {
    if (this.eof) this.error('Unexpected end of input');
    const start = this.tokenStart;
    let expectIdent = false;
    if (this.isDelim($d6ebf4cc7a0493b1$var$ASTERISK)) {
        expectIdent = true;
        this.next();
    } else if (!this.isDelim($d6ebf4cc7a0493b1$var$VERTICALLINE)) this.eat($iYo0F.Ident);
    if (this.isDelim($d6ebf4cc7a0493b1$var$VERTICALLINE)) {
        if (this.charCodeAt(this.tokenStart + 1) !== $d6ebf4cc7a0493b1$var$EQUALSSIGN) {
            this.next();
            this.eat($iYo0F.Ident);
        } else if (expectIdent) this.error('Identifier is expected', this.tokenEnd);
    } else if (expectIdent) this.error('Vertical line is expected');
    return {
        type: 'Identifier',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start)
    };
}
function $d6ebf4cc7a0493b1$var$getOperator() {
    const start = this.tokenStart;
    const code = this.charCodeAt(start);
    if (code !== $d6ebf4cc7a0493b1$var$EQUALSSIGN && // =
    code !== $d6ebf4cc7a0493b1$var$TILDE && // ~=
    code !== $d6ebf4cc7a0493b1$var$CIRCUMFLEXACCENT && // ^=
    code !== $d6ebf4cc7a0493b1$var$DOLLARSIGN && // $=
    code !== $d6ebf4cc7a0493b1$var$ASTERISK && // *=
    code !== $d6ebf4cc7a0493b1$var$VERTICALLINE // |=
    ) this.error('Attribute selector (=, ~=, ^=, $=, *=, |=) is expected');
    this.next();
    if (code !== $d6ebf4cc7a0493b1$var$EQUALSSIGN) {
        if (!this.isDelim($d6ebf4cc7a0493b1$var$EQUALSSIGN)) this.error('Equal sign is expected');
        this.next();
    }
    return this.substrToCursor(start);
}
// '[' <wq-name> ']'
// '[' <wq-name> <attr-matcher> [ <string-token> | <ident-token> ] <attr-modifier>? ']'
const $d6ebf4cc7a0493b1$var$name = 'AttributeSelector';
const $d6ebf4cc7a0493b1$var$structure = {
    name: 'Identifier',
    matcher: [
        String,
        null
    ],
    value: [
        'String',
        'Identifier',
        null
    ],
    flags: [
        String,
        null
    ]
};
function $d6ebf4cc7a0493b1$var$parse() {
    const start = this.tokenStart;
    let name;
    let matcher = null;
    let value = null;
    let flags = null;
    this.eat($iYo0F.LeftSquareBracket);
    this.skipSC();
    name = $d6ebf4cc7a0493b1$var$getAttributeName.call(this);
    this.skipSC();
    if (this.tokenType !== $iYo0F.RightSquareBracket) {
        // avoid case `[name i]`
        if (this.tokenType !== $iYo0F.Ident) {
            matcher = $d6ebf4cc7a0493b1$var$getOperator.call(this);
            this.skipSC();
            value = this.tokenType === $iYo0F.String ? this.String() : this.Identifier();
            this.skipSC();
        }
        // attribute flags
        if (this.tokenType === $iYo0F.Ident) {
            flags = this.consume($iYo0F.Ident);
            this.skipSC();
        }
    }
    this.eat($iYo0F.RightSquareBracket);
    return {
        type: 'AttributeSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        matcher: matcher,
        value: value,
        flags: flags
    };
}
function $d6ebf4cc7a0493b1$var$generate(node) {
    this.token($iYo0F.Delim, '[');
    this.node(node.name);
    if (node.matcher !== null) {
        this.tokenize(node.matcher);
        this.node(node.value);
    }
    if (node.flags !== null) this.token($iYo0F.Ident, node.flags);
    this.token($iYo0F.Delim, ']');
}
$d6ebf4cc7a0493b1$export$80d376111cc09ad7 = $d6ebf4cc7a0493b1$var$generate;
$d6ebf4cc7a0493b1$export$a8ff84c12d48cfa6 = $d6ebf4cc7a0493b1$var$name;
$d6ebf4cc7a0493b1$export$98e6a39c04603d36 = $d6ebf4cc7a0493b1$var$parse;
$d6ebf4cc7a0493b1$export$46a2a563c28afca0 = $d6ebf4cc7a0493b1$var$structure;

});

parcelRegister("f7sOf", function(module, exports) {

$parcel$export(module.exports, "generate", () => $b01ddb6c9478a491$export$80d376111cc09ad7, (v) => $b01ddb6c9478a491$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $b01ddb6c9478a491$export$a8ff84c12d48cfa6, (v) => $b01ddb6c9478a491$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $b01ddb6c9478a491$export$98e6a39c04603d36, (v) => $b01ddb6c9478a491$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $b01ddb6c9478a491$export$46a2a563c28afca0, (v) => $b01ddb6c9478a491$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $b01ddb6c9478a491$export$f7e0bb689fefb8c2, (v) => $b01ddb6c9478a491$export$f7e0bb689fefb8c2 = v);
var $b01ddb6c9478a491$export$80d376111cc09ad7;
var $b01ddb6c9478a491$export$a8ff84c12d48cfa6;
var $b01ddb6c9478a491$export$98e6a39c04603d36;
var $b01ddb6c9478a491$export$46a2a563c28afca0;
var $b01ddb6c9478a491$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
function $b01ddb6c9478a491$var$consumeRaw(startToken) {
    return this.Raw(startToken, null, true);
}
function $b01ddb6c9478a491$var$consumeRule() {
    return this.parseWithFallback(this.Rule, $b01ddb6c9478a491$var$consumeRaw);
}
function $b01ddb6c9478a491$var$consumeRawDeclaration(startToken) {
    return this.Raw(startToken, this.consumeUntilSemicolonIncluded, true);
}
function $b01ddb6c9478a491$var$consumeDeclaration() {
    if (this.tokenType === $iYo0F.Semicolon) return $b01ddb6c9478a491$var$consumeRawDeclaration.call(this, this.tokenIndex);
    const node = this.parseWithFallback(this.Declaration, $b01ddb6c9478a491$var$consumeRawDeclaration);
    if (this.tokenType === $iYo0F.Semicolon) this.next();
    return node;
}
const $b01ddb6c9478a491$var$name = 'Block';
const $b01ddb6c9478a491$var$walkContext = 'block';
const $b01ddb6c9478a491$var$structure = {
    children: [
        [
            'Atrule',
            'Rule',
            'Declaration'
        ]
    ]
};
function $b01ddb6c9478a491$var$parse(isDeclaration) {
    const consumer = isDeclaration ? $b01ddb6c9478a491$var$consumeDeclaration : $b01ddb6c9478a491$var$consumeRule;
    const start = this.tokenStart;
    let children = this.createList();
    this.eat($iYo0F.LeftCurlyBracket);
    scan: while(!this.eof)switch(this.tokenType){
        case $iYo0F.RightCurlyBracket:
            break scan;
        case $iYo0F.WhiteSpace:
        case $iYo0F.Comment:
            this.next();
            break;
        case $iYo0F.AtKeyword:
            children.push(this.parseWithFallback(this.Atrule, $b01ddb6c9478a491$var$consumeRaw));
            break;
        default:
            children.push(consumer.call(this));
    }
    if (!this.eof) this.eat($iYo0F.RightCurlyBracket);
    return {
        type: 'Block',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $b01ddb6c9478a491$var$generate(node) {
    this.token($iYo0F.LeftCurlyBracket, '{');
    this.children(node, (prev)=>{
        if (prev.type === 'Declaration') this.token($iYo0F.Semicolon, ';');
    });
    this.token($iYo0F.RightCurlyBracket, '}');
}
$b01ddb6c9478a491$export$80d376111cc09ad7 = $b01ddb6c9478a491$var$generate;
$b01ddb6c9478a491$export$a8ff84c12d48cfa6 = $b01ddb6c9478a491$var$name;
$b01ddb6c9478a491$export$98e6a39c04603d36 = $b01ddb6c9478a491$var$parse;
$b01ddb6c9478a491$export$46a2a563c28afca0 = $b01ddb6c9478a491$var$structure;
$b01ddb6c9478a491$export$f7e0bb689fefb8c2 = $b01ddb6c9478a491$var$walkContext;

});

parcelRegister("8xr0b", function(module, exports) {

$parcel$export(module.exports, "generate", () => $637659cf30e636c8$export$80d376111cc09ad7, (v) => $637659cf30e636c8$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $637659cf30e636c8$export$a8ff84c12d48cfa6, (v) => $637659cf30e636c8$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $637659cf30e636c8$export$98e6a39c04603d36, (v) => $637659cf30e636c8$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $637659cf30e636c8$export$46a2a563c28afca0, (v) => $637659cf30e636c8$export$46a2a563c28afca0 = v);
var $637659cf30e636c8$export$80d376111cc09ad7;
var $637659cf30e636c8$export$a8ff84c12d48cfa6;
var $637659cf30e636c8$export$98e6a39c04603d36;
var $637659cf30e636c8$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $637659cf30e636c8$var$name = 'Brackets';
const $637659cf30e636c8$var$structure = {
    children: [
        []
    ]
};
function $637659cf30e636c8$var$parse(readSequence, recognizer) {
    const start = this.tokenStart;
    let children = null;
    this.eat($iYo0F.LeftSquareBracket);
    children = readSequence.call(this, recognizer);
    if (!this.eof) this.eat($iYo0F.RightSquareBracket);
    return {
        type: 'Brackets',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $637659cf30e636c8$var$generate(node) {
    this.token($iYo0F.Delim, '[');
    this.children(node);
    this.token($iYo0F.Delim, ']');
}
$637659cf30e636c8$export$80d376111cc09ad7 = $637659cf30e636c8$var$generate;
$637659cf30e636c8$export$a8ff84c12d48cfa6 = $637659cf30e636c8$var$name;
$637659cf30e636c8$export$98e6a39c04603d36 = $637659cf30e636c8$var$parse;
$637659cf30e636c8$export$46a2a563c28afca0 = $637659cf30e636c8$var$structure;

});

parcelRegister("jplhI", function(module, exports) {

$parcel$export(module.exports, "generate", () => $e210dcce6f2e917a$export$80d376111cc09ad7, (v) => $e210dcce6f2e917a$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $e210dcce6f2e917a$export$a8ff84c12d48cfa6, (v) => $e210dcce6f2e917a$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $e210dcce6f2e917a$export$98e6a39c04603d36, (v) => $e210dcce6f2e917a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $e210dcce6f2e917a$export$46a2a563c28afca0, (v) => $e210dcce6f2e917a$export$46a2a563c28afca0 = v);
var $e210dcce6f2e917a$export$80d376111cc09ad7;
var $e210dcce6f2e917a$export$a8ff84c12d48cfa6;
var $e210dcce6f2e917a$export$98e6a39c04603d36;
var $e210dcce6f2e917a$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $e210dcce6f2e917a$var$name = 'CDC';
const $e210dcce6f2e917a$var$structure = [];
function $e210dcce6f2e917a$var$parse() {
    const start = this.tokenStart;
    this.eat($iYo0F.CDC); // -->
    return {
        type: 'CDC',
        loc: this.getLocation(start, this.tokenStart)
    };
}
function $e210dcce6f2e917a$var$generate() {
    this.token($iYo0F.CDC, '-->');
}
$e210dcce6f2e917a$export$80d376111cc09ad7 = $e210dcce6f2e917a$var$generate;
$e210dcce6f2e917a$export$a8ff84c12d48cfa6 = $e210dcce6f2e917a$var$name;
$e210dcce6f2e917a$export$98e6a39c04603d36 = $e210dcce6f2e917a$var$parse;
$e210dcce6f2e917a$export$46a2a563c28afca0 = $e210dcce6f2e917a$var$structure;

});

parcelRegister("hQNxd", function(module, exports) {

$parcel$export(module.exports, "generate", () => $cfedb790d7a27142$export$80d376111cc09ad7, (v) => $cfedb790d7a27142$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $cfedb790d7a27142$export$a8ff84c12d48cfa6, (v) => $cfedb790d7a27142$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $cfedb790d7a27142$export$98e6a39c04603d36, (v) => $cfedb790d7a27142$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $cfedb790d7a27142$export$46a2a563c28afca0, (v) => $cfedb790d7a27142$export$46a2a563c28afca0 = v);
var $cfedb790d7a27142$export$80d376111cc09ad7;
var $cfedb790d7a27142$export$a8ff84c12d48cfa6;
var $cfedb790d7a27142$export$98e6a39c04603d36;
var $cfedb790d7a27142$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $cfedb790d7a27142$var$name = 'CDO';
const $cfedb790d7a27142$var$structure = [];
function $cfedb790d7a27142$var$parse() {
    const start = this.tokenStart;
    this.eat($iYo0F.CDO); // <!--
    return {
        type: 'CDO',
        loc: this.getLocation(start, this.tokenStart)
    };
}
function $cfedb790d7a27142$var$generate() {
    this.token($iYo0F.CDO, '<!--');
}
$cfedb790d7a27142$export$80d376111cc09ad7 = $cfedb790d7a27142$var$generate;
$cfedb790d7a27142$export$a8ff84c12d48cfa6 = $cfedb790d7a27142$var$name;
$cfedb790d7a27142$export$98e6a39c04603d36 = $cfedb790d7a27142$var$parse;
$cfedb790d7a27142$export$46a2a563c28afca0 = $cfedb790d7a27142$var$structure;

});

parcelRegister("7VwxD", function(module, exports) {

$parcel$export(module.exports, "generate", () => $5c571958887f088b$export$80d376111cc09ad7, (v) => $5c571958887f088b$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $5c571958887f088b$export$a8ff84c12d48cfa6, (v) => $5c571958887f088b$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $5c571958887f088b$export$98e6a39c04603d36, (v) => $5c571958887f088b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $5c571958887f088b$export$46a2a563c28afca0, (v) => $5c571958887f088b$export$46a2a563c28afca0 = v);
var $5c571958887f088b$export$80d376111cc09ad7;
var $5c571958887f088b$export$a8ff84c12d48cfa6;
var $5c571958887f088b$export$98e6a39c04603d36;
var $5c571958887f088b$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $5c571958887f088b$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
// '.' ident
const $5c571958887f088b$var$name = 'ClassSelector';
const $5c571958887f088b$var$structure = {
    name: String
};
function $5c571958887f088b$var$parse() {
    this.eatDelim($5c571958887f088b$var$FULLSTOP);
    return {
        type: 'ClassSelector',
        loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
        name: this.consume($iYo0F.Ident)
    };
}
function $5c571958887f088b$var$generate(node) {
    this.token($iYo0F.Delim, '.');
    this.token($iYo0F.Ident, node.name);
}
$5c571958887f088b$export$80d376111cc09ad7 = $5c571958887f088b$var$generate;
$5c571958887f088b$export$a8ff84c12d48cfa6 = $5c571958887f088b$var$name;
$5c571958887f088b$export$98e6a39c04603d36 = $5c571958887f088b$var$parse;
$5c571958887f088b$export$46a2a563c28afca0 = $5c571958887f088b$var$structure;

});

parcelRegister("aNcVJ", function(module, exports) {

$parcel$export(module.exports, "generate", () => $7db882a120680c46$export$80d376111cc09ad7, (v) => $7db882a120680c46$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $7db882a120680c46$export$a8ff84c12d48cfa6, (v) => $7db882a120680c46$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $7db882a120680c46$export$98e6a39c04603d36, (v) => $7db882a120680c46$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $7db882a120680c46$export$46a2a563c28afca0, (v) => $7db882a120680c46$export$46a2a563c28afca0 = v);
var $7db882a120680c46$export$80d376111cc09ad7;
var $7db882a120680c46$export$a8ff84c12d48cfa6;
var $7db882a120680c46$export$98e6a39c04603d36;
var $7db882a120680c46$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $7db882a120680c46$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $7db882a120680c46$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $7db882a120680c46$var$GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
const $7db882a120680c46$var$TILDE = 0x007E; // U+007E TILDE (~)
const $7db882a120680c46$var$name = 'Combinator';
const $7db882a120680c46$var$structure = {
    name: String
};
// + | > | ~ | /deep/
function $7db882a120680c46$var$parse() {
    const start = this.tokenStart;
    let name;
    switch(this.tokenType){
        case $iYo0F.WhiteSpace:
            name = ' ';
            break;
        case $iYo0F.Delim:
            switch(this.charCodeAt(this.tokenStart)){
                case $7db882a120680c46$var$GREATERTHANSIGN:
                case $7db882a120680c46$var$PLUSSIGN:
                case $7db882a120680c46$var$TILDE:
                    this.next();
                    break;
                case $7db882a120680c46$var$SOLIDUS:
                    this.next();
                    this.eatIdent('deep');
                    this.eatDelim($7db882a120680c46$var$SOLIDUS);
                    break;
                default:
                    this.error('Combinator is expected');
            }
            name = this.substrToCursor(start);
            break;
    }
    return {
        type: 'Combinator',
        loc: this.getLocation(start, this.tokenStart),
        name: name
    };
}
function $7db882a120680c46$var$generate(node) {
    this.tokenize(node.name);
}
$7db882a120680c46$export$80d376111cc09ad7 = $7db882a120680c46$var$generate;
$7db882a120680c46$export$a8ff84c12d48cfa6 = $7db882a120680c46$var$name;
$7db882a120680c46$export$98e6a39c04603d36 = $7db882a120680c46$var$parse;
$7db882a120680c46$export$46a2a563c28afca0 = $7db882a120680c46$var$structure;

});

parcelRegister("hSilY", function(module, exports) {

$parcel$export(module.exports, "generate", () => $d035b7682f20b249$export$80d376111cc09ad7, (v) => $d035b7682f20b249$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $d035b7682f20b249$export$a8ff84c12d48cfa6, (v) => $d035b7682f20b249$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $d035b7682f20b249$export$98e6a39c04603d36, (v) => $d035b7682f20b249$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $d035b7682f20b249$export$46a2a563c28afca0, (v) => $d035b7682f20b249$export$46a2a563c28afca0 = v);
var $d035b7682f20b249$export$80d376111cc09ad7;
var $d035b7682f20b249$export$a8ff84c12d48cfa6;
var $d035b7682f20b249$export$98e6a39c04603d36;
var $d035b7682f20b249$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $d035b7682f20b249$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $d035b7682f20b249$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $d035b7682f20b249$var$name = 'Comment';
const $d035b7682f20b249$var$structure = {
    value: String
};
function $d035b7682f20b249$var$parse() {
    const start = this.tokenStart;
    let end = this.tokenEnd;
    this.eat($iYo0F.Comment);
    if (end - start + 2 >= 2 && this.charCodeAt(end - 2) === $d035b7682f20b249$var$ASTERISK && this.charCodeAt(end - 1) === $d035b7682f20b249$var$SOLIDUS) end -= 2;
    return {
        type: 'Comment',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substring(start + 2, end)
    };
}
function $d035b7682f20b249$var$generate(node) {
    this.token($iYo0F.Comment, '/*' + node.value + '*/');
}
$d035b7682f20b249$export$80d376111cc09ad7 = $d035b7682f20b249$var$generate;
$d035b7682f20b249$export$a8ff84c12d48cfa6 = $d035b7682f20b249$var$name;
$d035b7682f20b249$export$98e6a39c04603d36 = $d035b7682f20b249$var$parse;
$d035b7682f20b249$export$46a2a563c28afca0 = $d035b7682f20b249$var$structure;

});

parcelRegister("bpQLC", function(module, exports) {

$parcel$export(module.exports, "generate", () => $84faf5f652502063$export$80d376111cc09ad7, (v) => $84faf5f652502063$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $84faf5f652502063$export$a8ff84c12d48cfa6, (v) => $84faf5f652502063$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $84faf5f652502063$export$98e6a39c04603d36, (v) => $84faf5f652502063$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $84faf5f652502063$export$46a2a563c28afca0, (v) => $84faf5f652502063$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $84faf5f652502063$export$f7e0bb689fefb8c2, (v) => $84faf5f652502063$export$f7e0bb689fefb8c2 = v);
var $84faf5f652502063$export$80d376111cc09ad7;
var $84faf5f652502063$export$a8ff84c12d48cfa6;
var $84faf5f652502063$export$98e6a39c04603d36;
var $84faf5f652502063$export$46a2a563c28afca0;
var $84faf5f652502063$export$f7e0bb689fefb8c2;
'use strict';

var $jJe0G = parcelRequire("jJe0G");

var $iYo0F = parcelRequire("iYo0F");
const $84faf5f652502063$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
const $84faf5f652502063$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $84faf5f652502063$var$DOLLARSIGN = 0x0024; // U+0024 DOLLAR SIGN ($)
const $84faf5f652502063$var$AMPERSAND = 0x0026; // U+0026 AMPERSAND (&)
const $84faf5f652502063$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $84faf5f652502063$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $84faf5f652502063$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
function $84faf5f652502063$var$consumeValueRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilExclamationMarkOrSemicolon, true);
}
function $84faf5f652502063$var$consumeCustomPropertyRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilExclamationMarkOrSemicolon, false);
}
function $84faf5f652502063$var$consumeValue() {
    const startValueToken = this.tokenIndex;
    const value = this.Value();
    if (value.type !== 'Raw' && this.eof === false && this.tokenType !== $iYo0F.Semicolon && this.isDelim($84faf5f652502063$var$EXCLAMATIONMARK) === false && this.isBalanceEdge(startValueToken) === false) this.error();
    return value;
}
const $84faf5f652502063$var$name = 'Declaration';
const $84faf5f652502063$var$walkContext = 'declaration';
const $84faf5f652502063$var$structure = {
    important: [
        Boolean,
        String
    ],
    property: String,
    value: [
        'Value',
        'Raw'
    ]
};
function $84faf5f652502063$var$parse() {
    const start = this.tokenStart;
    const startToken = this.tokenIndex;
    const property = $84faf5f652502063$var$readProperty.call(this);
    const customProperty = $jJe0G.isCustomProperty(property);
    const parseValue = customProperty ? this.parseCustomProperty : this.parseValue;
    const consumeRaw = customProperty ? $84faf5f652502063$var$consumeCustomPropertyRaw : $84faf5f652502063$var$consumeValueRaw;
    let important = false;
    let value;
    this.skipSC();
    this.eat($iYo0F.Colon);
    const valueStart = this.tokenIndex;
    if (!customProperty) this.skipSC();
    if (parseValue) value = this.parseWithFallback($84faf5f652502063$var$consumeValue, consumeRaw);
    else value = consumeRaw.call(this, this.tokenIndex);
    if (customProperty && value.type === 'Value' && value.children.isEmpty) {
        for(let offset = valueStart - this.tokenIndex; offset <= 0; offset++)if (this.lookupType(offset) === $iYo0F.WhiteSpace) {
            value.children.appendData({
                type: 'WhiteSpace',
                loc: null,
                value: ' '
            });
            break;
        }
    }
    if (this.isDelim($84faf5f652502063$var$EXCLAMATIONMARK)) {
        important = $84faf5f652502063$var$getImportant.call(this);
        this.skipSC();
    }
    // Do not include semicolon to range per spec
    // https://drafts.csswg.org/css-syntax/#declaration-diagram
    if (this.eof === false && this.tokenType !== $iYo0F.Semicolon && this.isBalanceEdge(startToken) === false) this.error();
    return {
        type: 'Declaration',
        loc: this.getLocation(start, this.tokenStart),
        important: important,
        property: property,
        value: value
    };
}
function $84faf5f652502063$var$generate(node) {
    this.token($iYo0F.Ident, node.property);
    this.token($iYo0F.Colon, ':');
    this.node(node.value);
    if (node.important) {
        this.token($iYo0F.Delim, '!');
        this.token($iYo0F.Ident, node.important === true ? 'important' : node.important);
    }
}
function $84faf5f652502063$var$readProperty() {
    const start = this.tokenStart;
    // hacks
    if (this.tokenType === $iYo0F.Delim) switch(this.charCodeAt(this.tokenStart)){
        case $84faf5f652502063$var$ASTERISK:
        case $84faf5f652502063$var$DOLLARSIGN:
        case $84faf5f652502063$var$PLUSSIGN:
        case $84faf5f652502063$var$NUMBERSIGN:
        case $84faf5f652502063$var$AMPERSAND:
            this.next();
            break;
        // TODO: not sure we should support this hack
        case $84faf5f652502063$var$SOLIDUS:
            this.next();
            if (this.isDelim($84faf5f652502063$var$SOLIDUS)) this.next();
            break;
    }
    if (this.tokenType === $iYo0F.Hash) this.eat($iYo0F.Hash);
    else this.eat($iYo0F.Ident);
    return this.substrToCursor(start);
}
// ! ws* important
function $84faf5f652502063$var$getImportant() {
    this.eat($iYo0F.Delim);
    this.skipSC();
    const important = this.consume($iYo0F.Ident);
    // store original value in case it differ from `important`
    // for better original source restoring and hacks like `!ie` support
    return important === 'important' ? true : important;
}
$84faf5f652502063$export$80d376111cc09ad7 = $84faf5f652502063$var$generate;
$84faf5f652502063$export$a8ff84c12d48cfa6 = $84faf5f652502063$var$name;
$84faf5f652502063$export$98e6a39c04603d36 = $84faf5f652502063$var$parse;
$84faf5f652502063$export$46a2a563c28afca0 = $84faf5f652502063$var$structure;
$84faf5f652502063$export$f7e0bb689fefb8c2 = $84faf5f652502063$var$walkContext;

});

parcelRegister("ksrhQ", function(module, exports) {

$parcel$export(module.exports, "generate", () => $ee4b96bfbe247012$export$80d376111cc09ad7, (v) => $ee4b96bfbe247012$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $ee4b96bfbe247012$export$a8ff84c12d48cfa6, (v) => $ee4b96bfbe247012$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $ee4b96bfbe247012$export$98e6a39c04603d36, (v) => $ee4b96bfbe247012$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $ee4b96bfbe247012$export$46a2a563c28afca0, (v) => $ee4b96bfbe247012$export$46a2a563c28afca0 = v);
var $ee4b96bfbe247012$export$80d376111cc09ad7;
var $ee4b96bfbe247012$export$a8ff84c12d48cfa6;
var $ee4b96bfbe247012$export$98e6a39c04603d36;
var $ee4b96bfbe247012$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
function $ee4b96bfbe247012$var$consumeRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilSemicolonIncluded, true);
}
const $ee4b96bfbe247012$var$name = 'DeclarationList';
const $ee4b96bfbe247012$var$structure = {
    children: [
        [
            'Declaration'
        ]
    ]
};
function $ee4b96bfbe247012$var$parse() {
    const children = this.createList();
    while(!this.eof)switch(this.tokenType){
        case $iYo0F.WhiteSpace:
        case $iYo0F.Comment:
        case $iYo0F.Semicolon:
            this.next();
            break;
        default:
            children.push(this.parseWithFallback(this.Declaration, $ee4b96bfbe247012$var$consumeRaw));
    }
    return {
        type: 'DeclarationList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $ee4b96bfbe247012$var$generate(node) {
    this.children(node, (prev)=>{
        if (prev.type === 'Declaration') this.token($iYo0F.Semicolon, ';');
    });
}
$ee4b96bfbe247012$export$80d376111cc09ad7 = $ee4b96bfbe247012$var$generate;
$ee4b96bfbe247012$export$a8ff84c12d48cfa6 = $ee4b96bfbe247012$var$name;
$ee4b96bfbe247012$export$98e6a39c04603d36 = $ee4b96bfbe247012$var$parse;
$ee4b96bfbe247012$export$46a2a563c28afca0 = $ee4b96bfbe247012$var$structure;

});

parcelRegister("ej7Bo", function(module, exports) {

$parcel$export(module.exports, "generate", () => $a6a8bca39895ef32$export$80d376111cc09ad7, (v) => $a6a8bca39895ef32$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $a6a8bca39895ef32$export$a8ff84c12d48cfa6, (v) => $a6a8bca39895ef32$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $a6a8bca39895ef32$export$98e6a39c04603d36, (v) => $a6a8bca39895ef32$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $a6a8bca39895ef32$export$46a2a563c28afca0, (v) => $a6a8bca39895ef32$export$46a2a563c28afca0 = v);
var $a6a8bca39895ef32$export$80d376111cc09ad7;
var $a6a8bca39895ef32$export$a8ff84c12d48cfa6;
var $a6a8bca39895ef32$export$98e6a39c04603d36;
var $a6a8bca39895ef32$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $a6a8bca39895ef32$var$name = 'Dimension';
const $a6a8bca39895ef32$var$structure = {
    value: String,
    unit: String
};
function $a6a8bca39895ef32$var$parse() {
    const start = this.tokenStart;
    const value = this.consumeNumber($iYo0F.Dimension);
    return {
        type: 'Dimension',
        loc: this.getLocation(start, this.tokenStart),
        value: value,
        unit: this.substring(start + value.length, this.tokenStart)
    };
}
function $a6a8bca39895ef32$var$generate(node) {
    this.token($iYo0F.Dimension, node.value + node.unit);
}
$a6a8bca39895ef32$export$80d376111cc09ad7 = $a6a8bca39895ef32$var$generate;
$a6a8bca39895ef32$export$a8ff84c12d48cfa6 = $a6a8bca39895ef32$var$name;
$a6a8bca39895ef32$export$98e6a39c04603d36 = $a6a8bca39895ef32$var$parse;
$a6a8bca39895ef32$export$46a2a563c28afca0 = $a6a8bca39895ef32$var$structure;

});

parcelRegister("gGYMY", function(module, exports) {

$parcel$export(module.exports, "generate", () => $c26fb9014f010e41$export$80d376111cc09ad7, (v) => $c26fb9014f010e41$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $c26fb9014f010e41$export$a8ff84c12d48cfa6, (v) => $c26fb9014f010e41$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $c26fb9014f010e41$export$98e6a39c04603d36, (v) => $c26fb9014f010e41$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $c26fb9014f010e41$export$46a2a563c28afca0, (v) => $c26fb9014f010e41$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $c26fb9014f010e41$export$f7e0bb689fefb8c2, (v) => $c26fb9014f010e41$export$f7e0bb689fefb8c2 = v);
var $c26fb9014f010e41$export$80d376111cc09ad7;
var $c26fb9014f010e41$export$a8ff84c12d48cfa6;
var $c26fb9014f010e41$export$98e6a39c04603d36;
var $c26fb9014f010e41$export$46a2a563c28afca0;
var $c26fb9014f010e41$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $c26fb9014f010e41$var$name = 'Function';
const $c26fb9014f010e41$var$walkContext = 'function';
const $c26fb9014f010e41$var$structure = {
    name: String,
    children: [
        []
    ]
};
// <function-token> <sequence> )
function $c26fb9014f010e41$var$parse(readSequence, recognizer) {
    const start = this.tokenStart;
    const name = this.consumeFunctionName();
    const nameLowerCase = name.toLowerCase();
    let children;
    children = recognizer.hasOwnProperty(nameLowerCase) ? recognizer[nameLowerCase].call(this, recognizer) : readSequence.call(this, recognizer);
    if (!this.eof) this.eat($iYo0F.RightParenthesis);
    return {
        type: 'Function',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $c26fb9014f010e41$var$generate(node) {
    this.token($iYo0F.Function, node.name + '(');
    this.children(node);
    this.token($iYo0F.RightParenthesis, ')');
}
$c26fb9014f010e41$export$80d376111cc09ad7 = $c26fb9014f010e41$var$generate;
$c26fb9014f010e41$export$a8ff84c12d48cfa6 = $c26fb9014f010e41$var$name;
$c26fb9014f010e41$export$98e6a39c04603d36 = $c26fb9014f010e41$var$parse;
$c26fb9014f010e41$export$46a2a563c28afca0 = $c26fb9014f010e41$var$structure;
$c26fb9014f010e41$export$f7e0bb689fefb8c2 = $c26fb9014f010e41$var$walkContext;

});

parcelRegister("4I8uN", function(module, exports) {

$parcel$export(module.exports, "generate", () => $36e1dc93f051de9b$export$80d376111cc09ad7, (v) => $36e1dc93f051de9b$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $36e1dc93f051de9b$export$a8ff84c12d48cfa6, (v) => $36e1dc93f051de9b$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $36e1dc93f051de9b$export$98e6a39c04603d36, (v) => $36e1dc93f051de9b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $36e1dc93f051de9b$export$46a2a563c28afca0, (v) => $36e1dc93f051de9b$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "xxx", () => $36e1dc93f051de9b$export$78cbacf5ba6edce7, (v) => $36e1dc93f051de9b$export$78cbacf5ba6edce7 = v);
var $36e1dc93f051de9b$export$80d376111cc09ad7;
var $36e1dc93f051de9b$export$a8ff84c12d48cfa6;
var $36e1dc93f051de9b$export$98e6a39c04603d36;
var $36e1dc93f051de9b$export$46a2a563c28afca0;
var $36e1dc93f051de9b$export$78cbacf5ba6edce7;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
// '#' ident
const $36e1dc93f051de9b$var$xxx = 'XXX';
const $36e1dc93f051de9b$var$name = 'Hash';
const $36e1dc93f051de9b$var$structure = {
    value: String
};
function $36e1dc93f051de9b$var$parse() {
    const start = this.tokenStart;
    this.eat($iYo0F.Hash);
    return {
        type: 'Hash',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start + 1)
    };
}
function $36e1dc93f051de9b$var$generate(node) {
    this.token($iYo0F.Hash, '#' + node.value);
}
$36e1dc93f051de9b$export$80d376111cc09ad7 = $36e1dc93f051de9b$var$generate;
$36e1dc93f051de9b$export$a8ff84c12d48cfa6 = $36e1dc93f051de9b$var$name;
$36e1dc93f051de9b$export$98e6a39c04603d36 = $36e1dc93f051de9b$var$parse;
$36e1dc93f051de9b$export$46a2a563c28afca0 = $36e1dc93f051de9b$var$structure;
$36e1dc93f051de9b$export$78cbacf5ba6edce7 = $36e1dc93f051de9b$var$xxx;

});

parcelRegister("01xxE", function(module, exports) {

$parcel$export(module.exports, "generate", () => $004a1ccc9bafb62a$export$80d376111cc09ad7, (v) => $004a1ccc9bafb62a$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $004a1ccc9bafb62a$export$a8ff84c12d48cfa6, (v) => $004a1ccc9bafb62a$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $004a1ccc9bafb62a$export$98e6a39c04603d36, (v) => $004a1ccc9bafb62a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $004a1ccc9bafb62a$export$46a2a563c28afca0, (v) => $004a1ccc9bafb62a$export$46a2a563c28afca0 = v);
var $004a1ccc9bafb62a$export$80d376111cc09ad7;
var $004a1ccc9bafb62a$export$a8ff84c12d48cfa6;
var $004a1ccc9bafb62a$export$98e6a39c04603d36;
var $004a1ccc9bafb62a$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $004a1ccc9bafb62a$var$name = 'Identifier';
const $004a1ccc9bafb62a$var$structure = {
    name: String
};
function $004a1ccc9bafb62a$var$parse() {
    return {
        type: 'Identifier',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        name: this.consume($iYo0F.Ident)
    };
}
function $004a1ccc9bafb62a$var$generate(node) {
    this.token($iYo0F.Ident, node.name);
}
$004a1ccc9bafb62a$export$80d376111cc09ad7 = $004a1ccc9bafb62a$var$generate;
$004a1ccc9bafb62a$export$a8ff84c12d48cfa6 = $004a1ccc9bafb62a$var$name;
$004a1ccc9bafb62a$export$98e6a39c04603d36 = $004a1ccc9bafb62a$var$parse;
$004a1ccc9bafb62a$export$46a2a563c28afca0 = $004a1ccc9bafb62a$var$structure;

});

parcelRegister("an8qD", function(module, exports) {

$parcel$export(module.exports, "generate", () => $78d29720b8ced031$export$80d376111cc09ad7, (v) => $78d29720b8ced031$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $78d29720b8ced031$export$a8ff84c12d48cfa6, (v) => $78d29720b8ced031$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $78d29720b8ced031$export$98e6a39c04603d36, (v) => $78d29720b8ced031$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $78d29720b8ced031$export$46a2a563c28afca0, (v) => $78d29720b8ced031$export$46a2a563c28afca0 = v);
var $78d29720b8ced031$export$80d376111cc09ad7;
var $78d29720b8ced031$export$a8ff84c12d48cfa6;
var $78d29720b8ced031$export$98e6a39c04603d36;
var $78d29720b8ced031$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $78d29720b8ced031$var$name = 'IdSelector';
const $78d29720b8ced031$var$structure = {
    name: String
};
function $78d29720b8ced031$var$parse() {
    const start = this.tokenStart;
    // TODO: check value is an ident
    this.eat($iYo0F.Hash);
    return {
        type: 'IdSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start + 1)
    };
}
function $78d29720b8ced031$var$generate(node) {
    // Using Delim instead of Hash is a hack to avoid for a whitespace between ident and id-selector
    // in safe mode (e.g. "a#id"), because IE11 doesn't allow a sequence <ident-token> <hash-token>
    // without a whitespace in values (e.g. "1px solid#000")
    this.token($iYo0F.Delim, '#' + node.name);
}
$78d29720b8ced031$export$80d376111cc09ad7 = $78d29720b8ced031$var$generate;
$78d29720b8ced031$export$a8ff84c12d48cfa6 = $78d29720b8ced031$var$name;
$78d29720b8ced031$export$98e6a39c04603d36 = $78d29720b8ced031$var$parse;
$78d29720b8ced031$export$46a2a563c28afca0 = $78d29720b8ced031$var$structure;

});

parcelRegister("9zX8c", function(module, exports) {

$parcel$export(module.exports, "generate", () => $01ccbad75568b158$export$80d376111cc09ad7, (v) => $01ccbad75568b158$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $01ccbad75568b158$export$a8ff84c12d48cfa6, (v) => $01ccbad75568b158$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $01ccbad75568b158$export$98e6a39c04603d36, (v) => $01ccbad75568b158$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $01ccbad75568b158$export$46a2a563c28afca0, (v) => $01ccbad75568b158$export$46a2a563c28afca0 = v);
var $01ccbad75568b158$export$80d376111cc09ad7;
var $01ccbad75568b158$export$a8ff84c12d48cfa6;
var $01ccbad75568b158$export$98e6a39c04603d36;
var $01ccbad75568b158$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $01ccbad75568b158$var$name = 'MediaFeature';
const $01ccbad75568b158$var$structure = {
    name: String,
    value: [
        'Identifier',
        'Number',
        'Dimension',
        'Ratio',
        null
    ]
};
function $01ccbad75568b158$var$parse() {
    const start = this.tokenStart;
    let name;
    let value = null;
    this.eat($iYo0F.LeftParenthesis);
    this.skipSC();
    name = this.consume($iYo0F.Ident);
    this.skipSC();
    if (this.tokenType !== $iYo0F.RightParenthesis) {
        this.eat($iYo0F.Colon);
        this.skipSC();
        switch(this.tokenType){
            case $iYo0F.Number:
                if (this.lookupNonWSType(1) === $iYo0F.Delim) value = this.Ratio();
                else value = this.Number();
                break;
            case $iYo0F.Dimension:
                value = this.Dimension();
                break;
            case $iYo0F.Ident:
                value = this.Identifier();
                break;
            default:
                this.error('Number, dimension, ratio or identifier is expected');
        }
        this.skipSC();
    }
    this.eat($iYo0F.RightParenthesis);
    return {
        type: 'MediaFeature',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        value: value
    };
}
function $01ccbad75568b158$var$generate(node) {
    this.token($iYo0F.LeftParenthesis, '(');
    this.token($iYo0F.Ident, node.name);
    if (node.value !== null) {
        this.token($iYo0F.Colon, ':');
        this.node(node.value);
    }
    this.token($iYo0F.RightParenthesis, ')');
}
$01ccbad75568b158$export$80d376111cc09ad7 = $01ccbad75568b158$var$generate;
$01ccbad75568b158$export$a8ff84c12d48cfa6 = $01ccbad75568b158$var$name;
$01ccbad75568b158$export$98e6a39c04603d36 = $01ccbad75568b158$var$parse;
$01ccbad75568b158$export$46a2a563c28afca0 = $01ccbad75568b158$var$structure;

});

parcelRegister("eLYwZ", function(module, exports) {

$parcel$export(module.exports, "generate", () => $ac1468b48eb6181e$export$80d376111cc09ad7, (v) => $ac1468b48eb6181e$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $ac1468b48eb6181e$export$a8ff84c12d48cfa6, (v) => $ac1468b48eb6181e$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $ac1468b48eb6181e$export$98e6a39c04603d36, (v) => $ac1468b48eb6181e$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $ac1468b48eb6181e$export$46a2a563c28afca0, (v) => $ac1468b48eb6181e$export$46a2a563c28afca0 = v);
var $ac1468b48eb6181e$export$80d376111cc09ad7;
var $ac1468b48eb6181e$export$a8ff84c12d48cfa6;
var $ac1468b48eb6181e$export$98e6a39c04603d36;
var $ac1468b48eb6181e$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $ac1468b48eb6181e$var$name = 'MediaQuery';
const $ac1468b48eb6181e$var$structure = {
    children: [
        [
            'Identifier',
            'MediaFeature',
            'WhiteSpace'
        ]
    ]
};
function $ac1468b48eb6181e$var$parse() {
    const children = this.createList();
    let child = null;
    this.skipSC();
    scan: while(!this.eof){
        switch(this.tokenType){
            case $iYo0F.Comment:
            case $iYo0F.WhiteSpace:
                this.next();
                continue;
            case $iYo0F.Ident:
                child = this.Identifier();
                break;
            case $iYo0F.LeftParenthesis:
                child = this.MediaFeature();
                break;
            default:
                break scan;
        }
        children.push(child);
    }
    if (child === null) this.error('Identifier or parenthesis is expected');
    return {
        type: 'MediaQuery',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $ac1468b48eb6181e$var$generate(node) {
    this.children(node);
}
$ac1468b48eb6181e$export$80d376111cc09ad7 = $ac1468b48eb6181e$var$generate;
$ac1468b48eb6181e$export$a8ff84c12d48cfa6 = $ac1468b48eb6181e$var$name;
$ac1468b48eb6181e$export$98e6a39c04603d36 = $ac1468b48eb6181e$var$parse;
$ac1468b48eb6181e$export$46a2a563c28afca0 = $ac1468b48eb6181e$var$structure;

});

parcelRegister("e5Xih", function(module, exports) {

$parcel$export(module.exports, "generate", () => $a42f86d1451043ff$export$80d376111cc09ad7, (v) => $a42f86d1451043ff$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $a42f86d1451043ff$export$a8ff84c12d48cfa6, (v) => $a42f86d1451043ff$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $a42f86d1451043ff$export$98e6a39c04603d36, (v) => $a42f86d1451043ff$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $a42f86d1451043ff$export$46a2a563c28afca0, (v) => $a42f86d1451043ff$export$46a2a563c28afca0 = v);
var $a42f86d1451043ff$export$80d376111cc09ad7;
var $a42f86d1451043ff$export$a8ff84c12d48cfa6;
var $a42f86d1451043ff$export$98e6a39c04603d36;
var $a42f86d1451043ff$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $a42f86d1451043ff$var$name = 'MediaQueryList';
const $a42f86d1451043ff$var$structure = {
    children: [
        [
            'MediaQuery'
        ]
    ]
};
function $a42f86d1451043ff$var$parse() {
    const children = this.createList();
    this.skipSC();
    while(!this.eof){
        children.push(this.MediaQuery());
        if (this.tokenType !== $iYo0F.Comma) break;
        this.next();
    }
    return {
        type: 'MediaQueryList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $a42f86d1451043ff$var$generate(node) {
    this.children(node, ()=>this.token($iYo0F.Comma, ','));
}
$a42f86d1451043ff$export$80d376111cc09ad7 = $a42f86d1451043ff$var$generate;
$a42f86d1451043ff$export$a8ff84c12d48cfa6 = $a42f86d1451043ff$var$name;
$a42f86d1451043ff$export$98e6a39c04603d36 = $a42f86d1451043ff$var$parse;
$a42f86d1451043ff$export$46a2a563c28afca0 = $a42f86d1451043ff$var$structure;

});

parcelRegister("c53ky", function(module, exports) {

$parcel$export(module.exports, "generate", () => $8cb88903bc430bdb$export$80d376111cc09ad7, (v) => $8cb88903bc430bdb$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $8cb88903bc430bdb$export$a8ff84c12d48cfa6, (v) => $8cb88903bc430bdb$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $8cb88903bc430bdb$export$98e6a39c04603d36, (v) => $8cb88903bc430bdb$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $8cb88903bc430bdb$export$46a2a563c28afca0, (v) => $8cb88903bc430bdb$export$46a2a563c28afca0 = v);
var $8cb88903bc430bdb$export$80d376111cc09ad7;
var $8cb88903bc430bdb$export$a8ff84c12d48cfa6;
var $8cb88903bc430bdb$export$98e6a39c04603d36;
var $8cb88903bc430bdb$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $8cb88903bc430bdb$var$name = 'Nth';
const $8cb88903bc430bdb$var$structure = {
    nth: [
        'AnPlusB',
        'Identifier'
    ],
    selector: [
        'SelectorList',
        null
    ]
};
function $8cb88903bc430bdb$var$parse() {
    this.skipSC();
    const start = this.tokenStart;
    let end = start;
    let selector = null;
    let nth;
    if (this.lookupValue(0, 'odd') || this.lookupValue(0, 'even')) nth = this.Identifier();
    else nth = this.AnPlusB();
    end = this.tokenStart;
    this.skipSC();
    if (this.lookupValue(0, 'of')) {
        this.next();
        selector = this.SelectorList();
        end = this.tokenStart;
    }
    return {
        type: 'Nth',
        loc: this.getLocation(start, end),
        nth: nth,
        selector: selector
    };
}
function $8cb88903bc430bdb$var$generate(node) {
    this.node(node.nth);
    if (node.selector !== null) {
        this.token($iYo0F.Ident, 'of');
        this.node(node.selector);
    }
}
$8cb88903bc430bdb$export$80d376111cc09ad7 = $8cb88903bc430bdb$var$generate;
$8cb88903bc430bdb$export$a8ff84c12d48cfa6 = $8cb88903bc430bdb$var$name;
$8cb88903bc430bdb$export$98e6a39c04603d36 = $8cb88903bc430bdb$var$parse;
$8cb88903bc430bdb$export$46a2a563c28afca0 = $8cb88903bc430bdb$var$structure;

});

parcelRegister("gXnZP", function(module, exports) {

$parcel$export(module.exports, "generate", () => $c584c5292380aad3$export$80d376111cc09ad7, (v) => $c584c5292380aad3$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $c584c5292380aad3$export$a8ff84c12d48cfa6, (v) => $c584c5292380aad3$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $c584c5292380aad3$export$98e6a39c04603d36, (v) => $c584c5292380aad3$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $c584c5292380aad3$export$46a2a563c28afca0, (v) => $c584c5292380aad3$export$46a2a563c28afca0 = v);
var $c584c5292380aad3$export$80d376111cc09ad7;
var $c584c5292380aad3$export$a8ff84c12d48cfa6;
var $c584c5292380aad3$export$98e6a39c04603d36;
var $c584c5292380aad3$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $c584c5292380aad3$var$name = 'Number';
const $c584c5292380aad3$var$structure = {
    value: String
};
function $c584c5292380aad3$var$parse() {
    return {
        type: 'Number',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: this.consume($iYo0F.Number)
    };
}
function $c584c5292380aad3$var$generate(node) {
    this.token($iYo0F.Number, node.value);
}
$c584c5292380aad3$export$80d376111cc09ad7 = $c584c5292380aad3$var$generate;
$c584c5292380aad3$export$a8ff84c12d48cfa6 = $c584c5292380aad3$var$name;
$c584c5292380aad3$export$98e6a39c04603d36 = $c584c5292380aad3$var$parse;
$c584c5292380aad3$export$46a2a563c28afca0 = $c584c5292380aad3$var$structure;

});

parcelRegister("aQk36", function(module, exports) {

$parcel$export(module.exports, "generate", () => $7e4e50087741d990$export$80d376111cc09ad7, (v) => $7e4e50087741d990$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $7e4e50087741d990$export$a8ff84c12d48cfa6, (v) => $7e4e50087741d990$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $7e4e50087741d990$export$98e6a39c04603d36, (v) => $7e4e50087741d990$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $7e4e50087741d990$export$46a2a563c28afca0, (v) => $7e4e50087741d990$export$46a2a563c28afca0 = v);
var $7e4e50087741d990$export$80d376111cc09ad7;
var $7e4e50087741d990$export$a8ff84c12d48cfa6;
var $7e4e50087741d990$export$98e6a39c04603d36;
var $7e4e50087741d990$export$46a2a563c28afca0;
'use strict';
// '/' | '*' | ',' | ':' | '+' | '-'
const $7e4e50087741d990$var$name = 'Operator';
const $7e4e50087741d990$var$structure = {
    value: String
};
function $7e4e50087741d990$var$parse() {
    const start = this.tokenStart;
    this.next();
    return {
        type: 'Operator',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start)
    };
}
function $7e4e50087741d990$var$generate(node) {
    this.tokenize(node.value);
}
$7e4e50087741d990$export$80d376111cc09ad7 = $7e4e50087741d990$var$generate;
$7e4e50087741d990$export$a8ff84c12d48cfa6 = $7e4e50087741d990$var$name;
$7e4e50087741d990$export$98e6a39c04603d36 = $7e4e50087741d990$var$parse;
$7e4e50087741d990$export$46a2a563c28afca0 = $7e4e50087741d990$var$structure;

});

parcelRegister("fju2N", function(module, exports) {

$parcel$export(module.exports, "generate", () => $b25fef7983dc021e$export$80d376111cc09ad7, (v) => $b25fef7983dc021e$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $b25fef7983dc021e$export$a8ff84c12d48cfa6, (v) => $b25fef7983dc021e$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $b25fef7983dc021e$export$98e6a39c04603d36, (v) => $b25fef7983dc021e$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $b25fef7983dc021e$export$46a2a563c28afca0, (v) => $b25fef7983dc021e$export$46a2a563c28afca0 = v);
var $b25fef7983dc021e$export$80d376111cc09ad7;
var $b25fef7983dc021e$export$a8ff84c12d48cfa6;
var $b25fef7983dc021e$export$98e6a39c04603d36;
var $b25fef7983dc021e$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $b25fef7983dc021e$var$name = 'Parentheses';
const $b25fef7983dc021e$var$structure = {
    children: [
        []
    ]
};
function $b25fef7983dc021e$var$parse(readSequence, recognizer) {
    const start = this.tokenStart;
    let children = null;
    this.eat($iYo0F.LeftParenthesis);
    children = readSequence.call(this, recognizer);
    if (!this.eof) this.eat($iYo0F.RightParenthesis);
    return {
        type: 'Parentheses',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $b25fef7983dc021e$var$generate(node) {
    this.token($iYo0F.LeftParenthesis, '(');
    this.children(node);
    this.token($iYo0F.RightParenthesis, ')');
}
$b25fef7983dc021e$export$80d376111cc09ad7 = $b25fef7983dc021e$var$generate;
$b25fef7983dc021e$export$a8ff84c12d48cfa6 = $b25fef7983dc021e$var$name;
$b25fef7983dc021e$export$98e6a39c04603d36 = $b25fef7983dc021e$var$parse;
$b25fef7983dc021e$export$46a2a563c28afca0 = $b25fef7983dc021e$var$structure;

});

parcelRegister("2kUaV", function(module, exports) {

$parcel$export(module.exports, "generate", () => $1b39064109d913a7$export$80d376111cc09ad7, (v) => $1b39064109d913a7$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $1b39064109d913a7$export$a8ff84c12d48cfa6, (v) => $1b39064109d913a7$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $1b39064109d913a7$export$98e6a39c04603d36, (v) => $1b39064109d913a7$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $1b39064109d913a7$export$46a2a563c28afca0, (v) => $1b39064109d913a7$export$46a2a563c28afca0 = v);
var $1b39064109d913a7$export$80d376111cc09ad7;
var $1b39064109d913a7$export$a8ff84c12d48cfa6;
var $1b39064109d913a7$export$98e6a39c04603d36;
var $1b39064109d913a7$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $1b39064109d913a7$var$name = 'Percentage';
const $1b39064109d913a7$var$structure = {
    value: String
};
function $1b39064109d913a7$var$parse() {
    return {
        type: 'Percentage',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: this.consumeNumber($iYo0F.Percentage)
    };
}
function $1b39064109d913a7$var$generate(node) {
    this.token($iYo0F.Percentage, node.value + '%');
}
$1b39064109d913a7$export$80d376111cc09ad7 = $1b39064109d913a7$var$generate;
$1b39064109d913a7$export$a8ff84c12d48cfa6 = $1b39064109d913a7$var$name;
$1b39064109d913a7$export$98e6a39c04603d36 = $1b39064109d913a7$var$parse;
$1b39064109d913a7$export$46a2a563c28afca0 = $1b39064109d913a7$var$structure;

});

parcelRegister("6BEdX", function(module, exports) {

$parcel$export(module.exports, "generate", () => $4cf5666f5eaa20f3$export$80d376111cc09ad7, (v) => $4cf5666f5eaa20f3$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $4cf5666f5eaa20f3$export$a8ff84c12d48cfa6, (v) => $4cf5666f5eaa20f3$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $4cf5666f5eaa20f3$export$98e6a39c04603d36, (v) => $4cf5666f5eaa20f3$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $4cf5666f5eaa20f3$export$46a2a563c28afca0, (v) => $4cf5666f5eaa20f3$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $4cf5666f5eaa20f3$export$f7e0bb689fefb8c2, (v) => $4cf5666f5eaa20f3$export$f7e0bb689fefb8c2 = v);
var $4cf5666f5eaa20f3$export$80d376111cc09ad7;
var $4cf5666f5eaa20f3$export$a8ff84c12d48cfa6;
var $4cf5666f5eaa20f3$export$98e6a39c04603d36;
var $4cf5666f5eaa20f3$export$46a2a563c28afca0;
var $4cf5666f5eaa20f3$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $4cf5666f5eaa20f3$var$name = 'PseudoClassSelector';
const $4cf5666f5eaa20f3$var$walkContext = 'function';
const $4cf5666f5eaa20f3$var$structure = {
    name: String,
    children: [
        [
            'Raw'
        ],
        null
    ]
};
// : [ <ident> | <function-token> <any-value>? ) ]
function $4cf5666f5eaa20f3$var$parse() {
    const start = this.tokenStart;
    let children = null;
    let name;
    let nameLowerCase;
    this.eat($iYo0F.Colon);
    if (this.tokenType === $iYo0F.Function) {
        name = this.consumeFunctionName();
        nameLowerCase = name.toLowerCase();
        if (hasOwnProperty.call(this.pseudo, nameLowerCase)) {
            this.skipSC();
            children = this.pseudo[nameLowerCase].call(this);
            this.skipSC();
        } else {
            children = this.createList();
            children.push(this.Raw(this.tokenIndex, null, false));
        }
        this.eat($iYo0F.RightParenthesis);
    } else name = this.consume($iYo0F.Ident);
    return {
        type: 'PseudoClassSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $4cf5666f5eaa20f3$var$generate(node) {
    this.token($iYo0F.Colon, ':');
    if (node.children === null) this.token($iYo0F.Ident, node.name);
    else {
        this.token($iYo0F.Function, node.name + '(');
        this.children(node);
        this.token($iYo0F.RightParenthesis, ')');
    }
}
$4cf5666f5eaa20f3$export$80d376111cc09ad7 = $4cf5666f5eaa20f3$var$generate;
$4cf5666f5eaa20f3$export$a8ff84c12d48cfa6 = $4cf5666f5eaa20f3$var$name;
$4cf5666f5eaa20f3$export$98e6a39c04603d36 = $4cf5666f5eaa20f3$var$parse;
$4cf5666f5eaa20f3$export$46a2a563c28afca0 = $4cf5666f5eaa20f3$var$structure;
$4cf5666f5eaa20f3$export$f7e0bb689fefb8c2 = $4cf5666f5eaa20f3$var$walkContext;

});

parcelRegister("TNJb9", function(module, exports) {

$parcel$export(module.exports, "generate", () => $0a7bb60d6f138e6a$export$80d376111cc09ad7, (v) => $0a7bb60d6f138e6a$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $0a7bb60d6f138e6a$export$a8ff84c12d48cfa6, (v) => $0a7bb60d6f138e6a$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $0a7bb60d6f138e6a$export$98e6a39c04603d36, (v) => $0a7bb60d6f138e6a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $0a7bb60d6f138e6a$export$46a2a563c28afca0, (v) => $0a7bb60d6f138e6a$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $0a7bb60d6f138e6a$export$f7e0bb689fefb8c2, (v) => $0a7bb60d6f138e6a$export$f7e0bb689fefb8c2 = v);
var $0a7bb60d6f138e6a$export$80d376111cc09ad7;
var $0a7bb60d6f138e6a$export$a8ff84c12d48cfa6;
var $0a7bb60d6f138e6a$export$98e6a39c04603d36;
var $0a7bb60d6f138e6a$export$46a2a563c28afca0;
var $0a7bb60d6f138e6a$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $0a7bb60d6f138e6a$var$name = 'PseudoElementSelector';
const $0a7bb60d6f138e6a$var$walkContext = 'function';
const $0a7bb60d6f138e6a$var$structure = {
    name: String,
    children: [
        [
            'Raw'
        ],
        null
    ]
};
// :: [ <ident> | <function-token> <any-value>? ) ]
function $0a7bb60d6f138e6a$var$parse() {
    const start = this.tokenStart;
    let children = null;
    let name;
    let nameLowerCase;
    this.eat($iYo0F.Colon);
    this.eat($iYo0F.Colon);
    if (this.tokenType === $iYo0F.Function) {
        name = this.consumeFunctionName();
        nameLowerCase = name.toLowerCase();
        if (hasOwnProperty.call(this.pseudo, nameLowerCase)) {
            this.skipSC();
            children = this.pseudo[nameLowerCase].call(this);
            this.skipSC();
        } else {
            children = this.createList();
            children.push(this.Raw(this.tokenIndex, null, false));
        }
        this.eat($iYo0F.RightParenthesis);
    } else name = this.consume($iYo0F.Ident);
    return {
        type: 'PseudoElementSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $0a7bb60d6f138e6a$var$generate(node) {
    this.token($iYo0F.Colon, ':');
    this.token($iYo0F.Colon, ':');
    if (node.children === null) this.token($iYo0F.Ident, node.name);
    else {
        this.token($iYo0F.Function, node.name + '(');
        this.children(node);
        this.token($iYo0F.RightParenthesis, ')');
    }
}
$0a7bb60d6f138e6a$export$80d376111cc09ad7 = $0a7bb60d6f138e6a$var$generate;
$0a7bb60d6f138e6a$export$a8ff84c12d48cfa6 = $0a7bb60d6f138e6a$var$name;
$0a7bb60d6f138e6a$export$98e6a39c04603d36 = $0a7bb60d6f138e6a$var$parse;
$0a7bb60d6f138e6a$export$46a2a563c28afca0 = $0a7bb60d6f138e6a$var$structure;
$0a7bb60d6f138e6a$export$f7e0bb689fefb8c2 = $0a7bb60d6f138e6a$var$walkContext;

});

parcelRegister("2lkt2", function(module, exports) {

$parcel$export(module.exports, "generate", () => $1b4d6b586c480613$export$80d376111cc09ad7, (v) => $1b4d6b586c480613$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $1b4d6b586c480613$export$a8ff84c12d48cfa6, (v) => $1b4d6b586c480613$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $1b4d6b586c480613$export$98e6a39c04603d36, (v) => $1b4d6b586c480613$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $1b4d6b586c480613$export$46a2a563c28afca0, (v) => $1b4d6b586c480613$export$46a2a563c28afca0 = v);
var $1b4d6b586c480613$export$80d376111cc09ad7;
var $1b4d6b586c480613$export$a8ff84c12d48cfa6;
var $1b4d6b586c480613$export$98e6a39c04603d36;
var $1b4d6b586c480613$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");

var $kIeAG = parcelRequire("kIeAG");
const $1b4d6b586c480613$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $1b4d6b586c480613$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
// Terms of <ratio> should be a positive numbers (not zero or negative)
// (see https://drafts.csswg.org/mediaqueries-3/#values)
// However, -o-min-device-pixel-ratio takes fractional values as a ratio's term
// and this is using by various sites. Therefore we relax checking on parse
// to test a term is unsigned number without an exponent part.
// Additional checking may be applied on lexer validation.
function $1b4d6b586c480613$var$consumeNumber() {
    this.skipSC();
    const value = this.consume($iYo0F.Number);
    for(let i = 0; i < value.length; i++){
        const code = value.charCodeAt(i);
        if (!$kIeAG.isDigit(code) && code !== $1b4d6b586c480613$var$FULLSTOP) this.error('Unsigned number is expected', this.tokenStart - value.length + i);
    }
    if (Number(value) === 0) this.error('Zero number is not allowed', this.tokenStart - value.length);
    return value;
}
const $1b4d6b586c480613$var$name = 'Ratio';
const $1b4d6b586c480613$var$structure = {
    left: String,
    right: String
};
// <positive-integer> S* '/' S* <positive-integer>
function $1b4d6b586c480613$var$parse() {
    const start = this.tokenStart;
    const left = $1b4d6b586c480613$var$consumeNumber.call(this);
    let right;
    this.skipSC();
    this.eatDelim($1b4d6b586c480613$var$SOLIDUS);
    right = $1b4d6b586c480613$var$consumeNumber.call(this);
    return {
        type: 'Ratio',
        loc: this.getLocation(start, this.tokenStart),
        left: left,
        right: right
    };
}
function $1b4d6b586c480613$var$generate(node) {
    this.token($iYo0F.Number, node.left);
    this.token($iYo0F.Delim, '/');
    this.token($iYo0F.Number, node.right);
}
$1b4d6b586c480613$export$80d376111cc09ad7 = $1b4d6b586c480613$var$generate;
$1b4d6b586c480613$export$a8ff84c12d48cfa6 = $1b4d6b586c480613$var$name;
$1b4d6b586c480613$export$98e6a39c04603d36 = $1b4d6b586c480613$var$parse;
$1b4d6b586c480613$export$46a2a563c28afca0 = $1b4d6b586c480613$var$structure;

});

parcelRegister("aTzIL", function(module, exports) {

$parcel$export(module.exports, "generate", () => $7eeabfdc2e9b4a38$export$80d376111cc09ad7, (v) => $7eeabfdc2e9b4a38$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $7eeabfdc2e9b4a38$export$a8ff84c12d48cfa6, (v) => $7eeabfdc2e9b4a38$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $7eeabfdc2e9b4a38$export$98e6a39c04603d36, (v) => $7eeabfdc2e9b4a38$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $7eeabfdc2e9b4a38$export$46a2a563c28afca0, (v) => $7eeabfdc2e9b4a38$export$46a2a563c28afca0 = v);
var $7eeabfdc2e9b4a38$export$80d376111cc09ad7;
var $7eeabfdc2e9b4a38$export$a8ff84c12d48cfa6;
var $7eeabfdc2e9b4a38$export$98e6a39c04603d36;
var $7eeabfdc2e9b4a38$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
function $7eeabfdc2e9b4a38$var$getOffsetExcludeWS() {
    if (this.tokenIndex > 0) {
        if (this.lookupType(-1) === $iYo0F.WhiteSpace) return this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset;
    }
    return this.tokenStart;
}
const $7eeabfdc2e9b4a38$var$name = 'Raw';
const $7eeabfdc2e9b4a38$var$structure = {
    value: String
};
function $7eeabfdc2e9b4a38$var$parse(startToken, consumeUntil, excludeWhiteSpace) {
    const startOffset = this.getTokenStart(startToken);
    let endOffset;
    this.skipUntilBalanced(startToken, consumeUntil || this.consumeUntilBalanceEnd);
    if (excludeWhiteSpace && this.tokenStart > startOffset) endOffset = $7eeabfdc2e9b4a38$var$getOffsetExcludeWS.call(this);
    else endOffset = this.tokenStart;
    return {
        type: 'Raw',
        loc: this.getLocation(startOffset, endOffset),
        value: this.substring(startOffset, endOffset)
    };
}
function $7eeabfdc2e9b4a38$var$generate(node) {
    this.tokenize(node.value);
}
$7eeabfdc2e9b4a38$export$80d376111cc09ad7 = $7eeabfdc2e9b4a38$var$generate;
$7eeabfdc2e9b4a38$export$a8ff84c12d48cfa6 = $7eeabfdc2e9b4a38$var$name;
$7eeabfdc2e9b4a38$export$98e6a39c04603d36 = $7eeabfdc2e9b4a38$var$parse;
$7eeabfdc2e9b4a38$export$46a2a563c28afca0 = $7eeabfdc2e9b4a38$var$structure;

});

parcelRegister("5ppzC", function(module, exports) {

$parcel$export(module.exports, "generate", () => $3f031fe84885563d$export$80d376111cc09ad7, (v) => $3f031fe84885563d$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $3f031fe84885563d$export$a8ff84c12d48cfa6, (v) => $3f031fe84885563d$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $3f031fe84885563d$export$98e6a39c04603d36, (v) => $3f031fe84885563d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $3f031fe84885563d$export$46a2a563c28afca0, (v) => $3f031fe84885563d$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $3f031fe84885563d$export$f7e0bb689fefb8c2, (v) => $3f031fe84885563d$export$f7e0bb689fefb8c2 = v);
var $3f031fe84885563d$export$80d376111cc09ad7;
var $3f031fe84885563d$export$a8ff84c12d48cfa6;
var $3f031fe84885563d$export$98e6a39c04603d36;
var $3f031fe84885563d$export$46a2a563c28afca0;
var $3f031fe84885563d$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
function $3f031fe84885563d$var$consumeRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilLeftCurlyBracket, true);
}
function $3f031fe84885563d$var$consumePrelude() {
    const prelude = this.SelectorList();
    if (prelude.type !== 'Raw' && this.eof === false && this.tokenType !== $iYo0F.LeftCurlyBracket) this.error();
    return prelude;
}
const $3f031fe84885563d$var$name = 'Rule';
const $3f031fe84885563d$var$walkContext = 'rule';
const $3f031fe84885563d$var$structure = {
    prelude: [
        'SelectorList',
        'Raw'
    ],
    block: [
        'Block'
    ]
};
function $3f031fe84885563d$var$parse() {
    const startToken = this.tokenIndex;
    const startOffset = this.tokenStart;
    let prelude;
    let block;
    if (this.parseRulePrelude) prelude = this.parseWithFallback($3f031fe84885563d$var$consumePrelude, $3f031fe84885563d$var$consumeRaw);
    else prelude = $3f031fe84885563d$var$consumeRaw.call(this, startToken);
    block = this.Block(true);
    return {
        type: 'Rule',
        loc: this.getLocation(startOffset, this.tokenStart),
        prelude: prelude,
        block: block
    };
}
function $3f031fe84885563d$var$generate(node) {
    this.node(node.prelude);
    this.node(node.block);
}
$3f031fe84885563d$export$80d376111cc09ad7 = $3f031fe84885563d$var$generate;
$3f031fe84885563d$export$a8ff84c12d48cfa6 = $3f031fe84885563d$var$name;
$3f031fe84885563d$export$98e6a39c04603d36 = $3f031fe84885563d$var$parse;
$3f031fe84885563d$export$46a2a563c28afca0 = $3f031fe84885563d$var$structure;
$3f031fe84885563d$export$f7e0bb689fefb8c2 = $3f031fe84885563d$var$walkContext;

});

parcelRegister("9gWZU", function(module, exports) {

$parcel$export(module.exports, "generate", () => $6c035f5e1683f0d2$export$80d376111cc09ad7, (v) => $6c035f5e1683f0d2$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $6c035f5e1683f0d2$export$a8ff84c12d48cfa6, (v) => $6c035f5e1683f0d2$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $6c035f5e1683f0d2$export$98e6a39c04603d36, (v) => $6c035f5e1683f0d2$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $6c035f5e1683f0d2$export$46a2a563c28afca0, (v) => $6c035f5e1683f0d2$export$46a2a563c28afca0 = v);
var $6c035f5e1683f0d2$export$80d376111cc09ad7;
var $6c035f5e1683f0d2$export$a8ff84c12d48cfa6;
var $6c035f5e1683f0d2$export$98e6a39c04603d36;
var $6c035f5e1683f0d2$export$46a2a563c28afca0;
'use strict';
const $6c035f5e1683f0d2$var$name = 'Selector';
const $6c035f5e1683f0d2$var$structure = {
    children: [
        [
            'TypeSelector',
            'IdSelector',
            'ClassSelector',
            'AttributeSelector',
            'PseudoClassSelector',
            'PseudoElementSelector',
            'Combinator',
            'WhiteSpace'
        ]
    ]
};
function $6c035f5e1683f0d2$var$parse() {
    const children = this.readSequence(this.scope.Selector);
    // nothing were consumed
    if (this.getFirstListNode(children) === null) this.error('Selector is expected');
    return {
        type: 'Selector',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $6c035f5e1683f0d2$var$generate(node) {
    this.children(node);
}
$6c035f5e1683f0d2$export$80d376111cc09ad7 = $6c035f5e1683f0d2$var$generate;
$6c035f5e1683f0d2$export$a8ff84c12d48cfa6 = $6c035f5e1683f0d2$var$name;
$6c035f5e1683f0d2$export$98e6a39c04603d36 = $6c035f5e1683f0d2$var$parse;
$6c035f5e1683f0d2$export$46a2a563c28afca0 = $6c035f5e1683f0d2$var$structure;

});

parcelRegister("3CnUF", function(module, exports) {

$parcel$export(module.exports, "generate", () => $2a27784fb085305b$export$80d376111cc09ad7, (v) => $2a27784fb085305b$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $2a27784fb085305b$export$a8ff84c12d48cfa6, (v) => $2a27784fb085305b$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $2a27784fb085305b$export$98e6a39c04603d36, (v) => $2a27784fb085305b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $2a27784fb085305b$export$46a2a563c28afca0, (v) => $2a27784fb085305b$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $2a27784fb085305b$export$f7e0bb689fefb8c2, (v) => $2a27784fb085305b$export$f7e0bb689fefb8c2 = v);
var $2a27784fb085305b$export$80d376111cc09ad7;
var $2a27784fb085305b$export$a8ff84c12d48cfa6;
var $2a27784fb085305b$export$98e6a39c04603d36;
var $2a27784fb085305b$export$46a2a563c28afca0;
var $2a27784fb085305b$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $2a27784fb085305b$var$name = 'SelectorList';
const $2a27784fb085305b$var$walkContext = 'selector';
const $2a27784fb085305b$var$structure = {
    children: [
        [
            'Selector',
            'Raw'
        ]
    ]
};
function $2a27784fb085305b$var$parse() {
    const children = this.createList();
    while(!this.eof){
        children.push(this.Selector());
        if (this.tokenType === $iYo0F.Comma) {
            this.next();
            continue;
        }
        break;
    }
    return {
        type: 'SelectorList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $2a27784fb085305b$var$generate(node) {
    this.children(node, ()=>this.token($iYo0F.Comma, ','));
}
$2a27784fb085305b$export$80d376111cc09ad7 = $2a27784fb085305b$var$generate;
$2a27784fb085305b$export$a8ff84c12d48cfa6 = $2a27784fb085305b$var$name;
$2a27784fb085305b$export$98e6a39c04603d36 = $2a27784fb085305b$var$parse;
$2a27784fb085305b$export$46a2a563c28afca0 = $2a27784fb085305b$var$structure;
$2a27784fb085305b$export$f7e0bb689fefb8c2 = $2a27784fb085305b$var$walkContext;

});

parcelRegister("1v6vW", function(module, exports) {

$parcel$export(module.exports, "generate", () => $117dbd43eae40b95$export$80d376111cc09ad7, (v) => $117dbd43eae40b95$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $117dbd43eae40b95$export$a8ff84c12d48cfa6, (v) => $117dbd43eae40b95$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $117dbd43eae40b95$export$98e6a39c04603d36, (v) => $117dbd43eae40b95$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $117dbd43eae40b95$export$46a2a563c28afca0, (v) => $117dbd43eae40b95$export$46a2a563c28afca0 = v);
var $117dbd43eae40b95$export$80d376111cc09ad7;
var $117dbd43eae40b95$export$a8ff84c12d48cfa6;
var $117dbd43eae40b95$export$98e6a39c04603d36;
var $117dbd43eae40b95$export$46a2a563c28afca0;
'use strict';

var $lF7ah = parcelRequire("lF7ah");

var $iYo0F = parcelRequire("iYo0F");
const $117dbd43eae40b95$var$name = 'String';
const $117dbd43eae40b95$var$structure = {
    value: String
};
function $117dbd43eae40b95$var$parse() {
    return {
        type: 'String',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: $lF7ah.decode(this.consume($iYo0F.String))
    };
}
function $117dbd43eae40b95$var$generate(node) {
    this.token($iYo0F.String, $lF7ah.encode(node.value));
}
$117dbd43eae40b95$export$80d376111cc09ad7 = $117dbd43eae40b95$var$generate;
$117dbd43eae40b95$export$a8ff84c12d48cfa6 = $117dbd43eae40b95$var$name;
$117dbd43eae40b95$export$98e6a39c04603d36 = $117dbd43eae40b95$var$parse;
$117dbd43eae40b95$export$46a2a563c28afca0 = $117dbd43eae40b95$var$structure;

});
parcelRegister("lF7ah", function(module, exports) {

$parcel$export(module.exports, "decode", () => $fc52fc12433f323f$export$2f872c0f2117be69, (v) => $fc52fc12433f323f$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "encode", () => $fc52fc12433f323f$export$c564cdbbe6da493, (v) => $fc52fc12433f323f$export$c564cdbbe6da493 = v);
var $fc52fc12433f323f$export$2f872c0f2117be69;
var $fc52fc12433f323f$export$c564cdbbe6da493;
'use strict';

var $kIeAG = parcelRequire("kIeAG");

var $7UrOl = parcelRequire("7UrOl");
const $fc52fc12433f323f$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
const $fc52fc12433f323f$var$QUOTATION_MARK = 0x0022; // "
const $fc52fc12433f323f$var$APOSTROPHE = 0x0027; // '
function $fc52fc12433f323f$var$decode(str) {
    const len = str.length;
    const firstChar = str.charCodeAt(0);
    const start = firstChar === $fc52fc12433f323f$var$QUOTATION_MARK || firstChar === $fc52fc12433f323f$var$APOSTROPHE ? 1 : 0;
    const end = start === 1 && len > 1 && str.charCodeAt(len - 1) === firstChar ? len - 2 : len - 1;
    let decoded = '';
    for(let i = start; i <= end; i++){
        let code = str.charCodeAt(i);
        if (code === $fc52fc12433f323f$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) {
                // if the next input code point is EOF, do nothing
                // otherwise include last quote as escaped
                if (i !== len - 1) decoded = str.substr(i + 1);
                break;
            }
            code = str.charCodeAt(++i);
            // consume escaped
            if ($kIeAG.isValidEscape($fc52fc12433f323f$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = $7UrOl.consumeEscaped(str, escapeStart);
                i = escapeEnd - 1;
                decoded += $7UrOl.decodeEscaped(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
// https://drafts.csswg.org/cssom/#serialize-a-string
// § 2.1. Common Serializing Idioms
function $fc52fc12433f323f$var$encode(str, apostrophe) {
    const quote = apostrophe ? '\'' : '"';
    const quoteCode = apostrophe ? $fc52fc12433f323f$var$APOSTROPHE : $fc52fc12433f323f$var$QUOTATION_MARK;
    let encoded = '';
    let wsBeforeHexIsNeeded = false;
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        // If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F,
        // the character escaped as code point.
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        if (code <= 0x001f || code === 0x007F) {
            encoded += '\\' + code.toString(16);
            wsBeforeHexIsNeeded = true;
            continue;
        }
        // If the character is '"' (U+0022) or "\" (U+005C), the escaped character.
        if (code === quoteCode || code === $fc52fc12433f323f$var$REVERSE_SOLIDUS) {
            encoded += '\\' + str.charAt(i);
            wsBeforeHexIsNeeded = false;
        } else {
            if (wsBeforeHexIsNeeded && ($kIeAG.isHexDigit(code) || $kIeAG.isWhiteSpace(code))) encoded += ' ';
            // Otherwise, the character itself.
            encoded += str.charAt(i);
            wsBeforeHexIsNeeded = false;
        }
    }
    return quote + encoded + quote;
}
$fc52fc12433f323f$export$2f872c0f2117be69 = $fc52fc12433f323f$var$decode;
$fc52fc12433f323f$export$c564cdbbe6da493 = $fc52fc12433f323f$var$encode;

});


parcelRegister("2ZnEQ", function(module, exports) {

$parcel$export(module.exports, "generate", () => $22d3a13705b3bc3c$export$80d376111cc09ad7, (v) => $22d3a13705b3bc3c$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $22d3a13705b3bc3c$export$a8ff84c12d48cfa6, (v) => $22d3a13705b3bc3c$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $22d3a13705b3bc3c$export$98e6a39c04603d36, (v) => $22d3a13705b3bc3c$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $22d3a13705b3bc3c$export$46a2a563c28afca0, (v) => $22d3a13705b3bc3c$export$46a2a563c28afca0 = v);
$parcel$export(module.exports, "walkContext", () => $22d3a13705b3bc3c$export$f7e0bb689fefb8c2, (v) => $22d3a13705b3bc3c$export$f7e0bb689fefb8c2 = v);
var $22d3a13705b3bc3c$export$80d376111cc09ad7;
var $22d3a13705b3bc3c$export$a8ff84c12d48cfa6;
var $22d3a13705b3bc3c$export$98e6a39c04603d36;
var $22d3a13705b3bc3c$export$46a2a563c28afca0;
var $22d3a13705b3bc3c$export$f7e0bb689fefb8c2;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $22d3a13705b3bc3c$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
function $22d3a13705b3bc3c$var$consumeRaw(startToken) {
    return this.Raw(startToken, null, false);
}
const $22d3a13705b3bc3c$var$name = 'StyleSheet';
const $22d3a13705b3bc3c$var$walkContext = 'stylesheet';
const $22d3a13705b3bc3c$var$structure = {
    children: [
        [
            'Comment',
            'CDO',
            'CDC',
            'Atrule',
            'Rule',
            'Raw'
        ]
    ]
};
function $22d3a13705b3bc3c$var$parse() {
    const start = this.tokenStart;
    const children = this.createList();
    let child;
    while(!this.eof){
        switch(this.tokenType){
            case $iYo0F.WhiteSpace:
                this.next();
                continue;
            case $iYo0F.Comment:
                // ignore comments except exclamation comments (i.e. /*! .. */) on top level
                if (this.charCodeAt(this.tokenStart + 2) !== $22d3a13705b3bc3c$var$EXCLAMATIONMARK) {
                    this.next();
                    continue;
                }
                child = this.Comment();
                break;
            case $iYo0F.CDO:
                child = this.CDO();
                break;
            case $iYo0F.CDC:
                child = this.CDC();
                break;
            // CSS Syntax Module Level 3
            // §2.2 Error handling
            // At the "top level" of a stylesheet, an <at-keyword-token> starts an at-rule.
            case $iYo0F.AtKeyword:
                child = this.parseWithFallback(this.Atrule, $22d3a13705b3bc3c$var$consumeRaw);
                break;
            // Anything else starts a qualified rule ...
            default:
                child = this.parseWithFallback(this.Rule, $22d3a13705b3bc3c$var$consumeRaw);
        }
        children.push(child);
    }
    return {
        type: 'StyleSheet',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $22d3a13705b3bc3c$var$generate(node) {
    this.children(node);
}
$22d3a13705b3bc3c$export$80d376111cc09ad7 = $22d3a13705b3bc3c$var$generate;
$22d3a13705b3bc3c$export$a8ff84c12d48cfa6 = $22d3a13705b3bc3c$var$name;
$22d3a13705b3bc3c$export$98e6a39c04603d36 = $22d3a13705b3bc3c$var$parse;
$22d3a13705b3bc3c$export$46a2a563c28afca0 = $22d3a13705b3bc3c$var$structure;
$22d3a13705b3bc3c$export$f7e0bb689fefb8c2 = $22d3a13705b3bc3c$var$walkContext;

});

parcelRegister("lz3BD", function(module, exports) {

$parcel$export(module.exports, "generate", () => $fb2fa9f203e20d40$export$80d376111cc09ad7, (v) => $fb2fa9f203e20d40$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $fb2fa9f203e20d40$export$a8ff84c12d48cfa6, (v) => $fb2fa9f203e20d40$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $fb2fa9f203e20d40$export$98e6a39c04603d36, (v) => $fb2fa9f203e20d40$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $fb2fa9f203e20d40$export$46a2a563c28afca0, (v) => $fb2fa9f203e20d40$export$46a2a563c28afca0 = v);
var $fb2fa9f203e20d40$export$80d376111cc09ad7;
var $fb2fa9f203e20d40$export$a8ff84c12d48cfa6;
var $fb2fa9f203e20d40$export$98e6a39c04603d36;
var $fb2fa9f203e20d40$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $fb2fa9f203e20d40$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $fb2fa9f203e20d40$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
function $fb2fa9f203e20d40$var$eatIdentifierOrAsterisk() {
    if (this.tokenType !== $iYo0F.Ident && this.isDelim($fb2fa9f203e20d40$var$ASTERISK) === false) this.error('Identifier or asterisk is expected');
    this.next();
}
const $fb2fa9f203e20d40$var$name = 'TypeSelector';
const $fb2fa9f203e20d40$var$structure = {
    name: String
};
// ident
// ident|ident
// ident|*
// *
// *|ident
// *|*
// |ident
// |*
function $fb2fa9f203e20d40$var$parse() {
    const start = this.tokenStart;
    if (this.isDelim($fb2fa9f203e20d40$var$VERTICALLINE)) {
        this.next();
        $fb2fa9f203e20d40$var$eatIdentifierOrAsterisk.call(this);
    } else {
        $fb2fa9f203e20d40$var$eatIdentifierOrAsterisk.call(this);
        if (this.isDelim($fb2fa9f203e20d40$var$VERTICALLINE)) {
            this.next();
            $fb2fa9f203e20d40$var$eatIdentifierOrAsterisk.call(this);
        }
    }
    return {
        type: 'TypeSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start)
    };
}
function $fb2fa9f203e20d40$var$generate(node) {
    this.tokenize(node.name);
}
$fb2fa9f203e20d40$export$80d376111cc09ad7 = $fb2fa9f203e20d40$var$generate;
$fb2fa9f203e20d40$export$a8ff84c12d48cfa6 = $fb2fa9f203e20d40$var$name;
$fb2fa9f203e20d40$export$98e6a39c04603d36 = $fb2fa9f203e20d40$var$parse;
$fb2fa9f203e20d40$export$46a2a563c28afca0 = $fb2fa9f203e20d40$var$structure;

});

parcelRegister("51prC", function(module, exports) {

$parcel$export(module.exports, "generate", () => $3a80c878c4a12e39$export$80d376111cc09ad7, (v) => $3a80c878c4a12e39$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $3a80c878c4a12e39$export$a8ff84c12d48cfa6, (v) => $3a80c878c4a12e39$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $3a80c878c4a12e39$export$98e6a39c04603d36, (v) => $3a80c878c4a12e39$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $3a80c878c4a12e39$export$46a2a563c28afca0, (v) => $3a80c878c4a12e39$export$46a2a563c28afca0 = v);
var $3a80c878c4a12e39$export$80d376111cc09ad7;
var $3a80c878c4a12e39$export$a8ff84c12d48cfa6;
var $3a80c878c4a12e39$export$98e6a39c04603d36;
var $3a80c878c4a12e39$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");

var $kIeAG = parcelRequire("kIeAG");
const $3a80c878c4a12e39$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $3a80c878c4a12e39$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $3a80c878c4a12e39$var$QUESTIONMARK = 0x003F; // U+003F QUESTION MARK (?)
function $3a80c878c4a12e39$var$eatHexSequence(offset, allowDash) {
    let len = 0;
    for(let pos = this.tokenStart + offset; pos < this.tokenEnd; pos++){
        const code = this.charCodeAt(pos);
        if (code === $3a80c878c4a12e39$var$HYPHENMINUS && allowDash && len !== 0) {
            $3a80c878c4a12e39$var$eatHexSequence.call(this, offset + len + 1, false);
            return -1;
        }
        if (!$kIeAG.isHexDigit(code)) this.error(allowDash && len !== 0 ? 'Hyphen minus' + (len < 6 ? ' or hex digit' : '') + ' is expected' : len < 6 ? 'Hex digit is expected' : 'Unexpected input', pos);
        if (++len > 6) this.error('Too many hex digits', pos);
    }
    this.next();
    return len;
}
function $3a80c878c4a12e39$var$eatQuestionMarkSequence(max) {
    let count = 0;
    while(this.isDelim($3a80c878c4a12e39$var$QUESTIONMARK)){
        if (++count > max) this.error('Too many question marks');
        this.next();
    }
}
function $3a80c878c4a12e39$var$startsWith(code) {
    if (this.charCodeAt(this.tokenStart) !== code) this.error((code === $3a80c878c4a12e39$var$PLUSSIGN ? 'Plus sign' : 'Hyphen minus') + ' is expected');
}
// https://drafts.csswg.org/css-syntax/#urange
// Informally, the <urange> production has three forms:
// U+0001
//      Defines a range consisting of a single code point, in this case the code point "1".
// U+0001-00ff
//      Defines a range of codepoints between the first and the second value, in this case
//      the range between "1" and "ff" (255 in decimal) inclusive.
// U+00??
//      Defines a range of codepoints where the "?" characters range over all hex digits,
//      in this case defining the same as the value U+0000-00ff.
// In each form, a maximum of 6 digits is allowed for each hexadecimal number (if you treat "?" as a hexadecimal digit).
//
// <urange> =
//   u '+' <ident-token> '?'* |
//   u <dimension-token> '?'* |
//   u <number-token> '?'* |
//   u <number-token> <dimension-token> |
//   u <number-token> <number-token> |
//   u '+' '?'+
function $3a80c878c4a12e39$var$scanUnicodeRange() {
    let hexLength = 0;
    switch(this.tokenType){
        case $iYo0F.Number:
            // u <number-token> '?'*
            // u <number-token> <dimension-token>
            // u <number-token> <number-token>
            hexLength = $3a80c878c4a12e39$var$eatHexSequence.call(this, 1, true);
            if (this.isDelim($3a80c878c4a12e39$var$QUESTIONMARK)) {
                $3a80c878c4a12e39$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
                break;
            }
            if (this.tokenType === $iYo0F.Dimension || this.tokenType === $iYo0F.Number) {
                $3a80c878c4a12e39$var$startsWith.call(this, $3a80c878c4a12e39$var$HYPHENMINUS);
                $3a80c878c4a12e39$var$eatHexSequence.call(this, 1, false);
                break;
            }
            break;
        case $iYo0F.Dimension:
            // u <dimension-token> '?'*
            hexLength = $3a80c878c4a12e39$var$eatHexSequence.call(this, 1, true);
            if (hexLength > 0) $3a80c878c4a12e39$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
            break;
        default:
            // u '+' <ident-token> '?'*
            // u '+' '?'+
            this.eatDelim($3a80c878c4a12e39$var$PLUSSIGN);
            if (this.tokenType === $iYo0F.Ident) {
                hexLength = $3a80c878c4a12e39$var$eatHexSequence.call(this, 0, true);
                if (hexLength > 0) $3a80c878c4a12e39$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
                break;
            }
            if (this.isDelim($3a80c878c4a12e39$var$QUESTIONMARK)) {
                this.next();
                $3a80c878c4a12e39$var$eatQuestionMarkSequence.call(this, 5);
                break;
            }
            this.error('Hex digit or question mark is expected');
    }
}
const $3a80c878c4a12e39$var$name = 'UnicodeRange';
const $3a80c878c4a12e39$var$structure = {
    value: String
};
function $3a80c878c4a12e39$var$parse() {
    const start = this.tokenStart;
    // U or u
    this.eatIdent('u');
    $3a80c878c4a12e39$var$scanUnicodeRange.call(this);
    return {
        type: 'UnicodeRange',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start)
    };
}
function $3a80c878c4a12e39$var$generate(node) {
    this.tokenize(node.value);
}
$3a80c878c4a12e39$export$80d376111cc09ad7 = $3a80c878c4a12e39$var$generate;
$3a80c878c4a12e39$export$a8ff84c12d48cfa6 = $3a80c878c4a12e39$var$name;
$3a80c878c4a12e39$export$98e6a39c04603d36 = $3a80c878c4a12e39$var$parse;
$3a80c878c4a12e39$export$46a2a563c28afca0 = $3a80c878c4a12e39$var$structure;

});

parcelRegister("id4Cb", function(module, exports) {

$parcel$export(module.exports, "generate", () => $d41d05482ef35d5d$export$80d376111cc09ad7, (v) => $d41d05482ef35d5d$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $d41d05482ef35d5d$export$a8ff84c12d48cfa6, (v) => $d41d05482ef35d5d$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $d41d05482ef35d5d$export$98e6a39c04603d36, (v) => $d41d05482ef35d5d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $d41d05482ef35d5d$export$46a2a563c28afca0, (v) => $d41d05482ef35d5d$export$46a2a563c28afca0 = v);
var $d41d05482ef35d5d$export$80d376111cc09ad7;
var $d41d05482ef35d5d$export$a8ff84c12d48cfa6;
var $d41d05482ef35d5d$export$98e6a39c04603d36;
var $d41d05482ef35d5d$export$46a2a563c28afca0;
'use strict';

var $1r7OF = parcelRequire("1r7OF");

var $lF7ah = parcelRequire("lF7ah");

var $iYo0F = parcelRequire("iYo0F");
const $d41d05482ef35d5d$var$name = 'Url';
const $d41d05482ef35d5d$var$structure = {
    value: String
};
// <url-token> | <function-token> <string> )
function $d41d05482ef35d5d$var$parse() {
    const start = this.tokenStart;
    let value;
    switch(this.tokenType){
        case $iYo0F.Url:
            value = $1r7OF.decode(this.consume($iYo0F.Url));
            break;
        case $iYo0F.Function:
            if (!this.cmpStr(this.tokenStart, this.tokenEnd, 'url(')) this.error('Function name must be `url`');
            this.eat($iYo0F.Function);
            this.skipSC();
            value = $lF7ah.decode(this.consume($iYo0F.String));
            this.skipSC();
            if (!this.eof) this.eat($iYo0F.RightParenthesis);
            break;
        default:
            this.error('Url or Function is expected');
    }
    return {
        type: 'Url',
        loc: this.getLocation(start, this.tokenStart),
        value: value
    };
}
function $d41d05482ef35d5d$var$generate(node) {
    this.token($iYo0F.Url, $1r7OF.encode(node.value));
}
$d41d05482ef35d5d$export$80d376111cc09ad7 = $d41d05482ef35d5d$var$generate;
$d41d05482ef35d5d$export$a8ff84c12d48cfa6 = $d41d05482ef35d5d$var$name;
$d41d05482ef35d5d$export$98e6a39c04603d36 = $d41d05482ef35d5d$var$parse;
$d41d05482ef35d5d$export$46a2a563c28afca0 = $d41d05482ef35d5d$var$structure;

});
parcelRegister("1r7OF", function(module, exports) {

$parcel$export(module.exports, "decode", () => $10be602f39acbef9$export$2f872c0f2117be69, (v) => $10be602f39acbef9$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "encode", () => $10be602f39acbef9$export$c564cdbbe6da493, (v) => $10be602f39acbef9$export$c564cdbbe6da493 = v);
var $10be602f39acbef9$export$2f872c0f2117be69;
var $10be602f39acbef9$export$c564cdbbe6da493;
'use strict';

var $kIeAG = parcelRequire("kIeAG");

var $7UrOl = parcelRequire("7UrOl");
const $10be602f39acbef9$var$SPACE = 0x0020; // U+0020 SPACE
const $10be602f39acbef9$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
const $10be602f39acbef9$var$QUOTATION_MARK = 0x0022; // "
const $10be602f39acbef9$var$APOSTROPHE = 0x0027; // '
const $10be602f39acbef9$var$LEFTPARENTHESIS = 0x0028; // U+0028 LEFT PARENTHESIS (()
const $10be602f39acbef9$var$RIGHTPARENTHESIS = 0x0029; // U+0029 RIGHT PARENTHESIS ())
function $10be602f39acbef9$var$decode(str) {
    const len = str.length;
    let start = 4; // length of "url("
    let end = str.charCodeAt(len - 1) === $10be602f39acbef9$var$RIGHTPARENTHESIS ? len - 2 : len - 1;
    let decoded = '';
    while(start < end && $kIeAG.isWhiteSpace(str.charCodeAt(start)))start++;
    while(start < end && $kIeAG.isWhiteSpace(str.charCodeAt(end)))end--;
    for(let i = start; i <= end; i++){
        let code = str.charCodeAt(i);
        if (code === $10be602f39acbef9$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) {
                // if the next input code point is EOF, do nothing
                // otherwise include last left parenthesis as escaped
                if (i !== len - 1) decoded = str.substr(i + 1);
                break;
            }
            code = str.charCodeAt(++i);
            // consume escaped
            if ($kIeAG.isValidEscape($10be602f39acbef9$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = $7UrOl.consumeEscaped(str, escapeStart);
                i = escapeEnd - 1;
                decoded += $7UrOl.decodeEscaped(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
function $10be602f39acbef9$var$encode(str) {
    let encoded = '';
    let wsBeforeHexIsNeeded = false;
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        // If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F,
        // the character escaped as code point.
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        if (code <= 0x001f || code === 0x007F) {
            encoded += '\\' + code.toString(16);
            wsBeforeHexIsNeeded = true;
            continue;
        }
        if (code === $10be602f39acbef9$var$SPACE || code === $10be602f39acbef9$var$REVERSE_SOLIDUS || code === $10be602f39acbef9$var$QUOTATION_MARK || code === $10be602f39acbef9$var$APOSTROPHE || code === $10be602f39acbef9$var$LEFTPARENTHESIS || code === $10be602f39acbef9$var$RIGHTPARENTHESIS) {
            encoded += '\\' + str.charAt(i);
            wsBeforeHexIsNeeded = false;
        } else {
            if (wsBeforeHexIsNeeded && $kIeAG.isHexDigit(code)) encoded += ' ';
            encoded += str.charAt(i);
            wsBeforeHexIsNeeded = false;
        }
    }
    return 'url(' + encoded + ')';
}
$10be602f39acbef9$export$2f872c0f2117be69 = $10be602f39acbef9$var$decode;
$10be602f39acbef9$export$c564cdbbe6da493 = $10be602f39acbef9$var$encode;

});


parcelRegister("dpFhL", function(module, exports) {

$parcel$export(module.exports, "generate", () => $9c3da2995bc56853$export$80d376111cc09ad7, (v) => $9c3da2995bc56853$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $9c3da2995bc56853$export$a8ff84c12d48cfa6, (v) => $9c3da2995bc56853$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $9c3da2995bc56853$export$98e6a39c04603d36, (v) => $9c3da2995bc56853$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $9c3da2995bc56853$export$46a2a563c28afca0, (v) => $9c3da2995bc56853$export$46a2a563c28afca0 = v);
var $9c3da2995bc56853$export$80d376111cc09ad7;
var $9c3da2995bc56853$export$a8ff84c12d48cfa6;
var $9c3da2995bc56853$export$98e6a39c04603d36;
var $9c3da2995bc56853$export$46a2a563c28afca0;
'use strict';
const $9c3da2995bc56853$var$name = 'Value';
const $9c3da2995bc56853$var$structure = {
    children: [
        []
    ]
};
function $9c3da2995bc56853$var$parse() {
    const start = this.tokenStart;
    const children = this.readSequence(this.scope.Value);
    return {
        type: 'Value',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $9c3da2995bc56853$var$generate(node) {
    this.children(node);
}
$9c3da2995bc56853$export$80d376111cc09ad7 = $9c3da2995bc56853$var$generate;
$9c3da2995bc56853$export$a8ff84c12d48cfa6 = $9c3da2995bc56853$var$name;
$9c3da2995bc56853$export$98e6a39c04603d36 = $9c3da2995bc56853$var$parse;
$9c3da2995bc56853$export$46a2a563c28afca0 = $9c3da2995bc56853$var$structure;

});

parcelRegister("c6UNZ", function(module, exports) {

$parcel$export(module.exports, "generate", () => $8d121bf0252a8225$export$80d376111cc09ad7, (v) => $8d121bf0252a8225$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "name", () => $8d121bf0252a8225$export$a8ff84c12d48cfa6, (v) => $8d121bf0252a8225$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "parse", () => $8d121bf0252a8225$export$98e6a39c04603d36, (v) => $8d121bf0252a8225$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "structure", () => $8d121bf0252a8225$export$46a2a563c28afca0, (v) => $8d121bf0252a8225$export$46a2a563c28afca0 = v);
var $8d121bf0252a8225$export$80d376111cc09ad7;
var $8d121bf0252a8225$export$a8ff84c12d48cfa6;
var $8d121bf0252a8225$export$98e6a39c04603d36;
var $8d121bf0252a8225$export$46a2a563c28afca0;
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $8d121bf0252a8225$var$SPACE = Object.freeze({
    type: 'WhiteSpace',
    loc: null,
    value: ' '
});
const $8d121bf0252a8225$var$name = 'WhiteSpace';
const $8d121bf0252a8225$var$structure = {
    value: String
};
function $8d121bf0252a8225$var$parse() {
    this.eat($iYo0F.WhiteSpace);
    return $8d121bf0252a8225$var$SPACE;
// return {
//     type: 'WhiteSpace',
//     loc: this.getLocation(this.tokenStart, this.tokenEnd),
//     value: this.consume(WHITESPACE)
// };
}
function $8d121bf0252a8225$var$generate(node) {
    this.token($iYo0F.WhiteSpace, node.value);
}
$8d121bf0252a8225$export$80d376111cc09ad7 = $8d121bf0252a8225$var$generate;
$8d121bf0252a8225$export$a8ff84c12d48cfa6 = $8d121bf0252a8225$var$name;
$8d121bf0252a8225$export$98e6a39c04603d36 = $8d121bf0252a8225$var$parse;
$8d121bf0252a8225$export$46a2a563c28afca0 = $8d121bf0252a8225$var$structure;

});



parcelRegister("tQYnB", function(module, exports) {
'use strict';

var $kRuM8 = parcelRequire("kRuM8");

var $jd9bG = parcelRequire("jd9bG");

var $IXvNq = parcelRequire("IXvNq");

var $aLKeg = parcelRequire("aLKeg");
const $059bccdb0bf7d517$var$config = {
    parseContext: {
        default: 'StyleSheet',
        stylesheet: 'StyleSheet',
        atrule: 'Atrule',
        atrulePrelude (options) {
            return this.AtrulePrelude(options.atrule ? String(options.atrule) : null);
        },
        mediaQueryList: 'MediaQueryList',
        mediaQuery: 'MediaQuery',
        rule: 'Rule',
        selectorList: 'SelectorList',
        selector: 'Selector',
        block () {
            return this.Block(true);
        },
        declarationList: 'DeclarationList',
        declaration: 'Declaration',
        value: 'Value'
    },
    scope: $kRuM8,
    atrule: $jd9bG,
    pseudo: $IXvNq,
    node: $aLKeg
};
module.exports = $059bccdb0bf7d517$var$config;

});
parcelRegister("kRuM8", function(module, exports) {

$parcel$export(module.exports, "AtrulePrelude", () => $f300a137ff534a83$export$a551ca711e9f0de7, (v) => $f300a137ff534a83$export$a551ca711e9f0de7 = v);
$parcel$export(module.exports, "Selector", () => $f300a137ff534a83$export$d15f4cd5286f9b1e, (v) => $f300a137ff534a83$export$d15f4cd5286f9b1e = v);
$parcel$export(module.exports, "Value", () => $f300a137ff534a83$export$4c8d1a57a761ef94, (v) => $f300a137ff534a83$export$4c8d1a57a761ef94 = v);
var $f300a137ff534a83$export$a551ca711e9f0de7;
var $f300a137ff534a83$export$d15f4cd5286f9b1e;
var $f300a137ff534a83$export$4c8d1a57a761ef94;
'use strict';

var $3AH7N = parcelRequire("3AH7N");

var $dGxav = parcelRequire("dGxav");

var $OtLwJ = parcelRequire("OtLwJ");
$f300a137ff534a83$export$a551ca711e9f0de7 = $3AH7N;
$f300a137ff534a83$export$d15f4cd5286f9b1e = $dGxav;
$f300a137ff534a83$export$4c8d1a57a761ef94 = $OtLwJ;

});
parcelRegister("3AH7N", function(module, exports) {
'use strict';

var $40OiX = parcelRequire("40OiX");
const $29d62f8bb2a83b8b$var$atrulePrelude = {
    getNode: $40OiX
};
module.exports = $29d62f8bb2a83b8b$var$atrulePrelude;

});
parcelRegister("40OiX", function(module, exports) {
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $2ebe2f005cdd8f49$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $2ebe2f005cdd8f49$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $2ebe2f005cdd8f49$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $2ebe2f005cdd8f49$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $2ebe2f005cdd8f49$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $2ebe2f005cdd8f49$var$U = 0x0075; // U+0075 LATIN SMALL LETTER U (u)
function $2ebe2f005cdd8f49$var$defaultRecognizer(context) {
    switch(this.tokenType){
        case $iYo0F.Hash:
            return this.Hash();
        case $iYo0F.Comma:
            return this.Operator();
        case $iYo0F.LeftParenthesis:
            return this.Parentheses(this.readSequence, context.recognizer);
        case $iYo0F.LeftSquareBracket:
            return this.Brackets(this.readSequence, context.recognizer);
        case $iYo0F.String:
            return this.String();
        case $iYo0F.Dimension:
            return this.Dimension();
        case $iYo0F.Percentage:
            return this.Percentage();
        case $iYo0F.Number:
            return this.Number();
        case $iYo0F.Function:
            return this.cmpStr(this.tokenStart, this.tokenEnd, 'url(') ? this.Url() : this.Function(this.readSequence, context.recognizer);
        case $iYo0F.Url:
            return this.Url();
        case $iYo0F.Ident:
            // check for unicode range, it should start with u+ or U+
            if (this.cmpChar(this.tokenStart, $2ebe2f005cdd8f49$var$U) && this.cmpChar(this.tokenStart + 1, $2ebe2f005cdd8f49$var$PLUSSIGN)) return this.UnicodeRange();
            else return this.Identifier();
        case $iYo0F.Delim:
            {
                const code = this.charCodeAt(this.tokenStart);
                if (code === $2ebe2f005cdd8f49$var$SOLIDUS || code === $2ebe2f005cdd8f49$var$ASTERISK || code === $2ebe2f005cdd8f49$var$PLUSSIGN || code === $2ebe2f005cdd8f49$var$HYPHENMINUS) return this.Operator(); // TODO: replace with Delim
                // TODO: produce a node with Delim node type
                if (code === $2ebe2f005cdd8f49$var$NUMBERSIGN) this.error('Hex or identifier is expected', this.tokenStart + 1);
                break;
            }
    }
}
module.exports = $2ebe2f005cdd8f49$var$defaultRecognizer;

});


parcelRegister("dGxav", function(module, exports) {
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $9f68ed2505ec6ef9$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $9f68ed2505ec6ef9$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $9f68ed2505ec6ef9$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $9f68ed2505ec6ef9$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $9f68ed2505ec6ef9$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
const $9f68ed2505ec6ef9$var$GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
const $9f68ed2505ec6ef9$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
const $9f68ed2505ec6ef9$var$TILDE = 0x007E; // U+007E TILDE (~)
function $9f68ed2505ec6ef9$var$onWhiteSpace(next, children) {
    if (children.last !== null && children.last.type !== 'Combinator' && next !== null && next.type !== 'Combinator') children.push({
        type: 'Combinator',
        loc: null,
        name: ' '
    });
}
function $9f68ed2505ec6ef9$var$getNode() {
    switch(this.tokenType){
        case $iYo0F.LeftSquareBracket:
            return this.AttributeSelector();
        case $iYo0F.Hash:
            return this.IdSelector();
        case $iYo0F.Colon:
            if (this.lookupType(1) === $iYo0F.Colon) return this.PseudoElementSelector();
            else return this.PseudoClassSelector();
        case $iYo0F.Ident:
            return this.TypeSelector();
        case $iYo0F.Number:
        case $iYo0F.Percentage:
            return this.Percentage();
        case $iYo0F.Dimension:
            // throws when .123ident
            if (this.charCodeAt(this.tokenStart) === $9f68ed2505ec6ef9$var$FULLSTOP) this.error('Identifier is expected', this.tokenStart + 1);
            break;
        case $iYo0F.Delim:
            {
                const code = this.charCodeAt(this.tokenStart);
                switch(code){
                    case $9f68ed2505ec6ef9$var$PLUSSIGN:
                    case $9f68ed2505ec6ef9$var$GREATERTHANSIGN:
                    case $9f68ed2505ec6ef9$var$TILDE:
                    case $9f68ed2505ec6ef9$var$SOLIDUS:
                        return this.Combinator();
                    case $9f68ed2505ec6ef9$var$FULLSTOP:
                        return this.ClassSelector();
                    case $9f68ed2505ec6ef9$var$ASTERISK:
                    case $9f68ed2505ec6ef9$var$VERTICALLINE:
                        return this.TypeSelector();
                    case $9f68ed2505ec6ef9$var$NUMBERSIGN:
                        return this.IdSelector();
                }
                break;
            }
    }
}
const $9f68ed2505ec6ef9$var$Selector = {
    onWhiteSpace: $9f68ed2505ec6ef9$var$onWhiteSpace,
    getNode: $9f68ed2505ec6ef9$var$getNode
};
module.exports = $9f68ed2505ec6ef9$var$Selector;

});

parcelRegister("OtLwJ", function(module, exports) {
'use strict';

var $40OiX = parcelRequire("40OiX");

var $aywJG = parcelRequire("aywJG");

var $iC66s = parcelRequire("iC66s");
function $097bc2727c82aa4f$var$isPlusMinusOperator(node) {
    return node !== null && node.type === 'Operator' && (node.value[node.value.length - 1] === '-' || node.value[node.value.length - 1] === '+');
}
const $097bc2727c82aa4f$var$value = {
    getNode: $40OiX,
    onWhiteSpace (next, children) {
        if ($097bc2727c82aa4f$var$isPlusMinusOperator(next)) next.value = ' ' + next.value;
        if ($097bc2727c82aa4f$var$isPlusMinusOperator(children.last)) children.last.value += ' ';
    },
    'expression': $aywJG,
    'var': $iC66s
};
module.exports = $097bc2727c82aa4f$var$value;

});
parcelRegister("aywJG", function(module, exports) {
'use strict';
// legacy IE function
// expression( <any-value> )
function $7af67907cf18875d$var$expressionFn() {
    return this.createSingleNodeList(this.Raw(this.tokenIndex, null, false));
}
module.exports = $7af67907cf18875d$var$expressionFn;

});

parcelRegister("iC66s", function(module, exports) {
'use strict';

var $iYo0F = parcelRequire("iYo0F");
// var( <ident> , <value>? )
function $d8d08290cc3fdcef$var$varFn() {
    const children = this.createList();
    this.skipSC();
    // NOTE: Don't check more than a first argument is an ident, rest checks are for lexer
    children.push(this.Identifier());
    this.skipSC();
    if (this.tokenType === $iYo0F.Comma) {
        children.push(this.Operator());
        const startIndex = this.tokenIndex;
        const value = this.parseCustomProperty ? this.Value(null) : this.Raw(this.tokenIndex, this.consumeUntilExclamationMarkOrSemicolon, false);
        if (value.type === 'Value' && value.children.isEmpty) {
            for(let offset = startIndex - this.tokenIndex; offset <= 0; offset++)if (this.lookupType(offset) === $iYo0F.WhiteSpace) {
                value.children.appendData({
                    type: 'WhiteSpace',
                    loc: null,
                    value: ' '
                });
                break;
            }
        }
        children.push(value);
    }
    return children;
}
module.exports = $d8d08290cc3fdcef$var$varFn;

});



parcelRegister("jd9bG", function(module, exports) {
'use strict';

var $hFzqK = parcelRequire("hFzqK");

var $en8dz = parcelRequire("en8dz");

var $8gJUD = parcelRequire("8gJUD");

var $1V5sN = parcelRequire("1V5sN");

var $4mHby = parcelRequire("4mHby");
const $dfc65ba8cfb5a059$var$atrule = {
    'font-face': $hFzqK,
    'import': $en8dz,
    media: $8gJUD,
    page: $1V5sN,
    supports: $4mHby
};
module.exports = $dfc65ba8cfb5a059$var$atrule;

});
parcelRegister("hFzqK", function(module, exports) {
'use strict';
const $cdd1bfb9fbba62cf$var$fontFace = {
    parse: {
        prelude: null,
        block () {
            return this.Block(true);
        }
    }
};
module.exports = $cdd1bfb9fbba62cf$var$fontFace;

});

parcelRegister("en8dz", function(module, exports) {
'use strict';

var $iYo0F = parcelRequire("iYo0F");
const $a769968ed17cdaad$var$importAtrule = {
    parse: {
        prelude () {
            const children = this.createList();
            this.skipSC();
            switch(this.tokenType){
                case $iYo0F.String:
                    children.push(this.String());
                    break;
                case $iYo0F.Url:
                case $iYo0F.Function:
                    children.push(this.Url());
                    break;
                default:
                    this.error('String or url() is expected');
            }
            if (this.lookupNonWSType(0) === $iYo0F.Ident || this.lookupNonWSType(0) === $iYo0F.LeftParenthesis) children.push(this.MediaQueryList());
            return children;
        },
        block: null
    }
};
module.exports = $a769968ed17cdaad$var$importAtrule;

});

parcelRegister("8gJUD", function(module, exports) {
'use strict';
const $60536e98a6ddaf84$var$media = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.MediaQueryList());
        },
        block () {
            return this.Block(false);
        }
    }
};
module.exports = $60536e98a6ddaf84$var$media;

});

parcelRegister("1V5sN", function(module, exports) {
'use strict';
const $165f5a43d9d99a26$var$page = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.SelectorList());
        },
        block () {
            return this.Block(true);
        }
    }
};
module.exports = $165f5a43d9d99a26$var$page;

});

parcelRegister("4mHby", function(module, exports) {
'use strict';

var $iYo0F = parcelRequire("iYo0F");
function $32dab735882c8428$var$consumeRaw() {
    return this.createSingleNodeList(this.Raw(this.tokenIndex, null, false));
}
function $32dab735882c8428$var$parentheses() {
    this.skipSC();
    if (this.tokenType === $iYo0F.Ident && this.lookupNonWSType(1) === $iYo0F.Colon) return this.createSingleNodeList(this.Declaration());
    return $32dab735882c8428$var$readSequence.call(this);
}
function $32dab735882c8428$var$readSequence() {
    const children = this.createList();
    let child;
    this.skipSC();
    scan: while(!this.eof){
        switch(this.tokenType){
            case $iYo0F.Comment:
            case $iYo0F.WhiteSpace:
                this.next();
                continue;
            case $iYo0F.Function:
                child = this.Function($32dab735882c8428$var$consumeRaw, this.scope.AtrulePrelude);
                break;
            case $iYo0F.Ident:
                child = this.Identifier();
                break;
            case $iYo0F.LeftParenthesis:
                child = this.Parentheses($32dab735882c8428$var$parentheses, this.scope.AtrulePrelude);
                break;
            default:
                break scan;
        }
        children.push(child);
    }
    return children;
}
const $32dab735882c8428$var$supports = {
    parse: {
        prelude () {
            const children = $32dab735882c8428$var$readSequence.call(this);
            if (this.getFirstListNode(children) === null) this.error('Condition is expected');
            return children;
        },
        block () {
            return this.Block(false);
        }
    }
};
module.exports = $32dab735882c8428$var$supports;

});


parcelRegister("IXvNq", function(module, exports) {
'use strict';
const $087245fccbc3b17c$var$selectorList = {
    parse () {
        return this.createSingleNodeList(this.SelectorList());
    }
};
const $087245fccbc3b17c$var$selector = {
    parse () {
        return this.createSingleNodeList(this.Selector());
    }
};
const $087245fccbc3b17c$var$identList = {
    parse () {
        return this.createSingleNodeList(this.Identifier());
    }
};
const $087245fccbc3b17c$var$nth = {
    parse () {
        return this.createSingleNodeList(this.Nth());
    }
};
const $087245fccbc3b17c$var$pseudo = {
    'dir': $087245fccbc3b17c$var$identList,
    'has': $087245fccbc3b17c$var$selectorList,
    'lang': $087245fccbc3b17c$var$identList,
    'matches': $087245fccbc3b17c$var$selectorList,
    'is': $087245fccbc3b17c$var$selectorList,
    '-moz-any': $087245fccbc3b17c$var$selectorList,
    '-webkit-any': $087245fccbc3b17c$var$selectorList,
    'where': $087245fccbc3b17c$var$selectorList,
    'not': $087245fccbc3b17c$var$selectorList,
    'nth-child': $087245fccbc3b17c$var$nth,
    'nth-last-child': $087245fccbc3b17c$var$nth,
    'nth-last-of-type': $087245fccbc3b17c$var$nth,
    'nth-of-type': $087245fccbc3b17c$var$nth,
    'slotted': $087245fccbc3b17c$var$selector
};
module.exports = $087245fccbc3b17c$var$pseudo;

});

parcelRegister("aLKeg", function(module, exports) {

$parcel$export(module.exports, "AnPlusB", () => $7d7227491b14936d$export$29d22f23fc62deec, (v) => $7d7227491b14936d$export$29d22f23fc62deec = v);
$parcel$export(module.exports, "Atrule", () => $7d7227491b14936d$export$b0e869c28ebe2686, (v) => $7d7227491b14936d$export$b0e869c28ebe2686 = v);
$parcel$export(module.exports, "AtrulePrelude", () => $7d7227491b14936d$export$a551ca711e9f0de7, (v) => $7d7227491b14936d$export$a551ca711e9f0de7 = v);
$parcel$export(module.exports, "AttributeSelector", () => $7d7227491b14936d$export$8170b1e1b2558dd5, (v) => $7d7227491b14936d$export$8170b1e1b2558dd5 = v);
$parcel$export(module.exports, "Block", () => $7d7227491b14936d$export$d96a8827a60d6b69, (v) => $7d7227491b14936d$export$d96a8827a60d6b69 = v);
$parcel$export(module.exports, "Brackets", () => $7d7227491b14936d$export$27f9608f5b4a4cfa, (v) => $7d7227491b14936d$export$27f9608f5b4a4cfa = v);
$parcel$export(module.exports, "CDC", () => $7d7227491b14936d$export$b0b2bd2d1777c179, (v) => $7d7227491b14936d$export$b0b2bd2d1777c179 = v);
$parcel$export(module.exports, "CDO", () => $7d7227491b14936d$export$521ef26a3002003b, (v) => $7d7227491b14936d$export$521ef26a3002003b = v);
$parcel$export(module.exports, "ClassSelector", () => $7d7227491b14936d$export$208720b1a4408baf, (v) => $7d7227491b14936d$export$208720b1a4408baf = v);
$parcel$export(module.exports, "Combinator", () => $7d7227491b14936d$export$3cbfd7ee92c4e2ca, (v) => $7d7227491b14936d$export$3cbfd7ee92c4e2ca = v);
$parcel$export(module.exports, "Comment", () => $7d7227491b14936d$export$4d299b491347818a, (v) => $7d7227491b14936d$export$4d299b491347818a = v);
$parcel$export(module.exports, "Declaration", () => $7d7227491b14936d$export$48f3d9e786303b67, (v) => $7d7227491b14936d$export$48f3d9e786303b67 = v);
$parcel$export(module.exports, "DeclarationList", () => $7d7227491b14936d$export$b8d0a768b241031f, (v) => $7d7227491b14936d$export$b8d0a768b241031f = v);
$parcel$export(module.exports, "Dimension", () => $7d7227491b14936d$export$c940ece961bc43c6, (v) => $7d7227491b14936d$export$c940ece961bc43c6 = v);
$parcel$export(module.exports, "Function", () => $7d7227491b14936d$export$f3890eeaf6851387, (v) => $7d7227491b14936d$export$f3890eeaf6851387 = v);
$parcel$export(module.exports, "Hash", () => $7d7227491b14936d$export$ab85ecd77ce6a5cd, (v) => $7d7227491b14936d$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "Identifier", () => $7d7227491b14936d$export$989167234458594d, (v) => $7d7227491b14936d$export$989167234458594d = v);
$parcel$export(module.exports, "IdSelector", () => $7d7227491b14936d$export$31c96e959895721d, (v) => $7d7227491b14936d$export$31c96e959895721d = v);
$parcel$export(module.exports, "MediaFeature", () => $7d7227491b14936d$export$a38b0f36e6ad18cf, (v) => $7d7227491b14936d$export$a38b0f36e6ad18cf = v);
$parcel$export(module.exports, "MediaQuery", () => $7d7227491b14936d$export$b745838c41029eb3, (v) => $7d7227491b14936d$export$b745838c41029eb3 = v);
$parcel$export(module.exports, "MediaQueryList", () => $7d7227491b14936d$export$789660f679e96cab, (v) => $7d7227491b14936d$export$789660f679e96cab = v);
$parcel$export(module.exports, "Nth", () => $7d7227491b14936d$export$69f042d6c338d0d, (v) => $7d7227491b14936d$export$69f042d6c338d0d = v);
$parcel$export(module.exports, "Number", () => $7d7227491b14936d$export$fffa67e515d04022, (v) => $7d7227491b14936d$export$fffa67e515d04022 = v);
$parcel$export(module.exports, "Operator", () => $7d7227491b14936d$export$fa5f90bfb4dbdbcd, (v) => $7d7227491b14936d$export$fa5f90bfb4dbdbcd = v);
$parcel$export(module.exports, "Parentheses", () => $7d7227491b14936d$export$f9c1f512ab2b4a4c, (v) => $7d7227491b14936d$export$f9c1f512ab2b4a4c = v);
$parcel$export(module.exports, "Percentage", () => $7d7227491b14936d$export$d11913f8a6922aea, (v) => $7d7227491b14936d$export$d11913f8a6922aea = v);
$parcel$export(module.exports, "PseudoClassSelector", () => $7d7227491b14936d$export$4a1f3470168c60fe, (v) => $7d7227491b14936d$export$4a1f3470168c60fe = v);
$parcel$export(module.exports, "PseudoElementSelector", () => $7d7227491b14936d$export$fcc96471f1c8a2f3, (v) => $7d7227491b14936d$export$fcc96471f1c8a2f3 = v);
$parcel$export(module.exports, "Ratio", () => $7d7227491b14936d$export$438ad6fc467f929b, (v) => $7d7227491b14936d$export$438ad6fc467f929b = v);
$parcel$export(module.exports, "Raw", () => $7d7227491b14936d$export$6f88fe47d32c9c94, (v) => $7d7227491b14936d$export$6f88fe47d32c9c94 = v);
$parcel$export(module.exports, "Rule", () => $7d7227491b14936d$export$f1ff2a90c38ff669, (v) => $7d7227491b14936d$export$f1ff2a90c38ff669 = v);
$parcel$export(module.exports, "Selector", () => $7d7227491b14936d$export$d15f4cd5286f9b1e, (v) => $7d7227491b14936d$export$d15f4cd5286f9b1e = v);
$parcel$export(module.exports, "SelectorList", () => $7d7227491b14936d$export$d2c5a04859a7aa8c, (v) => $7d7227491b14936d$export$d2c5a04859a7aa8c = v);
$parcel$export(module.exports, "String", () => $7d7227491b14936d$export$89b8e0fa65f6a914, (v) => $7d7227491b14936d$export$89b8e0fa65f6a914 = v);
$parcel$export(module.exports, "StyleSheet", () => $7d7227491b14936d$export$9d753cd7ae895cce, (v) => $7d7227491b14936d$export$9d753cd7ae895cce = v);
$parcel$export(module.exports, "TypeSelector", () => $7d7227491b14936d$export$1cbeb7199b91dfe2, (v) => $7d7227491b14936d$export$1cbeb7199b91dfe2 = v);
$parcel$export(module.exports, "UnicodeRange", () => $7d7227491b14936d$export$3f8e011aa996e1b4, (v) => $7d7227491b14936d$export$3f8e011aa996e1b4 = v);
$parcel$export(module.exports, "Url", () => $7d7227491b14936d$export$59d795186a5d3f58, (v) => $7d7227491b14936d$export$59d795186a5d3f58 = v);
$parcel$export(module.exports, "Value", () => $7d7227491b14936d$export$4c8d1a57a761ef94, (v) => $7d7227491b14936d$export$4c8d1a57a761ef94 = v);
$parcel$export(module.exports, "WhiteSpace", () => $7d7227491b14936d$export$fb98946286ab4c97, (v) => $7d7227491b14936d$export$fb98946286ab4c97 = v);
var $7d7227491b14936d$export$29d22f23fc62deec;
var $7d7227491b14936d$export$b0e869c28ebe2686;
var $7d7227491b14936d$export$a551ca711e9f0de7;
var $7d7227491b14936d$export$8170b1e1b2558dd5;
var $7d7227491b14936d$export$d96a8827a60d6b69;
var $7d7227491b14936d$export$27f9608f5b4a4cfa;
var $7d7227491b14936d$export$b0b2bd2d1777c179;
var $7d7227491b14936d$export$521ef26a3002003b;
var $7d7227491b14936d$export$208720b1a4408baf;
var $7d7227491b14936d$export$3cbfd7ee92c4e2ca;
var $7d7227491b14936d$export$4d299b491347818a;
var $7d7227491b14936d$export$48f3d9e786303b67;
var $7d7227491b14936d$export$b8d0a768b241031f;
var $7d7227491b14936d$export$c940ece961bc43c6;
var $7d7227491b14936d$export$f3890eeaf6851387;
var $7d7227491b14936d$export$ab85ecd77ce6a5cd;
var $7d7227491b14936d$export$989167234458594d;
var $7d7227491b14936d$export$31c96e959895721d;
var $7d7227491b14936d$export$a38b0f36e6ad18cf;
var $7d7227491b14936d$export$b745838c41029eb3;
var $7d7227491b14936d$export$789660f679e96cab;
var $7d7227491b14936d$export$69f042d6c338d0d;
var $7d7227491b14936d$export$fffa67e515d04022;
var $7d7227491b14936d$export$fa5f90bfb4dbdbcd;
var $7d7227491b14936d$export$f9c1f512ab2b4a4c;
var $7d7227491b14936d$export$d11913f8a6922aea;
var $7d7227491b14936d$export$4a1f3470168c60fe;
var $7d7227491b14936d$export$fcc96471f1c8a2f3;
var $7d7227491b14936d$export$438ad6fc467f929b;
var $7d7227491b14936d$export$6f88fe47d32c9c94;
var $7d7227491b14936d$export$f1ff2a90c38ff669;
var $7d7227491b14936d$export$d15f4cd5286f9b1e;
var $7d7227491b14936d$export$d2c5a04859a7aa8c;
var $7d7227491b14936d$export$89b8e0fa65f6a914;
var $7d7227491b14936d$export$9d753cd7ae895cce;
var $7d7227491b14936d$export$1cbeb7199b91dfe2;
var $7d7227491b14936d$export$3f8e011aa996e1b4;
var $7d7227491b14936d$export$59d795186a5d3f58;
var $7d7227491b14936d$export$4c8d1a57a761ef94;
var $7d7227491b14936d$export$fb98946286ab4c97;
'use strict';

var $kqMf5 = parcelRequire("kqMf5");

var $4zWEu = parcelRequire("4zWEu");

var $a6F6BB = parcelRequire("a6F6BB");

var $is1r8 = parcelRequire("is1r8");

var $f7sOf = parcelRequire("f7sOf");

var $8xr0b = parcelRequire("8xr0b");

var $jplhI = parcelRequire("jplhI");

var $hQNxd = parcelRequire("hQNxd");

var $7VwxD = parcelRequire("7VwxD");

var $aNcVJ = parcelRequire("aNcVJ");

var $hSilY = parcelRequire("hSilY");

var $bpQLC = parcelRequire("bpQLC");

var $ksrhQ = parcelRequire("ksrhQ");

var $ej7Bo = parcelRequire("ej7Bo");

var $gGYMY = parcelRequire("gGYMY");

var $4I8uN = parcelRequire("4I8uN");

var $01xxE = parcelRequire("01xxE");

var $an8qD = parcelRequire("an8qD");

var $9zX8c = parcelRequire("9zX8c");

var $eLYwZ = parcelRequire("eLYwZ");

var $e5Xih = parcelRequire("e5Xih");

var $c53ky = parcelRequire("c53ky");

var $gXnZP = parcelRequire("gXnZP");

var $aQk36 = parcelRequire("aQk36");

var $fju2N = parcelRequire("fju2N");

var $2kUaV = parcelRequire("2kUaV");

var $6BEdX = parcelRequire("6BEdX");

var $TNJb9 = parcelRequire("TNJb9");

var $2lkt2 = parcelRequire("2lkt2");

var $aTzIL = parcelRequire("aTzIL");

var $5ppzC = parcelRequire("5ppzC");

var $9gWZU = parcelRequire("9gWZU");

var $3CnUF = parcelRequire("3CnUF");

var $1v6vW = parcelRequire("1v6vW");

var $2ZnEQ = parcelRequire("2ZnEQ");

var $lz3BD = parcelRequire("lz3BD");

var $51prC = parcelRequire("51prC");

var $id4Cb = parcelRequire("id4Cb");

var $dpFhL = parcelRequire("dpFhL");

var $c6UNZ = parcelRequire("c6UNZ");
$7d7227491b14936d$export$29d22f23fc62deec = $kqMf5.parse;
$7d7227491b14936d$export$b0e869c28ebe2686 = $4zWEu.parse;
$7d7227491b14936d$export$a551ca711e9f0de7 = $a6F6BB.parse;
$7d7227491b14936d$export$8170b1e1b2558dd5 = $is1r8.parse;
$7d7227491b14936d$export$d96a8827a60d6b69 = $f7sOf.parse;
$7d7227491b14936d$export$27f9608f5b4a4cfa = $8xr0b.parse;
$7d7227491b14936d$export$b0b2bd2d1777c179 = $jplhI.parse;
$7d7227491b14936d$export$521ef26a3002003b = $hQNxd.parse;
$7d7227491b14936d$export$208720b1a4408baf = $7VwxD.parse;
$7d7227491b14936d$export$3cbfd7ee92c4e2ca = $aNcVJ.parse;
$7d7227491b14936d$export$4d299b491347818a = $hSilY.parse;
$7d7227491b14936d$export$48f3d9e786303b67 = $bpQLC.parse;
$7d7227491b14936d$export$b8d0a768b241031f = $ksrhQ.parse;
$7d7227491b14936d$export$c940ece961bc43c6 = $ej7Bo.parse;
$7d7227491b14936d$export$f3890eeaf6851387 = $gGYMY.parse;
$7d7227491b14936d$export$ab85ecd77ce6a5cd = $4I8uN.parse;
$7d7227491b14936d$export$989167234458594d = $01xxE.parse;
$7d7227491b14936d$export$31c96e959895721d = $an8qD.parse;
$7d7227491b14936d$export$a38b0f36e6ad18cf = $9zX8c.parse;
$7d7227491b14936d$export$b745838c41029eb3 = $eLYwZ.parse;
$7d7227491b14936d$export$789660f679e96cab = $e5Xih.parse;
$7d7227491b14936d$export$69f042d6c338d0d = $c53ky.parse;
$7d7227491b14936d$export$fffa67e515d04022 = $gXnZP.parse;
$7d7227491b14936d$export$fa5f90bfb4dbdbcd = $aQk36.parse;
$7d7227491b14936d$export$f9c1f512ab2b4a4c = $fju2N.parse;
$7d7227491b14936d$export$d11913f8a6922aea = $2kUaV.parse;
$7d7227491b14936d$export$4a1f3470168c60fe = $6BEdX.parse;
$7d7227491b14936d$export$fcc96471f1c8a2f3 = $TNJb9.parse;
$7d7227491b14936d$export$438ad6fc467f929b = $2lkt2.parse;
$7d7227491b14936d$export$6f88fe47d32c9c94 = $aTzIL.parse;
$7d7227491b14936d$export$f1ff2a90c38ff669 = $5ppzC.parse;
$7d7227491b14936d$export$d15f4cd5286f9b1e = $9gWZU.parse;
$7d7227491b14936d$export$d2c5a04859a7aa8c = $3CnUF.parse;
$7d7227491b14936d$export$89b8e0fa65f6a914 = $1v6vW.parse;
$7d7227491b14936d$export$9d753cd7ae895cce = $2ZnEQ.parse;
$7d7227491b14936d$export$1cbeb7199b91dfe2 = $lz3BD.parse;
$7d7227491b14936d$export$3f8e011aa996e1b4 = $51prC.parse;
$7d7227491b14936d$export$59d795186a5d3f58 = $id4Cb.parse;
$7d7227491b14936d$export$4c8d1a57a761ef94 = $dpFhL.parse;
$7d7227491b14936d$export$fb98946286ab4c97 = $c6UNZ.parse;

});


parcelRegister("1WjjG", function(module, exports) {
'use strict';

var $1jT8b = parcelRequire("1jT8b");
const $169a31165ff653aa$var$config = {
    node: $1jT8b
};
module.exports = $169a31165ff653aa$var$config;

});


parcelRegister("ktuCZ", function(module, exports) {
module.exports = "2.2.1";

});

parcelRegister("7DVyC", function(module, exports) {

$parcel$export(module.exports, "SyntaxError", () => $5908d2a082826d37$export$f21cea08b0dd60e8, (v) => $5908d2a082826d37$export$f21cea08b0dd60e8 = v);
$parcel$export(module.exports, "generate", () => $5908d2a082826d37$export$80d376111cc09ad7, (v) => $5908d2a082826d37$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "parse", () => $5908d2a082826d37$export$98e6a39c04603d36, (v) => $5908d2a082826d37$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "walk", () => $5908d2a082826d37$export$588732934346abbf, (v) => $5908d2a082826d37$export$588732934346abbf = v);
var $5908d2a082826d37$export$f21cea08b0dd60e8;
var $5908d2a082826d37$export$80d376111cc09ad7;
var $5908d2a082826d37$export$98e6a39c04603d36;
var $5908d2a082826d37$export$588732934346abbf;
'use strict';

var $MxUmp = parcelRequire("MxUmp");

var $fiYed = parcelRequire("fiYed");

var $8tOv6 = parcelRequire("8tOv6");

var $cSjEF = parcelRequire("cSjEF");
$5908d2a082826d37$export$f21cea08b0dd60e8 = $MxUmp.SyntaxError;
$5908d2a082826d37$export$80d376111cc09ad7 = $fiYed.generate;
$5908d2a082826d37$export$98e6a39c04603d36 = $8tOv6.parse;
$5908d2a082826d37$export$588732934346abbf = $cSjEF.walk;

});

parcelRegister("6vDqu", function(module, exports) {

$parcel$export(module.exports, "clone", () => $4bd438949849462a$export$9cd59f9826255e47, (v) => $4bd438949849462a$export$9cd59f9826255e47 = v);
var $4bd438949849462a$export$9cd59f9826255e47;
'use strict';

var $72kB1 = parcelRequire("72kB1");
function $4bd438949849462a$var$clone(node) {
    const result = {};
    for(const key in node){
        let value = node[key];
        if (value) {
            if (Array.isArray(value) || value instanceof $72kB1.List) value = value.map($4bd438949849462a$var$clone);
            else if (value.constructor === Object) value = $4bd438949849462a$var$clone(value);
        }
        result[key] = value;
    }
    return result;
}
$4bd438949849462a$export$9cd59f9826255e47 = $4bd438949849462a$var$clone;

});

parcelRegister("jFe7E", function(module, exports) {

$parcel$export(module.exports, "decode", () => $e50ccd142d89daaf$export$2f872c0f2117be69, (v) => $e50ccd142d89daaf$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "encode", () => $e50ccd142d89daaf$export$c564cdbbe6da493, (v) => $e50ccd142d89daaf$export$c564cdbbe6da493 = v);
var $e50ccd142d89daaf$export$2f872c0f2117be69;
var $e50ccd142d89daaf$export$c564cdbbe6da493;
'use strict';

var $kIeAG = parcelRequire("kIeAG");

var $7UrOl = parcelRequire("7UrOl");
const $e50ccd142d89daaf$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
function $e50ccd142d89daaf$var$decode(str) {
    const end = str.length - 1;
    let decoded = '';
    for(let i = 0; i < str.length; i++){
        let code = str.charCodeAt(i);
        if (code === $e50ccd142d89daaf$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) break;
            code = str.charCodeAt(++i);
            // consume escaped
            if ($kIeAG.isValidEscape($e50ccd142d89daaf$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = $7UrOl.consumeEscaped(str, escapeStart);
                i = escapeEnd - 1;
                decoded += $7UrOl.decodeEscaped(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
// https://drafts.csswg.org/cssom/#serialize-an-identifier
// § 2.1. Common Serializing Idioms
function $e50ccd142d89daaf$var$encode(str) {
    let encoded = '';
    // If the character is the first character and is a "-" (U+002D),
    // and there is no second character, then the escaped character.
    // Note: That's means a single dash string "-" return as escaped dash,
    // so move the condition out of the main loop
    if (str.length === 1 && str.charCodeAt(0) === 0x002D) return '\\-';
    // To serialize an identifier means to create a string represented
    // by the concatenation of, for each character of the identifier:
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        if (// If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F ...
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        code <= 0x001F || code === 0x007F || // [or] ... is in the range [0-9] (U+0030 to U+0039),
        code >= 0x0030 && code <= 0x0039 && // If the character is the first character ...
        (i === 0 || // If the character is the second character ... and the first character is a "-" (U+002D)
        i === 1 && str.charCodeAt(0) === 0x002D)) {
            // ... then the character escaped as code point.
            encoded += '\\' + code.toString(16) + ' ';
            continue;
        }
        // If the character is not handled by one of the above rules and is greater
        // than or equal to U+0080, is "-" (U+002D) or "_" (U+005F), or is in one
        // of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to U+005A),
        // or \[a-z] (U+0061 to U+007A), then the character itself.
        if ($kIeAG.isName(code)) encoded += str.charAt(i);
        else // Otherwise, the escaped character.
        encoded += '\\' + str.charAt(i);
    }
    return encoded;
}
$e50ccd142d89daaf$export$2f872c0f2117be69 = $e50ccd142d89daaf$var$decode;
$e50ccd142d89daaf$export$c564cdbbe6da493 = $e50ccd142d89daaf$var$encode;

});


parcelRegister("l2JNJ", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $eteAt = parcelRequire("eteAt");

var $6r8Jy = parcelRequire("6r8Jy");

var $1sA7C = parcelRequire("1sA7C");

var $eGYk7 = parcelRequire("eGYk7");
function $f51d50074db192f3$var$readChunk(input, specialComments) {
    const children = new $bi5JI.List();
    let nonSpaceTokenInBuffer = false;
    let protectedComment;
    input.nextUntil(input.head, (node, item, list)=>{
        if (node.type === 'Comment') {
            if (!specialComments || node.value.charAt(0) !== '!') {
                list.remove(item);
                return;
            }
            if (nonSpaceTokenInBuffer || protectedComment) return true;
            list.remove(item);
            protectedComment = node;
            return;
        }
        if (node.type !== 'WhiteSpace') nonSpaceTokenInBuffer = true;
        children.insert(list.remove(item));
    });
    return {
        comment: protectedComment,
        stylesheet: {
            type: 'StyleSheet',
            loc: null,
            children: children
        }
    };
}
function $f51d50074db192f3$var$compressChunk(ast, firstAtrulesAllowed, num, options) {
    options.logger(`Compress block #${num}`, null, true);
    let seed = 1;
    if (ast.type === 'StyleSheet') {
        ast.firstAtrulesAllowed = firstAtrulesAllowed;
        ast.id = seed++;
    }
    $bi5JI.walk(ast, {
        visit: 'Atrule',
        enter (node) {
            if (node.block !== null) node.block.id = seed++;
        }
    });
    options.logger('init', ast);
    // remove redundant
    $6r8Jy(ast, options);
    options.logger('clean', ast);
    // replace nodes for shortened forms
    $1sA7C(ast);
    options.logger('replace', ast);
    // structure optimisations
    if (options.restructuring) $eGYk7(ast, options);
    return ast;
}
function $f51d50074db192f3$var$getCommentsOption(options) {
    let comments = 'comments' in options ? options.comments : 'exclamation';
    if (typeof comments === 'boolean') comments = comments ? 'exclamation' : false;
    else if (comments !== 'exclamation' && comments !== 'first-exclamation') comments = false;
    return comments;
}
function $f51d50074db192f3$var$getRestructureOption(options) {
    if ('restructure' in options) return options.restructure;
    return 'restructuring' in options ? options.restructuring : true;
}
function $f51d50074db192f3$var$wrapBlock(block) {
    return new $bi5JI.List().appendData({
        type: 'Rule',
        loc: null,
        prelude: {
            type: 'SelectorList',
            loc: null,
            children: new $bi5JI.List().appendData({
                type: 'Selector',
                loc: null,
                children: new $bi5JI.List().appendData({
                    type: 'TypeSelector',
                    loc: null,
                    name: 'x'
                })
            })
        },
        block: block
    });
}
function $f51d50074db192f3$var$compress(ast, options) {
    ast = ast || {
        type: 'StyleSheet',
        loc: null,
        children: new $bi5JI.List()
    };
    options = options || {};
    const compressOptions = {
        logger: typeof options.logger === 'function' ? options.logger : function() {},
        restructuring: $f51d50074db192f3$var$getRestructureOption(options),
        forceMediaMerge: Boolean(options.forceMediaMerge),
        usage: options.usage ? $eteAt.buildIndex(options.usage) : false
    };
    const output = new $bi5JI.List();
    let specialComments = $f51d50074db192f3$var$getCommentsOption(options);
    let firstAtrulesAllowed = true;
    let input;
    let chunk;
    let chunkNum = 1;
    let chunkChildren;
    if (options.clone) ast = $bi5JI.clone(ast);
    if (ast.type === 'StyleSheet') {
        input = ast.children;
        ast.children = output;
    } else input = $f51d50074db192f3$var$wrapBlock(ast);
    do {
        chunk = $f51d50074db192f3$var$readChunk(input, Boolean(specialComments));
        $f51d50074db192f3$var$compressChunk(chunk.stylesheet, firstAtrulesAllowed, chunkNum++, compressOptions);
        chunkChildren = chunk.stylesheet.children;
        if (chunk.comment) {
            // add \n before comment if there is another content in output
            if (!output.isEmpty) output.insert($bi5JI.List.createItem({
                type: 'Raw',
                value: '\n'
            }));
            output.insert($bi5JI.List.createItem(chunk.comment));
            // add \n after comment if chunk is not empty
            if (!chunkChildren.isEmpty) output.insert($bi5JI.List.createItem({
                type: 'Raw',
                value: '\n'
            }));
        }
        if (firstAtrulesAllowed && !chunkChildren.isEmpty) {
            const lastRule = chunkChildren.last;
            if (lastRule.type !== 'Atrule' || lastRule.name !== 'import' && lastRule.name !== 'charset') firstAtrulesAllowed = false;
        }
        if (specialComments !== 'exclamation') specialComments = false;
        output.appendList(chunkChildren);
    }while (!input.isEmpty);
    return {
        ast: ast
    };
}
module.exports = $f51d50074db192f3$var$compress;

});
parcelRegister("eteAt", function(module, exports) {

$parcel$export(module.exports, "buildIndex", () => $a88f16db163722b8$export$234f5dac53d1ad9a, (v) => $a88f16db163722b8$export$234f5dac53d1ad9a = v);
var $a88f16db163722b8$export$234f5dac53d1ad9a;
'use strict';
const { hasOwnProperty: $a88f16db163722b8$var$hasOwnProperty } = Object.prototype;
function $a88f16db163722b8$var$buildMap(list, caseInsensitive) {
    const map = Object.create(null);
    if (!Array.isArray(list)) return null;
    for (let name of list){
        if (caseInsensitive) name = name.toLowerCase();
        map[name] = true;
    }
    return map;
}
function $a88f16db163722b8$var$buildList(data) {
    if (!data) return null;
    const tags = $a88f16db163722b8$var$buildMap(data.tags, true);
    const ids = $a88f16db163722b8$var$buildMap(data.ids);
    const classes = $a88f16db163722b8$var$buildMap(data.classes);
    if (tags === null && ids === null && classes === null) return null;
    return {
        tags: tags,
        ids: ids,
        classes: classes
    };
}
function $a88f16db163722b8$var$buildIndex(data) {
    let scopes = false;
    if (data.scopes && Array.isArray(data.scopes)) {
        scopes = Object.create(null);
        for(let i = 0; i < data.scopes.length; i++){
            const list = data.scopes[i];
            if (!list || !Array.isArray(list)) throw new Error('Wrong usage format');
            for (const name of list){
                if ($a88f16db163722b8$var$hasOwnProperty.call(scopes, name)) throw new Error(`Class can't be used for several scopes: ${name}`);
                scopes[name] = i + 1;
            }
        }
    }
    return {
        whitelist: $a88f16db163722b8$var$buildList(data),
        blacklist: $a88f16db163722b8$var$buildList(data.blacklist),
        scopes: scopes
    };
}
$a88f16db163722b8$export$234f5dac53d1ad9a = $a88f16db163722b8$var$buildIndex;

});

parcelRegister("6r8Jy", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $fjr1y = parcelRequire("fjr1y");

var $oz5KW = parcelRequire("oz5KW");

var $01uBW = parcelRequire("01uBW");

var $9r75y = parcelRequire("9r75y");

var $320NE = parcelRequire("320NE");

var $8Cyl6 = parcelRequire("8Cyl6");

var $h3AVu = parcelRequire("h3AVu");
const $4afc0a0b8310faba$var$handlers = {
    Atrule: $fjr1y,
    Comment: $oz5KW,
    Declaration: $01uBW,
    Raw: $9r75y,
    Rule: $320NE,
    TypeSelector: $8Cyl6,
    WhiteSpace: $h3AVu
};
function $4afc0a0b8310faba$var$clean(ast, options) {
    $bi5JI.walk(ast, {
        leave (node, item, list) {
            if ($4afc0a0b8310faba$var$handlers.hasOwnProperty(node.type)) $4afc0a0b8310faba$var$handlers[node.type].call(this, node, item, list, options);
        }
    });
}
module.exports = $4afc0a0b8310faba$var$clean;

});
parcelRegister("fjr1y", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $iJPfk = parcelRequire("iJPfk");
function $b25d97c67bbf9192$var$cleanAtrule(node, item, list) {
    if (node.block) {
        // otherwise removed at-rule don't prevent @import for removal
        if (this.stylesheet !== null) this.stylesheet.firstAtrulesAllowed = false;
        if ($iJPfk.hasNoChildren(node.block)) {
            list.remove(item);
            return;
        }
    }
    switch(node.name){
        case 'charset':
            if ($iJPfk.hasNoChildren(node.prelude)) {
                list.remove(item);
                return;
            }
            // if there is any rule before @charset -> remove it
            if (item.prev) {
                list.remove(item);
                return;
            }
            break;
        case 'import':
            if (this.stylesheet === null || !this.stylesheet.firstAtrulesAllowed) {
                list.remove(item);
                return;
            }
            // if there are some rules that not an @import or @charset before @import
            // remove it
            list.prevUntil(item.prev, function(rule) {
                if (rule.type === 'Atrule') {
                    if (rule.name === 'import' || rule.name === 'charset') return;
                }
                this.root.firstAtrulesAllowed = false;
                list.remove(item);
                return true;
            }, this);
            break;
        default:
            {
                const name = $bi5JI.keyword(node.name).basename;
                if (name === 'keyframes' || name === 'media' || name === 'supports') // drop at-rule with no prelude
                {
                    if ($iJPfk.hasNoChildren(node.prelude) || $iJPfk.hasNoChildren(node.block)) list.remove(item);
                }
            }
    }
}
module.exports = $b25d97c67bbf9192$var$cleanAtrule;

});
parcelRegister("iJPfk", function(module, exports) {

$parcel$export(module.exports, "hasNoChildren", () => $da442e6c18c03e41$export$4ae8c0b0b49712f0, (v) => $da442e6c18c03e41$export$4ae8c0b0b49712f0 = v);
$parcel$export(module.exports, "isNodeChildrenList", () => $da442e6c18c03e41$export$3a3f2495309887d7, (v) => $da442e6c18c03e41$export$3a3f2495309887d7 = v);
var $da442e6c18c03e41$export$4ae8c0b0b49712f0;
var $da442e6c18c03e41$export$3a3f2495309887d7;
'use strict';
function $da442e6c18c03e41$var$hasNoChildren(node) {
    return !node || !node.children || node.children.isEmpty;
}
function $da442e6c18c03e41$var$isNodeChildrenList(node, list) {
    return node !== null && node.children === list;
}
$da442e6c18c03e41$export$4ae8c0b0b49712f0 = $da442e6c18c03e41$var$hasNoChildren;
$da442e6c18c03e41$export$3a3f2495309887d7 = $da442e6c18c03e41$var$isNodeChildrenList;

});


parcelRegister("oz5KW", function(module, exports) {
'use strict';
function $049d7683a8bb6b61$var$cleanComment(data, item, list) {
    list.remove(item);
}
module.exports = $049d7683a8bb6b61$var$cleanComment;

});

parcelRegister("01uBW", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");
function $0047d6cb8d63a473$var$cleanDeclartion(node, item, list) {
    if (node.value.children && node.value.children.isEmpty) {
        list.remove(item);
        return;
    }
    if ($bi5JI.property(node.property).custom) {
        if (/\S/.test(node.value.value)) node.value.value = node.value.value.trim();
    }
}
module.exports = $0047d6cb8d63a473$var$cleanDeclartion;

});

parcelRegister("9r75y", function(module, exports) {
'use strict';

var $iJPfk = parcelRequire("iJPfk");
function $6dec224c45b9784b$var$cleanRaw(node, item, list) {
    // raw in stylesheet or block children
    if ($iJPfk.isNodeChildrenList(this.stylesheet, list) || $iJPfk.isNodeChildrenList(this.block, list)) list.remove(item);
}
module.exports = $6dec224c45b9784b$var$cleanRaw;

});

parcelRegister("320NE", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $iJPfk = parcelRequire("iJPfk");
const { hasOwnProperty: $23522dd877de4566$var$hasOwnProperty } = Object.prototype;
const $23522dd877de4566$var$skipUsageFilteringAtrule = new Set([
    'keyframes'
]);
function $23522dd877de4566$var$cleanUnused(selectorList, usageData) {
    selectorList.children.forEach((selector, item, list)=>{
        let shouldRemove = false;
        $bi5JI.walk(selector, function(node) {
            // ignore nodes in nested selectors
            if (this.selector === null || this.selector === selectorList) switch(node.type){
                case 'SelectorList':
                    // TODO: remove toLowerCase when pseudo selectors will be normalized
                    // ignore selectors inside :not()
                    if (this.function === null || this.function.name.toLowerCase() !== 'not') {
                        if ($23522dd877de4566$var$cleanUnused(node, usageData)) shouldRemove = true;
                    }
                    break;
                case 'ClassSelector':
                    if (usageData.whitelist !== null && usageData.whitelist.classes !== null && !$23522dd877de4566$var$hasOwnProperty.call(usageData.whitelist.classes, node.name)) shouldRemove = true;
                    if (usageData.blacklist !== null && usageData.blacklist.classes !== null && $23522dd877de4566$var$hasOwnProperty.call(usageData.blacklist.classes, node.name)) shouldRemove = true;
                    break;
                case 'IdSelector':
                    if (usageData.whitelist !== null && usageData.whitelist.ids !== null && !$23522dd877de4566$var$hasOwnProperty.call(usageData.whitelist.ids, node.name)) shouldRemove = true;
                    if (usageData.blacklist !== null && usageData.blacklist.ids !== null && $23522dd877de4566$var$hasOwnProperty.call(usageData.blacklist.ids, node.name)) shouldRemove = true;
                    break;
                case 'TypeSelector':
                    // TODO: remove toLowerCase when type selectors will be normalized
                    // ignore universal selectors
                    if (node.name.charAt(node.name.length - 1) !== '*') {
                        if (usageData.whitelist !== null && usageData.whitelist.tags !== null && !$23522dd877de4566$var$hasOwnProperty.call(usageData.whitelist.tags, node.name.toLowerCase())) shouldRemove = true;
                        if (usageData.blacklist !== null && usageData.blacklist.tags !== null && $23522dd877de4566$var$hasOwnProperty.call(usageData.blacklist.tags, node.name.toLowerCase())) shouldRemove = true;
                    }
                    break;
            }
        });
        if (shouldRemove) list.remove(item);
    });
    return selectorList.children.isEmpty;
}
function $23522dd877de4566$var$cleanRule(node, item, list, options) {
    if ($iJPfk.hasNoChildren(node.prelude) || $iJPfk.hasNoChildren(node.block)) {
        list.remove(item);
        return;
    }
    // avoid usage filtering for some at-rules
    if (this.atrule && $23522dd877de4566$var$skipUsageFilteringAtrule.has($bi5JI.keyword(this.atrule.name).basename)) return;
    const { usage: usage } = options;
    if (usage && (usage.whitelist !== null || usage.blacklist !== null)) {
        $23522dd877de4566$var$cleanUnused(node.prelude, usage);
        if ($iJPfk.hasNoChildren(node.prelude)) {
            list.remove(item);
            return;
        }
    }
}
module.exports = $23522dd877de4566$var$cleanRule;

});

parcelRegister("8Cyl6", function(module, exports) {
'use strict';
// remove useless universal selector
function $646c826dfa21f215$var$cleanTypeSelector(node, item, list) {
    const name = item.data.name;
    // check it's a non-namespaced universal selector
    if (name !== '*') return;
    // remove when universal selector before other selectors
    const nextType = item.next && item.next.data.type;
    if (nextType === 'IdSelector' || nextType === 'ClassSelector' || nextType === 'AttributeSelector' || nextType === 'PseudoClassSelector' || nextType === 'PseudoElementSelector') list.remove(item);
}
module.exports = $646c826dfa21f215$var$cleanTypeSelector;

});

parcelRegister("h3AVu", function(module, exports) {
'use strict';
function $c6af5c3e60d1187a$var$cleanWhitespace(node, item, list) {
    list.remove(item);
}
module.exports = $c6af5c3e60d1187a$var$cleanWhitespace;

});


parcelRegister("1sA7C", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $lWzde = parcelRequire("lWzde");

var $lMUoe = parcelRequire("lMUoe");

var $gkEAf = parcelRequire("gkEAf");

var $gs3r9 = parcelRequire("gs3r9");

var $br2Yd = parcelRequire("br2Yd");

var $hfhqS = parcelRequire("hfhqS");

var $7wvDQ = parcelRequire("7wvDQ");

var $1Q2ll = parcelRequire("1Q2ll");
const $11046d075d3ab398$var$handlers = {
    Atrule: $lWzde,
    AttributeSelector: $lMUoe,
    Value: $gkEAf,
    Dimension: $gs3r9,
    Percentage: $br2Yd,
    Number: $hfhqS.Number,
    Url: $7wvDQ,
    Hash: $1Q2ll.compressHex,
    Identifier: $1Q2ll.compressIdent,
    Function: $1Q2ll.compressFunction
};
function $11046d075d3ab398$var$replace(ast) {
    $bi5JI.walk(ast, {
        leave (node, item, list) {
            if ($11046d075d3ab398$var$handlers.hasOwnProperty(node.type)) $11046d075d3ab398$var$handlers[node.type].call(this, node, item, list);
        }
    });
}
module.exports = $11046d075d3ab398$var$replace;

});
parcelRegister("lWzde", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $djQLR = parcelRequire("djQLR");
function $ff9a543b0338e6a9$var$Atrule(node) {
    // compress @keyframe selectors
    if ($bi5JI.keyword(node.name).basename === 'keyframes') $djQLR(node);
}
module.exports = $ff9a543b0338e6a9$var$Atrule;

});
parcelRegister("djQLR", function(module, exports) {
'use strict';
function $9b25fbed23a97bf0$var$compressKeyframes(node) {
    node.block.children.forEach((rule)=>{
        rule.prelude.children.forEach((simpleselector)=>{
            simpleselector.children.forEach((data, item)=>{
                if (data.type === 'Percentage' && data.value === '100') item.data = {
                    type: 'TypeSelector',
                    loc: data.loc,
                    name: 'to'
                };
                else if (data.type === 'TypeSelector' && data.name === 'from') item.data = {
                    type: 'Percentage',
                    loc: data.loc,
                    value: '0'
                };
            });
        });
    });
}
module.exports = $9b25fbed23a97bf0$var$compressKeyframes;

});


parcelRegister("lMUoe", function(module, exports) {
'use strict';
// Can unquote attribute detection
// Adopted implementation of Mathias Bynens
// https://github.com/mathiasbynens/mothereff.in/blob/master/unquoted-attributes/eff.js
const $fdc9d2851d7c1bd0$var$blockUnquoteRx = /^(-?\d|--)|[\u0000-\u002c\u002e\u002f\u003A-\u0040\u005B-\u005E\u0060\u007B-\u009f]/;
function $fdc9d2851d7c1bd0$var$canUnquote(value) {
    if (value === '' || value === '-') return false;
    return !$fdc9d2851d7c1bd0$var$blockUnquoteRx.test(value);
}
function $fdc9d2851d7c1bd0$var$AttributeSelector(node) {
    const attrValue = node.value;
    if (!attrValue || attrValue.type !== 'String') return;
    if ($fdc9d2851d7c1bd0$var$canUnquote(attrValue.value)) node.value = {
        type: 'Identifier',
        loc: attrValue.loc,
        name: attrValue.value
    };
}
module.exports = $fdc9d2851d7c1bd0$var$AttributeSelector;

});

parcelRegister("gkEAf", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $j0WO5 = parcelRequire("j0WO5");

var $jkSci = parcelRequire("jkSci");

var $luUuX = parcelRequire("luUuX");

var $bzQ71 = parcelRequire("bzQ71");
const $be3dfeaf7bc24a83$var$handlers = {
    'font': $j0WO5,
    'font-weight': $jkSci,
    'background': $luUuX,
    'border': $bzQ71,
    'outline': $bzQ71
};
function $be3dfeaf7bc24a83$var$compressValue(node) {
    if (!this.declaration) return;
    const property = $bi5JI.property(this.declaration.property);
    if ($be3dfeaf7bc24a83$var$handlers.hasOwnProperty(property.basename)) $be3dfeaf7bc24a83$var$handlers[property.basename](node);
}
module.exports = $be3dfeaf7bc24a83$var$compressValue;

});
parcelRegister("j0WO5", function(module, exports) {
'use strict';
function $dd7ba23bcc78eae6$var$compressFont(node) {
    const list = node.children;
    list.forEachRight(function(node, item) {
        if (node.type === 'Identifier') {
            if (node.name === 'bold') item.data = {
                type: 'Number',
                loc: node.loc,
                value: '700'
            };
            else if (node.name === 'normal') {
                const prev = item.prev;
                if (prev && prev.data.type === 'Operator' && prev.data.value === '/') this.remove(prev);
                this.remove(item);
            }
        }
    });
    if (list.isEmpty) list.insert(list.createItem({
        type: 'Identifier',
        name: 'normal'
    }));
}
module.exports = $dd7ba23bcc78eae6$var$compressFont;

});

parcelRegister("jkSci", function(module, exports) {
'use strict';
function $e139ed0f7a0d9e4e$var$compressFontWeight(node) {
    const value = node.children.head.data;
    if (value.type === 'Identifier') switch(value.name){
        case 'normal':
            node.children.head.data = {
                type: 'Number',
                loc: value.loc,
                value: '400'
            };
            break;
        case 'bold':
            node.children.head.data = {
                type: 'Number',
                loc: value.loc,
                value: '700'
            };
            break;
    }
}
module.exports = $e139ed0f7a0d9e4e$var$compressFontWeight;

});

parcelRegister("luUuX", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");
function $fa6839ae44e314e8$var$compressBackground(node) {
    function flush() {
        if (!buffer.length) buffer.unshift({
            type: 'Number',
            loc: null,
            value: '0'
        }, {
            type: 'Number',
            loc: null,
            value: '0'
        });
        newValue.push.apply(newValue, buffer);
        buffer = [];
    }
    let newValue = [];
    let buffer = [];
    node.children.forEach((node)=>{
        if (node.type === 'Operator' && node.value === ',') {
            flush();
            newValue.push(node);
            return;
        }
        // remove defaults
        if (node.type === 'Identifier') {
            if (node.name === 'transparent' || node.name === 'none' || node.name === 'repeat' || node.name === 'scroll') return;
        }
        buffer.push(node);
    });
    flush();
    node.children = new $bi5JI.List().fromArray(newValue);
}
module.exports = $fa6839ae44e314e8$var$compressBackground;

});

parcelRegister("bzQ71", function(module, exports) {
'use strict';
function $86db62fcea4c102b$var$compressBorder(node) {
    node.children.forEach((node, item, list)=>{
        if (node.type === 'Identifier' && node.name.toLowerCase() === 'none') {
            if (list.head === list.tail) // replace `none` for zero when `none` is a single term
            item.data = {
                type: 'Number',
                loc: node.loc,
                value: '0'
            };
            else list.remove(item);
        }
    });
}
module.exports = $86db62fcea4c102b$var$compressBorder;

});


parcelRegister("gs3r9", function(module, exports) {
'use strict';

var $hfhqS = parcelRequire("hfhqS");
const $bfa1ed60d7bb2ddf$var$MATH_FUNCTIONS = new Set([
    'calc',
    'min',
    'max',
    'clamp'
]);
const $bfa1ed60d7bb2ddf$var$LENGTH_UNIT = new Set([
    // absolute length units
    'px',
    'mm',
    'cm',
    'in',
    'pt',
    'pc',
    // relative length units
    'em',
    'ex',
    'ch',
    'rem',
    // viewport-percentage lengths
    'vh',
    'vw',
    'vmin',
    'vmax',
    'vm'
]);
function $bfa1ed60d7bb2ddf$var$compressDimension(node, item) {
    const value = $hfhqS.packNumber(node.value);
    node.value = value;
    if (value === '0' && this.declaration !== null && this.atrulePrelude === null) {
        const unit = node.unit.toLowerCase();
        // only length values can be compressed
        if (!$bfa1ed60d7bb2ddf$var$LENGTH_UNIT.has(unit)) return;
        // issue #362: shouldn't remove unit in -ms-flex since it breaks flex in IE10/11
        // issue #200: shouldn't remove unit in flex since it breaks flex in IE10/11
        if (this.declaration.property === '-ms-flex' || this.declaration.property === 'flex') return;
        // issue #222: don't remove units inside calc
        if (this.function && $bfa1ed60d7bb2ddf$var$MATH_FUNCTIONS.has(this.function.name)) return;
        item.data = {
            type: 'Number',
            loc: node.loc,
            value: value
        };
    }
}
module.exports = $bfa1ed60d7bb2ddf$var$compressDimension;

});
parcelRegister("hfhqS", function(module, exports) {

$parcel$export(module.exports, "Number", () => $c8e15c1d9d94cc0e$export$fffa67e515d04022, (v) => $c8e15c1d9d94cc0e$export$fffa67e515d04022 = v);
$parcel$export(module.exports, "packNumber", () => $c8e15c1d9d94cc0e$export$ac6f31934831a099, (v) => $c8e15c1d9d94cc0e$export$ac6f31934831a099 = v);
var $c8e15c1d9d94cc0e$export$fffa67e515d04022;
var $c8e15c1d9d94cc0e$export$ac6f31934831a099;
'use strict';
const $c8e15c1d9d94cc0e$var$OMIT_PLUSSIGN = /^(?:\+|(-))?0*(\d*)(?:\.0*|(\.\d*?)0*)?$/;
const $c8e15c1d9d94cc0e$var$KEEP_PLUSSIGN = /^([\+\-])?0*(\d*)(?:\.0*|(\.\d*?)0*)?$/;
const $c8e15c1d9d94cc0e$var$unsafeToRemovePlusSignAfter = new Set([
    'Dimension',
    'Hash',
    'Identifier',
    'Number',
    'Raw',
    'UnicodeRange'
]);
function $c8e15c1d9d94cc0e$var$packNumber(value, item) {
    // omit plus sign only if no prev or prev is safe type
    const regexp = item && item.prev !== null && $c8e15c1d9d94cc0e$var$unsafeToRemovePlusSignAfter.has(item.prev.data.type) ? $c8e15c1d9d94cc0e$var$KEEP_PLUSSIGN : $c8e15c1d9d94cc0e$var$OMIT_PLUSSIGN;
    // 100 -> '100'
    // 00100 -> '100'
    // +100 -> '100'
    // -100 -> '-100'
    // 0.123 -> '.123'
    // 0.12300 -> '.123'
    // 0.0 -> ''
    // 0 -> ''
    // -0 -> '-'
    value = String(value).replace(regexp, '$1$2$3');
    if (value === '' || value === '-') value = '0';
    // FIXME: is it solution simplier?
    // value = String(Number(value)).replace(/^(-?)0+\./, '$1.');
    return value;
}
function $c8e15c1d9d94cc0e$var$Number(node) {
    node.value = $c8e15c1d9d94cc0e$var$packNumber(node.value);
}
$c8e15c1d9d94cc0e$export$fffa67e515d04022 = $c8e15c1d9d94cc0e$var$Number;
$c8e15c1d9d94cc0e$export$ac6f31934831a099 = $c8e15c1d9d94cc0e$var$packNumber;

});


parcelRegister("br2Yd", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $hfhqS = parcelRequire("hfhqS");
const $8534852c7e57505d$var$blacklist = new Set([
    // see https://github.com/jakubpawlowicz/clean-css/issues/957
    'width',
    'min-width',
    'max-width',
    'height',
    'min-height',
    'max-height',
    // issue #410: Don’t remove units in flex-basis value for (-ms-)flex shorthand
    // issue #362: shouldn't remove unit in -ms-flex since it breaks flex in IE10/11
    // issue #200: shouldn't remove unit in flex since it breaks flex in IE10/11
    'flex',
    '-ms-flex'
]);
function $8534852c7e57505d$var$compressPercentage(node, item) {
    node.value = $hfhqS.packNumber(node.value);
    if (node.value === '0' && this.declaration && !$8534852c7e57505d$var$blacklist.has(this.declaration.property)) {
        // try to convert a number
        item.data = {
            type: 'Number',
            loc: node.loc,
            value: node.value
        };
        // that's ok only when new value matches on length
        if (!$bi5JI.lexer.matchDeclaration(this.declaration).isType(item.data, 'length')) // otherwise rollback changes
        item.data = node;
    }
}
module.exports = $8534852c7e57505d$var$compressPercentage;

});

parcelRegister("7wvDQ", function(module, exports) {
'use strict';
function $57a410eb5ac428e2$var$Url(node) {
    // convert `\\` to `/`
    node.value = node.value.replace(/\\/g, '/');
}
module.exports = $57a410eb5ac428e2$var$Url;

});

parcelRegister("1Q2ll", function(module, exports) {

$parcel$export(module.exports, "compressFunction", () => $156c7718c524d7c0$export$ee70891f659cb665, (v) => $156c7718c524d7c0$export$ee70891f659cb665 = v);
$parcel$export(module.exports, "compressHex", () => $156c7718c524d7c0$export$d070e3da4f1ec57e, (v) => $156c7718c524d7c0$export$d070e3da4f1ec57e = v);
$parcel$export(module.exports, "compressIdent", () => $156c7718c524d7c0$export$dd6ac38a204d62ea, (v) => $156c7718c524d7c0$export$dd6ac38a204d62ea = v);
var $156c7718c524d7c0$export$ee70891f659cb665;
var $156c7718c524d7c0$export$d070e3da4f1ec57e;
var $156c7718c524d7c0$export$dd6ac38a204d62ea;
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $hfhqS = parcelRequire("hfhqS");
// http://www.w3.org/TR/css3-color/#svg-color
const $156c7718c524d7c0$var$NAME_TO_HEX = {
    'aliceblue': 'f0f8ff',
    'antiquewhite': 'faebd7',
    'aqua': '0ff',
    'aquamarine': '7fffd4',
    'azure': 'f0ffff',
    'beige': 'f5f5dc',
    'bisque': 'ffe4c4',
    'black': '000',
    'blanchedalmond': 'ffebcd',
    'blue': '00f',
    'blueviolet': '8a2be2',
    'brown': 'a52a2a',
    'burlywood': 'deb887',
    'cadetblue': '5f9ea0',
    'chartreuse': '7fff00',
    'chocolate': 'd2691e',
    'coral': 'ff7f50',
    'cornflowerblue': '6495ed',
    'cornsilk': 'fff8dc',
    'crimson': 'dc143c',
    'cyan': '0ff',
    'darkblue': '00008b',
    'darkcyan': '008b8b',
    'darkgoldenrod': 'b8860b',
    'darkgray': 'a9a9a9',
    'darkgrey': 'a9a9a9',
    'darkgreen': '006400',
    'darkkhaki': 'bdb76b',
    'darkmagenta': '8b008b',
    'darkolivegreen': '556b2f',
    'darkorange': 'ff8c00',
    'darkorchid': '9932cc',
    'darkred': '8b0000',
    'darksalmon': 'e9967a',
    'darkseagreen': '8fbc8f',
    'darkslateblue': '483d8b',
    'darkslategray': '2f4f4f',
    'darkslategrey': '2f4f4f',
    'darkturquoise': '00ced1',
    'darkviolet': '9400d3',
    'deeppink': 'ff1493',
    'deepskyblue': '00bfff',
    'dimgray': '696969',
    'dimgrey': '696969',
    'dodgerblue': '1e90ff',
    'firebrick': 'b22222',
    'floralwhite': 'fffaf0',
    'forestgreen': '228b22',
    'fuchsia': 'f0f',
    'gainsboro': 'dcdcdc',
    'ghostwhite': 'f8f8ff',
    'gold': 'ffd700',
    'goldenrod': 'daa520',
    'gray': '808080',
    'grey': '808080',
    'green': '008000',
    'greenyellow': 'adff2f',
    'honeydew': 'f0fff0',
    'hotpink': 'ff69b4',
    'indianred': 'cd5c5c',
    'indigo': '4b0082',
    'ivory': 'fffff0',
    'khaki': 'f0e68c',
    'lavender': 'e6e6fa',
    'lavenderblush': 'fff0f5',
    'lawngreen': '7cfc00',
    'lemonchiffon': 'fffacd',
    'lightblue': 'add8e6',
    'lightcoral': 'f08080',
    'lightcyan': 'e0ffff',
    'lightgoldenrodyellow': 'fafad2',
    'lightgray': 'd3d3d3',
    'lightgrey': 'd3d3d3',
    'lightgreen': '90ee90',
    'lightpink': 'ffb6c1',
    'lightsalmon': 'ffa07a',
    'lightseagreen': '20b2aa',
    'lightskyblue': '87cefa',
    'lightslategray': '789',
    'lightslategrey': '789',
    'lightsteelblue': 'b0c4de',
    'lightyellow': 'ffffe0',
    'lime': '0f0',
    'limegreen': '32cd32',
    'linen': 'faf0e6',
    'magenta': 'f0f',
    'maroon': '800000',
    'mediumaquamarine': '66cdaa',
    'mediumblue': '0000cd',
    'mediumorchid': 'ba55d3',
    'mediumpurple': '9370db',
    'mediumseagreen': '3cb371',
    'mediumslateblue': '7b68ee',
    'mediumspringgreen': '00fa9a',
    'mediumturquoise': '48d1cc',
    'mediumvioletred': 'c71585',
    'midnightblue': '191970',
    'mintcream': 'f5fffa',
    'mistyrose': 'ffe4e1',
    'moccasin': 'ffe4b5',
    'navajowhite': 'ffdead',
    'navy': '000080',
    'oldlace': 'fdf5e6',
    'olive': '808000',
    'olivedrab': '6b8e23',
    'orange': 'ffa500',
    'orangered': 'ff4500',
    'orchid': 'da70d6',
    'palegoldenrod': 'eee8aa',
    'palegreen': '98fb98',
    'paleturquoise': 'afeeee',
    'palevioletred': 'db7093',
    'papayawhip': 'ffefd5',
    'peachpuff': 'ffdab9',
    'peru': 'cd853f',
    'pink': 'ffc0cb',
    'plum': 'dda0dd',
    'powderblue': 'b0e0e6',
    'purple': '800080',
    'rebeccapurple': '639',
    'red': 'f00',
    'rosybrown': 'bc8f8f',
    'royalblue': '4169e1',
    'saddlebrown': '8b4513',
    'salmon': 'fa8072',
    'sandybrown': 'f4a460',
    'seagreen': '2e8b57',
    'seashell': 'fff5ee',
    'sienna': 'a0522d',
    'silver': 'c0c0c0',
    'skyblue': '87ceeb',
    'slateblue': '6a5acd',
    'slategray': '708090',
    'slategrey': '708090',
    'snow': 'fffafa',
    'springgreen': '00ff7f',
    'steelblue': '4682b4',
    'tan': 'd2b48c',
    'teal': '008080',
    'thistle': 'd8bfd8',
    'tomato': 'ff6347',
    'turquoise': '40e0d0',
    'violet': 'ee82ee',
    'wheat': 'f5deb3',
    'white': 'fff',
    'whitesmoke': 'f5f5f5',
    'yellow': 'ff0',
    'yellowgreen': '9acd32'
};
const $156c7718c524d7c0$var$HEX_TO_NAME = {
    '800000': 'maroon',
    '800080': 'purple',
    '808000': 'olive',
    '808080': 'gray',
    '00ffff': 'cyan',
    'f0ffff': 'azure',
    'f5f5dc': 'beige',
    'ffe4c4': 'bisque',
    '000000': 'black',
    '0000ff': 'blue',
    'a52a2a': 'brown',
    'ff7f50': 'coral',
    'ffd700': 'gold',
    '008000': 'green',
    '4b0082': 'indigo',
    'fffff0': 'ivory',
    'f0e68c': 'khaki',
    '00ff00': 'lime',
    'faf0e6': 'linen',
    '000080': 'navy',
    'ffa500': 'orange',
    'da70d6': 'orchid',
    'cd853f': 'peru',
    'ffc0cb': 'pink',
    'dda0dd': 'plum',
    'f00': 'red',
    'ff0000': 'red',
    'fa8072': 'salmon',
    'a0522d': 'sienna',
    'c0c0c0': 'silver',
    'fffafa': 'snow',
    'd2b48c': 'tan',
    '008080': 'teal',
    'ff6347': 'tomato',
    'ee82ee': 'violet',
    'f5deb3': 'wheat',
    'ffffff': 'white',
    'ffff00': 'yellow'
};
function $156c7718c524d7c0$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $156c7718c524d7c0$var$hslToRgb(h, s, l, a) {
    let r;
    let g;
    let b;
    if (s === 0) r = g = b = l; // achromatic
    else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = $156c7718c524d7c0$var$hueToRgb(p, q, h + 1 / 3);
        g = $156c7718c524d7c0$var$hueToRgb(p, q, h);
        b = $156c7718c524d7c0$var$hueToRgb(p, q, h - 1 / 3);
    }
    return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255),
        a
    ];
}
function $156c7718c524d7c0$var$toHex(value) {
    value = value.toString(16);
    return value.length === 1 ? '0' + value : value;
}
function $156c7718c524d7c0$var$parseFunctionArgs(functionArgs, count, rgb) {
    let cursor = functionArgs.head;
    let args = [];
    let wasValue = false;
    while(cursor !== null){
        const { type: type, value: value } = cursor.data;
        switch(type){
            case 'Number':
            case 'Percentage':
                if (wasValue) return;
                wasValue = true;
                args.push({
                    type: type,
                    value: Number(value)
                });
                break;
            case 'Operator':
                if (value === ',') {
                    if (!wasValue) return;
                    wasValue = false;
                } else if (wasValue || value !== '+') return;
                break;
            default:
                // something we couldn't understand
                return;
        }
        cursor = cursor.next;
    }
    if (args.length !== count) // invalid arguments count
    // TODO: remove those tokens
    return;
    if (args.length === 4) {
        if (args[3].type !== 'Number') // 4th argument should be a number
        // TODO: remove those tokens
        return;
        args[3].type = 'Alpha';
    }
    if (rgb) {
        if (args[0].type !== args[1].type || args[0].type !== args[2].type) // invalid color, numbers and percentage shouldn't be mixed
        // TODO: remove those tokens
        return;
    } else {
        if (args[0].type !== 'Number' || args[1].type !== 'Percentage' || args[2].type !== 'Percentage') // invalid color, for hsl values should be: number, percentage, percentage
        // TODO: remove those tokens
        return;
        args[0].type = 'Angle';
    }
    return args.map(function(arg) {
        let value = Math.max(0, arg.value);
        switch(arg.type){
            case 'Number':
                // fit value to [0..255] range
                value = Math.min(value, 255);
                break;
            case 'Percentage':
                // convert 0..100% to value in [0..255] range
                value = Math.min(value, 100) / 100;
                if (!rgb) return value;
                value = 255 * value;
                break;
            case 'Angle':
                // fit value to (-360..360) range
                return (value % 360 + 360) % 360 / 360;
            case 'Alpha':
                // fit value to [0..1] range
                return Math.min(value, 1);
        }
        return Math.round(value);
    });
}
function $156c7718c524d7c0$var$compressFunction(node, item) {
    let functionName = node.name;
    let args;
    if (functionName === 'rgba' || functionName === 'hsla') {
        args = $156c7718c524d7c0$var$parseFunctionArgs(node.children, 4, functionName === 'rgba');
        if (!args) // something went wrong
        return;
        if (functionName === 'hsla') {
            args = $156c7718c524d7c0$var$hslToRgb(...args);
            node.name = 'rgba';
        }
        if (args[3] === 0) {
            // try to replace `rgba(x, x, x, 0)` to `transparent`
            // always replace `rgba(0, 0, 0, 0)` to `transparent`
            // otherwise avoid replacement in gradients since it may break color transition
            // http://stackoverflow.com/questions/11829410/css3-gradient-rendering-issues-from-transparent-to-white
            const scopeFunctionName = this.function && this.function.name;
            if (args[0] === 0 && args[1] === 0 && args[2] === 0 || !/^(?:to|from|color-stop)$|gradient$/i.test(scopeFunctionName)) {
                item.data = {
                    type: 'Identifier',
                    loc: node.loc,
                    name: 'transparent'
                };
                return;
            }
        }
        if (args[3] !== 1) {
            // replace argument values for normalized/interpolated
            node.children.forEach((node, item, list)=>{
                if (node.type === 'Operator') {
                    if (node.value !== ',') list.remove(item);
                    return;
                }
                item.data = {
                    type: 'Number',
                    loc: node.loc,
                    value: $hfhqS.packNumber(args.shift())
                };
            });
            return;
        }
        // otherwise convert to rgb, i.e. rgba(255, 0, 0, 1) -> rgb(255, 0, 0)
        functionName = 'rgb';
    }
    if (functionName === 'hsl') {
        args = args || $156c7718c524d7c0$var$parseFunctionArgs(node.children, 3, false);
        if (!args) // something went wrong
        return;
        // convert to rgb
        args = $156c7718c524d7c0$var$hslToRgb(...args);
        functionName = 'rgb';
    }
    if (functionName === 'rgb') {
        args = args || $156c7718c524d7c0$var$parseFunctionArgs(node.children, 3, true);
        if (!args) // something went wrong
        return;
        item.data = {
            type: 'Hash',
            loc: node.loc,
            value: $156c7718c524d7c0$var$toHex(args[0]) + $156c7718c524d7c0$var$toHex(args[1]) + $156c7718c524d7c0$var$toHex(args[2])
        };
        $156c7718c524d7c0$var$compressHex(item.data, item);
    }
}
function $156c7718c524d7c0$var$compressIdent(node, item) {
    if (this.declaration === null) return;
    let color = node.name.toLowerCase();
    if ($156c7718c524d7c0$var$NAME_TO_HEX.hasOwnProperty(color) && $bi5JI.lexer.matchDeclaration(this.declaration).isType(node, 'color')) {
        const hex = $156c7718c524d7c0$var$NAME_TO_HEX[color];
        if (hex.length + 1 <= color.length) // replace for shorter hex value
        item.data = {
            type: 'Hash',
            loc: node.loc,
            value: hex
        };
        else {
            // special case for consistent colors
            if (color === 'grey') color = 'gray';
            // just replace value for lower cased name
            node.name = color;
        }
    }
}
function $156c7718c524d7c0$var$compressHex(node, item) {
    let color = node.value.toLowerCase();
    // #112233 -> #123
    if (color.length === 6 && color[0] === color[1] && color[2] === color[3] && color[4] === color[5]) color = color[0] + color[2] + color[4];
    if ($156c7718c524d7c0$var$HEX_TO_NAME[color]) item.data = {
        type: 'Identifier',
        loc: node.loc,
        name: $156c7718c524d7c0$var$HEX_TO_NAME[color]
    };
    else node.value = color;
}
$156c7718c524d7c0$export$ee70891f659cb665 = $156c7718c524d7c0$var$compressFunction;
$156c7718c524d7c0$export$d070e3da4f1ec57e = $156c7718c524d7c0$var$compressHex;
$156c7718c524d7c0$export$dd6ac38a204d62ea = $156c7718c524d7c0$var$compressIdent;

});


parcelRegister("eGYk7", function(module, exports) {
'use strict';

var $119sA = parcelRequire("119sA");

var $welhf = parcelRequire("welhf");

var $eZaRu = parcelRequire("eZaRu");

var $aAkVI = parcelRequire("aAkVI");

var $3TOAM = parcelRequire("3TOAM");

var $mqvO3 = parcelRequire("mqvO3");

var $8ElkY = parcelRequire("8ElkY");

var $sBHTI = parcelRequire("sBHTI");
function $ab23c7ed2a9f84bc$var$restructure(ast, options) {
    // prepare ast for restructing
    const indexer = $119sA(ast, options);
    options.logger('prepare', ast);
    $welhf(ast, options);
    options.logger('mergeAtrule', ast);
    $eZaRu(ast);
    options.logger('initialMergeRuleset', ast);
    $aAkVI(ast);
    options.logger('disjoinRuleset', ast);
    $3TOAM(ast, indexer);
    options.logger('restructShorthand', ast);
    $mqvO3(ast);
    options.logger('restructBlock', ast);
    $8ElkY(ast);
    options.logger('mergeRuleset', ast);
    $sBHTI(ast);
    options.logger('restructRuleset', ast);
}
module.exports = $ab23c7ed2a9f84bc$var$restructure;

});
parcelRegister("119sA", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $jsZeB = parcelRequire("jsZeB");

var $iKIOe = parcelRequire("iKIOe");
function $0bdd38ff88e2dec2$var$prepare(ast, options) {
    const markDeclaration = $jsZeB();
    $bi5JI.walk(ast, {
        visit: 'Rule',
        enter (node) {
            node.block.children.forEach(markDeclaration);
            $iKIOe(node, options.usage);
        }
    });
    $bi5JI.walk(ast, {
        visit: 'Atrule',
        enter (node) {
            if (node.prelude) {
                node.prelude.id = null; // pre-init property to avoid multiple hidden class for generate
                node.prelude.id = $bi5JI.generate(node.prelude);
            }
            // compare keyframe selectors by its values
            // NOTE: still no clarification about problems with keyframes selector grouping (issue #197)
            if ($bi5JI.keyword(node.name).basename === 'keyframes') {
                node.block.avoidRulesMerge = true; /* probably we don't need to prevent those merges for @keyframes
                                                       TODO: need to be checked */ 
                node.block.children.forEach(function(rule) {
                    rule.prelude.children.forEach(function(simpleselector) {
                        simpleselector.compareMarker = simpleselector.id;
                    });
                });
            }
        }
    });
    return {
        declaration: markDeclaration
    };
}
module.exports = $0bdd38ff88e2dec2$var$prepare;

});
parcelRegister("jsZeB", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");
class $e2c021c050138822$var$Index {
    resolve(str) {
        let index = this.map.get(str);
        if (index === undefined) {
            index = this.map.size + 1;
            this.map.set(str, index);
        }
        return index;
    }
    constructor(){
        this.map = new Map();
    }
}
function $e2c021c050138822$var$createDeclarationIndexer() {
    const ids = new $e2c021c050138822$var$Index();
    return function markDeclaration(node) {
        const id = $bi5JI.generate(node);
        node.id = ids.resolve(id);
        node.length = id.length;
        node.fingerprint = null;
        return node;
    };
}
module.exports = $e2c021c050138822$var$createDeclarationIndexer;

});

parcelRegister("iKIOe", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $iePWG = parcelRequire("iePWG");
const $da6f480b1a2e3b7b$var$nonFreezePseudoElements = new Set([
    'first-letter',
    'first-line',
    'after',
    'before'
]);
const $da6f480b1a2e3b7b$var$nonFreezePseudoClasses = new Set([
    'link',
    'visited',
    'hover',
    'active',
    'first-letter',
    'first-line',
    'after',
    'before'
]);
function $da6f480b1a2e3b7b$var$processSelector(node, usageData) {
    const pseudos = new Set();
    node.prelude.children.forEach(function(simpleSelector) {
        let tagName = '*';
        let scope = 0;
        simpleSelector.children.forEach(function(node) {
            switch(node.type){
                case 'ClassSelector':
                    if (usageData && usageData.scopes) {
                        const classScope = usageData.scopes[node.name] || 0;
                        if (scope !== 0 && classScope !== scope) throw new Error('Selector can\'t has classes from different scopes: ' + $bi5JI.generate(simpleSelector));
                        scope = classScope;
                    }
                    break;
                case 'PseudoClassSelector':
                    {
                        const name = node.name.toLowerCase();
                        if (!$da6f480b1a2e3b7b$var$nonFreezePseudoClasses.has(name)) pseudos.add(`:${name}`);
                        break;
                    }
                case 'PseudoElementSelector':
                    {
                        const name = node.name.toLowerCase();
                        if (!$da6f480b1a2e3b7b$var$nonFreezePseudoElements.has(name)) pseudos.add(`::${name}`);
                        break;
                    }
                case 'TypeSelector':
                    tagName = node.name.toLowerCase();
                    break;
                case 'AttributeSelector':
                    if (node.flags) pseudos.add(`[${node.flags.toLowerCase()}]`);
                    break;
                case 'Combinator':
                    tagName = '*';
                    break;
            }
        });
        simpleSelector.compareMarker = $iePWG(simpleSelector).toString();
        simpleSelector.id = null; // pre-init property to avoid multiple hidden class
        simpleSelector.id = $bi5JI.generate(simpleSelector);
        if (scope) simpleSelector.compareMarker += ':' + scope;
        if (tagName !== '*') simpleSelector.compareMarker += ',' + tagName;
    });
    // add property to all rule nodes to avoid multiple hidden class
    node.pseudoSignature = pseudos.size > 0 ? [
        ...pseudos
    ].sort().join(',') : false;
}
module.exports = $da6f480b1a2e3b7b$var$processSelector;

});
parcelRegister("iePWG", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");
function $d471d41537772d80$var$ensureSelectorList(node) {
    if (node.type === 'Raw') return $bi5JI.parse(node.value, {
        context: 'selectorList'
    });
    return node;
}
function $d471d41537772d80$var$maxSpecificity(a, b) {
    for(let i = 0; i < 3; i++){
        if (a[i] !== b[i]) return a[i] > b[i] ? a : b;
    }
    return a;
}
function $d471d41537772d80$var$maxSelectorListSpecificity(selectorList) {
    return $d471d41537772d80$var$ensureSelectorList(selectorList).children.reduce((result, node)=>$d471d41537772d80$var$maxSpecificity($d471d41537772d80$var$specificity(node), result), [
        0,
        0,
        0
    ]);
}
// §16. Calculating a selector’s specificity
// https://www.w3.org/TR/selectors-4/#specificity-rules
function $d471d41537772d80$var$specificity(simpleSelector) {
    let A = 0;
    let B = 0;
    let C = 0;
    // A selector’s specificity is calculated for a given element as follows:
    simpleSelector.children.forEach((node)=>{
        switch(node.type){
            // count the number of ID selectors in the selector (= A)
            case 'IdSelector':
                A++;
                break;
            // count the number of class selectors, attributes selectors, ...
            case 'ClassSelector':
            case 'AttributeSelector':
                B++;
                break;
            // ... and pseudo-classes in the selector (= B)
            case 'PseudoClassSelector':
                switch(node.name.toLowerCase()){
                    // The specificity of an :is(), :not(), or :has() pseudo-class is replaced
                    // by the specificity of the most specific complex selector in its selector list argument.
                    case 'not':
                    case 'has':
                    case 'is':
                    // :matches() is used before it was renamed to :is()
                    // https://github.com/w3c/csswg-drafts/issues/3258
                    case 'matches':
                    // Older browsers support :is() functionality as prefixed pseudo-class :any()
                    // https://developer.mozilla.org/en-US/docs/Web/CSS/:is
                    case '-webkit-any':
                    case '-moz-any':
                        {
                            const [a, b, c] = $d471d41537772d80$var$maxSelectorListSpecificity(node.children.first);
                            A += a;
                            B += b;
                            C += c;
                            break;
                        }
                    // Analogously, the specificity of an :nth-child() or :nth-last-child() selector
                    // is the specificity of the pseudo class itself (counting as one pseudo-class selector)
                    // plus the specificity of the most specific complex selector in its selector list argument (if any).
                    case 'nth-child':
                    case 'nth-last-child':
                        {
                            const arg = node.children.first;
                            if (arg.type === 'Nth' && arg.selector) {
                                const [a, b, c] = $d471d41537772d80$var$maxSelectorListSpecificity(arg.selector);
                                A += a;
                                B += b + 1;
                                C += c;
                            } else B++;
                            break;
                        }
                    // The specificity of a :where() pseudo-class is replaced by zero.
                    case 'where':
                        break;
                    // The four Level 2 pseudo-elements (::before, ::after, ::first-line, and ::first-letter) may,
                    // for legacy reasons, be represented using the <pseudo-class-selector> grammar,
                    // with only a single ":" character at their start.
                    // https://www.w3.org/TR/selectors-4/#single-colon-pseudos
                    case 'before':
                    case 'after':
                    case 'first-line':
                    case 'first-letter':
                        C++;
                        break;
                    default:
                        B++;
                }
                break;
            // count the number of type selectors ...
            case 'TypeSelector':
                // ignore the universal selector
                if (!node.name.endsWith('*')) C++;
                break;
            // ... and pseudo-elements in the selector (= C)
            case 'PseudoElementSelector':
                C++;
                break;
        }
    });
    return [
        A,
        B,
        C
    ];
}
module.exports = $d471d41537772d80$var$specificity;

});



parcelRegister("welhf", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");
const { hasOwnProperty: $060e1d54f2f1bbcf$var$hasOwnProperty } = Object.prototype;
function $060e1d54f2f1bbcf$var$addRuleToMap(map, item, list, single) {
    const node = item.data;
    const name = $bi5JI.keyword(node.name).basename;
    const id = node.name.toLowerCase() + '/' + (node.prelude ? node.prelude.id : null);
    if (!$060e1d54f2f1bbcf$var$hasOwnProperty.call(map, name)) map[name] = Object.create(null);
    if (single) delete map[name][id];
    if (!$060e1d54f2f1bbcf$var$hasOwnProperty.call(map[name], id)) map[name][id] = new $bi5JI.List();
    map[name][id].append(list.remove(item));
}
function $060e1d54f2f1bbcf$var$relocateAtrules(ast, options) {
    const collected = Object.create(null);
    let topInjectPoint = null;
    ast.children.forEach(function(node, item, list) {
        if (node.type === 'Atrule') {
            const name = $bi5JI.keyword(node.name).basename;
            switch(name){
                case 'keyframes':
                    $060e1d54f2f1bbcf$var$addRuleToMap(collected, item, list, true);
                    return;
                case 'media':
                    if (options.forceMediaMerge) {
                        $060e1d54f2f1bbcf$var$addRuleToMap(collected, item, list, false);
                        return;
                    }
                    break;
            }
            if (topInjectPoint === null && name !== 'charset' && name !== 'import') topInjectPoint = item;
        } else if (topInjectPoint === null) topInjectPoint = item;
    });
    for(const atrule in collected)for(const id in collected[atrule])ast.children.insertList(collected[atrule][id], atrule === 'media' ? null : topInjectPoint);
}
function $060e1d54f2f1bbcf$var$isMediaRule(node) {
    return node.type === 'Atrule' && node.name === 'media';
}
function $060e1d54f2f1bbcf$var$processAtrule(node, item, list) {
    if (!$060e1d54f2f1bbcf$var$isMediaRule(node)) return;
    const prev = item.prev && item.prev.data;
    if (!prev || !$060e1d54f2f1bbcf$var$isMediaRule(prev)) return;
    // merge @media with same query
    if (node.prelude && prev.prelude && node.prelude.id === prev.prelude.id) {
        prev.block.children.appendList(node.block.children);
        list.remove(item);
    // TODO: use it when we can refer to several points in source
    // prev.loc = {
    //     primary: prev.loc,
    //     merged: node.loc
    // };
    }
}
function $060e1d54f2f1bbcf$var$rejoinAtrule(ast, options) {
    $060e1d54f2f1bbcf$var$relocateAtrules(ast, options);
    $bi5JI.walk(ast, {
        visit: 'Atrule',
        reverse: true,
        enter: $060e1d54f2f1bbcf$var$processAtrule
    });
}
module.exports = $060e1d54f2f1bbcf$var$rejoinAtrule;

});

parcelRegister("eZaRu", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $hxWAl = parcelRequire("hxWAl");
function $ae8f301909d3b712$var$processRule(node, item, list) {
    const selectors = node.prelude.children;
    const declarations = node.block.children;
    list.prevUntil(item.prev, function(prev) {
        // skip non-ruleset node if safe
        if (prev.type !== 'Rule') return $hxWAl.unsafeToSkipNode.call(selectors, prev);
        const prevSelectors = prev.prelude.children;
        const prevDeclarations = prev.block.children;
        // try to join rulesets with equal pseudo signature
        if (node.pseudoSignature === prev.pseudoSignature) {
            // try to join by selectors
            if ($hxWAl.isEqualSelectors(prevSelectors, selectors)) {
                prevDeclarations.appendList(declarations);
                list.remove(item);
                return true;
            }
            // try to join by declarations
            if ($hxWAl.isEqualDeclarations(declarations, prevDeclarations)) {
                $hxWAl.addSelectors(prevSelectors, selectors);
                list.remove(item);
                return true;
            }
        }
        // go to prev ruleset if has no selector similarities
        return $hxWAl.hasSimilarSelectors(selectors, prevSelectors);
    });
}
// NOTE: direction should be left to right, since rulesets merge to left
// ruleset. When direction right to left unmerged rulesets may prevent lookup
// TODO: remove initial merge
function $ae8f301909d3b712$var$initialMergeRule(ast) {
    $bi5JI.walk(ast, {
        visit: 'Rule',
        enter: $ae8f301909d3b712$var$processRule
    });
}
module.exports = $ae8f301909d3b712$var$initialMergeRule;

});
parcelRegister("hxWAl", function(module, exports) {

$parcel$export(module.exports, "addSelectors", () => $cc62f68af26be7bc$export$f19b2de7003025a4, (v) => $cc62f68af26be7bc$export$f19b2de7003025a4 = v);
$parcel$export(module.exports, "compareDeclarations", () => $cc62f68af26be7bc$export$c33c6bd7b1b33115, (v) => $cc62f68af26be7bc$export$c33c6bd7b1b33115 = v);
$parcel$export(module.exports, "hasSimilarSelectors", () => $cc62f68af26be7bc$export$17616afcba2c76fe, (v) => $cc62f68af26be7bc$export$17616afcba2c76fe = v);
$parcel$export(module.exports, "isEqualDeclarations", () => $cc62f68af26be7bc$export$e33504c5cd20a712, (v) => $cc62f68af26be7bc$export$e33504c5cd20a712 = v);
$parcel$export(module.exports, "isEqualSelectors", () => $cc62f68af26be7bc$export$82fb32fe5b82c40b, (v) => $cc62f68af26be7bc$export$82fb32fe5b82c40b = v);
$parcel$export(module.exports, "unsafeToSkipNode", () => $cc62f68af26be7bc$export$a048038cc2a3b0e2, (v) => $cc62f68af26be7bc$export$a048038cc2a3b0e2 = v);
var $cc62f68af26be7bc$export$f19b2de7003025a4;
var $cc62f68af26be7bc$export$c33c6bd7b1b33115;
var $cc62f68af26be7bc$export$17616afcba2c76fe;
var $cc62f68af26be7bc$export$e33504c5cd20a712;
var $cc62f68af26be7bc$export$82fb32fe5b82c40b;
var $cc62f68af26be7bc$export$a048038cc2a3b0e2;
'use strict';
const { hasOwnProperty: $cc62f68af26be7bc$var$hasOwnProperty } = Object.prototype;
function $cc62f68af26be7bc$var$isEqualSelectors(a, b) {
    let cursor1 = a.head;
    let cursor2 = b.head;
    while(cursor1 !== null && cursor2 !== null && cursor1.data.id === cursor2.data.id){
        cursor1 = cursor1.next;
        cursor2 = cursor2.next;
    }
    return cursor1 === null && cursor2 === null;
}
function $cc62f68af26be7bc$var$isEqualDeclarations(a, b) {
    let cursor1 = a.head;
    let cursor2 = b.head;
    while(cursor1 !== null && cursor2 !== null && cursor1.data.id === cursor2.data.id){
        cursor1 = cursor1.next;
        cursor2 = cursor2.next;
    }
    return cursor1 === null && cursor2 === null;
}
function $cc62f68af26be7bc$var$compareDeclarations(declarations1, declarations2) {
    const result = {
        eq: [],
        ne1: [],
        ne2: [],
        ne2overrided: []
    };
    const fingerprints = Object.create(null);
    const declarations2hash = Object.create(null);
    for(let cursor = declarations2.head; cursor; cursor = cursor.next)declarations2hash[cursor.data.id] = true;
    for(let cursor = declarations1.head; cursor; cursor = cursor.next){
        const data = cursor.data;
        if (data.fingerprint) fingerprints[data.fingerprint] = data.important;
        if (declarations2hash[data.id]) {
            declarations2hash[data.id] = false;
            result.eq.push(data);
        } else result.ne1.push(data);
    }
    for(let cursor = declarations2.head; cursor; cursor = cursor.next){
        const data = cursor.data;
        if (declarations2hash[data.id]) {
            // when declarations1 has an overriding declaration, this is not a difference
            // unless no !important is used on prev and !important is used on the following
            if (!$cc62f68af26be7bc$var$hasOwnProperty.call(fingerprints, data.fingerprint) || !fingerprints[data.fingerprint] && data.important) result.ne2.push(data);
            result.ne2overrided.push(data);
        }
    }
    return result;
}
function $cc62f68af26be7bc$var$addSelectors(dest, source) {
    source.forEach((sourceData)=>{
        const newStr = sourceData.id;
        let cursor = dest.head;
        while(cursor){
            const nextStr = cursor.data.id;
            if (nextStr === newStr) return;
            if (nextStr > newStr) break;
            cursor = cursor.next;
        }
        dest.insert(dest.createItem(sourceData), cursor);
    });
    return dest;
}
// check if simpleselectors has no equal specificity and element selector
function $cc62f68af26be7bc$var$hasSimilarSelectors(selectors1, selectors2) {
    let cursor1 = selectors1.head;
    while(cursor1 !== null){
        let cursor2 = selectors2.head;
        while(cursor2 !== null){
            if (cursor1.data.compareMarker === cursor2.data.compareMarker) return true;
            cursor2 = cursor2.next;
        }
        cursor1 = cursor1.next;
    }
    return false;
}
// test node can't to be skipped
function $cc62f68af26be7bc$var$unsafeToSkipNode(node) {
    switch(node.type){
        case 'Rule':
            // unsafe skip ruleset with selector similarities
            return $cc62f68af26be7bc$var$hasSimilarSelectors(node.prelude.children, this);
        case 'Atrule':
            // can skip at-rules with blocks
            if (node.block) // unsafe skip at-rule if block contains something unsafe to skip
            return node.block.children.some($cc62f68af26be7bc$var$unsafeToSkipNode, this);
            break;
        case 'Declaration':
            return false;
    }
    // unsafe by default
    return true;
}
$cc62f68af26be7bc$export$f19b2de7003025a4 = $cc62f68af26be7bc$var$addSelectors;
$cc62f68af26be7bc$export$c33c6bd7b1b33115 = $cc62f68af26be7bc$var$compareDeclarations;
$cc62f68af26be7bc$export$17616afcba2c76fe = $cc62f68af26be7bc$var$hasSimilarSelectors;
$cc62f68af26be7bc$export$e33504c5cd20a712 = $cc62f68af26be7bc$var$isEqualDeclarations;
$cc62f68af26be7bc$export$82fb32fe5b82c40b = $cc62f68af26be7bc$var$isEqualSelectors;
$cc62f68af26be7bc$export$a048038cc2a3b0e2 = $cc62f68af26be7bc$var$unsafeToSkipNode;

});


parcelRegister("aAkVI", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");
function $7b4d806bcf83f785$var$processRule(node, item, list) {
    const selectors = node.prelude.children;
    // generate new rule sets:
    // .a, .b { color: red; }
    // ->
    // .a { color: red; }
    // .b { color: red; }
    // while there are more than 1 simple selector split for rulesets
    while(selectors.head !== selectors.tail){
        const newSelectors = new $bi5JI.List();
        newSelectors.insert(selectors.remove(selectors.head));
        list.insert(list.createItem({
            type: 'Rule',
            loc: node.loc,
            prelude: {
                type: 'SelectorList',
                loc: node.prelude.loc,
                children: newSelectors
            },
            block: {
                type: 'Block',
                loc: node.block.loc,
                children: node.block.children.copy()
            },
            pseudoSignature: node.pseudoSignature
        }), item);
    }
}
function $7b4d806bcf83f785$var$disjoinRule(ast) {
    $bi5JI.walk(ast, {
        visit: 'Rule',
        reverse: true,
        enter: $7b4d806bcf83f785$var$processRule
    });
}
module.exports = $7b4d806bcf83f785$var$disjoinRule;

});

parcelRegister("3TOAM", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");
const $2d6dc0b7c708f58b$var$REPLACE = 1;
const $2d6dc0b7c708f58b$var$REMOVE = 2;
const $2d6dc0b7c708f58b$var$TOP = 0;
const $2d6dc0b7c708f58b$var$RIGHT = 1;
const $2d6dc0b7c708f58b$var$BOTTOM = 2;
const $2d6dc0b7c708f58b$var$LEFT = 3;
const $2d6dc0b7c708f58b$var$SIDES = [
    'top',
    'right',
    'bottom',
    'left'
];
const $2d6dc0b7c708f58b$var$SIDE = {
    'margin-top': 'top',
    'margin-right': 'right',
    'margin-bottom': 'bottom',
    'margin-left': 'left',
    'padding-top': 'top',
    'padding-right': 'right',
    'padding-bottom': 'bottom',
    'padding-left': 'left',
    'border-top-color': 'top',
    'border-right-color': 'right',
    'border-bottom-color': 'bottom',
    'border-left-color': 'left',
    'border-top-width': 'top',
    'border-right-width': 'right',
    'border-bottom-width': 'bottom',
    'border-left-width': 'left',
    'border-top-style': 'top',
    'border-right-style': 'right',
    'border-bottom-style': 'bottom',
    'border-left-style': 'left'
};
const $2d6dc0b7c708f58b$var$MAIN_PROPERTY = {
    'margin': 'margin',
    'margin-top': 'margin',
    'margin-right': 'margin',
    'margin-bottom': 'margin',
    'margin-left': 'margin',
    'padding': 'padding',
    'padding-top': 'padding',
    'padding-right': 'padding',
    'padding-bottom': 'padding',
    'padding-left': 'padding',
    'border-color': 'border-color',
    'border-top-color': 'border-color',
    'border-right-color': 'border-color',
    'border-bottom-color': 'border-color',
    'border-left-color': 'border-color',
    'border-width': 'border-width',
    'border-top-width': 'border-width',
    'border-right-width': 'border-width',
    'border-bottom-width': 'border-width',
    'border-left-width': 'border-width',
    'border-style': 'border-style',
    'border-top-style': 'border-style',
    'border-right-style': 'border-style',
    'border-bottom-style': 'border-style',
    'border-left-style': 'border-style'
};
class $2d6dc0b7c708f58b$var$TRBL {
    getValueSequence(declaration, count) {
        const values = [];
        let iehack = '';
        const hasBadValues = declaration.value.type !== 'Value' || declaration.value.children.some(function(child) {
            let special = false;
            switch(child.type){
                case 'Identifier':
                    switch(child.name){
                        case '\\0':
                        case '\\9':
                            iehack = child.name;
                            return;
                        case 'inherit':
                        case 'initial':
                        case 'unset':
                        case 'revert':
                            special = child.name;
                            break;
                    }
                    break;
                case 'Dimension':
                    switch(child.unit){
                        // is not supported until IE11
                        case 'rem':
                        // v* units is too buggy across browsers and better
                        // don't merge values with those units
                        case 'vw':
                        case 'vh':
                        case 'vmin':
                        case 'vmax':
                        case 'vm':
                            special = child.unit;
                            break;
                    }
                    break;
                case 'Hash':
                case 'Number':
                case 'Percentage':
                    break;
                case 'Function':
                    if (child.name === 'var') return true;
                    special = child.name;
                    break;
                default:
                    return true; // bad value
            }
            values.push({
                node: child,
                special: special,
                important: declaration.important
            });
        });
        if (hasBadValues || values.length > count) return false;
        if (typeof this.iehack === 'string' && this.iehack !== iehack) return false;
        this.iehack = iehack; // move outside
        return values;
    }
    canOverride(side, value) {
        const currentValue = this.sides[side];
        return !currentValue || value.important && !currentValue.important;
    }
    add(name, declaration) {
        function attemptToAdd() {
            const sides = this.sides;
            const side = $2d6dc0b7c708f58b$var$SIDE[name];
            if (side) {
                if (side in sides === false) return false;
                const values = this.getValueSequence(declaration, 1);
                if (!values || !values.length) return false;
                // can mix only if specials are equal
                for(const key in sides){
                    if (sides[key] !== null && sides[key].special !== values[0].special) return false;
                }
                if (!this.canOverride(side, values[0])) return true;
                sides[side] = values[0];
                return true;
            } else if (name === this.name) {
                const values = this.getValueSequence(declaration, 4);
                if (!values || !values.length) return false;
                switch(values.length){
                    case 1:
                        values[$2d6dc0b7c708f58b$var$RIGHT] = values[$2d6dc0b7c708f58b$var$TOP];
                        values[$2d6dc0b7c708f58b$var$BOTTOM] = values[$2d6dc0b7c708f58b$var$TOP];
                        values[$2d6dc0b7c708f58b$var$LEFT] = values[$2d6dc0b7c708f58b$var$TOP];
                        break;
                    case 2:
                        values[$2d6dc0b7c708f58b$var$BOTTOM] = values[$2d6dc0b7c708f58b$var$TOP];
                        values[$2d6dc0b7c708f58b$var$LEFT] = values[$2d6dc0b7c708f58b$var$RIGHT];
                        break;
                    case 3:
                        values[$2d6dc0b7c708f58b$var$LEFT] = values[$2d6dc0b7c708f58b$var$RIGHT];
                        break;
                }
                // can mix only if specials are equal
                for(let i = 0; i < 4; i++)for(const key in sides){
                    if (sides[key] !== null && sides[key].special !== values[i].special) return false;
                }
                for(let i = 0; i < 4; i++)if (this.canOverride($2d6dc0b7c708f58b$var$SIDES[i], values[i])) sides[$2d6dc0b7c708f58b$var$SIDES[i]] = values[i];
                return true;
            }
        }
        if (!attemptToAdd.call(this)) return false;
        // TODO: use it when we can refer to several points in source
        // if (this.loc) {
        //     this.loc = {
        //         primary: this.loc,
        //         merged: declaration.loc
        //     };
        // } else {
        //     this.loc = declaration.loc;
        // }
        if (!this.loc) this.loc = declaration.loc;
        return true;
    }
    isOkToMinimize() {
        const top = this.sides.top;
        const right = this.sides.right;
        const bottom = this.sides.bottom;
        const left = this.sides.left;
        if (top && right && bottom && left) {
            const important = top.important + right.important + bottom.important + left.important;
            return important === 0 || important === 4;
        }
        return false;
    }
    getValue() {
        const result = new $bi5JI.List();
        const sides = this.sides;
        const values = [
            sides.top,
            sides.right,
            sides.bottom,
            sides.left
        ];
        const stringValues = [
            $bi5JI.generate(sides.top.node),
            $bi5JI.generate(sides.right.node),
            $bi5JI.generate(sides.bottom.node),
            $bi5JI.generate(sides.left.node)
        ];
        if (stringValues[$2d6dc0b7c708f58b$var$LEFT] === stringValues[$2d6dc0b7c708f58b$var$RIGHT]) {
            values.pop();
            if (stringValues[$2d6dc0b7c708f58b$var$BOTTOM] === stringValues[$2d6dc0b7c708f58b$var$TOP]) {
                values.pop();
                if (stringValues[$2d6dc0b7c708f58b$var$RIGHT] === stringValues[$2d6dc0b7c708f58b$var$TOP]) values.pop();
            }
        }
        for(let i = 0; i < values.length; i++)result.appendData(values[i].node);
        if (this.iehack) result.appendData({
            type: 'Identifier',
            loc: null,
            name: this.iehack
        });
        return {
            type: 'Value',
            loc: null,
            children: result
        };
    }
    getDeclaration() {
        return {
            type: 'Declaration',
            loc: this.loc,
            important: this.sides.top.important,
            property: this.name,
            value: this.getValue()
        };
    }
    constructor(name){
        this.name = name;
        this.loc = null;
        this.iehack = undefined;
        this.sides = {
            'top': null,
            'right': null,
            'bottom': null,
            'left': null
        };
    }
}
function $2d6dc0b7c708f58b$var$processRule(rule, shorts, shortDeclarations, lastShortSelector) {
    const declarations = rule.block.children;
    const selector = rule.prelude.children.first.id;
    rule.block.children.forEachRight(function(declaration, item) {
        const property = declaration.property;
        if (!$2d6dc0b7c708f58b$var$MAIN_PROPERTY.hasOwnProperty(property)) return;
        const key = $2d6dc0b7c708f58b$var$MAIN_PROPERTY[property];
        let shorthand;
        let operation;
        if (!lastShortSelector || selector === lastShortSelector) {
            if (key in shorts) {
                operation = $2d6dc0b7c708f58b$var$REMOVE;
                shorthand = shorts[key];
            }
        }
        if (!shorthand || !shorthand.add(property, declaration)) {
            operation = $2d6dc0b7c708f58b$var$REPLACE;
            shorthand = new $2d6dc0b7c708f58b$var$TRBL(key);
            // if can't parse value ignore it and break shorthand children
            if (!shorthand.add(property, declaration)) {
                lastShortSelector = null;
                return;
            }
        }
        shorts[key] = shorthand;
        shortDeclarations.push({
            operation: operation,
            block: declarations,
            item: item,
            shorthand: shorthand
        });
        lastShortSelector = selector;
    });
    return lastShortSelector;
}
function $2d6dc0b7c708f58b$var$processShorthands(shortDeclarations, markDeclaration) {
    shortDeclarations.forEach(function(item) {
        const shorthand = item.shorthand;
        if (!shorthand.isOkToMinimize()) return;
        if (item.operation === $2d6dc0b7c708f58b$var$REPLACE) item.item.data = markDeclaration(shorthand.getDeclaration());
        else item.block.remove(item.item);
    });
}
function $2d6dc0b7c708f58b$var$restructBlock(ast, indexer) {
    const stylesheetMap = {};
    const shortDeclarations = [];
    $bi5JI.walk(ast, {
        visit: 'Rule',
        reverse: true,
        enter (node) {
            const stylesheet = this.block || this.stylesheet;
            const ruleId = (node.pseudoSignature || '') + '|' + node.prelude.children.first.id;
            let ruleMap;
            let shorts;
            if (!stylesheetMap.hasOwnProperty(stylesheet.id)) {
                ruleMap = {
                    lastShortSelector: null
                };
                stylesheetMap[stylesheet.id] = ruleMap;
            } else ruleMap = stylesheetMap[stylesheet.id];
            if (ruleMap.hasOwnProperty(ruleId)) shorts = ruleMap[ruleId];
            else {
                shorts = {};
                ruleMap[ruleId] = shorts;
            }
            ruleMap.lastShortSelector = $2d6dc0b7c708f58b$var$processRule.call(this, node, shorts, shortDeclarations, ruleMap.lastShortSelector);
        }
    });
    $2d6dc0b7c708f58b$var$processShorthands(shortDeclarations, indexer.declaration);
}
module.exports = $2d6dc0b7c708f58b$var$restructBlock;

});

parcelRegister("mqvO3", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");
let $04369eebc61eb8a2$var$fingerprintId = 1;
const $04369eebc61eb8a2$var$dontRestructure = new Set([
    'src' // https://github.com/afelix/csso/issues/50
]);
const $04369eebc61eb8a2$var$DONT_MIX_VALUE = {
    // https://developer.mozilla.org/en-US/docs/Web/CSS/display#Browser_compatibility
    'display': /table|ruby|flex|-(flex)?box$|grid|contents|run-in/i,
    // https://developer.mozilla.org/en/docs/Web/CSS/text-align
    'text-align': /^(start|end|match-parent|justify-all)$/i
};
const $04369eebc61eb8a2$var$SAFE_VALUES = {
    cursor: [
        'auto',
        'crosshair',
        'default',
        'move',
        'text',
        'wait',
        'help',
        'n-resize',
        'e-resize',
        's-resize',
        'w-resize',
        'ne-resize',
        'nw-resize',
        'se-resize',
        'sw-resize',
        'pointer',
        'progress',
        'not-allowed',
        'no-drop',
        'vertical-text',
        'all-scroll',
        'col-resize',
        'row-resize'
    ],
    overflow: [
        'hidden',
        'visible',
        'scroll',
        'auto'
    ],
    position: [
        'static',
        'relative',
        'absolute',
        'fixed'
    ]
};
const $04369eebc61eb8a2$var$NEEDLESS_TABLE = {
    'border-width': [
        'border'
    ],
    'border-style': [
        'border'
    ],
    'border-color': [
        'border'
    ],
    'border-top': [
        'border'
    ],
    'border-right': [
        'border'
    ],
    'border-bottom': [
        'border'
    ],
    'border-left': [
        'border'
    ],
    'border-top-width': [
        'border-top',
        'border-width',
        'border'
    ],
    'border-right-width': [
        'border-right',
        'border-width',
        'border'
    ],
    'border-bottom-width': [
        'border-bottom',
        'border-width',
        'border'
    ],
    'border-left-width': [
        'border-left',
        'border-width',
        'border'
    ],
    'border-top-style': [
        'border-top',
        'border-style',
        'border'
    ],
    'border-right-style': [
        'border-right',
        'border-style',
        'border'
    ],
    'border-bottom-style': [
        'border-bottom',
        'border-style',
        'border'
    ],
    'border-left-style': [
        'border-left',
        'border-style',
        'border'
    ],
    'border-top-color': [
        'border-top',
        'border-color',
        'border'
    ],
    'border-right-color': [
        'border-right',
        'border-color',
        'border'
    ],
    'border-bottom-color': [
        'border-bottom',
        'border-color',
        'border'
    ],
    'border-left-color': [
        'border-left',
        'border-color',
        'border'
    ],
    'margin-top': [
        'margin'
    ],
    'margin-right': [
        'margin'
    ],
    'margin-bottom': [
        'margin'
    ],
    'margin-left': [
        'margin'
    ],
    'padding-top': [
        'padding'
    ],
    'padding-right': [
        'padding'
    ],
    'padding-bottom': [
        'padding'
    ],
    'padding-left': [
        'padding'
    ],
    'font-style': [
        'font'
    ],
    'font-variant': [
        'font'
    ],
    'font-weight': [
        'font'
    ],
    'font-size': [
        'font'
    ],
    'font-family': [
        'font'
    ],
    'list-style-type': [
        'list-style'
    ],
    'list-style-position': [
        'list-style'
    ],
    'list-style-image': [
        'list-style'
    ]
};
function $04369eebc61eb8a2$var$getPropertyFingerprint(propertyName, declaration, fingerprints) {
    const realName = $bi5JI.property(propertyName).basename;
    if (realName === 'background') return propertyName + ':' + $bi5JI.generate(declaration.value);
    const declarationId = declaration.id;
    let fingerprint = fingerprints[declarationId];
    if (!fingerprint) {
        switch(declaration.value.type){
            case 'Value':
                const special = {};
                let vendorId = '';
                let iehack = '';
                let raw = false;
                declaration.value.children.forEach(function walk(node) {
                    switch(node.type){
                        case 'Value':
                        case 'Brackets':
                        case 'Parentheses':
                            node.children.forEach(walk);
                            break;
                        case 'Raw':
                            raw = true;
                            break;
                        case 'Identifier':
                            {
                                const { name: name } = node;
                                if (!vendorId) vendorId = $bi5JI.keyword(name).vendor;
                                if (/\\[09]/.test(name)) iehack = RegExp.lastMatch;
                                if ($04369eebc61eb8a2$var$SAFE_VALUES.hasOwnProperty(realName)) {
                                    if ($04369eebc61eb8a2$var$SAFE_VALUES[realName].indexOf(name) === -1) special[name] = true;
                                } else if ($04369eebc61eb8a2$var$DONT_MIX_VALUE.hasOwnProperty(realName)) {
                                    if ($04369eebc61eb8a2$var$DONT_MIX_VALUE[realName].test(name)) special[name] = true;
                                }
                                break;
                            }
                        case 'Function':
                            {
                                let { name: name } = node;
                                if (!vendorId) vendorId = $bi5JI.keyword(name).vendor;
                                if (name === 'rect') {
                                    // there are 2 forms of rect:
                                    //   rect(<top>, <right>, <bottom>, <left>) - standart
                                    //   rect(<top> <right> <bottom> <left>) – backwards compatible syntax
                                    // only the same form values can be merged
                                    const hasComma = node.children.some((node)=>node.type === 'Operator' && node.value === ',');
                                    if (!hasComma) name = 'rect-backward';
                                }
                                special[name + '()'] = true;
                                // check nested tokens too
                                node.children.forEach(walk);
                                break;
                            }
                        case 'Dimension':
                            {
                                const { unit: unit } = node;
                                if (/\\[09]/.test(unit)) iehack = RegExp.lastMatch;
                                switch(unit){
                                    // is not supported until IE11
                                    case 'rem':
                                    // v* units is too buggy across browsers and better
                                    // don't merge values with those units
                                    case 'vw':
                                    case 'vh':
                                    case 'vmin':
                                    case 'vmax':
                                    case 'vm':
                                        special[unit] = true;
                                        break;
                                }
                                break;
                            }
                    }
                });
                fingerprint = raw ? '!' + $04369eebc61eb8a2$var$fingerprintId++ : '!' + Object.keys(special).sort() + '|' + iehack + vendorId;
                break;
            case 'Raw':
                fingerprint = '!' + declaration.value.value;
                break;
            default:
                fingerprint = $bi5JI.generate(declaration.value);
        }
        fingerprints[declarationId] = fingerprint;
    }
    return propertyName + fingerprint;
}
function $04369eebc61eb8a2$var$needless(props, declaration, fingerprints) {
    const property = $bi5JI.property(declaration.property);
    if ($04369eebc61eb8a2$var$NEEDLESS_TABLE.hasOwnProperty(property.basename)) {
        const table = $04369eebc61eb8a2$var$NEEDLESS_TABLE[property.basename];
        for (const entry of table){
            const ppre = $04369eebc61eb8a2$var$getPropertyFingerprint(property.prefix + entry, declaration, fingerprints);
            const prev = props.hasOwnProperty(ppre) ? props[ppre] : null;
            if (prev && (!declaration.important || prev.item.data.important)) return prev;
        }
    }
}
function $04369eebc61eb8a2$var$processRule(rule, item, list, props, fingerprints) {
    const declarations = rule.block.children;
    declarations.forEachRight(function(declaration, declarationItem) {
        const { property: property } = declaration;
        const fingerprint = $04369eebc61eb8a2$var$getPropertyFingerprint(property, declaration, fingerprints);
        const prev = props[fingerprint];
        if (prev && !$04369eebc61eb8a2$var$dontRestructure.has(property)) {
            if (declaration.important && !prev.item.data.important) {
                props[fingerprint] = {
                    block: declarations,
                    item: declarationItem
                };
                prev.block.remove(prev.item);
            // TODO: use it when we can refer to several points in source
            // declaration.loc = {
            //     primary: declaration.loc,
            //     merged: prev.item.data.loc
            // };
            } else declarations.remove(declarationItem);
        } else {
            const prev = $04369eebc61eb8a2$var$needless(props, declaration, fingerprints);
            if (prev) declarations.remove(declarationItem);
            else {
                declaration.fingerprint = fingerprint;
                props[fingerprint] = {
                    block: declarations,
                    item: declarationItem
                };
            }
        }
    });
    if (declarations.isEmpty) list.remove(item);
}
function $04369eebc61eb8a2$var$restructBlock(ast) {
    const stylesheetMap = {};
    const fingerprints = Object.create(null);
    $bi5JI.walk(ast, {
        visit: 'Rule',
        reverse: true,
        enter (node, item, list) {
            const stylesheet = this.block || this.stylesheet;
            const ruleId = (node.pseudoSignature || '') + '|' + node.prelude.children.first.id;
            let ruleMap;
            let props;
            if (!stylesheetMap.hasOwnProperty(stylesheet.id)) {
                ruleMap = {};
                stylesheetMap[stylesheet.id] = ruleMap;
            } else ruleMap = stylesheetMap[stylesheet.id];
            if (ruleMap.hasOwnProperty(ruleId)) props = ruleMap[ruleId];
            else {
                props = {};
                ruleMap[ruleId] = props;
            }
            $04369eebc61eb8a2$var$processRule.call(this, node, item, list, props, fingerprints);
        }
    });
}
module.exports = $04369eebc61eb8a2$var$restructBlock;

});

parcelRegister("8ElkY", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $hxWAl = parcelRequire("hxWAl");
/*
    At this step all rules has single simple selector. We try to join by equal
    declaration blocks to first rule, e.g.

    .a { color: red }
    b { ... }
    .b { color: red }
    ->
    .a, .b { color: red }
    b { ... }
*/ function $64c29c4a6373fa21$var$processRule(node, item, list) {
    const selectors = node.prelude.children;
    const declarations = node.block.children;
    const nodeCompareMarker = selectors.first.compareMarker;
    const skippedCompareMarkers = {};
    list.nextUntil(item.next, function(next, nextItem) {
        // skip non-ruleset node if safe
        if (next.type !== 'Rule') return $hxWAl.unsafeToSkipNode.call(selectors, next);
        if (node.pseudoSignature !== next.pseudoSignature) return true;
        const nextFirstSelector = next.prelude.children.head;
        const nextDeclarations = next.block.children;
        const nextCompareMarker = nextFirstSelector.data.compareMarker;
        // if next ruleset has same marked as one of skipped then stop joining
        if (nextCompareMarker in skippedCompareMarkers) return true;
        // try to join by selectors
        if (selectors.head === selectors.tail) {
            if (selectors.first.id === nextFirstSelector.data.id) {
                declarations.appendList(nextDeclarations);
                list.remove(nextItem);
                return;
            }
        }
        // try to join by properties
        if ($hxWAl.isEqualDeclarations(declarations, nextDeclarations)) {
            const nextStr = nextFirstSelector.data.id;
            selectors.some((data, item)=>{
                const curStr = data.id;
                if (nextStr < curStr) {
                    selectors.insert(nextFirstSelector, item);
                    return true;
                }
                if (!item.next) {
                    selectors.insert(nextFirstSelector);
                    return true;
                }
            });
            list.remove(nextItem);
            return;
        }
        // go to next ruleset if current one can be skipped (has no equal specificity nor element selector)
        if (nextCompareMarker === nodeCompareMarker) return true;
        skippedCompareMarkers[nextCompareMarker] = true;
    });
}
function $64c29c4a6373fa21$var$mergeRule(ast) {
    $bi5JI.walk(ast, {
        visit: 'Rule',
        enter: $64c29c4a6373fa21$var$processRule
    });
}
module.exports = $64c29c4a6373fa21$var$mergeRule;

});

parcelRegister("sBHTI", function(module, exports) {
'use strict';

var $bi5JI = parcelRequire("bi5JI");

var $hxWAl = parcelRequire("hxWAl");
function $055fdd782577c544$var$calcSelectorLength(list) {
    return list.reduce((res, data)=>res + data.id.length + 1, 0) - 1;
}
function $055fdd782577c544$var$calcDeclarationsLength(tokens) {
    let length = 0;
    for (const token of tokens)length += token.length;
    return length + // declarations
    tokens.length - 1 // delimeters
    ;
}
function $055fdd782577c544$var$processRule(node, item, list) {
    const avoidRulesMerge = this.block !== null ? this.block.avoidRulesMerge : false;
    const selectors = node.prelude.children;
    const block = node.block;
    const disallowDownMarkers = Object.create(null);
    let allowMergeUp = true;
    let allowMergeDown = true;
    list.prevUntil(item.prev, function(prev, prevItem) {
        const prevBlock = prev.block;
        const prevType = prev.type;
        if (prevType !== 'Rule') {
            const unsafe = $hxWAl.unsafeToSkipNode.call(selectors, prev);
            if (!unsafe && prevType === 'Atrule' && prevBlock) $bi5JI.walk(prevBlock, {
                visit: 'Rule',
                enter (node) {
                    node.prelude.children.forEach((data)=>{
                        disallowDownMarkers[data.compareMarker] = true;
                    });
                }
            });
            return unsafe;
        }
        if (node.pseudoSignature !== prev.pseudoSignature) return true;
        const prevSelectors = prev.prelude.children;
        allowMergeDown = !prevSelectors.some((selector)=>selector.compareMarker in disallowDownMarkers);
        // try prev ruleset if simpleselectors has no equal specifity and element selector
        if (!allowMergeDown && !allowMergeUp) return true;
        // try to join by selectors
        if (allowMergeUp && $hxWAl.isEqualSelectors(prevSelectors, selectors)) {
            prevBlock.children.appendList(block.children);
            list.remove(item);
            return true;
        }
        // try to join by properties
        const diff = $hxWAl.compareDeclarations(block.children, prevBlock.children);
        // console.log(diff.eq, diff.ne1, diff.ne2);
        if (diff.eq.length) {
            if (!diff.ne1.length && !diff.ne2.length) {
                // equal blocks
                if (allowMergeDown) {
                    $hxWAl.addSelectors(selectors, prevSelectors);
                    list.remove(prevItem);
                }
                return true;
            } else if (!avoidRulesMerge) {
                if (diff.ne1.length && !diff.ne2.length) {
                    // prevBlock is subset block
                    const selectorLength = $055fdd782577c544$var$calcSelectorLength(selectors);
                    const blockLength = $055fdd782577c544$var$calcDeclarationsLength(diff.eq); // declarations length
                    if (allowMergeUp && selectorLength < blockLength) {
                        $hxWAl.addSelectors(prevSelectors, selectors);
                        block.children.fromArray(diff.ne1);
                    }
                } else if (!diff.ne1.length && diff.ne2.length) {
                    // node is subset of prevBlock
                    const selectorLength = $055fdd782577c544$var$calcSelectorLength(prevSelectors);
                    const blockLength = $055fdd782577c544$var$calcDeclarationsLength(diff.eq); // declarations length
                    if (allowMergeDown && selectorLength < blockLength) {
                        $hxWAl.addSelectors(selectors, prevSelectors);
                        prevBlock.children.fromArray(diff.ne2);
                    }
                } else {
                    // diff.ne1.length && diff.ne2.length
                    // extract equal block
                    const newSelector = {
                        type: 'SelectorList',
                        loc: null,
                        children: $hxWAl.addSelectors(prevSelectors.copy(), selectors)
                    };
                    const newBlockLength = $055fdd782577c544$var$calcSelectorLength(newSelector.children) + 2; // selectors length + curly braces length
                    const blockLength = $055fdd782577c544$var$calcDeclarationsLength(diff.eq); // declarations length
                    // create new ruleset if declarations length greater than
                    // ruleset description overhead
                    if (blockLength >= newBlockLength) {
                        const newItem = list.createItem({
                            type: 'Rule',
                            loc: null,
                            prelude: newSelector,
                            block: {
                                type: 'Block',
                                loc: null,
                                children: new $bi5JI.List().fromArray(diff.eq)
                            },
                            pseudoSignature: node.pseudoSignature
                        });
                        block.children.fromArray(diff.ne1);
                        prevBlock.children.fromArray(diff.ne2overrided);
                        if (allowMergeUp) list.insert(newItem, prevItem);
                        else list.insert(newItem, item);
                        return true;
                    }
                }
            }
        }
        if (allowMergeUp) // TODO: disallow up merge only if any property interception only (i.e. diff.ne2overrided.length > 0);
        // await property families to find property interception correctly
        allowMergeUp = !prevSelectors.some((prevSelector)=>selectors.some((selector)=>selector.compareMarker === prevSelector.compareMarker));
        prevSelectors.forEach((data)=>{
            disallowDownMarkers[data.compareMarker] = true;
        });
    });
}
function $055fdd782577c544$var$restructRule(ast) {
    $bi5JI.walk(ast, {
        visit: 'Rule',
        reverse: true,
        enter: $055fdd782577c544$var$processRule
    });
}
module.exports = $055fdd782577c544$var$restructRule;

});




parcelRegister("girxf", function(module, exports) {

$parcel$export(module.exports, "processSelector", () => $bdd3afb632fb57aa$export$1710f6b3fa7159fa, (v) => $bdd3afb632fb57aa$export$1710f6b3fa7159fa = v);
$parcel$export(module.exports, "addSelectors", () => $bdd3afb632fb57aa$export$f19b2de7003025a4, (v) => $bdd3afb632fb57aa$export$f19b2de7003025a4 = v);
$parcel$export(module.exports, "compareDeclarations", () => $bdd3afb632fb57aa$export$c33c6bd7b1b33115, (v) => $bdd3afb632fb57aa$export$c33c6bd7b1b33115 = v);
$parcel$export(module.exports, "hasSimilarSelectors", () => $bdd3afb632fb57aa$export$17616afcba2c76fe, (v) => $bdd3afb632fb57aa$export$17616afcba2c76fe = v);
$parcel$export(module.exports, "isEqualDeclarations", () => $bdd3afb632fb57aa$export$e33504c5cd20a712, (v) => $bdd3afb632fb57aa$export$e33504c5cd20a712 = v);
$parcel$export(module.exports, "isEqualSelectors", () => $bdd3afb632fb57aa$export$82fb32fe5b82c40b, (v) => $bdd3afb632fb57aa$export$82fb32fe5b82c40b = v);
$parcel$export(module.exports, "unsafeToSkipNode", () => $bdd3afb632fb57aa$export$a048038cc2a3b0e2, (v) => $bdd3afb632fb57aa$export$a048038cc2a3b0e2 = v);
var $bdd3afb632fb57aa$export$1710f6b3fa7159fa;
var $bdd3afb632fb57aa$export$f19b2de7003025a4;
var $bdd3afb632fb57aa$export$c33c6bd7b1b33115;
var $bdd3afb632fb57aa$export$17616afcba2c76fe;
var $bdd3afb632fb57aa$export$e33504c5cd20a712;
var $bdd3afb632fb57aa$export$82fb32fe5b82c40b;
var $bdd3afb632fb57aa$export$a048038cc2a3b0e2;
'use strict';

var $iKIOe = parcelRequire("iKIOe");

var $hxWAl = parcelRequire("hxWAl");
$bdd3afb632fb57aa$export$1710f6b3fa7159fa = $iKIOe;
$bdd3afb632fb57aa$export$f19b2de7003025a4 = $hxWAl.addSelectors;
$bdd3afb632fb57aa$export$c33c6bd7b1b33115 = $hxWAl.compareDeclarations;
$bdd3afb632fb57aa$export$17616afcba2c76fe = $hxWAl.hasSimilarSelectors;
$bdd3afb632fb57aa$export$e33504c5cd20a712 = $hxWAl.isEqualDeclarations;
$bdd3afb632fb57aa$export$82fb32fe5b82c40b = $hxWAl.isEqualSelectors;
$bdd3afb632fb57aa$export$a048038cc2a3b0e2 = $hxWAl.unsafeToSkipNode;

});



parcelRegister("iaRmR", function(module, exports) {

$parcel$export(module.exports, "LegacyMacroStyledElement", () => $442661c5ce449806$export$e9dd081c6786d35c);
/* LegacyMacroStyledElement.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* SSR is also using the same elements to prevent duplication and risk for getting out of sync. Moved to fabric extension to
 prevent circular dependency with fabric-extension-handler and content-renderer */ // We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
parcelRequire("jUZqZ");
var $hEeUR = parcelRequire("hEeUR");

var $adbKg = parcelRequire("adbKg");

var $5kjCz = parcelRequire("5kjCz");

var $9wGTI = parcelRequire("9wGTI");

var $gwrgp = parcelRequire("gwrgp");
const $442661c5ce449806$export$2b189d249f2bce2b = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentId: contentId, className: className, isInline: isInline, nodeProps: nodeProps, macroDataProps: macroDataProps, macroRepresentation: macroRepresentation, macroRenderedOutput: macroRenderedOutput, style: style, children: children, featureFlags: featureFlags, extensionHandlers: extensionHandlers, mediaToken: mediaToken, ssredElement: ssredElement, delayIframe: delayIframe, extensionKey: extensionKey })=>{
    const ElementTag = isInline ? 'span' : 'div';
    const containerRef = nodeProps?.ref;
    const placeholderRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const markerElement = placeholderRef.current;
        if (markerElement && ssredElement) {
            markerElement.insertAdjacentElement('afterend', ssredElement);
            if (containerRef && typeof containerRef === 'function') containerRef(ssredElement);
            return ()=>{
                // We inserted ssredElement above which is outside the React lifecycle
                // When the actual macro is rendered, this component will unmount.
                // At that point, we need to remove the inserted element to avoid duplication
                try {
                    ssredElement.parentNode?.removeChild(ssredElement);
                } catch  {}
            };
        }
    }, [
        containerRef,
        ssredElement
    ]);
    (0, $adbKg.useDelayedIframe)(delayIframe, ssredElement);
    if (children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        ...nodeProps,
        ...macroDataProps
    }, children);
    if (macroRepresentation === 'atlas_doc_format') return macroRenderedOutput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        ...nodeProps,
        ...macroDataProps,
        "data-testid": "legacy-macro-adf",
        "data-vc": `legacy-macro-element_${extensionKey || 'no-extension-key-provided'}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hEeUR.ADFRenderer), {
        document: JSON.parse(macroRenderedOutput),
        contentId: contentId,
        featureFlags: featureFlags ?? {},
        extensionHandlers: extensionHandlers,
        mediaToken: mediaToken,
        appearance: "full-width"
    })) : null;
    else {
        // we don't need to do placeholder logic when hydration is enabled
        const shouldDisablePlaceholder = window?.__HYDRATABLE__ && (0, $9wGTI.fg)('confluence_frontend_hydrate_legacy_macro');
        if (!shouldDisablePlaceholder && ssredElement && !(0, $9wGTI.fg)('enable_loadable_placeholder_for_legacy_macros')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("input", {
            type: "hidden",
            ref: placeholderRef,
            "data-legacy-ssred-element-ref": true
        });
        const macroHtml = delayIframe ? (0, $adbKg.delayIframeLoading)(macroRenderedOutput) : macroRenderedOutput;
        const placeholderId = macroDataProps && macroDataProps['data-fabric-macro'] && `ssr-extension-handler-placeholder-${macroDataProps['data-fabric-macro']}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: className,
            style: style,
            dangerouslySetInnerHTML: {
                __html: `${macroHtml}`
            },
            ...nodeProps,
            ...macroDataProps,
            ...delayIframe ? {
                'data-delay-iframe': '1'
            } : {},
            "data-testid": "legacy-macro-element",
            "data-vc": `legacy-macro-element_${extensionKey || 'no-extension-key-provided'}`,
            "data-ssr-placeholder": placeholderId,
            "data-ssr-placeholder-replace": placeholderId
        });
    }
});
const $442661c5ce449806$var$createClassnameForExtension = (adf)=>{
    const macroParams = adf?.attrs?.parameters?.macroParams || {};
    const extensionKey = adf?.attrs?.extensionKey || '';
    let key = `macro${extensionKey}`;
    if (extensionKey === 'jira' && !macroParams.key && !macroParams.count) key += 'Table';
    return key;
};
const $442661c5ce449806$var$LegacyMacroStyledElementBaseStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementJiraTableStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementIncludeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementEditorModeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementRendererModeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementInlineStyles = null;
const $442661c5ce449806$export$e9dd081c6786d35c = ({ adf: adf, mode: mode, isInline: isInline, ...props })=>{
    const hasMacroJiraTable = $442661c5ce449806$var$createClassnameForExtension(adf) === 'macrojiraTable';
    const hasMacroInclude = $442661c5ce449806$var$createClassnameForExtension(adf) === 'macroinclude';
    if ((0, $9wGTI.fg)('confluence_frontend_legacymacro_compiled_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($442661c5ce449806$export$2b189d249f2bce2b, {
        adf: adf,
        mode: mode,
        isInline: isInline,
        ...props,
        className: (0, $35pXk.default)([
            "_o5724jg8 _11rm1hrf _5xln4jg8 _1v0sze3t _tmbuze3t _og5autpp _oxx4utpp",
            hasMacroJiraTable && "_1e0c1ule _p12f1osq _1reo1wug _1cqiaq80 _1lkk4jg8",
            hasMacroInclude && "_1t1412x7 _12c1ze3t _4lh2ze3t _1cqiaq80 _hxtqze3t _vzdwze3t",
            mode === (0, $5kjCz.EDITOR) && "_kqswh2mm _uiztglyw",
            isInline && "_11rmglyw",
            mode === (0, $5kjCz.RENDERER) && isInline && "_1yt4v77o _1e0c1o8l"
        ])
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($442661c5ce449806$export$c3cc2e27fa0fdfe0, {
        "data-testid": "emotion-legacy-macro",
        adf: adf,
        mode: mode,
        isInline: isInline,
        ...props
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $442661c5ce449806$export$c3cc2e27fa0fdfe0 = /*#__PURE__*/ (0, $gwrgp.default)($442661c5ce449806$export$2b189d249f2bce2b, {
    target: "ey937e10"
})("white-space:normal;p{white-space:normal;}[data-node-type='expand']{margin-left:var(--ds-space-0, 0px);margin-right:var(--ds-space-0, 0px);}", (props)=>{
    const adfJiraMacroPageIncludeCssOverride = $442661c5ce449806$var$createClassnameForExtension(props.adf) === 'macrojiraTable' || $442661c5ce449806$var$createClassnameForExtension(props.adf) === 'macroinclude';
    return adfJiraMacroPageIncludeCssOverride && `.ak-renderer-document > div.ak-renderer-extension {
       width: 100% !important;
     }`;
}, " ", (props)=>{
    return $442661c5ce449806$var$createClassnameForExtension(props.adf) === 'macroinclude' && `.ak-renderer-document .ak-renderer-extension-overflow-container .error {
     padding: ${"var(--ds-space-075, 6px)"};
   }`;
}, " ", (props)=>{
    return $442661c5ce449806$var$createClassnameForExtension(props.adf) === 'macrojiraTable' && `display: block;
         max-width: 100%;
         overflow-x: auto;
         th {
           word-break: normal;
         }`;
}, " ", (props)=>props.mode === (0, $5kjCz.EDITOR) && `position: relative; user-select: none;`, " ", (props)=>props.isInline ? `clear: none;` : `clear: both;`, " ", (props)=>props.mode === (0, $5kjCz.RENDERER) && props.isInline && `display: inline-block; padding: ${"var(--ds-space-025, 2px)"};`, " ", (props)=>{
    return $442661c5ce449806$var$createClassnameForExtension(props.adf) === 'macroinclude' && `.ak-renderer-document > .pm-table-container > .pm-table-wrapper {
     padding: ${"var(--ds-space-0, 0px)"};
     margin: ${"var(--ds-space-0, 0px)"};
   }
   .ak-renderer-document [data-testid="sticky-table-fixed"] > .pm-table-container {
     margin-bottom: ${"var(--ds-space-0, 0px)"};
   }
   .ak-renderer-document [data-testid="sticky-table-fixed"] > .pm-table-container table {
     margin-top: ${"var(--ds-space-0, 0px)"};
   }`;
}, " table.confluenceTable{tr{th.confluenceTh:nth-of-type(1),td.confluenceTd:nth-of-type(1){padding-left:var(--ds-space-150, 12px);}}}");

});
parcelRegister("adbKg", function(module, exports) {

$parcel$export(module.exports, "delayIframeLoading", () => $4995ce58a287dd32$export$79f3459501b856f9);
$parcel$export(module.exports, "useDelayedIframe", () => $4995ce58a287dd32$export$1a181571c396c997);

var $gwFzn = parcelRequire("gwFzn");
const $4995ce58a287dd32$var$iframeSrcRegex = /(<iframe.*)\ssrc=((?:".*?")|(?:'.*?'))(.*>)/gim;
const $4995ce58a287dd32$var$iframeTagRegex = /<iframe/gi;
const $4995ce58a287dd32$export$79f3459501b856f9 = (extensionHTML)=>{
    if (!extensionHTML) return extensionHTML;
    // Account for multiple iframes in the input, to make non-advised Regex-based HTML
    // handling more robust in this particular case.
    return extensionHTML.split($4995ce58a287dd32$var$iframeTagRegex).map((fragment, index)=>{
        return index === 0 ? fragment : `<iframe${fragment}`.replace($4995ce58a287dd32$var$iframeSrcRegex, `$1 data-delayed-src=$2$3`);
    }).join('');
};
const $4995ce58a287dd32$export$1a181571c396c997 = (delayIframe, extensionElement)=>{
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (extensionElement) {
            if (delayIframe) extensionElement.setAttribute('data-delay-iframe', 'true');
            else extensionElement.removeAttribute('data-delay-iframe');
        }
    }, [
        extensionElement,
        delayIframe
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const srcAttr = 'src';
        const delayedSrcAttr = 'data-delayed-src';
        if (extensionElement) {
            const iframe = extensionElement.querySelector('iframe');
            if (iframe && !delayIframe) {
                const delayedSrc = iframe.getAttribute(delayedSrcAttr);
                if (delayedSrc) {
                    iframe.setAttribute(srcAttr, delayedSrc);
                    iframe.removeAttribute(delayedSrcAttr);
                }
            }
        }
    }, [
        extensionElement,
        delayIframe
    ]);
};

});


parcelRegister("3o0Dr", function(module, exports) {

$parcel$export(module.exports, "FabricLegacyMacrosServerLoader", () => $1c95b3b9276df843$export$b5cf65c5c3b73c3f);

var $gwFzn = parcelRequire("gwFzn");


var $eczvQ = parcelRequire("eczvQ");
const $1c95b3b9276df843$var$THROTTLE_MACROS_QUERY_THRESHOLD = 8;
const $1c95b3b9276df843$export$b5cf65c5c3b73c3f = ({ node: node, mode: mode, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
        node: node
    });
};

});

parcelRegister("lqWPF", function(module, exports) {

$parcel$export(module.exports, "useDataMacroBody", () => $8ed303578fdef1ee$export$d2c0db192704879b);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $xQxzY = parcelRequire("xQxzY");

var $8pcS0 = parcelRequire("8pcS0");

var $92uc5 = parcelRequire("92uc5");
function $8ed303578fdef1ee$export$d2c0db192704879b(node, contentId) {
    const bodyContentParam = node.parameters?.macroParams?.__bodyContent;
    const isPlainText = node.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) && Boolean(bodyContentParam);
    const isRichTextMacro = node.type === (0, $8pcS0.BODIED_EXTENSION_TYPE);
    const contentConverterQueryResult = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query useDataMacroBodyContentConverterQuery($content:String!$contentId:ID!$from:String!$to:String!$spaceKeyContext:String=""){contentConverter(from:$from to:$to content:$content contentIdContext:$contentId spaceKeyContext:$spaceKeyContext){value}}`, {
        variables: (0, $92uc5.getContentConverterVariables)({
            content: node.content,
            contentId: contentId
        }),
        fetchPolicy: 'cache-only',
        skip: !isRichTextMacro
    });
    if (isRichTextMacro) return contentConverterQueryResult.data ? {
        value: contentConverterQueryResult.data.contentConverter?.value
    } : {
        missing: true
    };
    if (isPlainText) return {
        value: bodyContentParam?.value || ''
    };
    return {
        value: ''
    };
}

});

parcelRegister("ji0Re", function(module, exports) {

$parcel$export(module.exports, "useMacroContentData", () => $f467909144d22250$export$6bb3728261293af5);

var $xQxzY = parcelRequire("xQxzY");

var $ld6xp = parcelRequire("ld6xp");
var $8mIlz = parcelRequire("8mIlz");
var $9p5st = parcelRequire("9p5st");
var $iKSlH = parcelRequire("iKSlH");
const $f467909144d22250$export$9f73be5695bf7530 = (contentId, node)=>{
    const { isMacroContentAndBody: isMacroContentAndBody, ...rest } = (0, $8mIlz.getMacroQueryVariables)({
        node: node,
        contentId: contentId
    });
    const MacroQuery = isMacroContentAndBody ? (0, $9p5st.MacroBodyRendererQueryWithTags) : (0, $9p5st.MacroContentRendererQueryWithTags);
    const { data: data } = (0, $xQxzY.useQuery)(MacroQuery, {
        fetchPolicy: 'cache-only',
        variables: rest
    });
    return data;
};
const $f467909144d22250$export$60af9684eedb3caa = (contentId, node)=>{
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const { renderedMacro: renderedMacro } = (0, $iKSlH.useMultiMacroQuery)({
        contentId: contentId,
        macroId: macroId
    });
    return {
        macroBodyRenderer: renderedMacro,
        representation: renderedMacro?.macroRenderedRepresentation,
        mediaToken: renderedMacro?.mediaToken,
        webResourceDependencies: renderedMacro?.webResource,
        macroBodyStorageFormat: {
            value: renderedMacro?.macroBodyStorage
        }
    };
};
const $f467909144d22250$export$6bb3728261293af5 = (contentId, node)=>{
    return (0, $ld6xp.canUseMultiMacroQuery)(node.extensionKey) ? $f467909144d22250$export$60af9684eedb3caa(contentId, node) : $f467909144d22250$export$9f73be5695bf7530(contentId, node);
};

});

parcelRegister("ebUME", function(module, exports) {

$parcel$export(module.exports, "getSsrExtensionHandlers", () => $dff9e4cf0075d57c$export$be8c01ded2deab2c);
/* eslint-disable react/jsx-no-bind */ 
var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $lspPP = parcelRequire("lspPP");

var $8pcS0 = parcelRequire("8pcS0");

var $eS4Za = parcelRequire("eS4Za");

var $5kjCz = parcelRequire("5kjCz");
parcelRequire("jUZqZ");
var $hEeUR = parcelRequire("hEeUR");
parcelRequire("5PGOG");
var $bnGqC = parcelRequire("bnGqC");
var $5PGOG = parcelRequire("5PGOG");

var $1aGr8 = parcelRequire("1aGr8");

var $l86Zj = parcelRequire("l86Zj");
var $hKeSi = parcelRequire("hKeSi");
var $2LCBF = parcelRequire("2LCBF");
var $8BBIU = parcelRequire("8BBIU");
var $6v9Za = parcelRequire("6v9Za");

var $PrCoC = parcelRequire("PrCoC");

var $dTAyb = parcelRequire("dTAyb");

var $duRQc = parcelRequire("duRQc");

var $9nJuY = parcelRequire("9nJuY");

var $989nU = parcelRequire("989nU");
const $dff9e4cf0075d57c$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
const $dff9e4cf0075d57c$export$be8c01ded2deab2c = ({ adf: adf, contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId, macroRenderedOutput: macroRenderedOutput, includeSuperbatch: includeSuperbatch })=>{
    return {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $dff9e4cf0075d57c$var$getMacroExtensionHandlerForRenderer({
            adf: adf,
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId,
            userId: userId,
            macroRenderedOutput: macroRenderedOutput,
            includeSuperbatch: includeSuperbatch
        }),
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES]: $dff9e4cf0075d57c$var$getEmptyHandlers(),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: $dff9e4cf0075d57c$var$getEmptyHandlers(),
        [(0, $8pcS0.EXTENSION_TYPE).TEMPLATE]: $dff9e4cf0075d57c$var$getEmptyHandlers()
    };
};
const $dff9e4cf0075d57c$var$getEmptyHandlers = ()=>(0, $eS4Za.createMacroExtensionHandler)(()=>{
        return null;
    });
const $dff9e4cf0075d57c$export$d3d0d63f461591f5 = ({ macroDefaultProps: macroDefaultProps, extension: extension, cloudId: cloudId, contentId: contentId, userId: userId, adf: adf })=>{
    function getSsrButtonLabel() {
        const { buttonLabel: buttonLabel, createButtonLabel: createButtonLabel } = macroDefaultProps.node.parameters.macroParams;
        const labelText = buttonLabel?.value || createButtonLabel?.value;
        return labelText || undefined;
    }
    return {
        [(0, $8pcS0.EXTENSION_KEY).TOC]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $duRQc.TableOfContentsHandler), {
                macroDefaultProps: macroDefaultProps,
                adf: adf,
                cloudId: cloudId,
                userId: userId
            }),
        [(0, $8pcS0.EXTENSION_KEY).CREATE_FROM_TEMPLATE]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9nJuY.CreateFromTemplateHandler), {
                macroDefaultProps: macroDefaultProps,
                cloudId: cloudId,
                userId: userId,
                ssrButtonLabel: getSsrButtonLabel()
            }),
        [(0, $8pcS0.EXTENSION_KEY).LIVE_SEARCH]: ()=>{
            (0, $PrCoC.ssrDisableHydrationRecorder).setDisableHydration(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dTAyb.LiveSearchHandler), {
                macroDefaultProps: macroDefaultProps
            });
        },
        [(0, $8pcS0.EXTENSION_KEY).DETAILS]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hKeSi.DetailsExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXPAND]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6v9Za.ExpandExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXCERPT]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2LCBF.ExcerptExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            }),
        [(0, $8pcS0.EXTENSION_KEY).ANCHOR]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l86Zj.AnchorExtensionHandler), {
                ...macroDefaultProps,
                isSSR: true
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXCERPT_INCLUDE]: ()=>{
            if (contentId) {
                if (macroDefaultProps.node.type === 'inlineExtension') (0, $PrCoC.ssrDisableHydrationRecorder).setDisableHydration(true);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8BBIU.ExcerptIncludeSSRExtensionHandler), {
                    ...macroDefaultProps,
                    Renderer: (0, $hEeUR.ADFRenderer),
                    getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
                });
            } else return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).PROFILE_PICTURE]: ()=>{
            if ((0, $bnGqC.isProfileMacrosExperimentEnabled)()) {
                (0, $PrCoC.ssrDisableHydrationRecorder).setDisableHydration(true);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5PGOG.ProfilePictureMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
            } else return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).PROFILE]: ()=>(0, $bnGqC.isProfileMacrosExperimentEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5PGOG.UserProfileMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            }) : null,
        /* These macros have React implementation on SPA */ [(0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY]: ()=>null,
        [(0, $8pcS0.EXTENSION_KEY).REDACTED_MACRO_PLACEHOLDER]: ()=>null,
        [(0, $8pcS0.EXTENSION_KEY).CONFLUENCE_DATABASES]: ()=>null
    };
};
const $dff9e4cf0075d57c$var$ConditionalLoadablePlaceholderServer = ({ children: children, extensionKey: extensionKey })=>{
    if ((0, $dh538.fg)('enable_loadable_placeholder_for_legacy_macros')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
        placeholderId: `ssr-extension-handler-placeholder-${extensionKey}`,
        tag: "div"
    }, children);
    return children;
};
const $dff9e4cf0075d57c$var$getMacroExtensionHandlerForRenderer = ({ adf: adf, contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId, includeSuperbatch: includeSuperbatch, macroRenderedOutput: macroRenderedOutput })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        const { extensionKey: extensionKey } = extension;
        const macroDefaultProps = {
            node: extension,
            contentId: contentId,
            spaceKey: spaceKey,
            context: $dff9e4cf0075d57c$var$context,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey
        };
        // This callback won't be available on a recursive call for handlers from bodied macros
        // but it only needs to be called on the top level of recursion.
        if (includeSuperbatch) includeSuperbatch();
        const serverExtensionHandlersMap = $dff9e4cf0075d57c$export$d3d0d63f461591f5({
            adf: adf,
            userId: userId,
            contentId: contentId,
            cloudId: cloudId,
            extension: extension,
            macroDefaultProps: macroDefaultProps
        });
        const handlerContent = serverExtensionHandlersMap[extensionKey];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lspPP.RendererActionsContext), null, typeof handlerContent === 'function' ? /**
     * This is a "detached" loadable placeholder.
     * It renders a begin and end marker for stuff rendered on the server-side.
     * When rendering SPA the loadable in
     * confluence/node_modules/@atlaskit/editor-common/dist/es2019/extensions/extension-handlers.js
     * will take this placeholder while loading
     *
     * We are specifying the tag to be div instead of normally a hidden input.
     * This is because the renderer will try to fix the DOM structure placing the input tag to another <p> tag.
     * This will break the collect() in confluence/next/packages/loadable/src/placeholders/placeholders.ts
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
            placeholderId: `ssr-extension-handler-placeholder-${extensionKey}`,
            tag: "div"
        }, handlerContent()) : /**
     * There is no loadable marker for legacy macros
     * This is because it has its own handling confluence/next/packages/content-renderer/src/LegacyMacroStyledElement.tsx
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($dff9e4cf0075d57c$var$ConditionalLoadablePlaceholderServer, {
            extensionKey: extensionKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $989nU.FabricLegacyMacrosServerRenderer), {
            macroRenderedOutput: macroRenderedOutput,
            macroDefaultProps: macroDefaultProps,
            macroOutput: extension?.parameters?.macroOutput
        })));
    });

});
parcelRegister("eS4Za", function(module, exports) {

$parcel$export(module.exports, "createMacroExtensionHandler", () => $b665af2ad4850853$export$399071cd24abe8c9);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $dIouf = parcelRequire("dIouf");

var $ge2sX = parcelRequire("ge2sX");
var $f7i8j = parcelRequire("f7i8j");

var $hp2SH = parcelRequire("hp2SH");
const $b665af2ad4850853$export$399071cd24abe8c9 = (extensionHandler)=>(extension, ...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).PAGE_EXTENSIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.ApolloProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                value: sessionData
            }, extensionHandler(extension, args)))));

});

parcelRegister("5PGOG", function(module, exports) {

$parcel$export(module.exports, "ProfilePictureMacroHandler", () => $bd293076cf2c23b4$export$ef74c28fadeef856);
$parcel$export(module.exports, "UserProfileMacroHandler", () => $bd293076cf2c23b4$export$6e074cbc05db83c0);
$parcel$export(module.exports, "isProfileMacrosExperimentEnabled", () => (parcelRequire("bnGqC")).isProfileMacrosExperimentEnabled);

var $jmjWc = parcelRequire("jmjWc");

var $bnGqC = parcelRequire("bnGqC");

const $bd293076cf2c23b4$export$ef74c28fadeef856 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dE-Ul",
    name: "ProfilePictureMacroHandler",
    loader: async ()=>(await (parcelRequire("7vPtK"))).ProfilePictureMacroRenderer
});

const $bd293076cf2c23b4$export$6e074cbc05db83c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iCCvO",
    name: "UserProfileMacroHandler",
    loader: async ()=>(await (parcelRequire("kkaZf"))).UserProfileMacroRenderer
});

});
parcelRegister("bnGqC", function(module, exports) {

$parcel$export(module.exports, "isProfileMacrosExperimentEnabled", () => $34a26922b55fbb13$export$7968ac5aa248cce9);

var $6mKj3 = parcelRequire("6mKj3");
const $34a26922b55fbb13$export$7968ac5aa248cce9 = ()=>{
    return (0, $6mKj3.expVal)('confluence_profile_macros_updates', 'isEnabled', false);
};

});

parcelRegister("7vPtK", function(module, exports) {

let $57835c42a23f9bd6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $57835c42a23f9bd6$var$load("1mjYg").then(()=>parcelRequire('lhP7Q'));

});

parcelRegister("kkaZf", function(module, exports) {

let $ecbe32af57f02fb8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ecbe32af57f02fb8$var$load("1a9Rr").then(()=>parcelRequire('7fnEu'));

});


parcelRegister("l86Zj", function(module, exports) {

$parcel$export(module.exports, "AnchorExtensionHandler", () => $9df11074aa88af9a$export$d5c71aa37ef97617);
/* AnchorExtensionHandler.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9df11074aa88af9a$var$AnchorWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _4t3i1x4e _1bsbidpf",
            __cmplp.className
        ])
    });
});
const $9df11074aa88af9a$var$getAnchorName = (node)=>{
    const rawValue = node?.parameters?.macroParams?.['']?.value;
    if (typeof rawValue !== 'string') return null;
    return rawValue.replaceAll(/[%"'\s]/g, '');
};
const $9df11074aa88af9a$var$getLegacyAnchorName = (node)=>{
    return node?.parameters?.macroParams?.['legacyAnchorId']?.value;
};
const $9df11074aa88af9a$export$d5c71aa37ef97617 = ({ node: node, isSSR: isSSR })=>{
    const isHidden = Boolean(node?.parameters?.macroParams?.hidden?.value);
    const anchorName = $9df11074aa88af9a$var$getAnchorName(node);
    const legacyAnchorName = $9df11074aa88af9a$var$getLegacyAnchorName(node);
    const hasName = !!anchorName || !!legacyAnchorName;
    // Note that we do not render `name` attribute on SSR stage for the following reason:
    // If `name` attribute would be rendered in SSR and there is a corresponding hash
    // in the browser url address field, the viewport will jump to an anchor as soon as HTML
    // is delivered to a client. However, right after that SPA rendering is happening which
    // involves replacing SSR-rendered DOM with SPA-rendered DOM. And this will cause the
    // viewport to jump back to the start of the page.
    const anchorAttr = isSSR ? {} : {
        name: anchorName
    };
    const legacyAnchorAttr = isSSR ? {} : {
        name: legacyAnchorName
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, !isHidden && hasName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9df11074aa88af9a$var$AnchorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
        "data-group": "deeplink",
        ...anchorAttr
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
        "data-group": "deeplink",
        ...legacyAnchorAttr
    })) : null);
};

});

parcelRegister("hKeSi", function(module, exports) {

$parcel$export(module.exports, "DetailsExtensionHandler", () => $a9b8ba98dfcca4d1$export$5a0ddb4204896541);

var $gwFzn = parcelRequire("gwFzn");

var $iu6m9 = parcelRequire("iu6m9");

var $5kjCz = parcelRequire("5kjCz");
var $bX5uj = parcelRequire("bX5uj");

var $2w2Hu = parcelRequire("2w2Hu");
var $3GQl6 = parcelRequire("3GQl6");

var $6gj4X = parcelRequire("6gj4X");
const $a9b8ba98dfcca4d1$export$5a0ddb4204896541 = ({ contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer, getExtensionHandlers: getExtensionHandlers, annotationProvider: annotationProvider })=>{
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader
    ]);
    const isHidden = Boolean(node?.parameters?.macroParams?.hidden?.value);
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const document = {
        type: 'doc',
        version: 1,
        content: node?.content
    };
    // ADFRenderer (next-based) requires extension handlers during rendering on server side,
    // for extensions like this as they use renderer internally. Handlers aren't needed with
    // legacy renderer because legacy component cooks them internally.
    const extensionHandlers = getExtensionHandlers && !isLegacyRenderer ? getExtensionHandlers({
        adf: document,
        contentId: contentId,
        appearance: appearance,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-fabric-macro": (0, $6gj4X.getMacroId)(node)
    }, isHidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Renderer, {
        ...(0, $6gj4X.convertRendererProps)(isLegacyRenderer, {
            contentId: contentId,
            document: document
        }),
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview,
        extensionHandlers: extensionHandlers,
        appearance: appearance || 'default',
        spaceKey: spaceKey,
        UNSTABLE_allowTableResizing: false,
        annotationProvider: annotationProvider,
        allowAnnotations: !!annotationProvider,
        ...(0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true) ? {
            allowInlineComments: true
        } : {}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        contentId: contentId
    }));
};

});
parcelRegister("6gj4X", function(module, exports) {

$parcel$export(module.exports, "convertRendererProps", () => $45b144f792a5212a$export$36b5af56b86b89d3);
$parcel$export(module.exports, "getMacroId", () => $45b144f792a5212a$export$47eae2202f029f6b);
const $45b144f792a5212a$export$36b5af56b86b89d3 = (isLegacyRenderer, rendererProps)=>{
    if (!isLegacyRenderer) return rendererProps;
    return {
        adf: rendererProps.document,
        objectId: rendererProps.contentId
    };
};
const $45b144f792a5212a$export$47eae2202f029f6b = (node)=>node?.parameters?.macroMetadata?.macroId?.value;

});


parcelRegister("2LCBF", function(module, exports) {

$parcel$export(module.exports, "ExcerptExtensionHandler", () => $63bceb6b2cfa43e7$export$32fd79437615e824);

var $gwFzn = parcelRequire("gwFzn");

var $iu6m9 = parcelRequire("iu6m9");

var $dIouf = parcelRequire("dIouf");

var $5kjCz = parcelRequire("5kjCz");
var $bX5uj = parcelRequire("bX5uj");

var $2w2Hu = parcelRequire("2w2Hu");
var $3GQl6 = parcelRequire("3GQl6");

var $6gj4X = parcelRequire("6gj4X");
const $63bceb6b2cfa43e7$export$1c60c335317f0c91 = ({ contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer, getExtensionHandlers: getExtensionHandlers, mediaToken: mediaToken, annotationProvider: annotationProvider })=>{
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader
    ]);
    const hiddenMacroParamValue = node?.parameters?.macroParams?.hidden?.value;
    const isHidden = hiddenMacroParamValue === 'false' ? false : Boolean(hiddenMacroParamValue);
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const document = {
        type: 'doc',
        version: 1,
        content: node?.content
    };
    // ADFRenderer (next-based) requires extension handlers during rendering on server side,
    // for extensions like this as they use renderer internally. Handlers aren't needed with
    // legacy renderer because legacy component cooks them internally.
    const extensionHandlers = getExtensionHandlers && !isLegacyRenderer ? getExtensionHandlers({
        adf: document,
        contentId: contentId,
        appearance: appearance,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-fabric-macro": (0, $6gj4X.getMacroId)(node)
    }, isHidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Renderer, {
        ...(0, $6gj4X.convertRendererProps)(isLegacyRenderer, {
            contentId: contentId,
            document: document
        }),
        spaceKey: spaceKey,
        appearance: appearance || 'default',
        allowStickyHeaders: false,
        extensionHandlers: extensionHandlers,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview,
        mediaToken: mediaToken,
        annotationProvider: annotationProvider,
        allowAnnotations: !!annotationProvider,
        ...(0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true) ? {
            allowInlineComments: true
        } : {}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        contentId: contentId
    }));
};
const $63bceb6b2cfa43e7$export$32fd79437615e824 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($63bceb6b2cfa43e7$export$1c60c335317f0c91, props));

});

parcelRegister("8BBIU", function(module, exports) {

$parcel$export(module.exports, "ExcerptIncludeSSRExtensionHandler", () => $073def04dea47e25$export$682885b7d6415d72);

var $gwFzn = parcelRequire("gwFzn");

var $jJli4 = parcelRequire("jJli4");

var $2w2Hu = parcelRequire("2w2Hu");
var $3GQl6 = parcelRequire("3GQl6");
const $073def04dea47e25$export$682885b7d6415d72 = ({ contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, getExtensionHandlers: getExtensionHandlers })=>{
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader
    ]);
    const RendererWrapper = (0, $gwFzn.useMemo)(()=>({ targetContentId: targetContentId, adf: adf, mediaToken: mediaToken })=>{
            const document = {
                type: 'doc',
                version: 1,
                content: adf
            };
            // ADFRenderer (next-based) requires extension handlers during rendering on server side,
            // for extensions like this as they use renderer internally.
            const extensionHandlers = getExtensionHandlers({
                adf: document,
                contentId: targetContentId,
                appearance: appearance,
                showTemplateInputInPreview: showTemplateInputInPreview,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Renderer, {
                contentId: targetContentId,
                document: document,
                hasInlineComments: false,
                showTemplateInputInPreview: showTemplateInputInPreview,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview,
                extensionHandlers: extensionHandlers,
                appearance: appearance || 'default',
                spaceKey: spaceKey,
                mediaToken: mediaToken
            });
        }, [
        getExtensionHandlers,
        appearance,
        showTemplateInputInPreview,
        showTemplateVariablesInPreview,
        spaceKey,
        Renderer
    ]);
    const componentProps = {
        mode: mode,
        contentId: contentId,
        spaceKey: spaceKey,
        extensionKey: extensionKey,
        macroNode: node,
        RendererWrapper: RendererWrapper,
        isLegacyRenderer: false
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jJli4.ExcerptIncludeLoader), componentProps);
};

});
parcelRegister("jJli4", function(module, exports) {

$parcel$export(module.exports, "ExcerptIncludeLoader", () => $7549d063fe593b21$export$2800e3d415e59020);

var $jmjWc = parcelRequire("jmjWc");

var $f9KPY = parcelRequire("f9KPY");

const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("ddeId"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});

});
parcelRegister("f9KPY", function(module, exports) {

$parcel$export(module.exports, "ExcerptIncludeComponentShadow", () => $747c563e4499b240$export$8f88facf076a2d46);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $lOkIA = parcelRequire("lOkIA");

var $dhEYL = parcelRequire("dhEYL");
class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $gwFzn.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}

});
parcelRegister("dhEYL", function(module, exports) {

$parcel$export(module.exports, "panel", () => $9b021e0aba5455d5$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelHeader", () => $9b021e0aba5455d5$export$92937d9937dc7ce9);
$parcel$export(module.exports, "panelBody", () => $9b021e0aba5455d5$export$d763905bda51ef54);
$parcel$export(module.exports, "panelHeaderExcerpt", () => $9b021e0aba5455d5$export$99e3f651fb62ec86);
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: '1px',
    borderRadius: '3px',
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #091E4224)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    fontSize: '16px'
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: '1px 0px 0px 0px',
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #091E4224)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #626F86)",
    paddingLeft: "var(--ds-space-050, 4px)"
};

});


parcelRegister("ddeId", function(module, exports) {

let $99e7e6c6280b802f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $99e7e6c6280b802f$var$load("9tNcH").then(()=>parcelRequire('c6u22'));

});



parcelRegister("6v9Za", function(module, exports) {

$parcel$export(module.exports, "ExpandExtensionHandler", () => $2d8d2baed7861ad9$export$633f4824b681947a);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $eEA8O = parcelRequire("eEA8O");

var $jPwBx = parcelRequire("jPwBx");

var $5kjCz = parcelRequire("5kjCz");
var $bX5uj = parcelRequire("bX5uj");

var $2w2Hu = parcelRequire("2w2Hu");
var $3GQl6 = parcelRequire("3GQl6");

var $6gj4X = parcelRequire("6gj4X");
const $2d8d2baed7861ad9$export$1ade295ab0337f6b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-200, 16px)"}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: 3,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-200, 16px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-200, 16px)",
            margin: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-025, 2px)"}
        ${"var(--ds-space-0, 0px)"}`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: 3,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 120,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: 20
        }
    }));
const $2d8d2baed7861ad9$var$EXPANDED_STYLES = {
    transition: 'opacity 0.5s',
    height: 'auto',
    opacity: 1,
    paddingLeft: "var(--ds-space-600, 48px)"
};
const $2d8d2baed7861ad9$var$COLLAPSED_STYLES = {
    transition: '0s',
    height: "var(--ds-space-0, 0px)",
    opacity: 0,
    overflow: 'hidden',
    paddingLeft: "var(--ds-space-600, 48px)",
    pointerEvents: 'none'
};
const $2d8d2baed7861ad9$export$633f4824b681947a = ({ contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer, getExtensionHandlers: getExtensionHandlers, annotationProvider: annotationProvider })=>{
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader
    ]);
    const [isExpanded, setExpanded] = (0, $gwFzn.useState)(false);
    const toggleExpand = (0, $gwFzn.useCallback)(()=>{
        setExpanded((expanded)=>!expanded);
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (isExpanded) window.dispatchEvent(new Event('resize'));
    }, [
        isExpanded
    ]);
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const document = {
        type: 'doc',
        version: 1,
        content: node?.content
    };
    const title = node?.parameters?.macroParams?.title;
    // ADFRenderer (next-based) requires extension handlers during rendering on server side,
    // for extensions like this as they use renderer internally. Handlers aren't needed with
    // legacy renderer because legacy component cooks them internally.
    const extensionHandlers = getExtensionHandlers && !isLegacyRenderer ? getExtensionHandlers({
        adf: document,
        contentId: contentId,
        appearance: appearance,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            style: {
                transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                transition: '0.2s'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jPwBx))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })),
        onClick: toggleExpand
    }, title !== undefined ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "content-renderer-extension-handlers.expand-macro.default-title",
        defaultMessage: "Click here to expand..."
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: isExpanded ? $2d8d2baed7861ad9$var$EXPANDED_STYLES : $2d8d2baed7861ad9$var$COLLAPSED_STYLES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Renderer, {
        ...(0, $6gj4X.convertRendererProps)(isLegacyRenderer, {
            contentId: contentId,
            document: document
        }),
        extensionHandlers: extensionHandlers,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview,
        annotationProvider: annotationProvider,
        allowAnnotations: !!annotationProvider
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};

});

parcelRegister("dTAyb", function(module, exports) {

$parcel$export(module.exports, "LiveSearchHandler", () => $3f248c73bf14394e$export$e8ac5007ab7a695a);

var $gwFzn = parcelRequire("gwFzn");

var $6mEZ3 = parcelRequire("6mEZ3");

var $l7BGZ = parcelRequire("l7BGZ");
const $3f248c73bf14394e$export$e8ac5007ab7a695a = ({ macroDefaultProps: macroDefaultProps })=>{
    const { node: node } = macroDefaultProps;
    const macroNode = (0, $6mEZ3.extensionToADF)(node);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l7BGZ.LiveSearchLoader), {
        macroNode: macroNode
    });
};

});
parcelRegister("l7BGZ", function(module, exports) {

$parcel$export(module.exports, "LiveSearchLoader", () => $076f2e82bb035170$export$b5586d12ffc2e1b);
$parcel$export(module.exports, "LazyLiveSearchLoader", () => $076f2e82bb035170$export$e7e4bc50f3fd132e);

var $jmjWc = parcelRequire("jmjWc");

const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("9xE1E"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("9xE1E"))).LiveSearch
});

});
parcelRegister("9xE1E", function(module, exports) {

let $6f263e5d86fa358c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6f263e5d86fa358c$var$load("8059b"),
    $6f263e5d86fa358c$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});



parcelRegister("duRQc", function(module, exports) {

$parcel$export(module.exports, "TableOfContentsHandler", () => $13135e29d0f1ffa1$export$cf1c26fcb7e6ff9f);

var $gwFzn = parcelRequire("gwFzn");

var $dwS6P = parcelRequire("dwS6P");
const $13135e29d0f1ffa1$export$cf1c26fcb7e6ff9f = ({ macroDefaultProps: macroDefaultProps, adf: adf, cloudId: cloudId, userId: userId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dwS6P.TableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    });
};

});

parcelRegister("9nJuY", function(module, exports) {

$parcel$export(module.exports, "CreateFromTemplateHandler", () => $3211097f4985a15f$export$30c773822372f598);

var $gwFzn = parcelRequire("gwFzn");

var $cYJC5 = parcelRequire("cYJC5");
const $3211097f4985a15f$export$30c773822372f598 = ({ macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, ssrButtonLabel: ssrButtonLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        ssrButtonLabel: ssrButtonLabel
    });

});
parcelRegister("cYJC5", function(module, exports) {

$parcel$export(module.exports, "CreateFromTemplateLoader", () => $c1c34d439a5f73ff$export$d9cdb53348aba8);
$parcel$export(module.exports, "LazyCreateFromTemplateLoader", () => $c1c34d439a5f73ff$export$3ecbbe8a82bf4f99);

var $jmjWc = parcelRequire("jmjWc");

const $c1c34d439a5f73ff$export$d9cdb53348aba8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "BS09z",
    name: "CreateFromTemplateLoader",
    loader: async ()=>(await (parcelRequire("b9uHB"))).CreateFromTemplate
});

const $c1c34d439a5f73ff$export$3ecbbe8a82bf4f99 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ikblw",
    name: "LazyCreateFromTemplateLoader",
    loader: async ()=>(await (parcelRequire("b9uHB"))).CreateFromTemplate
});

});
parcelRegister("b9uHB", function(module, exports) {

let $81e859d435489cc3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $81e859d435489cc3$var$load("16ht2"),
    $81e859d435489cc3$var$load("70aiP"),
    $81e859d435489cc3$var$load("2zJ0a"),
    $81e859d435489cc3$var$load("idfnC"),
    $81e859d435489cc3$var$load("b1vDf")
]).then(()=>parcelRequire('6JR3B'));

});





parcelRegister("hMRhJ", function(module, exports) {

$parcel$export(module.exports, "RendererExtensionContext", () => $14a9ee80cba83190$export$4eaca3ef6119646c);

var $gwFzn = parcelRequire("gwFzn");
const $14a9ee80cba83190$export$4eaca3ef6119646c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});

});

parcelRegister("5LTS4", function(module, exports) {

$parcel$export(module.exports, "ExtensionLoadingComplete", () => $ebb4d303074e1a0c$export$64e91845ba744516);

var $gwFzn = parcelRequire("gwFzn");

var $ep3mz = parcelRequire("ep3mz");

var $6VdZc = parcelRequire("6VdZc");

var $4JC0x = parcelRequire("4JC0x");

var $4VJDS = parcelRequire("4VJDS");

var $bF1aY = parcelRequire("bF1aY");

var $h8C1D = parcelRequire("h8C1D");

var $kksmx = parcelRequire("kksmx");
const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $4VJDS.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $gwFzn.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $gwFzn.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0
        };
        const metric = (0, $bF1aY.LEGACY_EXTENSION_LOADING_METRIC)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        ref: markerRef
    });
};

});
parcelRegister("bF1aY", function(module, exports) {

$parcel$export(module.exports, "LEGACY_EXTENSION_LOADING_METRIC", () => $63112e910a0def69$export$841f5507db609445);

var $lSOAM = parcelRequire("lSOAM");
var $fd6g2 = parcelRequire("fd6g2");
const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});

});

parcelRegister("h8C1D", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_INDEX", () => $028a91b33dee434b$export$e4ac003417d6dace);
$parcel$export(module.exports, "ExtrensionIndexProvider", () => $028a91b33dee434b$export$981cab9712b3b1a3);
$parcel$export(module.exports, "useExtensionIndex", () => $028a91b33dee434b$export$ea9830505fbaa6ad);

var $gwFzn = parcelRequire("gwFzn");

var $lcuos = parcelRequire("lcuos");

var $8pcS0 = parcelRequire("8pcS0");
const $028a91b33dee434b$export$7affafe0528b70b1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    indexes: new Map()
});
const $028a91b33dee434b$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $028a91b33dee434b$export$e4ac003417d6dace = 'UNKNOWN';
const $028a91b33dee434b$export$981cab9712b3b1a3 = ({ document: document, children: children })=>{
    const indexes = (0, $gwFzn.useMemo)(()=>{
        const extensions = $028a91b33dee434b$var$extractExtensions(document);
        return new Map(extensions.map((node, idx)=>{
            window['unsupportedExtension'] = window['unsupportedExtension'] || {};
            if (node.attrs?.parameters?.nestedContent?.content && node.attrs.extensionKey === '__confluenceADFMigrationUnsupportedContentInternalExtension__') node.attrs.parameters.nestedContent.content.forEach((each)=>{
                window['unsupportedExtension'][each.attrs?.parameters?.macroMetadata?.macroId?.value] = idx;
            });
            return [
                node.attrs?.parameters?.macroMetadata?.macroId?.value,
                idx
            ];
        }));
    }, [
        document
    ]);
    const value = (0, $gwFzn.useMemo)(()=>({
            indexes: indexes
        }), [
        indexes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($028a91b33dee434b$export$7affafe0528b70b1.Provider, {
        value: value
    }, children);
};
const $028a91b33dee434b$export$ea9830505fbaa6ad = (macroId)=>{
    const { indexes: indexes } = (0, $gwFzn.useContext)($028a91b33dee434b$export$7affafe0528b70b1);
    let index = indexes.get(macroId);
    const unsupportedExtensions = window['unsupportedExtension'];
    let isUnsupportedExtension = false;
    if (unsupportedExtensions && unsupportedExtensions[macroId]) {
        index = unsupportedExtensions[macroId];
        isUnsupportedExtension = true;
    }
    return {
        extensionIndex: typeof index === 'number' ? index : $028a91b33dee434b$export$e4ac003417d6dace,
        isUnsupportedExtension: isUnsupportedExtension
    };
};

});


parcelRegister("hHZWk", function(module, exports) {

$parcel$export(module.exports, "LegacyUserElementsHover", () => $fe7178b75f06350f$export$549ba0a29911d5ee);

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $jlIaF = parcelRequire("jlIaF");

var $a6t12 = parcelRequire("a6t12");

var $4qzKl = parcelRequire("4qzKl");
/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $gwFzn.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", item.props, item.props.children)), item.placeholder);
        };
    }
}

});

parcelRegister("3Btfb", function(module, exports) {

$parcel$export(module.exports, "withNavigationPolicy", () => $fa7a566b22788032$export$a039e57df2bba181);

var $gwFzn = parcelRequire("gwFzn");

var $4o1RV = parcelRequire("4o1RV");
function $fa7a566b22788032$export$a039e57df2bba181(InnerComponent) {
    function WithNavigationPolicy(props) {
        const navigationPolicy = (0, $4o1RV.useNavigationPolicy)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(InnerComponent, {
            ...props,
            navigationPolicy: navigationPolicy
        });
    }
    WithNavigationPolicy.displayName = `withNavigationPolicy(${InnerComponent.displayName || InnerComponent.name})`;
    return WithNavigationPolicy;
}

});

parcelRegister("iQhLj", function(module, exports) {

$parcel$export(module.exports, "ConnectMacroModule", () => $172ec9aa4291f34d$export$65a835712c7fb845);
$parcel$export(module.exports, "defineMacroModule", () => $172ec9aa4291f34d$export$f3a2903499008e78);
/* eslint-disable no-console */ 
var $cpjd2 = parcelRequire("cpjd2");
class $172ec9aa4291f34d$export$65a835712c7fb845 {
    static init(hostAPI, logger) {
        if (this.macroActions === null) {
            const getMacroId = (arg)=>{
                const macroId = arg?._context?.extension?.options?.productContext?.['macro.id'];
                if (!macroId) throw new Error('No macro ID found in the call.');
                return macroId;
            };
            const getEditorAction = (methodName, macroId)=>{
                const cachedMacro = this.macrosCache.get(macroId);
                if (typeof cachedMacro?.actions?.[methodName] !== 'function') throw new Error('Failed to execute this method. Please ensure that you are calling this method from within a multi-body extension inside your Connect application.');
                return cachedMacro.actions[methodName];
            };
            const assertNotReadonly = (macroId)=>{
                const cachedMacro = this.macrosCache.get(macroId);
                if (cachedMacro && cachedMacro.readonly) throw new Error('This method is not allowed in view mode');
                return true;
            };
            /**
       * Adding extra param to function ({returnPromise: true}) to let Connect know that
       * it returns Promise
       */ const prepareModuleFunction = (moduleFn)=>{
                return Object.assign(moduleFn, {
                    returnsPromise: true
                });
            };
            this.macroActions = {
                addBody: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const addChild = getEditorAction('addChild', macroId);
                        return Promise.resolve(addChild());
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                removeBody: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || typeof args[0] !== 'number') throw new Error('The removeBody method expects an index number as its argument.');
                        const [index, context] = args;
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const removeChild = getEditorAction('removeChild', macroId);
                        return Promise.resolve(removeChild(index));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                showBody: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || typeof args[0]?.body !== 'number' || typeof args[0]?.frame !== 'number') throw new Error('The showBody method expects an object with body and frame properties as its argument.');
                        const [indexes, context] = args;
                        const macroId = getMacroId(context);
                        const changeActive = getEditorAction('changeActive', macroId);
                        return Promise.resolve(changeActive(indexes.body));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                getBodyCount: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        const getChildrenCount = getEditorAction('getChildrenCount', macroId);
                        return Promise.resolve(getChildrenCount());
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                getParameters: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        const cachedMacro = this.macrosCache.get(macroId);
                        if (!cachedMacro) throw new Error('Failed to execute this method. Please ensure that you are calling this method from within a multi-body extension inside your Connect application.');
                        return Promise.resolve(JSON.parse(cachedMacro.parameters));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                updateParameters: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || !args[0] || typeof args[0] !== 'object') throw new Error('The updateParameters method expects an object with macro parameters as its argument.');
                        const [parameters, context] = args;
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const updateParameters = getEditorAction('updateParameters', macroId);
                        return Promise.resolve(updateParameters(parameters));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                })
            };
        }
        if (!hostAPI.isModuleDefined(this.macroName)) hostAPI.defineModule(this.macroName, this.macroActions);
    }
    static register(macroId, macroParams, editorActions, readonly) {
        if (!this.macrosCache.has(macroId)) this.macrosCache.set(macroId, {
            actions: editorActions,
            parameters: macroParams,
            readonly: readonly
        });
    }
    static deregister(macroId) {
        if (this.macrosCache.has(macroId)) this.macrosCache.delete(macroId);
    }
    static cleanCache() {
        this.macrosCache.clear();
    }
}
$172ec9aa4291f34d$export$65a835712c7fb845.macroName = 'macro';
$172ec9aa4291f34d$export$65a835712c7fb845.macroActions = null;
$172ec9aa4291f34d$export$65a835712c7fb845.macrosCache = new Map();
const $172ec9aa4291f34d$export$f3a2903499008e78 = async ({ logger: logger })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            if (!connectHost) {
                logger.error`ConnectHost is not available to init macro module`;
                resolve();
                return;
            }
            $172ec9aa4291f34d$export$65a835712c7fb845.init(connectHost, logger);
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for macro module!`;
            resolve();
        });
    });
};

});

parcelRegister("jShOo", function(module, exports) {

$parcel$export(module.exports, "MultiBodiedExtensionHandler", () => $24172b2397b2d142$export$13124d26de07dad1);

var $gwFzn = parcelRequire("gwFzn");

var $5ZqQS = parcelRequire("5ZqQS");

var $dIouf = parcelRequire("dIouf");

var $iQhLj = parcelRequire("iQhLj");
const $24172b2397b2d142$export$13124d26de07dad1 = ({ macroId: macroId, macroParams: macroParams, editorActions: editorActions, readonly: readonly = false })=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!editorActions) {
            (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`No editor actions has been provided to MultiBodiedExtensionHandler for macro ${macroId}.`), {
                attribution: (0, $dIouf.Attribution).ECOSYSTEM
            });
            return;
        }
        (0, $iQhLj.ConnectMacroModule).register(macroId, macroParams, editorActions, readonly);
        return ()=>{
            (0, $iQhLj.ConnectMacroModule).deregister(macroId);
        };
    }, [
        macroId,
        macroParams,
        editorActions,
        readonly
    ]);
    return null;
};

});

parcelRegister("9L50P", function(module, exports) {

$parcel$export(module.exports, "LegacyMacroReferenceListener", () => $b1fc10dfab719594$export$b2f0fd57401a56fe);

var $gwFzn = parcelRequire("gwFzn");

var $lwdd5 = parcelRequire("lwdd5");

var $inPa6 = parcelRequire("inPa6");

var $gEtAQ = parcelRequire("gEtAQ");
const $b1fc10dfab719594$var$extractExtensionKey = (extensionId)=>{
    const split = extensionId.split('__');
    if (split.length === 3) return split[1];
    return 'UNKOWN_EXTENSION_KEY';
};
const $b1fc10dfab719594$var$sendReferenceData = (references, extensionId, createAnalyticsEvent)=>{
    const eventName = 'data_provider';
    const addonFilter = {
        id: extensionId
    };
    const eventData = {
        eventData: references
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: (0, $gEtAQ.isViewPage)() ? 'viewPageScreen' : 'editPageScreen',
            action: 'broadcasted',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: $b1fc10dfab719594$var$extractExtensionKey(extensionId)
            }
        }
    });
    analyticsEvent.fire();
    // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).connectHost.broadcastEvent(eventName, addonFilter, eventData);
};
const $b1fc10dfab719594$export$b2f0fd57401a56fe = ({ references: references, macroContainer: macroContainer })=>{
    const [extensionId, setExtensionId] = (0, $gwFzn.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        if (extensionId && Array.isArray(references) && references.length > 0) $b1fc10dfab719594$var$sendReferenceData(references, extensionId, createAnalyticsEvent);
    }, [
        references,
        extensionId,
        createAnalyticsEvent
    ]);
    const listeningForInitialization = (0, $gwFzn.useCallback)((event)=>{
        if (event.data?.type !== 'event_query' || !event.data?.eid || !event.data?.args?.includes?.('data_provider')) return;
        const iframeEl = document.getElementById(event.data.eid);
        if (iframeEl && macroContainer?.contains?.(iframeEl)) setExtensionId(event.data.eid);
    }, [
        macroContainer,
        setExtensionId
    ]);
    // Starts listening for macro initialization
    (0, $gwFzn.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).addEventListener('message', listeningForInitialization);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).removeEventListener('message', listeningForInitialization);
        };
    }, [
        listeningForInitialization
    ]);
    return null;
};

});

parcelRegister("4BMhZ", function(module, exports) {

$parcel$export(module.exports, "LegacyMacroRendererError", () => $bd422ab26f8348d3$export$99a6d9338f38339e);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");

var $2p7B1 = parcelRequire("2p7B1");

var $5kjCz = parcelRequire("5kjCz");
var $hUS75 = parcelRequire("hUS75");
const $bd422ab26f8348d3$export$99a6d9338f38339e = ({ error: error, mode: mode, extensionKey: extensionKey, node: node, contentId: contentId })=>{
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hUS75.MacroExperienceStop), {
        extensionKey: extensionKey,
        error: error || Error(`Unable to render ${extensionKey}`),
        mode: mode,
        attributes: attributes,
        contentId: contentId,
        name: (0, $5kjCz.getExperienceName)(mode, node),
        source: "LegacyMacroRendererError"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: 5,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 200,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: "var(--ds-space-050, 4px)"
        },
        "data-testid": "legacy-macro-renderer-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2p7B1))), {
        label: "",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "fabric-extension-legacy-macro-renderer.legacymacrorenderer.error",
        defaultMessage: "Failed to get macro details"
    }))));
};

});

parcelRegister("aQw7y", function(module, exports) {

$parcel$export(module.exports, "useShouldHideOverlay", () => $9d7353a17557989b$export$27f1b40a08e363aa);

var $gwFzn = parcelRequire("gwFzn");

var $3jwuS = parcelRequire("3jwuS");

var $j0gZR = parcelRequire("j0gZR");

var $9wGTI = parcelRequire("9wGTI");

var $4VJDS = parcelRequire("4VJDS");
const $9d7353a17557989b$export$27f1b40a08e363aa = (extensionKey, isBodiedExtension)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const shouldHide = (0, $gwFzn.useMemo)(()=>{
        const extensionsToHideOverlays = (0, $4VJDS.default).getStringList('confluence_frontend_extension_overlay_removal_list', []);
        if (!extensionKey || extensionsToHideOverlays.length === 0) return false;
        if (extensionsToHideOverlays[0] === 'ALLOW_ALL' || isLivePage) return true;
        const is2PNonBodied = !(0, $j0gZR.is1PMacro)(extensionKey) && !isBodiedExtension;
        if (is2PNonBodied && (0, $9wGTI.fg)('confluence_disable_macro_overlay_for_2p_nonbodied')) return true;
        const extensionKeys = extensionsToHideOverlays.map((ext)=>ext.trim().toLowerCase());
        return extensionKeys.includes(extensionKey.toLowerCase());
    }, [
        extensionKey,
        isLivePage,
        isBodiedExtension
    ]);
    return shouldHide;
};

});

parcelRegister("brT00", function(module, exports) {

$parcel$export(module.exports, "useLinkIntercept", () => $622a0e8eee3d2f68$export$5f4b0c82ca04cc0c);

var $gwFzn = parcelRequire("gwFzn");

var $4VJDS = parcelRequire("4VJDS");
const $622a0e8eee3d2f68$var$canOpenInNewTab = (href)=>{
    if (!href) // e.g., "Refresh" link in jira issue macro
    return false;
    const url = new URL(href);
    if (url.origin !== window.location.origin) return true;
    else if (url.pathname.includes('/wiki/rest/api')) return false;
    else if (url.pathname.includes('changes.action')) // e.g., "Show More" link in the recently updated macro
    return false;
    else if (url.pathname.includes('confirmattachmentremoval.action')) // e.g., "Delete" link in the attachments macro
    return false;
    else if (url.pathname.includes('.action')) // Most .action links should open in a new tab
    return true;
    else return true;
};
const $622a0e8eee3d2f68$export$5f4b0c82ca04cc0c = (extensionKey, container, isEditor)=>{
    const extensionsToOpenLinksInNewTab = (0, $gwFzn.useMemo)(()=>{
        const extensionSet = new Set();
        if (!isEditor) return extensionSet;
        const allowlist = (0, $4VJDS.default).getStringList('confluence_frontend_macro_links_new_tab_allowlist', []);
        allowlist.map((ext)=>ext.trim().toLowerCase()).forEach((ext)=>ext && extensionSet.add(ext));
        return extensionSet;
    }, [
        isEditor
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Short circuit if we're not in the editor or the container is falsey
        if (!isEditor || !container) return;
        // Only intercept links in the FF allowlist
        if (!extensionsToOpenLinksInNewTab?.has(extensionKey.toLowerCase())) return;
        function interceptLinkClick(ev) {
            const anchor = ev?.target;
            // Only intercept clicks on anchor tags
            if (anchor?.tagName !== 'A') return;
            if (!$622a0e8eee3d2f68$var$canOpenInNewTab(anchor.href)) return;
            ev.preventDefault();
            window.open(anchor.href, '_blank', 'noopener, noreferrer');
        }
        container.addEventListener('click', interceptLinkClick);
        return ()=>{
            // Remove the event listener when the component unmounts
            container.removeEventListener('click', interceptLinkClick);
        };
    }, [
        container,
        extensionsToOpenLinksInNewTab,
        extensionKey,
        isEditor
    ]);
};

});


parcelRegister("euF5O", function(module, exports) {

$parcel$export(module.exports, "LegacyMacroRendererContext", () => $914eacf4cf3bd652$export$26c05f52dcf7c5f2);

var $gwFzn = parcelRequire("gwFzn");
const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    shouldRefetchMacroQuery: false
});

});

parcelRegister("b7V26", function(module, exports) {

$parcel$export(module.exports, "PageIncludeContext", () => $3ff9e0546f2c245a$export$1b5865c105cfe12d);

var $gwFzn = parcelRequire("gwFzn");
const $3ff9e0546f2c245a$export$1b5865c105cfe12d = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    listOfRenderedPageIncludeNodes: []
});

});



//# sourceMappingURL=FullPageEditorComponent.83b5b291.js.map
